import React$1, { Component, useMemo, Children, forwardRef, Fragment, createRef, createContext, useContext, useState, useEffect, useRef, useCallback, useReducer, useImperativeHandle, useLayoutEffect } from 'react';
import PropTypes$1, { oneOfType, number, string, func, bool, shape, node, checkPropTypes, arrayOf } from 'prop-types';
import styled, { css, keyframes, withTheme, ThemeContext, ThemeProvider } from 'styled-components';
import { FormattedMessage, defineMessages, injectIntl, useIntl } from 'react-intl';
import { union, symmetricDifference, filter, complement, isEmpty, reduce, mapObjIndexed, keys, pickBy, isNil, equals, takeWhile, sort, find, propEq } from 'ramda';
import ReactDOM from 'react-dom';
import { Link, NavLink } from 'react-router-dom';

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf$2(subClass, superClass);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var logo = "data:image/svg+xml;base64,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";

function _templateObject5$c() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  line-height: 1.67;\n  margin: 0 40px 40px;\n"]);

  _templateObject5$c = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$i() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  margin: 40px;\n"]);

  _templateObject4$i = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$w() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 30px;\n  line-height: normal;\n"]);

  _templateObject3$w = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$O() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  padding: 35px;\n  max-width: 250px;\n  width: 50%;\n"]);

  _templateObject2$O = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1o() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  margin: auto;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #1a1919;\n"]);

  _templateObject$1o = function _templateObject() {
    return data;
  };

  return data;
}
var ErrorWrapper = styled.div(_templateObject$1o());
var Image$1 = styled.img(_templateObject2$O());
var ErrorHeader = styled.div(_templateObject3$w());
var ErrorMessage = styled.div(_templateObject4$i());
var ErrorHelp = styled.div(_templateObject5$c());

var FatalError = function FatalError(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React$1.createElement(ErrorWrapper, null, /*#__PURE__*/React$1.createElement(Image$1, {
    src: logo
  }), /*#__PURE__*/React$1.createElement(ErrorHeader, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "2244720377",
    defaultMessage: "An unexpected error seems to have occurred."
  })), /*#__PURE__*/React$1.createElement(ErrorMessage, null, message), /*#__PURE__*/React$1.createElement(ErrorHelp, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "4152906165",
    defaultMessage: "We're investigating the problem and expect to be back soon. Please wait a few minutes{break}and refresh your browser, or visit our <link>Status Page</link>.",
    values: {
      link: function link() {
        for (var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++) {
          chunks[_key] = arguments[_key];
        }

        return /*#__PURE__*/React$1.createElement("a", {
          href: "https://www.onelogin.com/status"
        }, chunks);
      },
      "break": /*#__PURE__*/React$1.createElement("br", null)
    }
  })));
};

FatalError.propTypes = {
  message: PropTypes$1.string.isRequired
};

var SingleValueForm = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(SingleValueForm, _Component);

  function SingleValueForm(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onChange = function (value) {
      _this.setState({
        value: value,
        invalid: false
      });
    };

    _this.onSubmit = function (event) {
      event.preventDefault();
      var value = _this.state.value;
      var validateFn = _this.props.validateFn;

      if (_this.props.trim === true) {
        value = value.trim();
      }

      var valueIsValid = function valueIsValid(value) {
        if (validateFn && typeof validateFn === "function") {
          return validateFn(value);
        } else if (value.length > 0) {
          return true;
        } else return false;
      };

      if (valueIsValid(value)) {
        _this.props.onSubmit(value);
      } else {
        _this.setState({
          invalid: true
        });
      }
    };

    _this.render = function () {
      return /*#__PURE__*/React$1.createElement("form", {
        onSubmit: _this.onSubmit
      }, _this.props.render(_objectSpread2({}, _this.state, {
        onChange: _this.onChange
      })));
    };

    _this.state = {
      value: props.value,
      invalid: false
    };
    return _this;
  }

  return SingleValueForm;
}(Component);

SingleValueForm.defaultProps = {
  value: ""
};
SingleValueForm.displayName = "SingleValueForm";
SingleValueForm.propTypes = {
  onSubmit: PropTypes$1.func.isRequired,
  validateFn: PropTypes$1.func,
  trim: PropTypes$1.bool,
  value: PropTypes$1.string
};

var CHALLENGES = {
  lower: /[a-z]/,
  upper: /[A-Z]/,
  numbers: /[0-9]/,
  specials: /[^a-zA-Z0-9]/,
  letters: /[a-zA-Z]/
};
var getPasswordValidator = (function (rules) {
  var _rules$complexity = rules.complexity,
      challenges = _rules$complexity.challenges;
      _rules$complexity.min;
      var required = _rules$complexity.required;
  var requiredPasswordLength = rules.length;
  return function (password) {
    var errors = challengesMet(challenges, password);
    var requiredErrors = challengesMet(required, password);

    if (password.length < requiredPasswordLength) {
      requiredErrors.unshift("length");
    }

    if (requiredErrors.length) {
      return union(requiredErrors, errors);
    } else {
      return errors;
    }
  };
});

var challengesMet = function challengesMet(challenges, password, min) {

  var errors = challenges.filter(function (name) {
    return !CHALLENGES[name].test(password);
  });
  return errors;
};

var PasswordComplexity = function PasswordComplexity(_ref) {
  var value = _ref.value,
      rules = _ref.rules,
      render = _ref.render,
      restProps = _objectWithoutPropertiesLoose$1(_ref, ["value", "rules", "render"]);

  //useMemo to avoid `incomplete` to be called because of 'different' function
  var passwordValidator = useMemo(function () {
    return getPasswordValidator(rules);
  }, [rules]); //useMemo probably not that much needed, as this renders because of 'value' changes most of the time

  var incomplete = useMemo(function () {
    return passwordValidator(value);
  }, [value, passwordValidator]);
  var required = useMemo(function () {
    return passwordValidator("");
  }, [passwordValidator]);
  return render(_objectSpread2({
    invalid: incomplete.includes('length') || !incomplete.includes('length') && !(rules.complexity.challenges.length - rules.complexity.min >= incomplete.length),
    challenges: required,
    completedChallenges: symmetricDifference(incomplete, required)
  }, restProps));
};

function _templateObject$1n() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: 24px;\n"]);

  _templateObject$1n = function _templateObject() {
    return data;
  };

  return data;
}
var Content$3 = styled.div(_templateObject$1n());
Content$3.displayName = "Content";

/**
 *  Primary colors
 *
 *  They are mostly used on Call to Action and brand centric elements
 */
// Black and White
var WHITE = "#FFFFFF";
var BLACK = "#000000"; // Action color

var ACTION_COLORS = {
  ONELOGIN_BLUE: "#00A9E0",
  ONELOGIN_BLUE_DARK: "#009ACC",
  BLUE_MAIN: "#00779E",
  BLUE_LIGHT: "#00BBFA",
  BLUE_MID: "#008FBF",
  BLUE_DARK: "#005E7D",
  BLUE_DARKER: "#00455C",
  // dropdown item highlight
  BLUE_ITEM_HIGHLIGHT: "#eefbff",
  // States of BLUE_MAIN
  BLUE_MAIN_HOVER: "#0891BF",
  BLUE_MAIN_ACTIVE: "#005875"
};
/**
 *  Secondary colors
 */
// OneLogin gray colors

var ONELOGIN_GRAY_COLORS = {
  ONELOGIN_BLACK: "#1C1F2A",
  ONELOGIN_GRAY_DARK: "#494B54",
  ONELOGIN_GRAY_MID: "#76787F",
  ONELOGIN_GRAY: "#A4A5A9",
  ONELOGIN_SILVER: "#D1D2D4",
  ONELOGIN_GRAY_LIGHT: "#F3F3F4"
}; // Grayscale (the number affixed is from the Brightness value of HSB in Sketch app)

var GRAY_COLORS = {
  GRAY_99: "#FAFCFC",
  GRAY_98: "#F7F9FA",
  GRAY_97: "#F5F7F7",
  GRAY_96: "#F2F4F5",
  GRAY_94: "#EDEFF0",
  GRAY_92: "#E8EAEB",
  GRAY_90: "#E3E5E6",
  GRAY_88: "#DEE0E0",
  GRAY_84: "#D4D6D6",
  GRAY_78: "#C5C6C7",
  GRAY_68: "#ACADAD",
  GRAY_55: "#8B8C8C",
  GRAY_45: "#727273",
  GRAY_35: "#585959",
  GRAY_25: "#3F4040",
  GRAY_18: "#2D2E2E"
};
/**
 *  Colors for status
 */

var STATUS_COLORS = {
  ERROR: "#D6291A",
  WARNING: "#F29B05",
  SUCCESS: "#5DA30D",
  INFO: ACTION_COLORS.BLUE_MID,
  PROGRESS: ACTION_COLORS.BLUE_MID,
  WHITE: WHITE,
  DARK_GRAY: GRAY_COLORS.GRAY_25
};
/**
 *  Typegraphy colors
 */

var TEXT_COLORS = {
  DEFAULT: GRAY_COLORS.GRAY_35,
  TITLE: GRAY_COLORS.GRAY_25,
  EMPHASIZED: GRAY_COLORS.GRAY_25,
  LINK: ACTION_COLORS.BLUE_MAIN,
  LABEL: GRAY_COLORS.GRAY_45,
  PLACEHOLDER: GRAY_COLORS.GRAY_68,
  DISABLE: GRAY_COLORS.GRAY_78,
  DESCRIPTION_SMALL: GRAY_COLORS.GRAY_55
};
/**
 *  Separator colors
 */

var SEPARATOR_COLORS = {
  REGULAR: GRAY_COLORS.GRAY_94,
  MEDIUM: GRAY_COLORS.GRAY_92,
  STRONG: GRAY_COLORS.GRAY_90,
  LIGHT: GRAY_COLORS.GRAY_84
};
/**
 *  Icon colors
 */

var ICON_COLORS = {
  NORMAL: GRAY_COLORS.GRAY_55,
  HOVER: ACTION_COLORS.BLUE_MAIN_HOVER,
  ACTIVE: ACTION_COLORS.BLUE_MAIN_ACTIVE,
  SELECTED: ACTION_COLORS.ONELOGIN_BLUE,
  WHITE: WHITE,
  DARK_GRAY: GRAY_COLORS.GRAY_25,
  PLACEHOLDER: GRAY_COLORS.GRAY_84
};
/**
 *  Form colors
 */

var TEXTFIELD_COLORS = {
  BORDER: GRAY_COLORS.GRAY_88,
  BORDER_HOVER: GRAY_COLORS.GRAY_78,
  BORDER_ACTIVE: ACTION_COLORS.ONELOGIN_BLUE,
  BORDER_DISABLED: GRAY_COLORS.GRAY_94,
  BACKGROUND_DISABLED: GRAY_COLORS.GRAY_96,
  BACKGROUND_LOCKED: GRAY_COLORS.GRAY_94
};
/* ----------------------------------------------------- */

/**
 *   Group all settings and export as single constant
 */

var COLORS = {
  WHITE: WHITE,
  BLACK: BLACK,
  ACTION_COLORS: ACTION_COLORS,
  ONELOGIN_GRAY_COLORS: ONELOGIN_GRAY_COLORS,
  GRAY_COLORS: GRAY_COLORS,
  STATUS_COLORS: STATUS_COLORS,
  TEXT_COLORS: TEXT_COLORS,
  SEPARATOR_COLORS: SEPARATOR_COLORS,
  ICON_COLORS: ICON_COLORS,
  TEXTFIELD_COLORS: TEXTFIELD_COLORS
};

function _templateObject2$N() {
  var data = _taggedTemplateLiteralLoose(["\n      text-align: center;\n      align-items: center;\n    "]);

  _templateObject2$N = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1m() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0;\n  color: ", ";\n\n  ", ";\n\n  &:first-child {\n    margin-top: 0px;\n  }\n\n  &:last-child {\n    margin-bottom: 0px;\n  }\n"]);

  _templateObject$1m = function _templateObject() {
    return data;
  };

  return data;
}
var ContentBlock = styled.div(_templateObject$1m(), COLORS.TEXT_COLORS.DEFAULT, function (props) {
  return props.centered && css(_templateObject2$N());
});
ContentBlock.displayName = "ContentBlock";

/**
 *  Font family
 */
var FONT_FAMILY = {
  DEFAULT: 'Roboto, "Helvetica Neue", Helvetica, "Segoe UI", Arial, sans-serif',
  MONOSPACE: '"Roboto Mono", monospace'
};
/* ----------------------------------------------------- */

/**
 *  Group all settings and export as single constant
 */

var FONTS = {
  FONT_FAMILY: FONT_FAMILY
};

// sizes for inputs, buttons, etc.
var MEDIUM = "medium";
var LARGE = "large";
var BIG = "big";
var SIZES = {
  MEDIUM: MEDIUM,
  LARGE: LARGE,
  BIG: BIG
};

function _templateObject3$v() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      height: ", "px;\n    "]);

  _templateObject3$v = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$M() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 16px;\n      height: ", "px;\n    "]);

  _templateObject2$M = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1l() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 18px;\n      height: ", "px;\n    "]);

  _templateObject$1l = function _templateObject() {
    return data;
  };

  return data;
}
var getHeight = function getHeight(size, heightMap) {
  return heightMap[size];
};

var getSizingDefinitions$1 = function getSizingDefinitions(size, heightMap) {
  if (size === SIZES.BIG) {
    return css(_templateObject$1l(), getHeight(size, heightMap));
  } else if (size === SIZES.LARGE) {
    return css(_templateObject2$M(), getHeight(size, heightMap));
  } else {
    // medium (default)
    return css(_templateObject3$v(), getHeight(size, heightMap));
  }
};

var _heightMap$4;

function _templateObject$1k() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  background-color: transparent;\n  padding: 0;\n  border: none;\n  border-radius: 2px;\n  color: ", ";\n  cursor: pointer;\n  font-family: ", ";\n  line-height: 1;\n  box-sizing: content-box;\n  text-align: left;\n  padding: 4px 0;\n\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n  }\n"]);

  _templateObject$1k = function _templateObject() {
    return data;
  };

  return data;
}
var heightMap$4 = (_heightMap$4 = {}, _heightMap$4[SIZES.MEDIUM] = 28, _heightMap$4[SIZES.LARGE] = 38, _heightMap$4[SIZES.BIG] = 38, _heightMap$4);
var StyledButton$2 = styled.button(_templateObject$1k(), function (props) {
  return getSizingDefinitions$1(props.size, heightMap$4);
}, COLORS.TEXT_COLORS.LINK, FONTS.FONT_FAMILY.DEFAULT, COLORS.ACTION_COLORS.BLUE_MAIN_HOVER, COLORS.ACTION_COLORS.BLUE_MAIN_ACTIVE);

var LinkButton = function LinkButton(props) {
  return /*#__PURE__*/React$1.createElement(StyledButton$2, _extends$2({
    type: "button"
  }, props));
};

LinkButton.defaultProps = {
  size: SIZES.MEDIUM
};
LinkButton.propTypes = {
  /** onClick handler function */
  onClick: PropTypes$1.func.isRequired,

  /** link button text size */
  size: PropTypes$1.oneOf([SIZES.MEDIUM, SIZES.LARGE])
};

function _templateObject4$h() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  flex: 1 0 auto;\n  text-align: right;\n"]);

  _templateObject4$h = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$u() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  flex: 1 0 auto;\n  text-align: right;\n"]);

  _templateObject3$u = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$L() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-weight: 400;\n  font-family: ", ";\n  letter-spacing: 0.4px;\n  margin-right: 8px;\n"]);

  _templateObject2$L = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1j() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  line-height: 20px;\n"]);

  _templateObject$1j = function _templateObject() {
    return data;
  };

  return data;
}

var LabelWrapper = styled.div(_templateObject$1j());
var LabelText = styled.label(_templateObject2$L(), COLORS.TEXT_COLORS.LABEL, FONTS.FONT_FAMILY.DEFAULT);
var InfoText$1 = styled.div(_templateObject3$u(), COLORS.TEXT_COLORS.LABEL);
var RequiredInfo = styled.div(_templateObject4$h(), COLORS.STATUS_COLORS.ERROR);
var Label$1 = function Label(_ref) {
  var forId = _ref.forId,
      action = _ref.action,
      isRequired = _ref.isRequired,
      infoText = _ref.infoText,
      children = _ref.children;
  return /*#__PURE__*/React$1.createElement(LabelWrapper, null, /*#__PURE__*/React$1.createElement(LabelText, {
    htmlFor: forId
  }, children), action && /*#__PURE__*/React$1.createElement(LinkButton, {
    onClick: action.handler
  }, action.title), infoText && /*#__PURE__*/React$1.createElement(InfoText$1, null, infoText), isRequired && /*#__PURE__*/React$1.createElement(RequiredInfo, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "1935535842",
    defaultMessage: "Required"
  })));
};
Label$1.propTypes = {
  forId: PropTypes$1.string,
  action: PropTypes$1.shape({
    title: PropTypes$1.string.isRequired,
    handler: PropTypes$1.func.isRequired
  }),
  isRequired: PropTypes$1.bool,
  infoText: PropTypes$1.string
};

function _templateObject5$b() {
  var data = _taggedTemplateLiteralLoose(["\n    &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n    }\n  "]);

  _templateObject5$b = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$g() {
  var data = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n    "]);

  _templateObject4$g = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$t() {
  var data = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n    "]);

  _templateObject3$t = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$K() {
  var data = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n    "]);

  _templateObject2$K = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1i() {
  var data = _taggedTemplateLiteralLoose(["\n      border-color: ", ";\n    "]);

  _templateObject$1i = function _templateObject() {
    return data;
  };

  return data;
}

var getBorderColorDefinition = function getBorderColorDefinition(_ref) {
  var focused = _ref.focused,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      hovered = _ref.hovered;

  if (invalid) {
    return css(_templateObject$1i(), COLORS.STATUS_COLORS.ERROR);
  }

  if (focused) {
    return css(_templateObject2$K(), COLORS.ACTION_COLORS.ONELOGIN_BLUE);
  }

  if (disabled) {
    return css(_templateObject3$t(), COLORS.GRAY_COLORS.GRAY_94);
  }

  if (hovered) {
    return css(_templateObject4$g(), COLORS.GRAY_COLORS.GRAY_68);
  }

  return css(_templateObject5$b(), COLORS.GRAY_COLORS.GRAY_68, COLORS.ACTION_COLORS.ONELOGIN_BLUE);
};

var getBackgroundColor = function getBackgroundColor(_ref) {
  var locked = _ref.locked,
      disabled = _ref.disabled;

  if (locked) {
    return "#edfaff";
  }

  if (disabled) {
    return "#f2f4f5";
  }

  return COLORS.STATUS_COLORS.WHITE;
};

var _heightMap$3;

function _templateObject$1h() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  box-sizing: border-box;\n  width: 100%;\n  border: 1px solid ", ";\n  transition: border-color 0.2s;\n  border-radius: 2px;\n  font-family: ", ";\n  color: ", ";\n  letter-spacing: 0.2px;\n  padding: 0 12px;\n  line-height: normal;\n  background-color: ", ";\n\n  ", ";\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &::-webkit-credentials-auto-fill-button {\n    visibility: hidden;\n  }\n\n  &::placeholder {\n    color: #acadad;\n  }\n"]);

  _templateObject$1h = function _templateObject() {
    return data;
  };

  return data;
}
var heightMap$3 = (_heightMap$3 = {}, _heightMap$3[SIZES.MEDIUM] = 38, _heightMap$3[SIZES.LARGE] = 48, _heightMap$3[SIZES.BIG] = 48, _heightMap$3);
var Input = styled.input(_templateObject$1h(), function (props) {
  return getSizingDefinitions$1(props.size, heightMap$3);
}, COLORS.GRAY_COLORS.GRAY_88, FONTS.FONT_FAMILY.DEFAULT, COLORS.TEXT_COLORS.EMPHASIZED, function (props) {
  return getBackgroundColor(props);
}, function (props) {
  return getBorderColorDefinition(props);
});
Input.defaultProps = {
  type: "text",
  autoFocus: false,
  disabled: false,
  invalid: false,
  autoComplete: "off",
  autoCorrect: "off",
  spellCheck: "false",
  large: false,
  maxLength: 255,
  focused: false,
  locked: false,
  size: SIZES.MEDIUM
};
Input.propTypes = {
  id: PropTypes$1.string.isRequired,
  value: PropTypes$1.string,
  onChange: PropTypes$1.func,
  type: PropTypes$1.string,
  onBlur: PropTypes$1.func,
  autoFocus: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  autoComplete: PropTypes$1.string,
  autoCorrect: PropTypes$1.string,
  spellCheck: PropTypes$1.string,
  maxLength: PropTypes$1.number,
  name: PropTypes$1.string,
  autoCapitalize: PropTypes$1.string,
  size: PropTypes$1.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG]),
  focused: PropTypes$1.bool,
  locked: PropTypes$1.bool
};

var _heightMap$2;

function _templateObject4$f() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  line-height: normal;\n"]);

  _templateObject4$f = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$s() {
  var data = _taggedTemplateLiteralLoose(["\n  -webkit-text-security: ", ";\n  line-height: ", "px;\n"]);

  _templateObject3$s = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$J() {
  var data = _taggedTemplateLiteralLoose(["\n  line-height: ", "px;\n"]);

  _templateObject2$J = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1g() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: ", "px; //to avoid bumping in IE\n"]);

  _templateObject$1g = function _templateObject() {
    return data;
  };

  return data;
}
var revealLinkSize = SIZES.MEDIUM;
var heightMap$2 = (_heightMap$2 = {}, _heightMap$2[SIZES.MEDIUM] = 38, _heightMap$2[SIZES.LARGE] = 48, _heightMap$2[SIZES.BIG] = 48, _heightMap$2);
var PasswordInputContainer = styled.div(_templateObject$1g(), function (props) {
  return getHeight(props.size, heightMap$2);
});
var PasswordInputStyled = styled(Input)(_templateObject2$J(), function (props) {
  return getHeight(props.size, heightMap$2);
});
var PasswordPlaceholder = styled(Input)(_templateObject3$s(), function (props) {
  return props.revealed ? "initial" : "disc";
}, function (props) {
  return getHeight(props.size, heightMap$2);
});
var RevealContainer = styled.div(_templateObject4$f());
var PasswordInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(PasswordInput, _Component);

  function PasswordInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.toggleInputVisibility = function () {
      if (!_this.props.disabled) {
        _this.setState({
          inputVisible: !_this.state.inputVisible
        });
      }
    };

    _this.toggleReveal = function (event) {
      if (!_this.props.disabled) {
        _this.setState({
          revealed: !_this.state.revealed
        });
      }
    };

    _this.onBlur = function (event) {
      _this.toggleInputVisibility();

      typeof _this.props.onBlur === "function" && _this.props.onBlur(event.target.value);
    };

    _this.state = {
      inputVisible: props.autoFocus,
      revealed: false
    };
    return _this;
  }

  var _proto = PasswordInput.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        value = _this$props.value,
        disabled = _this$props.disabled; // you can override revealed from outside (use-case: reveal password on generate password)

    var revealed = this.props.revealed || this.state.revealed;
    var showRevealToggle = !disabled && value && !this.props.revealed;
    return /*#__PURE__*/React$1.createElement(PasswordInputContainer, {
      size: this.props.size
    }, this.state.inputVisible ? /*#__PURE__*/React$1.createElement(PasswordInputStyled, _extends$2({}, this.props, {
      type: revealed ? "text" : "password",
      onBlur: this.onBlur,
      autoFocus: true
    })) : /*#__PURE__*/React$1.createElement(PasswordPlaceholder, {
      as: "div",
      id: this.props.id,
      tabIndex: this.props.disabled ? undefined : 0,
      onClick: this.toggleInputVisibility,
      onFocus: this.toggleInputVisibility,
      revealed: revealed,
      disabled: disabled,
      size: this.props.size,
      invalid: this.props.invalid
    }, revealed ? value : value.replace(/./g, "•")), showRevealToggle && /*#__PURE__*/React$1.createElement(RevealContainer, {
      size: this.props.size
    }, /*#__PURE__*/React$1.createElement(LinkButton, {
      onClick: this.toggleReveal,
      size: revealLinkSize
    }, revealed ? /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "2600324508",
      defaultMessage: "Hide"
    }) : /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "1242107845",
      defaultMessage: "Show"
    }))));
  };

  return PasswordInput;
}(Component);
PasswordInput.defaultProps = {
  autoFocus: false,
  disabled: false,
  invalid: false,
  autoComplete: "off",
  autoCorrect: "off",
  spellCheck: "false",
  maxLength: 255,
  revealed: false,
  size: SIZES.MEDIUM
};
PasswordInput.propTypes = {
  id: PropTypes$1.string.isRequired,
  value: PropTypes$1.string.isRequired,
  onChange: PropTypes$1.func,
  onBlur: PropTypes$1.func,
  autoFocus: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  autoComplete: PropTypes$1.string,
  autoCorrect: PropTypes$1.string,
  spellCheck: PropTypes$1.string,
  maxLength: PropTypes$1.number,
  name: PropTypes$1.string,
  autoCapitalize: PropTypes$1.string,
  revealed: PropTypes$1.bool,
  size: PropTypes$1.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG])
};

var Avatar_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8Y2lyY2xlIGlkPSJhdmF0YXItMjQtYSIgY3g9IjEyIiBjeT0iMTIiIHI9IjEyIi8+CiAgICA8cGF0aCBpZD0iYXZhdGFyLTI0LWMiIGQ9Ik01LjM5MjQxMzM5LDExIEM2LjQ0NTk1NjE5LDExLjYzNDgxOTggNy42ODAzMzE4OSwxMiA5LDEyIEMxMC4zMTk2NjgxLDEyIDExLjU1NDA0MzgsMTEuNjM0ODE5OCAxMi42MDc1ODY2LDExIEwxMywxMSBDMTUuNzYxNDIzNywxMSAxOCwxMy4yMzg1NzYzIDE4LDE2IEwxOCwxOCBMMCwxOCBMMCwxNiBDLTMuMzgxNzY4NzZlLTE2LDEzLjIzODU3NjMgMi4yMzg1NzYyNSwxMSA1LDExIEw1LjM5MjQxMzM5LDExIFogTTksMTAgQzYuMjM4NTc2MjUsMTAgNCw3Ljc2MTQyMzc1IDQsNSBDNCwyLjIzODU3NjI1IDYuMjM4NTc2MjUsMCA5LDAgQzExLjc2MTQyMzcsMCAxNCwyLjIzODU3NjI1IDE0LDUgQzE0LDcuNzYxNDIzNzUgMTEuNzYxNDIzNywxMCA5LDEwIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPG1hc2sgaWQ9ImF2YXRhci0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjYXZhdGFyLTI0LWEiLz4KICAgIDwvbWFzaz4KICAgIDx1c2UgZmlsbD0iI0YzRjNGNCIgeGxpbms6aHJlZj0iI2F2YXRhci0yNC1hIi8+CiAgICA8ZyBtYXNrPSJ1cmwoI2F2YXRhci0yNC1iKSI+CiAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgNikiPgogICAgICAgIDxtYXNrIGlkPSJhdmF0YXItMjQtZCIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhdmF0YXItMjQtYyIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNhdmF0YXItMjQtYyIvPgogICAgICAgIDxnIG1hc2s9InVybCgjYXZhdGFyLTI0LWQpIj4KICAgICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgZmlsbD0iIzhCOEM4QyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM5IC00MikiLz4KICAgICAgICA8L2c+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Alert = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGMjlCMDUiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTQzLjIgNDNINC43ODlhMi43OTMgMi43OTMgMCAwIDEtMi40MTUtMS40IDIuODE1IDIuODE1IDAgMCAxIDAtMi44TDIxLjU3OCA1LjRBMi43OTUgMi43OTUgMCAwIDEgMjMuOTk0IDRjLjk5MyAwIDEuOTE4LjUzNiAyLjQxNiAxLjRsMTkuMDY4IDMzLjE2MmMuMzU4LjUzMS41MjIgMS4wNzUuNTIyIDEuNjM4YTIuODAyIDIuODAyIDAgMCAxLTIuOCAyLjh6TTIyIDM0djRoNHYtNGgtNHptMC0xOXYxNmg0VjE1aC00eiIvPgogICAgPC9nPgo8L3N2Zz4K";

var App_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0icHJlZml4X19hIiBkPSJNMTQuNTU4IDcuNjI0bC4zODQuMjIyYy40NzkuMjc3LjY0My44ODguMzY2IDEuMzY2bC0uMzQ1LjZjLjI0My4yNjguNDUuNTcuNjE0Ljg5Ni4wOTIuMTgyLjE3LjM3Mi4yMzMuNTY4aC42OWMuNTUyIDAgMSAuNDQ4IDEgMXYuNDQ1YzAgLjU1Mi0uNDQ4IDEtMSAxaC0uNjljLS4xNzYuNTUtLjQ2OCAxLjA0OC0uODQ3IDEuNDY1bC4zNDUuNTk4Yy4yNzcuNDc5LjExMyAxLjA5LS4zNjYgMS4zNjZsLS4zODQuMjIzYy0uNDc5LjI3Ni0xLjA5LjExMi0xLjM2Ni0uMzY2bC0uMzQ1LS41OTdjLS4yNzMuMDU4LS41NTYuMDktLjg0Ny4wOS0uMjkgMC0uNTc0LS4wMzItLjg0Ny0uMDlsLS4zNDUuNTk3Yy0uMjc2LjQ3OC0uODg3LjY0Mi0xLjM2Ni4zNjZsLS4zODQtLjIyM2MtLjQ3OS0uMjc2LS42NDMtLjg4Ny0uMzY2LTEuMzY2bC4zNDUtLjU5OGMtLjM4LS40MTctLjY3LS45MTUtLjg0Ny0xLjQ2NUg3LjVjLS41NTIgMC0xLS40NDgtMS0xdi0uNDQ1YzAtLjU1Mi40NDgtMSAxLTFoLjY5Yy4xNzctLjU1LjQ2OS0xLjA0Ny44NDgtMS40NjRsLS4zNDYtLjZjLS4yNzctLjQ3OC0uMTEzLTEuMDkuMzY2LTEuMzY2bC4zODQtLjIyMmMuNDc5LS4yNzYgMS4wOS0uMTEyIDEuMzY2LjM2NmwuMzQ2LjU5OWMuMjczLS4wNTkuNTU2LS4wOS44NDYtLjA5LjI5IDAgLjU3My4wMzEuODQ1LjA5bC4zNDctLjU5OWMuMjc2LS40NzguODg3LS42NDIgMS4zNjYtLjM2NnpNMTIgMTAuNWMtMS4xMDUgMC0yIC44OTUtMiAycy44OTUgMiAyIDIgMi0uODk1IDItMi0uODk1LTItMi0yeiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iIzc2Nzg3RiIgZD0iTTMgMmgxOGMxLjEwNSAwIDIgLjg5NSAyIDJ2MTVjMCAxLjEwNS0uODk1IDItMiAySDNjLTEuMTA1IDAtMi0uODk1LTItMlY0YzAtMS4xMDUuODk1LTIgMi0yeiIvPgogICAgICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIxNSIgeD0iMiIgeT0iNSIgZmlsbD0iI0ZGRiIgcng9IjEiLz4KICAgICAgICA8dXNlIGZpbGw9IiMzQjlBREUiIHhsaW5rOmhyZWY9IiNwcmVmaXhfX2EiLz4KICAgIDwvZz4KPC9zdmc+Cg==";

var Checkmark_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hlY2ttYXJrLTE2LWEiIHBvaW50cz0iNC45OTggMTAgMCA1IDEuNDk4IDMuNSA0Ljk5OCA3IDExLjk5OCAwIDEzLjQ5OCAxLjUiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAzKSI+CiAgICAgIDxtYXNrIGlkPSJjaGVja21hcmstMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjY2hlY2ttYXJrLTE2LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNjaGVja21hcmstMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2NoZWNrbWFyay0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDEgLTQ0KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Checkmark_16_thick = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iYSIgZD0iTTQuOTk4IDEwTDAgNWwxLjQ5OC0xLjUgMy41IDMuNSA3LTcgMS41IDEuNXoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMTZ2MTZIMHoiLz4KICAgIDx1c2UgZmlsbD0iI0ZGRiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAzKSIgeGxpbms6aHJlZj0iI2EiLz4KICA8L2c+Cjwvc3ZnPgo=";

var Checkmark_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hlY2ttYXJrLTI0LWEiIHBvaW50cz0iNS45OTggMTMuNTcyIDAgNy41NzIgMS40OTggNi4wNzIgNS45OTggMTAuNTcyIDE1Ljk5OCAuNTcyIDE3LjQ5OCAyLjA3MiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDUpIj4KICAgICAgPG1hc2sgaWQ9ImNoZWNrbWFyay0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGVja21hcmstMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzVEQTMwRCIgeGxpbms6aHJlZj0iI2NoZWNrbWFyay0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM1REEzMEQiIG1hc2s9InVybCgjY2hlY2ttYXJrLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOSAtMzkpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var CheckmarkCheckbox = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+CiAgICA8cG9seWdvbiB4PSIxIiB5PSIzIiB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSI1Ljk5OCAxMyAxIDggMi40OTggNi41IDUuOTk4IDEwIDEyLjk5OCAzIDE0LjQ5OCA0LjUiLz4KICA8L2c+Cjwvc3ZnPgo=";

var ChevronDown_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9kb3duLTEyLWEiIHBvaW50cz0iNC45NzggNC4xMSA4LjkyMyAwIDEwIDEuMDMzIDQuOTcxIDYuMjczIDAgMS4wMjcgMS4wODMgMCIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIi8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDMpIj4KICAgICAgPG1hc2sgaWQ9ImNoZXZyb25fZG93bi0xMi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGV2cm9uX2Rvd24tMTItYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2NoZXZyb25fZG93bi0xMi1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjY2hldnJvbl9kb3duLTEyLWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MSAtNDMpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var ChevronDown_12_white = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0icHJlZml4X19hIiBkPSJNNC45NzggNC4xMUw4LjkyMyAwIDEwIDEuMDMzIDQuOTcxIDYuMjczIDAgMS4wMjcgMS4wODMgMHoiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMEgxMlYxMkgweiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMykiPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNGRkYiIHhsaW5rOmhyZWY9IiNwcmVmaXhfX2EiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";

var ChevronDown_12_black = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0icHJlZml4X19hIiBkPSJNNC45NzggNC4xMUw4LjkyMyAwIDEwIDEuMDMzIDQuOTcxIDYuMjczIDAgMS4wMjcgMS4wODMgMHoiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMEgxMlYxMkgweiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMykiPgogICAgICAgICAgICA8dXNlIGZpbGw9IiMwMDAiIHhsaW5rOmhyZWY9IiNwcmVmaXhfX2EiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";

var ChevronDown_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9kb3duLTE2LWEiIHBvaW50cz0iNi45NjkgNS43NTQgMTIuNDkzIDAgMTQgMS40NDcgNi45NTkgOC43ODIgMCAxLjQzNyAxLjUxNyAwIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgNCkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9kb3duLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fZG93bi0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjY2hldnJvbl9kb3duLTE2LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjaGV2cm9uX2Rvd24tMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxIC00NCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var ChevronLeft_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9sZWZ0LTEyLWEiIHBvaW50cz0iMi44OTIgNS4wMjIgNy4wMDIgOC45MTcgNS45NzYgMTAgLjczIDUuMDI5IDUuOTY5IDAgNy4wMDMgMS4wNzciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMiAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9sZWZ0LTEyLWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fbGVmdC0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjY2hldnJvbl9sZWZ0LTEyLWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjaGV2cm9uX2xlZnQtMTItYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyIC00MikiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var ChevronLeft_12_white = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9sZWZ0LTEyLWEiIHBvaW50cz0iMi44OTIgNS4wMjIgNy4wMDIgOC45MTcgNS45NzYgMTAgLjczIDUuMDI5IDUuOTY5IDAgNy4wMDMgMS4wNzciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMiAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9sZWZ0LTEyLWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fbGVmdC0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjZmZmZmZmIiB4bGluazpocmVmPSIjY2hldnJvbl9sZWZ0LTEyLWEiLz4KICAgICAgPGcgZmlsbD0iI2ZmZmZmZiIgbWFzaz0idXJsKCNjaGV2cm9uX2xlZnQtMTItYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyIC00MikiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var ChevronLeft_12_black = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9sZWZ0LTEyLWEiIHBvaW50cz0iMi44OTIgNS4wMjIgNy4wMDIgOC45MTcgNS45NzYgMTAgLjczIDUuMDI5IDUuOTY5IDAgNy4wMDMgMS4wNzciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMiAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9sZWZ0LTEyLWIiIGZpbGw9IiMwMDAiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fbGVmdC0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjMDAwMDAwIiB4bGluazpocmVmPSIjY2hldnJvbl9sZWZ0LTEyLWEiLz4KICAgICAgPGcgZmlsbD0iIzAwMDAwMCIgbWFzaz0idXJsKCNjaGV2cm9uX2xlZnQtMTItYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyIC00MikiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var ChevronLeft_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTUuNzU0IDYuOTY5TDAgMS41MTcgMS40MzcgMGw3LjM0NSA2Ljk2TDEuNDQ3IDE0IDAgMTIuNDkzeiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMCAwaDE2djE2SDB6Ii8+CiAgICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAxMS43ODIgMSkiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";

var ChevronLeft_16_white = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTUuNzU0IDYuOTY5TDAgMS41MTcgMS40MzcgMGw3LjM0NSA2Ljk2TDEuNDQ3IDE0IDAgMTIuNDkzeiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMCAwaDE2djE2SDB6Ii8+CiAgICAgICAgPHVzZSBmaWxsPSIjRkZGRkZGIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAxMS43ODIgMSkiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";

var ChevronRight_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9yaWdodC0xMi1hIiBwb2ludHM9IjQuMTEgNS4wMjIgMCAxLjA3NyAxLjAzMyAwIDYuMjczIDUuMDI5IDEuMDI3IDEwIDAgOC45MTciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMyAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9yaWdodC0xMi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjaGV2cm9uX3JpZ2h0LTEyLWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MyAtNDIpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var ChevronRight_12_white = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9yaWdodC0xMi1hLXdoaXRlIiBwb2ludHM9IjQuMTEgNS4wMjIgMCAxLjA3NyAxLjAzMyAwIDYuMjczIDUuMDI5IDEuMDI3IDEwIDAgOC45MTciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMyAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9yaWdodC0xMi1iLXdoaXRlIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEtd2hpdGUiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiNmZmYiIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEtd2hpdGUiLz4KICAgICAgPGcgZmlsbD0iI2ZmZiIgbWFzaz0idXJsKCNjaGV2cm9uX3JpZ2h0LTEyLWItd2hpdGUpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MyAtNDIpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var ChevronRight_12_black = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9yaWdodC0xMi1hLXdoaXRlIiBwb2ludHM9IjQuMTEgNS4wMjIgMCAxLjA3NyAxLjAzMyAwIDYuMjczIDUuMDI5IDEuMDI3IDEwIDAgOC45MTciLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMyAxMSkiPgogICAgICA8bWFzayBpZD0iY2hldnJvbl9yaWdodC0xMi1iLXdoaXRlIiBmaWxsPSIjMDAwIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEtd2hpdGUiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiMwMDAiIHhsaW5rOmhyZWY9IiNjaGV2cm9uX3JpZ2h0LTEyLWEtd2hpdGUiLz4KICAgICAgPGcgZmlsbD0iIzAwMCIgbWFzaz0idXJsKCNjaGV2cm9uX3JpZ2h0LTEyLWItd2hpdGUpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MyAtNDIpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var ChevronRight_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl9yaWdodC0xNi1hIiBwb2ludHM9IjUuNzU0IDYuOTY5IDAgMS41MTcgMS40MzcgMCA4Ljc4MiA2Ljk1OSAxLjQ0NyAxNCAwIDEyLjQ5MyIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDEpIj4KICAgICAgPG1hc2sgaWQ9ImNoZXZyb25fcmlnaHQtMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjY2hldnJvbl9yaWdodC0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjY2hldnJvbl9yaWdodC0xNi1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjY2hldnJvbl9yaWdodC0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDMgLTQyKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var ChevronUp_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl91cC0xMi1hIiBwb2ludHM9IjQuOTc4IDQuMTEgOC45MjMgMCAxMCAxLjAzMyA0Ljk3MSA2LjI3MyAwIDEuMDI3IDEuMDgzIDAiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMSA5KSI+CiAgICAgIDxtYXNrIGlkPSJjaGV2cm9uX3VwLTEyLWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fdXAtMTItYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2NoZXZyb25fdXAtMTItYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2NoZXZyb25fdXAtMTItYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxIC00NCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var ChevronUp_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0iY2hldnJvbl91cC0xNi1hIiBwb2ludHM9IjYuOTY5IDMuMDI3IDEuNTE3IDguNzgxIDAgNy4zNDQgNi45NTkgMCAxNCA3LjMzNSAxMi40OTMgOC43ODIiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAzKSI+CiAgICAgIDxtYXNrIGlkPSJjaGV2cm9uX3VwLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NoZXZyb25fdXAtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2NoZXZyb25fdXAtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2NoZXZyb25fdXAtMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxIC00MykiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var CircleDisabled_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iMTIiIHI9IjgiIGZpbGw9IiNERUUwRTAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNCkiLz4KPC9zdmc+Cg==";

var Clock_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xvY2stMjQtYSIgZD0iTTExLDkuODQ3MzUwNzMgTDE0LjMzMDEyNywxMS43NzAwMDA1IEwxMy4zMzAxMjcsMTMuNTAyMDUxMyBMOSwxMS4wMDIwNTEzIEw5LjAwMTE4NDMsMTEgTDksMTEgTDksNCBMMTEsNCBMMTEsOS44NDczNTA3MyBaIE0xMCwyMCBDNC40NzcxNTI1LDIwIC0zLjU4ODI0MDgyZS0xMywxNS41MjI4NDc1IC0zLjU4ODI0MDgyZS0xMywxMCBDLTMuNTg4MjQwODJlLTEzLDQuNDc3MTUyNSA0LjQ3NzE1MjUsMCAxMCwwIEMxNS41MjI4NDc1LDAgMjAsNC40NzcxNTI1IDIwLDEwIEMyMCwxNS41MjI4NDc1IDE1LjUyMjg0NzUsMjAgMTAsMjAgWiBNMTAsMTggQzE0LjQxODI3OCwxOCAxOCwxNC40MTgyNzggMTgsMTAgQzE4LDUuNTgxNzIyIDE0LjQxODI3OCwyIDEwLDIgQzUuNTgxNzIyLDIgMiw1LjU4MTcyMiAyLDEwIEMyLDE0LjQxODI3OCA1LjU4MTcyMiwxOCAxMCwxOCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICA8bWFzayBpZD0iY2xvY2stMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjY2xvY2stMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2Nsb2NrLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjbG9jay0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzggLTM5KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Close_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xvc2UtMTItYSIgZD0iTTUsNS43ODMwMjkwMyBMMC43ODMwMjkwMjksMTAgTDAsOS4yMTY5NzA5NyBMNC4yMTY5NzA5Nyw1IEwwLDAuNzgzMDI5MDI5IEwwLjc4MzAyOTAyOSwwIEw1LDQuMjE2OTcwOTcgTDkuMjE2OTcwOTcsMCBMMTAsMC43ODMwMjkwMjkgTDUuNzgzMDI5MDMsNSBMMTAsOS4yMTY5NzA5NyBMOS4yMTY5NzA5NywxMCBMNSw1Ljc4MzAyOTAzIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSI+CiAgICAgIDxtYXNrIGlkPSJjbG9zZS0xMi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjbG9zZS0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjY2xvc2UtMTItYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2Nsb3NlLTEyLWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MSAtNDEpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Close_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xvc2UtMTYtYSIgZD0iTTYsNi43ODMwMjkwMyBMMC43ODMwMjkwMjksMTIgTDEuMTM2ODY4MzhlLTEzLDExLjIxNjk3MSBMNS4yMTY5NzA5Nyw2IEwxLjEzNjg2ODM4ZS0xMywwLjc4MzAyOTAyOSBMMC43ODMwMjkwMjksMCBMNiw1LjIxNjk3MDk3IEwxMS4yMTY5NzEsMCBMMTIsMC43ODMwMjkwMjkgTDYuNzgzMDI5MDMsNiBMMTIsMTEuMjE2OTcxIEwxMS4yMTY5NzEsMTIgTDYsNi43ODMwMjkwMyBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICA8bWFzayBpZD0iY2xvc2UtMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjY2xvc2UtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2Nsb3NlLTE2LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNjbG9zZS0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDIgLTQyKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Close_16_thick = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTAgMGgxNnYxNkgweiIvPgogICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTEyLjQ5OCAybDEuNSAxLjVMOS40OTcgOGw0LjUgNC41TDEyLjUgMTQgNy45OTkgOS40OTkgMy40OTggMTQgMiAxMi41bDQuNDk5LTQuNTAxTDIgMy41IDMuNSAybDQuNDk4IDQuNSA0LjUtNC41eiIvPgogIDwvZz4KPC9zdmc+Cg==";

var Close_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xvc2UtMjQtYSIgZD0iTTgsOC43ODMwMjkwMyBMMC43ODMwMjkwMjksMTYgTDAsMTUuMjE2OTcxIEw3LjIxNjk3MDk3LDggTDAsMC43ODMwMjkwMjkgTDAuNzgzMDI5MDI5LDAgTDgsNy4yMTY5NzA5NyBMMTUuMjE2OTcxLDAgTDE2LDAuNzgzMDI5MDI5IEw4Ljc4MzAyOTAzLDggTDE2LDE1LjIxNjk3MSBMMTUuMjE2OTcxLDE2IEw4LDguNzgzMDI5MDMgWiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj4KICAgICAgPG1hc2sgaWQ9ImNsb3NlLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2Nsb3NlLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNjbG9zZS0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjY2xvc2UtMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwIC00MCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var Download_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZG93bmxvYWQtMTYtYSIgZD0iTTQuOTk5ODYwMjEsNyBMNC45OTk4NjAyMSwwIEw2Ljk5OTg2MDIxLDAgTDYuOTk5ODYwMjEsNi45OTczMTMwNSBMOS45OTk4NjAyMSw0IEwxMS40OTgwOTAyLDUuNSBMNS45OTk4NjAyMSwxMC45OTE3Nzk3IEw1Ljk5OTg2MDIxLDEwLjk5NTM2MTMgTDUuOTk4MDY3NiwxMC45OTM1NzAyIEw1Ljk5NjI3NDM5LDEwLjk5NTM2MTMgTDUuOTk2Mjc0MzksMTAuOTkxNzc4NSBMMC40OTk4NjAyMDgsNS41IEwxLjk5OTg2MDIxLDQgTDQuOTk5ODYwMjEsNyBaIE0xMiwxMiBMMTIsMTQgTDAsMTQgTDAsMTIgTDEyLDEyIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAxKSI+CiAgICAgIDxtYXNrIGlkPSJkb3dubG9hZC0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNkb3dubG9hZC0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNkb3dubG9hZC0xNi1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjZG93bmxvYWQtMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyIC00MSkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var Ellipsis_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZWxsaXBzaXMtMTYtYSIgZD0iTTUsMiBDNC40NDc3MTUyNSwyIDQsMS41NTIyODQ3NSA0LDEgQzQsMC40NDc3MTUyNSA0LjQ0NzcxNTI1LDAgNSwwIEM1LjU1MjI4NDc1LDAgNiwwLjQ0NzcxNTI1IDYsMSBDNiwxLjU1MjI4NDc1IDUuNTUyMjg0NzUsMiA1LDIgWiBNMSwyIEMwLjQ0NzcxNTI1LDIgMCwxLjU1MjI4NDc1IDAsMSBDMCwwLjQ0NzcxNTI1IDAuNDQ3NzE1MjUsMCAxLDAgQzEuNTUyMjg0NzUsMCAyLDAuNDQ3NzE1MjUgMiwxIEMyLDEuNTUyMjg0NzUgMS41NTIyODQ3NSwyIDEsMiBaIE05LDIgQzguNDQ3NzE1MjUsMiA4LDEuNTUyMjg0NzUgOCwxIEM4LDAuNDQ3NzE1MjUgOC40NDc3MTUyNSwwIDksMCBDOS41NTIyODQ3NSwwIDEwLDAuNDQ3NzE1MjUgMTAsMSBDMTAsMS41NTIyODQ3NSA5LjU1MjI4NDc1LDIgOSwyIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyA3KSI+CiAgICAgIDxtYXNrIGlkPSJlbGxpcHNpcy0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNlbGxpcHNpcy0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjZWxsaXBzaXMtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2VsbGlwc2lzLTE2LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MyAtNDYpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Ellipsis_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZWxsaXBzaXMtMjQtYSIgZD0iTTgsMy41IEM3LjE3MTU3Mjg4LDMuNSA2LjUsMi44Mjg0MjcxMiA2LjUsMiBDNi41LDEuMTcxNTcyODggNy4xNzE1NzI4OCwwLjUgOCwwLjUgQzguODI4NDI3MTIsMC41IDkuNSwxLjE3MTU3Mjg4IDkuNSwyIEM5LjUsMi44Mjg0MjcxMiA4LjgyODQyNzEyLDMuNSA4LDMuNSBaIE0xNC41LDMuNSBDMTMuNjcxNTcyOSwzLjUgMTMsMi44Mjg0MjcxMiAxMywyIEMxMywxLjE3MTU3Mjg4IDEzLjY3MTU3MjksMC41IDE0LjUsMC41IEMxNS4zMjg0MjcxLDAuNSAxNiwxLjE3MTU3Mjg4IDE2LDIgQzE2LDIuODI4NDI3MTIgMTUuMzI4NDI3MSwzLjUgMTQuNSwzLjUgWiBNMS41LDMuNSBDMC42NzE1NzI4NzUsMy41IDAsMi44Mjg0MjcxMiAwLDIgQzAsMS4xNzE1NzI4OCAwLjY3MTU3Mjg3NSwwLjUgMS41LDAuNSBDMi4zMjg0MjcxMiwwLjUgMywxLjE3MTU3Mjg4IDMsMiBDMywyLjgyODQyNzEyIDIuMzI4NDI3MTIsMy41IDEuNSwzLjUgWiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDEwKSI+CiAgICAgIDxtYXNrIGlkPSJlbGxpcHNpcy0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNlbGxpcHNpcy0yNC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjQTJBM0E3IiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNlbGxpcHNpcy0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjZWxsaXBzaXMtMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwIC00NikiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var Error_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iZXJyb3ItMjQtYSIgZD0iTTEwLDIwIEM0LjQ3NzE1MjUsMjAgMCwxNS41MjI4NDc1IDAsMTAgQzAsNC40NzcxNTI1IDQuNDc3MTUyNSwwIDEwLDAgQzE1LjUyMjg0NzUsMCAyMCw0LjQ3NzE1MjUgMjAsMTAgQzIwLDE1LjUyMjg0NzUgMTUuNTIyODQ3NSwyMCAxMCwyMCBaIE05LDEzIEw5LDE1IEwxMSwxNSBMMTEsMTMgTDksMTMgWiBNOSw1IEw5LDExIEwxMSwxMSBMMTEsNSBMOSw1IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+CiAgICAgIDxtYXNrIGlkPSJlcnJvci0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNlcnJvci0yNC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjZXJyb3ItMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjRDYyOTFBIiBtYXNrPSJ1cmwoI2Vycm9yLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOCAtMzgpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var ErrorWhite_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTEwIDIwQzQuNDc3IDIwIDAgMTUuNTIzIDAgMTBTNC40NzcgMCAxMCAwczEwIDQuNDc3IDEwIDEwLTQuNDc3IDEwLTEwIDEwem0tMS03djJoMnYtMkg5em0wLTh2NmgyVjVIOXoiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgICAgICA8ZyBmaWxsPSIjZmZmIiBtYXNrPSJ1cmwoI2IpIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0tMzgtMzhoOTZ2OTZoLTk2eiIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";

var Eye_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAgMEgyNFYyNEgweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkwNiAtNzUpIHRyYW5zbGF0ZSgwIDUyKSB0cmFuc2xhdGUoOTA2IDIzKSIvPgogICAgICAgICAgICAgICAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMSAuNUM2IC41IDAgNCAwIDhjMCA0LjAxNCA2IDcuNSAxMSA3LjVTMjIgMTEuOTk2IDIyIDhjMC00LTYtNy41LTExLTcuNXpNMTEgMTNjLTIuNzYgMC01LTIuMjQtNS01czIuMjQtNSA1LTUgNSAyLjI0IDUgNS0yLjI0IDUtNSA1em0wLThDOS4zNCA1IDggNi4zNCA4IDhzMS4zNCAzIDMgMyAzLTEuMzQgMy0zLTEuMzQtMy0zLTN6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTA2IC03NSkgdHJhbnNsYXRlKDAgNTIpIHRyYW5zbGF0ZSg5MDYgMjMpIHRyYW5zbGF0ZSgxIDQpIi8+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";

var Forbid_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMEgxNlYxNkgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNENjI5MUEiIGQ9Ik04IDBjNC40MTkgMCA4IDMuNTgyIDggOHMtMy41ODEgOC04IDhjLTQuNDE5IDAtOC0zLjU4Mi04LThzMy41ODEtOCA4LTh6bTQuODkgNC41MjNsLTguMzY3IDguMzY4QzUuNTA0IDEzLjU4OSA2LjcwNCAxNCA4IDE0YzMuMzE0IDAgNi0yLjY4NiA2LTYgMC0xLjI5Ni0uNDEtMi40OTYtMS4xMS0zLjQ3N3pNOCAyQzQuNjg2IDIgMiA0LjY4NiAyIDhjMCAxLjI5Ni40MSAyLjQ5NiAxLjExIDMuNDc3bDguMzY3LTguMzY4QzEwLjQ5NiAyLjQxMSA5LjI5NiAyIDggMnoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";

var Gear_24 = "data:image/svg+xml;base64,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";

var Grip_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTQgNGgydjJINFY0em0wLTRoMnYySDRWMHptMCA4aDJ2Mkg0Vjh6TTAgMGgydjJIMFYwem0wIDRoMnYySDBWNHptMCA0aDJ2MkgwVjh6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0wIDBoMTZ2MTZIMHoiLz4KICAgICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUgMykiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";

var InProgress_24 = "data:image/svg+xml;base64,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";

var InfoOutline_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iaW5mb19vdXRsaW5lLTE2LWEiIGQ9Ik04LDE2IEMzLjU4MTcyMiwxNiAwLDEyLjQxODI3OCAwLDggQzAsMy41ODE3MjIgMy41ODE3MjIsMCA4LDAgQzEyLjQxODI3OCwwIDE2LDMuNTgxNzIyIDE2LDggQzE2LDEyLjQxODI3OCAxMi40MTgyNzgsMTYgOCwxNiBaIE04LDE1IEMxMS44NjU5OTMyLDE1IDE1LDExLjg2NTk5MzIgMTUsOCBDMTUsNC4xMzQwMDY3NSAxMS44NjU5OTMyLDEgOCwxIEM0LjEzNDAwNjc1LDEgMSw0LjEzNDAwNjc1IDEsOCBDMSwxMS44NjU5OTMyIDQuMTM0MDA2NzUsMTUgOCwxNSBaIE03LDQgTDksNCBMOSw2IEw3LDYgTDcsNCBaIE03LDcgTDksNyBMOSwxMiBMNywxMiBMNyw3IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPG1hc2sgaWQ9ImluZm9fb3V0bGluZS0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjaW5mb19vdXRsaW5lLTE2LWEiLz4KICAgIDwvbWFzaz4KICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2luZm9fb3V0bGluZS0xNi1hIi8+CiAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2luZm9fb3V0bGluZS0xNi1iKSI+CiAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwIC00MCkiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var InfoOutline_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iaW5mb19vdXRsaW5lLTI0LWEiIGQ9Ik0xMCwyMCBDNC40NzcxNTI1LDIwIDAsMTUuNTIyODQ3NSAwLDEwIEMwLDQuNDc3MTUyNSA0LjQ3NzE1MjUsMCAxMCwwIEMxNS41MjI4NDc1LDAgMjAsNC40NzcxNTI1IDIwLDEwIEMyMCwxNS41MjI4NDc1IDE1LjUyMjg0NzUsMjAgMTAsMjAgWiBNMTAsMTggQzE0LjQxODI3OCwxOCAxOCwxNC40MTgyNzggMTgsMTAgQzE4LDUuNTgxNzIyIDE0LjQxODI3OCwyIDEwLDIgQzUuNTgxNzIyLDIgMiw1LjU4MTcyMiAyLDEwIEMyLDE0LjQxODI3OCA1LjU4MTcyMiwxOCAxMCwxOCBaIE05LDkgTDExLDkgTDExLDE1IEw5LDE1IEw5LDkgWiBNOSw1IEwxMSw1IEwxMSw3IEw5LDcgTDksNSBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICA8bWFzayBpZD0iaW5mb19vdXRsaW5lLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2luZm9fb3V0bGluZS0yNC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNpbmZvX291dGxpbmUtMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2luZm9fb3V0bGluZS0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzggLTM4KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Info_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iaW5mby0xNi1hIiBkPSJNOCwxNiBDMy41ODE3MjIsMTYgMCwxMi40MTgyNzggMCw4IEMwLDMuNTgxNzIyIDMuNTgxNzIyLDAgOCwwIEMxMi40MTgyNzgsMCAxNiwzLjU4MTcyMiAxNiw4IEMxNiwxMi40MTgyNzggMTIuNDE4Mjc4LDE2IDgsMTYgWiBNNyw0IEw3LDYgTDksNiBMOSw0IEw3LDQgWiBNNyw3IEw3LDEyIEw5LDEyIEw5LDcgTDcsNyBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxtYXNrIGlkPSJpbmZvLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICA8dXNlIHhsaW5rOmhyZWY9IiNpbmZvLTE2LWEiLz4KICAgIDwvbWFzaz4KICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2luZm8tMTYtYSIvPgogICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNpbmZvLTE2LWIpIj4KICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAgLTQwKSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var Info_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iaW5mby0yNC1hIiBkPSJNMTAsMjAgQzQuNDc3MTUyNSwyMCAwLDE1LjUyMjg0NzUgMCwxMCBDMCw0LjQ3NzE1MjUgNC40NzcxNTI1LDAgMTAsMCBDMTUuNTIyODQ3NSwwIDIwLDQuNDc3MTUyNSAyMCwxMCBDMjAsMTUuNTIyODQ3NSAxNS41MjI4NDc1LDIwIDEwLDIwIFogTTksNSBMOSw3IEwxMSw3IEwxMSw1IEw5LDUgWiBNOSw5IEw5LDE1IEwxMSwxNSBMMTEsOSBMOSw5IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+CiAgICAgIDxtYXNrIGlkPSJpbmZvLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2luZm8tMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2luZm8tMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2luZm8tMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM4IC0zOCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var Key_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMEwyNCAwIDI0IDI0IDAgMjR6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iIzYyQUM0OSIgZD0iTTE1IDNjMy4zMTQgMCA2IDIuNjg2IDYgNnMtMi42ODYgNi02IDZjLS45MjYgMC0xLjgwNC0uMjEtMi41ODctLjU4NWwtMS43MzIgMS43MzEgMS42NDcgMS42NDdMOS41IDIwLjYybC0xLjY0Ny0xLjY0N0w1Ljg4IDIwLjk1IDMuMDUgMTguMTJsNi41MzUtNi41MzRDOS4yMSAxMC44MDQgOSA5LjkyNyA5IDljMC0zLjMxNCAyLjY4Ni02IDYtNnptMCA0Yy0xLjEwNSAwLTIgLjg5NS0yIDJzLjg5NSAyIDIgMiAyLS44OTUgMi0yLS44OTUtMi0yLTJ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";

var Library_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibGlicmFyeS0yNC1hIiBkPSJNMTcsMTggTDIsMTggTDIsMTcgTDE3LDE3IEwxNywyIEwxOCwyIEwxOCwxOCBMMTcsMTggWiBNMSwwIEwxNSwwIEMxNS41NTIyODQ3LC0xLjAxNDUzMDYzZS0xNiAxNiwwLjQ0NzcxNTI1IDE2LDEgTDE2LDE1IEMxNiwxNS41NTIyODQ3IDE1LjU1MjI4NDcsMTYgMTUsMTYgTDEsMTYgQzAuNDQ3NzE1MjUsMTYgNi43NjM1Mzc1MWUtMTcsMTUuNTUyMjg0NyAwLDE1IEwwLDEgQy02Ljc2MzUzNzUxZS0xNywwLjQ0NzcxNTI1IDAuNDQ3NzE1MjUsMS4wMTQ1MzA2M2UtMTYgMSwwIFogTTMsMTAgTDMsMTEgTDksMTEgTDksMTAgTDMsMTAgWiBNMyw3IEwzLDggTDEzLDggTDEzLDcgTDMsNyBaIE0zLDQgTDMsNSBMMTMsNSBMMTMsNCBMMyw0IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgIDxtYXNrIGlkPSJsaWJyYXJ5LTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2xpYnJhcnktMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2xpYnJhcnktMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI2xpYnJhcnktMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM5IC00MCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var Lock_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibG9jay0xNi1hIiBkPSJNMTAsNiBMMTEsNiBDMTEuNTUyMjg0Nyw2IDEyLDYuNDQ3NzE1MjUgMTIsNyBMMTIsMTMgQzEyLDEzLjU1MjI4NDcgMTEuNTUyMjg0NywxNCAxMSwxNCBMMSwxNCBDMC40NDc3MTUyNSwxNCA2Ljc2MzUzNzUxZS0xNywxMy41NTIyODQ3IDAsMTMgTDAsNyBDLTYuNzYzNTM3NTFlLTE3LDYuNDQ3NzE1MjUgMC40NDc3MTUyNSw2IDEsNiBMMiw2IEwyLDMuNTcxNDI4NTcgQzIsMS42IDMuNzkyLDAgNiwwIEM4LjIwOCwwIDEwLDEuNiAxMCwzLjU3MTQyODU3IEwxMCw2IFogTTguMzI1LDYgTDMuNjc0OTk5NzEsNiBMMy42NzQ5OTk3MSwzLjk1NDE1NTgyIEMzLjY3NDk5OTcxLDIuNjUyMDU3NDMgNC43MTc1LDEuNTkzNjI2NTcgNiwxLjU5MzYyNjU3IEM3LjI4MjUsMS41OTM2MjY1NyA4LjMyNSwyLjY1MjA1NzQzIDguMzI1LDMuOTU0MTU1ODIgTDguMzI1LDYgWiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDEpIj4KICAgICAgPG1hc2sgaWQ9ImxvY2stMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjbG9jay0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjbG9jay0xNi1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjbG9jay0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQgLTQ0KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Lock_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibG9jay0yNC1hIiBkPSJNMTMsNyBMMTUsNyBDMTUuNTUyMjg0Nyw3IDE2LDcuNDQ3NzE1MjUgMTYsOCBMMTYsMTcgQzE2LDE3LjU1MjI4NDcgMTUuNTUyMjg0NywxOCAxNSwxOCBMMSwxOCBDMC40NDc3MTUyNSwxOCA2Ljc2MzUzNzUxZS0xNywxNy41NTIyODQ3IDAsMTcgTDAsOCBDLTYuNzYzNTM3NTFlLTE3LDcuNDQ3NzE1MjUgMC40NDc3MTUyNSw3IDEsNyBMMyw3IEwzLDUgQzMsMi4yNCA1LjI0LDAgOCwwIEMxMC43NiwwIDEzLDIuMjQgMTMsNSBMMTMsNyBaIE0xMS4xLDcgTDQuODk5OTk5NjIsNyBMNC44OTk5OTk2Miw1IEM0Ljg5OTk5OTYyLDMuMjkgNi4yOSwxLjkgOCwxLjkgQzkuNzEsMS45IDExLjEsMy4yOSAxMS4xLDUgTDExLjEsNyBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQgMykiPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNsb2NrLTI0LWEiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var MagnifyingGlass_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibWFnbmlmeWluZ19nbGFzcy0yNC1hIiBkPSJNMTIuODQ4MjQyOSwxMC44NDgyNDI5IEwxOCwxNiBMMTYsMTggTDEwLjg0ODI0MjksMTIuODQ4MjQyOSBDOS43NDQwNjk1MywxMy41NzYyNzY4IDguNDIxNTE3NywxNCA3LDE0IEMzLjEzNDAwNjc1LDE0IDAsMTAuODY1OTkzMiAwLDcgQzAsMy4xMzQwMDY3NSAzLjEzNDAwNjc1LDAgNywwIEMxMC44NjU5OTMyLDAgMTQsMy4xMzQwMDY3NSAxNCw3IEMxNCw4LjQyMTUxNzcgMTMuNTc2Mjc2OCw5Ljc0NDA2OTUzIDEyLjg0ODI0MjksMTAuODQ4MjQyOSBaIE03LDEyIEM5Ljc2MTQyMzc1LDEyIDEyLDkuNzYxNDIzNzUgMTIsNyBDMTIsNC4yMzg1NzYyNSA5Ljc2MTQyMzc1LDIgNywyIEM0LjIzODU3NjI1LDIgMiw0LjIzODU3NjI1IDIsNyBDMiw5Ljc2MTQyMzc1IDQuMjM4NTc2MjUsMTIgNywxMiBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiPgogICAgICA8bWFzayBpZD0ibWFnbmlmeWluZ19nbGFzcy0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNtYWduaWZ5aW5nX2dsYXNzLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNtYWduaWZ5aW5nX2dsYXNzLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNtYWduaWZ5aW5nX2dsYXNzLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MCAtNDApIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Mail_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibWFpbC0yNC1hIiBkPSJNMjAsNC41IEwyMCwxMyBDMjAsMTMuNTUyMjg0NyAxOS41NTIyODQ3LDE0IDE5LDE0IEwxLDE0IEMwLjQ0NzcxNTI1LDE0IDYuNzYzNTM3NTFlLTE3LDEzLjU1MjI4NDcgMCwxMyBMMCw0LjUgTDEwLDkuNSBMMjAsNC41IFogTTIwLDIuOTk3MzYwMjMgTDEwLDggTDAsMi45OTczNjAyMyBMMCwxIEMtNi43NjM1Mzc1MWUtMTcsMC40NDc3MTUyNSAwLjQ0NzcxNTI1LDEuMDE0NTMwNjNlLTE2IDEsMCBMMTksMCBDMTkuNTUyMjg0NywtMS4wMTQ1MzA2M2UtMTYgMjAsMC40NDc3MTUyNSAyMCwxIEwyMCwyLjk5NzM2MDIzIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiA1KSI+CiAgICAgIDxtYXNrIGlkPSJtYWlsLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI21haWwtMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI21haWwtMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI21haWwtMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM4IC00MCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var Menu_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ibWVudS0yNC1hIiBkPSJNMCw1IEwxOCw1IEwxOCw3IEwwLDcgTDAsNSBaIE0wLDAgTDE4LDAgTDE4LDIgTDAsMiBMMCwwIFogTTAsMTAgTDE4LDEwIEwxOCwxMiBMMCwxMiBMMCwxMCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgNikiPgogICAgICA8bWFzayBpZD0ibWVudS0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNtZW51LTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNtZW51LTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNtZW51LTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMTA4IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDUgLTQyKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Minus_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0ibWludXMtMTYtYSIgd2lkdGg9IjEyIiBoZWlnaHQ9IjIiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiA3KSI+CiAgICAgIDxtYXNrIGlkPSJtaW51cy0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNtaW51cy0xNi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjbWludXMtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI21pbnVzLTE2LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MiAtNDcpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Minus_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0ibWludXMtMjQtYSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjIiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCAxMSkiPgogICAgICA8bWFzayBpZD0ibWludXMtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjbWludXMtMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI21pbnVzLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNtaW51cy0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAgLTQ3KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Papers_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGFwZXJzLTI0LWEiIGQ9Ik0xMiw3IEw4LDcgTDgsMyBMMiwzIEMxLjQ0NzcxNTI1LDMgMSwzLjQ0NzcxNTI1IDEsNCBMMSwxNiBDMSwxNi41NTIyODQ3IDEuNDQ3NzE1MjUsMTcgMiwxNyBMMTEsMTcgQzExLjU1MjI4NDcsMTcgMTIsMTYuNTUyMjg0NyAxMiwxNiBMMTIsNyBaIE0yLDIgQzIsMC44OTU0MzA1IDIuODk1NDMwNSwyLjAyOTA2MTI1ZS0xNiA0LDAgTDExLDAgTDE1LDQgTDE1LDE0IEMxNSwxNS4xMDQ1Njk1IDE0LjEwNDU2OTUsMTYgMTMsMTYgQzEzLDE3LjEwNDU2OTUgMTIuMTA0NTY5NSwxOCAxMSwxOCBMMiwxOCBDMC44OTU0MzA1LDE4IDEuMzUyNzA3NWUtMTYsMTcuMTA0NTY5NSAwLDE2IEwwLDQgQy0xLjM1MjcwNzVlLTE2LDIuODk1NDMwNSAwLjg5NTQzMDUsMiAyLDIgWiBNMywyIEw5LDIgTDEzLDYgTDEzLDE1IEMxMy41NTIyODQ3LDE1IDE0LDE0LjU1MjI4NDcgMTQsMTQgTDE0LDQuNSBMMTAuNSwxIEw0LDEgQzMuNDQ3NzE1MjUsMSAzLDEuNDQ3NzE1MjUgMywyIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNSAzKSI+CiAgICAgIDxtYXNrIGlkPSJwYXBlcnMtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGFwZXJzLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiNBMkEzQTciIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI3BhcGVycy0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjcGFwZXJzLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NiAtMzkpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Pencil_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGVuY2lsLTI0LWEiIGQ9Ik0wLDE4IEwzLjM3Nzc3Nzc4LDE4IEwxNS4xNTU1NTU2LDYuMTMzMzMzMzMgTDExLjc3Nzc3NzgsMi43NTU1NTU1NiBMMCwxNC42MjIyMjIyIEwwLDE4IFogTTE3LjczMzMzMzMsMi4zMTExMTExMSBMMTUuNjg4ODg4OSwwLjI2NjY2NjY2NyBDMTUuMzMzMzMzMywtMC4wODg4ODg4ODg5IDE0LjgsLTAuMDg4ODg4ODg4OSAxNC40NDQ0NDQ0LDAuMjY2NjY2NjY3IEwxMi44NDQ0NDQ0LDEuODY2NjY2NjcgTDE2LjIyMjIyMjIsNS4yNDQ0NDQ0NCBMMTcuNzMzMzMzMywzLjU1NTU1NTU2IEMxOC4wODg4ODg5LDMuMiAxOC4wODg4ODg5LDIuNjY2NjY2NjcgMTcuNzMzMzMzMywyLjMxMTExMTExIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgIDxtYXNrIGlkPSJwZW5jaWwtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGVuY2lsLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiNBMkEzQTciIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI3BlbmNpbC0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjcGVuY2lsLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOCAtNDApIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Person_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGVyc29uLTI0LWEiIGQ9Ik01LjM5MjQxMzM5LDExIEM2LjQ0NTk1NjE5LDExLjYzNDgxOTggNy42ODAzMzE4OSwxMiA5LDEyIEMxMC4zMTk2NjgxLDEyIDExLjU1NDA0MzgsMTEuNjM0ODE5OCAxMi42MDc1ODY2LDExIEwxMywxMSBDMTUuNzYxNDIzNywxMSAxOCwxMy4yMzg1NzYzIDE4LDE2IEwxOCwxOCBMMCwxOCBMMCwxNiBDLTMuMzgxNzY4NzZlLTE2LDEzLjIzODU3NjMgMi4yMzg1NzYyNSwxMSA1LDExIEw1LjM5MjQxMzM5LDExIFogTTksMTAgQzYuMjM4NTc2MjUsMTAgNCw3Ljc2MTQyMzc1IDQsNSBDNCwyLjIzODU3NjI1IDYuMjM4NTc2MjUsMCA5LDAgQzExLjc2MTQyMzcsMCAxNCwyLjIzODU3NjI1IDE0LDUgQzE0LDcuNzYxNDIzNzUgMTEuNzYxNDIzNywxMCA5LDEwIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgIDxtYXNrIGlkPSJwZXJzb24tMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGVyc29uLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNwZXJzb24tMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI3BlcnNvbi0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkgLTM4KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Person_Plus_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDBIMjRWMjRIMHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTYwIC0xNDIpIHRyYW5zbGF0ZSgzNTYgMTI2KSB0cmFuc2xhdGUoMjQgMTYpIHRyYW5zbGF0ZSg3ODApIi8+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGZpbGw9IiM4QjhDOEMiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTE5IDEydjNoM3YyaC0zdjNoLTJ2LTMuMDAxTDE0IDE3di0ybDMtLjAwMVYxMmgyek05IDEyYzEuMzE5IDAgMi41NTMtLjM2NSAzLjYwNi0uOTk5TDEzIDExYzEuMTI2IDAgMi4xNjUuMzcyIDMuMDAxIDFMMTYgMTQgMTMgMTR2NEgwdi0yYzAtMi43NjEgMi4yMzktNSA1LTVsLjM5NC4wMDFDNi40NDcgMTEuNjM1IDcuNjgxIDEyIDkgMTJ6TTkgMGMyLjc2MSAwIDUgMi4yMzkgNSA1cy0yLjIzOSA1LTUgNS01LTIuMjM5LTUtNSAyLjIzOS01IDUtNXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTYwIC0xNDIpIHRyYW5zbGF0ZSgzNTYgMTI2KSB0cmFuc2xhdGUoMjQgMTYpIHRyYW5zbGF0ZSg3ODApIHRyYW5zbGF0ZSgxIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";

var Plus_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGx1cy0xNi1hIiBkPSJNNyw1IEwxMiw1IEwxMiw3IEw3LDcgTDcsMTIgTDUsMTIgTDUsNyBMMCw3IEwwLDUgTDUsNSBMNSwwIEw3LDAgTDcsNSBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgICA8bWFzayBpZD0icGx1cy0xNi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwbHVzLTE2LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNwbHVzLTE2LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNwbHVzLTE2LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MiAtNDIpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Plus_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icGx1cy0yNC1hIiBkPSJNOSw3IEwxNiw3IEwxNiw5IEw5LDkgTDksMTYgTDcsMTYgTDcsOSBMMCw5IEwwLDcgTDcsNyBMNywwIEw5LDAgTDksNyBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQgNCkiPgogICAgICA8bWFzayBpZD0icGx1cy0yNC1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwbHVzLTI0LWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiNwbHVzLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCNwbHVzLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MCAtNDApIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var QuestionMarkCircleOutline_16 = "data:image/svg+xml;base64,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";

var QuestionMarkCircle_16 = "data:image/svg+xml;base64,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";

var Refresh_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0icmVmcmVzaC0yNC1hIiBkPSJNOCwwLjAwMDgyMjE1OTU4MiBDMy41ODE3MjIsMC4wMDA4MjIxNTk1ODIgNS4wNzUzMDUyNmUtMTYsMy41ODI1NDQxNiAwLDguMDAwODIyMTYgQy01LjA3NTMwNTI2ZS0xNiwxMi40MTkxMDAyIDMuNTgxNzIyLDE2LjAwMDgyMjIgOCwxNi4wMDA4MjIyIEMxMC4xMzMzNTAyLDE2LjAzMTM4OTMgMTIuMTkwNTI2NywxNS4yMDg1MTg3IDEzLjcxNDI4NTcsMTMuNzE1MTA3OSBMMTIuMTQyODU3MSwxMi4wMDA4MjIyIEMxMS4wNTMxMDY2LDEzLjExMjc3MTcgOS41NTY4MjU0MSwxMy43MzE5MjI2IDgsMTMuNzE1MTA3OSBDNC44NDQwODcxNCwxMy43MTUxMDc5IDIuMjg1NzE0MjksMTEuMTU2NzM1IDIuMjg1NzE0MjksOC4wMDA4MjIxNiBDMi4yODU3MTQyOSw0Ljg0NDkwOTMgNC44NDQwODcxNCwyLjI4NjUzNjQ1IDgsMi4yODY1MzY0NSBDOS41NTY4MjU0MSwyLjI2OTcyMTc2IDExLjA1MzEwNjYsMi44ODg4NzI1OSAxMi4xNDI4NTcxLDQuMDAwODIyMTYgTDkuNzE0Mjg1NzEsNi4yODY1MzY0NSBMMTYsNi4yODY1MzY0NSBMMTYsMC4wMDA4MjIxNTk1ODIgTDEzLjcxNDI4NTcsMi4yODY1MzY0NSBDMTIuMTkwNTI2NywwLjc5MzEyNTYyOSAxMC4xMzMzNTAyLC0wLjAyOTc0NDk4OTkgOCwwLjAwMDgyMjE1OTU4MiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj4KICAgICAgPG1hc2sgaWQ9InJlZnJlc2gtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcmVmcmVzaC0yNC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjcmVmcmVzaC0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiM4QjhDOEMiIG1hc2s9InVybCgjcmVmcmVzaC0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAgLTQwKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Revert_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMEgxNlYxNkgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik04IDFjMy44NjYgMCA3IDMuMTM0IDcgN3MtMy4xMzQgNy03IDdjLTEuOTMyIDAtMy42ODItLjc4My00Ljk0OS0yLjA1bDEuNDE0LTEuNDEzQzUuMzcgMTIuNDQgNi42MiAxMyA4IDEzYzIuNzYxIDAgNS0yLjIzOSA1LTVzLTIuMjM5LTUtNS01Yy0xLjM4IDAtMi42My41Ni0zLjUzNiAxLjQ2NEw3IDdIMVYxbDIuMDUgMi4wNUM0LjMxNyAxLjc4NCA2LjA2NyAxIDggMXoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";

var Revert_24 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlJldmVydC0yNCI+CjxwYXRoIGlkPSJPdmFsIDIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMyAzVjEwLjcxNDNMMTAuNzE0MyAxMC43MTQzTDcuNzU3MzYgNy43NTczNkM4Ljg0MzE1IDYuNjcxNTcgMTAuMzQzMSA2IDEyIDZDMTUuMzEzNyA2IDE4IDguNjg2MjkgMTggMTJDMTggMTUuMzEzNyAxNS4zMTM3IDE4IDEyIDE4QzkuOTI4MTkgMTggOC4xMDE2MyAxNi45NDk5IDcuMDIzNTQgMTUuMzUyOUw0LjgxNjE3IDE3LjQyMjNDNi40NTkxNSAxOS41OTU2IDkuMDY1NTcgMjEgMTIgMjFDMTYuOTcwNiAyMSAyMSAxNi45NzA2IDIxIDEyQzIxIDcuMDI5NDQgMTYuOTcwNiAzIDEyIDNDOS41MTQ3MiAzIDcuMjY0NzIgNC4wMDczNiA1LjYzNjA0IDUuNjM2MDRMMyAzWiIgZmlsbD0iIzhCOEM4QyIvPgo8L2c+Cjwvc3ZnPgo=";

var Reset_Password_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMEwyNCAwIDI0IDI0IDAgMjR6Ii8+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnIGZpbGw9IiM3Njc4N0YiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMykiPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTcgMGMuNTUyIDAgMSAuNDQ4IDEgMXYxaC0xVjFIMXY2aDh2MUgxYy0uNTUyIDAtMS0uNDQ4LTEtMVYxYzAtLjU1Mi40NDgtMSAxLTFoMTZ6Ii8+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iMSIvPgogICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iNyIgY3k9IjQiIHI9IjEiLz4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iNCIgcj0iMSIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMykgdHJhbnNsYXRlKDEwIDQpIj4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI3IiBmaWxsPSIjRUQ1OTk3Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNNyAzLjVjMS45MzMgMCAzLjUgMS41NjcgMy41IDMuNVM4LjkzMyAxMC41IDcgMTAuNWMtLjgyNyAwLTEuNTg3LS4yODctMi4xODYtLjc2N2wuNjI1LS43OGMuNDI4LjM0Mi45Ny41NDcgMS41NjEuNTQ3IDEuMzggMCAyLjUtMS4xMiAyLjUtMi41UzguMzggNC41IDcgNC41Yy0uNjkgMC0xLjMxNS4yOC0xLjc2Ny43MzJsLS43MDgtLjcwN0M1LjE2IDMuODkyIDYuMDM0IDMuNSA3IDMuNXpNMyAzbDQgNEgzVjN6Ii8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";

var Star_Outline_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAgMEgxNlYxNkgweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkxIC00MTgpIHRyYW5zbGF0ZSgzMiAxNDcpIHRyYW5zbGF0ZSgwIDI1NCkgdHJhbnNsYXRlKDU4IDEzKSB0cmFuc2xhdGUoMCAzKSB0cmFuc2xhdGUoMSAxKSIvPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiM4QjhDOEMiIGQ9Ik03LjQ5IDEuMzk3Yy0uMTguMTA3LS4zMjMuMjY4LS40MDcuNDYybC0xLjM5IDMuMjA0LTMuNTMxLjI5M2MtLjU1LjA0NS0uOTYuNTI4LS45MTQgMS4wNzlsLjAyLjEzYy4wNDYuMjE0LjE2MS40MDguMzMuNTVsMi42NjYgMi4yNTctLjgwMyAzLjM2N2MtLjEyOC41MzcuMjAzIDEuMDc3Ljc0IDEuMjA1bC4xMjcuMDIyYy4yMTMuMDIyLjQyOC0uMDI0LjYxNC0uMTMzTDggMTIuMDI4bDMuMDU4IDEuODA1Yy40NzYuMjggMS4wOS4xMjIgMS4zNy0uMzUzbC4wNTgtLjExNWMuMDg0LS4xOTcuMTAzLS40MTYuMDUzLS42MjZsLS44MDQtMy4zNjcgMi42NjctMi4yNTdjLjQyMS0uMzU3LjQ3NC0uOTg4LjExNy0xLjQwOWwtLjA5Mi0uMDk1Yy0uMTYyLS4xNDctLjM2OC0uMjM3LS41ODktLjI1NWwtMy41MzItLjI5My0xLjM4OS0zLjIwNGMtLjIyLS41MDctLjgwOC0uNzQtMS4zMTUtLjUybC0uMTEyLjA1OHpNNi4zNzMgNi4wMUw4IDIuMjU3IDkuNjI3IDYuMDFsNC4xMjkuMzQyLTMuMTM2IDIuNjU1Ljk0NiAzLjk2NEw4IDEwLjg2N2wtMy41NjYgMi4xMDQuOTQ2LTMuOTY0LTMuMTM2LTIuNjU1IDQuMTI5LS4zNDJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTEgLTQxOCkgdHJhbnNsYXRlKDMyIDE0NykgdHJhbnNsYXRlKDAgMjU0KSB0cmFuc2xhdGUoNTggMTMpIHRyYW5zbGF0ZSgwIDMpIHRyYW5zbGF0ZSgxIDEpIi8+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";

var Star_Yellow_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAgMEgxNlYxNkgweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkxIC0yNzEpIHRyYW5zbGF0ZSgzMiAxNDcpIHRyYW5zbGF0ZSgwIDEwNykgdHJhbnNsYXRlKDU4IDEzKSB0cmFuc2xhdGUoMCAzKSB0cmFuc2xhdGUoMSAxKSIvPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGMjlCMDUiIGQ9Ik04IDExLjQ0OGwzLjMxMiAxLjk1NGMuMjM4LjE0LjU0NS4wNjEuNjg1LS4xNzcuMDY2LS4xMTEuMDg2LS4yNDQuMDU2LS4zN2wtLjg3NS0zLjY2NSAyLjktMi40NTZjLjIxMS0uMTc5LjIzOC0uNDk0LjA2LS43MDUtLjA4Ny0uMTAxLS4yMDktLjE2NC0uMzQxLS4xNzVsLTMuODMtLjMxOC0xLjUwOC0zLjQ3OGMtLjExLS4yNTMtLjQwNS0uMzctLjY1OC0uMjYtLjExNi4wNS0uMjEuMTQzLS4yNi4yNkw2LjAzMyA1LjUzNmwtMy44My4zMThjLS4yNzUuMDIzLS40OC4yNjQtLjQ1Ny41NC4wMTEuMTMyLjA3NC4yNTQuMTc1LjM0TDQuODIyIDkuMTlsLS44NzUgMy42NjVjLS4wNjQuMjY5LjEwMi41MzkuMzcuNjAzLjEyNi4wMy4yNi4wMS4zNy0uMDU2TDggMTEuNDQ4eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkxIC0yNzEpIHRyYW5zbGF0ZSgzMiAxNDcpIHRyYW5zbGF0ZSgwIDEwNykgdHJhbnNsYXRlKDU4IDEzKSB0cmFuc2xhdGUoMCAzKSB0cmFuc2xhdGUoMSAxKSIvPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";

var StatusCircle_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8Y2lyY2xlIGlkPSJzdGF0dXNfY2lyY2xlLTEyLWEiIGN4PSI0IiBjeT0iNCIgcj0iNCIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIi8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDIpIj4KICAgICAgPG1hc2sgaWQ9InN0YXR1c19jaXJjbGUtMTItYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjc3RhdHVzX2NpcmNsZS0xMi1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHVzZSBmaWxsPSIjOEI4QzhDIiB4bGluazpocmVmPSIjc3RhdHVzX2NpcmNsZS0xMi1hIi8+CiAgICAgIDxnIGZpbGw9IiM1REEzMEQiIG1hc2s9InVybCgjc3RhdHVzX2NpcmNsZS0xMi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQgLTQ0KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Success_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ic3VjY2Vzcy0xNi1hIiBkPSJNNDgsNTYgQzUyLjQxODI3OCw1NiA1Niw1Mi40MTgyNzggNTYsNDggQzU2LDQzLjU4MTcyMiA1Mi40MTgyNzgsNDAgNDgsNDAgQzQzLjU4MTcyMiw0MCA0MCw0My41ODE3MjIgNDAsNDggQzQwLDUyLjQxODI3OCA0My41ODE3MjIsNTYgNDgsNTYgWiBNNDYuMTI5MTg4NCw1MiBMNDMsNDguODg4ODg4OSBMNDQuMTcyMjUxMiw0Ny43MjIyMjIyIEw0Ni4xMjkxODg0LDQ5LjY2NjY2NjcgTDUwLjgyNTgzNzcsNDUgTDUyLDQ2LjE2NjY2NjcgTDQ2LjEyOTE4ODQsNTIgWiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDAgLTQwKSI+CiAgICAgIDxtYXNrIGlkPSJzdWNjZXNzLTE2LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3N1Y2Nlc3MtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzVEQTMwRCIgeGxpbms6aHJlZj0iI3N1Y2Nlc3MtMTYtYSIvPgogICAgICA8ZyBmaWxsPSIjNURBMzBEIiBtYXNrPSJ1cmwoI3N1Y2Nlc3MtMTYtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Success_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0ic3VjY2Vzcy0yNC1hIiBkPSJNMTAsMjAgQzE1LjUyMjg0NzUsMjAgMjAsMTUuNTIyODQ3NSAyMCwxMCBDMjAsNC40NzcxNTI1IDE1LjUyMjg0NzUsMCAxMCwwIEM0LjQ3NzE1MjUsMCAwLDQuNDc3MTUyNSAwLDEwIEMwLDE1LjUyMjg0NzUgNC40NzcxNTI1LDIwIDEwLDIwIFogTTcuOTk3NTU4NTksMTUgTDQsMTEgTDUuNDk3NTU4NTksOS41IEw3Ljk5NzU1ODU5LDEyIEwxMy45OTc1NTg2LDYgTDE1LjQ5NzU1ODYsNy41IEw3Ljk5NzU1ODU5LDE1IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+CiAgICAgIDxtYXNrIGlkPSJzdWNjZXNzLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3N1Y2Nlc3MtMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI3N1Y2Nlc3MtMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjNURBMzBEIiBtYXNrPSJ1cmwoI3N1Y2Nlc3MtMjQtYikiPgogICAgICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM4IC0zOCkiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";

var Timer_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0idGltZXItMjQtYSIgZD0iTTQuMDE3MzU5NzgsMTUuMzQzNzU3OSBMOSwxMiBMOSw2IEMxMi4zMTM3MDg1LDYgMTUsOC42ODYyOTE1IDE1LDEyIEMxNSwxNS4zMTM3MDg1IDEyLjMxMzcwODUsMTggOSwxOCBDNi45MjQyMjE0MSwxOCA1LjA5NDY0Mzc4LDE2Ljk0NTg4ODQgNC4wMTczNTk3OCwxNS4zNDM3NTc5IFogTTIuNDMyMjgyMTEsNS44NDY0OTU2NyBMMS4yOTI4OTMyMiw0LjcwNzEwNjc4IEwyLjcwNzEwNjc4LDMuMjkyODkzMjIgTDMuOTU4MDI4MzgsNC41NDM4MTQ4MSBDNS4zOTYzOTUwNCwzLjU2OTI3MDEzIDcuMTMxNzE3NDQsMyA5LDMgQzEzLjk3MDU2MjcsMyAxOCw3LjAyOTQzNzI1IDE4LDEyIEMxOCwxNi45NzA1NjI3IDEzLjk3MDU2MjcsMjEgOSwyMSBDNC4wMjk0MzcyNSwyMSAzLjU4ODI0MDgyZS0xMywxNi45NzA1NjI3IDMuNTg4MjQwODJlLTEzLDEyIEMzLjU4ODI0MDgyZS0xMyw5LjYyMDA3ODM1IDAuOTIzNzU4ODEzLDcuNDU1OTEyMTMgMi40MzIyODIxMSw1Ljg0NjQ5NTY3IFogTTksMTkgQzEyLjg2NTk5MzIsMTkgMTYsMTUuODY1OTkzMiAxNiwxMiBDMTYsOC4xMzQwMDY3NSAxMi44NjU5OTMyLDUgOSw1IEM1LjEzNDAwNjc1LDUgMiw4LjEzNDAwNjc1IDIsMTIgQzIsMTUuODY1OTkzMiA1LjEzNDAwNjc1LDE5IDksMTkgWiBNNiwwIEwxMiwwIEwxMiwyIEw2LDIgTDYsMCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMSkiPgogICAgICA8bWFzayBpZD0idGltZXItMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdGltZXItMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI3RpbWVyLTI0LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCN0aW1lci0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkgLTM4KSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var Trashcan_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0idHJhc2hjYW4tMjQtYSIgZD0iTTQsMSBDNCwwLjQ0NzcxNTI1IDQuNDQ3NzE1MjUsMS4wMTQ1MzA2M2UtMTYgNSwwIEw5LDAgQzkuNTUyMjg0NzUsLTEuMDE0NTMwNjNlLTE2IDEwLDAuNDQ3NzE1MjUgMTAsMSBMMTMsMSBDMTMuNTUyMjg0NywxIDE0LDEuNDQ3NzE1MjUgMTQsMiBMMTQsMyBMMCwzIEwwLDIgQy02Ljc2MzUzNzUxZS0xNywxLjQ0NzcxNTI1IDAuNDQ3NzE1MjUsMSAxLDEgTDQsMSBaIE0xLDQgTDEzLDQgTDEzLDE3IEMxMywxNy41NTIyODQ3IDEyLjU1MjI4NDcsMTggMTIsMTggTDIsMTggQzEuNDQ3NzE1MjUsMTggMSwxNy41NTIyODQ3IDEsMTcgTDEsNCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUgMykiPgogICAgICA8bWFzayBpZD0idHJhc2hjYW4tMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdHJhc2hjYW4tMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iI0EyQTNBNyIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjdHJhc2hjYW4tMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI3RyYXNoY2FuLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MSAtMzkpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var TriangleDown_12 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8cG9seWdvbiBpZD0idHJpYW5nbGUtZG93bi0xMi1hIiBwb2ludHM9IjggMCA0IDUgMCAwIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgNCkiPgogICAgICA8bWFzayBpZD0idHJpYW5nbGUtZG93bi0xMi1iIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiN0cmlhbmdsZS1kb3duLTEyLWEiLz4KICAgICAgPC9tYXNrPgogICAgICA8dXNlIGZpbGw9IiM4QjhDOEMiIHhsaW5rOmhyZWY9IiN0cmlhbmdsZS1kb3duLTEyLWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCN0cmlhbmdsZS1kb3duLTEyLWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iNzciIGhlaWdodD0iODAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNCAtMzgpIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var VerticalEllipsis_16 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0idmVydGljYWxfZWxsaXBzaXMtMTYtYSIgZD0iTTEsNiBDMC40NDc3MTUyNSw2IDAsNS41NTIyODQ3NSAwLDUgQzAsNC40NDc3MTUyNSAwLjQ0NzcxNTI1LDQgMSw0IEMxLjU1MjI4NDc1LDQgMiw0LjQ0NzcxNTI1IDIsNSBDMiw1LjU1MjI4NDc1IDEuNTUyMjg0NzUsNiAxLDYgWiBNMSwyIEMwLjQ0NzcxNTI1LDIgMCwxLjU1MjI4NDc1IDAsMSBDMCwwLjQ0NzcxNTI1IDAuNDQ3NzE1MjUsMCAxLDAgQzEuNTUyMjg0NzUsMCAyLDAuNDQ3NzE1MjUgMiwxIEMyLDEuNTUyMjg0NzUgMS41NTIyODQ3NSwyIDEsMiBaIE0xLDEwIEMwLjQ0NzcxNTI1LDEwIDAsOS41NTIyODQ3NSAwLDkgQzAsOC40NDc3MTUyNSAwLjQ0NzcxNTI1LDggMSw4IEMxLjU1MjI4NDc1LDggMiw4LjQ0NzcxNTI1IDIsOSBDMiw5LjU1MjI4NDc1IDEuNTUyMjg0NzUsMTAgMSwxMCBaIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcgMykiPgogICAgICA8bWFzayBpZD0idmVydGljYWxfZWxsaXBzaXMtMTYtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdmVydGljYWxfZWxsaXBzaXMtMTYtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI3ZlcnRpY2FsX2VsbGlwc2lzLTE2LWEiLz4KICAgICAgPGcgZmlsbD0iIzhCOEM4QyIgbWFzaz0idXJsKCN2ZXJ0aWNhbF9lbGxpcHNpcy0xNi1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDcgLTQzKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

var VerticalEllipsis_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0idmVydGljYWxfZWxsaXBzaXMtMjQtYSIgZD0iTTIsOS41IEMxLjE3MTU3Mjg4LDkuNSAwLjUsOC44Mjg0MjcxMiAwLjUsOCBDMC41LDcuMTcxNTcyODggMS4xNzE1NzI4OCw2LjUgMiw2LjUgQzIuODI4NDI3MTIsNi41IDMuNSw3LjE3MTU3Mjg4IDMuNSw4IEMzLjUsOC44Mjg0MjcxMiAyLjgyODQyNzEyLDkuNSAyLDkuNSBaIE0yLDE2IEMxLjE3MTU3Mjg4LDE2IDAuNSwxNS4zMjg0MjcxIDAuNSwxNC41IEMwLjUsMTMuNjcxNTcyOSAxLjE3MTU3Mjg4LDEzIDIsMTMgQzIuODI4NDI3MTIsMTMgMy41LDEzLjY3MTU3MjkgMy41LDE0LjUgQzMuNSwxNS4zMjg0MjcxIDIuODI4NDI3MTIsMTYgMiwxNiBaIE0yLDMgQzEuMTcxNTcyODgsMyAwLjUsMi4zMjg0MjcxMiAwLjUsMS41IEMwLjUsMC42NzE1NzI4NzUgMS4xNzE1NzI4OCwwIDIsMCBDMi44Mjg0MjcxMiwwIDMuNSwwLjY3MTU3Mjg3NSAzLjUsMS41IEMzLjUsMi4zMjg0MjcxMiAyLjgyODQyNzEyLDMgMiwzIFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAgNCkiPgogICAgICA8bWFzayBpZD0idmVydGljYWxfZWxsaXBzaXMtMjQtYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjdmVydGljYWxfZWxsaXBzaXMtMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iI0EyQTNBNyIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjdmVydGljYWxfZWxsaXBzaXMtMjQtYSIvPgogICAgICA8ZyBmaWxsPSIjOEI4QzhDIiBtYXNrPSJ1cmwoI3ZlcnRpY2FsX2VsbGlwc2lzLTI0LWIpIj4KICAgICAgICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NiAtNDApIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";

var Warning_24 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0id2FybmluZy0yNC1hIiBkPSJNMTguNzI3NTQyNywxNy45OTcyNzcgTDEuMjY3Mzg2MjYsMTcuOTk3Mjc3IEMwLjgxNTcwNTU5MywxNy45OTcyNzcgMC4zOTUxNzUzMTIsMTcuNzUzNjA1NiAwLjE2OTUxNjA4MiwxNy4zNjA4MjIgQy0wLjA1NjUwNTM2MDgsMTYuOTY4NzY1NyAtMC4wNTY1MDUzNjA4LDE2LjQ4MDY5NTYgMC4xNjk1MTYwODIsMTYuMDg3OTExOSBMOC44OTkyMzIxMSwwLjkwNjQ1OTI5NyBDOS4xMjUyNTM1NSwwLjUxMzY3NTYyNSA5LjU0NTc4MzgzLDAuMjcwMDA0MjcyIDkuOTk3NDY0NSwwLjI3MDAwNDI3MiBDMTAuNDQ4NzgzLDAuMjcwMDA0MjcyIDEwLjg2OTMxMzIsMC41MTM2NzU2MjUgMTEuMDk1MzM0NywwLjkwNjQ1OTI5NyBMMTkuNzYyNzQ5OSwxNS45Nzk4OTY0IEMxOS45MjUzODM5LDE2LjIyMTM4NTYgMjAsMTYuNDY4NjkzOSAyMCwxNi43MjQzNjcgQzE5Ljk5ODkxMzQsMTcuNDI4MTA0NCAxOS40MzQ5NDY0LDE3Ljk5MTQ1OCAxOC43Mjc1NDI3LDE3Ljk5NzI3NyBaIE05LDEzIEw5LDE1IEwxMSwxNSBMMTEsMTMgTDksMTMgWiBNOSw2IEw5LDEyIEwxMSwxMiBMMTEsNiBMOSw2IFoiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAzKSI+CiAgICAgIDxtYXNrIGlkPSJ3YXJuaW5nLTI0LWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3dhcm5pbmctMjQtYSIvPgogICAgICA8L21hc2s+CiAgICAgIDx1c2UgZmlsbD0iI0YyOUIwNSIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjd2FybmluZy0yNC1hIi8+CiAgICAgIDxnIGZpbGw9IiNGMjlCMDUiIG1hc2s9InVybCgjd2FybmluZy0yNC1iKSI+CiAgICAgICAgPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzkgLTQwKSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

// A
var svgList = {
  // A
  Avatar_24: Avatar_24,
  Alert: Alert,
  "App-24": App_24,
  // C
  "Checkmark-16": Checkmark_16,
  "Checkmark-16-thick": Checkmark_16_thick,
  "Checkmark-24": Checkmark_24,
  "Checkmark-checkbox": CheckmarkCheckbox,
  "Chevron_down-12": ChevronDown_12,
  "Chevron_down-12-white": ChevronDown_12_white,
  "Chevron_down-12-black": ChevronDown_12_black,
  "Chevron_down-16": ChevronDown_16,
  "Chevron_left-12": ChevronLeft_12,
  "Chevron_left-12-white": ChevronLeft_12_white,
  "Chevron_left-12-black": ChevronLeft_12_black,
  "Chevron_left-16": ChevronLeft_16,
  "Chevron_left-16-white": ChevronLeft_16_white,
  "Chevron_right-12": ChevronRight_12,
  "Chevron_right-12-white": ChevronRight_12_white,
  "Chevron_right-12-black": ChevronRight_12_black,
  "Chevron_right-16": ChevronRight_16,
  "Chevron_up-12": ChevronUp_12,
  "Chevron_up-16": ChevronUp_16,
  "Circle_disabled-16": CircleDisabled_16,
  "Clock-24": Clock_24,
  "Close-12": Close_12,
  "Close-16": Close_16,
  "Close-16-thick": Close_16_thick,
  "Close-24": Close_24,
  // D
  "Download-16": Download_16,
  // E
  "Ellipsis-16": Ellipsis_16,
  "Ellipsis-24": Ellipsis_24,
  "Error-24": Error_24,
  ErrorWhite_24: ErrorWhite_24,
  "Eye-24": Eye_24,
  // F
  "Forbid-16": Forbid_16,
  // G
  "Gear-24": Gear_24,
  "Grip-16": Grip_16,
  // I
  "In_progress-24": InProgress_24,
  "Info_outline-16": InfoOutline_16,
  "Info_outline-24": InfoOutline_24,
  "Info-16": Info_16,
  "Info-24": Info_24,
  // K
  "Key-24": Key_24,
  // L
  "Library-24": Library_24,
  "Lock-16": Lock_16,
  "Lock-24": Lock_24,
  // M
  "Magnifying_glass-24": MagnifyingGlass_24,
  "Mail-24": Mail_24,
  "Menu-24": Menu_24,
  "Minus-16": Minus_16,
  "Minus-24": Minus_24,
  // P
  "Papers-24": Papers_24,
  "Pencil-24": Pencil_24,
  "Person-24": Person_24,
  "Person-Plus-24": Person_Plus_24,
  "Plus-16": Plus_16,
  "Plus-24": Plus_24,
  // Q
  "Question_mark_circle_outline-16": QuestionMarkCircleOutline_16,
  "Question_mark_circle-16": QuestionMarkCircle_16,
  // R
  "Refresh-24": Refresh_24,
  "Revert-16": Revert_16,
  "Revert-24": Revert_24,
  "Reset-Password-24": Reset_Password_24,
  // S
  "Star-Outline-16": Star_Outline_16,
  "Star-Yellow-16": Star_Yellow_16,
  "Status_circle-12": StatusCircle_12,
  "Success-16": Success_16,
  "Success-24": Success_24,
  // T
  "Timer-24": Timer_24,
  "Trashcan-24": Trashcan_24,
  "Triangle-down-12": TriangleDown_12,
  // V
  "Vertical_ellipsis-16": VerticalEllipsis_16,
  "Vertical_ellipsis-24": VerticalEllipsis_24,
  // W
  "Warning-24": Warning_24
};

function _templateObject$1f() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width: ", ";\n  padding: ", ";\n  cursor: ", ";\n"]);

  _templateObject$1f = function _templateObject() {
    return data;
  };

  return data;
}
var Image = styled.img(_templateObject$1f(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.onClick ? "pointer" : "auto";
});

var Icon$2 = function Icon(_ref) {
  var icon = _ref.icon,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose$1(_ref, ["icon", "name"]);

  return /*#__PURE__*/React$1.createElement(Image, _extends$2({
    src: svgList[name || icon]
  }, rest));
};

Icon$2.displayName = "ImageWrapper";
Icon$2.defaultProps = {
  size: "24px",
  padding: "0"
};
Icon$2.propTypes = {
  name: PropTypes$1.string,
  icon: PropTypes$1.string,
  size: PropTypes$1.string,
  padding: PropTypes$1.string,
  onClick: PropTypes$1.func
};

function _templateObject3$r() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: Roboto;\n  font-size: 13px;\n  line-height: 24px;\n  color: ", ";\n  margin-left: 8px;\n  display: inline-block;\n"]);

  _templateObject3$r = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$I() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2$I = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1e() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 2px;\n  padding: 16px;\n  margin: 0;\n  background-color: ", ";\n"]);

  _templateObject$1e = function _templateObject() {
    return data;
  };

  return data;
}
var UnorderedList = styled.ul(_templateObject$1e(), COLORS.GRAY_COLORS.GRAY_96);
var ListItem$1 = styled.li(_templateObject2$I());
var Label = styled.label(_templateObject3$r(), function (props) {
  return props.active ? COLORS.TEXT_COLORS.EMPHASIZED : COLORS.TEXT_COLORS.LABEL;
});
var ToDoItem = function ToDoItem(_ref) {
  var done = _ref.done,
      label = _ref.label;
  return /*#__PURE__*/React$1.createElement(ListItem$1, null, done ? /*#__PURE__*/React$1.createElement(Icon$2, {
    icon: "Success-16",
    size: "16"
  }) : /*#__PURE__*/React$1.createElement(Icon$2, {
    icon: "Circle_disabled-16",
    size: "16"
  }), done ? /*#__PURE__*/React$1.createElement(Label, {
    active: true
  }, label) : /*#__PURE__*/React$1.createElement(Label, null, label));
};
var ToDoList = (function (_ref2) {
  var list = _ref2.list;
  var itemList = list.map(function (item, i) {
    return /*#__PURE__*/React$1.createElement(ToDoItem, {
      label: item.text,
      done: item.complete,
      key: i
    });
  });
  return /*#__PURE__*/React$1.createElement(UnorderedList, null, itemList);
});

function _templateObject2$H() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 12px;\n\n  &:first-child {\n    margin-left: 0px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    margin-left: 0px;\n    margin-top: 24px;\n    display: flex;\n    flex-direction: column;\n\n    &:first-child {\n      margin-top: 0px;\n    }\n  }\n"]);

  _templateObject2$H = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1d() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: ", ";\n\n  border-top: solid 1px ", ";\n  padding: 16px 24px;\n\n  @media screen and (max-width: ", "px) {\n    flex-direction: column;\n    padding: 32px 20px;\n  }\n"]);

  _templateObject$1d = function _templateObject() {
    return data;
  };

  return data;
}
var Footer = styled.div(_templateObject$1d(), function (props) {
  return props.horizontalCenter ? "center" : "flex-end";
}, COLORS.SEPARATOR_COLORS.MEDIUM, function (props) {
  return props.breakpoint;
});
var StyledItem$2 = styled.div(_templateObject2$H(), function (props) {
  return props.breakpoint;
});

var DialogFooter = function DialogFooter(_ref) {
  var children = _ref.children,
      breakpoint = _ref.breakpoint,
      horizontalCenter = _ref.horizontalCenter;
  return /*#__PURE__*/React$1.createElement(Footer, {
    horizontalCenter: horizontalCenter,
    breakpoint: breakpoint
  }, Children.map(children, function (child) {
    return child && /*#__PURE__*/React$1.createElement(StyledItem$2, {
      breakpoint: breakpoint
    }, child);
  }));
};

DialogFooter.propTypes = {
  breakpoint: PropTypes$1.number,
  horizontalCenter: PropTypes$1.bool
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$1(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf$1(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found.\n\n",
  "75": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized$1(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */


function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$1({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDarken = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(darken);

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$1({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore


var curriedLighten = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(lighten);

var getLuminance = function getLuminance(color) {
  //rgba also translates named colors (like 'yellow') to rgba, so it can be used for lightening or darkening
  //but not non-senses (see specs); when user set such color, make it work even if ugly (try-catch)
  var sanitizedColor;

  try {
    sanitizedColor = rgba(color, 1);
  } catch (e) {
    sanitizedColor = COLORS.GRAY_COLORS.GRAY_18;
  }

  var rgb = parseToRgb(sanitizedColor);
  return (rgb.red * 212.6 + rgb.green * 715.2 + rgb.blue * 72.2) / 1000 / 255;
};

var isLight = function isLight(color) {
  return 0.5 <= getLuminance(color);
}; //count font color based on its luminance

var readableColor = function readableColor(color) {
  return isLight(color) ? "#000" : "#fff";
}; //make given color lighter or darker based on its luminance

var darkenOrLighten = function darkenOrLighten(color) {
  if (color === void 0) {
    color = COLORS.GRAY_COLORS.GRAY_18;
  }

  //rgba also translates named colors (like 'yellow') to rgba, so it can be used for lightening or darkening
  //but not non-senses (see specs); when user set such color, make it work even if ugly (try-catch)
  var sanitizedColor;

  try {
    sanitizedColor = rgba(color, 1);
  } catch (e) {
    sanitizedColor = COLORS.GRAY_COLORS.GRAY_18;
  }

  return isLight(sanitizedColor) ? curriedDarken(0.1, sanitizedColor) : curriedLighten(0.1, sanitizedColor);
};
var getActiveColor = function getActiveColor(color) {
  var hslParsed = parseToHsl(color);
  return hsl(hslParsed.hue, hslParsed.saturation, Math.max(0, hslParsed.lightness - 0.08));
};
var getHoverColor = function getHoverColor(color) {
  var hslParsed = parseToHsl(color);
  return hsl(hslParsed.hue, Math.max(0, hslParsed.saturation - 0.08), Math.min(1, hslParsed.lightness + 0.08));
};

function _templateObject4$e() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      line-height: 16px;\n      padding: 0 16px;\n      height: 38px;\n      min-width: 88px;\n    "]);

  _templateObject4$e = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$q() {
  var data = _taggedTemplateLiteralLoose(["\n      font-size: 16px;\n      line-height: 20px;\n      padding: 0 20px;\n      height: 48px;\n      min-width: 112px;\n    "]);

  _templateObject3$q = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$G() {
  var data = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      background-color: ", ";\n      border: ", ";\n\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n        border: ", ";\n      }\n\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border: ", ";\n      }\n\n      &:disabled,\n      &[disabled] {\n        opacity: 0.3;\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n          border: ", ";\n        }\n      }\n    "]);

  _templateObject2$G = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1c() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: 400;\n  font-family: ", ";\n  border-radius: 2px;\n  letter-spacing: 0.4px;\n  box-shadow: none;\n  text-shadow: none;\n  text-transform: capitalize;\n  border: none;\n  cursor: pointer;\n\n  ", ";\n"]);

  _templateObject$1c = function _templateObject() {
    return data;
  };

  return data;
}
var PRIMARY_LOOK = "primary";
var REGULAR_LOOK = "regular";
var LINK_LOOK = "link";
var OUTLINE_LOOK = "outline";
var StyledButton$1 = styled.button(_templateObject$1c(), function (props) {
  return getSizingDefinitions(props.size);
}, FONTS.FONT_FAMILY.DEFAULT, function (props) {
  var colors = resolveColorSchema(props.look, props.theme.accentColor);
  return css(_templateObject2$G(), colors.normal.color, colors.normal.backgroundColor, colors.normal.border, colors.hover.color, colors.hover.backgroundColor, colors.hover.border, colors.active.color, colors.active.backgroundColor, colors.active.border, colors.normal.color, colors.normal.backgroundColor, colors.normal.border);
});

var getSizingDefinitions = function getSizingDefinitions(size) {
  if (size === SIZES.LARGE) {
    return css(_templateObject3$q());
  } else {
    // medium (default)
    return css(_templateObject4$e());
  }
};

var resolveColorSchema = function resolveColorSchema(look, accentColor) {
  if (accentColor === void 0) {
    accentColor = COLORS.ACTION_COLORS.BLUE_MAIN;
  }

  switch (look) {
    case PRIMARY_LOOK:
      {
        var textColor = readableColor(accentColor);
        return {
          normal: {
            backgroundColor: accentColor,
            color: textColor
          },
          hover: {
            backgroundColor: getHoverColor(accentColor),
            color: textColor
          },
          active: {
            backgroundColor: getActiveColor(accentColor),
            color: textColor
          }
        };
      }

    case OUTLINE_LOOK:
      {
        return {
          normal: {
            backgroundColor: "transparent",
            color: COLORS.GRAY_COLORS.GRAY_25,
            border: "solid 1px " + COLORS.GRAY_COLORS.GRAY_35
          },
          hover: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_35,
            color: "#ffffff",
            border: "solid 1px " + COLORS.GRAY_COLORS.GRAY_35
          },
          active: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_18,
            color: "#ffffff",
            border: "solid 1px " + COLORS.GRAY_COLORS.GRAY_18
          }
        };
      }

    case REGULAR_LOOK:
      {
        return {
          normal: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_97,
            color: COLORS.GRAY_COLORS.GRAY_35,
            border: "solid 1px " + COLORS.GRAY_COLORS.GRAY_84
          },
          hover: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_99,
            color: COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_BLACK,
            border: "solid 1px " + COLORS.ACTION_COLORS.ONELOGIN_BLUE
          },
          active: {
            backgroundColor: COLORS.GRAY_COLORS.GRAY_96,
            color: COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_BLACK,
            border: "solid 1px " + COLORS.ACTION_COLORS.BLUE_MID
          }
        };
      }

    default:
      {
        // link
        return {
          normal: {
            backgroundColor: "transparent",
            color: COLORS.ACTION_COLORS.BLUE_MAIN
          },
          hover: {
            backgroundColor: "rgba(0,0,0,0.05)",
            color: COLORS.ACTION_COLORS.BLUE_MAIN_HOVER
          },
          active: {
            backgroundColor: "rgba(0,0,0,0.1)",
            color: COLORS.ACTION_COLORS.BLUE_MAIN_ACTIVE
          }
        };
      }
  }
};

var Button$1 = forwardRef(function (props, ref) {
  return /*#__PURE__*/React$1.createElement(StyledButton$1, _extends$2({
    ref: ref
  }, props));
});
Button$1.defaultProps = {
  tabIndex: "0",
  disabled: false,
  type: "button",
  size: SIZES.MEDIUM,
  look: LINK_LOOK
};
Button$1.propTypes = {
  onClick: PropTypes$1.func,
  type: PropTypes$1.string,
  tabIndex: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  look: PropTypes$1.oneOf([PRIMARY_LOOK, REGULAR_LOOK, LINK_LOOK, OUTLINE_LOOK]),
  size: PropTypes$1.oneOf([SIZES.MEDIUM, SIZES.LARGE])
};

var challengeMap = function challengeMap(length) {
  return {
    length: /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "744377571",
      defaultMessage: "Minimum {length} characters",
      values: {
        length: length
      }
    }),
    upper: /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "1963245695",
      defaultMessage: "1 Uppercase"
    }),
    lower: /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "3877285238",
      defaultMessage: "1 lowercase"
    }),
    numbers: /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "2792137744",
      defaultMessage: "1 number"
    }),
    specials: /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "3286567409",
      defaultMessage: "1 special character"
    })
  };
};

var FIELDNAME = "New Password";

var NewPassword = function NewPassword(_ref) {
  var onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      rules = _ref.rules;
  return /*#__PURE__*/React$1.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var value = _ref2.value,
          _onChange = _ref2.onChange;
      return /*#__PURE__*/React$1.createElement(PasswordComplexity, {
        rules: rules,
        value: value,
        render: function render(_ref3) {
          var invalid = _ref3.invalid,
              completedChallenges = _ref3.completedChallenges,
              challenges = _ref3.challenges;
          return /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Content$3, {
            "data-testid": "reset-password-screen"
          }, /*#__PURE__*/React$1.createElement(ContentBlock, {
            "data-testid": "reset-password-content"
          }, /*#__PURE__*/React$1.createElement(Label$1, {
            forId: "password-input"
          }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
            id: "1254879564",
            defaultMessage: FIELDNAME
          })), /*#__PURE__*/React$1.createElement(PasswordInput, {
            "data-testid": "reset-password-input",
            id: "password-input",
            onChange: function onChange(e) {
              return _onChange(e.target.value);
            },
            autoFocus: true,
            value: value
          })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(ToDoList, {
            list: challenges.map(function (challenge) {
              return {
                text: challengeMap(rules.length)[challenge],
                complete: completedChallenges.includes(challenge)
              };
            })
          }))), /*#__PURE__*/React$1.createElement(DialogFooter, null, /*#__PURE__*/React$1.createElement(Button$1, {
            size: "large",
            type: "submit",
            look: "primary",
            disabled: invalid
          }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
            id: "751710530",
            defaultMessage: "Submit"
          })), /*#__PURE__*/React$1.createElement(Button$1, {
            size: "large",
            onClick: onCancel
          }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
            id: "3528672691",
            defaultMessage: "Cancel"
          }))));
        }
      });
    }
  });
};

var WarningIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGMjlCMDUiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTQzLjIgNDNINC43ODlhMi43OTMgMi43OTMgMCAwIDEtMi40MTUtMS40IDIuODE1IDIuODE1IDAgMCAxIDAtMi44TDIxLjU3OCA1LjRBMi43OTUgMi43OTUgMCAwIDEgMjMuOTk0IDRjLjk5MyAwIDEuOTE4LjUzNiAyLjQxNiAxLjRsMTkuMDY4IDMzLjE2MmMuMzU4LjUzMS41MjIgMS4wNzUuNTIyIDEuNjM4YTIuODAyIDIuODAyIDAgMCAxLTIuOCAyLjh6TTIyIDM0djRoNHYtNGgtNHptMC0xOXYxNmg0VjE1aC00eiIvPgogICAgPC9nPgo8L3N2Zz4K";

function _templateObject$1b() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 48px;\n  height: 48px;\n  align-self: center;\n"]);

  _templateObject$1b = function _templateObject() {
    return data;
  };

  return data;
}
var CenteredIcon = styled(Icon$2)(_templateObject$1b());

var ContactAdmin = function ContactAdmin(_ref) {
  var onContinue = _ref.onContinue,
      warningMessage = _ref.warningMessage;
  return /*#__PURE__*/React$1.createElement(Content$3, {
    "data-testid": "contact-admin-screen"
  }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(CenteredIcon, {
    src: WarningIcon
  })), /*#__PURE__*/React$1.createElement(ContentBlock, null, warningMessage || /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "3737470122",
    defaultMessage: "Please contact admin for more information."
  })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
    onClick: onContinue,
    size: "large",
    look: "primary"
  }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "3640052215",
    defaultMessage: "Continue"
  }))));
};

ContactAdmin.displayName = "ContactAdmin";
ContactAdmin.propTypes = {
  onContinue: PropTypes$1.func.isRequired,
  warningMessage: PropTypes$1.object
};

function _templateObject3$p() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", "px;\n  display: block;\n  margin-top: ", "px;\n"]);

  _templateObject3$p = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$F() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: rotate 2s linear infinite;\n  transform-origin: center center;\n  height: 100%;\n  width: 100%;\n  max-width: ", "px;\n  max-height: ", "px;\n  margin: auto;\n\n  & .path {\n    stroke-dasharray: 75, 120;\n    stroke-dashoffset: 0;\n    stroke: ", ";\n    animation: dash 1.5s ease-in-out infinite;\n    stroke-linecap: round;\n  }\n\n  @keyframes rotate {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes dash {\n    0% {\n      stroke-dasharray: 1, 120;\n      stroke-dashoffset: 0;\n    }\n    50% {\n      stroke-dasharray: 65, 120;\n      stroke-dashoffset: -30px;\n    }\n    100% {\n      stroke-dasharray: 65, 120;\n      stroke-dashoffset: -100px;\n    }\n  }\n"]);

  _templateObject2$F = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1a() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: calc(50% - ", "px);\n  top: calc(50% - ", "px);\n  text-align: center;\n"]);

  _templateObject$1a = function _templateObject() {
    return data;
  };

  return data;
}
var SPINNER_HEIGHT = 72;
var MSG_FONT_SIZE = 14;
var MSG_SPINNER_DISTANCE = 12;
var LoadingContainer = styled.div(_templateObject$1a(), SPINNER_HEIGHT / 2, SPINNER_HEIGHT / 2);
var StyledSpinner = styled.svg(_templateObject2$F(), SPINNER_HEIGHT, SPINNER_HEIGHT, COLORS.ACTION_COLORS.ONELOGIN_BLUE);
var LoadingMessage = styled.span(_templateObject3$p(), MSG_FONT_SIZE, MSG_SPINNER_DISTANCE);
var Loading = function Loading(_ref) {
  var msg = _ref.msg,
      className = _ref.className;
  return /*#__PURE__*/React$1.createElement(LoadingContainer, {
    className: className
  }, /*#__PURE__*/React$1.createElement(StyledSpinner, {
    viewBox: "20 20 40 40"
  }, /*#__PURE__*/React$1.createElement("circle", {
    className: "path",
    cx: "40",
    cy: "40",
    r: "16",
    fill: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React$1.createElement(LoadingMessage, null, msg));
};
Loading.propTypes = {
  msg: PropTypes$1.string
};

function _templateObject$19() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 275px;\n"]);

  _templateObject$19 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$4 = styled.div(_templateObject$19());

var LoginLoading = function LoginLoading() {
  return /*#__PURE__*/React$1.createElement(Container$4, null, /*#__PURE__*/React$1.createElement(Loading, null));
};

LoginLoading.propTypes = {};

function _templateObject$18() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: ", ";\n  line-height: 28px;\n"]);

  _templateObject$18 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTextField = styled.div(_templateObject$18(), COLORS.TEXT_COLORS.DEFAULT, function (props) {
  return props.large ? "16px" : "14px";
});
StyledTextField.defaultProps = {
  large: false
};
StyledTextField.propTypes = {
  large: PropTypes$1.bool
};
StyledTextField.displayName = "TextField";

function _templateObject2$E() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 12px;\n"]);

  _templateObject2$E = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$17() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 12px;\n"]);

  _templateObject$17 = function _templateObject() {
    return data;
  };

  return data;
}
var BottomButton = styled(Button$1)(_templateObject$17());
var TopButton = styled(Button$1)(_templateObject2$E());

var EnterRegistrationCode = function EnterRegistrationCode(_ref) {
  var onSubmit = _ref.onSubmit,
      contactInfo = _ref.contactInfo,
      onTryAgain = _ref.onTryAgain;
  return /*#__PURE__*/React$1.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "enter-sms-code-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, contactInfo ? /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "contact-info"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3827227259",
        defaultMessage: "A confirmation code was sent to"
      })), /*#__PURE__*/React$1.createElement(StyledTextField, {
        large: true
      }, " ", contactInfo)) : /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "contact-info"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "1212847248",
        defaultMessage: "A confirmation code was sent to your configured address."
      }))), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "security-code"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3327626662",
        defaultMessage: "Enter your confirmation code"
      })), /*#__PURE__*/React$1.createElement(Input, {
        id: "security-code",
        value: value,
        onChange: function onChange(event) {
          return _onChange(event.target.value);
        },
        autoFocus: true,
        invalid: invalid,
        size: "large"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(TopButton, {
        size: "large",
        type: "submit",
        look: "primary"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      })), /*#__PURE__*/React$1.createElement(BottomButton, {
        "data-testid": "try-again-button",
        size: "large",
        look: "regular",
        onClick: onTryAgain
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "2018264248",
        defaultMessage: "Try Again"
      }))));
    }
  });
};

EnterRegistrationCode.displayName = "EnterRegistrationCode";
EnterRegistrationCode.propTypes = {
  onSubmit: PropTypes$1.func.isRequired,
  onTryAgain: PropTypes$1.func.isRequired,
  contactInfo: PropTypes$1.string
};

var MultiValueForm = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(MultiValueForm, _Component);

  function MultiValueForm(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.getOnChange = function (fieldName) {
      return function (value) {
        var _this$setState;

        _this.setState((_this$setState = {}, _this$setState[fieldName] = {
          value: value,
          invalid: false
        }, _this$setState));
      };
    };

    _this.isValid = function (fieldName) {
      return _this.state[fieldName].value.length >= 1;
    };

    _this.onSubmit = function (event) {
      event.preventDefault();
      var invalidFieldNames = filter(complement(_this.isValid), _this.props.fieldNames);

      if (isEmpty(invalidFieldNames)) {
        // all forms input have valid value
        var fieldToValueMap = reduce(function (acc, fieldName) {
          acc[fieldName] = _this.state[fieldName].value;
          return acc;
        }, {}, _this.props.fieldNames);

        _this.props.onSubmit(fieldToValueMap);
      } else {
        _this.setState(reduce(function (acc, fieldName) {
          acc[fieldName] = _objectSpread2({}, _this.state[fieldName], {
            invalid: true
          });
          return acc;
        }, {}, invalidFieldNames));
      }
    };

    _this.render = function () {
      return /*#__PURE__*/React$1.createElement("form", {
        onSubmit: _this.onSubmit
      }, _this.props.render(_objectSpread2({}, mapObjIndexed(function (value, key) {
        return _objectSpread2({}, value, {
          onChange: _this.getOnChange(key)
        });
      }, _this.state))));
    };

    _this.state = reduce(function (acc, fieldName) {
      acc[fieldName] = {
        value: "",
        invalid: false
      };
      return acc;
    }, {}, props.fieldNames);
    return _this;
  }

  return MultiValueForm;
}(Component);

MultiValueForm.displayName = "MultiValueForm";
MultiValueForm.propTypes = {
  onSubmit: PropTypes$1.func.isRequired,
  fieldNames: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  render: PropTypes$1.func.isRequired
};

var RegisterWithCredentialIdAndTwoOtps = function RegisterWithCredentialIdAndTwoOtps(_ref) {
  var onSubmit = _ref.onSubmit,
      children = _ref.children,
      credentialIdText = _ref.credentialIdText,
      otp1Label = _ref.otp1Label,
      otp2Label = _ref.otp2Label;
  return /*#__PURE__*/React$1.createElement(MultiValueForm, {
    fieldNames: ["credentialId", "otp1", "otp2"],
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var credentialId = _ref2.credentialId,
          otp1 = _ref2.otp1,
          otp2 = _ref2.otp2;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "register-with-two-otp"
      }, children, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "credentialId"
      }, credentialIdText), /*#__PURE__*/React$1.createElement(Input, {
        id: "credentialId",
        value: credentialId.value,
        onChange: function onChange(event) {
          return credentialId.onChange(event.target.value);
        },
        invalid: credentialId.invalid,
        size: "large"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "otp1"
      }, otp1Label), /*#__PURE__*/React$1.createElement(Input, {
        id: "otp1",
        value: otp1.value,
        onChange: function onChange(event) {
          return otp1.onChange(event.target.value);
        },
        invalid: otp1.invalid,
        size: "large"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "otp2"
      }, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "otp2"
      }, otp2Label)), /*#__PURE__*/React$1.createElement(Input, {
        id: "otp2",
        value: otp2.value,
        onChange: function onChange(event) {
          return otp2.onChange(event.target.value);
        },
        invalid: otp2.invalid,
        size: "large"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        type: "submit",
        look: "primary",
        "data-testid": "continue-button"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

RegisterWithCredentialIdAndTwoOtps.displayName = "RegisterWithCredentialIdAndTwoOtps";
RegisterWithCredentialIdAndTwoOtps.propTypes = {
  onSubmit: PropTypes$1.func.isRequired,
  children: PropTypes$1.element,
  otp1Label: PropTypes$1.element,
  otp2Label: PropTypes$1.element
};

function _templateObject$16() {
  var data = _taggedTemplateLiteralLoose(["\n  .react-tel-input {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 15px;\n    position: relative;\n    width: 100%;\n  }\n  .react-tel-input :disabled {\n    cursor: not-allowed;\n  }\n  .react-tel-input .flag {\n    width: 16px;\n    height: 11px;\n    background-image: url(data:image/png;base64,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);\n  }\n  .react-tel-input .ad {\n    background-position: -16px 0;\n  }\n  .react-tel-input .ae {\n    background-position: -32px 0;\n  }\n  .react-tel-input .af {\n    background-position: -48px 0;\n  }\n  .react-tel-input .ag {\n    background-position: -64px 0;\n  }\n  .react-tel-input .ai {\n    background-position: -80px 0;\n  }\n  .react-tel-input .al {\n    background-position: -96px 0;\n  }\n  .react-tel-input .am {\n    background-position: -112px 0;\n  }\n  .react-tel-input .ao {\n    background-position: -128px 0;\n  }\n  .react-tel-input .ar {\n    background-position: -144px 0;\n  }\n  .react-tel-input .as {\n    background-position: -160px 0;\n  }\n  .react-tel-input .at {\n    background-position: -176px 0;\n  }\n  .react-tel-input .au {\n    background-position: -192px 0;\n  }\n  .react-tel-input .aw {\n    background-position: -208px 0;\n  }\n  .react-tel-input .az {\n    background-position: -224px 0;\n  }\n  .react-tel-input .ba {\n    background-position: -240px 0;\n  }\n  .react-tel-input .bb {\n    background-position: 0 -11px;\n  }\n  .react-tel-input .bd {\n    background-position: -16px -11px;\n  }\n  .react-tel-input .be {\n    background-position: -32px -11px;\n  }\n  .react-tel-input .bf {\n    background-position: -48px -11px;\n  }\n  .react-tel-input .bg {\n    background-position: -64px -11px;\n  }\n  .react-tel-input .bh {\n    background-position: -80px -11px;\n  }\n  .react-tel-input .bi {\n    background-position: -96px -11px;\n  }\n  .react-tel-input .bj {\n    background-position: -112px -11px;\n  }\n  .react-tel-input .bm {\n    background-position: -128px -11px;\n  }\n  .react-tel-input .bn {\n    background-position: -144px -11px;\n  }\n  .react-tel-input .bo {\n    background-position: -160px -11px;\n  }\n  .react-tel-input .br {\n    background-position: -176px -11px;\n  }\n  .react-tel-input .bs {\n    background-position: -192px -11px;\n  }\n  .react-tel-input .bt {\n    background-position: -208px -11px;\n  }\n  .react-tel-input .bw {\n    background-position: -224px -11px;\n  }\n  .react-tel-input .by {\n    background-position: -240px -11px;\n  }\n  .react-tel-input .bz {\n    background-position: 0 -22px;\n  }\n  .react-tel-input .ca {\n    background-position: -16px -22px;\n  }\n  .react-tel-input .cd {\n    background-position: -32px -22px;\n  }\n  .react-tel-input .cf {\n    background-position: -48px -22px;\n  }\n  .react-tel-input .cg {\n    background-position: -64px -22px;\n  }\n  .react-tel-input .ch {\n    background-position: -80px -22px;\n  }\n  .react-tel-input .ci {\n    background-position: -96px -22px;\n  }\n  .react-tel-input .ck {\n    background-position: -112px -22px;\n  }\n  .react-tel-input .cl {\n    background-position: -128px -22px;\n  }\n  .react-tel-input .cm {\n    background-position: -144px -22px;\n  }\n  .react-tel-input .cn {\n    background-position: -160px -22px;\n  }\n  .react-tel-input .co {\n    background-position: -176px -22px;\n  }\n  .react-tel-input .cr {\n    background-position: -192px -22px;\n  }\n  .react-tel-input .cu {\n    background-position: -208px -22px;\n  }\n  .react-tel-input .cv {\n    background-position: -224px -22px;\n  }\n  .react-tel-input .cw {\n    background-position: -240px -22px;\n  }\n  .react-tel-input .cy {\n    background-position: 0 -33px;\n  }\n  .react-tel-input .cz {\n    background-position: -16px -33px;\n  }\n  .react-tel-input .de {\n    background-position: -32px -33px;\n  }\n  .react-tel-input .dj {\n    background-position: -48px -33px;\n  }\n  .react-tel-input .dk {\n    background-position: -64px -33px;\n  }\n  .react-tel-input .dm {\n    background-position: -80px -33px;\n  }\n  .react-tel-input .do {\n    background-position: -96px -33px;\n  }\n  .react-tel-input .dz {\n    background-position: -112px -33px;\n  }\n  .react-tel-input .ec {\n    background-position: -128px -33px;\n  }\n  .react-tel-input .ee {\n    background-position: -144px -33px;\n  }\n  .react-tel-input .eg {\n    background-position: -160px -33px;\n  }\n  .react-tel-input .er {\n    background-position: -176px -33px;\n  }\n  .react-tel-input .es {\n    background-position: -192px -33px;\n  }\n  .react-tel-input .et {\n    background-position: -208px -33px;\n  }\n  .react-tel-input .fi {\n    background-position: -224px -33px;\n  }\n  .react-tel-input .fj {\n    background-position: -240px -33px;\n  }\n  .react-tel-input .fk {\n    background-position: 0 -44px;\n  }\n  .react-tel-input .fm {\n    background-position: -16px -44px;\n  }\n  .react-tel-input .fo {\n    background-position: -32px -44px;\n  }\n  .react-tel-input .fr,\n  .react-tel-input .bl,\n  .react-tel-input .mf {\n    background-position: -48px -44px;\n  }\n  .react-tel-input .ga {\n    background-position: -64px -44px;\n  }\n  .react-tel-input .gb {\n    background-position: -80px -44px;\n  }\n  .react-tel-input .gd {\n    background-position: -96px -44px;\n  }\n  .react-tel-input .ge {\n    background-position: -112px -44px;\n  }\n  .react-tel-input .gf {\n    background-position: -128px -44px;\n  }\n  .react-tel-input .gh {\n    background-position: -144px -44px;\n  }\n  .react-tel-input .gi {\n    background-position: -160px -44px;\n  }\n  .react-tel-input .gl {\n    background-position: -176px -44px;\n  }\n  .react-tel-input .gm {\n    background-position: -192px -44px;\n  }\n  .react-tel-input .gn {\n    background-position: -208px -44px;\n  }\n  .react-tel-input .gp {\n    background-position: -224px -44px;\n  }\n  .react-tel-input .gq {\n    background-position: -240px -44px;\n  }\n  .react-tel-input .gr {\n    background-position: 0 -55px;\n  }\n  .react-tel-input .gt {\n    background-position: -16px -55px;\n  }\n  .react-tel-input .gu {\n    background-position: -32px -55px;\n  }\n  .react-tel-input .gw {\n    background-position: -48px -55px;\n  }\n  .react-tel-input .gy {\n    background-position: -64px -55px;\n  }\n  .react-tel-input .hk {\n    background-position: -80px -55px;\n  }\n  .react-tel-input .hn {\n    background-position: -96px -55px;\n  }\n  .react-tel-input .hr {\n    background-position: -112px -55px;\n  }\n  .react-tel-input .ht {\n    background-position: -128px -55px;\n  }\n  .react-tel-input .hu {\n    background-position: -144px -55px;\n  }\n  .react-tel-input .id {\n    background-position: -160px -55px;\n  }\n  .react-tel-input .ie {\n    background-position: -176px -55px;\n  }\n  .react-tel-input .il {\n    background-position: -192px -55px;\n  }\n  .react-tel-input .in {\n    background-position: -208px -55px;\n  }\n  .react-tel-input .io {\n    background-position: -224px -55px;\n  }\n  .react-tel-input .iq {\n    background-position: -240px -55px;\n  }\n  .react-tel-input .ir {\n    background-position: 0 -66px;\n  }\n  .react-tel-input .is {\n    background-position: -16px -66px;\n  }\n  .react-tel-input .it {\n    background-position: -32px -66px;\n  }\n  .react-tel-input .je {\n    background-position: -144px -154px;\n  }\n  .react-tel-input .jm {\n    background-position: -48px -66px;\n  }\n  .react-tel-input .jo {\n    background-position: -64px -66px;\n  }\n  .react-tel-input .jp {\n    background-position: -80px -66px;\n  }\n  .react-tel-input .ke {\n    background-position: -96px -66px;\n  }\n  .react-tel-input .kg {\n    background-position: -112px -66px;\n  }\n  .react-tel-input .kh {\n    background-position: -128px -66px;\n  }\n  .react-tel-input .ki {\n    background-position: -144px -66px;\n  }\n  .react-tel-input .xk {\n    background-position: -128px -154px;\n  }\n  .react-tel-input .km {\n    background-position: -160px -66px;\n  }\n  .react-tel-input .kn {\n    background-position: -176px -66px;\n  }\n  .react-tel-input .kp {\n    background-position: -192px -66px;\n  }\n  .react-tel-input .kr {\n    background-position: -208px -66px;\n  }\n  .react-tel-input .kw {\n    background-position: -224px -66px;\n  }\n  .react-tel-input .ky {\n    background-position: -240px -66px;\n  }\n  .react-tel-input .kz {\n    background-position: 0 -77px;\n  }\n  .react-tel-input .la {\n    background-position: -16px -77px;\n  }\n  .react-tel-input .lb {\n    background-position: -32px -77px;\n  }\n  .react-tel-input .lc {\n    background-position: -48px -77px;\n  }\n  .react-tel-input .li {\n    background-position: -64px -77px;\n  }\n  .react-tel-input .lk {\n    background-position: -80px -77px;\n  }\n  .react-tel-input .lr {\n    background-position: -96px -77px;\n  }\n  .react-tel-input .ls {\n    background-position: -112px -77px;\n  }\n  .react-tel-input .lt {\n    background-position: -128px -77px;\n  }\n  .react-tel-input .lu {\n    background-position: -144px -77px;\n  }\n  .react-tel-input .lv {\n    background-position: -160px -77px;\n  }\n  .react-tel-input .ly {\n    background-position: -176px -77px;\n  }\n  .react-tel-input .ma {\n    background-position: -192px -77px;\n  }\n  .react-tel-input .mc {\n    background-position: -208px -77px;\n  }\n  .react-tel-input .md {\n    background-position: -224px -77px;\n  }\n  .react-tel-input .me {\n    background-position: -112px -154px;\n    height: 12px;\n  }\n  .react-tel-input .mg {\n    background-position: 0 -88px;\n  }\n  .react-tel-input .mh {\n    background-position: -16px -88px;\n  }\n  .react-tel-input .mk {\n    background-position: -32px -88px;\n  }\n  .react-tel-input .ml {\n    background-position: -48px -88px;\n  }\n  .react-tel-input .mm {\n    background-position: -64px -88px;\n  }\n  .react-tel-input .mn {\n    background-position: -80px -88px;\n  }\n  .react-tel-input .mo {\n    background-position: -96px -88px;\n  }\n  .react-tel-input .mp {\n    background-position: -112px -88px;\n  }\n  .react-tel-input .mq {\n    background-position: -128px -88px;\n  }\n  .react-tel-input .mr {\n    background-position: -144px -88px;\n  }\n  .react-tel-input .ms {\n    background-position: -160px -88px;\n  }\n  .react-tel-input .mt {\n    background-position: -176px -88px;\n  }\n  .react-tel-input .mu {\n    background-position: -192px -88px;\n  }\n  .react-tel-input .mv {\n    background-position: -208px -88px;\n  }\n  .react-tel-input .mw {\n    background-position: -224px -88px;\n  }\n  .react-tel-input .mx {\n    background-position: -240px -88px;\n  }\n  .react-tel-input .my {\n    background-position: 0 -99px;\n  }\n  .react-tel-input .mz {\n    background-position: -16px -99px;\n  }\n  .react-tel-input .na {\n    background-position: -32px -99px;\n  }\n  .react-tel-input .nc {\n    background-position: -48px -99px;\n  }\n  .react-tel-input .ne {\n    background-position: -64px -99px;\n  }\n  .react-tel-input .nf {\n    background-position: -80px -99px;\n  }\n  .react-tel-input .ng {\n    background-position: -96px -99px;\n  }\n  .react-tel-input .ni {\n    background-position: -112px -99px;\n  }\n  .react-tel-input .nl,\n  .react-tel-input .bq {\n    background-position: -128px -99px;\n  }\n  .react-tel-input .no {\n    background-position: -144px -99px;\n  }\n  .react-tel-input .np {\n    background-position: -160px -99px;\n  }\n  .react-tel-input .nr {\n    background-position: -176px -99px;\n  }\n  .react-tel-input .nu {\n    background-position: -192px -99px;\n  }\n  .react-tel-input .nz {\n    background-position: -208px -99px;\n  }\n  .react-tel-input .om {\n    background-position: -224px -99px;\n  }\n  .react-tel-input .pa {\n    background-position: -240px -99px;\n  }\n  .react-tel-input .pe {\n    background-position: 0 -110px;\n  }\n  .react-tel-input .pf {\n    background-position: -16px -110px;\n  }\n  .react-tel-input .pg {\n    background-position: -32px -110px;\n  }\n  .react-tel-input .ph {\n    background-position: -48px -110px;\n  }\n  .react-tel-input .pk {\n    background-position: -64px -110px;\n  }\n  .react-tel-input .pl {\n    background-position: -80px -110px;\n  }\n  .react-tel-input .pm {\n    background-position: -96px -110px;\n  }\n  .react-tel-input .pr {\n    background-position: -112px -110px;\n  }\n  .react-tel-input .ps {\n    background-position: -128px -110px;\n  }\n  .react-tel-input .pt {\n    background-position: -144px -110px;\n  }\n  .react-tel-input .pw {\n    background-position: -160px -110px;\n  }\n  .react-tel-input .py {\n    background-position: -176px -110px;\n  }\n  .react-tel-input .qa {\n    background-position: -192px -110px;\n  }\n  .react-tel-input .re {\n    background-position: -208px -110px;\n  }\n  .react-tel-input .ro {\n    background-position: -224px -110px;\n  }\n  .react-tel-input .rs {\n    background-position: -240px -110px;\n  }\n  .react-tel-input .ru {\n    background-position: 0 -121px;\n  }\n  .react-tel-input .rw {\n    background-position: -16px -121px;\n  }\n  .react-tel-input .sa {\n    background-position: -32px -121px;\n  }\n  .react-tel-input .sb {\n    background-position: -48px -121px;\n  }\n  .react-tel-input .sc {\n    background-position: -64px -121px;\n  }\n  .react-tel-input .sd {\n    background-position: -80px -121px;\n  }\n  .react-tel-input .se {\n    background-position: -96px -121px;\n  }\n  .react-tel-input .sg {\n    background-position: -112px -121px;\n  }\n  .react-tel-input .sh {\n    background-position: -128px -121px;\n  }\n  .react-tel-input .si {\n    background-position: -144px -121px;\n  }\n  .react-tel-input .sk {\n    background-position: -160px -121px;\n  }\n  .react-tel-input .sl {\n    background-position: -176px -121px;\n  }\n  .react-tel-input .sm {\n    background-position: -192px -121px;\n  }\n  .react-tel-input .sn {\n    background-position: -208px -121px;\n  }\n  .react-tel-input .so {\n    background-position: -224px -121px;\n  }\n  .react-tel-input .sr {\n    background-position: -240px -121px;\n  }\n  .react-tel-input .ss {\n    background-position: 0 -132px;\n  }\n  .react-tel-input .st {\n    background-position: -16px -132px;\n  }\n  .react-tel-input .sv {\n    background-position: -32px -132px;\n  }\n  .react-tel-input .sx {\n    background-position: -48px -132px;\n  }\n  .react-tel-input .sy {\n    background-position: -64px -132px;\n  }\n  .react-tel-input .sz {\n    background-position: -80px -132px;\n  }\n  .react-tel-input .tc {\n    background-position: -96px -132px;\n  }\n  .react-tel-input .td {\n    background-position: -112px -132px;\n  }\n  .react-tel-input .tg {\n    background-position: -128px -132px;\n  }\n  .react-tel-input .th {\n    background-position: -144px -132px;\n  }\n  .react-tel-input .tj {\n    background-position: -160px -132px;\n  }\n  .react-tel-input .tk {\n    background-position: -176px -132px;\n  }\n  .react-tel-input .tl {\n    background-position: -192px -132px;\n  }\n  .react-tel-input .tm {\n    background-position: -208px -132px;\n  }\n  .react-tel-input .tn {\n    background-position: -224px -132px;\n  }\n  .react-tel-input .to {\n    background-position: -240px -132px;\n  }\n  .react-tel-input .tr {\n    background-position: 0 -143px;\n  }\n  .react-tel-input .tt {\n    background-position: -16px -143px;\n  }\n  .react-tel-input .tv {\n    background-position: -32px -143px;\n  }\n  .react-tel-input .tw {\n    background-position: -48px -143px;\n  }\n  .react-tel-input .tz {\n    background-position: -64px -143px;\n  }\n  .react-tel-input .ua {\n    background-position: -80px -143px;\n  }\n  .react-tel-input .ug {\n    background-position: -96px -143px;\n  }\n  .react-tel-input .us {\n    background-position: -112px -143px;\n  }\n  .react-tel-input .uy {\n    background-position: -128px -143px;\n  }\n  .react-tel-input .uz {\n    background-position: -144px -143px;\n  }\n  .react-tel-input .va {\n    background-position: -160px -143px;\n  }\n  .react-tel-input .vc {\n    background-position: -176px -143px;\n  }\n  .react-tel-input .ve {\n    background-position: -192px -143px;\n  }\n  .react-tel-input .vg {\n    background-position: -208px -143px;\n  }\n  .react-tel-input .vi {\n    background-position: -224px -143px;\n  }\n  .react-tel-input .vn {\n    background-position: -240px -143px;\n  }\n  .react-tel-input .vu {\n    background-position: 0 -154px;\n  }\n  .react-tel-input .wf {\n    background-position: -16px -154px;\n  }\n  .react-tel-input .ws {\n    background-position: -32px -154px;\n  }\n  .react-tel-input .ye {\n    background-position: -48px -154px;\n  }\n  .react-tel-input .za {\n    background-position: -64px -154px;\n  }\n  .react-tel-input .zm {\n    background-position: -80px -154px;\n  }\n  .react-tel-input .zw {\n    background-position: -96px -154px;\n  }\n  .react-tel-input * {\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n  }\n  .react-tel-input .hide {\n    display: none;\n  }\n  .react-tel-input .v-hide {\n    visibility: hidden;\n  }\n  .react-tel-input .form-control {\n    position: relative;\n    font-size: 14px;\n    letter-spacing: 0.01rem;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    padding-left: 48px;\n    margin-left: 0;\n    background: #ffffff;\n    border: 1px solid #cacaca;\n    border-radius: 5px;\n    line-height: 25px;\n    height: 35px;\n    width: 300px;\n  }\n  .react-tel-input .form-control.invalid-number {\n    border: 1px solid #d79f9f;\n    background-color: #faf0f0;\n    border-left-color: #cacaca;\n  }\n  .react-tel-input .form-control.invalid-number:focus {\n    border: 1px solid #d79f9f;\n    border-left-color: #cacaca;\n    background-color: #faf0f0;\n  }\n  .react-tel-input .flag-dropdown {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    padding: 0;\n    background-color: #f5f5f5;\n    border: 1px solid #cacaca;\n    border-radius: 3px 0 0 3px;\n  }\n  .react-tel-input .flag-dropdown:hover,\n  .react-tel-input .flag-dropdown:focus {\n    cursor: pointer;\n  }\n  .react-tel-input .flag-dropdown.invalid-number {\n    border-color: #d79f9f;\n  }\n  .react-tel-input .flag-dropdown.open {\n    z-index: 2;\n    background: #fff;\n    border-radius: 3px 0 0 0;\n  }\n  .react-tel-input .flag-dropdown.open .selected-flag {\n    background: #fff;\n    border-radius: 3px 0 0 0;\n  }\n  .react-tel-input input[disabled] + .flag-dropdown:hover {\n    cursor: default;\n  }\n  .react-tel-input input[disabled] + .flag-dropdown:hover .selected-flag {\n    background-color: transparent;\n  }\n  .react-tel-input .selected-flag {\n    position: relative;\n    width: 38px;\n    height: 100%;\n    padding: 0 0 0 8px;\n    border-radius: 3px 0 0 3px;\n  }\n  .react-tel-input .selected-flag:hover,\n  .react-tel-input .selected-flag:focus {\n    background-color: #fff;\n  }\n  .react-tel-input .selected-flag .flag {\n    position: absolute;\n    top: 50%;\n    margin-top: -5px;\n  }\n  .react-tel-input .selected-flag .arrow {\n    position: relative;\n    top: 50%;\n    margin-top: -2px;\n    left: 20px;\n    width: 0;\n    height: 0;\n    border-left: 3px solid transparent;\n    border-right: 3px solid transparent;\n    border-top: 4px solid #555;\n  }\n  .react-tel-input .selected-flag .arrow.up {\n    border-top: none;\n    border-bottom: 4px solid #555;\n  }\n  .react-tel-input .country-list {\n    z-index: 1;\n    list-style: none;\n    position: absolute;\n    padding: 0;\n    margin: 10px 0 10px -1px;\n    box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.35);\n    background-color: white;\n    width: 300px;\n    max-height: 200px;\n    overflow-y: scroll;\n    border-radius: 0 0 3px 3px;\n  }\n  .react-tel-input .country-list .flag {\n    display: inline-block;\n  }\n  .react-tel-input .country-list .divider {\n    padding-bottom: 5px;\n    margin-bottom: 5px;\n    border-bottom: 1px solid #ccc;\n  }\n  .react-tel-input .country-list .country {\n    padding: 7px 9px;\n  }\n  .react-tel-input .country-list .country .dial-code {\n    color: #6b6b6b;\n  }\n  .react-tel-input .country-list .country:hover {\n    background-color: #f1f1f1;\n  }\n  .react-tel-input .country-list .country.highlight {\n    background-color: #f1f1f1;\n  }\n  .react-tel-input .country-list .flag {\n    margin-right: 7px;\n    margin-top: 2px;\n  }\n  .react-tel-input .country-list .country-name {\n    margin-right: 6px;\n  }\n  .react-tel-input .country-list .search {\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    padding: 10px 0 6px 10px;\n  }\n  .react-tel-input .country-list .search-emoji {\n    font-size: 15px;\n  }\n  .react-tel-input .country-list .search-box {\n    border: 1px solid #cacaca;\n    border-radius: 3px;\n    font-size: 15px;\n    line-height: 15px;\n    margin-left: 6px;\n    padding: 3px 8px 5px;\n  }\n  .react-tel-input .country-list .no-entries-message {\n    padding: 7px 10px 11px;\n    opacity: 0.7;\n  }\n  .react-tel-input .invalid-number-message {\n    position: absolute;\n    z-index: 1;\n    font-size: 13px;\n    left: 46px;\n    top: -8px;\n    background: #fff;\n    padding: 0 2px;\n    color: #de0000;\n  }\n  .react-tel-input .special-label {\n    display: none;\n    position: absolute;\n    z-index: 1;\n    font-size: 13px;\n    left: 46px;\n    top: -8px;\n    background: #fff;\n    padding: 0 2px;\n    white-space: nowrap;\n  }\n"]);

  _templateObject$16 = function _templateObject() {
    return data;
  };

  return data;
}
// and paste here. This is just exported prettified content of style.css.
// We wanted to avoid rollup's css-postprocessors to be involved in RC. So the styles are wrapped into this styled.css
// we also need to delete all the `outline: none` in this file

var phoneNumberInputStyles = css(_templateObject$16());

function _templateObject$15() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  .react-tel-input {\n    .form-control {\n      line-height: normal;\n      height: 38px;\n      border-radius: 2px;\n      width: 100%;\n      padding-left: 66px;\n      border-color: ", ";\n    }\n\n    .flag-dropdown {\n      background-color: white;\n      width: 54px;\n      border-color: ", ";\n\n      .selected-flag {\n        padding-left: 12px;\n        z-index: inherit;\n        .arrow {\n          left: 24px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject$15 = function _templateObject() {
    return data;
  };

  return data;
}

var PhoneInput = require("react-phone-input-2")["default"];

var phoneInputStyle = {
  lineHeight: "normal",
  height: "38px",
  borderRadius: "2px",
  width: "100%",
  color: COLORS.GRAY_COLORS.GRAY_35,
  fontFamily: FONTS.FONT_FAMILY.DEFAULT
};
var countrySelectorStyle = {
  backgroundColor: "white",
  width: "48px"
};
var PhoneInputWrapper = styled.div(_templateObject$15(), phoneNumberInputStyles, COLORS.GRAY_COLORS.GRAY_88, COLORS.GRAY_COLORS.GRAY_88);

var PhoneNumberInput = function PhoneNumberInput(_ref) {
  var _onChange = _ref.onChange,
      value = _ref.value,
      defaultCountry = _ref.defaultCountry,
      disabled = _ref.disabled,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder;
  return /*#__PURE__*/React$1.createElement(PhoneInputWrapper, null, /*#__PURE__*/React$1.createElement(PhoneInput, {
    id: "phone-number",
    country: defaultCountry,
    value: value,
    onChange: function onChange(value) {
      return _onChange(value);
    },
    buttonStyle: countrySelectorStyle,
    inputStyle: phoneInputStyle,
    disableAreaCodes: true,
    disabled: disabled,
    placeholder: placeholder
  }));
};

PhoneNumberInput.displayName = "PhoneNumberInput";
PhoneNumberInput.propTypes = {
  onChange: PropTypes$1.func.isRequired,
  value: PropTypes$1.string,
  defaultCountry: PropTypes$1.string.isRequired,
  disabled: PropTypes$1.bool,
  placeholder: PropTypes$1.string
};

var EnterPhoneNumber = function EnterPhoneNumber(_ref) {
  var onSubmitSMS = _ref.onSubmitSMS,
      phoneNumber = _ref.phoneNumber,
      defaultCountry = _ref.defaultCountry,
      placeholder = _ref.placeholder;
  return /*#__PURE__*/React$1.createElement(SingleValueForm, {
    onSubmit: onSubmitSMS,
    value: phoneNumber,
    render: function render(_ref2) {
      _ref2.invalid;
          var value = _ref2.value,
          onChange = _ref2.onChange;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "enter-phone-number-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "enter-phone-number"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "2229754167",
        defaultMessage: "Enter your phone number"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(PhoneNumberInput, {
        defaultCountry: defaultCountry || "us",
        onChange: onChange,
        value: value,
        placeholder: placeholder
      }))), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        type: "submit",
        look: "primary"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

EnterPhoneNumber.displayName = "EnterPhoneNumber";
EnterPhoneNumber.propTypes = {
  onSubmitSMS: PropTypes$1.func.isRequired,
  phoneNumber: PropTypes$1.string,
  defaultCountry: PropTypes$1.string,
  placeholder: PropTypes$1.string
};

function _templateObject7$3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", "px;\n  height: ", "px;\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$7() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n  padding-left: 4px;\n  font-size: 14px;\n"]);

  _templateObject6$7 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$a() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: flex-end;\n  display: flex;\n  align-items: center;\n  height: 100%;\n"]);

  _templateObject5$a = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$d() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex: 1 1 auto;\n  padding-right: ", "px;\n"]);

  _templateObject4$d = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$o() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n  width: ", "px;\n"]);

  _templateObject3$o = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$D() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  flex: 0 0 ", "px;\n"]);

  _templateObject2$D = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$14() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  width: auto;\n  height: ", "px;\n  cursor: pointer;\n  border-bottom: 1px solid ", ";\n  font-size: 16px;\n  color: ", ";\n  overflow: hidden;\n  padding-right: 24px;\n  padding-left: 24px;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:first-child {\n    border-top: 1px solid ", ";\n  }\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject$14 = function _templateObject() {
    return data;
  };

  return data;
}
var ICON_IMAGE_SIZE$3 = 24;
var ICON_MARGIN$1 = 16;
var LIST_HEIGHT$1 = 56;
var Container$3 = styled.div(_templateObject$14(), LIST_HEIGHT$1, COLORS.SEPARATOR_COLORS.REGULAR, COLORS.TEXT_COLORS.DEFAULT, COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_GRAY_LIGHT, COLORS.SEPARATOR_COLORS.MEDIUM, COLORS.SEPARATOR_COLORS.MEDIUM);
var IconWrapper$1 = styled.div(_templateObject2$D(), ICON_IMAGE_SIZE$3 + ICON_MARGIN$1);
var Icon$1 = styled.img(_templateObject3$o(), ICON_IMAGE_SIZE$3, ICON_IMAGE_SIZE$3);
var TextWrapper$3 = styled.div(_templateObject4$d(), ICON_MARGIN$1);
var Configure = styled.div(_templateObject5$a());
var ConfigureText = styled.div(_templateObject6$7());
var AddIcon = styled.img.attrs(function (props) {
  return {
    src: props.icon
  };
})(_templateObject7$3(), function (props) {
  return props.big ? 24 : 16;
}, function (props) {
  return props.big ? 24 : 16;
});

var ListItem = function ListItem(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      showConfigure = _ref.showConfigure,
      configureIcon = _ref.configureIcon,
      showConfigureText = _ref.showConfigureText,
      onClick = _ref.onClick;
  return /*#__PURE__*/React$1.createElement(Container$3, {
    onClick: onClick
  }, icon && /*#__PURE__*/React$1.createElement(IconWrapper$1, null, /*#__PURE__*/React$1.createElement(Icon$1, {
    src: icon,
    alt: text
  })), /*#__PURE__*/React$1.createElement(TextWrapper$3, null, text), showConfigure && /*#__PURE__*/React$1.createElement(Configure, null, /*#__PURE__*/React$1.createElement(AddIcon, {
    big: !showConfigureText,
    icon: svgList[configureIcon]
  }), showConfigureText && /*#__PURE__*/React$1.createElement(ConfigureText, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "1477893598",
    defaultMessage: "Configure"
  }))));
};

ListItem.propTypes = {
  /** Optional icon to render */
  icon: PropTypes$1.string,

  /** Text displayed in item */
  text: PropTypes$1.string.isRequired,

  /** Show +configure icon and text */
  showConfigure: PropTypes$1.bool,

  /** Change configure icon */
  configureIcon: PropTypes$1.string,

  /** Show configure text next to icon */
  showConfigureText: PropTypes$1.bool,

  /** On item click handler */
  onClick: PropTypes$1.func.isRequired
};
ListItem.defaultProps = {
  configureIcon: "Plus-24"
};

var EmailIcon = "data:image/png;base64,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";

var ProtectIcon = "data:image/png;base64,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";

var VipIcon = "data:image/png;base64,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";

var YubiKeyIcon = "data:image/png;base64,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";

var DuoIcon = "data:image/png;base64,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";

var GoogleAuthIcon = "data:image/png;base64,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";

var OneloginSmsIcon = "data:image/png;base64,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";

var SecureIdIcon = "data:image/png;base64,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";

var SecurityQuestionsIcon = "data:image/png;base64,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";

var TempOtpIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MDAiIGhlaWdodD0iNTAwIiB2aWV3Qm94PSIwIDAgNTAwIDUwMCI+CiAgPG1ldGFkYXRhPjw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+Cjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIvPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPiAgICAgICAgICAgICAgICAgICAgICAgICAKPD94cGFja2V0IGVuZD0idyI/PjwvbWV0YWRhdGE+CjxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICMxYzFmMmE7CiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMTIwLDM4NmMtMTM4LjA3LDAtMjUwLDExMS45MjgtMjUwLDI1MHMxMTEuOTMsMjUwLDI1MCwyNTAsMjUwLTExMS45MjcsMjUwLTI1MFMyMjU4LjA3LDM4NiwyMTIwLDM4NlptMzcuMTEsMzM4LjQ2NnEwLDcuMDg3LTcuMDksNy4wODdoLTQ0Ljg3cS03LjA5NSwwLTcuMDktNy4wODdWNjE2LjIzNmgtMzQuNDhxLTcuMSwwLTcuMDktNy4wODZWNTY0LjI2OXEwLTcuMDg2LDcuMDktNy4wODZoODcuNjNjNC43MiwwLDUuOSwyLjM2Miw1LjksNS45VjcyNC40NjdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTg3MCAtMzg2KSIvPgo8L3N2Zz4K";

var OneloginVoiceIcon = "data:image/png;base64,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";

var WebAuthnOtpIcon = "data:image/png;base64,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";

var EmailOtpIcon = "data:image/png;base64,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";

var TidpIcon = "data:image/png;base64,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";

var OathIcon = "data:image/png;base64,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";

var MFA_TYPE_EMAIL = 0;
var MFA_TYPE_YUBIKEY = 1;
var MFA_TYPE_VIPACCESS = 2;
var MFA_TYPE_SECURID = 7;
var MFA_TYPE_ONELOGIN = 8;
var MFA_TYPE_AUTHENTICATOR = 10;
var MFA_TYPE_SMS = 11;
var MFA_TYPE_DUOSECURITY = 12;
var MFA_TYPE_SECURITYQUESTIONS = 13;
var MFA_TYPE_TEMP_OTP = 16;
var MFA_TYPE_VOICE = 17;
var MFA_TYPE_WEBAUTHN = 18;
var MFA_TYPE_EMAIL_OTP = 19;
var MFA_TYPE_TRUSTED_IDP = 20;
var MFA_TYPE_OATH = 22;

var IconProvider = function IconProvider(type) {
  switch (type) {
    case MFA_TYPE_EMAIL:
      {
        return EmailIcon;
      }

    case MFA_TYPE_YUBIKEY:
      {
        return YubiKeyIcon;
      }

    case MFA_TYPE_VIPACCESS:
      {
        return VipIcon;
      }

    case MFA_TYPE_SECURID:
      {
        return SecureIdIcon;
      }

    case MFA_TYPE_ONELOGIN:
      {
        return ProtectIcon;
      }

    case MFA_TYPE_AUTHENTICATOR:
      {
        return GoogleAuthIcon;
      }

    case MFA_TYPE_SMS:
      {
        return OneloginSmsIcon;
      }

    case MFA_TYPE_DUOSECURITY:
      {
        return DuoIcon;
      }

    case MFA_TYPE_SECURITYQUESTIONS:
      {
        return SecurityQuestionsIcon;
      }

    case MFA_TYPE_TEMP_OTP:
      {
        return TempOtpIcon;
      }

    case MFA_TYPE_VOICE:
      {
        return OneloginVoiceIcon;
      }

    case MFA_TYPE_WEBAUTHN:
      {
        return WebAuthnOtpIcon;
      }

    case MFA_TYPE_EMAIL_OTP:
      {
        return EmailOtpIcon;
      }

    case MFA_TYPE_TRUSTED_IDP:
      {
        return TidpIcon;
      }

    case MFA_TYPE_OATH:
      {
        return OathIcon;
      }

    default:
      return ProtectIcon;
  }
};

var SelectMFADevice = function SelectMFADevice(_ref) {
  var devices = _ref.devices,
      onSelect = _ref.onSelect;
  return /*#__PURE__*/React$1.createElement("div", {
    "data-testid": "devices-list"
  }, devices.map(function (device) {
    return /*#__PURE__*/React$1.createElement(ListItem, {
      key: device.id,
      icon: device.customIconUrl || IconProvider(device.factorTypeId),
      text: device.factorName,
      onClick: function onClick() {
        return onSelect(device.id);
      }
    });
  }));
};

SelectMFADevice.displayName = "SelectMFADevice";
SelectMFADevice.propTypes = {
  devices: PropTypes$1.arrayOf(PropTypes$1.shape({
    /** Text representation of link */
    factorName: PropTypes$1.string.isRequired,

    /** On link click handler */
    id: PropTypes$1.number.isRequired,

    /** MFA device type id */
    factorTypeId: PropTypes$1.number.isRequired,

    /** Custom icon set for device factor */
    customIconUrl: PropTypes$1.string
  })).isRequired,
  onSelect: PropTypes$1.func.isRequired
};

function _templateObject4$c() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  content: '';\n  ", "\n  transform: translate", "(-50%);\n  ", ";\n  z-index: 1;\n"]);

  _templateObject4$c = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$n() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  border-radius: 3px;\n  background-color: white;\n  pointer-events: auto;\n\n  ", "\n\n  ", "\n  box-shadow: 0 0 25px ", ";\n  z-index: 1;\n"]);

  _templateObject3$n = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$C() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n"]);

  _templateObject2$C = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$13() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  outline: none;\n"]);

  _templateObject$13 = function _templateObject() {
    return data;
  };

  return data;
}
/** Tooltip Component **
 *
 * This component allows any other component to have a tooltip with customizable location. Accepts these props:
 *
 * - Child (React node): This object is always rendered, and is what the tooltip is rendered relative to
 * - tooltip - (() -> React node): The object to be rendered inside the tooltip area (what effectively IS the tooltip)
 * - open (bool): Determines whether the tooltip is open or not. This component does not maintain its own state, it's
 * -    up to a parent component to manage that.
 * - onFocusLeave (func): When the tooltip is opened, it is also considered focused. When focus leaves the tooltip,
 * -    like when clicking elsewhere on the page, this function is called. Useful for signaling to the parent
 * -    that the tooltip should close
 * - dir ('top' | 'bottom' | 'left' | 'right'): Signals where the tooltip should be rendered relative to the child
 * -    (default is 'bottom')
 * - lean ('up' | 'down' | 'left' | 'right'): This allows the tooltip to be offset, rather than centered. 'left' and
 * -    'right' can only be used when dir is 'top' or 'bottom', and 'up' and 'down' can only be used when dir is
 * -    'left' or 'right'
 * -    (not providing this prop assumes a centered position)
 */

var TRIANGLE_WIDTH = "8px";
var TOOLTIP_MARGIN = "16px";

var getOpposite = function getOpposite(dir) {
  switch (dir) {
    case "left":
      return "right";

    case "right":
      return "left";

    case "up":
    case "top":
      return "bottom";

    case "down":
    case "bottom":
      return "top";

    default:
      return null;
  }
};

var perpendicular = function perpendicular(dir) {
  switch (dir) {
    case "top":
    case "bottom":
      return "left";

    case "left":
    case "right":
      return "top";

    default:
      return null;
  }
};

var getLean = function getLean(_ref) {
  var lean = _ref.lean,
      perp = _ref.perp,
      axis = _ref.axis;

  if (lean !== "center") {
    return getOpposite(lean) + ": 0;";
  }

  return perp + ": 50%; transform: translate" + axis + "(-50%);";
};

var getMarginProps = function getMarginProps(opposite, margin) {
  return opposite + ": 100%; margin-" + opposite + ": " + margin + ";";
};

var getBorderProps = function getBorderProps(perp, dir) {
  return "border-" + perp + ": " + TRIANGLE_WIDTH + " solid transparent; \n   border-" + getOpposite(perp) + ": " + TRIANGLE_WIDTH + " solid transparent;\n   border-" + dir + ": " + TRIANGLE_WIDTH + " solid white;\n   " + perp + ": 50%;";
};

var getOppositeProp = function getOppositeProp(opposite) {
  return opposite + ": calc(100% + " + TOOLTIP_MARGIN + " - " + TRIANGLE_WIDTH + ")";
};

var TooltipWrapper = styled.div(_templateObject$13());
var TooltipSpacer = styled.div(_templateObject2$C());
var TooltipBubble = styled.div(_templateObject3$n(), function (props) {
  return getMarginProps(props.opposite, TOOLTIP_MARGIN);
}, getLean, COLORS.GRAY_COLORS.GRAY_68);
var Tip = styled.div(_templateObject4$c(), function (props) {
  return getBorderProps(props.perp, props.dir);
}, function (props) {
  return props.axis;
}, function (props) {
  return getOppositeProp(props.opposite);
});

var Tooltip = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(Tooltip, _Component);

  function Tooltip(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleBodyClick = function (event) {
      var current = _this.tooltipWrapper.current;
      var onFocusLeave = _this.props.onFocusLeave;

      if (onFocusLeave && current && !current.contains(event.target)) {
        onFocusLeave();
      }
    };

    _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          open = _this$props.open,
          tooltip = _this$props.tooltip,
          dir = _this$props.dir,
          lean = _this$props.lean,
          ariaLabel = _this$props.ariaLabel;
      var opposite = getOpposite(dir);
      var perp = perpendicular(dir);
      var axis = perp === "left" ? "X" : "Y";
      return /*#__PURE__*/React$1.createElement(TooltipWrapper, {
        ref: _this.tooltipWrapper,
        "aria-label": ariaLabel
      }, children, open && /*#__PURE__*/React$1.createElement(TooltipSpacer, null, /*#__PURE__*/React$1.createElement(TooltipBubble, {
        dir: dir,
        lean: lean,
        perp: perp,
        opposite: opposite,
        axis: axis
      }, tooltip()), /*#__PURE__*/React$1.createElement(Tip, {
        dir: dir,
        perp: perp,
        opposite: opposite,
        axis: axis
      })));
    };

    _this.tooltipWrapper = createRef();
    return _this;
  }

  var _proto = Tooltip.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.body.removeEventListener("click", this.handleBodyClick, false);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.open) {
      document.body.addEventListener("click", this.handleBodyClick, false);
    } else {
      document.body.removeEventListener("click", this.handleBodyClick, false);
    }
  };

  return Tooltip;
}(Component);

Tooltip.propTypes = {
  open: PropTypes$1.bool.isRequired,
  children: PropTypes$1.element.isRequired,
  tooltip: PropTypes$1.func.isRequired,
  onFocusLeave: PropTypes$1.func,
  dir: PropTypes$1.string,
  lean: PropTypes$1.string,
  ariaLabel: PropTypes$1.string
};
Tooltip.defaultProps = {
  dir: "top",
  lean: "center"
};

function _templateObject2$B() {
  var data = _taggedTemplateLiteralLoose(["\n  width: max-content;\n  max-width: 300px;\n  padding: 0 20px;\n  font-size: 14px;\n"]);

  _templateObject2$B = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$12() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 7px;\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n"]);

  _templateObject$12 = function _templateObject() {
    return data;
  };

  return data;
}
var ToggleTooltipWrapper = styled.div(_templateObject$12());
var TooltipData = styled.p(_templateObject2$B());

var ToggleTooltip = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(ToggleTooltip, _Component);

  function ToggleTooltip(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      hover: false
    };
    return _this;
  }

  var _proto = ToggleTooltip.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        dir = _this$props.dir,
        lean = _this$props.lean,
        info = _this$props.info,
        children = _this$props.children;
    var hover = this.state.hover;
    return /*#__PURE__*/React$1.createElement(ToggleTooltipWrapper, {
      onMouseEnter: function onMouseEnter() {
        return _this2.setState({
          hover: true
        });
      },
      onMouseLeave: function onMouseLeave() {
        return _this2.setState({
          hover: false
        });
      },
      "data-testid": "toggle-tooltip"
    }, /*#__PURE__*/React$1.createElement(Tooltip, {
      open: hover,
      dir: dir,
      lean: lean,
      ariaLabel: info,
      tooltip: function tooltip() {
        return /*#__PURE__*/React$1.createElement(TooltipData, null, info);
      }
    }, children));
  };

  return ToggleTooltip;
}(Component);

ToggleTooltip.propTypes = {
  dir: PropTypes$1.string,
  lean: PropTypes$1.string,
  info: PropTypes$1.string.isRequired,
  children: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.node), PropTypes$1.node]).isRequired
};

function _templateObject5$9() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: flex-end;\n  display: flex;\n  align-items: center;\n  height: 100%;\n"]);

  _templateObject5$9 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$b() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1 1 auto;\n  padding-right: ", "px;\n  overflow: hidden;\n  max-height: 40px;\n  line-height: 20px;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$m() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n  width: ", "px;\n"]);

  _templateObject3$m = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$A() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  flex: 0 0 ", "px;\n"]);

  _templateObject2$A = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$11() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  width: auto;\n  height: ", "px;\n  cursor: pointer;\n  border-bottom: 1px solid ", ";\n  font-size: 16px;\n  color: ", ";\n  padding-right: 24px;\n  padding-left: 24px;\n  flex-shrink: 0;\n  outline-offset: -5px;\n  text-decoration: none;\n  align-items: center;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:first-child {\n    border-top: 1px solid ", ";\n  }\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject$11 = function _templateObject() {
    return data;
  };

  return data;
}
var ICON_IMAGE_SIZE$2 = 24;
var ICON_MARGIN = 16;
var LIST_HEIGHT = 52;
var COLUMN_VISIBLE_ROWS = 2;
var LOGIN_FACTOR_LOGO = "Key-24";
var PW_RESET_FACTOR_LOGO = "Reset-Password-24";
var APP_FACTOR_LOGO = "App-24";
var messages$7 = defineMessages({
  loginFactor: {
    "id": "loginFactor",
    defaultMessage: "This factor is used for login."
  },
  pwResetFactor: {
    "id": "pwResetFactor",
    defaultMessage: "This factor is used for password reset."
  },
  appFactor: {
    "id": "appFactor",
    defaultMessage: "This factor is used for app."
  }
});
var Container$2 = styled.a(_templateObject$11(), LIST_HEIGHT, COLORS.SEPARATOR_COLORS.REGULAR, COLORS.TEXT_COLORS.DEFAULT, COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_GRAY_LIGHT, COLORS.SEPARATOR_COLORS.MEDIUM, COLORS.SEPARATOR_COLORS.MEDIUM);
var IconWrapper = styled.div(_templateObject2$A(), ICON_IMAGE_SIZE$2 + ICON_MARGIN);
var DeviceIcon = styled.img(_templateObject3$m(), ICON_IMAGE_SIZE$2, ICON_IMAGE_SIZE$2);
var TextWrapper$2 = styled.div(_templateObject4$b(), ICON_MARGIN, COLUMN_VISIBLE_ROWS);
var FactorIcons = styled.div(_templateObject5$9());

var FactorListItem = function FactorListItem(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      _onClick = _ref.onClick,
      isLoginFactor = _ref.isLoginFactor,
      isPasswordResetFactor = _ref.isPasswordResetFactor,
      isAppFactor = _ref.isAppFactor,
      isLastItem = _ref.isLastItem,
      intl = _ref.intl;
  return /*#__PURE__*/React$1.createElement(Container$2, {
    href: "#",
    onClick: function onClick(event) {
      event.preventDefault();

      _onClick();
    },
    tabIndex: "0"
  }, icon && /*#__PURE__*/React$1.createElement(IconWrapper, null, /*#__PURE__*/React$1.createElement(DeviceIcon, {
    src: icon,
    alt: text
  })), /*#__PURE__*/React$1.createElement(TextWrapper$2, {
    title: text
  }, text), /*#__PURE__*/React$1.createElement(FactorIcons, null, isLoginFactor && /*#__PURE__*/React$1.createElement(ToggleTooltip, {
    dir: isLastItem ? "top" : "bottom",
    lean: "left",
    info: intl.formatMessage(messages$7.loginFactor)
  }, /*#__PURE__*/React$1.createElement(Icon$2, {
    name: LOGIN_FACTOR_LOGO,
    size: "24px"
  })), isPasswordResetFactor && /*#__PURE__*/React$1.createElement(ToggleTooltip, {
    dir: isLastItem ? "top" : "bottom",
    lean: "left",
    info: intl.formatMessage(messages$7.pwResetFactor)
  }, /*#__PURE__*/React$1.createElement(Icon$2, {
    name: PW_RESET_FACTOR_LOGO,
    size: "24px"
  })), isAppFactor && /*#__PURE__*/React$1.createElement(ToggleTooltip, {
    dir: isLastItem ? "top" : "bottom",
    lean: "left",
    info: intl.formatMessage(messages$7.appFactor)
  }, /*#__PURE__*/React$1.createElement(Icon$2, {
    name: APP_FACTOR_LOGO,
    size: "24px"
  }))));
};

FactorListItem.propTypes = {
  /** Optional icon to render */
  icon: PropTypes$1.string,

  /** Text displayed in item */
  text: PropTypes$1.string.isRequired,

  /** On item click handler */
  onClick: PropTypes$1.func.isRequired,

  /** Show login factor icon */
  isLoginFactor: PropTypes$1.bool,

  /** Show password reset factor icon */
  isPasswordResetFactor: PropTypes$1.bool,

  /** Show app factor icon */
  isAppFactor: PropTypes$1.bool
};
FactorListItem.defaultProps = {
  configureIcon: "Plus-24"
};
var FactorListItem$1 = injectIntl(FactorListItem);

var FactorList = function FactorList(_ref) {
  var factors = _ref.factors,
      onSelect = _ref.onSelect;
  return /*#__PURE__*/React$1.createElement("div", {
    "data-testid": "factor-list"
  }, factors.map(function (factor, index) {
    return /*#__PURE__*/React$1.createElement(FactorListItem$1, {
      key: factor.id,
      icon: factor.customIconUrl || IconProvider(factor.typeId),
      text: factor.name,
      onClick: function onClick() {
        return onSelect(factor.id);
      },
      isLoginFactor: factor.isLoginFactor,
      isPasswordResetFactor: factor.isPasswordResetFactor,
      isAppFactor: factor.isAppFactor,
      isLastItem: index === factors.length - 1
    });
  }));
};

FactorList.displayName = "FactorList";
FactorList.propTypes = {
  factors: PropTypes$1.arrayOf(PropTypes$1.shape({
    /** Text representation of link */
    name: PropTypes$1.string.isRequired,

    /** MFA id of factor */
    id: PropTypes$1.number.isRequired,

    /** MFA type of factor */
    typeId: PropTypes$1.number.isRequired,

    /** Custom icon set for factor instance */
    customIconUrl: PropTypes$1.string,

    /** if factor is used for Login */
    isLoginFactor: PropTypes$1.bool,

    /** if factor is used for Password Reset */
    isPasswordResetFactor: PropTypes$1.bool,

    /** if factor is used for App */
    isAppFactor: PropTypes$1.bool
  })).isRequired,
  onSelect: PropTypes$1.func.isRequired
};

function _templateObject$10() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 48px;\n  height: 48px;\n  align-self: center;\n"]);

  _templateObject$10 = function _templateObject() {
    return data;
  };

  return data;
}
var ImageWrapper = styled.img(_templateObject$10());

var RegistrationRequired = function RegistrationRequired(_ref) {
  var onContinue = _ref.onContinue,
      message = _ref.message;
  return /*#__PURE__*/React$1.createElement("form", {
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      onContinue();
    }
  }, /*#__PURE__*/React$1.createElement(Content$3, {
    "data-testid": "registration-required-screen"
  }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(ImageWrapper, {
    src: WarningIcon
  })), /*#__PURE__*/React$1.createElement(ContentBlock, null, message || /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "2859281487",
    defaultMessage: "2-factor authentication is required to secure your account."
  })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
    size: "large",
    type: "submit",
    look: "primary"
  }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "3640052215",
    defaultMessage: "Continue"
  })))));
};

RegistrationRequired.displayName = "RegistrationRequired";
RegistrationRequired.propTypes = {
  onContinue: PropTypes$1.func.isRequired,
  message: PropTypes$1.string
};

function _templateObject3$l() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n"]);

  _templateObject3$l = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$z() {
  var data = _taggedTemplateLiteralLoose(["\n  counter-increment: item;\n  line-height: ", "px;\n  margin-bottom: 24px;\n  color: ", ";\n\n  display: flex;\n  align-self: center;\n  justify-items: center;\n\n  &:before {\n    flex: 0 0 ", "px;\n    max-height: ", "px;\n    max-width: ", "px;\n    margin-right: 12px;\n    font-size: 14px;\n    line-height: 16px;\n    content: counter(item);\n    background: ", ";\n    border-radius: 100%;\n    color: white;\n    padding: 6px 0;\n    text-align: center;\n    vertical-align: middle;\n    display: flex;\n    justify-content: center;\n    align-self: flex-start;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject2$z = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$$() {
  var data = _taggedTemplateLiteralLoose(["\n  counter-reset: item;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 16px; //TODO: unify with content in bullet somehow\n"]);

  _templateObject$$ = function _templateObject() {
    return data;
  };

  return data;
}
var BulletSize = 28;
var BulletOrderedList = styled.ol(_templateObject$$());
var BulletItem = styled.li(_templateObject2$z(), BulletSize, COLORS.TEXT_COLORS.DEFAULT, BulletSize, BulletSize, BulletSize, COLORS.ACTION_COLORS.BLUE_DARKER);
var StyledContent = styled.div(_templateObject3$l());

var Bullets = function Bullets(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React$1.createElement(BulletOrderedList, null, Children.map(children, function (child) {
    return child && /*#__PURE__*/React$1.createElement(BulletItem, null, /*#__PURE__*/React$1.createElement(StyledContent, null, child));
  }));
};

Bullets.propTypes = {};

var mode$1 = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};

var mode = mode$1;

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

var _8BitByte = QR8bitByte;

var ErrorCorrectLevel$1 = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};

// ErrorCorrectLevel
var ECL = ErrorCorrectLevel$1;

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
};

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
};

var RSBlock$1 = QRRSBlock;

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

var BitBuffer$1 = QRBitBuffer;

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

var math$2 = QRMath;

var math$1 = math$2;

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math$1.gexp(math$1.glog(this.get(i) ) + math$1.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math$1.glog(this.get(0) ) - math$1.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math$1.gexp(math$1.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

var Polynomial$2 = QRPolynomial;

var Mode = mode$1;
var Polynomial$1 = Polynomial$2;
var math = math$2;

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial$1([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial$1([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

var util$1 = QRUtil;

var BitByte = _8BitByte;
var RSBlock = RSBlock$1;
var BitBuffer = BitBuffer$1;
var util = util$1;
var Polynomial = Polynomial$2;

function QRCode$1(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode$1.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode$1.PAD0 = 0xEC;
QRCode$1.PAD1 = 0x11;

QRCode$1.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD1, 8);
	}

	return QRCode$1.createBytes(buffer, rsBlocks);
};

QRCode$1.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

var QRCode_1 = QRCode$1;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = React$1;

var PropTypes = PropTypes$1; // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = QRCode_1;

var ErrorCorrectLevel = ErrorCorrectLevel$1; // TODO: pull this off of the QRCode class type so it matches.


// Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/
function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000',
  includeMargin: false
};
var PROP_TYPES = process.env.NODE_ENV !== 'production' ? {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string,
  includeMargin: PropTypes.bool,
  imageSettings: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    excavate: PropTypes.bool,
    x: PropTypes.number,
    y: PropTypes.number
  })
} : {};
var MARGIN_SIZE = 4; // This is *very* rough estimate of max amount of QRCode allowed to be covered.
// It is "wrong" in a lot of ways (area is a terrible way to estimate, it
// really should be number of modules covered), but if for some reason we don't
// get an explicit height or width, I'd rather default to something than throw.

var DEFAULT_IMG_SCALE = 0.1;

function generatePath(modules) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ops = [];
  modules.forEach(function (row, y) {
    var start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        // M0 0h7v1H0z injects the space with the move and drops the comma,
        // saving a char per operation
        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
        start = null;
        return;
      } // end of row, clean up or skip


      if (x === row.length - 1) {
        if (!cell) {
          // We would have closed the op above already so this can only mean
          // 2+ light modules in a row.
          return;
        }

        if (start === null) {
          // Just a single dark module.
          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
        } else {
          // Otherwise finish the current line.
          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
        }

        return;
      }

      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join('');
} // We could just do this in generatePath, except that we want to support
// non-Path2D canvas, so we need to keep it an explicit step.


function excavateModules(modules, excavation) {
  return modules.slice().map(function (row, y) {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }

    return row.map(function (cell, x) {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }

      return false;
    });
  });
}

function getImageSettings(props, cells) {
  var imageSettings = props.imageSettings,
      size = props.size,
      includeMargin = props.includeMargin;

  if (imageSettings == null) {
    return null;
  }

  var margin = includeMargin ? MARGIN_SIZE : 0;
  var numCells = cells.length + margin * 2;
  var defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  var scale = numCells / size;
  var w = (imageSettings.width || defaultSize) * scale;
  var h = (imageSettings.height || defaultSize) * scale;
  var x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  var y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  var excavation = null;

  if (imageSettings.excavate) {
    var floorX = Math.floor(x);
    var floorY = Math.floor(y);
    var ceilW = Math.ceil(w + x - floorX);
    var ceilH = Math.ceil(h + y - floorY);
    excavation = {
      x: floorX,
      y: floorY,
      w: ceilW,
      h: ceilH
    };
  }

  return {
    x: x,
    y: y,
    h: h,
    w: w,
    excavation: excavation
  };
} // For canvas we're going to switch our drawing mode based on whether or not
// the environment supports Path2D. We only need the constructor to be
// supported, but Edge doesn't actually support the path (string) type
// argument. Luckily it also doesn't support the addPath() method. We can
// treat that as the same thing.


var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }

  return true;
}();

var QRCodeCanvas =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(QRCodeCanvas, _React$PureComponent);

  function QRCodeCanvas() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(QRCodeCanvas)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_canvas", void 0);

    _defineProperty(_assertThisInitialized(_this), "_image", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      imgLoaded: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleImageLoad", function () {
      _this.setState({
        imgLoaded: true
      });
    });

    return _this;
  }

  _createClass(QRCodeCanvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _this$props = this.props,
          value = _this$props.value,
          size = _this$props.size,
          level = _this$props.level,
          bgColor = _this$props.bgColor,
          fgColor = _this$props.fgColor,
          includeMargin = _this$props.includeMargin,
          imageSettings = _this$props.imageSettings; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var margin = includeMargin ? MARGIN_SIZE : 0;
        var numCells = cells.length + margin * 2;
        var calculatedImageSettings = getImageSettings(this.props, cells);

        if (imageSettings != null && calculatedImageSettings != null) {
          if (calculatedImageSettings.excavation != null) {
            cells = excavateModules(cells, calculatedImageSettings.excavation);
          }
        } // We're going to scale this so that the number of drawable units
        // matches the number of cells. This avoids rounding issues, but does
        // result in some potentially unwanted single pixel issues between
        // blocks, only in environments that don't support Path2D.


        var pixelRatio = window.devicePixelRatio || 1;
        canvas.height = canvas.width = size * pixelRatio;
        var scale = size / numCells * pixelRatio;
        ctx.scale(scale, scale); // Draw solid background, only paint dark modules.

        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, numCells, numCells);
        ctx.fillStyle = fgColor;

        if (SUPPORTS_PATH2D) {
          // $FlowFixMe: Path2D c'tor doesn't support args yet.
          ctx.fill(new Path2D(generatePath(cells, margin)));
        } else {
          cells.forEach(function (row, rdx) {
            row.forEach(function (cell, cdx) {
              if (cell) {
                ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
              }
            });
          });
        }

        if (this.state.imgLoaded && this._image && calculatedImageSettings != null) {
          ctx.drawImage(this._image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
          _this$props2.value;
          var size = _this$props2.size;
          _this$props2.level;
          _this$props2.bgColor;
          _this$props2.fgColor;
          var style = _this$props2.style;
          _this$props2.includeMargin;
          var imageSettings = _this$props2.imageSettings,
          otherProps = _objectWithoutProperties(_this$props2, ["value", "size", "level", "bgColor", "fgColor", "style", "includeMargin", "imageSettings"]);

      var canvasStyle = _objectSpread({
        height: size,
        width: size
      }, style);

      var img = null;
      var imgSrc = imageSettings && imageSettings.src;

      if (imageSettings != null && imgSrc != null) {
        img = React.createElement("img", {
          src: imgSrc,
          style: {
            display: 'none'
          },
          onLoad: this.handleImageLoad,
          ref: function ref(_ref) {
            return _this2._image = _ref;
          }
        });
      }

      return React.createElement(React.Fragment, null, React.createElement("canvas", _extends({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref2) {
          return _this2._canvas = _ref2;
        }
      }, otherProps)), img);
    }
  }]);

  return QRCodeCanvas;
}(React.PureComponent);

_defineProperty(QRCodeCanvas, "defaultProps", DEFAULT_PROPS);

if (process.env.NODE_ENV !== 'production') {
  QRCodeCanvas.propTypes = PROP_TYPES;
}

var QRCodeSVG =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(QRCodeSVG, _React$PureComponent2);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _possibleConstructorReturn(this, _getPrototypeOf(QRCodeSVG).apply(this, arguments));
  }

  _createClass(QRCodeSVG, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          size = _this$props3.size,
          level = _this$props3.level,
          bgColor = _this$props3.bgColor,
          fgColor = _this$props3.fgColor,
          includeMargin = _this$props3.includeMargin,
          imageSettings = _this$props3.imageSettings,
          otherProps = _objectWithoutProperties(_this$props3, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "imageSettings"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return null;
      }

      var margin = includeMargin ? MARGIN_SIZE : 0;
      var numCells = cells.length + margin * 2;
      var calculatedImageSettings = getImageSettings(this.props, cells);
      var image = null;

      if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) {
          cells = excavateModules(cells, calculatedImageSettings.excavation);
        }

        image = React.createElement("image", {
          xlinkHref: imageSettings.src,
          height: calculatedImageSettings.h,
          width: calculatedImageSettings.w,
          x: calculatedImageSettings.x + margin,
          y: calculatedImageSettings.y + margin,
          preserveAspectRatio: "none"
        });
      } // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2


      var fgPath = generatePath(cells, margin);
      return React.createElement("svg", _extends({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: fgPath
      }), image);
    }
  }]);

  return QRCodeSVG;
}(React.PureComponent);

_defineProperty(QRCodeSVG, "defaultProps", DEFAULT_PROPS);

if (process.env.NODE_ENV !== 'production') {
  QRCodeSVG.propTypes = PROP_TYPES;
}

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode.defaultProps = _objectSpread({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
var lib = QRCode;

function _templateObject$_() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 32px;\n  position: relative;\n  left: 60px;\n"]);

  _templateObject$_ = function _templateObject() {
    return data;
  };

  return data;
}
var QRCODE_WIDTH = 120;
var QRCodeWrap = styled.div(_templateObject$_());

var ScanBarCode = function ScanBarCode(_ref) {
  var appName = _ref.appName,
      code = _ref.code,
      onContinue = _ref.onContinue,
      onCantScan = _ref.onCantScan;
  return /*#__PURE__*/React$1.createElement(Content$3, {
    "data-testid": "scan-bar-code-screen"
  }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Bullets, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "737192390",
    defaultMessage: "Open {appName}",
    values: {
      appName: appName
    }
  }), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "3645029425",
    defaultMessage: "Scan below QR Code"
  }), /*#__PURE__*/React$1.createElement(QRCodeWrap, null, /*#__PURE__*/React$1.createElement(lib, {
    value: encodeURI(code),
    size: QRCODE_WIDTH
  }))))), onCantScan && /*#__PURE__*/React$1.createElement(ContentBlock, {
    centered: true
  }, /*#__PURE__*/React$1.createElement(LinkButton, {
    onClick: onCantScan,
    size: "large"
  }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "3469481929",
    defaultMessage: "Can't scan the code?"
  }))), onContinue && /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
    size: "large",
    look: "primary",
    onClick: onContinue,
    "data-testid": "activate-button"
  }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "3673120330",
    defaultMessage: "Next"
  }))));
};

ScanBarCode.propTypes = {
  appName: PropTypes$1.string.isRequired,
  onContinue: PropTypes$1.func,
  onCantScan: PropTypes$1.func,
  code: PropTypes$1.string.isRequired
};

function _templateObject3$k() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  box-sizing: border-box;\n  width: 42px;\n  font-family: ", ";\n  line-height: 14px;\n  color: ", ";\n\n  &:not(:last-of-type) {\n    position: relative;\n\n    &::after {\n      content: \"\";\n      display: block;\n      width: 1px;\n      height: 38px;\n      position: absolute;\n      right: 0;\n      top: -12px;\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject3$k = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$y() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-width: 1px;\n  border-color: ", ";\n  font-size: ", ";\n  line-height: 1;\n  letter-spacing: ", ";\n  box-sizing: border-box;\n  min-width: 336px;\n  padding: ", ";\n  margin-top: 16px;\n  margin-left: -40px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  text-align: center;\n"]);

  _templateObject2$y = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Z() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin: 24px;\n"]);

  _templateObject$Z = function _templateObject() {
    return data;
  };

  return data;
}
var Content$2 = styled.div(_templateObject$Z());
var StyledCode$1 = styled.div(_templateObject2$y(), COLORS.GRAY_COLORS.GRAY_96, function (props) {
  return props.copied ? COLORS.STATUS_COLORS.SUCCESS : "transparent";
}, function (props) {
  return props.condensedCode ? "13px" : "20px";
}, function (props) {
  return props.condensedCode ? "0.4px" : "8px";
}, function (props) {
  return props.condensedCode ? "12px 0" : "16px 8px";
});
var SecretKeyBlock = styled.div(_templateObject3$k(), FONTS.FONT_FAMILY.MONOSPACE, COLORS.TEXT_COLORS.EMPHASIZED, COLORS.WHITE);

var CopyCodeManually = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(CopyCodeManually, _Component);

  function CopyCodeManually(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onCopy = function () {
      _this.setState({
        copied: true
      });

      _this.copiedTimeoutId = setTimeout(function () {
        _this.setState({
          copied: false
        });
      }, 1000);
    };

    _this.showCode = function () {
      if (_this.props.appName === "OneLogin Protect") {
        return _this.props.code;
      } else if (_this.props.appName === "Authenticator") {
        var keyBlocks = [];

        for (var i = 0; i < 32; i += 4) {
          keyBlocks.push( /*#__PURE__*/React$1.createElement(SecretKeyBlock, {
            key: i
          }, _this.props.code.slice(i, i + 4)));
        }

        return /*#__PURE__*/React$1.createElement("div", null, keyBlocks);
      }
    };

    _this.render = function () {
      return /*#__PURE__*/React$1.createElement(Content$2, {
        "data-testid": "copy-code-manually-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Bullets, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3374226769",
        defaultMessage: "Click Pair using manual entry"
      }), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3855542277",
        defaultMessage: "Enter this code into the app"
      }), /*#__PURE__*/React$1.createElement(StyledCode$1, {
        copied: _this.state.copied,
        condensedCode: _this.props.condensedCode
      }, _this.showCode())))), _this.props.onScanBarCode && /*#__PURE__*/React$1.createElement(ContentBlock, {
        centered: true
      }, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        onClick: _this.props.onScanBarCode
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "2097632732",
        defaultMessage: "Scan barcode instead"
      }))), _this.props.onContinue && /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        look: "primary",
        onClick: _this.props.onContinue,
        "data-testid": "activate-button"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3673120330",
        defaultMessage: "Next"
      }))));
    };

    _this.state = {
      copied: undefined
    };
    return _this;
  }

  var _proto = CopyCodeManually.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.copiedTimeoutId);
  };

  return CopyCodeManually;
}(Component);

CopyCodeManually.displayName = "CopyCodeManually";
CopyCodeManually.propTypes = {
  appName: PropTypes$1.oneOf(["OneLogin Protect", "Authenticator"]).isRequired,
  onScanBarCode: PropTypes$1.func,
  code: PropTypes$1.string.isRequired,
  condensedCode: PropTypes$1.bool
};
CopyCodeManually.defaultProps = {
  condensedCode: false
};

var PairProtectOrAuthenticator = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(PairProtectOrAuthenticator, _Component);

  function PairProtectOrAuthenticator(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.toggleQR = function (event) {
      event.preventDefault();

      _this.setState({
        showScanBarCode: !_this.state.showScanBarCode
      });
    };

    _this.render = function () {
      var _this$props = _this.props,
          code = _this$props.code,
          qrLink = _this$props.qrLink,
          onContinue = _this$props.onContinue,
          appName = _this$props.appName,
          condensedCode = _this$props.condensedCode;
      return _this.state.showScanBarCode ? /*#__PURE__*/React$1.createElement(ScanBarCode, {
        appName: appName,
        code: qrLink,
        onCantScan: _this.toggleQR,
        onContinue: onContinue
      }) : /*#__PURE__*/React$1.createElement(CopyCodeManually, {
        appName: appName,
        code: code,
        condensedCode: condensedCode,
        onScanBarCode: _this.toggleQR,
        onContinue: onContinue
      });
    };

    _this.state = {
      showScanBarCode: true
    };
    return _this;
  }

  return PairProtectOrAuthenticator;
}(Component);

PairProtectOrAuthenticator.displayName = "PairProtectOrAuthenticator";
PairProtectOrAuthenticator.propTypes = {
  appName: PropTypes$1.string.isRequired,
  qrLink: PropTypes$1.string.isRequired,
  code: PropTypes$1.string.isRequired,
  condensedCode: PropTypes$1.bool
};

var AppleBadgeIcon = "data:image/svg+xml;base64,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";

function _templateObject3$j() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 20px;\n"]);

  _templateObject3$j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$x() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 140px;\n"]);

  _templateObject2$x = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Y() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 160px;\n  margin: -10px;\n  height: 67px;\n"]);

  _templateObject$Y = function _templateObject() {
    return data;
  };

  return data;
}
var messages$6 = defineMessages({
  linkToGooglePlay: {
    "id": "linkToGooglePlay",
    defaultMessage: "Link to Google Play"
  },
  linkToAppStore: {
    "id": "linkToAppStore",
    defaultMessage: "Link to App Store"
  },
  getOnGooglePlay: {
    "id": "getOnGooglePlay",
    defaultMessage: "Get it on Google Play"
  },
  downloadOnAppStore: {
    "id": "downloadOnAppStore",
    defaultMessage: "Download on the app store"
  }
});
var ACTIVATE_ACTION_TEXT = "Activate";
var GoogleBadge = styled.img(_templateObject$Y());
var AppleBadge = styled.img(_templateObject2$x());
var BadgeWrapper = styled.div(_templateObject3$j()); // https://play.google.com/intl/en_us/badges/
// google badge is not translated by intention

var GOOGLE_BADGE = function GOOGLE_BADGE(intl) {
  return /*#__PURE__*/React$1.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.onelogin.protect",
    target: "_blank",
    alt: intl.formatMessage(messages$6.linkToGooglePlay),
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React$1.createElement(GoogleBadge, {
    alt: intl.formatMessage(messages$6.getOnGooglePlay),
    src: "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
  }));
}; // https://developer.apple.com/app-store/marketing/guidelines/#downloadOnAppstore
// apple bade is not translated by intention (see 1.2 Localized badges ^)


var APPLE_BADGE = function APPLE_BADGE(intl) {
  return /*#__PURE__*/React$1.createElement("a", {
    href: "https://itunes.apple.com/us/app/onelogin-protect/id509252983",
    target: "_blank",
    alt: intl.formatMessage(messages$6.linkToAppStore),
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React$1.createElement(AppleBadge, {
    alt: intl.formatMessage(messages$6.downloadOnAppStore),
    src: AppleBadgeIcon
  }));
};

var OTHER_BADGE = function OTHER_BADGE(intl) {
  return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("a", {
    href: "https://itunes.apple.com/us/app/onelogin-protect/id509252983",
    target: "_blank",
    alt: intl.formatMessage(messages$6.linkToAppStore),
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React$1.createElement(AppleBadge, {
    alt: intl.formatMessage(messages$6.downloadOnAppStore),
    src: AppleBadgeIcon
  })), /*#__PURE__*/React$1.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.onelogin.protect",
    target: "_blank",
    alt: intl.formatMessage(messages$6.linkToGooglePlay),
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React$1.createElement(GoogleBadge, {
    alt: intl.formatMessage(messages$6.getOnGooglePlay),
    src: "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
  })));
};

var InstallProtect = function InstallProtect(_ref) {
  var bowser = _ref.bowser,
      onContinue = _ref.onContinue,
      onUseMagicLink = _ref.onUseMagicLink,
      intl = _ref.intl;

  var badge = function badge(bowser) {
    if (bowser.android) {
      return GOOGLE_BADGE(intl);
    } else if (bowser.ios) {
      return APPLE_BADGE(intl);
    } else {
      return OTHER_BADGE(intl);
    }
  };

  return /*#__PURE__*/React$1.createElement(Content$3, {
    "data-testid": "install-protect-screen"
  }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Bullets, null, /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "1536965459",
    defaultMessage: "Download and install OneLogin Protect on your device"
  }), /*#__PURE__*/React$1.createElement(BadgeWrapper, null, badge(bowser))), /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "4227081527",
    defaultMessage: "When the app is installed, come back to this screen and click {action}",
    values: {
      action: /*#__PURE__*/React$1.createElement("b", null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3865193889",
        defaultMessage: ACTIVATE_ACTION_TEXT
      }))
    }
  }))), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
    size: "large",
    look: "primary",
    onClick: onContinue,
    "data-testid": "activate-button"
  }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "3865193889",
    defaultMessage: ACTIVATE_ACTION_TEXT
  })), onUseMagicLink && /*#__PURE__*/React$1.createElement(Button$1, {
    size: "large",
    onClick: onUseMagicLink
  }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "505702857",
    defaultMessage: "Magic Link"
  })))));
};

InstallProtect.propTypes = {
  bowser: PropTypes$1.object,
  onContinue: PropTypes$1.func,
  onUseMagicLink: PropTypes$1.func
};
var InstallProtect$1 = injectIntl(InstallProtect);

var LoginSecurityCode = function LoginSecurityCode(_ref) {
  var children = _ref.children,
      deviceName = _ref.deviceName,
      onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React$1.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "security-code-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "security-code"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "694278426",
        defaultMessage: "Enter your {deviceName} code",
        values: {
          deviceName: deviceName
        }
      })), /*#__PURE__*/React$1.createElement(PasswordInput, {
        "data-testid": "security-code",
        id: "security-code",
        onChange: function onChange(event) {
          return _onChange(event.target.value);
        },
        value: value,
        invalid: invalid,
        autoFocus: true,
        size: "large"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        type: "submit"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))), children && /*#__PURE__*/React$1.createElement(ContentBlock, null, children));
    }
  });
};

LoginSecurityCode.displayName = "LoginSecurityCode";
LoginSecurityCode.propTypes = {
  deviceName: PropTypes$1.string.isRequired,
  onSubmit: PropTypes$1.func.isRequired
};

function _templateObject$X() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.2px;\n\n  pre {\n    white-space: normal;\n  }\n"]);

  _templateObject$X = function _templateObject() {
    return data;
  };

  return data;
}
var TextWrapper$1 = styled.div(_templateObject$X(), COLORS.TEXT_COLORS.DEFAULT);

var DescriptionText = function DescriptionText(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React$1.createElement(TextWrapper$1, {
    className: className
  }, children);
};

var EnterYubiKey = function EnterYubiKey(_ref) {
  var onSubmit = _ref.onSubmit;
      _ref.onChangeClient;
  return /*#__PURE__*/React$1.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "enter-yubikey-screen"
      }, /*#__PURE__*/React$1.createElement(DescriptionText, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "2606375562",
        defaultMessage: "Insert your YubiKey in the USB port and press the button"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Input, {
        id: "security-code",
        value: value,
        onChange: function onChange(event) {
          return _onChange(event.target.value.toLowerCase());
        },
        autoFocus: true,
        invalid: invalid,
        size: "large",
        type: "password"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        type: "submit",
        look: "primary"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

EnterYubiKey.displayName = "EnterYubiKey";
EnterYubiKey.propTypes = {
  onSubmit: PropTypes$1.func.isRequired
};

/* eslint-disable */
// this script was downloaded from https://api.duosecurity.com/frame/hosted/Duo-Web-v2.js
// and updated to be exported as ES module

/**
 * Duo Web SDK v2
 * Copyright 2017, Duo Security
 */
function Duo () {
  var DUO_MESSAGE_FORMAT = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/;
  var DUO_ERROR_FORMAT = /^ERR\|[\w\s\.\(\)]+$/;
  var DUO_OPEN_WINDOW_FORMAT = /^DUO_OPEN_WINDOW\|/;
  var VALID_OPEN_WINDOW_DOMAINS = ["duo.com", "duosecurity.com", "duomobile.s3-us-west-1.amazonaws.com"];
  var iframeId = "duo_iframe",
      postAction = "",
      postArgument = "sig_response",
      host,
      duoSig,
      appSig,
      iframe,
      submitCallback;

  function throwError(message, url) {
    throw new Error("Duo Web SDK error: " + message + (url ? "\n" + "See " + url + " for more information" : ""));
  }

  function hyphenize(str) {
    return str.replace(/([a-z])([A-Z])/, "$1-$2").toLowerCase();
  } // cross-browser data attributes


  function getDataAttribute(element, name) {
    if ("dataset" in element) {
      return element.dataset[name];
    } else {
      return element.getAttribute("data-" + hyphenize(name));
    }
  } // cross-browser event binding/unbinding


  function on(context, event, fallbackEvent, callback) {
    if ("addEventListener" in window) {
      context.addEventListener(event, callback, false);
    } else {
      context.attachEvent(fallbackEvent, callback);
    }
  }

  function off(context, event, fallbackEvent, callback) {
    if ("removeEventListener" in window) {
      context.removeEventListener(event, callback, false);
    } else {
      context.detachEvent(fallbackEvent, callback);
    }
  }

  function onReady(callback) {
    on(document, "DOMContentLoaded", "onreadystatechange", callback);
  }

  function offReady(callback) {
    off(document, "DOMContentLoaded", "onreadystatechange", callback);
  }

  function onMessage(callback) {
    on(window, "message", "onmessage", callback);
  }

  function offMessage(callback) {
    off(window, "message", "onmessage", callback);
  }
  /**
   * Parse the sig_request parameter, throwing errors if the token contains
   * a server error or if the token is invalid.
   *
   * @param {String} sig Request token
   */


  function parseSigRequest(sig) {
    if (!sig) {
      // nothing to do
      return;
    } // see if the token contains an error, throwing it if it does


    if (sig.indexOf("ERR|") === 0) {
      throwError(sig.split("|")[1]);
    } // validate the token


    if (sig.indexOf(":") === -1 || sig.split(":").length !== 2) {
      throwError("Duo was given a bad token.  This might indicate a configuration " + "problem with one of Duo's client libraries.", "https://www.duosecurity.com/docs/duoweb#first-steps");
    }

    var sigParts = sig.split(":"); // hang on to the token, and the parsed duo and app sigs
    duoSig = sigParts[0];
    appSig = sigParts[1];
    return {
      sigRequest: sig,
      duoSig: sigParts[0],
      appSig: sigParts[1]
    };
  }
  /**
   * This function is set up to run when the DOM is ready, if the iframe was
   * not available during `init`.
   */


  function onDOMReady() {
    iframe = document.getElementById(iframeId);

    if (!iframe) {
      throw new Error("This page does not contain an iframe for Duo to use." + 'Add an element like <iframe id="duo_iframe"></iframe> ' + "to this page.  " + "See https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe " + "for more information.");
    } // we've got an iframe, away we go!


    ready(); // always clean up after yourself

    offReady(onDOMReady);
  }
  /**
   * Validate that a MessageEvent came from the Duo service, and that it
   * is a properly formatted payload.
   *
   * The Google Chrome sign-in page injects some JS into pages that also
   * make use of postMessage, so we need to do additional validation above
   * and beyond the origin.
   *
   * @param {MessageEvent} event Message received via postMessage
   */


  function isDuoMessage(event) {
    return Boolean(event.origin === "https://" + host && typeof event.data === "string" && (event.data.match(DUO_MESSAGE_FORMAT) || event.data.match(DUO_ERROR_FORMAT) || event.data.match(DUO_OPEN_WINDOW_FORMAT)));
  }
  /**
   * Validate the request token and prepare for the iframe to become ready.
   *
   * All options below can be passed into an options hash to `Duo.init`, or
   * specified on the iframe using `data-` attributes.
   *
   * Options specified using the options hash will take precedence over
   * `data-` attributes.
   *
   * Example using options hash:
   * ```javascript
   * Duo.init({
   *     iframe: "some_other_id",
   *     host: "api-main.duo.test",
   *     sig_request: "...",
   *     post_action: "/auth",
   *     post_argument: "resp"
   * });
   * ```
   *
   * Example using `data-` attributes:
   * ```
   * <iframe id="duo_iframe"
   *         data-host="api-main.duo.test"
   *         data-sig-request="..."
   *         data-post-action="/auth"
   *         data-post-argument="resp"
   *         >
   * </iframe>
   * ```
   *
   * @param {Object} options
   * @param {String} options.iframe                         The iframe, or id of an iframe to set up
   * @param {String} options.host                           Hostname
   * @param {String} options.sig_request                    Request token
   * @param {String} [options.post_action='']               URL to POST back to after successful auth
   * @param {String} [options.post_argument='sig_response'] Parameter name to use for response token
   * @param {Function} [options.submit_callback]            If provided, duo will not submit the form instead execute
   *                                                        the callback function with reference to the "duo_form" form object
   *                                                        submit_callback can be used to prevent the webpage from reloading.
   */


  function init(options) {
    if (options) {
      if (options.host) {
        host = options.host;
      }

      if (options.sig_request) {
        parseSigRequest(options.sig_request);
      }

      if (options.post_action) {
        postAction = options.post_action;
      }

      if (options.post_argument) {
        postArgument = options.post_argument;
      }

      if (options.iframe) {
        if (options.iframe.tagName) {
          iframe = options.iframe;
        } else if (typeof options.iframe === "string") {
          iframeId = options.iframe;
        }
      }

      if (typeof options.submit_callback === "function") {
        submitCallback = options.submit_callback;
      }
    } // if we were given an iframe, no need to wait for the rest of the DOM


    if (iframe) {
      ready();
    } else {
      // try to find the iframe in the DOM
      iframe = document.getElementById(iframeId); // iframe is in the DOM, away we go!

      if (iframe) {
        ready();
      } else {
        // wait until the DOM is ready, then try again
        onReady(onDOMReady);
      }
    } // always clean up after yourself!


    offReady(init);
  }
  /**
   * This function is called when a message was received from another domain
   * using the `postMessage` API.  Check that the event came from the Duo
   * service domain, and that the message is a properly formatted payload,
   * then perform the post back to the primary service.
   *
   * @param event Event object (contains origin and data)
   */


  function onReceivedMessage(event) {
    if (isDuoMessage(event)) {
      if (event.data.match(DUO_OPEN_WINDOW_FORMAT)) {
        var url = event.data.substring("DUO_OPEN_WINDOW|".length);

        if (isValidUrlToOpen(url)) {
          // Open the URL that comes after the DUO_WINDOW_OPEN token.
          window.open(url, "_self");
        }
      } else {
        // the event came from duo, do the post back
        doPostBack(event.data); // always clean up after yourself!

        offMessage(onReceivedMessage);
      }
    }
  }
  /**
   * Validate that this passed in URL is one that we will actually allow to
   * be opened.
   * @param url String URL that the message poster wants to open
   * @returns {boolean} true if we allow this url to be opened in the window
   */


  function isValidUrlToOpen(url) {
    if (!url) {
      return false;
    }

    var parser = document.createElement("a");
    parser.href = url;

    if (parser.protocol === "duotrustedendpoints:") {
      return true;
    } else if (parser.protocol !== "https:") {
      return false;
    }

    for (var i = 0; i < VALID_OPEN_WINDOW_DOMAINS.length; i++) {
      if (parser.hostname.endsWith("." + VALID_OPEN_WINDOW_DOMAINS[i]) || parser.hostname === VALID_OPEN_WINDOW_DOMAINS[i]) {
        return true;
      }
    }

    return false;
  }
  /**
   * Point the iframe at Duo, then wait for it to postMessage back to us.
   */


  function ready() {
    if (!host) {
      host = getDataAttribute(iframe, "host");

      if (!host) {
        throwError("No API hostname is given for Duo to use.  Be sure to pass " + "a `host` parameter to Duo.init, or through the `data-host` " + "attribute on the iframe element.", "https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe");
      }
    }

    if (!duoSig || !appSig) {
      parseSigRequest(getDataAttribute(iframe, "sigRequest"));

      if (!duoSig || !appSig) {
        throwError("No valid signed request is given.  Be sure to give the " + "`sig_request` parameter to Duo.init, or use the " + "`data-sig-request` attribute on the iframe element.", "https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe");
      }
    } // if postAction/Argument are defaults, see if they are specified
    // as data attributes on the iframe


    if (postAction === "") {
      postAction = getDataAttribute(iframe, "postAction") || postAction;
    }

    if (postArgument === "sig_response") {
      postArgument = getDataAttribute(iframe, "postArgument") || postArgument;
    } // point the iframe at Duo


    iframe.src = ["https://", host, "/frame/web/v1/auth?tx=", duoSig, "&parent=", encodeURIComponent(document.location.href), "&v=2.6"].join(""); // listen for the 'message' event

    onMessage(onReceivedMessage);
  }
  /**
   * We received a postMessage from Duo.  POST back to the primary service
   * with the response token, and any additional user-supplied parameters
   * given in form#duo_form.
   */


  function doPostBack(response) {
    // create a hidden input to contain the response token
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = postArgument;
    input.value = response + ":" + appSig; // user may supply their own form with additional inputs

    var form = document.getElementById("duo_form"); // if the form doesn't exist, create one

    if (!form) {
      form = document.createElement("form"); // insert the new form after the iframe

      iframe.parentElement.insertBefore(form, iframe.nextSibling);
    } // make sure we are actually posting to the right place


    form.method = "POST";
    form.action = postAction; // add the response token input to the form

    form.appendChild(input); // away we go!

    if (typeof submitCallback === "function") {
      submitCallback.call(null, form);
    } else {
      form.submit();
    }
  }

  return {
    init: init,
    _onReady: onReady,
    _parseSigRequest: parseSigRequest,
    _isDuoMessage: isDuoMessage,
    _doPostBack: doPostBack
  };
}

function _templateObject$W() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 400px;\n  width: 100%;\n  border: 0;\n  display: block;\n  padding: 8px;\n  box-sizing: border-box;\n"]);

  _templateObject$W = function _templateObject() {
    return data;
  };

  return data;
}
var StyledIFrame = styled.iframe(_templateObject$W());

var DuoFrame = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(DuoFrame, _React$Component);

  function DuoFrame() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          host = _this$props.host,
          sigRequest = _this$props.sigRequest;
      Duo().init({
        host: host,
        sig_request: sigRequest,
        submit_callback: _this.handleDuoResponse
      });
    };

    _this.handleDuoResponse = function (duoForm) {
      var callback = _this.props.callback; // read signedResponse from Duo form

      var sigResponse = duoForm.firstChild.value;
      return callback(sigResponse);
    };

    _this.render = function () {
      return /*#__PURE__*/React$1.createElement(StyledIFrame, {
        id: "duo_iframe",
        title: "Duo 2FA"
      });
    };

    return _this;
  }

  return DuoFrame;
}(React$1.Component);

DuoFrame.displayName = "DuoFrame";
DuoFrame.propTypes = {
  host: PropTypes$1.string.isRequired,
  sigRequest: PropTypes$1.string.isRequired,
  callback: PropTypes$1.func
};
DuoFrame.defaultProps = {
  callback: function callback() {}
};

var RegisterVipAccess = function RegisterVipAccess(_ref) {
  var onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React$1.createElement(RegisterWithCredentialIdAndTwoOtps, {
    onSubmit: onSubmit,
    credentialIdText: /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "2758306961",
      defaultMessage: "Credential ID"
    }),
    otp1Label: /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "694920552",
      defaultMessage: "First Security Code"
    }),
    otp2Label: /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "2942752129",
      defaultMessage: "Second Security Code"
    })
  }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "26286820",
    defaultMessage: "Enter Credential ID and two consecutive Security Codes from Symantec VIP Access."
  })));
};

RegisterVipAccess.displayName = "RegisterVipAccess";
RegisterVipAccess.propTypes = {
  onSubmit: PropTypes$1.func.isRequired
};

var RegisterSecureId = function RegisterSecureId(_ref) {
  var onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React$1.createElement(MultiValueForm, {
    fieldNames: ["username", "securityCode"],
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var username = _ref2.username,
          securityCode = _ref2.securityCode;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "register-secure-id-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "2124363772",
        defaultMessage: "Enter your username and security code from your SecurID token."
      }))), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "username"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "2663586870",
        defaultMessage: "Username"
      })), /*#__PURE__*/React$1.createElement(Input, {
        id: "username",
        value: username.value,
        onChange: function onChange(event) {
          return username.onChange(event.target.value);
        },
        invalid: username.invalid,
        size: "large"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "security-code"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "1654624862",
        defaultMessage: "Security Code"
      })), /*#__PURE__*/React$1.createElement(PasswordInput, {
        "data-testid": "security-code",
        id: "security-code",
        onChange: function onChange(event) {
          return securityCode.onChange(event.target.value);
        },
        value: securityCode.value,
        invalid: securityCode.invalid,
        size: "large"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        type: "submit",
        look: "primary"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

RegisterSecureId.displayName = "RegisterSecureId";
RegisterSecureId.propTypes = {
  onSubmit: PropTypes$1.func.isRequired
};

var LoginProvideAnswer = function LoginProvideAnswer(_ref) {
  var question = _ref.question,
      onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React$1.createElement(SingleValueForm, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "provide-answer-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "secure-answer"
      }, question), /*#__PURE__*/React$1.createElement(PasswordInput, {
        id: "secure-answer",
        value: value,
        onChange: function onChange(event) {
          return _onChange(event.target.value);
        },
        autoFocus: true,
        invalid: invalid,
        size: "large"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        type: "submit",
        look: "primary"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

LoginProvideAnswer.displayName = "LoginProvideAnswer";
LoginProvideAnswer.propTypes = {
  question: PropTypes$1.string.isRequired,
  onSubmit: PropTypes$1.func.isRequired
};

function _templateObject$V() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: 400px;\n"]);

  _templateObject$V = function _templateObject() {
    return data;
  };

  return data;
}
var ScrollableContent = styled.div(_templateObject$V());
ScrollableContent.displayName = "ScrollableContent";

var SelectQuestion = function SelectQuestion(_ref) {
  var onSelect = _ref.onSelect,
      questions = _ref.questions;
  return /*#__PURE__*/React$1.createElement(ScrollableContent, {
    "data-testid": "select-question-screen"
  }, keys(questions).map(function (key) {
    return /*#__PURE__*/React$1.createElement(ListItem, {
      key: key,
      text: questions[key],
      onClick: function onClick() {
        return onSelect(key);
      }
    });
  }));
};

SelectQuestion.displayName = "SelectQuestion";
SelectQuestion.propTypes = {
  questions: PropTypes$1.object.isRequired,
  onSelect: PropTypes$1.func.isRequired
};

function _templateObject$U() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 22px;\n  padding: 16px 24px;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject$U = function _templateObject() {
    return data;
  };

  return data;
}
var SubTitle = styled.div(_templateObject$U(), COLORS.TEXT_COLORS.TITLE, COLORS.SEPARATOR_COLORS.MEDIUM);

var AnswerSecurityQuestions = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(AnswerSecurityQuestions, _Component);

  function AnswerSecurityQuestions(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onSelectQuestion = function (id) {
      _this.setState({
        current: id,
        remaining: _this.state.remaining.filter(function (current) {
          return current !== id;
        }),
        showSelector: false
      });
    };

    _this.getSubmitAnswer = function (questionId) {
      return function (answer) {
        _this.answers[questionId] = answer;

        if (keys(_this.answers).length === _this.props.requiredAnwersCount || isEmpty(_this.state.remaining)) {
          _this.props.onComplete(_this.answers);
        } else {
          if (_this.letUserPickAnswers) {
            _this.setState({
              showSelector: true
            });
          } else {
            var _this$state$remaining = _this.state.remaining,
                current = _this$state$remaining[0],
                remaining = _this$state$remaining.slice(1);

            _this.setState({
              current: current,
              remaining: remaining
            });
          }
        }
      };
    };

    _this.render = function () {
      var _this$state = _this.state,
          current = _this$state.current,
          questions = _this$state.questions,
          remaining = _this$state.remaining,
          showSelector = _this$state.showSelector;
      var totalQuestions = keys(questions);

      if (showSelector) {
        return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement(SubTitle, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
          id: "4151518079",
          defaultMessage: "Select Security Question {current} / {total}",
          values: {
            current: totalQuestions.length - remaining.length + 1,
            total: _this.props.requiredAnwersCount || totalQuestions.length
          }
        })), /*#__PURE__*/React$1.createElement(SelectQuestion, {
          questions: pickBy(function (val, id) {
            return remaining.includes(id);
          }, questions),
          onSelect: _this.onSelectQuestion
        }));
      } else {
        return (
          /*#__PURE__*/
          // key is used here in quite hacky way (it ensures that the same LoginProvideAnswer is not reused)
          React$1.createElement(LoginProvideAnswer, {
            key: current,
            question: questions[current],
            onSubmit: _this.getSubmitAnswer(current)
          })
        );
      }
    };

    _this.letUserPickAnswers = !isNil(props.requiredAnwersCount) && props.requiredAnwersCount < keys(props.questions).length;

    if (_this.letUserPickAnswers) {
      _this.state = {
        showSelector: true,
        remaining: keys(props.questions),
        questions: props.questions
      };
    } else {
      var _keys = keys(props.questions),
          current = _keys[0],
          remaining = _keys.slice(1);

      _this.state = {
        current: current,
        remaining: remaining,
        questions: props.questions
      };
    }

    _this.answers = {};
    return _this;
  }

  return AnswerSecurityQuestions;
}(Component);

AnswerSecurityQuestions.propTypes = {
  questions: PropTypes$1.object.isRequired,
  requiredAnwersCount: PropTypes$1.number,
  onComplete: PropTypes$1.func.isRequired
};

var callingGif = "data:image/gif;base64,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";

function _templateObject$T() {
  var data = _taggedTemplateLiteralLoose(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"]);

  _templateObject$T = function _templateObject() {
    return data;
  };

  return data;
}
var fadeIn = keyframes(_templateObject$T());

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 140px;\n  height: 24px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  text-align: center;\n  margin-top: 12px;\n  line-height: 16px;\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject6$6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$8() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"]);

  _templateObject5$8 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$i() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: 16px;\n  padding-bottom: 16px;\n"]);

  _templateObject3$i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$w() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-width: 1px;\n  border-color: ", ";\n  font-size: 28px;\n  line-height: 1;\n  letter-spacing: 8px;\n  transition: border-color 0.2s;\n  height: 60px;\n  margin-top: 8px;\n"]);

  _templateObject2$w = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$S() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: ", " 0.3s ease-in-out;\n"]);

  _templateObject$S = function _templateObject() {
    return data;
  };

  return data;
}
var messages$5 = defineMessages({
  calling: {
    "id": "calling",
    defaultMessage: "Calling"
  }
});
var FadeInButton$1 = styled(Button$1)(_templateObject$S(), fadeIn);
var StyledBlock = styled.div(_templateObject2$w(), COLORS.GRAY_COLORS.GRAY_96, function (props) {
  return props.copied ? COLORS.STATUS_COLORS.SUCCESS : "transparent";
});
var StyledCode = styled.div(_templateObject3$i());
var PhoneNumber = styled(StyledTextField)(_templateObject4$a());
var Centered = styled.div(_templateObject5$8());
var CenteredFlex = styled(Centered)(_templateObject6$6());
var CenteredSmallTextField$1 = styled(StyledTextField)(_templateObject7$2());
var EmptyCenteredSmallTextField$1 = styled(CenteredSmallTextField$1)(_templateObject8$2());
var CallingGif = styled.img(_templateObject9$1());
var GifButton$1 = styled.div(_templateObject10$1());
var DEFAULT_SECONDS$1 = 30;

var getInitialState$1 = function getInitialState() {
  return {
    secLeft: DEFAULT_SECONDS$1
  };
};

var ShowPinCode = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(ShowPinCode, _Component);

  function ShowPinCode(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.componentDidMount = function () {
      _this.timer = setInterval(_this.countdown, 1000);
    };

    _this.componentWillUnmount = function () {
      clearInterval(_this.timer);
    };

    _this.countdown = function () {
      var seconds = _this.state.secLeft;

      if (seconds === 0) {
        clearInterval(_this.timer);
      } else {
        _this.setState({
          secLeft: seconds - 1
        });
      }
    };

    _this.resetTimer = function () {
      _this.setState({
        secLeft: DEFAULT_SECONDS$1
      });
    };

    _this.renderButton = function () {
      if (_this.state.secLeft === 0) {
        return /*#__PURE__*/React$1.createElement(FadeInButton$1, {
          "data-testid": "try-again-button",
          size: "large",
          look: "regular",
          onClick: function onClick() {
            _this.props.onTryAgain();

            _this.resetTimer();
          }
        }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
          id: "2018264248",
          defaultMessage: "Try Again"
        }));
      } else {
        return /*#__PURE__*/React$1.createElement(GifButton$1, null, /*#__PURE__*/React$1.createElement(CallingGif, {
          alt: _this.props.intl.formatMessage(messages$5.calling),
          src: callingGif
        }), /*#__PURE__*/React$1.createElement(Button$1, {
          "data-testid": "calling-button",
          size: "large",
          look: "regular",
          disabled: true
        }));
      }
    };

    _this.renderRemainingSecs = function () {
      if (_this.state.secLeft > 0) {
        return /*#__PURE__*/React$1.createElement(CenteredSmallTextField$1, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
          id: "374233718",
          defaultMessage: "You can try again in {secLeft, number} {secLeft, plural,\n                        one {second}\n                        other {seconds}\n                      }",
          values: {
            secLeft: _this.state.secLeft
          }
        }));
      } else {
        return /*#__PURE__*/React$1.createElement(EmptyCenteredSmallTextField$1, null);
      }
    };

    _this.render = function () {
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "show-pincode-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "4000449233",
        defaultMessage: "Calling the below phone number:"
      }), /*#__PURE__*/React$1.createElement(PhoneNumber, {
        large: true
      }, " ", _this.props.phoneNumber)), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3645116517",
        defaultMessage: "Enter this code when receiving the call:"
      }), /*#__PURE__*/React$1.createElement(CenteredFlex, null, /*#__PURE__*/React$1.createElement(StyledBlock, null, /*#__PURE__*/React$1.createElement(StyledCode, null, _this.props.verificationToken)))), /*#__PURE__*/React$1.createElement(ContentBlock, null, _this.renderButton(), _this.renderRemainingSecs()));
    };

    _this.state = getInitialState$1();
    return _this;
  }

  return ShowPinCode;
}(Component);

ShowPinCode.displayName = "ShowPinCode";
ShowPinCode.propTypes = {
  onTryAgain: PropTypes$1.func.isRequired,
  verificationToken: PropTypes$1.string.isRequired,
  phoneNumber: PropTypes$1.string.isRequired
};
var ShowPinCode$1 = injectIntl(ShowPinCode);

function _templateObject$R() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"]);

  _templateObject$R = function _templateObject() {
    return data;
  };

  return data;
}
var HorizontalCenter$1 = styled(DescriptionText)(_templateObject$R());

var CancelAuthentication = function CancelAuthentication(_ref) {
  var onRetry = _ref.onRetry;
  return /*#__PURE__*/React$1.createElement(Content$3, {
    "data-testid": "cancelled-webauthn-screen"
  }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(HorizontalCenter$1, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "1136625613",
    defaultMessage: "The process was cancelled. Please try again or use another authentication factor."
  })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
    size: "large",
    look: "regular",
    onClick: onRetry
  }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "2018264248",
    defaultMessage: "Try Again"
  })))));
};

CancelAuthentication.displayName = "CancelAuthentication";
CancelAuthentication.propTypes = {
  onRetry: PropTypes$1.func.isRequired
};

function _templateObject2$v() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 15px;\n"]);

  _templateObject2$v = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Q() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"]);

  _templateObject$Q = function _templateObject() {
    return data;
  };

  return data;
}
var ICON_IMAGE_SIZE$1 = "32px";
var TextWrapper = styled.div(_templateObject$Q());
var IconPadding = styled.div(_templateObject2$v());
function UnsupportedBrowser() {
  return /*#__PURE__*/React$1.createElement(Content$3, {
    "data-testid": "unsupported-webauthn-screen"
  }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(TextWrapper, null, /*#__PURE__*/React$1.createElement(IconPadding, null, /*#__PURE__*/React$1.createElement(Icon$2, {
    icon: "Warning-24",
    size: ICON_IMAGE_SIZE$1
  })), /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "3781468762",
    defaultMessage: "Your browser doesn't support WebAuthn"
  }))));
}

function _templateObject$P() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"]);

  _templateObject$P = function _templateObject() {
    return data;
  };

  return data;
}
var HorizontalCenter = styled(DescriptionText)(_templateObject$P());

var WebAuthn = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(WebAuthn, _Component);

  function WebAuthn() {
    var _this;

    _this = _Component.call(this) || this;

    _this.callAuthenticateUser = function () {
      _this.props.authenticateUser()["catch"](function () {
        _this.setState({
          error: true
        });
      });
    };

    _this.handleRetry = function () {
      _this.setState({
        error: false
      }, _this.callAuthenticateUser);
    };

    _this.state = {
      error: false
    };
    return _this;
  }

  var _proto = WebAuthn.prototype;

  _proto.browserSupported = function browserSupported() {
    return navigator.credentials && navigator.credentials.create;
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.browserSupported()) {
      this.callAuthenticateUser();
    }
  };

  _proto.render = function render() {
    if (!this.browserSupported()) {
      return /*#__PURE__*/React$1.createElement(UnsupportedBrowser, null);
    } else if (this.props.loading) {
      return /*#__PURE__*/React$1.createElement(LoginLoading, null);
    } else if (this.state.error) {
      return /*#__PURE__*/React$1.createElement(CancelAuthentication, {
        onRetry: this.handleRetry
      });
    }

    return /*#__PURE__*/React$1.createElement(Content$3, {
      "data-testid": "webauthn-screen"
    }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(HorizontalCenter, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "437305782",
      defaultMessage: "Verifying your WebAuthn authenticators now."
    }))));
  };

  return WebAuthn;
}(Component);

var sendingMailGif = "data:image/gif;base64,R0lGODlhGAEwAPcAAAAAAACp4AB3ngBefRkZGcHCxQBFXMzMz1dZYe7u797f4CwuOR8iLe3u7omKkZyeomRnbjI1P2xudVRXXz1BSbOzs7S0tFHE6RgYGHZ4f1FRUVGivCcpNVGRplJVXPf39/T09TE0Pvr6+jAzPbi5vebm5yYpM36AhlGAjzM2P3V3fiAjLhCu4tXv+BsbGw6u4g4ODqChphB/pFFTXHh6gCcrNRAQENXo7tXV1VZYYQ5+oxBohQ5nhNXk6dfY2R8iLH5/hb2+weLi4y0vOqGipjU4QsTFxzs9RyksNuzs7W9xeCMmMVNWXkZJUurr7K+wtEBDTPv7+7a3ulpdZBBQZpOUmTc6RB0gK6iprUNFTpudoW1vdvj5+cbHyqmrr09RWtzd3np8gg5PZYWGjLe4vPHy8tXg5IyNk0xPV9fw+NTv+Ayt4Q2t4dfX19TU1AwMDA0NDQ1+o9Tn7Qx9otfp7tTj6A1mg9fl6gxlg4KEipydol1gZ4iKjy4wOgxOZNfh5ZWXnCUoM1VYYCwvOUdKUtTf4/Hx8nR1fA1OZCsuOJSWm4eJjhwfKvz8/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDQ2MCwgMjAyMC8wNS8xMi0xNjowNDoxNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjODBlNGYwOC0xZWYyLTQ2YTItYmM5MC0wNzBmZjdmZTY0MmUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTAxODQ4N0VEQTdCMTFFQUI4QzI5NjQzRDJDMDEyQzgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTAxODQ4N0REQTdCMTFFQUI4QzI5NjQzRDJDMDEyQzgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxMDEzOGQxNy03YTA5LTRiNzAtYWIwYS0yNjFmNmUxYjc2YmUiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDpmMDljZWVmNS0wYTk2LWVjNGEtODIwYS1kYzVlMmEyZjJmOWMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQEGQAAACwAAAAAGAEwAAAI/wAbCRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDRjzgQMIEChxqUJggwcEBkTBjypxJs6bBAhkiMNrJs+fOCBkK2BxKtKhRowc8+FzK1MPLo1CjSp36UAEEpliZQlBAtavXr0QLLMhK1ucCoWDTql2L8QGDsnB5MnjAtq7duwdPxN3L8wTev4DBPuBLmBHdwIjtkhhRuDHPESQQFnjrGC4DtIkzg01RuXKKgwrGdoa7gKvm01RHVz54VTVcCKhjR3Xd2OAB2nGfyt5tEzdhg0p9k/XAuzhN4XsLFkBeFrPx5x+nMCc7paCK6VkzQN/+sQsT7D2ZdP8xqDNungTo0ydIQohwBO7wOxr5gv2LkYO398ZAiKCw7vgASuQDQUGgIRwaQRA04EAO8LXfQf0R5kCAFEZ0xRZgEERGE641QQZBYGxxBUESOMhfYRJUqGJDO/2ghGmNRCFFFpVlIUUUAymgxA87ETQBX3qcSNgEKxaZUE8rZCDEQCI8AQVhUDwhwkBCZLBCTwRRwFcfOXRpCEER8kWBRRYQQIAFFJV5ZppmojmRmm5KBCeba77ZJkVLrRBGCUx6cQRcR3gxpUAlhHGlTwRx4FgDYBbGgUUEAAAAARRFOmmlklI6kaWaSsQpppdumimeTC0BBJ8CcYGFFVhZgQUXA5X/AMQSWBFUw6KNElYDpJJiAKqvogIArKe9/mpssMNGRJYJYzgx0AdEFNFTEUR8MJATY5hAVpa4DhTmXmNWVAEGLlRA0bjlnkuuuROhy65E7qqbbrvrkrosHwk8q0UIIWhhrUAJLKJtWT52K9C3cRFp5MIE7YXEGfkKBAIIAyVwBhLJDVRiY4x6iyLDIDdC2CBVlEFQGVUk8huDBjeCMFwThrxwY0MAMrEiQ9Q2UH6FdXywfzLP7Bi/qxFUHmE+u+xe0EKDx5R1jSVBkCCEacd0kU7XStByhe1Bw9eHBEKYc1dTmPXTBc1w9k7Elb3i2ogWxHPW/7kdINxYGtSa07DZbq0i3jyBJhp2pfn9N+CMSEYZc5cZriJneH+G0GDTHeY4hYvBDZlCeiHn1+Wgh+QWbnOFbjpIYrl21umse2TVaFu1LntHB6hd2Ax1z647RgWocHRWEahA9u7EZ0SSSShxsFJLuRfv/PPQRy/9bgEBACH5BAQZAAAALEIAFAAIAAgAAAgxABulufDixYU0jVqwCMAwAIsWFxo2JCiR4ZoXFQOsiVjxgpqFDVmoSXiBDZsLLRoFBAAh+QQEGQAAACxCABQAIAAIAAAIcwAb0dmgQ8cGOo0SKlzIUGGaCy9eXEjT6IYMARgFyLjRsKPCFiwCiAzAosWGjBk3ePR4YeTICzpQYpyzsuMLlyLXxJRJsybDmzjXnJSp0ufCljgvyLmYUYYcowvVhBzJQk3FDXHibOAIdWGLC2zYXGjRKCAAIfkEBBkAAAAsQgAUADgACAAACKoAG93pwINHhzuNEipcyFAhnQ06dGyg07AiwzQXXry4kKZRjx0DQg7Y0cOixRsyBKgUIOOGyYotWASYGYBFiw4iRXZ42XDDypUbeDK8QJPmBR45Q+IRulDHT5VzmCp8UXTmGqRJl0pt5PRp1K1Uq67BmXTnVp9Pg24lWvVCHZAid9TZ2khOypUy5NBVI5MmCzUeO9ix06Ek3UY3NsSJs8Hl4RYX2LC50KJRQAAh+QQEGQAAACxCABQAUAAIAAAI3gAb/UEhRgyKP40SKlzIUOGdDjx4dLjTsCJDOht06NhAx6LHRmkuvHhxIU0jM1QMqDRAxczHhj12DJg5YEePlwxvyBDAU4CMGzgXtmARoGgAFi1QrFyJIqjCDjRpdnCacEPPnhuoNrpg1OgFMUtV+tHKI+pMPFp1XOU5R+uLrkXXgA07lmpZs2ipql3blupbuGuUhm1KFarZqVStrs1KlSvcC4VSrqRSSGsdmTR31NEqZ2dPGXK0qiFqlIWakygQIULhUmujHh3s2Olw0/WNDXHibADqusUFNmwutGgUEAAh+QQEGQAAACxCABQAaAAIAAAI/wAbtdEAA4aGNo0SKlzIUOEfFGLEoPjTsCLDOx148Ohwx6LHRnQ26NCxgc5Hi2kuvHhxIU0jHDYAyARgA8dJhmaoGNhpgIqZmwt77BhAdMCOHkAV3pAhoKkAGTeSJmzBIoDVACxaaJg5U4PURih48kTxtUPRoh2+bnDqdMPXC1evXoDBVeabr2LE7vTzlcdZoni+6mDbdM7XF3GtrqFb967UvHr5SvX7N7DUwYQNS0WceM3Wul6lhtVLVqrZv2mlriXsVircxBfcxJxpw83XQjp5Uin0tc7QojvqfJXD1KkMOV/VVL3KQs1LDXDgaLD5tZEZFIgQofhZvUcHO3Y6IBOtfmNDnDgbolZvcYENmwstGgUEACH5BAQZAAAALFoAFABoAAgAAAj/ABu10QADhoY2jRIqXMhQ4R8UYsSg+NOwIsM7HXjw6HDHosdGdDbo0LGBzkeLaS68eHEhTSMcNgDIBGADx0mGZqgY2GmAipmbC3vsGEB0wI4eQBXekCGgqQAZN5ImbMEigNUALFpomDlTg9RGKHjyRPG1Q9GiHb5ucOp0w9cLV69egMFV5puvYsTu9POVx1mieL7qYNt0ztcXca2uoVv3rtS8evlK9fs3sNTBhA1LRZx4zda6XqWG1UtWqtm/aaWuJexWKtzEF9zEnGnDzddCOnlSKfS1ztCiO+p8lcPUqQw5X9VUvcpCzUsNcOBosPm1kRkUiBCh+Fm9Rwc7djogE61+Y0OcOBuiVm9xgQ2bCy0aBQQAIfkEBBkAAAAscgAUAGgACAAACP8AG7XRAAOGhjaNEipcyFDhHxRixKD407AiwzsdePDocMeix0Z0NujQsYHOR4tpLrx4cSFNIxw2AMgEYAPHSYZmqBjYaYCKmZsLe+wYQHTAjh5AFd6QIaCpABk3kiZswSKA1QAsWmiYOVOD1EYoePJE8bVD0aIdvm5w6nTD1wtXr16AwVXmm69ixO7085XHWaJ4vupg23TO1xdxra6hW/eu1Lx6+Ur1+zew1MGEDUtFnHjN1rpepYbVS1aq2b9ppa4l7FYq3MQX3MScacPN10I6eVIp9LXO0KI76nyVw9SpDDlf1VS9ykLNSw1w4Giw+bWRGRSIEKH4Wb1HBzt2OiATrX5jQ5w4G6JWb3GBDZsLLRoFBAA7";

function _templateObject5$7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$9() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 140px;\n  height: 24px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$u() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  text-align: center;\n  margin-top: 12px;\n  line-height: 16px;\n"]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$O() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: ", " 0.3s ease-in-out;\n"]);

  _templateObject$O = function _templateObject() {
    return data;
  };

  return data;
}
var messages$4 = defineMessages({
  sending: {
    "id": "sending",
    defaultMessage: "Sending"
  }
});
var FadeInButton = styled(Button$1)(_templateObject$O(), fadeIn);
var CenteredSmallTextField = styled(StyledTextField)(_templateObject2$u());
var EmptyCenteredSmallTextField = styled(CenteredSmallTextField)(_templateObject3$h());
var SendingMailGif = styled.img(_templateObject4$9());
var GifButton = styled.div(_templateObject5$7());
var DEFAULT_SECONDS = 120;

var getInitialState = function getInitialState() {
  return {
    secLeft: DEFAULT_SECONDS
  };
};

var WaitForEmail = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(WaitForEmail, _Component);

  function WaitForEmail(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.componentDidMount = function () {
      _this.timer = setInterval(_this.countdown, 1000);
    };

    _this.componentWillUnmount = function () {
      clearInterval(_this.timer);
    };

    _this.countdown = function () {
      var seconds = _this.state.secLeft;

      if (seconds === 0) {
        clearInterval(_this.timer);
      } else {
        _this.setState({
          secLeft: seconds - 1
        });
      }
    };

    _this.resetTimer = function () {
      _this.setState(getInitialState());
    };

    _this.renderButton = function () {
      if (_this.state.secLeft === 0) {
        return /*#__PURE__*/React$1.createElement(FadeInButton, {
          "data-testid": "try-again-button",
          size: "large",
          look: "regular",
          onClick: function onClick() {
            _this.props.onTryAgain();

            _this.resetTimer();
          }
        }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
          id: "2018264248",
          defaultMessage: "Try Again"
        }));
      } else {
        return /*#__PURE__*/React$1.createElement(GifButton, null, /*#__PURE__*/React$1.createElement(SendingMailGif, {
          alt: _this.props.intl.formatMessage(messages$4.sending),
          src: sendingMailGif
        }), /*#__PURE__*/React$1.createElement(Button$1, {
          "data-testid": "sending-button",
          size: "large",
          look: "regular",
          disabled: true
        }));
      }
    };

    _this.renderRemainingSecs = function () {
      if (_this.state.secLeft > 0) {
        return /*#__PURE__*/React$1.createElement(CenteredSmallTextField, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
          id: "374233718",
          defaultMessage: "You can try again in {secLeft, number} {secLeft, plural,\n                        one {second}\n                        other {seconds}\n                      }",
          values: {
            secLeft: _this.state.secLeft
          }
        }));
      } else {
        return /*#__PURE__*/React$1.createElement(EmptyCenteredSmallTextField, null);
      }
    };

    _this.render = function () {
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "show-email-screen"
      }, _this.props.email ? /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "email"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3669652728",
        defaultMessage: "An access link was sent to"
      })), /*#__PURE__*/React$1.createElement(StyledTextField, {
        large: true
      }, _this.props.email)) : /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "2584272257",
        defaultMessage: "An access link was sent to your email"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "987359842",
        defaultMessage: "Please click the link on your email to continue"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, _this.renderButton(), _this.renderRemainingSecs()));
    };

    _this.state = getInitialState();
    return _this;
  }

  return WaitForEmail;
}(Component);

WaitForEmail.displayName = "WaitForEmail";
WaitForEmail.propTypes = {
  onTryAgain: PropTypes$1.func.isRequired,
  email: PropTypes$1.string
};
var WaitForEmail$1 = injectIntl(WaitForEmail);

// RFC 2822 Regex taken from here https://gist.github.com/gregseth/5582254
var isValidEmail = function isValidEmail(email) {
  return !!String(email).toLowerCase().match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
};

var EnterEmail = function EnterEmail(_ref) {
  var onSubmitEmail = _ref.onSubmitEmail,
      email = _ref.email;
  return /*#__PURE__*/React$1.createElement(SingleValueForm, {
    onSubmit: onSubmitEmail,
    validateFn: isValidEmail,
    value: email,
    render: function render(_ref2) {
      var invalid = _ref2.invalid,
          value = _ref2.value,
          _onChange = _ref2.onChange;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "enter-email-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "enter-email"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "1232460711",
        defaultMessage: "Enter your email"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Input, {
        id: "enter-email",
        onChange: function onChange(event) {
          return _onChange(event.target.value);
        },
        value: value,
        invalid: invalid
      }))), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        type: "submit",
        look: "primary"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

EnterEmail.displayName = "EnterEmail";
EnterEmail.propTypes = {
  onSubmitEmail: PropTypes$1.func.isRequired,
  email: PropTypes$1.string
};

var RegisterOath = function RegisterOath(_ref) {
  var onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React$1.createElement(MultiValueForm, {
    fieldNames: ["serialNumber", "securityCode"],
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var serialNumber = _ref2.serialNumber,
          securityCode = _ref2.securityCode;
      return /*#__PURE__*/React$1.createElement(Content$3, {
        "data-testid": "register-oath-screen"
      }, /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "serial-number"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3061679461",
        defaultMessage: "Enter the serial number printed on the back of your device"
      })), /*#__PURE__*/React$1.createElement(Input, {
        id: "serial-number",
        value: serialNumber.value,
        onChange: function onChange(event) {
          return serialNumber.onChange(event.target.value);
        },
        invalid: serialNumber.invalid,
        autoFocus: true,
        size: "large",
        type: "text"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Label$1, {
        forId: "security-code"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "39019345",
        defaultMessage: "Press the button on your device and enter the displayed OTP code"
      })), /*#__PURE__*/React$1.createElement(PasswordInput, {
        "data-testid": "security-code",
        id: "security-code",
        value: securityCode.value,
        onChange: function onChange(event) {
          return securityCode.onChange(event.target.value);
        },
        invalid: securityCode.invalid,
        size: "large",
        type: "text"
      })), /*#__PURE__*/React$1.createElement(ContentBlock, null, /*#__PURE__*/React$1.createElement(Button$1, {
        size: "large",
        type: "submit",
        look: "primary"
      }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
        id: "3640052215",
        defaultMessage: "Continue"
      }))));
    }
  });
};

RegisterOath.displayName = "RegisterOath";
RegisterOath.propTypes = {
  onSubmit: PropTypes$1.func.isRequired
};

function _templateObject2$t() {
  var data = _taggedTemplateLiteralLoose(["\n      border-radius: 0;\n      width: 100%;\n    "]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$N() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n  visibility: hidden;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 0 0 3px 3px;\n  color: #ffffff;\n  text-align: center;\n\n  padding: 16px;\n  position: absolute;\n  font-size: 16px;\n  min-height: ", "px;\n  line-height: 1;\n\n  box-sizing: border-box;\n  z-index: 1;\n  transition: top 0.5s;\n\n  background-color: ", ";\n  border-color: ", ";\n  visibility: ", ";\n  top: ", ";\n\n  ", ";\n"]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}
var NOTIFICATION_MIN_HEIGHT = 50;

var typeToColor = function typeToColor(type) {
  switch (type) {
    case "success":
      return COLORS.STATUS_COLORS.SUCCESS;

    case "error":
      return COLORS.STATUS_COLORS.ERROR;

    default:
      return COLORS.STATUS_COLORS.INFO;
  }
}; // "invisible" => top=-height, visibility=hidden
// "showing" => top=0, visibility=visible
// "hiding" => top=-height;  visibility=visible


var computeTop = function computeTop(status, height) {
  var top = status === "showing" ? 0 : "-" + height;
  return top + "px";
};

var Notification = styled.div(_templateObject$N(), NOTIFICATION_MIN_HEIGHT, function (props) {
  return typeToColor(props.type);
}, function (props) {
  return typeToColor(props.type);
}, function (props) {
  return props.status === "invisible" ? "hidden" : "visible";
}, function (props) {
  return computeTop(props.status, props.height);
}, function (props) {
  return props.fluid && css(_templateObject2$t());
});

var NotificationItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(NotificationItem, _React$Component);

  function NotificationItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.notificationRef = React$1.createRef();
    _this.state = {
      height: NOTIFICATION_MIN_HEIGHT
    };
    return _this;
  }

  var _proto = NotificationItem.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$notificationRef = this.notificationRef.current.getBoundingClientRect(),
        height = _this$notificationRef.height;

    this.setState({
      height: height
    });
  };

  _proto.render = function render() {
    return /*#__PURE__*/React$1.createElement(Notification, _extends$2({}, this.props, {
      ref: this.notificationRef,
      height: this.state.height
    }));
  };

  return NotificationItem;
}(React$1.Component);

NotificationItem.defaultProps = {
  type: "info",
  status: "invisible",
  fluid: true
};
NotificationItem.propTypes = {
  status: PropTypes$1.oneOf(["invisible", "showing", "hiding"]),
  type: PropTypes$1.oneOf(["error", "success", "info"]),
  fluid: PropTypes$1.bool
};

var CSS_HIDE_ANIMATION_TIME = 600; // this must be equal or higher then transition time of hidding animation

var DEFAULT_DISMISS_DELAY = 2000;

var Notifications = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(Notifications, _Component);

  function Notifications(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      notification: null,
      status: "invisible"
    };
    return _this;
  }

  var _proto = Notifications.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.showNext(this.props);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.showingTimeout);
    clearTimeout(this.hiddingTimeout);
    clearTimeout(this.removeTimeout);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.notifications && this.props.notifications.length) {
      this.showNext(this.props);
    }
  };

  _proto.showNext = function showNext(props) {
    var _this2 = this;

    var notification = props.notifications && props.notifications.length ? props.notifications[0] : null;

    if (!this.state.notification && notification) {
      this.setState({
        notification: notification,
        status: "invisible"
      });
      this.showingTimeout = setTimeout(function () {
        _this2.setState({
          status: "showing"
        });
      }, 0);
      this.planHide(notification);
      props.clearDisplayedNotification(notification.id);
    }
  };

  _proto.planHide = function planHide(notification) {
    var _this3 = this;

    this.hiddingTimeout = setTimeout(function () {
      _this3.setState({
        status: "hiding"
      });

      _this3.removeTimeout = setTimeout(function () {
        _this3.setState({
          notification: null
        });

        _this3.showNext(_this3.props);
      }, CSS_HIDE_ANIMATION_TIME);
    }, notification.dismissDelay || DEFAULT_DISMISS_DELAY);
  };

  _proto.render = function render() {
    var _this$state = this.state,
        notification = _this$state.notification,
        status = _this$state.status;
    return notification && /*#__PURE__*/React$1.createElement(NotificationItem, {
      type: notification.type,
      status: status,
      fluid: true,
      "data-testid": "notification-item"
    }, notification.message);
  };

  return Notifications;
}(Component);

Notifications.propTypes = {
  notifications: PropTypes$1.arrayOf(PropTypes$1.shape({
    message: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]).isRequired,
    type: PropTypes$1.oneOf(["error", "success", "info"])
  })),
  clearDisplayedNotification: PropTypes$1.func.isRequired
};

function _templateObject$M() {
  var data = _taggedTemplateLiteralLoose(["\n  top: 0em;\n  left: 0em;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background-color: rgba(45, 45, 45, 0.85);\n  line-height: 1;\n  animation-fill-mode: both;\n  animation-duration: 0.5s;\n  transition: background-color 0.5s linear;\n  user-select: none;\n  z-index: 1000;\n\n  opacity: 1;\n\n  position: fixed;\n  transform-style: \"\";\n  perspective: 2000px;\n  transform-origin: center center;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}

var ModalDimmer = styled.div(_templateObject$M());

var Dimmer = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(Dimmer, _Component);

  function Dimmer(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onClickHandler = function (event) {
      if (_this.dimmerRef && _this.dimmerRef.current.contains(event.target)) {
        event.stopPropagation();
        _this.props.onClick && _this.props.onClick(event);
      }
    };

    _this.render = function () {
      var _this$props = _this.props,
          dataTestId = _this$props["data-testid"],
          children = _this$props.children;
      return /*#__PURE__*/React$1.createElement(ModalDimmer, {
        onClick: _this.onClickHandler,
        ref: _this.dimmerRef,
        "data-testid": dataTestId
      }, children);
    };

    _this.dimmerRef = React$1.createRef();
    return _this;
  }

  return Dimmer;
}(Component);

Dimmer.displayName = "Dimmer";
Dimmer.propTypes = {
  onClose: PropTypes$1.func
};

var BREAKPOINTS = {
  SMALL_MODAL_SIZE: "376px",
  PHONE_LARGE: "480px",
  PORTAL_MIDDLE: "652px",
  MID_VIEW_LIMIT: "856px",
  WIDE_VIEW_LIMIT: "1060px",
  MODAL_HEIGHT_LIMIT: "400px"
};

function _templateObject$L() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n\n  z-index: 1001;\n\n  text-align: left;\n  background: #ffffff;\n  border: none;\n  box-shadow: 1px 3px 3px 0px rgba(0, 0, 0, 0.2),\n    1px 3px 15px 2px rgba(0, 0, 0, 0.2);\n  transform-origin: 50% 25%;\n  border-radius: 0.28571429rem;\n  user-select: text;\n\n  padding: 0;\n  outline: none; //so whole dialog doesn't appear outlined when focused programatically\n\n  max-height: 70%;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  ", "\n\n  // when height is lower than 400px for desktop view\n  // we set the max-height back to 100% for better view\n  @media screen and (max-height: ", ") {\n    max-height: calc(100% - 30px);\n  }\n\n  ", "\n\n  @media screen and (max-width: ", "px) {\n    min-width: none;\n    margin: 0 !important;\n    border-radius: 0;\n    max-height: 100%;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n  }\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}
var largePhoneBreakpoint = parseInt(BREAKPOINTS.PHONE_LARGE, 10); // ui small modal transition visible active modal-dialog

var ModalBox = styled.div(_templateObject$L(), function (props) {
  return !props.fixedWidth && "\n    @media only screen and (min-width: " + largePhoneBreakpoint + ") {\n      width: 95%;\n    }\n    @media only screen and (min-width: 768px) {\n      width: 70.4%;\n    }\n    @media only screen and (min-width: 992px) {\n      width: 680px;\n    }\n    @media only screen and (min-width: 1200px) {\n      width: 720px;\n    }\n    @media only screen and (min-width: 1920px) {\n      width: 760px;\n    }\n  ";
}, BREAKPOINTS.MODAL_HEIGHT_LIMIT, function (props) {
  return props.fixedWidth && "width: " + props.fixedWidth + "px;";
}, function (props) {
  return props.fullScreenWidth;
}); //VPAT stuff taken/inspired by https://github.com/ghosh/Micromodal/blob/master/lib/src/index.js

var FOCUSABLE_ELEMENTS = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden])", "iframe", "object", "embed", "[contenteditable]", '[tabindex]:not([tabindex^="-"])'];

var Modal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.focusModal = function () {
      _this.modalRef.current.focus();
    };

    _this.addListeners = function () {
      _this.modalRef.current.addEventListener("keydown", _this.onKeyDown);
    };

    _this.removeListeners = function () {
      _this.modalRef.current.removeEventListener("keydown", _this.onKeyDown);
    };

    _this.onKeyDown = function (event) {
      if (event.key === "Tab") {
        _this.maintainFocus(event);
      }

      if (event.key === "Escape" && _this.props.onClose) {
        _this.closeDialog(event);
      }
    };

    _this.closeDialog = function () {
      _this.props.onClose && _this.props.onClose();
    };

    _this.getFocusableNodes = function () {
      var nodes = _this.modalRef.current.querySelectorAll(FOCUSABLE_ELEMENTS);

      return Array.apply(void 0, nodes);
    };

    _this.maintainFocus = function (event) {
      //theoretically getting focusable elements can be done only once, but it may not work for dynamic dialog contents
      //keeping here to avoid weird behavior and hard to catch bugs in future
      var focusableNodes = _this.getFocusableNodes();

      if (focusableNodes.length === 0) {
        _this.focusModal();

        event.preventDefault();
        return;
      }

      if (!_this.modalRef.current.contains(document.activeElement)) {
        focusableNodes[0].focus();
      } else {
        var focusedItemIndex = focusableNodes.indexOf(document.activeElement);

        if (event.shiftKey && focusedItemIndex === 0) {
          focusableNodes[focusableNodes.length - 1].focus();
          event.preventDefault();
        }

        if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) {
          focusableNodes[0].focus();
          event.preventDefault();
        }
      }
    };

    _this.onDimmerClick = function (event) {
      if (!_this.modalRef.current.contains(event.target)) {
        _this.focusModal();

        if (_this.props.closeOnClick && _this.props.onClose) {
          _this.closeDialog();
        }
      }
    };

    _this.activeElementBeforeOpening = undefined;
    _this.modalRef = React$1.createRef();
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.activeElementBeforeOpening = document.activeElement;
    this.modalRef.current.setAttribute("aria-hidden", "false");
    this.addListeners();
    this.focusModal();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.activeElementBeforeOpening && this.activeElementBeforeOpening.focus && this.activeElementBeforeOpening.focus();
    this.modalRef.current.setAttribute("aria-hidden", "true"); //probably not needed, as dialog will be probably removed from DOM anyway, but use-cases can be different

    this.removeListeners();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        fixedWidth = _this$props.fixedWidth,
        dataTestId = _this$props["data-testid"],
        onClose = _this$props.onClose;
    var fullScreenWidth = Math.max(largePhoneBreakpoint, fixedWidth || 0);
    return ReactDOM.createPortal( /*#__PURE__*/React$1.createElement(Dimmer, {
      onClick: this.onDimmerClick,
      "data-testid": dataTestId && dataTestId + "-dimmer"
    }, /*#__PURE__*/React$1.createElement(ModalBox, {
      fixedWidth: fixedWidth,
      fullScreenWidth: fullScreenWidth,
      ref: this.modalRef,
      tabIndex: -1,
      "data-testid": dataTestId
    }, React$1.Children.map(children, function (child) {
      return React$1.cloneElement(child, {
        breakpoint: fullScreenWidth,
        onClose: onClose
      });
    }))), document.body);
  };

  return Modal;
}(React$1.Component);

Modal.displayName = "Modal";
Modal.defaultProps = {
  closeOnClick: false
};
Modal.propTypes = {
  fixedWidth: PropTypes$1.number,
  closeOnClick: PropTypes$1.bool,
  onClose: PropTypes$1.func
};

function _templateObject3$g() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  box-sizing: initial;\n  background: none;\n  border: none;\n  padding: 0;\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: 8px;\n  min-width: ", "px;\n  height: ", "px;\n\n  @media screen and (max-width: ", "px) {\n    background-image: ", "\n  }\n"]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$s() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  font-size: ", "px;\n  line-height: ", ";\n  padding: 0 ", "px;\n\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  max-height: ", "px; //fallback for browsers not supporting -webkit-line-clamp (i.e. IE)\n\n  @media screen and (max-width: ", "px) {\n    font-size: 18px;\n    text-align: center;\n    padding: 0 8px;\n    margin-right: ", ";\n  }\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$K() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  height: 58px;\n  justify-content: left;\n  align-items: center;\n  color: #3f4040;\n  padding: 0 8px;\n  position: relative;\n\n  border-bottom: solid 1px ", ";\n\n  @media screen and (max-width: ", "px) {\n    background-color: ", ";\n    color: ", ";\n    border-bottom: none;\n    padding: 0 10px;\n    height: 52px;\n    flex-direction: row-reverse;\n  }\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}
var CLOSE_ICON_SIZE = 32;
var HEADER_CONTENT_PADDING = 16;
var messages$3 = defineMessages({
  closeDialog: {
    "id": "closeDialog",
    defaultMessage: "Close dialog"
  }
});
var HeaderContainer = styled.div(_templateObject$K(), COLORS.SEPARATOR_COLORS.MEDIUM, function (props) {
  return props.breakpoint;
}, function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.fontColor;
});
var CONTENT_FONT_SIZE$1 = 22;
var CONTENT_LINE_HEIGHT = 1.18;
var CONTENT_VISIBLE_ROWS = 2;
var Content$1 = styled.div(_templateObject2$s(), CONTENT_FONT_SIZE$1, CONTENT_LINE_HEIGHT, HEADER_CONTENT_PADDING, CONTENT_VISIBLE_ROWS, CONTENT_FONT_SIZE$1 * CONTENT_LINE_HEIGHT * CONTENT_VISIBLE_ROWS, function (props) {
  return props.breakpoint;
}, function (props) {
  return props.hasClose && CLOSE_ICON_SIZE + "px";
});
var CloseIconWrapper = styled.button(_templateObject3$g(), svgList["Close-16"], CLOSE_ICON_SIZE, CLOSE_ICON_SIZE, function (props) {
  return props.breakpoint;
}, function (props) {
  return props.showDarkIcon ? "url(" + svgList["Chevron_left-16"] + ");" : "url(" + svgList["Chevron_left-16-white"] + ");";
});
var DialogHeader = function DialogHeader(_ref) {
  var onClose = _ref.onClose,
      breakpoint = _ref.breakpoint,
      children = _ref.children,
      theme = _ref.theme,
      intl = _ref.intl;
  var fontColor = readableColor(theme.primaryColor);
  return /*#__PURE__*/React$1.createElement(HeaderContainer, {
    fontColor: fontColor,
    breakpoint: breakpoint
  }, /*#__PURE__*/React$1.createElement(Content$1, {
    hasClose: !!onClose,
    breakpoint: breakpoint
  }, children), onClose && /*#__PURE__*/React$1.createElement(CloseIconWrapper, {
    breakpoint: breakpoint,
    "data-testid": "close-dialog-button",
    "aria-label": intl.formatMessage(messages$3.closeDialog),
    showDarkIcon: fontColor === "#000",
    onClick: onClose
  }));
};
DialogHeader.propTypes = {
  onClose: PropTypes$1.func,
  breakpoint: PropTypes$1.number
};
var DialogHeader$1 = withTheme(injectIntl(DialogHeader));

function _templateObject3$f() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$r() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  text-align: center;\n  margin: auto;\n  padding: 24px;\n  line-height: 1.4;\n\n  @media screen and (max-width: ", "px) {\n    flex-direction: column;\n    padding: 32px 20px;\n    margin: 0;\n  }\n"]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$J() {
  var data = _taggedTemplateLiteralLoose(["\n  /** to make <Notifications /> hide properly */\n  overflow: hidden;\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}
var Wrap$1 = styled.div(_templateObject$J());
var Content = styled.div(_templateObject2$r(), function (props) {
  return props.breakpoint;
});
var NotificationsWrap = styled.div(_templateObject3$f());

var DialogContent = function DialogContent(_ref) {
  var notifications = _ref.notifications,
      clearDisplayedNotification = _ref.clearDisplayedNotification,
      children = _ref.children;
  return /*#__PURE__*/React$1.createElement(Wrap$1, null, notifications && /*#__PURE__*/React$1.createElement(NotificationsWrap, null, /*#__PURE__*/React$1.createElement(Notifications, {
    notifications: notifications,
    clearDisplayedNotification: clearDisplayedNotification
  })), /*#__PURE__*/React$1.createElement(Content, null, children));
};

function _templateObject2$q() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 12px;\n"]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$I() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 56px;\n  background-color: #d6291a;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 24px;\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}
var Box = styled.div(_templateObject$I());
var Text = styled.div(_templateObject2$q());

var DialogNotification = function DialogNotification(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React$1.createElement(Box, null, /*#__PURE__*/React$1.createElement(Icon$2, {
    name: "ErrorWhite_24",
    size: "20px"
  }), /*#__PURE__*/React$1.createElement(Text, null, children));
};

Modal.Content = DialogContent;
Modal.Actions = DialogFooter;
Modal.Header = DialogHeader$1;
Modal.Notification = DialogNotification;

function _templateObject2$p() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n  width: ", "px;\n  margin-right: 16px;\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$H() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: ", ";\n  background-color: #ffffff;\n  height: 64px;\n  padding-left: 24px;\n  border-bottom: solid 1px ", ";\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}
var HeadingWrapper = styled.div(_templateObject$H(), COLORS.TEXT_COLORS.TITLE, COLORS.SEPARATOR_COLORS.MEDIUM);
var ICON_IMAGE_SIZE = 32;
var Icon = styled.img(_templateObject2$p(), ICON_IMAGE_SIZE, ICON_IMAGE_SIZE);

var Heading$1 = function Heading(_ref) {
  var children = _ref.children,
      icon = _ref.icon;
  return /*#__PURE__*/React$1.createElement(HeadingWrapper, null, icon && /*#__PURE__*/React$1.createElement(Icon, {
    src: icon
  }), children);
};

Heading$1.propTypes = {
  icon: PropTypes$1.string
};

function _templateObject2$o() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-basis: auto;\n  padding: 0 16px;\n  text-align: center;\n  position: relative;\n\n  &:not(:first-child)::after {\n    content: \"\";\n    background: ", ";\n    position: absolute;\n    bottom: 25%;\n    left: 0;\n    height: 50%;\n    width: 1px;\n  }\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$G() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}
var StyledList$1 = styled.ul(_templateObject$G());
var StyledItem$1 = styled.li(_templateObject2$o(), COLORS.SEPARATOR_COLORS.MEDIUM);

var LinksList = function LinksList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React$1.createElement(StyledList$1, null, Children.map(children, function (child) {
    return child && /*#__PURE__*/React$1.createElement(StyledItem$1, null, child);
  }));
};

LinksList.propTypes = {};

function _templateObject2$n() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-basis: auto;\n  padding: 0 5px;\n  text-align: left;\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$F() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: left;\n  margin: 0;\n  padding: 0;\n  line-height: 2;\n  font-size: 14px;\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}
var StyledList = styled.ul(_templateObject$F());
var StyledItem = styled.li(_templateObject2$n());

var VerticalList = function VerticalList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React$1.createElement(StyledList, null, Children.map(children, function (child) {
    return child && /*#__PURE__*/React$1.createElement(StyledItem, null, child);
  }));
};

VerticalList.propTypes = {};

var ProjectRootContext = createContext(); //just to have nicer provider name, instead of ProjectRootContext.Provider

var ProjectRootProvider = ProjectRootContext.Provider;

var useProjectRoot = function useProjectRoot() {
  var projectRoot = useContext(ProjectRootContext);

  if (projectRoot === undefined) {
    throw new Error("useProjectRoot must be used within a ProjectRootProvider");
  }

  return projectRoot;
};

function RCLink(_ref) {
  var href = _ref.href,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose$1(_ref, ["href", "children"]);

  var projectRoot = useProjectRoot();
  var sanitizedProjectRoot = "/" + (projectRoot || "").replace(/^\/+/, "");
  var isInternal = href.startsWith(sanitizedProjectRoot);
  return isInternal ? /*#__PURE__*/React$1.createElement(Link, _extends$2({
    to: href
  }, props), children) : /*#__PURE__*/React$1.createElement("a", _extends$2({
    href: href
  }, props), children);
}
RCLink.propTypes = {
  /** href can be either absolute URL or pathname for internal links */
  href: PropTypes$1.string.isRequired
};

var EmailInput = function EmailInput(_ref) {
  var value = _ref.value,
      restProps = _objectWithoutPropertiesLoose$1(_ref, ["value"]);

  return /*#__PURE__*/React$1.createElement(Input, _extends$2({
    invalid: value && !isValidEmail(value)
  }, restProps, {
    value: value
  }));
};

var _heightMap$1;

function _templateObject$E() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  box-sizing: border-box;\n  width: 100%;\n  border: 1px solid ", ";\n  transition: border-color 0.2s;\n  border-radius: 2px;\n  font-family: ", ";\n  color: ", ";\n  letter-spacing: 0.2px;\n  padding: 12px;\n  line-height: normal;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &::-webkit-credentials-auto-fill-button {\n    visibility: hidden;\n  }\n\n  &::placeholder {\n    color: #acadad;\n  }\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}
var heightMap$1 = (_heightMap$1 = {}, _heightMap$1[SIZES.MEDIUM] = 100, _heightMap$1[SIZES.LARGE] = 200, _heightMap$1[SIZES.BIG] = 200, _heightMap$1);
var TextArea = styled.textarea(_templateObject$E(), function (props) {
  return getSizingDefinitions$1(props.size, heightMap$1);
}, COLORS.GRAY_COLORS.GRAY_88, FONTS.FONT_FAMILY.DEFAULT, COLORS.TEXT_COLORS.EMPHASIZED, function (props) {
  return getBackgroundColor(props);
}, function (props) {
  return props.restrictResize && "resize: none";
}, function (props) {
  return getBorderColorDefinition(props);
});
TextArea.defaultProps = {
  autoFocus: false,
  disabled: false,
  invalid: false,
  autoComplete: "off",
  autoCorrect: "off",
  spellCheck: "false",
  large: false,
  focused: false,
  locked: false,
  size: SIZES.MEDIUM,
  restrictResize: false
};
TextArea.propTypes = {
  id: PropTypes$1.string.isRequired,
  value: PropTypes$1.string,
  onChange: PropTypes$1.func,
  onBlur: PropTypes$1.func,
  autoFocus: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  autoComplete: PropTypes$1.string,
  autoCorrect: PropTypes$1.string,
  spellCheck: PropTypes$1.string,
  name: PropTypes$1.string,
  size: PropTypes$1.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG]),
  focused: PropTypes$1.bool,
  locked: PropTypes$1.bool,
  restrictResize: PropTypes$1.bool
};

function _templateObject2$m() {
  var data = _taggedTemplateLiteralLoose(["\n  height: inherit;\n  width: inherit;\n  padding-right: .5em;\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$D() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 1em;\n  display: flex;\n  font-size: smaller;\n  background-color: ", ";\n  align-items: center;\n  color: ", ";\n  border-left: 2px solid ", ";\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}
var StyledDiv$1 = styled.div(_templateObject$D(), COLORS.GRAY_COLORS.GRAY_94, COLORS.TEXT_COLORS.DEFAULT, COLORS.STATUS_COLORS.WARNING);
var StyledIcon$2 = styled(Icon$2)(_templateObject2$m());

var InfoText = function InfoText(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose$1(_ref, ["children"]);

  return /*#__PURE__*/React$1.createElement(StyledDiv$1, props, /*#__PURE__*/React$1.createElement(StyledIcon$2, {
    alt: "",
    name: "Info_outline-16"
  }), children);
};

var ARROW_DOWN = 40;
var ARROW_UP = 38;
var SPACE = 32;
var ENTER = 13;
var ESC = 27;
var TAB = 9;
var KEY_CODES = {
  ARROW_DOWN: ARROW_DOWN,
  ARROW_UP: ARROW_UP,
  SPACE: SPACE,
  ENTER: ENTER,
  ESC: ESC,
  TAB: TAB
};

var clearSearchIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxwYXRoIGZpbGw9IiM5ODk4OTgiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE5LjIxMy4wMzNsLTkuMTggOS4yMTNMLjgyLjAzMy4xOTcuNjU2bDkuMTggOS4yMTMtOS4xOCA5LjIxMy42MjMuNjIzIDkuMjEzLTkuMjEzIDkuMTggOS4yMTMuNjU2LS42MjMtOS4yMTMtOS4yMTNMMTkuODY5LjY1NnoiLz4KPC9zdmc+Cg==";

var searchIcon$o = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNBNEE1QTkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1Ljg0OCAxMy44NDhMMjEgMTlsLTIgMi01LjE1Mi01LjE1MmE3IDcgMCAxIDEgMi0yek0xMCAxNWE1IDUgMCAxIDAgMC0xMCA1IDUgMCAwIDAgMCAxMHoiLz4KPC9zdmc+Cg==";

var _heightMap;

function _templateObject6$5() {
  var data = _taggedTemplateLiteralLoose(["\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  margin: 0;\n"]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: ", "px;\n  top: ", "px;\n  width: ", "px;\n  height: ", "px;\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  box-sizing: content-box;\n  right: 0;\n  top: ", "px;\n  width: ", "px;\n  height: ", "px;\n  padding: ", "px;\n  cursor: pointer;\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$e() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex-grow: 1;\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$l() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$C() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: ", "px;\n  padding-right: ", "px;\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}
var searchIconSize = 24;
var iconsMargin = 8;
var clearIconSize = 12;
var clearIconInteractiveSize = 38;
var heightMap = (_heightMap = {}, _heightMap[SIZES.MEDIUM] = 38, _heightMap[SIZES.LARGE] = 48, _heightMap[SIZES.BIG] = 48, _heightMap);
var messages$2 = defineMessages({
  searchIcon: {
    "id": "searchIcon",
    defaultMessage: "search icon"
  },
  clearIcon: {
    "id": "clearIcon",
    defaultMessage: "clear icon"
  }
});
var InputOverrided = styled(Input)(_templateObject$C(), iconsMargin * 2 + searchIconSize, iconsMargin + clearIconInteractiveSize, function (props) {
  return props.showButton ? 0 : "inherit";
}, function (props) {
  return props.showButton ? 0 : "inherit";
});
var SearchContainer = styled.div(_templateObject2$l());
var InputField = styled.div(_templateObject3$e());
var ClearIcon = styled.img(_templateObject4$8(), function (props) {
  return (props.inputHeight - clearIconInteractiveSize) / 2;
}, clearIconSize, clearIconSize, (clearIconInteractiveSize - clearIconSize) / 2);
var SearchIcon = styled.img(_templateObject5$6(), iconsMargin, function (props) {
  return (props.inputHeight - searchIconSize) / 2;
}, searchIconSize, searchIconSize);
var ButtonOverrided = styled(Button$1)(_templateObject6$5());

var SearchField = function SearchField(_ref) {
  var inputRef = _ref.inputRef,
      value = _ref.value,
      onRemove = _ref.onRemove,
      onSearch = _ref.onSearch,
      showButton = _ref.showButton,
      onKeyDown = _ref.onKeyDown,
      buttonLabel = _ref.buttonLabel,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose$1(_ref, ["inputRef", "value", "onRemove", "onSearch", "showButton", "onKeyDown", "buttonLabel", "size"]);

  var intl = useIntl();

  var defaultOnKeyDown = function defaultOnKeyDown(event) {
    if (event.keyCode === KEY_CODES.ENTER) {
      onSearch(value);
    }

    if (event.keyCode === KEY_CODES.ESC) {
      onRemove(event);
    }
  };

  return /*#__PURE__*/React$1.createElement(SearchContainer, null, /*#__PURE__*/React$1.createElement(InputField, null, value.length > 0 && /*#__PURE__*/React$1.createElement(ClearIcon, {
    src: clearSearchIcon,
    onClick: onRemove,
    inputHeight: getHeight(size, heightMap),
    showButton: showButton,
    alt: intl.formatMessage(messages$2.clearIcon)
  }), /*#__PURE__*/React$1.createElement(SearchIcon, {
    src: searchIcon$o,
    inputHeight: getHeight(size, heightMap),
    alt: intl.formatMessage(messages$2.searchIcon)
  }), /*#__PURE__*/React$1.createElement(InputOverrided, _extends$2({}, rest, {
    value: value,
    size: size,
    ref: inputRef,
    onKeyDown: onKeyDown || defaultOnKeyDown
  }))), showButton && /*#__PURE__*/React$1.createElement(ButtonOverrided, {
    look: "regular",
    onClick: onSearch,
    size: size
  }, buttonLabel));
};

SearchField.defaultProps = {
  size: SIZES.MEDIUM,
  onSearch: function onSearch() {
    return null;
  },
  showButton: false,
  buttonLabel: "Search"
};
SearchField.propTypes = {
  value: PropTypes$1.string.isRequired,
  onRemove: PropTypes$1.func.isRequired,
  onSearch: PropTypes$1.func,
  showButton: PropTypes$1.bool,
  buttonLabel: PropTypes$1.string,
  size: PropTypes$1.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG]),
  inputRef: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.shape({
    current: PropTypes$1.instanceOf(Element)
  })])
};

function _templateObject$B() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
var Container$1 = styled.div(_templateObject$B());
/**
 * A wrapper for SearchField that handles form changes, form submit, and form clearing the output.
 * @param {Number|String} id - a number or string representing the id of the search field component
 * @param {Function} onSearch - a function that runs on keypress enter or click Search button
 * @param {String} placeholder - [default = "Search"] a string set to the placeholder of the search field component
 * @param {String} value - [optional] a string used as the initial value and the value of the search field component
 * @param {Function} handleChange - [optional] a function that runs when the value of the search field component is changed
 * @param {Boolean} showButton - [default = true] a boolean that controls if the search button is rendered or not
 * @example
 *   <SearchBox
 *     id="search-box-1234"
 *     onSearch={filterResults}
 *     placeholder="Search"
 *     value={value}
 *     handleChange={setValue}
 *     showButton={true}
 *   />
 * @type {{( props: { id: (number|string), onSearch: function, placeholder?: string, handleChange?: function, value?: string, showButton?: boolean }): JSX.Element}}
 */

var SearchBox = forwardRef(function (_ref, ref) {
  var _intl$formatMessage;

  var id = _ref.id,
      onSearch = _ref.onSearch,
      placeholder = _ref.placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      handleChange = _ref.handleChange,
      _ref$showButton = _ref.showButton,
      showButton = _ref$showButton === void 0 ? true : _ref$showButton,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose$1(_ref, ["id", "onSearch", "placeholder", "value", "handleChange", "showButton", "className"]);

  var _useState = useState(value),
      searchValue = _useState[0],
      setSearchValue = _useState[1];

  var intl = useIntl();

  var onSearchChange = function onSearchChange(value) {
    setSearchValue(value);
    handleChange && handleChange(value);
  };

  var onSearchClick = function onSearchClick() {
    return onSearch(searchValue);
  };

  var onSearchRemove = function onSearchRemove(event) {
    event.stopPropagation();
    onSearchChange("");
    onSearch("");
  };

  useEffect(function () {
    setSearchValue(value);
  }, [value]);
  return /*#__PURE__*/React$1.createElement(Container$1, {
    className: className
  }, /*#__PURE__*/React$1.createElement(SearchField, _extends$2({
    id: id,
    onSearch: onSearchClick,
    placeholder: placeholder || intl.formatMessage((_intl$formatMessage = {
      defaultMessage: "Search",
      "id": "4281662478"
    }, _intl$formatMessage["id"] = "4281662478", _intl$formatMessage)),
    value: searchValue,
    onChange: function onChange(event) {
      return onSearchChange(event.target.value);
    },
    showButton: showButton,
    onRemove: onSearchRemove,
    inputRef: ref
  }, props)));
});
SearchBox.propTypes = {
  id: oneOfType([number, string]).isRequired,
  onSearch: func.isRequired,
  placeholder: string,
  value: string,
  handleChange: func,
  showButton: bool
};

var StyledLoading = styled(Loading)(function (props) {
  return props.collapsed && "\n    position: unset;\n    top: unset;\n    right: unset;\n    bottom: unset;\n    left: unset;\n    transform: unset;\n  ";
});
/**
 * Wraps Loading component to control display of content or loader based on `loading` property.
 * @param {boolean} loading - [optional] describes if the content is loading
 * @param {boolean} collapsed - [optional] describes if the loading container is collapsed
 * @param {string} msg - [optional] the message to display with the loading animation
 * @returns {JSX.Element} the loading container when loading, children when not loading
 * @example
 *   <Load loading={loading} msg="The page is loading..." collapsed={true}>
 *     <div>Content that will render when loading == true</div>
 *   </Load>
 * @type {{( props: { loading?: boolean, collapsed?: boolean, msg?: string }): JSX.Element}}
 */

var Load = function Load(_ref) {
  var loading = _ref.loading,
      collapsed = _ref.collapsed,
      msg = _ref.msg,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose$1(_ref, ["loading", "collapsed", "msg", "children"]);

  if (!loading) return children;
  return /*#__PURE__*/React$1.createElement("div", _extends$2({
    "data-testid": "load"
  }, props), /*#__PURE__*/React$1.createElement(StyledLoading, {
    msg: msg,
    collapsed: collapsed
  }));
};

Load.propTypes = {
  collapsed: bool,
  loading: bool.isRequired,
  msg: string
};

/**
 * keydown hander for given ref element
 * - only works when element is active
 * - handlers is a map of {keyCode: handler}
 * - doesn't support special characters (ignores them)
 */

var useKeyDown = function useKeyDown(ref, handlers) {
  if (handlers === void 0) {
    handlers = {};
  }

  var onKeyDown = function onKeyDown(event) {
    handlers[event.keyCode] && handlers[event.keyCode](event);
  };

  useEffect(function () {
    var current = ref.current;
    current && current.addEventListener("keydown", onKeyDown);
    return function () {
      current && current.removeEventListener("keydown", onKeyDown);
    };
  });
};

// taken from https://usehooks.com/useWindowSize/

var useWindowSize = function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  var _useState = useState({
    width: window.innerWidth,
    height: window.innerHeight
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  useEffect(function () {
    var resizeTimer; // Handler to call on window resize

    var handleResize = function handleResize() {
      clearTimeout(resizeTimer); //debounce dimensions recounting

      resizeTimer = setTimeout(function () {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }, 50);
    }; // Add event listener


    window.addEventListener("resize", handleResize); // Call handler right away so state gets updated with initial window size

    handleResize(); // Remove event listener on cleanup

    return function () {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimer);
    };
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
};

/**
 * A custom hook that re-renders the component every time the given ref's position is changed by scrolling.
 * @param {Object} ref - an object reference created by React's useRef hook.
 * @param {Element} [ref.current] - an html element that is used to control whether the component should rerender or not
 * @param {Boolean} condition - a condition that controls whether the "onScroll" event listener is added
 * @example
 *   const toggleRef = useRef();
 *   const [isOpen, setOpen] = useState(false);
 *   useScroll(toggleRef, isOpen);
 */

var useScroll = function useScroll(ref, condition) {
  if (condition === void 0) {
    condition = true;
  }

  var _useState = useState(0),
      setScroll = _useState[1];

  useEffect(function () {
    var _ref$current;

    var prevRect = (_ref$current = ref.current) == null ? void 0 : _ref$current.getBoundingClientRect();

    var handleScroll = function handleScroll() {
      if (ref.current) {
        var currentRect = ref.current.getBoundingClientRect();
        if (prevRect) for (var prop in prevRect) {
          if (prevRect[prop] !== currentRect[prop]) {
            setScroll(function (prev) {
              return prev + 1;
            });
            prevRect = currentRect;
            break;
          }
        }
      }
    };

    if (condition) window.addEventListener("scroll", handleScroll, true);
    return function () {
      return window.removeEventListener("scroll", handleScroll, true);
    };
  }, [ref, condition]);
};

//taken from https://usehooks.com/useOnClickOutside/

var useOnClickOutside = function useOnClickOutside(refs, handler) {
  if (!Array.isArray(refs)) refs = [refs];
  useEffect(function () {
    var listener = function listener(event) {
      // Do nothing if clicking refs' element or descendent elements
      if (refs.some(function (ref) {
        return !ref.current || ref.current.contains(event.target);
      })) return;
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return function () {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new ...
  // ... function on every render that will cause this effect ...
  // ... callback/cleanup to run every render. It's not a big deal ...
  // ... but to optimize you can wrap handler in useCallback before ...
  // ... passing it into this hook.
  [refs, handler]);
};

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n  color: ", ";\n  font-size: 14px;\n  text-align: left;\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 10px;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n  color: ", ";\n  cursor: pointer;\n  transition: background-color 0.1s;\n  background: ", ";\n  font-size: 14px;\n  text-align: left;\n  &:hover {\n    background-color: ", ";\n  }\n  &[aria-selected=\"true\"] {\n    background-color: ", ";\n  }\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow-y: auto;\n  & > div {\n    outline-offset: -2px;\n  }\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 1em 0;\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$d() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 1px solid ", ";\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16);\n  box-sizing: border-box;\n  border-radius: 4px;\n  padding: 6px;\n  width: 100%;\n  min-width: max(310px, ", "px);\n  display: flex;\n  width: auto;\n  flex-direction: column;\n  background-color: ", ";\n  position: fixed; // necessary to appear on top of modal\n  z-index: 1;\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$k() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}
var Container = styled.div(_templateObject$A(), function (props) {
  return props.inline && "display: inline-block;";
});
var StyledSearchBox = styled(SearchBox)(_templateObject2$k());
var Dropdown$3 = styled.div.attrs(function (_ref) {
  var dirTop = _ref.dirTop,
      windowSize = _ref.windowSize,
      toggleRect = _ref.toggleRect;
  // style properties that change often belong in the .attrs() method
  var position = dirTop // css calc func is erased by jsdom in spec, so js is required
  ? {
    bottom: windowSize.height - toggleRect.top + "px"
  } : {
    top: "max(0px, " + toggleRect.bottom + "px)"
  };

  var style = _objectSpread2({
    maxHeight: (dirTop ? toggleRect.top : windowSize.height - toggleRect.bottom) + "px",
    left: "min(" + (windowSize.width - 310) + "px, " + toggleRect.left + "px)"
  }, position);

  return {
    style: style
  };
})(_templateObject3$d(), COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_SILVER, function (props) {
  return props.toggleRect.width;
}, COLORS.WHITE);
var StyledLoad = styled(Load)(_templateObject4$7());
var Results = styled.div(_templateObject5$5());
var Item = styled.div(_templateObject6$4(), COLORS.TEXT_COLORS.TITLE, COLORS.WHITE, COLORS.ACTION_COLORS.BLUE_ITEM_HIGHLIGHT, COLORS.ACTION_COLORS.BLUE_ITEM_HIGHLIGHT);
var SubLabel = styled.div(_templateObject7$1());
var NoResults = styled.div(_templateObject8$1(), COLORS.TEXT_COLORS.PLACEHOLDER);
/**
 * A component containing a search bar and list of selectable elements
 * Only allows a single child which requires forwardRef if the child is a functional React component
 * @param {Boolean} loading [default = false] - describes if the content is loading
 * @param {Number|String} id - a value given to dropdown and prepended to the search box, options list, and option elements' ids
 * @param {Function} onSearch - a function that runs when enter is pressed on the search input OR when typing if searchOnType = true
 * @param {Function} onSelect - a function that runs when a list element is selected
 * @param {[Object]|Null} searchResults - null OR an array of objects that render in a list
 *   @param {Number|String} searchResults[].label - the label of the rendered list element
 *   @param {Number|String} searchResults[].id - [optional] a unique value set to the list element key
 * @param {Boolean} dirTop - [optional] a boolean describing if the dropdown renders below or above the toggle element
 * @param {Boolean} searchOnType - [optional] a boolean describing if the onSearch function runs on type
 * @param {Boolean} inline - [optional] describes if the toggle is displayed inline or not
 * @example
 *   <SearchDropdown
 *     loading={loading}
 *     id="dropdown"
 *     onSearch={searchValue => filterResults(searchValue)}
 *     onSelect={() => alert("selected list element")}
 *     searchResults={[{ label: "Daniel Craig", id: 007 }]}
 *     dirTop
 *     searchOnType
 *     inline
 *   >
 *     <button>Toggle Dropdown</button>
 *   </SearchDropdown>
 * @type {{( props: { loading?: boolean, id: (number|string), onSearch: function, onSelect: function, searchResults?: [{ label: (number|string), id?: (number|string) }], dirTop?: boolean, searchOnType?: boolean, inline?: boolean }): JSX.Element}}
 */

var SearchDropdown = function SearchDropdown(_ref2) {
  var _useKeyDown, _useKeyDown2, _toggleEl$current;

  var _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? false : _ref2$loading,
      id = _ref2.id,
      onSearch = _ref2.onSearch,
      onSelect = _ref2.onSelect,
      searchResults = _ref2.searchResults,
      dirTop = _ref2.dirTop,
      searchOnType = _ref2.searchOnType,
      inline = _ref2.inline,
      children = _ref2.children,
      className = _ref2.className;

  // States
  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState(null),
      highlightIndex = _useState2[0],
      setHighlightIndex = _useState2[1];

  var _useState3 = useState(""),
      searchValue = _useState3[0],
      setSearchValue = _useState3[1]; // Refs


  var containerEl = useRef();
  var toggleWrapperEl = useRef();
  var toggleEl = useRef();
  var dropdownEl = useRef();
  var searchBoxEl = useRef();
  var options = [];
  var windowSize = useWindowSize();
  useScroll(toggleEl, open);

  var focusToggle = function focusToggle() {
    return toggleEl.current.focus();
  };

  var closeDropdown = function closeDropdown(event) {
    event.stopPropagation();
    setOpen(false);
    if (event.keyCode === ESC) focusToggle();
  };

  var onTogglerClick = function onTogglerClick(_ref3) {
    var keyCode = _ref3.keyCode,
        target = _ref3.target;
    var isEnter = keyCode === ENTER;
    var isButton = target.tagName === "BUTTON"; // prevents button keyboard click from running function twice

    if (!(isEnter && isButton)) setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };

  var onItemClick = function onItemClick(event) {
    var selectedItem = event.currentTarget.dataset.item || JSON.stringify(searchResults == null ? void 0 : searchResults[highlightIndex]);

    if (selectedItem) {
      onSelect(selectedItem);
      setOpen(false);
      setHighlightIndex(null);
      setSearchValue(""); // prevents re-opening of dropdown on enter-select item

      if (event.keyCode === ENTER) setTimeout(function () {
        return focusToggle();
      });
    }
  };

  var onArrowPress = function onArrowPress(event) {
    event.preventDefault(); // stop scrolling

    var isDownArrow = event.keyCode === ARROW_DOWN;
    var currentIndex = highlightIndex !== null ? highlightIndex : -1;
    isDownArrow ? currentIndex++ : currentIndex--; // loop options

    if (currentIndex < 0) currentIndex = options.length - 1;else if (currentIndex >= options.length) currentIndex = 0;
    var newOption = options[currentIndex];

    if (newOption) {
      // scrollIntoView not accessible in spec, therefore optional
      newOption.scrollIntoView && newOption.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
      setHighlightIndex(currentIndex);
    }
  };

  var handleChange = function handleChange(newSearchValue) {
    setHighlightIndex(null);
    setSearchValue(newSearchValue);
    searchOnType && onSearch(newSearchValue);
  };

  useEffect(function () {
    var currentToggle = toggleEl.current;

    var callback = function callback(_ref4) {
      var entry = _ref4[0];
      return !entry.isIntersecting && setOpen(false);
    };

    var observer = new IntersectionObserver(callback, {
      threshold: 0
    });
    if (currentToggle) observer.observe(currentToggle);
    return function () {
      return observer.unobserve(currentToggle);
    };
  }, [toggleEl]);
  useKeyDown(toggleWrapperEl, (_useKeyDown = {}, _useKeyDown[ENTER] = onTogglerClick, _useKeyDown[SPACE] = onTogglerClick, _useKeyDown));
  useKeyDown(dropdownEl, (_useKeyDown2 = {}, _useKeyDown2[ARROW_UP] = onArrowPress, _useKeyDown2[ARROW_DOWN] = onArrowPress, _useKeyDown2[ENTER] = onItemClick, _useKeyDown2[TAB] = closeDropdown, _useKeyDown2[ESC] = closeDropdown, _useKeyDown2));
  useEffect(function () {
    if (open) {
      setHighlightIndex(null);
      searchBoxEl.current.focus();
    }
  }, [open]);
  useOnClickOutside([toggleEl, dropdownEl], useCallback(function () {
    return setOpen(false);
  }, [setOpen]));
  return /*#__PURE__*/React$1.createElement(Container, {
    className: className,
    ref: containerEl,
    inline: inline
  }, /*#__PURE__*/React$1.createElement("span", {
    onClick: onTogglerClick,
    ref: toggleWrapperEl,
    role: "button",
    tabIndex: "-1"
  }, React$1.cloneElement(React$1.Children.only(children), {
    ref: toggleEl
  })), open && /*#__PURE__*/React$1.createElement(Dropdown$3, {
    id: id,
    ref: dropdownEl,
    dirTop: dirTop,
    toggleRect: (_toggleEl$current = toggleEl.current) == null ? void 0 : _toggleEl$current.getBoundingClientRect(),
    windowSize: windowSize
  }, /*#__PURE__*/React$1.createElement(StyledSearchBox, {
    id: id + "-search-box",
    ariaControls: id + "-options-list",
    "aria-activedescendant": id + "-option-" + highlightIndex,
    onSearch: onSearch,
    handleChange: handleChange,
    value: searchValue,
    showButton: false,
    ref: searchBoxEl
  }), /*#__PURE__*/React$1.createElement(StyledLoad, {
    collapsed: true,
    loading: loading
  }, /*#__PURE__*/React$1.createElement(Results, {
    id: id + "-options-list",
    role: "listbox",
    "aria-labelledby": id + "-search-box"
  }, (searchResults == null ? void 0 : searchResults.length) ? searchResults.map(function (item, idx) {
    return /*#__PURE__*/React$1.createElement(Item, {
      role: "option",
      key: item.id || item.id === 0 ? item.id : idx,
      id: id + "-option-" + idx,
      onClick: onItemClick,
      "aria-selected": idx === highlightIndex,
      "data-item": JSON.stringify(item),
      ref: function ref(el) {
        return options[idx] = el;
      }
    }, /*#__PURE__*/React$1.createElement("div", null, item.label), item.sublabel && /*#__PURE__*/React$1.createElement(SubLabel, null, item.sublabel));
  }) : /*#__PURE__*/React$1.createElement(NoResults, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
    id: "966052509",
    defaultMessage: "No Results"
  }))))));
};

var nullOrShape$1 = function nullOrShape(props, propName, componentName) {
  var _checkPropTypes, _checkPropTypes2;

  var prop = props[propName];
  if (prop === null) return;
  checkPropTypes((_checkPropTypes = {}, _checkPropTypes[propName] = arrayOf(optionShape$1).isRequired, _checkPropTypes), (_checkPropTypes2 = {}, _checkPropTypes2[propName] = prop, _checkPropTypes2), "prop", componentName);
};

var optionShape$1 = shape({
  label: oneOfType([string, number]).isRequired,
  id: oneOfType([string, number])
});
SearchDropdown.propTypes = {
  loading: bool,
  id: oneOfType([number, string]).isRequired,
  onSearch: func.isRequired,
  onSelect: func.isRequired,
  searchResults: nullOrShape$1,
  dirTop: bool,
  searchOnType: bool,
  children: node.isRequired
};

function _templateObject3$c() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 8px;\n  top: 11px;\n  height: 50%;\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$j() {
  var data = _taggedTemplateLiteralLoose(["\n  user-select: text;\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  padding: 9px 28px 8px 12px;\n  height: 38px;\n  line-height: normal;\n  font-family: Roboto, \"Helvetica Neue\", Helvetica, \"Segoe UI\", Arial, sans-serif;\n  font-size: 14px;\n  color: ", ";\n  background-color: ", ";\n  letter-spacing: 0.2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n  user-select: none;\n  &[data-hasvalue=false] {\n    color: ", ";\n  }\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}
var StyledDiv = styled.div(_templateObject$z(), COLORS.TEXTFIELD_COLORS.BORDER, COLORS.TEXT_COLORS.TITLE, COLORS.WHITE, COLORS.TEXT_COLORS.PLACEHOLDER);
var AllowSelect = styled.span(_templateObject2$j());
var StyledIcon$1 = styled(Icon$2)(_templateObject3$c());
/**
 * A selectable form field component
 * @param {String|Number} id - a string or number given to the component
 * @param {String|Number} value [optional] - a string or number that represents the value of the select field
 * @param {String} placeholder [optional] - the placeholder that renders when there is no value
 * @param {Function} onKeyDown [optional] - a function that runs when any keyDown event is triggered on the select field element
 * @returns {JSX.Element} a select field displaying the component's value or placeholder
 * @example
 *   <SelectField
 *     id="select-field"
 *     value="I was selected"
 *     placeholder="Placeholder Text"
 *     onKeyDown={() => alert("KeyDown on SelectField")}
 *   />
 * @type {{( props: { id: (string|number), value?: (string|number), placeholder?: string,  onKeyDown?: function }): JSX.Element}}
 */

var SelectField = forwardRef(function (_ref, ref) {
  var id = _ref.id,
      value = _ref.value,
      placeholder = _ref.placeholder,
      _onKeyDown = _ref.onKeyDown;
  var hasValue = !!value || value === 0;
  return /*#__PURE__*/React$1.createElement(StyledDiv, {
    id: id,
    "data-hasvalue": hasValue,
    role: "button",
    "aria-label": placeholder + ": " + (hasValue ? value : ""),
    tabIndex: "0",
    onKeyDown: function onKeyDown(evt) {
      return _onKeyDown && _onKeyDown(evt);
    },
    ref: ref
  }, hasValue ? /*#__PURE__*/React$1.createElement(AllowSelect, null, value) : placeholder, /*#__PURE__*/React$1.createElement(StyledIcon$1, {
    name: "Chevron_down-12"
  }));
});
SelectField.propTypes = {
  id: oneOfType([number, string]).isRequired,
  value: oneOfType([number, string]),
  placeholder: string,
  onKeyDown: func
};

/**
 * A component that includes a select input and search dropdown.
 * Combines two components: SelectField and SearchDropdown
 * @param {Number|String} id - a number or string prepended to SelectField and SearchDropdown components
 * @param {[Object]} list - an array of objects to render as list elements in the search dropdown
 *   @param {Number|String} list[].label - the label of the rendered list element
 *   @param {Number|String} list[].id - [optional] a unique value set to the list element key
 * @param {Null|Object} selected - a react state object describing the value of which list element has been selected
 * @param {Function} setSelected - a function generated by React.useState which sets the selected value
 * @param {String} placeholder - a placeholder string to render when no list element has been selected
 * @param {Boolean} dirTop - [optional] a boolean describing if the dropdown renders below or above the trigger element
 * @param {Boolean} searchOnType - [optional] a boolean describing if the onSearch method runs on type
 * @param {Boolean} onSearch - [optional] a function that overwrites the existing onSearch handler in the component
 * @example
 *   <SelectSearchDropdown
 *     id="favorite-food"
 *     list={[{label: "Janet", id: 1001001}]}
 *     selected={selected}
 *     setSelected={setSelected}
 *     placeholder="Select a food"
 *     dirTop
 *     searchOnType
 *     onSearch={filterList}
 *   />
 * @type {{(props: { id: (string|number), list: [{label: (number|string), id?: (number|string)}], selected: (null|{}), setSelected: function, placeholder: string, dirTop?: boolean, searchOnType?: boolean, onSearch?: function }): JSX.Element }}
 */

var SelectSearchDropdown = function SelectSearchDropdown(_ref) {
  var id = _ref.id,
      list = _ref.list,
      selected = _ref.selected,
      setSelected = _ref.setSelected,
      placeholder = _ref.placeholder,
      dirTop = _ref.dirTop,
      searchOnType = _ref.searchOnType,
      onSearch = _ref.onSearch,
      className = _ref.className;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(list),
      searchResults = _useState2[0],
      setSearchResults = _useState2[1];

  var handleSearch = function handleSearch(term) {
    term = term.trim().replace(/\s+/g, " ");
    setLoading(true);

    if (!term) {
      setLoading(false);
      setSearchResults(list);
      return;
    }

    var termWords = term.toLowerCase().split(" ");
    var newResults = list.filter(function (_ref2) {
      var label = _ref2.label;
      return termWords.every(function (word) {
        return label.toLowerCase().includes(word);
      });
    });
    setLoading(false);
    setSearchResults(newResults);
  };

  var search = onSearch || handleSearch;

  var onSelect = function onSelect(option) {
    setSelected(JSON.parse(option));
    setSearchResults(list);
  };

  useEffect(function () {
    setLoading(false);
    setSearchResults(list);
  }, [list]);
  return /*#__PURE__*/React$1.createElement(SearchDropdown, {
    loading: loading,
    id: id + "-search-dropdown",
    onSearch: search,
    onSelect: onSelect,
    searchResults: searchResults,
    dirTop: dirTop,
    searchOnType: searchOnType,
    className: className
  }, /*#__PURE__*/React$1.createElement(SelectField, {
    id: id + "-select-field",
    value: selected == null ? void 0 : selected.label,
    placeholder: placeholder
  }));
};

var nullOrShape = function nullOrShape(props, propName, componentName) {
  var _checkPropTypes, _checkPropTypes2;

  var prop = props[propName];
  if (prop === null) return;
  checkPropTypes((_checkPropTypes = {}, _checkPropTypes[propName] = optionShape.isRequired, _checkPropTypes), (_checkPropTypes2 = {}, _checkPropTypes2[propName] = prop, _checkPropTypes2), "prop", componentName);
};

var optionShape = shape({
  label: oneOfType([number, string]).isRequired,
  id: oneOfType([number, string])
});
SelectSearchDropdown.propTypes = {
  id: oneOfType([number, string]).isRequired,
  list: arrayOf(optionShape).isRequired,
  selected: nullOrShape,
  setSelected: func.isRequired,
  placeholder: string.isRequired,
  dirTop: bool,
  searchOnType: bool,
  onSearch: func
};

var _buttonSizeMap;

function _templateObject6$3() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #d62a1b;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #5da40d;\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n  width: ", "px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  border: none;\n  padding: 3px;\n  cursor: pointer;\n\n  & img {\n    cursor: pointer;\n  }\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$y() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  margin-left: 4px;\n  width: 100%;\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}
var messages$1 = defineMessages({
  confirm: {
    "id": "confirm",
    defaultMessage: "confirm"
  },
  revert: {
    "id": "revert",
    defaultMessage: "revert"
  },
  cancel: {
    "id": "cancel",
    defaultMessage: "cancel"
  }
});
var EditContainer = styled.div(_templateObject$y());
var ControlContainer = styled.div(_templateObject2$i());
var buttonSizeMap = (_buttonSizeMap = {}, _buttonSizeMap[SIZES.MEDIUM] = 32, _buttonSizeMap[SIZES.LARGE] = 42, _buttonSizeMap[SIZES.BIG] = 42, _buttonSizeMap);
var Button = styled.button(_templateObject3$b(), function (props) {
  return buttonSizeMap[props.size];
}, function (props) {
  return buttonSizeMap[props.size];
});
var CheckmarkButton = styled(Button)(_templateObject4$6());
var CloseButton = styled(Button)(_templateObject5$4());
var RevertButton = styled(Button)(_templateObject6$3(), COLORS.ACTION_COLORS.BLUE_MAIN);

var InlineTextEdit = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(InlineTextEdit, _Component);

  function InlineTextEdit(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.updateListener = function (editMode) {
      if (editMode) {
        document.addEventListener("mousedown", _this.handleOutsideClick);
      } else {
        document.removeEventListener("mousedown", _this.handleOutsideClick);
      }
    };

    _this.handleOutsideClick = function (event) {
      if (_this.containerRef && !_this.containerRef.current.contains(event.target)) {
        _this.props.saveOnBlur ? _this.props.onSave && _this.props.onSave(_this.state.updateValue) : _this.props.onCancel && _this.props.onCancel();
      }
    };

    _this.componentDidUpdate = function (prevProps) {
      var newEditMode = _this.props.editMode;

      if (prevProps.editMode !== newEditMode) {
        _this.setState({
          updateValue: _this.props.value
        });

        _this.updateListener(newEditMode);
      }
    };

    _this.componentDidMount = function () {
      _this.updateListener(_this.props.editMode);
    };

    _this.componentWillUnmount = function () {
      _this.updateListener(false);
    };

    _this.onKeyDown = function (_ref) {
      var key = _ref.key;
      var _this$props = _this.props,
          onSave = _this$props.onSave,
          onCancel = _this$props.onCancel;

      if (key === "Enter") {
        onSave && onSave(_this.state.updateValue);
      }

      if (key === "Escape") {
        onCancel && onCancel();
      }
    };

    _this.render = function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          value = _this$props2.value,
          editMode = _this$props2.editMode,
          render = _this$props2.render,
          onSave = _this$props2.onSave,
          onCancel = _this$props2.onCancel,
          onRevert = _this$props2.onRevert,
          size = _this$props2.size,
          intl = _this$props2.intl,
          inputProps = _objectWithoutPropertiesLoose$1(_this$props2, ["id", "value", "editMode", "render", "onSave", "onCancel", "onRevert", "size", "intl"]);

      var updateValue = _this.state.updateValue;

      if (editMode) {
        return /*#__PURE__*/React$1.createElement(EditContainer, {
          ref: _this.containerRef
        }, /*#__PURE__*/React$1.createElement(Input, _extends$2({
          id: id,
          value: updateValue,
          onChange: function onChange(event) {
            return _this.setState({
              updateValue: event.target.value
            });
          },
          onKeyDown: _this.onKeyDown
        }, inputProps, {
          size: size
        })), /*#__PURE__*/React$1.createElement(ControlContainer, null, /*#__PURE__*/React$1.createElement(CheckmarkButton, {
          onClick: function onClick() {
            return onSave && onSave(updateValue);
          },
          size: size
        }, /*#__PURE__*/React$1.createElement(Icon$2, {
          icon: "Checkmark-16-thick",
          alt: intl.formatMessage(messages$1.confirm),
          size: "16px"
        })), /*#__PURE__*/React$1.createElement(CloseButton, {
          onClick: function onClick() {
            return onCancel && onCancel();
          },
          size: size
        }, /*#__PURE__*/React$1.createElement(Icon$2, {
          icon: "Close-16-thick",
          alt: intl.formatMessage(messages$1.cancel),
          size: "16px"
        })), onRevert && /*#__PURE__*/React$1.createElement(RevertButton, {
          onClick: function onClick() {
            return onRevert && onRevert();
          },
          size: size
        }, /*#__PURE__*/React$1.createElement(Icon$2, {
          icon: "Revert-16",
          alt: intl.formatMessage(messages$1.revert),
          size: "16px"
        }))));
      }

      return render(value);
    };

    _this.state = {
      updateValue: props.value
    };
    _this.containerRef = createRef();
    return _this;
  } // This ensures that the event listener is only active when the component is in edit mode


  return InlineTextEdit;
}(Component);

InlineTextEdit.defaultProps = {
  saveOnBlur: false,
  autoFocus: false,
  disabled: false,
  invalid: false,
  autoComplete: "off",
  autoCorrect: "off",
  spellCheck: "false",
  large: false,
  maxLength: 255,
  focused: false,
  locked: false,
  size: SIZES.MEDIUM
};
InlineTextEdit.propTypes = {
  id: PropTypes$1.string.isRequired,
  value: PropTypes$1.string.isRequired,
  editMode: PropTypes$1.bool.isRequired,
  render: PropTypes$1.func.isRequired,
  onChange: PropTypes$1.func,
  onSave: PropTypes$1.func,
  onCancel: PropTypes$1.func,
  onRevert: PropTypes$1.func,
  saveOnBlur: PropTypes$1.bool,
  autoFocus: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  autoComplete: PropTypes$1.string,
  autoCorrect: PropTypes$1.string,
  spellCheck: PropTypes$1.string,
  maxLength: PropTypes$1.number,
  name: PropTypes$1.string,
  autoCapitalize: PropTypes$1.string,
  size: PropTypes$1.oneOf([SIZES.MEDIUM, SIZES.LARGE, SIZES.BIG]),
  focused: PropTypes$1.bool,
  locked: PropTypes$1.bool
};
var InlineTextEdit$1 = injectIntl(InlineTextEdit);

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  padding: 6px 12px;\n  font-size: ", "px;\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose(["\n          background-color: ", ";\n        "]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 0 12px;\n  cursor: pointer;\n  color: ", ";\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100%;\n  max-width: ", ";\n  border: ", "px solid ", ";\n  ", ";\n  border-top-width: ", ";\n  transition: border-color 0.2s;\n  overflow: auto;\n  border-bottom-left-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  background-color: #fff;\n  z-index: 1; //to appear above other elements\n  box-sizing: border-box;\n  margin-block-start: 0;\n  margin-block-end: 0;\n  padding-inline-start: 0;\n  //zero margin and padding for IE browsers\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$h() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteralLoose(["\n  background-image: url(", ");\n  background-position: right ", "px center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  padding-right: ", "px;\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}
var DROPDOWN_BORDER_WIDTH = 1;
var DROPDOWN_BORDER_RADIUS = 2;
var CONTENT_FONT_SIZE = 14;
var CHEVRON_WIDTH$1 = 12;
var CHEVRON_SPACING = 12;
var ITEM_ID_PREFIX$1 = "item_id_";
var OWNED_LISTBOX_PREFIX = "owned_listbox_";
var DropdownField = styled(Input)(_templateObject$x(), svgList["Chevron_down-12"], CHEVRON_SPACING, function (props) {
  return props.expanded ? "0px" : DROPDOWN_BORDER_RADIUS + "px";
}, function (props) {
  return props.expanded ? "0px" : DROPDOWN_BORDER_RADIUS + "px";
}, CHEVRON_SPACING * 2 + CHEVRON_WIDTH$1);
var DropdownWrap$1 = styled.div(_templateObject2$h());

var getListMaxWidth = function getListMaxWidth(listMaxWidth) {
  if (typeof listMaxWidth === "number") {
    return listMaxWidth + "px";
  } else if (typeof listMaxWidth === "string") {
    return listMaxWidth;
  }

  return "initial";
};

var ItemsWrap = styled.ul(_templateObject3$a(), function (props) {
  return getListMaxWidth(props.listMaxWidth);
}, DROPDOWN_BORDER_WIDTH, COLORS.GRAY_COLORS.GRAY_88, function (props) {
  return getBorderColorDefinition(props);
}, function (props) {
  return props.showListTopBorder ? "1px" : "0px";
}, DROPDOWN_BORDER_RADIUS, DROPDOWN_BORDER_RADIUS, function (props) {
  return props.showListTopBorder ? DROPDOWN_BORDER_RADIUS + "px" : 0;
}, function (props) {
  return props.showListTopBorder ? DROPDOWN_BORDER_RADIUS + "px" : 0;
});
var DropdownItem = styled.li(_templateObject4$5(), COLORS.GRAY_COLORS.GRAY_35, function (props) {
  return props.selected ? css(_templateObject5$3(), COLORS.ACTION_COLORS.BLUE_ITEM_HIGHLIGHT) : "";
}, COLORS.ACTION_COLORS.BLUE_ITEM_HIGHLIGHT, COLORS.GRAY_COLORS.GRAY_25);
var EmptyDropdown = styled.div(_templateObject6$2(), COLORS.GRAY_COLORS.GRAY_78, CONTENT_FONT_SIZE);

var getIdByValue = function getIdByValue(value) {
  return "" + ITEM_ID_PREFIX$1 + value;
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "setSelectedItem":
      //item selected by user from the list of options (either by mouseclick or enter/space key press)
      return _objectSpread2({}, state, {
        selectedItem: _objectSpread2({}, action.selectedItem),
        highlightedItem: _objectSpread2({}, action.selectedItem)
      });

    case "listUpdate":
      //clonned `list` of options, updated for `id` value
      return _objectSpread2({}, state, {
        listWithIds: [].concat(action.listWithIds)
      });

    case "highlightNext":
      return _objectSpread2({}, state, {
        highlightedItem: state.listWithIds[Math.min(state.highlightedItem.index + 1, state.listWithIds.length - 1 //not higher than list.length
        )]
      });

    case "highlightPrev":
      return _objectSpread2({}, state, {
        highlightedItem: state.listWithIds[Math.max(state.highlightedItem.index - 1, 0)]
      });

    case "setHighlightedItem":
      //highlighted item in the list of options (could be different to what selected item is, as there could be one option highlighted while other can be clicked)
      //highlight just makes the item visible and does not fire onChange event when changing
      //selectItem fires onChange event
      return _objectSpread2({}, state, {
        highlightedItem: action.highlightedItem
      });

    default:
      return _objectSpread2({}, state);
  }
};

var injectIds = function injectIds(list) {
  return list.map(function (item, index) {
    return _objectSpread2({}, item, {
      id: item.id || getIdByValue(item.value),
      index: index
    });
  });
};

var Dropdown$2 = forwardRef(function (_ref, ref) {
  var _useKeyDown;

  var list = _ref.list,
      onChange = _ref.onChange,
      size = _ref.size,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      value = _ref.value,
      placeholder = _ref.placeholder,
      noItemsPlaceholder = _ref.noItemsPlaceholder,
      ariaLabel = _ref.ariaLabel,
      triggerEl = _ref.triggerEl,
      listMaxWidth = _ref.listMaxWidth,
      showListTopBorder = _ref.showListTopBorder,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? Math.random().toString(36).replace(/[^a-z]+/g, "") : _ref$id;
  var windowSize = useWindowSize();

  var _useReducer = useReducer(reducer, {
    listWithIds: [],
    selectedItem: {
      text: ""
    },
    //empty text to avoid React's "A component is changing an uncontrolled input of type text to be controlled" warning
    highlightedItem: {}
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1]; //update list of items when new list props are passed from outside


  useEffect(function () {
    //  - update given `list` for generated ids so they can be used for ARIA handling
    var listWithIds = injectIds(list);

    if (!equals(listWithIds, state.listWithIds)) {
      var _state$selectedItem, _state$highlightedIte;

      dispatch({
        type: "listUpdate",
        listWithIds: listWithIds
      });
      var selectedItem = listWithIds.find(function (item) {
        return item.value === value;
      });

      if (selectedItem && ((_state$selectedItem = state.selectedItem) == null ? void 0 : _state$selectedItem.value) !== (selectedItem == null ? void 0 : selectedItem.value)) {
        dispatch({
          type: "setSelectedItem",
          selectedItem: selectedItem
        });
      }

      var itemToHighlight = selectedItem || listWithIds[0] || {};

      if (((_state$highlightedIte = state.highlightedItem) == null ? void 0 : _state$highlightedIte.value) !== itemToHighlight.value) {
        dispatch({
          type: "setHighlightedItem",
          highlightedItem: itemToHighlight
        });
      }
    }
  }, [list, state.highlightedItem, state.listWithIds, state.selectedItem, value]); //handle open/closed state

  var _useState = useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1]; //isHover state to make two sibling elements hovered at the same time


  var _useState2 = useState(undefined),
      isHover = _useState2[0],
      setHover = _useState2[1];

  var dropdownWrapRef = useRef();
  var dropdownFieldRef = useRef(); //hide dropdown on outer click

  useOnClickOutside(dropdownWrapRef, useCallback(function () {
    return setOpen(false);
  }, [setOpen])); //when item is selected in from dropdown list, fire the onChange handler with selected value
  //check for previous value so dropdown doesn't fire in case user selects the same value twice

  var doSelectionAndFocus = useCallback(function (selectedItem) {
    var _state$selectedItem2;

    setOpen(false);

    if (((_state$selectedItem2 = state.selectedItem) == null ? void 0 : _state$selectedItem2.value) !== (selectedItem == null ? void 0 : selectedItem.value)) {
      dispatch({
        type: "setSelectedItem",
        selectedItem: selectedItem
      });
      onChange(selectedItem.value);
    } //selection changes on **mousedown** event, so mouseclick event that happens after, makes <body> to focus.
    //putting the focus() call in settimeout makes it work at the right time (after mouseclick event happens)


    setTimeout(function () {
      dropdownFieldRef.current && dropdownFieldRef.current.focus();
    });
  }, [dispatch, onChange, state.selectedItem]);

  var onConfirm = function onConfirm(event) {
    event.preventDefault(); //don't scroll page (space) or submit form (enter)

    event.stopPropagation();

    if (isOpen) {
      doSelectionAndFocus(state.highlightedItem);
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  var onArrowDown = function onArrowDown(event) {
    event.preventDefault(); //do not scroll the page

    event.stopPropagation();

    if (isOpen) {
      dispatch({
        type: "highlightNext"
      });
    } else {
      setOpen(true);
    }
  };

  var onArrowUp = function onArrowUp(event) {
    event.preventDefault(); //do not scroll the page

    event.stopPropagation();

    if (isOpen) {
      dispatch({
        type: "highlightPrev"
      });
    } else {
      setOpen(true);
    }
  };

  var onEsc = function onEsc(event) {
    setOpen(false); //even though highlighted item is set on dropdown list open, we still need to revert aria-activedescendant attribute when list closes

    dispatch({
      type: "setHighlightedItem",
      highlightedItem: state.selectedItem
    });
  }; //TODO: home/end/printable-characters handling is missing,
  //see e.g. https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html


  useKeyDown(dropdownFieldRef, (_useKeyDown = {}, _useKeyDown[KEY_CODES.ARROW_DOWN] = onArrowDown, _useKeyDown[KEY_CODES.ARROW_UP] = onArrowUp, _useKeyDown[KEY_CODES.SPACE] = onConfirm, _useKeyDown[KEY_CODES.ENTER] = onConfirm, _useKeyDown[KEY_CODES.ESC] = onEsc, _useKeyDown)); //this is called whenever options list (dis)appears
  //when present on screen, count the available height for the list so it can scroll if there's a lot of items in the list

  var itemsWrapRef = useCallback(function (dropdownListEl) {
    var dropdownWrapEl = dropdownWrapRef.current;

    if (dropdownListEl !== null && dropdownWrapEl !== null) {
      var boxRect = dropdownWrapEl.getBoundingClientRect();
      dropdownListEl.style.maxHeight = windowSize.height - boxRect.bottom - DROPDOWN_BORDER_WIDTH + "px";
    }
  }, [windowSize]);

  var toggleOpen = function toggleOpen() {
    //when there's no given `value` passed to this component, then selectedItem is undefined, so select first item in the list of options
    //TODO: check this again, is listwithids[0] needed?
    dispatch({
      type: "setHighlightedItem",
      highlightedItem: state.selectedItem || state.listWithIds[0]
    });
    setOpen(!isOpen);
  };

  var onItemClick = doSelectionAndFocus;

  var onBlur = function onBlur() {
    setOpen(false);
  };

  useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        dropdownFieldRef.current.focus();
      }
    };
  });
  useEffect(function () {
    if (state.listWithIds) {
      var selectedItem = state.listWithIds.find(function (item) {
        return item.value === value;
      });
      if (selectedItem) dispatch({
        type: "setSelectedItem",
        selectedItem: selectedItem
      });
    }
  }, [value, state.selectedItem.value, state.listWithIds]);
  return /*#__PURE__*/React$1.createElement(DropdownWrap$1, {
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    ref: dropdownWrapRef
  }, triggerEl ? React$1.cloneElement(triggerEl, {
    id: id,
    "aria-expanded": isOpen,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    onMouseDown: toggleOpen,
    size: size,
    disabled: disabled,
    ref: dropdownFieldRef,
    onBlur: onBlur,
    "aria-activedescendant": state.highlightedItem ? state.highlightedItem.id : "",
    "aria-owns": "" + OWNED_LISTBOX_PREFIX + id,
    value: state.selectedItem ? state.selectedItem.text : "",
    placeholder: placeholder
  }) : /*#__PURE__*/React$1.createElement(DropdownField, {
    id: id,
    "aria-expanded": isOpen,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    expanded: isOpen,
    onMouseDown: toggleOpen,
    size: size,
    disabled: disabled,
    invalid: invalid,
    "aria-invalid": invalid,
    hovered: isHover,
    ref: dropdownFieldRef,
    onBlur: onBlur,
    "aria-activedescendant": state.highlightedItem ? state.highlightedItem.id : "",
    "aria-owns": "" + OWNED_LISTBOX_PREFIX + id,
    value: state.selectedItem ? state.selectedItem.text : "",
    placeholder: placeholder,
    readOnly: true
  }), isOpen && state.listWithIds && /*#__PURE__*/React$1.createElement(ItemsWrap, {
    disabled: disabled,
    hovered: isHover,
    ref: itemsWrapRef,
    role: "listbox",
    "aria-labelledby": id,
    id: "" + OWNED_LISTBOX_PREFIX + id,
    listMaxWidth: listMaxWidth,
    showListTopBorder: showListTopBorder
  }, state.listWithIds.map(function (item) {
    var isSelected = state.highlightedItem ? item.id === state.highlightedItem.id : false;
    return /*#__PURE__*/React$1.createElement(DropdownItem, {
      role: "option",
      onMouseDown: function onMouseDown() {
        onItemClick(item);
      },
      key: item.id,
      id: item.id,
      selected: isSelected,
      "aria-selected": isSelected
    }, item.text);
  }), state.listWithIds.length === 0 && /*#__PURE__*/React$1.createElement(EmptyDropdown, null, /*#__PURE__*/React$1.createElement("i", null, noItemsPlaceholder))));
});
Dropdown$2.defaultProps = {
  disabled: false,
  invalid: false,
  size: SIZES.MEDIUM,
  placeholder: "Select",
  noItemsPlaceholder: "No options",
  list: []
};
Dropdown$2.propTypes = {
  id: PropTypes$1.string,
  triggerEl: PropTypes$1.node,
  //string, element whatever can be passed here to act as a dropdown trigger; if not provided, than RC's Input will be used
  list: PropTypes$1.arrayOf(PropTypes$1.shape({
    value: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
    text: PropTypes$1.string.isRequired,
    id: PropTypes$1.string //not needed, will be generated when not provided

  })).isRequired,
  onChange: PropTypes$1.func.isRequired,
  size: PropTypes$1.oneOf(Object.keys(SIZES).map(function (e) {
    return SIZES[e];
  })),
  //used object.keys method to avoid polyfill object.values for IE11
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  value: PropTypes$1.any,
  placeholder: PropTypes$1.string,
  noItemsPlaceholder: PropTypes$1.string,
  ariaLabel: PropTypes$1.string.isRequired,
  //required
  listMaxWidth: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  //limit the popup list to a defined width or make it auto-width; If not provided, initial value is used.
  showListTopBorder: PropTypes$1.bool //explicitly set the visibility of list top border. When not set there's no top border on the list

};

var _positions;

function _templateObject2$g() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 1px solid #d1d2d4;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16);\n  border-radius: 4px;\n  padding: 6px 0;\n  display: inline-block;\n  min-width: 190px;\n  background-color: #ffffff;\n  z-index: 10;\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  left: ", ";\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$w() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 100%;\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}
var LEFT = "left";
var BOTTOM = "bottom";
var BOTTOMLEFT = "bottom-left";
var positions = (_positions = {}, _positions[LEFT] = {
  top: 0,
  right: "100%"
}, _positions[BOTTOM] = {
  top: "100%",
  left: 0
}, _positions[BOTTOMLEFT] = {
  top: "100%"
}, _positions);

var getTop = function getTop(menuPosition) {
  return positions[menuPosition].top;
};

var getRight = function getRight(menuPosition) {
  return positions[menuPosition].right;
};

var getLeft = function getLeft(menuPosition) {
  return positions[menuPosition].left;
};

var Wrap = styled.div(_templateObject$w());
var MenuWrap = styled.div(_templateObject2$g(), function (props) {
  return getTop(props.position);
}, function (props) {
  return getRight(props.position);
}, function (props) {
  return getLeft(props.position);
});

var Menu$2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(Menu, _Component);

  function Menu(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.onTogglerClick = function (event) {
      var isOpen = _this.state.isOpen;

      _this.setState({
        isOpen: !isOpen
      });

      _this.setListeners(!isOpen);
    };

    _this.setListeners = function (isOpen) {
      if (isOpen) {
        _this.registerListeners();
      } else {
        _this.unregisterListeners();
      }
    };

    _this.registerListeners = function () {
      window.addEventListener("mousedown", _this.onMouseDown, false);
      window.addEventListener("click", _this.onMouseClick, false);
    };

    _this.unregisterListeners = function () {
      window.removeEventListener("mousedown", _this.onMouseDown);
      window.removeEventListener("click", _this.onMouseClick);
    };

    _this.onMouseDown = function (event) {
      if (!_this.wrap.contains(event.target) && _this.state.isOpen) {
        _this.setState({
          isOpen: false
        });

        _this.setListeners(false);
      }
    };

    _this.onMouseClick = function (event) {
      if (_this.menuWrap && _this.menuWrap.contains(event.target) && _this.state.isOpen) {
        _this.setState({
          isOpen: false
        });

        _this.setListeners(false);
      }
    };

    _this.setMenuWrapPosition = function () {
      if (_this.toggleEl) {
        switch (_this.props.position) {
          case BOTTOMLEFT:
            var toggleRect = _this.toggleEl.getBoundingClientRect();

            var menuWrapRect = _this.menuWrap.getBoundingClientRect();

            _this.menuWrap.style.left = toggleRect.width - menuWrapRect.width + "px";
            break;

        }
      }
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  var _proto = Menu.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        toggle = _this$props.toggle,
        position = _this$props.position,
        children = _this$props.children;
    var toggleEl = React$1.cloneElement(toggle, {
      ref: function ref(tglEl) {
        if (tglEl) {
          _this2.toggleEl = tglEl;
        }
      },
      onClick: this.onTogglerClick
    });
    return /*#__PURE__*/React$1.createElement(Wrap, {
      ref: function ref(wrap) {
        if (wrap) {
          _this2.wrap = wrap;
          _this2.togglerWidth = wrap.offsetWidth;
        }
      }
    }, toggleEl, this.state.isOpen ? /*#__PURE__*/React$1.createElement(MenuWrap, {
      ref: function ref(menuWrap) {
        if (menuWrap) {
          _this2.menuWrap = menuWrap;
        }

        _this2.setMenuWrapPosition();
      },
      togglerWidth: this.togglerWidth,
      position: position
    }, children) : null);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unregisterListeners();
  };

  return Menu;
}(Component);

Menu$2.defaultProps = {
  position: BOTTOM
};
Menu$2.propTypes = {
  toggle: PropTypes$1.element,
  position: PropTypes$1.oneOf([LEFT, BOTTOM, BOTTOMLEFT])
};

function _templateObject$v() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n  color: #333333;\n  cursor: pointer;\n  transition: background-color 0.1s;\n  background: #ffffff;\n  border: none;\n  font-size: 14px;\n  display: block;\n  width: 100%;\n  text-align: left;\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}
var MenuItem = styled.button(_templateObject$v(), COLORS.ACTION_COLORS.BLUE_ITEM_HIGHLIGHT);

function _templateObject$u() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid #d1d2d4;\n  height: 1px;\n  margin: 6px 10px;\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}
var MenuDivider = styled.div(_templateObject$u());

function _templateObject$t() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin: 0 8px 0 0;\n  width: 52px;\n  letter-spacing: -1px;\n  line-height: 44px;\n  font-size: 18px;\n  transform: translate(-1px, 0) rotate(-90deg);\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n  display: \"inline-block\";\n  outline-offset: -4px;\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}
var MenuButton = styled.button(_templateObject$t(), function (_ref) {
  var theme = _ref.theme;
  return theme.textColor;
}, function (_ref2) {
  var theme = _ref2.theme,
      toggled = _ref2.toggled;
  return toggled ? theme.dropdownBgColor : theme.primaryColor;
});
function HamburgerMenu(_ref3) {
  var onClick = _ref3.onClick,
      menuVisible = _ref3.menuVisible;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React$1.createElement(MenuButton, {
    "aria-label": "Open the menu",
    theme: theme,
    onClick: onClick,
    toggled: menuVisible
  }, "|||");
}
HamburgerMenu.propTypes = {
  onClick: PropTypes$1.func,
  menuVisible: PropTypes$1.bool
};

function MenuLink(_ref) {
  var href = _ref.href,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose$1(_ref, ["href", "children"]);

  var attributes = {
    role: "menuitem",
    tabIndex: 0
  };

  if (href === undefined) {
    return /*#__PURE__*/React$1.createElement("button", _extends$2({}, props, attributes), children);
  }

  return /*#__PURE__*/React$1.createElement(RCLink, _extends$2({
    href: href
  }, props, attributes), children);
}
MenuLink.propTypes = {
  href: PropTypes$1.string,
  onClick: PropTypes$1.func
};

var NAVBAR_HEIGHT = 52;
var NAVBAR_MOBILE_WIDTH = 312;
var NAVBAR_DESKTOP_PADDING = 32;
var MENU_ITEM_MOBILE_HORIZONTAL_PADDING = 24;
var MENU_ITEM_DESKTOP_HORIZONTAL_PADDING = 20;
var LOGO_LINK = "/portal";

function _templateObject2$f() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n\n  padding: ", ";\n  line-height: 28px;\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: Roboto, \"Helvetica Neue\", Helvetica, \"Segoe UI\", Arial,\n    sans-serif;\n  color: inherit;\n  width: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  outline-offset: -3px;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n\n  background: transparent;\n  border: none;\n  font-size: inherit;\n  height: 100%;\n  cursor: pointer;\n  margin: 0;\n\n  text-decoration: none;\n  max-width: 100%;\n\n  padding: ", ";\n  line-height: 51px;\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}
var MenuItemStyles = css(_templateObject$s(), function (props) {
  return props.isMobile ? "100%" : "auto";
}, function (props) {
  return props.isMobile ? "0px " + MENU_ITEM_MOBILE_HORIZONTAL_PADDING + "px" : "0 " + MENU_ITEM_DESKTOP_HORIZONTAL_PADDING + "px";
});
var DropdownItemStyles = css(_templateObject2$f(), MenuItemStyles, function (props) {
  return props.isMobile ? "10px " + MENU_ITEM_MOBILE_HORIZONTAL_PADDING + "px 10px 32px" : "5px " + MENU_ITEM_DESKTOP_HORIZONTAL_PADDING + "px";
});
MenuItemStyles.propTypes = {
  isMobile: PropTypes$1.bool.isRequired
};

function _templateObject3$9() {
  var data = _taggedTemplateLiteralLoose(["\n  line-height: 1.75rem;\n  white-space: nowrap;\n  background-color: inherit;\n  list-style-type: none;\n  position: relative;\n  text-align: left;\n\n  &:focus-within,\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  > a {\n    ", "\n  }\n\n  > button {\n    ", "\n  }\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  top: auto;\n  right: auto;\n  left: auto;\n  background-color: ", ";\n  width: 100%;\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$r() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: ", "px;\n  left: ", ";\n  right: ", ";\n  min-width: 175px;\n  padding: 6px 0;\n  margin: 0;\n  border: 0;\n  box-shadow: 0 4px 12px 0 rgba(45, 46, 46, 0.08),\n    0 1px 4px 0 rgba(45, 46, 46, 0.2);\n  border-radius: 0 0 2px 2px;\n  list-style-type: none;\n  z-index: 1;\n  color: ", ";\n  background-color: ", ";\n  display: ", ";\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}
var DropdownMenu = styled.ul(_templateObject$r(), NAVBAR_HEIGHT, function (_ref) {
  var isRight = _ref.isRight;
  return isRight ? "auto" : 0;
}, function (_ref2) {
  var isRight = _ref2.isRight;
  return isRight ? 0 : "auto";
}, function (props) {
  return props.theme.dropdownTextColor;
}, function (props) {
  return props.theme.dropdownBgColor;
}, function (props) {
  return props.expanded ? "block" : "none";
});
var DropdownMenuMobile = styled(DropdownMenu)(_templateObject2$e(), function (props) {
  return props.theme.dropdownBgColor;
});
var Li$1 = styled.li(_templateObject3$9(), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.textColor;
}, DropdownItemStyles, DropdownItemStyles);

var getLinks = function getLinks(_ref3) {
  var data = _ref3.data,
      isMobile = _ref3.isMobile,
      theme = _ref3.theme;
  return data.map(function (_ref4, index) {
    var title = _ref4.title,
        link = _objectWithoutPropertiesLoose$1(_ref4, ["title"]);

    return /*#__PURE__*/React$1.createElement(Li$1, {
      theme: theme,
      isMobile: isMobile,
      key: index
    }, /*#__PURE__*/React$1.createElement(MenuLink, link, title));
  });
};

function Dropdown$1(_ref5) {
  var isMobile = _ref5.isMobile,
      expanded = _ref5.expanded,
      data = _ref5.data,
      isRight = _ref5.isRight;
  var theme = useContext(ThemeContext);

  if (isMobile) {
    return /*#__PURE__*/React$1.createElement(DropdownMenuMobile, {
      theme: theme,
      expanded: expanded,
      role: "menu"
    }, getLinks({
      data: data,
      isMobile: isMobile,
      theme: theme
    }));
  }

  return /*#__PURE__*/React$1.createElement(DropdownMenu, {
    theme: theme,
    expanded: expanded,
    role: "menu",
    isRight: isRight
  }, getLinks({
    data: data,
    isMobile: isMobile,
    theme: theme
  }));
}
Dropdown$1.defaultProps = {
  isRight: false
};
Dropdown$1.propTypes = {
  isMobile: PropTypes$1.bool,
  expanded: PropTypes$1.bool,
  isRight: PropTypes$1.bool,
  data: PropTypes$1.arrayOf(PropTypes$1.shape({
    href: PropTypes$1.string,
    title: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]),
    onClick: PropTypes$1.func
  }))
};

function _templateObject3$8() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  height: 32px;\n  width: 32px;\n  margin-right: 13px;\n  overflow: hidden;\n  vertical-align: middle;\n  cursor: pointer;\n  border-radius: 50%;\n  text-align: center;\n  align-items: center;\n  font-size: 12px;\n  line-height: 32px;\n  color: #000;\n  background-color: #f3f3f4;\n  letter-spacing: 0.2px;\n  font-weight: 400;\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  color: #999;\n  height: 32px;\n  width: 32px;\n  margin-right: 13px;\n  overflow: hidden;\n  vertical-align: middle;\n  cursor: pointer;\n  border-radius: 50%;\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}
var CHEVRON_WIDTH = 12;

var getTextMaxWidth = function getTextMaxWidth(isMobile, hasDropdown) {
  var chevronSpace = 0;

  if (hasDropdown && isMobile) {
    chevronSpace += CHEVRON_WIDTH;
    chevronSpace += MENU_ITEM_MOBILE_HORIZONTAL_PADDING;
  }

  return chevronSpace > 0 ? "calc(100% - " + chevronSpace + "px)" : "100%";
};

var Avatar$1 = styled.img(_templateObject$q());
var InitialsCircle = styled.div(_templateObject2$d());
var ButtonText = styled.div(_templateObject3$8(), function (_ref) {
  var isMobile = _ref.isMobile,
      hasDropdown = _ref.hasDropdown;
  return "" + getTextMaxWidth(isMobile, hasDropdown);
});

var getFirstName = function getFirstName(name) {
  if (!name) return "";
  return name.split(" ")[0].trim();
};

var getUserMenuTitle = function getUserMenuTitle(data) {
  if (data.profilePicture) {
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Avatar$1, {
      alt: "",
      src: data.profilePicture
    }), getFirstName(data.name));
  }

  if (data.initials) {
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(InitialsCircle, {
      "data-testid": "initials-circle"
    }, data.initials), getFirstName(data.name));
  } // Turns out, this is unreachable code, but leaving here
  // incase isUserMenu determination gets changed


  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Avatar$1, {
    alt: "",
    src: "/images/admin/icons/Avatar-32.svg"
  }), getFirstName(data.name));
};

function MenuCaret(_ref2) {
  var expanded = _ref2.expanded,
      primaryColorIsLight = _ref2.primaryColorIsLight;
  var iconNameDown = "Chevron_down-12-white";
  var iconNameRight = "Chevron_right-12-white";

  if (primaryColorIsLight) {
    iconNameDown = "Chevron_down-12-black";
    iconNameRight = "Chevron_right-12-black";
  }

  return expanded ? /*#__PURE__*/React$1.createElement(Icon$2, {
    name: iconNameDown,
    size: CHEVRON_WIDTH + "px"
  }) : /*#__PURE__*/React$1.createElement(Icon$2, {
    icon: iconNameRight,
    size: CHEVRON_WIDTH + "px"
  });
}

function MenuTitle(_ref3) {
  var data = _ref3.data,
      expanded = _ref3.expanded,
      isMobile = _ref3.isMobile,
      hasDropdown = _ref3.hasDropdown,
      children = _ref3.children;
  var theme = useContext(ThemeContext); //TODO: looks to be weird condition(?)

  var isUserMenu = data && data.initials;
  var title = data.title;
  var buttonLabel = isUserMenu ? getUserMenuTitle(data) : title;
  var titleProps = {
    "aria-haspopup": hasDropdown,
    target: data.target,
    onClick: hasDropdown ? undefined : data.onClick,
    id: data.id
  };

  if (hasDropdown) {
    titleProps = _objectSpread2({}, titleProps, {
      "aria-expanded": expanded
    });
  }

  if (data.href) {
    titleProps = _objectSpread2({}, titleProps, {
      href: data.href
    });
  }

  return /*#__PURE__*/React$1.createElement(MenuLink, titleProps, /*#__PURE__*/React$1.createElement(ButtonText, {
    isMobile: isMobile,
    hasDropdown: hasDropdown
  }, buttonLabel), isMobile && hasDropdown && /*#__PURE__*/React$1.createElement(MenuCaret, {
    expanded: expanded,
    primaryColorIsLight: theme.primaryColorIsLight
  }), children);
}
MenuTitle.propTypes = {
  data: PropTypes$1.shape({
    links: PropTypes$1.arrayOf(PropTypes$1.shape({
      href: PropTypes$1.string,
      title: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]),
      onClick: PropTypes$1.func
    })),
    name: PropTypes$1.string,
    profilePicture: PropTypes$1.string,
    title: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]),
    href: PropTypes$1.string
  }),
  expanded: PropTypes$1.bool,
  isMobile: PropTypes$1.bool,
  hasDropdown: PropTypes$1.bool
};

//IE11 doesn't support Event constructor, so we need to create event old way
var createNewEvent = function createNewEvent(eventName) {
  var event;

  if (typeof Event === "function") {
    event = new Event(eventName);
  } else {
    event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
  }

  return event;
};

function _templateObject$p() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: 0.4px;\n\n  line-height: 1.43;\n  cursor: pointer;\n  text-align: left;\n\n  outline-offset: -5px;\n  //TODO: discuss max-width?; due to translations\n  display: flex;\n  flex-direction: ", ";\n\n  align-items: center;\n  justify-content: space-between;\n\n  position: relative;\n  margin: 0;\n  margin-left: ", ";\n  background-color: ", ";\n  color: ", ";\n  border-bottom: ", ";\n\n  :focus-within,\n  :hover {\n    background-color: ", ";\n  }\n\n  > a {\n    ", "\n    display: block;\n  }\n\n  > button {\n    ", "\n  }\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}
var Li = styled.li(_templateObject$p(), function (props) {
  return props.isMobile && props.hasDropdown ? "column" : "row";
}, function (props) {
  return props.isRight ? "auto" : 0;
}, function (_ref) {
  var toggled = _ref.toggled,
      theme = _ref.theme;
  return toggled ? theme.dropdownBgColor : "inherit";
}, function (_ref2) {
  var toggled = _ref2.toggled,
      theme = _ref2.theme;
  return toggled ? theme.dropdownTextColor : theme.textColor;
}, function (_ref3) {
  var isMobile = _ref3.isMobile,
      theme = _ref3.theme;
  return isMobile ? theme.dropdownMobileItemSeparator + " 1px solid" : "none";
}, function (_ref4) {
  var isMobile = _ref4.isMobile,
      theme = _ref4.theme;
  return isMobile ? "" + theme.primaryColor : "" + theme.dropdownBgColor;
}, MenuItemStyles, MenuItemStyles);
function Menu$1(_ref5) {
  var listen = _ref5.listen,
      setListen = _ref5.setListen,
      alwaysListen = _ref5.alwaysListen,
      isMobile = _ref5.isMobile,
      menu = _ref5.menu;

  var _useState = useState(false),
      expanded = _useState[0],
      setMenuExpanded = _useState[1];

  var theme = useContext(ThemeContext); // When a menu is clicked, dispatch a "hideMenu" event,
  // toggle listenting (stop if listening, start if not listenting)
  // and toggle show (show if hidden, hide if showing).

  var menuClicked = function menuClicked(event) {
    event.stopPropagation();
    window.dispatchEvent(createNewEvent("hideMenu"));
    setListen(!listen);
    setMenuExpanded(!expanded);
  }; // if a menu is entered, fire a "hideMenu" event to tell everyone
  // else to go away. If this menu is in listening mode, it should
  // show itself


  var mouseEnter = function mouseEnter() {
    if (isMobile) {
      return;
    }

    window.dispatchEvent(createNewEvent("hideMenu"));

    if (listen) {
      setMenuExpanded(true);
    }
  }; // when leaving, hide, unless we are in Apple Menu Mode or
  // on mobile. This makes the menus "sticky". They stay open
  // until clicked


  var mouseLeave = function mouseLeave() {
    if (!alwaysListen || isMobile) {
      return;
    }

    setMenuExpanded(false);
  }; // if any menu is focused, it fires a hideMenu event. Every menu
  // listening for this event will hide, including the one that
  // fired the event, but then it shows itself immediately after


  useEffect(function () {
    var focusHandler = function focusHandler() {
      return setMenuExpanded(false);
    };

    window.addEventListener("hideMenu", focusHandler);
    return function () {
      return window.removeEventListener("hideMenu", focusHandler);
    };
  }, []);
  if (menu.length === 0) return null;
  var hasDropdown = menu.links && menu.links.length > 0;
  return /*#__PURE__*/React$1.createElement(Li, {
    isMobile: isMobile,
    theme: theme,
    toggled: expanded,
    isRight: menu.align === "right",
    onMouseEnter: mouseEnter,
    onMouseLeave: mouseLeave,
    onClick: menuClicked,
    hasDropdown: hasDropdown
  }, /*#__PURE__*/React$1.createElement(MenuTitle, {
    data: menu,
    expanded: expanded,
    hasDropdown: hasDropdown,
    isMobile: isMobile
  }), hasDropdown && /*#__PURE__*/React$1.createElement(Dropdown$1, {
    isMobile: isMobile,
    expanded: expanded,
    data: menu.links,
    isRight: menu.alignDropdown === "right"
  }));
}
Menu$1.defaultProps = {
  menu: []
};
Menu$1.propTypes = {
  listen: PropTypes$1.bool,
  setListen: PropTypes$1.func,
  alwaysListen: PropTypes$1.bool,
  isMobile: PropTypes$1.bool,
  menu: PropTypes$1.object
};

function _templateObject2$c() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  bottom: 0;\n  width: ", "px;\n  padding: 0 0 0.5rem 0;\n  overflow-x: hidden;\n  background-color: ", ";\n  margin-left: ", ";\n  transition: margin-left 0.4s ease-in-out;\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  padding-inline-start: 0;\n  list-style-type: none;\n  white-space: nowrap;\n  flex-grow: 1;\n  display: flex;\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}
var DesktopMenus = styled.ul(_templateObject$o());
var MobileMenus = styled(DesktopMenus)(_templateObject2$c(), NAVBAR_HEIGHT, NAVBAR_MOBILE_WIDTH, function (_ref) {
  var theme = _ref.theme;
  return theme.dropdownBgColor;
}, function (_ref2) {
  var expanded = _ref2.expanded;
  return expanded ? "0" : -(NAVBAR_MOBILE_WIDTH + 1) + "px";
});

var getMenus = function getMenus(menuData, props) {
  return menuData.map(function (menu, idx) {
    return /*#__PURE__*/React$1.createElement(Menu$1, {
      listen: props.listen,
      setListen: props.setListen,
      alwaysListen: props.alwaysListen,
      isMobile: props.isMobile,
      menu: menu,
      key: idx
    });
  });
};

var Menus = forwardRef(function (props, ref) {
  var menus = props.menus,
      isMobile = props.isMobile,
      mobileMenuExpanded = props.mobileMenuExpanded;

  var _useState = useState([]),
      menuData = _useState[0],
      setMenuData = _useState[1];

  var _useState2 = useState(false),
      renderMenus = _useState2[0],
      setRenderMenus = _useState2[1];

  var theme = useContext(ThemeContext);
  var handleTransitionEnd = useCallback(function () {
    return !mobileMenuExpanded && setRenderMenus(false);
  }, [mobileMenuExpanded]); // this is goofy, but the way to align items in flexbox is to add
  // margin-left: auto to the FIRST element of the right-aligned
  // elements. This de-dupes the align prop so the elements squish
  // together on the right instead of taking equal space
  // Additionally, IF at least one item is aligned right, then the
  // right-most (last) element needs to right-align the dropdown menu

  useEffect(function () {
    var aligned = false;
    var data = menus.map(function (menu) {
      if (menu.align) {
        if (aligned) delete menu.align;
        aligned = true;
      }

      return menu;
    });
    if (aligned) data[data.length - 1].alignDropdown = "right";
    setMenuData(data);
  }, [menus]);
  useEffect(function () {
    if (mobileMenuExpanded) setRenderMenus(true);
  }, [mobileMenuExpanded]);
  useEffect(function () {
    var current = ref == null ? void 0 : ref.current;

    if (current) {
      current.addEventListener("transitionend", handleTransitionEnd);
    }
    return function () {
      current.removeEventListener("transitionend", handleTransitionEnd);
    };
  }, [ref, handleTransitionEnd]);

  if (isMobile) {
    return /*#__PURE__*/React$1.createElement(MobileMenus, {
      expanded: mobileMenuExpanded,
      theme: theme,
      ref: ref
    }, renderMenus && getMenus(menuData, props));
  }

  return /*#__PURE__*/React$1.createElement(DesktopMenus, {
    theme: theme,
    ref: ref
  }, getMenus(menuData, props));
});
Menus.defaultProps = {
  menus: []
};
Menus.propTypes = {
  menus: PropTypes$1.array,
  listen: PropTypes$1.bool,
  setListen: PropTypes$1.func,
  alwaysListen: PropTypes$1.bool,
  isMobile: PropTypes$1.bool,
  mobileMenuExpanded: PropTypes$1.bool
};

function _templateObject2$b() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  overflow: hidden;\n  max-width: 300px;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  outline-offset: -3px;\n  margin-right: 32px;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n  display: block;\n  max-width: 100%;\n  max-height: 40px;\n  height: auto;\n  width: auto;\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
var messages = defineMessages({
  companyLogo: {
    "id": "companyLogo",
    defaultMessage: "company logo"
  }
});
var Img = styled.img(_templateObject$n());
var LogoWrapper = styled.div(_templateObject2$b());
var Logo = forwardRef(function (_ref, ref) {
  var href = _ref.href;
  var theme = useContext(ThemeContext);
  var intl = useIntl();
  var bDefaultImg = theme.logoUrl === "/images/logo_default@2x.png";
  var logo = bDefaultImg ? /*#__PURE__*/React$1.createElement(ImgSvg, {
    fillColor: theme.textColor,
    "aria-label": intl.formatMessage(messages.companyLogo)
  }) : /*#__PURE__*/React$1.createElement(Img, {
    alt: intl.formatMessage(messages.companyLogo),
    src: theme.logoUrl,
    "aria-label": intl.formatMessage(messages.companyLogo)
  }); //NOTE: `href` is not tied to aria-label; we assume logo link always points to portal

  return /*#__PURE__*/React$1.createElement(LogoWrapper, {
    ref: ref
  }, /*#__PURE__*/React$1.createElement(RCLink, {
    href: href,
    "aria-label": intl.formatMessage(messages.companyLogo)
  }, logo));
});
Logo.propTypes = {
  href: PropTypes$1.string.isRequired
};

function ImgSvg(_ref2) {
  var fillColor = _ref2.fillColor;
  return /*#__PURE__*/React$1.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "40",
    width: "98",
    viewBox: "0 0 98 40"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: fillColor,
    fillRule: "nonzero",
    d: "M32.165 18.83c.219-1.38 1.435-3.095 3.757-3.095 2.153 0 3.397 1.577 3.593 3.095h-7.35zm-2.986 1.106c0 3.813 2.762 6.41 6.798 6.41 2.652 0 4.393-1.3 5.417-2.433.105-.114.165-.274 0-.443l-1.421-1.312c-.165-.165-.325-.105-.444 0-.722.635-1.838 1.645-3.552 1.645-1.988 0-3.428-1.216-3.758-2.76h9.838c.274 0 .444-.165.444-.444v-.608c0-3.648-2.378-6.688-6.41-6.688-4.342 0-6.912 2.962-6.912 6.633zm15.086 5.856c0 .22.11.334.334.334h2.098c.22 0 .334-.11.334-.334V8.274c0-.164-.055-.274-.274-.274h-2.213c-.22 0-.274.11-.274.274v17.518h-.005zm-19.451 0c0 .22.11.334.333.334h2.099c.22 0 .333-.11.333-.334v-7.017c0-2.985-1.769-5.472-5.526-5.472h-.055c-1.824 0-3.205.608-4.032 1.326v-.663c0-.22-.165-.334-.334-.334h-2.098c-.22 0-.334.11-.334.334v11.826c0 .22.11.334.334.334h2.098c.22 0 .334-.11.334-.334v-6.519c0-2.043 1.051-3.538 3.483-3.538 2.432 0 3.37 1.49 3.37 3.538v6.519h-.005zm39.803 3.694c.965 1.129 2.994 2.496 5.847 2.496 3.986 0 6.41-2.432 6.41-6.3V13.966c0-.22-.11-.334-.335-.334h-1.988c-.22 0-.334.11-.334.334v.663c-.882-.718-2.043-1.326-3.922-1.326-3.593 0-6.743 2.651-6.743 6.519 0 3.922 3.04 6.519 6.743 6.519 1.737 0 2.953-.636 3.812-1.308v.814c0 2.212-1.284 3.648-3.67 3.648-1.98 0-3.292-1.074-4.124-1.879-.169-.165-.388-.165-.553 0l-1.147 1.317c-.165.164-.165.329.004.553zM10.61 19.822c0 2.212-1.66 3.977-3.867 3.977-2.208 0-3.758-1.879-3.758-3.977v-.11c0-2.098 1.545-3.867 3.758-3.867 2.212 0 3.867 1.769 3.867 3.977zm-10.61 0c0 3.538 2.875 6.519 6.743 6.519 3.867 0 6.743-2.981 6.743-6.52v-.109c0-3.538-2.876-6.41-6.743-6.41-3.868 0-6.743 2.876-6.743 6.52zm59.3 0c0 2.212-1.659 3.977-3.867 3.977-2.212 0-3.758-1.879-3.758-3.977v-.11c0-2.098 1.546-3.867 3.758-3.867 2.208 0 3.868 1.769 3.868 3.977zm-10.614 0c0 3.538 2.875 6.519 6.743 6.519 3.867 0 6.742-2.986 6.742-6.52v-.109c0-3.538-2.875-6.41-6.742-6.41-3.868 0-6.743 2.876-6.743 6.52zm30.784 5.97c0 .22.11.334.333.334h2.099c.22 0 .333-.11.333-.334V13.911c0-.165-.054-.274-.274-.274H79.75c-.22 0-.275.11-.275.274v11.881h-.004zm0-15.31c0 .22.11.334.333.334h2.099c.22 0 .333-.11.333-.334V8.274c0-.164-.054-.274-.274-.274H79.75c-.22 0-.275.11-.275.274v2.208h-.004zm14.92 15.31c0 .22.11.334.335.334h2.098c.22 0 .334-.11.334-.334v-7.017c0-2.985-1.77-5.472-5.527-5.472h-.055c-1.824 0-3.205.608-4.032 1.326v-.663c0-.22-.165-.334-.334-.334h-2.098c-.22 0-.334.11-.334.334v11.826c0 .22.11.334.334.334h2.098c.22 0 .334-.11.334-.334v-6.519c0-2.043 1.051-3.538 3.483-3.538 2.432 0 3.37 1.49 3.37 3.538v6.519h-.005zm-20.228-5.97c0 2.212-1.66 3.977-3.867 3.977-2.213 0-3.758-1.879-3.758-3.977v-.11c0-2.098 1.545-3.867 3.758-3.867 2.212 0 3.867 1.769 3.867 3.977z"
  }));
}

var getTheme = function getTheme(_ref) {
  var accentColor = _ref.accentColor,
      primaryColor = _ref.primaryColor;
  // olThemeProps: PropTypes.shape({
  //   primaryColor: PropTypes.string.isRequired,
  //   accentColor: PropTypes.string.isRequired,
  //   logoUrl: PropTypes.string
  // });
  var dropdownBgColor = darkenOrLighten(primaryColor);
  return {
    /** color provided by OL branding: button color */
    accentColor: accentColor,

    /** color provided by OL branding: navbar background color */
    primaryColor: primaryColor,

    /** text color of menu items in normal state */
    textColor: readableColor(primaryColor),

    /** opened dropdown background color */
    dropdownBgColor: dropdownBgColor,

    /** text color of menu items in opened state */
    dropdownTextColor: readableColor(dropdownBgColor),

    /** mobile view opened dropdown has separators around each item of this color */
    dropdownMobileItemSeparator: darkenOrLighten(dropdownBgColor),

    /** used for rendering proper icons within navbar (chevron-right, chevron-down) */
    primaryColorIsLight: isLight(primaryColor)
  };
};

function _templateObject3$7() {
  var data = _taggedTemplateLiteralLoose(["\n      @media screen and (max-width: ", "px) {\n        width: 100%;\n      }\n    "]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", "px;\n  display: flex;\n  margin: auto;\n  width: ", ";\n  transition: width 0.1s;\n\n  ", "\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$m() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  font-size: ", ";\n  user-select: none;\n  box-sizing: border-box;\n  background-color: ", ";\n  padding: ", ";\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
var Nav = styled.nav(_templateObject$m(), function (props) {
  return props.isMobile ? "16px" : "14px";
}, function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.isMobile ? 0 : "0 " + NAVBAR_DESKTOP_PADDING + "px";
});
var NavContent = styled.div(_templateObject2$a(), NAVBAR_HEIGHT, function (props) {
  return props.maxWidth ? props.maxWidth + "px" : "100%";
}, function (props) {
  return props.maxWidth !== undefined && css(_templateObject3$7(), function (props) {
    return parseInt(props.maxWidth, 10) + (props.isMobile ? 0 : NAVBAR_DESKTOP_PADDING * 2);
  });
}); // helper functions to flatten multi-section menus into single-section menus

var isSectioned = function isSectioned(tab) {
  return tab.menuType === "sectioned_dropdown";
};

var flattenTab = function flattenTab(tab) {
  return tab.sections.map(function (section) {
    return {
      links: section.sectionLinks,
      title: section.sectionHeader
    };
  });
};

var menuReducer = function menuReducer(menus, tab) {
  var sanitizedTab = isSectioned(tab) ? menus.concat(flattenTab(tab)) : menus.concat(tab);
  return sanitizedTab;
};

var flatifyLinks = function flatifyLinks(links) {
  return links.map(function (link) {
    return link;
  });
};

var mobileMenuFlatifyReducer = function mobileMenuFlatifyReducer(menus, tab) {
  var sanitizedTab = tab.links && tab.links.length > 0 ? menus.concat(flatifyLinks(tab.links)) : menus.concat(tab);
  return sanitizedTab;
};

var ITEM_ID_PREFIX = "navbar_item_";
var idCounter = 0;

var getMenuItemId = function getMenuItemId() {
  return "" + ITEM_ID_PREFIX + ++idCounter;
};

var getAriaOwns = function getAriaOwns(menuData) {
  return menuData.map(function (menuItem) {
    return menuItem.id;
  }).join(" ");
};

function Navbar(_ref) {
  var menus = _ref.menus,
      alwaysListen = _ref.alwaysListen,
      maxWidth = _ref.maxWidth,
      mobileBreakpoint = _ref.mobileBreakpoint,
      flatifyMobileMenus = _ref.flatifyMobileMenus;
  var MOBILE_BREAKPOINT = parseInt(mobileBreakpoint || BREAKPOINTS.PHONE_LARGE, 10);
  var windowSize = useWindowSize();

  var _useState = useState(0),
      availableMenuWidth = _useState[0],
      setAvailableMenuWidth = _useState[1];

  var _useState2 = useState(0),
      menuItemsTotalWidth = _useState2[0],
      setMenuItemsTotalWidth = _useState2[1];

  var _useState3 = useState(false),
      mobileMenuVisible = _useState3[0],
      setMobileMenuVisible = _useState3[1];

  var _useState4 = useState([]),
      menuData = _useState4[0],
      setMenuData = _useState4[1];

  var _useState5 = useState(alwaysListen),
      listen = _useState5[0],
      setListen = _useState5[1];

  var _useState6 = useState(false),
      isMobile = _useState6[0],
      setIsMobile = _useState6[1]; //always false for the first time to count width of menu items in desktop view //TODO: decideNeedMobileView()


  var _useState7 = useState(0),
      navbarDesktopPaddings = _useState7[0],
      setNavbarDesktopPaddings = _useState7[1];

  var navRef = useRef(null);
  var logoRef = useRef(null);
  var menusRef = useRef(null);
  var theme = getTheme(useContext(ThemeContext)); // determines if menus listen for mouseover events. In "Apple Style Menus"
  // they don't listen until a menu is clicked and stop listening when
  // another menu or the page is clicked

  var setListenWrapper = useCallback(function (value) {
    setListen(alwaysListen || value);
  }, [alwaysListen]); // when the page is clicked, menus should stop listening for mouseover events

  useEffect(function () {
    var clickHandler = function clickHandler() {
      window.dispatchEvent(createNewEvent("hideMenu"));
      setListenWrapper(false); //this hides mobile menu when clicked outside of it

      if (mobileMenuVisible === true) {
        setMobileMenuVisible(false);
      }
    };

    window.addEventListener("click", clickHandler);
    return function () {
      return window.removeEventListener("click", clickHandler);
    };
  }, [setListenWrapper, mobileMenuVisible]);
  useEffect(function () {
    var getAvailableMenuWidth = function getAvailableMenuWidth() {
      //in mobile view count the nav (screen) width - logo
      //(hamburger is not needed to be counted, as it will disappear when swapped into desktop view)
      if (isMobile) {
        var _navRef$current$getBo = navRef.current.getBoundingClientRect(),
            navWidth = _navRef$current$getBo.width;

        var anchor = logoRef.current;

        var _anchor$getBoundingCl = anchor.getBoundingClientRect(),
            width = _anchor$getBoundingCl.width;

        var _window$getComputedSt = window.getComputedStyle(anchor),
            marginLeft = _window$getComputedSt.marginLeft,
            marginRight = _window$getComputedSt.marginRight;

        var anchorWidth = width + parseInt(marginLeft, 10) + parseInt(marginRight, 10); //whole width - logo width makes available space for rendering menu items;

        return navWidth - anchorWidth - navbarDesktopPaddings;
      } else {
        //in desktop view, get UL element
        var ul = menusRef.current;

        var _window$getComputedSt2 = window.getComputedStyle(ul),
            overflow = _window$getComputedSt2.overflow; //hide overflow temporarily to count the available width properly


        ul.style.overflow = "hidden";

        var _ul$getBoundingClient = ul.getBoundingClientRect(),
            _width = _ul$getBoundingClient.width;

        ul.style.overflow = overflow; //set back original overflow

        return _width;
      }
    };

    setAvailableMenuWidth(getAvailableMenuWidth());
  }, [windowSize, navbarDesktopPaddings, isMobile]); //count <nav>'s padding, only in desktop view (which is drawn by default), only once

  useEffect(function () {
    var _window$getComputedSt3 = window.getComputedStyle(navRef.current),
        paddingLeft = _window$getComputedSt3.paddingLeft,
        paddingRight = _window$getComputedSt3.paddingRight;

    setNavbarDesktopPaddings(parseInt(paddingLeft, 10) + parseInt(paddingRight, 10));
  }, []); // when the component mounts, flatten the menu data.
  // The pre-revlon navbar had sections, the new navbar does not

  useEffect(function () {
    var menusToReduce = menus;

    if (flatifyMobileMenus && isMobile) {
      menusToReduce = menus.reduce(mobileMenuFlatifyReducer, []).map(function (_ref2) {
        var onClick = _ref2.onClick,
            menuItem = _objectWithoutPropertiesLoose$1(_ref2, ["onClick"]);

        var modifiedOnClick = function modifiedOnClick(event) {
          onClick && onClick(event);
          setMobileMenuVisible(false); //always hide mobile menu when item is clicked
        };

        return _objectSpread2({}, menuItem, {
          onClick: modifiedOnClick
        });
      });
    }

    var reducedMenu = menusToReduce.reduce(menuReducer, []).map(function (menuItem) {
      var newMenuItem = _objectSpread2({}, menuItem, {
        id: menuItem.id || getMenuItemId(),
        title: menuItem.title || menuItem.name,
        profilePicture: menuItem.picture
      });

      if (menuItem.links && menuItem.links.length) {
        newMenuItem.links = menuItem.links.map(function (_ref3) {
          var onClick = _ref3.onClick,
              link = _objectWithoutPropertiesLoose$1(_ref3, ["onClick"]);

          var modifiedOnClick = function modifiedOnClick(event) {
            onClick && onClick(event);
            setMobileMenuVisible(false); //always hide mobile menu when item is clicked
          };

          return _objectSpread2({}, link, {
            onClick: modifiedOnClick
          });
        });
      }

      return newMenuItem;
    });
    setMenuData(reducedMenu);
  }, [menus, isMobile, flatifyMobileMenus]); //count width of rendered menu and decide whether to show desktop or mobile menu

  useLayoutEffect(function () {
    //IE10 (and possibly other browsers) don't support MutationObserver at all.
    //In these browsers only MOBILE_BREAKPOINT is taken into account when resizing screen, not the width of menu items
    if (!navRef.current || !window.MutationObserver) {
      return;
    } //very naive counting of item widths. Changed items are awaited only once, then observer disconnects itself
    //should be probably solved better way


    var callback = function callback(mutations) {
      var totalWidth = 0;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          var _node$getBoundingClie = node.getBoundingClientRect(),
              width = _node$getBoundingClie.width;

          totalWidth += width;
        });
      });
      setMenuItemsTotalWidth(totalWidth); //desktop width of all menu items is counted, so make the menus active (<ul> parent styles changes a bit)

      observer.disconnect();
    };

    var observer = new MutationObserver(callback);

    if (!isMobile) {
      //set an observer to watch for childlist changes, so whenever new menu is added to the view we can count its width.
      //this may happen in as a bulk change (so all menu items are handled in one call)
      //react rendering works as follows in this case:
      // - Nav element + empty HamburgerMenu, Logo and Menus are present when this observer is set.
      // All mentioned elements has their widths already set because of CSS styling is already applied.
      // So Menus element has all the available width within navbar, we can use this value to count if menu items/dropdowns gonna fit it
      observer.observe(navRef.current, {
        childList: true,
        subtree: true
      });
    }

    return function () {
      return observer.disconnect();
    };
  }, [isMobile]);
  useEffect(function () {
    //in IE10 menuItemsTotalWidth is always 0; so only MOBILE_BREAKPOINT is taken into acount when deciding isMobile prop.
    var isMobile = windowSize.width <= MOBILE_BREAKPOINT || menuItemsTotalWidth > availableMenuWidth;
    setIsMobile(isMobile);
  }, [availableMenuWidth, menuItemsTotalWidth, windowSize, MOBILE_BREAKPOINT]);
  return /*#__PURE__*/React$1.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React$1.createElement(Nav, {
    theme: theme,
    isMobile: isMobile,
    ref: navRef
  }, /*#__PURE__*/React$1.createElement(NavContent, {
    maxWidth: maxWidth,
    role: "menu",
    "aria-owns": getAriaOwns(menuData)
  }, isMobile && /*#__PURE__*/React$1.createElement(HamburgerMenu, {
    onClick: function onClick() {
      return setMobileMenuVisible(!mobileMenuVisible);
    },
    menuVisible: mobileMenuVisible
  }), /*#__PURE__*/React$1.createElement(Logo, {
    ref: logoRef,
    href: LOGO_LINK
  }), /*#__PURE__*/React$1.createElement(Menus, {
    menus: menuData,
    listen: listen,
    setListen: setListenWrapper,
    alwaysListen: alwaysListen,
    isMobile: isMobile,
    mobileMenuExpanded: mobileMenuVisible,
    ref: menusRef
  }))));
}
Navbar.defaultProps = {
  alwaysListen: false,
  //TODO: property should be removed completely; default behavior should be discussed, but agreed across projects
  flatifyMobileMenus: false
};
Navbar.propTypes = {
  menus: PropTypes$1.array.isRequired,
  maxWidth: PropTypes$1.number,
  mobileBreakpoint: PropTypes$1.number,
  alwaysListen: PropTypes$1.bool,

  /**
   * in portal and profile, there's few of menu items, let's make user menu items to be expanded right into top level (in mobile view)
   */
  flatifyMobileMenus: PropTypes$1.bool
};

function _templateObject$l() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  font-size: 21px;\n  left: 0;\n  right: 0;\n  z-index: 1;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  line-height: 1;\n  background-color: ", ";\n  height: 70px;\n  padding: 0 32px;\n  border-bottom: solid 1px ", ";\n  margin: 0;\n  box-shadow: ", ";\n\n  @media only screen and (max-width: ", ") {\n    padding: 0 1em;\n    padding-left: 55px;\n  }\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var HeadingWrap = styled.header(_templateObject$l(), COLORS.WHITE, COLORS.GRAY_COLORS.GRAY_92, function (_ref) {
  var scroll = _ref.scroll;
  return scroll ? "0 1px 6px 0 rgba(0, 0, 0, 0.1)" : "none";
}, BREAKPOINTS.PORTAL_MIDDLE);

var Heading = function Heading(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutPropertiesLoose$1(_ref2, ["children"]);

  var _useState = useState(false),
      scroll = _useState[0],
      setScroll = _useState[1];

  useEffect(function () {
    var callback = function callback() {
      return setScroll(window.scrollY > 20);
    };

    document.addEventListener("scroll", callback);
    return function () {
      return document.removeEventListener("scroll", callback);
    };
  }, []);
  return /*#__PURE__*/React$1.createElement(HeadingWrap, _extends$2({}, props, {
    scroll: scroll
  }), children);
};

function _templateObject$k() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  background: ", ";\n  display: grid;\n  grid-template-columns: 233px 1fr;\n  grid-column-gap: 2em;\n\n  @media only screen and (max-width: ", ") {\n    grid-template-columns: 1fr;\n\n    padding: ", ";\n  }\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var Body = styled.div(_templateObject$k(), function (_ref) {
  var noHeading = _ref.noHeading;
  return noHeading ? "32px" : "78px 32px 32px";
}, COLORS.GRAY_98, BREAKPOINTS.PORTAL_MIDDLE, function (_ref2) {
  var noHeading = _ref2.noHeading;
  return noHeading ? "32px 1em" : "78px 1em 32px";
});
Body.propTypes = {
  noHeading: PropTypes$1.bool
};

function _templateObject$j() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  color: ", ";\n  font-size: 21px;\n  font-weight: normal;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-rendering: optimizeLegibility;\n  white-space: nowrap;\n  align-items: center;\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
function useSetDocumentTitle(title) {
  if (title === void 0) {
    title = "Administration";
  }

  var _useState = useState(title + " | OneLogin"),
      formatted = _useState[0],
      setFormatted = _useState[1];

  useEffect(function () {
    document.title = formatted;
  }, [formatted]);
  useEffect(function () {
    setFormatted(title + " | OneLogin");
  }, [title]);
  return formatted;
}
var TitleContainer = styled.h1(_templateObject$j(), COLORS.GRAY_COLORS.GRAY_25);

var Title = function Title(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose$1(_ref, ["children"]);

  useSetDocumentTitle(children);
  return /*#__PURE__*/React$1.createElement(TitleContainer, props, children);
};

Title.propTypes = {};

function _templateObject$i() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 90%;\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var Screen = styled.div(_templateObject$i());

function _templateObject$h() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 22px;\n  color: ", ";\n  margin-top: 20px;\n  margin-bottom: 16px;\n  font-weight: normal;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var ScreenHeader = styled.div(_templateObject$h(), COLORS.GRAY_COLORS.GRAY_25);

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: auto;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  position: absolute;\n  top: 8px;\n  left: 16px;\n  z-index: 5;\n  font-size: 22px;\n  box-sizing: border-box;\n  margin-top: 12px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var ToggleContent = styled.div(_templateObject$g());
var StyledIcon = styled(Icon$2)(_templateObject2$9());
var DropdownToggle = forwardRef(function (_ref, ref) {
  var _useKeyDown, _intl$formatMessage;

  var isOpen = _ref.isOpen,
      _onClick = _ref.onClick,
      _ref$setShouldFocus = _ref.setShouldFocus,
      setShouldFocus = _ref$setShouldFocus === void 0 ? function () {} : _ref$setShouldFocus,
      _ref$shouldFocus = _ref.shouldFocus,
      shouldFocus = _ref$shouldFocus === void 0 ? false : _ref$shouldFocus;
  var intl = useIntl();
  useEffect(function () {
    if (ref.current && shouldFocus) {
      ref.current.focus();
    }
  }, [ref, shouldFocus]);

  var onConfirm = function onConfirm(event) {
    event.preventDefault(); //don't scroll page (space) or submit form (enter)

    event.stopPropagation();
    setShouldFocus(true);

    _onClick();
  };

  useKeyDown(ref, (_useKeyDown = {}, _useKeyDown[KEY_CODES.SPACE] = onConfirm, _useKeyDown[KEY_CODES.ENTER] = onConfirm, _useKeyDown));
  return /*#__PURE__*/React$1.createElement(ToggleContent, {
    tabIndex: 0,
    ref: ref,
    onClick: function onClick() {
      _onClick();

      setShouldFocus(false);
    },
    isOpen: isOpen,
    role: "button"
  }, /*#__PURE__*/React$1.createElement(StyledIcon, {
    size: "16px",
    icon: isOpen ? "Chevron_up-16" : "Chevron_down-16",
    alt: intl.formatMessage((_intl$formatMessage = {
      defaultMessage: "Open menu",
      "id": "3499598078"
    }, _intl$formatMessage["id"] = "3499598078", _intl$formatMessage))
  }));
});
DropdownToggle.propTypes = {
  onClick: PropTypes$1.func.isRequired,
  isOpen: PropTypes$1.bool.isRequired,
  setShouldFocus: PropTypes$1.func,
  shouldFocus: PropTypes$1.bool
};

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  font-size: 21px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  letter-spacing: normal;\n  color: ", ";\n  border-bottom: solid 1px ", ";\n  padding-left: 55px;\n  padding-right: 1em;\n  height: 70px;\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  bottom: 0;\n  position: absolute;\n  top: ", "px;\n  text-align: left;\n  overflow-y: auto;\n  margin: 0;\n  display: inline;\n  height: auto;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var PADDING_TOP = 20;
var Overlay = styled.div(_templateObject$f(), function (props) {
  return props.top;
});
var DropdownWrap = styled.div(_templateObject2$8(), COLORS.WHITE);
var DropdownItems = styled.div(_templateObject3$6(), COLORS.WHITE);
var ActiveTitle = styled.div(_templateObject4$4(), COLORS.GRAY_COLORS.GRAY_25, COLORS.GRAY_COLORS.GRAY_92);

var Dropdown = function Dropdown(_ref) {
  var _ref$activeItemTitle = _ref.activeItemTitle,
      activeItemTitle = _ref$activeItemTitle === void 0 ? "" : _ref$activeItemTitle,
      children = _ref.children;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(),
      top = _useState2[0],
      setTop = _useState2[1];

  var dropdownToggleEl = useRef(null);
  var dropdownWrapEl = useRef(null);

  var _useState3 = useState(false),
      shouldFocus = _useState3[0],
      setShouldFocus = _useState3[1];

  if (dropdownToggleEl.current) {
    dropdownToggleEl.current.focus();
  }

  var closeModal = function closeModal(e) {
    if (!dropdownWrapEl.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  var onTogglerClick = function onTogglerClick() {
    //when dropdown is going to open, count the top position
    //it can change in time, e.g. navBar menu will be open or password expiration bar is displayed etc
    if (!isOpen && dropdownToggleEl && dropdownToggleEl.current) {
      var size = ReactDOM.findDOMNode(dropdownToggleEl.current).getBoundingClientRect();
      setTop(size.top - PADDING_TOP);
    }

    setIsOpen(function (prev) {
      return !prev;
    });
  };

  var dropdownToggle = /*#__PURE__*/React$1.createElement(DropdownToggle, {
    onClick: onTogglerClick,
    isOpen: isOpen,
    ref: dropdownToggleEl,
    setShouldFocus: setShouldFocus,
    shouldFocus: shouldFocus
  });

  if (isOpen) {
    return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Dimmer, {
      onClick: closeModal
    }, /*#__PURE__*/React$1.createElement(Overlay, {
      top: top,
      "data-testid": "overlay"
    }, /*#__PURE__*/React$1.createElement(DropdownWrap, {
      ref: dropdownWrapEl
    }, dropdownToggle, isOpen && /*#__PURE__*/React$1.createElement(ActiveTitle, null, activeItemTitle), /*#__PURE__*/React$1.createElement(DropdownItems, null, children)))));
  } else {
    return dropdownToggle;
  }
};

Dropdown.propTypes = {
  activeItemTitle: PropTypes$1.node.isRequired
};

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: 6px;\n  font-size: 14px;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  border-right: 1px solid ", ";\n  @media screen and (max-width: ", ") {\n    display: none;\n    overflow-y: scroll;\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  @media screen and (min-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var DropdownControl = styled.div(_templateObject$e(), BREAKPOINTS.PORTAL_MIDDLE);
var SideMenuWrapper = styled.div(_templateObject2$7(), COLORS.GRAY_COLORS.GRAY_92, BREAKPOINTS.PORTAL_MIDDLE);
var SideMenu = styled.div(_templateObject3$5());

var Menu = function Menu(_ref) {
  var children = _ref.children,
      activeItemTitle = _ref.activeItemTitle;
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(DropdownControl, null, /*#__PURE__*/React$1.createElement(Dropdown, {
    activeItemTitle: activeItemTitle
  }, children)), /*#__PURE__*/React$1.createElement(SideMenuWrapper, null, /*#__PURE__*/React$1.createElement(SideMenu, null, children)));
};

Menu.propTypes = {
  activeItemTitle: PropTypes$1.node.isRequired
};

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 14px;\n  padding-left: 25px;\n  font-size: 14px;\n  line-height: 16px;\n  line-height: 1rem;\n  color: ", ";\n  text-decoration: none;\n\n  &:before {\n    display: block;\n    content: \"\";\n    position: absolute;\n    top: 13px;\n    left: 10px;\n    width: 2px;\n    height: 0;\n    background-color: ", ";\n    transition: height 0.4s ease-in-out;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &.active {\n    font-weight: bold;\n  }\n  &.active::before {\n    height: 16px;\n  }\n\n  .active:hover {\n    background-color: transparent;\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarLink = styled(NavLink)(_templateObject$d(), COLORS.GRAY_COLORS.GRAY_35, COLORS.ACTION_COLORS.ONELOGIN_BLUE, COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_GRAY_LIGHT);

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 14px;\n  padding-left: 20px;\n  font-size: 13px;\n  line-height: 16px;\n  line-height: 1rem;\n  color: ", ";\n  text-decoration: none;\n  font-weight: 500;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid ", ";\n  margin-bottom: 10px;\n\n  a:last-child {\n    margin-bottom: 8px;\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var SidebarGroupWrapper = styled.div(_templateObject$c(), COLORS.GRAY_COLORS.GRAY_92);
var SidebarGroupWrapperTitle = styled.h3(_templateObject2$6(), COLORS.ACTION_COLORS.BLUE_DARKER);

var SidebarLinkGroup = function SidebarLinkGroup(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/React$1.createElement(SidebarGroupWrapper, null, /*#__PURE__*/React$1.createElement(SidebarGroupWrapperTitle, null, title), children);
};

SidebarLinkGroup.propTypes = {
  title: PropTypes$1.string.isRequired
};

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 48px;\n  width: 100%;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var Section = styled.div(_templateObject$b());

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  color: ", ";\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.56;\n  letter-spacing: 0.2px;\n  margin-bottom: 12px;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var SectionHeader = styled.div(_templateObject$a(), COLORS.GRAY_COLORS.GRAY_25);

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  top: ", "px;\n  flex-grow: 1;\n  flex-direction: column;\n  display: flex;\n  position: relative;\n  max-height: calc(100vh - ", "px);\n  width: 100%;\n  height: calc(100vh - ", "px);\n  font-family: ", ";\n  font-size: 14px;\n  color: ", ";\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var MainContent = styled.main(_templateObject$9(), NAVBAR_HEIGHT, NAVBAR_HEIGHT, NAVBAR_HEIGHT, FONTS.FONT_FAMILY.DEFAULT, COLORS.GRAY_COLORS.GRAY_35);

var CommonLayout = function CommonLayout(_ref) {
  var children = _ref.children,
      notifications = _ref.notifications,
      clearDisplayedNotification = _ref.clearDisplayedNotification,
      navbarMaxWidth = _ref.navbarMaxWidth,
      navbarProps = _objectWithoutPropertiesLoose$1(_ref, ["children", "notifications", "clearDisplayedNotification", "navbarMaxWidth"]);

  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Navbar, _extends$2({}, navbarProps, {
    maxWidth: navbarMaxWidth
  })), /*#__PURE__*/React$1.createElement(MainContent, {
    "data-testid": "common-layout-main-content",
    role: "main"
  }, children, notifications && /*#__PURE__*/React$1.createElement(Notifications, {
    notifications: notifications,
    clearDisplayedNotification: clearDisplayedNotification
  })));
};

CommonLayout.defaultProps = {
  alwaysListen: false,
  menus: []
};
CommonLayout.propTypes = {
  /**
   * array of menus to display as part of navbar
   */
  menus: PropTypes$1.array.isRequired,

  /**
   * if navbar should be constrained to some witdth, set it through this prop. Otherwise 100% of screen will be used
   */
  navbarMaxWidth: PropTypes$1.number,

  /**
   * determines if menus listen for mouseover events. In "Apple Style Menus"
   * they don't listen until a menu is clicked and stop listening when
   * another menu or the page is clicked
   * {true} means mouse hover over menu to expand it. It hides automatically when mouseout
   * {false} means user needs to click the menu to expand it. It then stays opened until item is clicked or document body is clicked
   */
  alwaysListen: PropTypes$1.bool,

  /**
   * when you want to set mobile view even though menu links still fit the view
   */
  mobileBreakpoint: PropTypes$1.number,

  /**
   * slide down notifications
   */
  notifications: PropTypes$1.arrayOf(PropTypes$1.shape({
    message: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]).isRequired,
    type: PropTypes$1.oneOf(["error", "success", "info"])
  })),

  /**
   * when notifications are dismissable, provide a callback function
   */
  clearDisplayedNotification: PropTypes$1.func.isRequired,

  /**
   * in portal and profile, there's few of menu items, let's make user menu items to be expanded right into top level (in mobile view)
   */
  flatifyMobileMenus: PropTypes$1.bool
};
CommonLayout.Heading = Heading;
CommonLayout.Title = Title;
CommonLayout.Body = Body;
CommonLayout.Sidebar = Menu;
CommonLayout.SidebarLink = SidebarLink;
CommonLayout.SidebarLinkGroup = SidebarLinkGroup;
CommonLayout.Screen = Screen;
CommonLayout.ScreenHeader = ScreenHeader;
CommonLayout.Section = Section;
CommonLayout.SectionHeader = SectionHeader;

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  display: inline-block;\n  position: relative;\n  line-height: 18px;\n  color: ", ";\n  opacity: ", ";\n}"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  margin: 0 8px 0 0;\n  opacity: ", ";\n\n  &:checked + ", " {\n    background: ", ";\n    border: 1px solid\n      ", ";\n    &::after {\n      content: \"\";\n      display: block;\n      border-radius: 50%;\n      width: 10px;\n      height: 10px;\n      margin: 4px;\n      background: ", ";\n    }\n  }\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: ", ";\n  border: 1px solid ", ";\n  opacity: ", ";\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  min-height: 24px;\n  position: relative;\n  margin-bottom: 10px;\n\n  &:focus-visible {\n    outline: none;\n  }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  height: auto;\n  width: 100%;\n  box-sizing: border-box;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var RadioGroupWrapper = styled.div(_templateObject$8());
var RadioButtonWrapper = styled.div(_templateObject2$5(), COLORS.GRAY_COLORS.GRAY_25, FONTS.FONT_FAMILY.DEFAULT);
var RadioButtonDot = styled.div(_templateObject3$4(), function (props) {
  return props.inputDisabled ? "" + COLORS.GRAY_COLORS.GRAY_90 : "" + COLORS.WHITE;
}, COLORS.GRAY_COLORS.GRAY_55, function (props) {
  return props.inputDisabled ? 0.3 : 1;
});
var RadioButtonInput = styled.input(_templateObject4$3(), function (props) {
  return props.disabled ? 0 : 1;
}, RadioButtonDot, COLORS.WHITE, function (props) {
  return props.disabled ? "" + COLORS.GRAY_COLORS.GRAY_55 : "" + COLORS.ACTION_COLORS.ONELOGIN_BLUE_DARK;
}, function (props) {
  return props.disabled ? "" + COLORS.GRAY_COLORS.GRAY_55 : "" + COLORS.ACTION_COLORS.ONELOGIN_BLUE_DARK;
});
var RadioButtonLabel = styled.label(_templateObject5$2(), function (props) {
  return props.checked ? "" + COLORS.GRAY_COLORS.GRAY_25 : "" + COLORS.GRAY_COLORS.GRAY_35;
}, function (props) {
  return props.inputDisabled ? 0.3 : 1;
});

var RadioGroup = function RadioGroup(_ref) {
  var _useKeyDown;

  var name = _ref.name,
      options = _ref.options,
      selected = _ref.selected,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  var selectedIndex = options.findIndex(function (item) {
    return item.value === selected;
  }); // manually setting initial index to 0 if selected is undefined

  if (selectedIndex === -1) {
    selectedIndex = 0;
  }

  var _useState = useState(selectedIndex),
      index = _useState[0],
      setIndex = _useState[1];

  var radioGroupRef = useRef();
  var radioButtonRef = useRef([]);
  var radioButtonTextRef = useRef([]);
  useEffect(function () {
    radioButtonRef.current = radioButtonRef.current.slice(0, options.length);
    radioButtonTextRef.current = radioButtonTextRef.current.slice(0, options.length);
  }, [options]);
  useEffect(function () {
    if (index !== selectedIndex) {
      setIndex(selectedIndex);
    }
  }, [index, selectedIndex]);

  var handleChange = function handleChange(value) {
    !disabled && onChange(value);
  };

  var handleClickChange = function handleClickChange(value) {
    if (disabled) {
      return;
    }

    var clickedIndex = options.findIndex(function (item) {
      return item.value === value;
    });

    if (clickedIndex !== -1 && radioButtonTextRef.current[clickedIndex]) {
      radioButtonTextRef.current[clickedIndex].focus();
    }

    onChange(value);
  };

  var onArrowDown = function onArrowDown(event) {
    event.preventDefault();
    event.stopPropagation();
    var nextIndex = Math.min(index + 1, options.length - 1);

    if (nextIndex !== index) {
      radioButtonRef.current[nextIndex].focus();

      if (radioButtonTextRef.current[nextIndex]) {
        radioButtonTextRef.current[nextIndex].focus();
      }

      setIndex(nextIndex);
      handleChange(options[nextIndex].value);
    }
  };

  var onArrowUp = function onArrowUp(event) {
    event.preventDefault(); //do not scroll the page

    event.stopPropagation();
    var prevIndex = Math.max(index - 1, 0);

    if (prevIndex !== index) {
      radioButtonRef.current[prevIndex].focus();

      if (radioButtonTextRef.current[prevIndex]) {
        radioButtonTextRef.current[prevIndex].focus();
      }

      setIndex(prevIndex);
      handleChange(options[prevIndex].value);
    }
  };

  var onConfirm = function onConfirm(event) {
    if (index !== -1) {
      if (!radioButtonTextRef.current[index] || radioButtonTextRef.current[index] && radioButtonTextRef.current[index] !== document.activeElement) {
        event.preventDefault(); //do not scroll the page

        event.stopPropagation();
      }
    }

    handleClickChange(options[index].value);
  };

  useKeyDown(radioGroupRef, (_useKeyDown = {}, _useKeyDown[KEY_CODES.ARROW_DOWN] = onArrowDown, _useKeyDown[KEY_CODES.ARROW_UP] = onArrowUp, _useKeyDown[KEY_CODES.SPACE] = onConfirm, _useKeyDown));
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(RadioGroupWrapper, {
    role: "radiogroup",
    ref: radioGroupRef,
    tabIndex: "-1"
  }, options.map(function (option, index) {
    var getTabIndex = function getTabIndex() {
      // only allow tab to first item if no item selected before
      // or allow tab on the selected item
      if (!disabled && (!selected && index === 0 || option.value === selected)) {
        return "0";
      } else {
        return "-1";
      }
    };

    return /*#__PURE__*/React$1.createElement(RadioButtonWrapper, {
      key: option.id,
      tabIndex: getTabIndex(),
      ref: function ref(el) {
        return radioButtonRef.current[index] = el;
      }
    }, /*#__PURE__*/React$1.createElement(RadioButtonInput, {
      id: option.id,
      type: "radio",
      name: name,
      value: option.value,
      checked: option.value === selected,
      "aria-checked": option.value === selected,
      onChange: function onChange() {
        return handleChange(option.value);
      },
      disabled: disabled,
      tabIndex: "-1"
    }), /*#__PURE__*/React$1.createElement(RadioButtonDot, {
      inputDisabled: disabled,
      onClick: function onClick() {
        return handleClickChange(option.value);
      }
    }), typeof option.text === "string" && /*#__PURE__*/React$1.createElement(RadioButtonLabel, {
      inputDisabled: disabled,
      htmlFor: option.id,
      checked: option.value === selected
    }, option.text), typeof option.text === "object" && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, React$1.cloneElement(option.text, {
      ref: function ref(el) {
        return radioButtonTextRef.current[index] = el;
      }
    })));
  })));
};

RadioGroup.propTypes = {
  name: PropTypes$1.string.isRequired,
  options: PropTypes$1.arrayOf(PropTypes$1.shape({
    id: PropTypes$1.string.isRequired,
    value: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number, PropTypes$1.bool]).isRequired,
    text: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]).isRequired
  })).isRequired,
  selected: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number, PropTypes$1.bool]),
  onChange: PropTypes$1.func,
  disabled: PropTypes$1.bool
};

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  color: white;\n  border-radius: 16px;\n  background: ", ";\n  font-size: 13px;\n  line-height: 14px;\n  padding: 8px 12px;\n  font-family: ", ";\n}"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTag = styled.span(_templateObject$7(), COLORS.ACTION_COLORS.BLUE_DARKER, FONTS.FONT_FAMILY.DEFAULT);

var Tag = /*#__PURE__*/function (_Component) {
  _inheritsLoose$1(Tag, _Component);

  function Tag(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized$2(_this));
    return _this;
  }

  var _proto = Tag.prototype;

  _proto.handleClose = function handleClose() {
    var _this$props = this.props,
        text = _this$props.text,
        id = _this$props.id,
        onClick = _this$props.onClick;
    onClick(text, id || null);
  };

  _proto.renderIcon = function renderIcon() {
    return /*#__PURE__*/React$1.createElement("span", {
      onClick: this.handleClose
    }, "x");
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        style = _this$props2.style,
        color = _this$props2.color,
        children = _this$props2.children,
        text = _this$props2.text,
        id = _this$props2.id;
    var colorStyle = {
      backgroundColor: color
    };
    var newStyle = Object.assign({}, style, colorStyle);
    return /*#__PURE__*/React$1.createElement(StyledTag, {
      id: id,
      style: newStyle
    }, text || children, this.renderIcon());
  };

  return Tag;
}(Component);

Tag.propTypes = {
  id: PropTypes$1.string,
  text: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.element]),
  icon: PropTypes$1.string,
  color: PropTypes$1.string,
  style: PropTypes$1.object,
  onClick: PropTypes$1.func,
  children: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.node), PropTypes$1.node]),
  className: PropTypes$1.string
};
Tag.defaultProps = {
  onClick: function onClick() {},
  color: COLORS.ACTION_COLORS.BLUE_DARKER
};

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n  /*margin: 5px;*/\n  display: inline-block;\n  position: relative;\n  padding-left: 26px;\n  line-height: 20px;\n  opacity: ", ";\n}"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  -webkit-appearance: none;\n\n  position: relative;\n  background-color: #ffffff;\n  border: solid 1px ", ";\n  border-radius: 2px;\n  cursor: pointer;\n  padding: 1px;\n  position: absolute;\n  left: 0;\n  top: 5px;\n\n  &:checked:after {\n    content: url( ", ");\n    \n    background-color: ", ";\n    border: solid 1px ", ";\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    left: -1px;\n    bottom: -1px;\n    border-radius: 2px;\n  }\n\n  &:checked:focus:after {\n    //for some reason input's outline is 1px higher than the checkbox itself. \n    //This hack makes the checkbox 1px higher in case it is focused, so there's no 1px white line\n    bottom: -2px; \n  }\n}"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  padding: 4px 0;\n  position: relative;\n}"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledCheckbox = styled.div(_templateObject$6(), COLORS.GRAY_COLORS.GRAY_25, FONTS.FONT_FAMILY.DEFAULT);
var StyledInput = styled.input(_templateObject2$4(), COLORS.GRAY_COLORS.GRAY_84, svgList["Checkmark-checkbox"], COLORS.ACTION_COLORS.ONELOGIN_BLUE, COLORS.ACTION_COLORS.ONELOGIN_BLUE);
var StyledLabel = styled.label(_templateObject3$3(), function (props) {
  return props.disabled ? 0.3 : 1;
});

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      id = _ref.id,
      value = _ref.value,
      onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled;

  var handleChange = function handleChange() {
    !disabled && onChange(id);
  };

  return /*#__PURE__*/React$1.createElement(StyledCheckbox, null, /*#__PURE__*/React$1.createElement(StyledInput, {
    onChange: handleChange,
    id: id,
    value: value,
    type: "checkbox",
    checked: checked,
    disabled: disabled
  }), /*#__PURE__*/React$1.createElement(StyledLabel, {
    htmlFor: id,
    disabled: disabled
  }, /*#__PURE__*/React$1.createElement("span", null, label)));
};

Checkbox.propTypes = {
  id: PropTypes$1.string.isRequired,
  onChange: PropTypes$1.func,
  value: PropTypes$1.string.isRequired,
  label: PropTypes$1.node,
  checked: PropTypes$1.bool,
  disabled: PropTypes$1.bool
};
Checkbox.defaultProps = {
  onChange: function onChange() {}
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 10px\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledButton = styled(Button$1)(_templateObject$5());
var Wrapper = styled.span(_templateObject2$3());
/**
 * A dialog modal to confirm an action that wraps a trigger element
 * @param {Function} onConfirm - a function to run when the child element is triggered
 * @param {String} message - a message to display in the dialog modal
 * @param {Boolean} bubble - [optional] a boolean that describes if bubbling is allowed when the child element is triggered
 * @return {JSX.Element} a div containing a wrapper with the passed children and a modal that is toggled by interaction with the passed children
 * @example
 *   <Confirm
 *     message="Are you sure you want to delete this item?"
 *     onConfirm={event => alert("Ok, it's gone")}
 *     bubble
 *   >
 *     <button>Delete</button>
 *   </Confirm>
 * @type {{( props: { onConfirm: function, message: string, bubble?: boolean }): JSX.Element}}
 */

var Confirm = function Confirm(_ref) {
  var _useKeyDown;

  var children = _ref.children,
      onConfirm = _ref.onConfirm,
      message = _ref.message,
      bubble = _ref.bubble;

  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  var wrapperEl = useRef();

  var onClick = function onClick(event) {
    if (!bubble) {
      event.preventDefault();
      event.stopPropagation();
    }

    setShow(true);
  };

  var onModalButtonClick = function onModalButtonClick(event, confirmed) {
    event.stopPropagation();
    setShow(false);
    if (confirmed) onConfirm(event, true);
  };

  var Modal$1 = function Modal$1() {
    return /*#__PURE__*/React$1.createElement(Modal, {
      "data-testid": "confirm-modal",
      onClose: function onClose() {
        return setShow(false);
      },
      closeOnClick: true
    }, /*#__PURE__*/React$1.createElement(Modal.Header, null, /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "2828880379",
      defaultMessage: "Confirm"
    })), /*#__PURE__*/React$1.createElement(Modal.Content, null, /*#__PURE__*/React$1.createElement("p", null, message)), /*#__PURE__*/React$1.createElement(Modal.Actions, null, /*#__PURE__*/React$1.createElement("span", null, /*#__PURE__*/React$1.createElement(StyledButton, {
      onClick: function onClick(event) {
        return onModalButtonClick(event, false);
      }
    }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "3528672691",
      defaultMessage: "Cancel"
    })), /*#__PURE__*/React$1.createElement(Button$1, {
      look: "primary",
      onClick: function onClick(event) {
        return onModalButtonClick(event, true);
      }
    }, /*#__PURE__*/React$1.createElement(FormattedMessage, {
      id: "660592555",
      defaultMessage: "OK"
    })))));
  };

  useKeyDown(wrapperEl, (_useKeyDown = {}, _useKeyDown[SPACE] = onClick, _useKeyDown[ENTER] = onClick, _useKeyDown));
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Wrapper, {
    onClick: onClick,
    ref: wrapperEl,
    role: "button",
    tabIndex: "-1"
  }, children), show && /*#__PURE__*/React$1.createElement(Modal$1, null));
};

Confirm.propTypes = {
  message: string.isRequired,
  onConfirm: func.isRequired,
  bubble: bool
};

var AvatarImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8Y2lyY2xlIGlkPSJhIiBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiLz4KICAgICAgICA8cGF0aCBpZD0iYyIgZD0iTTUuMzkyIDExYzEuMDU0LjYzNSAyLjI4OCAxIDMuNjA4IDEgMS4zMiAwIDIuNTU0LS4zNjUgMy42MDgtMUgxM2E1IDUgMCAwIDEgNSA1djJIMHYtMmE1IDUgMCAwIDEgNS01aC4zOTJ6TTkgMTBBNSA1IDAgMSAxIDkgMGE1IDUgMCAwIDEgMCAxMHoiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGZpbGw9IiNGM0YzRjQiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPGcgbWFzaz0idXJsKCNiKSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgNikiPgogICAgICAgICAgICAgICAgPG1hc2sgaWQ9ImQiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2MiLz4KICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgIDx1c2UgZmlsbD0iIzhCOEM4QyIgeGxpbms6aHJlZj0iI2MiLz4KICAgICAgICAgICAgICAgIDxnIG1hc2s9InVybCgjZCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiM4QjhDOEMiIGQ9Ik0tMzktNDJoOTZ2OTZoLTk2eiIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  background-image: url(", ");\n  width: ", ";\n  height: ", ";\n  background-size: cover;\n  background-position: top center;\n  border-radius: 50%;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var Avatar = styled.div(_templateObject$4(), function (props) {
  return props.image || AvatarImage;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
Avatar.displayName = "Avatar";
Avatar.propTypes = {
  image: PropTypes$1.string,
  size: PropTypes$1.string
};
Avatar.defaultProps = {
  image: "",
  size: "36px"
};

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  display: inline-block;\n  position: relative;\n  line-height: 18px;\n  color: ", ";\n  opacity: ", ";\n  margin-left: 8px;\n}"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  opacity: 0;\n  z-index: 1;\n  border-radius: 15px;\n  width: 52px;\n  height: 26px;\n  margin: 0px;\n\n  &:checked + ", " {\n    background: ", ";\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: 8px 50%;\n    &::after {\n      content: \"\";\n      display: block;\n      border-radius: 50%;\n      width: 20px;\n      height: 20px;\n      margin-left: 29px;\n      transition: 0.2s;\n    }\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 52px;\n  height: 26px;\n  border-radius: 15px;\n  background: ", ";\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: 75% 50%;\n  cursor: pointer;\n  &::after {\n    content: \"\";\n    display: block;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    margin: 3px;\n    background: ", ";\n    box-shadow: ", ";\n    transition: 0.2s;\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin: 4px 0;\n  font-family: ", ";\n  align-items: center;\n  height: 26px;\n  display: flex;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var ToggleButtonWrapper = styled.div(_templateObject$3(), FONTS.FONT_FAMILY.DEFAULT);
var ToggleButtonSelect = styled.div(_templateObject2$2(), function (props) {
  return props.disabled ? "" + COLORS.GRAY_COLORS.GRAY_78 : "" + COLORS.STATUS_COLORS.ERROR;
}, svgList["Close-16-thick"], function (props) {
  return props.disabled ? "" + COLORS.GRAY_COLORS.GRAY_90 : "" + COLORS.WHITE;
}, function (props) {
  return props.disabled ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.15)";
});
var ToggleButtonInput = styled.input(_templateObject3$2(), ToggleButtonSelect, function (props) {
  return props.disabled ? "" + COLORS.GRAY_COLORS.GRAY_78 : "" + COLORS.STATUS_COLORS.SUCCESS;
}, svgList["Checkmark-checkbox"]);
var ToggleButtonLabel = styled.label(_templateObject4$2(), function (props) {
  return props.checked ? "" + COLORS.GRAY_COLORS.GRAY_25 : "" + COLORS.GRAY_COLORS.GRAY_35;
}, function (props) {
  return props.disabled ? 0.3 : 1;
});

var ToggleButton = function ToggleButton(_ref) {
  var _useKeyDown;

  var id = _ref.id,
      value = _ref.value,
      onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled,
      label = _ref.label;
  var toggleButtonRef = useRef();

  var handleChange = function handleChange() {
    !disabled && onChange(id);
  };

  var onConfirm = function onConfirm(event) {
    event.preventDefault(); //do not scroll the page

    event.stopPropagation();
    handleChange();
  };

  useKeyDown(toggleButtonRef, (_useKeyDown = {}, _useKeyDown[KEY_CODES.SPACE] = onConfirm, _useKeyDown));
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(ToggleButtonWrapper, {
    ref: toggleButtonRef
  }, /*#__PURE__*/React$1.createElement(ToggleButtonInput, {
    id: id,
    value: value,
    onChange: handleChange,
    checked: checked,
    disabled: disabled,
    type: "checkbox",
    "data-testid": "toggle-button",
    tabIndex: "-1"
  }), /*#__PURE__*/React$1.createElement(ToggleButtonSelect, {
    disabled: disabled,
    tabIndex: "0"
  }), /*#__PURE__*/React$1.createElement(ToggleButtonLabel, {
    htmlFor: id
  }, label)));
};

ToggleButton.propTypes = {
  id: PropTypes$1.string.isRequired,
  value: PropTypes$1.bool.isRequired,
  onChange: PropTypes$1.func,
  checked: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  label: PropTypes$1.string
};

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n        background-color: ", ";\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n      cursor: move;\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: ", ";\n  background-color: #ffffff;\n  font-size: 13px;\n  position: relative;\n\n  ", "\n\n  &:hover {\n    ", "\n\n    ", " {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  opacity: 0.3;\n  background: transparent url(", ") no-repeat center;\n  left: 4px;\n  height: 16px;\n  background-size: 16px;\n  width: 16px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  background-color: white;\n  border-radius: 2px;\n  color: ", ";\n  padding: 0px ", "px;\n  position: absolute;\n  left: ", "px;\n  top: -10px;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-sizing: border-box;\n  max-width: calc(100% - 20px); //10px left + 10px right //TODO\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n      border-top: 1px solid ", ";\n      border-bottom: 1px solid ", ";\n    "]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n      border-top: 1px solid ", ";\n    "]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  position: relative;\n  color: ", ";\n  height: ", ";\n  \n    \n  ", "\n  border-bottom: 1px solid\n    ", ";\n  ", ";\n  font-weight: ", ";\n  line-height: 1.23;\n\n  &:first-child {\n    border-left: 1px solid\n      ", ";\n    \n    ", " {\n      padding-left: ", "px;\n    }\n  }\n\n  &:last-child {\n    border-right: 1px solid\n      ", ";\n\n    ", " {\n      padding-right: ", "px;\n    }\n  }\n\n  @media screen and (max-width: ", ") {\n    &:first-child {\n      border-top-width: ", ";\n    }\n    border-left: 0;\n    border-right: 0;\n  }\n\n  a {\n    text-decoration: none;\n    color: inherit;\n    display: flex;\n    flex-grow: 1;\n    height: 100%;\n    align-items: center;\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n      text-align: center;\n    "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n      text-align: right;\n    "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  //first and last cell contents are overridden below in TableCellInternal for different padding\n  padding-left: ", "px;\n  padding-right: ", "px;\n\n  ", "\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var ALIGNMENT = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right"
};
var CELL_PADDING = 24;
var CELL_INNER_PADDING = 8;
var HEADER_LEFT = 10;
var TDContent = styled.div(_templateObject$2(), CELL_INNER_PADDING, CELL_INNER_PADDING, function (props) {
  return props.contentAlign === ALIGNMENT.RIGHT && css(_templateObject2$1());
}, function (props) {
  return props.contentAlign === ALIGNMENT.CENTER && css(_templateObject3$1());
});
var TableCellInternal = styled.td(_templateObject4$1(), function (props) {
  return props.width;
}, COLORS.GRAY_COLORS.GRAY_35, function (props) {
  return props.isHeader ? "58px" : "50px";
}, function (props) {
  return props.isHighlighted && css(_templateObject5$1(), COLORS.STATUS_COLORS.SUCCESS);
}, function (props) {
  return props.isHighlighted ? COLORS.STATUS_COLORS.SUCCESS : COLORS.GRAY_COLORS.GRAY_94;
}, function (props) {
  return props.isHeader && css(_templateObject6$1(), COLORS.GRAY_COLORS.GRAY_94, COLORS.GRAY_COLORS.GRAY_90);
}, function (props) {
  return props.isHeader ? 500 : 400;
}, function (props) {
  return props.isHighlighted ? COLORS.STATUS_COLORS.SUCCESS : COLORS.GRAY_COLORS.GRAY_94;
}, TDContent, CELL_PADDING, function (props) {
  return props.isHighlighted ? COLORS.STATUS_COLORS.SUCCESS : COLORS.GRAY_COLORS.GRAY_94;
}, TDContent, CELL_PADDING, BREAKPOINTS.PORTAL_MIDDLE, function (props) {
  return props.hideTopBorderMobile ? 0 : "1px";
});
var RowTitle = styled.div(_templateObject7(), function (props) {
  return props.isHighlighted ? COLORS.STATUS_COLORS.SUCCESS : COLORS.GRAY_COLORS.GRAY_35;
}, CELL_PADDING - HEADER_LEFT, HEADER_LEFT);
var DragIcon = styled.div(_templateObject8(), svgList["Grip-16"]);
var TableRowInternal = styled.tr(_templateObject9(), function (props) {
  return props.isHighlighted ? "-1px" : "0px";
}, function (props) {
  return props.draggable && css(_templateObject10());
}, function (props) {
  return !props.isHeader && css(_templateObject11(), COLORS.ONELOGIN_GRAY_COLORS.ONELOGIN_GRAY_LIGHT);
}, DragIcon);
/* PORTAL-2630: The principle here is to allow cells to take up the space of all following
 * invisible cells, up until the next non-invisible cell. The result is sum of columns to merge (colspan attribute).
 */

var calculateColSpan = function calculateColSpan(cells, index) {
  var postCells = cells.slice(index + 1);
  var absorbedCells = takeWhile(function (cell) {
    return cell.hidden;
  }, postCells);
  return 1 + absorbedCells.length;
};

var TableRow = function TableRow(_ref) {
  var dragData = _ref.dragData,
      href = _ref.href,
      cells = _ref.cells,
      rowTitle = _ref.rowTitle,
      isHeader = _ref.isHeader,
      isHighlighted = _ref.isHighlighted,
      hideTopBorderMobile = _ref.hideTopBorderMobile,
      _ref$onDrop = _ref.onDrop,
      onDrop = _ref$onDrop === void 0 ? function () {
    return void 0;
  } : _ref$onDrop;
  var headerRendered,
      wasFirstVisibleColumnRendered = false;
  var row = useRef();

  var isDraggable = function isDraggable() {
    return !!dragData;
  };

  var ondragstart = function ondragstart(event) {
    try {
      var crt = row.current.cloneNode(true); //TODO: having a TR element appended directly to body el is weird. Should be a valid and styled element with limits in movement to the left and right as proposed in zeplin.

      crt.style.border = "1px solid edeff0";
      crt.style.backgroundColor = "white";
      crt.style.position = "absolute";
      crt.style.left = "-999999px";
      crt.id = "proxyElement";
      row.current.parentNode.appendChild(crt);
      event.dataTransfer.setDragImage(crt, 0, 0);
      event.dataTransfer.setData("application/json", JSON.stringify(dragData));
      event.dataTransfer.effectAllowed = "move";
    } catch (err) {//no op
    }
  };

  var ondragover = function ondragover(ev) {
    return ev.preventDefault();
  };

  var ondrop = function ondrop(ev) {
    ev.preventDefault();

    try {
      var data = ev.dataTransfer.getData("application/json");
      onDrop(null, JSON.parse(data), dragData);
    } catch (err) {
      onDrop(err, null, dragData);
    }
  };

  var ondragend = function ondragend(ev) {
    ev.preventDefault();

    try {
      document.body.removeChild(document.getElementById("proxyElement"));
    } catch (_unused) {// no op
    }
  };

  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(TableRowInternal, {
    draggable: isDraggable(),
    onDragStart: isDraggable() ? ondragstart : function () {
      return void 0;
    },
    onDragOver: isDraggable() ? ondragover : function () {
      return void 0;
    },
    onDrop: isDraggable() ? ondrop : function () {
      return void 0;
    },
    onDragEnd: isDraggable() ? ondragend : function () {
      return void 0;
    },
    ref: row,
    isHeader: isHeader
  }, cells.map(function (column, index) {
    var showDragIcon = false;
    var renderRowTitle = rowTitle && !headerRendered;
    var content = /*#__PURE__*/React$1.createElement(TDContent, {
      contentAlign: column.contentAlign
    }, column.content);

    if (!column.hidden) {
      if (!wasFirstVisibleColumnRendered && isDraggable()) {
        showDragIcon = true;
        wasFirstVisibleColumnRendered = true;
      }

      if (renderRowTitle) {
        headerRendered = true;
      }

      return /*#__PURE__*/React$1.createElement(TableCellInternal, {
        width: column.width,
        colSpan: calculateColSpan(cells, index),
        isHeader: isHeader,
        isHighlighted: isHighlighted,
        hideTopBorderMobile: hideTopBorderMobile,
        key: index
      }, showDragIcon && /*#__PURE__*/React$1.createElement(DragIcon, null), renderRowTitle && /*#__PURE__*/React$1.createElement(RowTitle, {
        isHighlighted: isHighlighted
      }, rowTitle), !!href ? /*#__PURE__*/React$1.createElement(RCLink, {
        href: href
      }, content) : content);
    } else {
      return null;
    }
  })));
};
TableRow.propTypes = {
  cells: PropTypes$1.arrayOf(PropTypes$1.shape({
    key: PropTypes$1.string.isRequired,
    width: PropTypes$1.string,
    //width containing units
    content: PropTypes$1.oneOfType([PropTypes$1.node, PropTypes$1.string]).isRequired,
    contentAlign: PropTypes$1.oneOf(Object.keys(ALIGNMENT).map(function (align) {
      return ALIGNMENT[align];
    })),
    //used object.keys method to avoid polyfill object.values for IE11
    hidden: PropTypes$1.bool
  })),
  href: PropTypes$1.string,
  isHeader: PropTypes$1.bool,
  isHighlighted: PropTypes$1.bool,
  rowTitle: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]),
  hideTopBorderMobile: PropTypes$1.bool,
  //TODO:?
  //dragData needs to be stringifyable, so test it here
  dragData: function dragData(props, propName, componentName) {
    try {
      JSON.stringify(props[propName]);
    } catch (e) {
      return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Validation failed.");
    }
  }
};

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", "px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  background: none;\n  border: none;\n  padding: 0;\n  height: 24px;\n  width: ", "px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  background-color: ", ";\n  border-top: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-size: 13px;\n  color: ", ";\n  height: 50px;\n  border: 1px solid ", ";\n  border-top: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-bottom: 16px;\n\n  @media screen and (max-width: ", ") {\n    margin-bottom: 0; //TODO?\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var CLIPPED_BUTTON_WIDTH = 24;
var TableContainer = styled.table(_templateObject$1(), BREAKPOINTS.PORTAL_MIDDLE);
var NoDataContent = styled.td(_templateObject2(), COLORS.GRAY_COLORS.GRAY_68, COLORS.GRAY_COLORS.GRAY_94);
var NoDataTableRow = styled.tr(_templateObject3(), COLORS.WHITE);
var TableClippedContainer = styled.button(_templateObject4(), CLIPPED_BUTTON_WIDTH);
var TableClippedContainerPlaceholder = styled.div(_templateObject5(), CLIPPED_BUTTON_WIDTH);
var IconWithChevron = styled(Icon$2).attrs({
  icon: "Chevron_right-16",
  size: "16"
})(_templateObject6());

var ResponsiveTable = function ResponsiveTable(_ref) {
  var tableStructure = _ref.tableStructure,
      noDataMessage = _ref.noDataMessage,
      hideTopBorderMobile = _ref.hideTopBorderMobile;
  var windowSize = useWindowSize();
  var tableContainerRef = createRef();
  var intl = useIntl();

  var _useState = useState(),
      width = _useState[0],
      setWidth = _useState[1];

  var _useState2 = useState(),
      sortedByPrio = _useState2[0],
      setSortedByPrio = _useState2[1];

  var _useState3 = useState(),
      rowStructure = _useState3[0],
      setRowStructure = _useState3[1]; // sort table columns by priority so we can use this when counting what fits into table
  // const { tableStructure } = this.props;


  useEffect(function () {
    var sortedByPrio = sort(function (a, b) {
      if (a.priority === b.priority) {
        return a.weight > b.weight ? -1 : 1;
      }

      return a.priority > b.priority ? -1 : 1;
    }, tableStructure.columns);
    setSortedByPrio(sortedByPrio);
  }, [tableStructure]); //set new width

  useEffect(function () {
    var rect = tableContainerRef.current.getBoundingClientRect();

    if (width !== rect.width) {
      setWidth(rect.width);
    }
  }, [windowSize, width, tableContainerRef]); //calculate visible columns

  useEffect(function () {
    if (sortedByPrio === undefined) {
      return;
    }

    var getCellBy = function getCellBy(key, datum) {
      var idItem = find(propEq("key", key), datum);
      return idItem;
    };

    var expanderDefined = tableStructure.expander && tableStructure.expander.idKey;
    var widthSum = expanderDefined ? CLIPPED_BUTTON_WIDTH : 0,
        //Always reserve place for expander column when enabled
    visibleHeaderCells = [],
        visibleKeys = {},
        totalWeight = 0; //keep adding columns until sum of their minWidths fits into table width

    for (var _iterator = _createForOfIteratorHelperLoose(sortedByPrio), _step; !(_step = _iterator()).done;) {
      var column = _step.value;
      widthSum += column.minWidth || 0;

      if (widthSum <= width) {
        visibleHeaderCells.push(column);
        visibleKeys[column.key] = column;
        totalWeight += column.weight || 0;
      }
    } //TODO: FIXME: no matter what, there needs to be at least one column visible :) fix it ^
    //filter out columns that are not visible - non-prio-sorted columns here
    //also count column width here


    visibleHeaderCells = tableStructure.columns.filter(function (column) {
      return visibleKeys[column.key] !== undefined;
    }).map(function (column) {
      return _objectSpread2({}, column, {
        width: column.width || column.weight && column.weight / totalWeight * 100 + "%"
      });
    }); //we want to show expander (chevron icon) when there's more columns then currently visible

    var isClipped = visibleHeaderCells.length < tableStructure.columns.length;
    var isExpanderAlwaysVisible = tableStructure.expander && tableStructure.expander.isAlwaysVisible;

    if (expanderDefined && (isClipped || isExpanderAlwaysVisible)) {
      visibleHeaderCells.push({
        width: CLIPPED_BUTTON_WIDTH + "px",
        content: /*#__PURE__*/React$1.createElement(TableClippedContainerPlaceholder, null),
        key: "expander"
      });
    } //filter out data of columns that are not visible


    var bodyRows = tableStructure.data.map(function (datum) {
      var cells = datum.cells.filter(function (cell) {
        return visibleKeys[cell.key] !== undefined;
      }).map(function (cell) {
        return _objectSpread2({}, cell, {
          href: datum.href // width: relatedColumn && relatedColumn.width //TODO: what about to set cell width to 0px if column is not visible? Will screen readers work as expected? Will rendering work properly?

        });
      }); //TODO: consider to not show chevron on every single row, but to show table expander to expand all the table, so users who need whole data can have it

      if (isClipped && expanderDefined || isExpanderAlwaysVisible) {
        var idItem = getCellBy(tableStructure.expander.idKey, datum.cells);
        cells.push({
          width: CLIPPED_BUTTON_WIDTH + "px",
          content: idItem && idItem.content !== undefined ? /*#__PURE__*/React$1.createElement(TableClippedContainer, {
            "data-testid": "show-details",
            "aria-label": intl.formatMessage({
              defaultMessage: "Show details",
              // TODO: aria-label can be passed as a prop, 'show details' needn't to be always the case OR do show the modal dialog always containing row data(?)
              id: "showDetails"
            }),
            onClick: function onClick() {
              tableStructure.expander.onClick && tableStructure.expander.onClick(idItem.content);
            }
          }, /*#__PURE__*/React$1.createElement(IconWithChevron, null)) : /*#__PURE__*/React$1.createElement(TableClippedContainerPlaceholder, null),
          key: "expander"
        });
      }

      return {
        cells: cells,
        meta: datum.meta
      };
    });
    setRowStructure({
      visibleHeaderCells: visibleHeaderCells,
      bodyRows: bodyRows
    });
  }, [sortedByPrio, tableStructure, width, intl]);
  return /*#__PURE__*/React$1.createElement(TableContainer, {
    ref: tableContainerRef,
    cellSpacing: 0,
    cellPadding: 0
  }, rowStructure !== undefined && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("thead", null, /*#__PURE__*/React$1.createElement(TableRow, {
    isHeader: true,
    cells: rowStructure.visibleHeaderCells,
    hideTopBorderMobile: hideTopBorderMobile
  })), /*#__PURE__*/React$1.createElement("tbody", null, rowStructure.bodyRows.length > 0 ? rowStructure.bodyRows.map(function (row, index) {
    return /*#__PURE__*/React$1.createElement(TableRow, _extends$2({
      key: index
    }, row.meta || {}, {
      cells: row.cells
    }));
  }) : /*#__PURE__*/React$1.createElement(NoDataTableRow, null, /*#__PURE__*/React$1.createElement(NoDataContent, {
    colSpan: rowStructure.visibleHeaderCells.length
  }, noDataMessage)))));
};

ResponsiveTable.propTypes = {
  tableStructure: PropTypes$1.shape({
    columns: PropTypes$1.arrayOf(PropTypes$1.shape({
      content: PropTypes$1.node,
      key: PropTypes$1.string.isRequired,
      minWidth: PropTypes$1.number,
      priority: PropTypes$1.number.isRequired,
      weight: PropTypes$1.number
    })).isRequired,
    data: PropTypes$1.arrayOf(PropTypes$1.shape({
      cells: PropTypes$1.arrayOf(PropTypes$1.shape({
        key: PropTypes$1.string.isRequired,
        width: PropTypes$1.string,
        //width containing units
        content: PropTypes$1.any.isRequired,
        contentAlign: PropTypes$1.string,
        hidden: PropTypes$1.bool
      })),
      meta: PropTypes$1.shape({
        isHighlighted: PropTypes$1.bool,
        rowTitle: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]),
        //dragData needs to be stringifyable, so test it here
        dragData: function dragData(props, propName, componentName) {
          try {
            JSON.stringify(props[propName]);
          } catch (e) {
            return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Validation failed.");
          }
        }
      })
    })).isRequired,
    expander: PropTypes$1.shape({
      isAlwaysVisible: PropTypes$1.bool,
      //TODO: find in target projects where and how this is used; if you see this during review ask me about this
      onClick: PropTypes$1.func,
      idKey: PropTypes$1.string
    })
  }),
  noDataMessage: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]),
  hideTopBorderMobile: PropTypes$1.bool
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var H1 = styled.h1(_templateObject());

var OptAnonContent = "\n// Get initial OnetrustActiveGroups ids\nif(typeof OptanonWrapperCount == \"undefined\"){\n    otGetInitialGrps();\n}\n\n//Delete cookies\notDeleteCookie(otIniGrps);\n\n// Assign OnetrustActiveGroups to custom variable\nfunction otGetInitialGrps(){\n    OptanonWrapperCount = '';\n    otIniGrps =  OnetrustActiveGroups;\n}\n\nfunction otDeleteCookie(iniOptGrpId)\n{\n    var otDomainGrps = JSON.parse(JSON.stringify(Optanon.GetDomainData().Groups));\n    var otDeletedGrpIds = otGetInactiveId(iniOptGrpId, OnetrustActiveGroups);\n    if(otDeletedGrpIds.length != 0 && otDomainGrps.length !=0){\n        for(var i=0; i < otDomainGrps.length; i++){\n            //Check if CustomGroupId matches\n        if(otDomainGrps[i]['CustomGroupId'] != '' && otDeletedGrpIds.includes(otDomainGrps[i]['CustomGroupId'])){\n                for(var j=0; j < otDomainGrps[i]['Cookies'].length; j++){\n                    //Delete cookie\n                    eraseCookie(otDomainGrps[i]['Cookies'][j]['Name']);\n                }\n            }\n\n            //Check if Hostid matches\n            if(otDomainGrps[i]['Hosts'].length != 0){\n                for(var j=0; j < otDomainGrps[i]['Hosts'].length; j++){\n                    //Check if HostId presents in the deleted list and cookie array is not blank\n                    if(otDeletedGrpIds.includes(otDomainGrps[i]['Hosts'][j]['HostId']) && otDomainGrps[i]['Hosts'][j]['Cookies'].length !=0){\n                        for(var k=0; k < otDomainGrps[i]['Hosts'][j]['Cookies'].length; k++){\n                            //Delete cookie\n                            eraseCookie(otDomainGrps[i]['Hosts'][j]['Cookies'][k]['Name']);\n                        }\n                    }\n                }\n            }\n\n        }\n    }\n    otGetInitialGrps(); //Reassign new group ids\n}\n\n//Get inactive ids\nfunction otGetInactiveId(customIniId, otActiveGrp){\n    //Initial OnetrustActiveGroups\n    customIniId = customIniId.split(\",\");\n    customIniId = customIniId.filter(Boolean);\n\n    //After action OnetrustActiveGroups\n    otActiveGrp = otActiveGrp.split(\",\");\n    otActiveGrp = otActiveGrp.filter(Boolean);\n\n    var result=[];\n    for (var i=0; i < customIniId.length; i++){\n        if ( otActiveGrp.indexOf(customIniId[i]) <= -1 ){\n            result.push(customIniId[i]);\n        }\n    }\n    return result;\n}\n\n//Delete cookie\nfunction eraseCookie(name) {\n    //Delete root path cookies\n    domainName = window.location.hostname;\n    rootDomain = domainName.replace(/^([^.]+)/i, \"\");\n    document.cookie = name+'=; Max-Age=-99999999; Path=/;Domain='+ domainName;\n    document.cookie = name+'=; Max-Age=-99999999; Path=/;Domain='+ rootDomain;\n    document.cookie = name+'=; Max-Age=-99999999; Path=/;';\n\n    //Delete LSO incase LSO being used, cna be commented out.\n    localStorage.removeItem(name);\n\n    //Check for the current path of the page\n    pathArray = window.location.pathname.split('/');\n    //Loop through path hierarchy and delete potential cookies at each path.\n    for (var i=0; i < pathArray.length; i++){\n        if (pathArray[i]){\n            //Build the path string from the Path Array e.g /site/login\n            var currentPath = pathArray.slice(0, i+1).join('/');\n            document.cookie = name+'=; Max-Age=-99999999; Path=' + currentPath + ';Domain='+ domainName;\n            document.cookie = name+'=; Max-Age=-99999999; Path=' + currentPath + ';';\n            //Maybe path has a trailing slash!\n            document.cookie = name+'=; Max-Age=-99999999; Path=' + currentPath + '/;Domain='+ domainName;\n            document.cookie = name+'=; Max-Age=-99999999; Path=' + currentPath + '/;';\n            //Also get the root domain\n            document.cookie = name+'=; Max-Age=-99999999; Path=' + currentPath + '/;Domain='+ rootDomain;\n            document.cookie = name+'=; Max-Age=-99999999; Path=' + currentPath + '/;';\n        }\n    }\n\n}\n";

/**
 * Conditionally adds the OneTrust CDN script to the document
 * @param {boolean} cookieManagementEnabled - defines if CDN will be added
 * @returns {JSX.Element} a div wrapper containing the children passed
 * @example
 *   <OneTrust
 *     cookieManagementEnabled={company.cookieManagementEnabled}
 *   >
 *     <Children/>
 *   </OneTrust>
 * @type {{( props: { cookieManagementEnabled: boolean }): JSX.Element}}
 */

var OneTrust = function OneTrust(_ref) {
  var cookieManagementEnabled = _ref.cookieManagementEnabled,
      children = _ref.children;
  useEffect(function () {
    var newScriptOne = document.createElement("script");
    newScriptOne.async = true;
    newScriptOne.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    newScriptOne.type = "text/javascript";
    newScriptOne.id = "OneTrustCDN";
    newScriptOne.setAttribute("data-domain-script", process.env.REACT_APP_ONETRUST_DATA_DOMAIN_SCRIPT_KEY);
    var newScriptTwo = document.createElement("script");
    newScriptTwo.async = true;
    newScriptTwo.id = "OneTrustWrapper";
    newScriptTwo.innerHTML = "function OptanonWrapper() {" + OptAnonContent + "}";

    if (cookieManagementEnabled && !document.getElementById("OneTrustCDN")) {
      var metaEl = document.getElementsByTagName("meta")[0];
      metaEl.parentNode.insertBefore(newScriptTwo, metaEl);
      metaEl.parentNode.insertBefore(newScriptOne, newScriptTwo);
    } else if (!cookieManagementEnabled && document.getElementById("OneTrustCDN")) {
      var oldScriptOne = document.getElementById("OneTrustCDN");
      var oldScriptTwo = document.getElementById("OneTrustWrapper");
      oldScriptTwo.parentNode.removeChild(oldScriptOne);
      oldScriptTwo.parentNode.removeChild(oldScriptTwo);
    }
  }, [cookieManagementEnabled]);
  return /*#__PURE__*/React$1.createElement("div", {
    "data-name": "OneTrust"
  }, children);
};
OneTrust.propTypes = {
  cookieManagementEnabled: bool.isRequired
};

var addApp$n = "Show {addApp} button when I log in to new websites.";
var addFactor$n = "Add Factor";
var additionalQuestions$n = "Additional Questions";
var addNewPrimaryBeforeRemove$n = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$n = "Add New Security Question";
var administration$n = "Administration";
var alert$n = "Alert";
var all$n = "all";
var app$n = "App";
var appDevice$n = "Tento faktor se používá pro aplikaci.";
var appDevices$n = "Tento faktor se používá pro aplikaci";
var appFactor$n = "Tento faktor se používá pro aplikaci.";
var application$n = "Application";
var appName$n = "App Name";
var appPortal$n = "App Portal";
var assumedUserNotification$n = "You cannot edit personal information while assuming a user.";
var broswerExtension$n = "Browser Extension";
var browser$n = "Browser";
var browserDeleteFailure$n = "Failed to delete trusted browser";
var browserDeleteSuccess$n = "Trusted browser was successfully deleted";
var browserDevice$n = "Browser/Device";
var browserFetchFailure$n = "Failed to fetch browsers";
var calling$n = "Volání";
var callUserAgain$n = "Calling you again";
var cancel$n = "zrušit";
var changePassword$n = "Change Password";
var changeSecurityFactor$n = "Change Security Factor";
var clearIcon$n = "odstranit ikonu";
var close$n = "Close";
var closeDialog$n = "Zavřít dialog";
var codeResent$n = "Code has been sent to your phone.";
var companyLogo$n = "logo společnosti";
var companyTab$n = "Default for company tab";
var conditionalRequirement$n = "At least {number} of the following requirements:";
var configuredOn$n = "Configured On";
var confirm$n = "potvrdit";
var contactAdminEmailOtp$n = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$n = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$n = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$n = "Contact your admin to reset password.";
var credentialId$n = "Credential ID";
var current$n = "Current";
var currentPassword$n = "Current password";
var deleteDeviceSuccess$n = "{factorName} was successfully deleted";
var deleteQuestion$n = "Delete question {position}";
var details$n = "Details";
var device$n = "Device";
var deviceDeleteFailure$n = "Failed to remove {factorName}";
var deviceFetchFailure$n = "Failed to fetch devices";
var deviceNameCannotBeBlank$n = "Authentication device name cannot be blank.";
var deviceRenameFailure$n = "Failed to update device name";
var downloadOnAppStore$n = "Stahování v app store";
var editDeviceName$n = "Edit name";
var editSQinfo$n = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$n = "Enroll new primary factor";
var event$n = "Event";
var eventType$n = "Event Type";
var eventUserAgent$n = "Event Useragent";
var eventUseragent$n = "Event Useragent";
var eventUUID$n = "Event UUID";
var eventUuid$n = "Event UUID";
var expirationDays$n = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$n = "Expire Date";
var expires$n = "Expires";
var extensionVersionInstalled$n = "Version {versionString} installed";
var factor$n = "Factor";
var factorFetchFailure$n = "Failed to fetch available factors";
var factorMfaTokenFailure$n = "Failed to fetch mfa token";
var factorPrimaryFailure$n = "Failed to set {factorName} as your primary factor";
var factors$n = "factors";
var factorsFetchFailure$n = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$n = "We couldn’t load your user information.";
var failedToRegisterAnswers$n = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$n = "We couldn't retrieve your security questions at this time.";
var forcedLogout$n = "Forced Logout";
var getOnGooglePlay$n = "Získat na Google Play";
var goToExternalSite$n = "Go to external site";
var helpRequestFailed$n = "We couldn't submit your help request.";
var helpRequestSuccessful$n = "Your support request has been sent to your OneLogin Admin.";
var hostname$n = "Hostname & OS";
var icon$n = "Icon";
var identifier$n = "Credential ID / Identifier";
var imageUpload$n = "Image Upload";
var inactive$n = "Inactive";
var inactiveDevice$n = "Inactive device";
var install$n = "Install";
var invalidCode$n = "Invalid code";
var invalidPhoneNumber$n = "Please use valid phone number.";
var language$n = "Language";
var languageConfirmation$n = "Are you sure you want to switch to {language}?";
var lastAuthentication$n = "Last Authentication";
var lastChanged$n = "Last changed";
var lastUsed$n = "Last Used";
var length$n = "Minimum {length} characters";
var letter$n = "1 Letter";
var linkToAppStore$n = "Odkaz do obchodu App Store";
var linkToGooglePlay$n = "Odkaz na Google Play";
var loadingRecentActivity$n = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$n = "Loading trusted browsers, please wait...";
var location$n = "Location";
var locationTime$n = "Location/Time";
var loggedOut$n = "Logged Out";
var login$n = "login";
var loginDevice$n = "Login device";
var loginEvent$n = "Login";
var loginFactor$n = "Tento faktor se používá pro přihlášení.";
var loginFailedEvent$n = "Login Failed";
var loginName$n = "Login Name";
var logOut$n = "Log Out";
var lower$n = "1 Lowercase";
var message$n = "{name} was successfully added.";
var mfaRegistrationFailure$n = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$n = "You successfully registered the device";
var more$n = "More";
var never$n = "Never";
var newPassword$n = "New password";
var newPrimaryFactor$n = "New primary factor";
var noActivities$n = "No activities have been made";
var noDevicesConfigured$n = "No devices have been configured";
var noExpiration$n = "Never expires";
var noMoreSecurityFactors$n = "There are no security factors available for registration.";
var notifyErrorLoadingUser$n = "Loading of user failed. Try again later";
var notifySuccessAddApp$n = "{name} was successfully added.";
var noTrustedBrowsers$n = "No browsers have been saved";
var numbers$n = "1 Number";
var oneloginDesktop$n = "OneLogin Desktop";
var oneloginDesktopFetchFailure$n = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$n = "OneLogin logo";
var onlyDesktopBrowsersSupported$n = "We currently only support browser extensions on desktop browsers.";
var otp1$n = "OTP 1";
var otp2$n = "OTP 2";
var otpDevice$n = "Tento faktor se používá pro přihlášení.";
var parsingUserProfilePhotoFailure$n = "Getting image details failed";
var password$n = "password";
var passwordChanged$n = "Password Changed";
var passwordChangedDays$n = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$n = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$n = "Your administrator has configured an external site for resetting your password.";
var passwordReset$n = "Password Reset";
var passwordUpdatedSuccessfully$n = "You have successfully updated your password.";
var passwordUpdateFailure$n = "Password update failed";
var phoneNumber$n = "Phone number";
var prefix$n = "Suspicious login report";
var previousDeviceName$n = "Previously {previousName}";
var primary$n = "Primary";
var proceedAnyway$n = "Proceed anyway";
var profile$n = "Profile";
var profileAvatar$n = "Profile avatar";
var profileMenuToggle$n = "Open profile menu";
var profilePhoto$n = "Profile photo";
var profilePhotoAction$n = "Profile image action";
var pwResetDevice$n = "Tento faktor se používá pro obnovení hesla.";
var pwResetFactor$n = "Tento faktor se používá pro resetování hesla.";
var questionNumber$n = "Question {position}";
var radiusAuthentication$n = "Service Login via Radius";
var recentActivity$n = "Recent Activity";
var redirectToChangePassword$n = "Redirect to change your password?";
var registerSecurityQuestions$n = "Register Security Questions";
var registrationRejected$n = "Registration unsuccessful, please try again.";
var registrationTimedout$n = "Registration context timed out";
var remove$n = "Remove";
var removeCurrentBrowserWarning$n = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$n = "You have successfully removed your profile picture.";
var removeFactorWarning$n = "Are you sure you want to remove {factor}?";
var removeImage$n = "Remove image";
var report$n = "Report";
var reportActivity$n = "Report Activity";
var requestField$n = "Describe the issue you're having";
var requiredQuestions$n = "Required Questions";
var revert$n = "vrátit se";
var revertToAdmin$n = "Revert to Admin";
var revertToSuperadmin$n = "Revert to OneLogin Admin";
var revoke$n = "Revoke";
var save$n = "Save Changes";
var searchIcon$n = "hledat ikonu";
var secureNotes$n = "Secure Notes";
var securityFactorAdded$n = "Security Factor Added";
var securityFactorRemoved$n = "Security Factor Removed";
var securityFactorRenamed$n = "Security Factor Renamed";
var securityFactors$n = "Security Factors";
var securityFactorsDescription$n = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$n = "Security Factors Updated";
var selectNewImage$n = "Select new image";
var selectNewPrimary$n = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$n = "Select Security Factor";
var sending$n = "Posílání";
var setPrimaryDevice$n = "Set as primary";
var showDetails$n = "Zobrazit podrobnosti";
var specials$n = "1 Special character";
var sqDropdownAriaLabel$n = "Question {position} dropdown";
var sqInfoHeader$n = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$n = "Blank answers will not be accepted";
var sqTipDoNotShare$n = "Do not share your questions and answers with anyone.";
var sqTipMinimum$n = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$n = "Answers are not case-sensitive.";
var sqTipNoUsePassword$n = "Do not use a password as an answer.";
var sqTipSameAnswer$n = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$n = "Special characters such as @#&*. will be ignored";
var submit$n = "Submit";
var submitting$n = "Submitting…";
var support$n = "Support";
var supportDefaultDescription$n = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$n = "Supported browsers: {browsers}";
var supportRequestHeader$n = "Support Request";
var time$n = "Time";
var trustDevice$n = "Trust Device";
var trusted$n = "Trusted";
var trustedBrowsers$n = "Trusted Browsers";
var trustedBrowsersDescription$n = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$n = "Trusted Device";
var unavailable$n = "Unavailable";
var unavailableTime$n = "Unavailable";
var unsetFactorSuccess$n = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$n = "Unset as primary";
var unsupportedBrowser$n = "Unsupported Browser";
var unsupportedBrowserHeading$n = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$n = "{newName} was successfully updated";
var updateFactorSuccess$n = "{factorName} is your new default security factor";
var updatePassword$n = "Update Password";
var updateUserProfileFailure$n = "Profile Update Failed";
var updateUserProfilePhotoFailure$n = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$n = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$n = "You have successfully updated your profile.";
var upper$n = "1 Uppercase";
var usedFor$n = "Used For";
var usedForApp$n = "This factor is used for app.";
var usedForLogin$n = "This factor is used for login.";
var usedForPasswordReset$n = "This factor is used for password reset.";
var version$n = "Version: {versionString}";
var yourBrowser$n = "Your browser: {browser}";
var csCZ = {
	"26286820": "Zadejte ID pověření a dva po sobě jdoucí bezpečnostní kódy z VIP přístupu Symantec.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Vložte kód, který jste dostali SMSkou.",
	"374233718": "Můžete to zkusit znovu za {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
	"437305782": "Nyní se ověřují vaše autentikátory WebAuthn.",
	"505702857": "Kouzelný odkaz",
	"519412053": "Změnit faktor ověření",
	"655462232": "Stáhněte si a nainstalujte OneLogin Protect na vašem zařízení",
	"660592555": "OK",
	"662924178": "Vypadá to, že dnešek není váš den.",
	"694278426": "Zadejte kód zařízení {deviceName}",
	"694920552": "První bezpečností kód",
	"737192390": "Otevřít {appName}",
	"740457555": "Druhý kód",
	"744377571": "Minimálně {length} znaků",
	"751710530": "Potvrdit",
	"916760408": "Vložte uživatelské jméno a bezpečnostní kód z vašeho zařízení.",
	"921093870": "Neobdrželi jste kód?",
	"966052509": "Žádné výsledky",
	"987359842": "Pro pokračování prosím klikněte na odkaz ve vašem emailu",
	"1068496829": "Vyberte bezpečnostní otázku {current}/{total}",
	"1079852660": "Vložte dva po sobě jdoucí bezpečnostní kódy",
	"1080736814": "Vložte {fieldName} z aplikace Symantec VIP Access",
	"1136625613": "Proces byl zrušen. Zkuste to znovu nebo použijte jiný faktor ověření.",
	"1212847248": "Ověřovací kód byl zaslán na vaši nakonfigurovanou adresu.",
	"1232460711": "Zadejte e-mailovou adresu",
	"1242107845": "Zobrazit",
	"1254879564": "Nové heslo",
	"1359200231": "Odeslat",
	"1433651550": "Vložte kód z OneLogin SMS.",
	"1477893598": "Konfigurovat",
	"1536965459": "Stáhněte si a nainstalujte OneLogin Protect na vašem zařízení",
	"1624184662": "Abyste si nastavili OneLogin SMS, pošleme vám aktivační kód SMSkou. Tento aktivační kód budete potřebovat k dokončení registrace zařízení.",
	"1654624862": "Bezpečnostní kód",
	"1833121415": "Vepsat odpověď {current}/{total}",
	"1919587067": "Znovu poslat kód",
	"1935535842": "Vyžadováno",
	"1963245695": "1 velké písmeno",
	"2018264248": "Zkuste to znovu",
	"2091874550": "První kód",
	"2097632732": "Naskenujte místo toho čárový kód",
	"2104438124": "Vložte {fieldName} a dva po sobě jdoucí bezpečnostní kódy ze Symantec VIP Access.",
	"2124363772": "Vložte své uživatelské jméno a bezpečnostní kód ze svého SecurID tokenu.",
	"2229754167": "Zadejte telefonní číslo",
	"2244720377": "Nejspíš nastala neočekávaná chyba.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Na váš email byl zaslán odkaz s přístupem",
	"2600324508": "Skrýt",
	"2606375562": "Vložte váš YubiKey do USB portu a zmáčkněte tlačítko",
	"2663586870": "Uživatelské jméno",
	"2758306961": "ID pověření",
	"2792137744": "1 číslo",
	"2815222727": "Naskenujte tento čárový kód",
	"2828880379": "Potvrdit",
	"2859281487": "K zabezpečení vašeho účtu je vyžadováno 2faktorové ověření.",
	"2942752129": "Druhý bezpečnostní kód",
	"3060896801": "Narazili jste na problém?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 speciální znak",
	"3294346597": "Zkusit znovu",
	"3327626662": "Zadejte potvrzovací kód",
	"3374226769": "Klikněte na Spárovat pomocí manuálního přístupu",
	"3469481929": "Kód nejde naskenovat?",
	"3499598078": "Otevřít nabídku",
	"3528672691": "Zrušit",
	"3640052215": "Pokračovat",
	"3645029425": "Naskenujte QR kód níže",
	"3645116517": "Tento kód zadejte, jakmile obdržíte hovor:",
	"3663548834": "Problém zkoumáme a brzy se ozveme. Vyčkejte prosím několik minut<br />a poté obnovte prohlížeč, nebo navštivte naši <a href='https://www.onelogin.com/status'>Stavovou stránku</a>.",
	"3669652728": "Odkaz s přístupem byl zaslán na",
	"3673120330": "Další",
	"3737470122": "Další informace vám sdělí správce.",
	"3781468762": "Váš prohlížeč nepodporuje WebAuthn",
	"3827227259": "Potvrzovací kód byl odeslán na",
	"3855542277": "Vložte tento kód do aplikace",
	"3865193889": "Aktivovat",
	"3877285238": "1 malé písmeno",
	"4000449233": "Volá se níže uvedené telefonní číslo:",
	"4072532148": "Znovu odeslat SMS kód",
	"4151518079": "Vybrat bezpečnostní otázku {current} / {total}",
	"4152906165": "Problém nyní prošetříme a brzy se vám znovu ozveme. Počkejte prosím několik minut a obnovte stránku nebo navštivte naši <link>stránku se stavem</link>.",
	"4227081527": "Poté, co bude aplikace nainstalována, jděte znovu na tuto obrazovku a klikněte na {action}",
	"4281662478": "Vyhledat",
	addApp: addApp$n,
	addFactor: addFactor$n,
	additionalQuestions: additionalQuestions$n,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$n,
	addNewSecurityQuestion: addNewSecurityQuestion$n,
	administration: administration$n,
	alert: alert$n,
	all: all$n,
	app: app$n,
	appDevice: appDevice$n,
	appDevices: appDevices$n,
	appFactor: appFactor$n,
	application: application$n,
	appName: appName$n,
	appPortal: appPortal$n,
	assumedUserNotification: assumedUserNotification$n,
	broswerExtension: broswerExtension$n,
	browser: browser$n,
	browserDeleteFailure: browserDeleteFailure$n,
	browserDeleteSuccess: browserDeleteSuccess$n,
	browserDevice: browserDevice$n,
	browserFetchFailure: browserFetchFailure$n,
	calling: calling$n,
	callUserAgain: callUserAgain$n,
	cancel: cancel$n,
	changePassword: changePassword$n,
	changeSecurityFactor: changeSecurityFactor$n,
	clearIcon: clearIcon$n,
	close: close$n,
	closeDialog: closeDialog$n,
	codeResent: codeResent$n,
	companyLogo: companyLogo$n,
	companyTab: companyTab$n,
	conditionalRequirement: conditionalRequirement$n,
	configuredOn: configuredOn$n,
	confirm: confirm$n,
	contactAdminEmailOtp: contactAdminEmailOtp$n,
	contactAdminForSMS: contactAdminForSMS$n,
	contactAdminForVoice: contactAdminForVoice$n,
	contactAdminPasswordReset: contactAdminPasswordReset$n,
	credentialId: credentialId$n,
	current: current$n,
	currentPassword: currentPassword$n,
	deleteDeviceSuccess: deleteDeviceSuccess$n,
	deleteQuestion: deleteQuestion$n,
	details: details$n,
	device: device$n,
	deviceDeleteFailure: deviceDeleteFailure$n,
	deviceFetchFailure: deviceFetchFailure$n,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$n,
	deviceRenameFailure: deviceRenameFailure$n,
	downloadOnAppStore: downloadOnAppStore$n,
	editDeviceName: editDeviceName$n,
	editSQinfo: editSQinfo$n,
	enrollNewFactor: enrollNewFactor$n,
	event: event$n,
	eventType: eventType$n,
	eventUserAgent: eventUserAgent$n,
	eventUseragent: eventUseragent$n,
	eventUUID: eventUUID$n,
	eventUuid: eventUuid$n,
	expirationDays: expirationDays$n,
	expireDate: expireDate$n,
	expires: expires$n,
	extensionVersionInstalled: extensionVersionInstalled$n,
	factor: factor$n,
	factorFetchFailure: factorFetchFailure$n,
	factorMfaTokenFailure: factorMfaTokenFailure$n,
	factorPrimaryFailure: factorPrimaryFailure$n,
	factors: factors$n,
	factorsFetchFailure: factorsFetchFailure$n,
	failedToFetchUserInfo: failedToFetchUserInfo$n,
	failedToRegisterAnswers: failedToRegisterAnswers$n,
	failedToRetrieveQuestions: failedToRetrieveQuestions$n,
	forcedLogout: forcedLogout$n,
	getOnGooglePlay: getOnGooglePlay$n,
	goToExternalSite: goToExternalSite$n,
	helpRequestFailed: helpRequestFailed$n,
	helpRequestSuccessful: helpRequestSuccessful$n,
	hostname: hostname$n,
	icon: icon$n,
	identifier: identifier$n,
	imageUpload: imageUpload$n,
	inactive: inactive$n,
	inactiveDevice: inactiveDevice$n,
	install: install$n,
	invalidCode: invalidCode$n,
	invalidPhoneNumber: invalidPhoneNumber$n,
	language: language$n,
	languageConfirmation: languageConfirmation$n,
	lastAuthentication: lastAuthentication$n,
	lastChanged: lastChanged$n,
	lastUsed: lastUsed$n,
	length: length$n,
	letter: letter$n,
	linkToAppStore: linkToAppStore$n,
	linkToGooglePlay: linkToGooglePlay$n,
	loadingRecentActivity: loadingRecentActivity$n,
	loadingTrustedBrowsers: loadingTrustedBrowsers$n,
	location: location$n,
	locationTime: locationTime$n,
	loggedOut: loggedOut$n,
	login: login$n,
	loginDevice: loginDevice$n,
	loginEvent: loginEvent$n,
	loginFactor: loginFactor$n,
	loginFailedEvent: loginFailedEvent$n,
	loginName: loginName$n,
	logOut: logOut$n,
	lower: lower$n,
	message: message$n,
	mfaRegistrationFailure: mfaRegistrationFailure$n,
	mfaRegistrationSuccess: mfaRegistrationSuccess$n,
	more: more$n,
	never: never$n,
	newPassword: newPassword$n,
	newPrimaryFactor: newPrimaryFactor$n,
	noActivities: noActivities$n,
	noDevicesConfigured: noDevicesConfigured$n,
	noExpiration: noExpiration$n,
	noMoreSecurityFactors: noMoreSecurityFactors$n,
	notifyErrorLoadingUser: notifyErrorLoadingUser$n,
	notifySuccessAddApp: notifySuccessAddApp$n,
	noTrustedBrowsers: noTrustedBrowsers$n,
	numbers: numbers$n,
	oneloginDesktop: oneloginDesktop$n,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$n,
	oneloginLogo: oneloginLogo$n,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$n,
	otp1: otp1$n,
	otp2: otp2$n,
	otpDevice: otpDevice$n,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$n,
	password: password$n,
	passwordChanged: passwordChanged$n,
	passwordChangedDays: passwordChangedDays$n,
	passwordHint: passwordHint$n,
	passwordRedirectDescription: passwordRedirectDescription$n,
	passwordReset: passwordReset$n,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$n,
	passwordUpdateFailure: passwordUpdateFailure$n,
	phoneNumber: phoneNumber$n,
	prefix: prefix$n,
	previousDeviceName: previousDeviceName$n,
	primary: primary$n,
	proceedAnyway: proceedAnyway$n,
	profile: profile$n,
	profileAvatar: profileAvatar$n,
	profileMenuToggle: profileMenuToggle$n,
	profilePhoto: profilePhoto$n,
	profilePhotoAction: profilePhotoAction$n,
	pwResetDevice: pwResetDevice$n,
	pwResetFactor: pwResetFactor$n,
	questionNumber: questionNumber$n,
	radiusAuthentication: radiusAuthentication$n,
	recentActivity: recentActivity$n,
	redirectToChangePassword: redirectToChangePassword$n,
	registerSecurityQuestions: registerSecurityQuestions$n,
	registrationRejected: registrationRejected$n,
	registrationTimedout: registrationTimedout$n,
	remove: remove$n,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$n,
	removedProfilePictureSuccess: removedProfilePictureSuccess$n,
	removeFactorWarning: removeFactorWarning$n,
	removeImage: removeImage$n,
	report: report$n,
	reportActivity: reportActivity$n,
	requestField: requestField$n,
	requiredQuestions: requiredQuestions$n,
	revert: revert$n,
	revertToAdmin: revertToAdmin$n,
	revertToSuperadmin: revertToSuperadmin$n,
	revoke: revoke$n,
	save: save$n,
	searchIcon: searchIcon$n,
	secureNotes: secureNotes$n,
	securityFactorAdded: securityFactorAdded$n,
	securityFactorRemoved: securityFactorRemoved$n,
	securityFactorRenamed: securityFactorRenamed$n,
	securityFactors: securityFactors$n,
	securityFactorsDescription: securityFactorsDescription$n,
	securityFactorsUpdated: securityFactorsUpdated$n,
	selectNewImage: selectNewImage$n,
	selectNewPrimary: selectNewPrimary$n,
	selectSecurityFactor: selectSecurityFactor$n,
	sending: sending$n,
	setPrimaryDevice: setPrimaryDevice$n,
	showDetails: showDetails$n,
	specials: specials$n,
	sqDropdownAriaLabel: sqDropdownAriaLabel$n,
	sqInfoHeader: sqInfoHeader$n,
	sqTipBlankAnswers: sqTipBlankAnswers$n,
	sqTipDoNotShare: sqTipDoNotShare$n,
	sqTipMinimum: sqTipMinimum$n,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$n,
	sqTipNoUsePassword: sqTipNoUsePassword$n,
	sqTipSameAnswer: sqTipSameAnswer$n,
	sqTipSpecialChars: sqTipSpecialChars$n,
	submit: submit$n,
	submitting: submitting$n,
	support: support$n,
	supportDefaultDescription: supportDefaultDescription$n,
	supportedBrowsers: supportedBrowsers$n,
	supportRequestHeader: supportRequestHeader$n,
	"switch": "Switch",
	time: time$n,
	trustDevice: trustDevice$n,
	trusted: trusted$n,
	trustedBrowsers: trustedBrowsers$n,
	trustedBrowsersDescription: trustedBrowsersDescription$n,
	trustedDevice: trustedDevice$n,
	unavailable: unavailable$n,
	unavailableTime: unavailableTime$n,
	unsetFactorSuccess: unsetFactorSuccess$n,
	unsetPrimaryDevice: unsetPrimaryDevice$n,
	unsupportedBrowser: unsupportedBrowser$n,
	unsupportedBrowserHeading: unsupportedBrowserHeading$n,
	updateDeviceNameSuccess: updateDeviceNameSuccess$n,
	updateFactorSuccess: updateFactorSuccess$n,
	updatePassword: updatePassword$n,
	updateUserProfileFailure: updateUserProfileFailure$n,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$n,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$n,
	updateUserProfileSuccess: updateUserProfileSuccess$n,
	upper: upper$n,
	usedFor: usedFor$n,
	usedForApp: usedForApp$n,
	usedForLogin: usedForLogin$n,
	usedForPasswordReset: usedForPasswordReset$n,
	version: version$n,
	yourBrowser: yourBrowser$n
};

var addApp$m = "Show {addApp} button when I log in to new websites.";
var addFactor$m = "Add Factor";
var additionalQuestions$m = "Additional Questions";
var addNewPrimaryBeforeRemove$m = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$m = "Add New Security Question";
var administration$m = "Administration";
var alert$m = "Alert";
var all$m = "all";
var app$m = "App";
var appDevice$m = "Denne faktor bruges til appen.";
var appDevices$m = "Denne faktor bruges til appen";
var appFactor$m = "Denne faktor bruges til appen.";
var application$m = "Application";
var appName$m = "App Name";
var appPortal$m = "App Portal";
var assumedUserNotification$m = "You cannot edit personal information while assuming a user.";
var broswerExtension$m = "Browser Extension";
var browser$m = "Browser";
var browserDeleteFailure$m = "Failed to delete trusted browser";
var browserDeleteSuccess$m = "Trusted browser was successfully deleted";
var browserDevice$m = "Browser/Device";
var browserFetchFailure$m = "Failed to fetch browsers";
var calling$m = "Ringer";
var callUserAgain$m = "Calling you again";
var cancel$m = "annuller";
var changePassword$m = "Change Password";
var changeSecurityFactor$m = "Change Security Factor";
var clearIcon$m = "ryd ikon";
var close$m = "Close";
var closeDialog$m = "Luk samtale";
var codeResent$m = "Code has been sent to your phone.";
var companyLogo$m = "firmalogo";
var companyTab$m = "Default for company tab";
var conditionalRequirement$m = "At least {number} of the following requirements:";
var configuredOn$m = "Configured On";
var confirm$m = "bekræft";
var contactAdminEmailOtp$m = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$m = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$m = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$m = "Contact your admin to reset password.";
var credentialId$m = "Credential ID";
var current$m = "Current";
var currentPassword$m = "Current password";
var deleteDeviceSuccess$m = "{factorName} was successfully deleted";
var deleteQuestion$m = "Delete question {position}";
var details$m = "Details";
var device$m = "Device";
var deviceDeleteFailure$m = "Failed to remove {factorName}";
var deviceFetchFailure$m = "Failed to fetch devices";
var deviceNameCannotBeBlank$m = "Authentication device name cannot be blank.";
var deviceRenameFailure$m = "Failed to update device name";
var downloadOnAppStore$m = "Download i app-butikken";
var editDeviceName$m = "Edit name";
var editSQinfo$m = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$m = "Enroll new primary factor";
var event$m = "Event";
var eventType$m = "Event Type";
var eventUserAgent$m = "Event Useragent";
var eventUseragent$m = "Event Useragent";
var eventUUID$m = "Event UUID";
var eventUuid$m = "Event UUID";
var expirationDays$m = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$m = "Expire Date";
var expires$m = "Expires";
var extensionVersionInstalled$m = "Version {versionString} installed";
var factor$m = "Factor";
var factorFetchFailure$m = "Failed to fetch available factors";
var factorMfaTokenFailure$m = "Failed to fetch mfa token";
var factorPrimaryFailure$m = "Failed to set {factorName} as your primary factor";
var factors$m = "factors";
var factorsFetchFailure$m = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$m = "We couldn’t load your user information.";
var failedToRegisterAnswers$m = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$m = "We couldn't retrieve your security questions at this time.";
var forcedLogout$m = "Forced Logout";
var getOnGooglePlay$m = "Få den på Google Play";
var goToExternalSite$m = "Go to external site";
var helpRequestFailed$m = "We couldn't submit your help request.";
var helpRequestSuccessful$m = "Your support request has been sent to your OneLogin Admin.";
var hostname$m = "Hostname & OS";
var icon$m = "Icon";
var identifier$m = "Credential ID / Identifier";
var imageUpload$m = "Image Upload";
var inactive$m = "Inactive";
var inactiveDevice$m = "Inactive device";
var install$m = "Install";
var invalidCode$m = "Invalid code";
var invalidPhoneNumber$m = "Please use valid phone number.";
var language$m = "Language";
var languageConfirmation$m = "Are you sure you want to switch to {language}?";
var lastAuthentication$m = "Last Authentication";
var lastChanged$m = "Last changed";
var lastUsed$m = "Last Used";
var length$m = "Minimum {length} characters";
var letter$m = "1 Letter";
var linkToAppStore$m = "Link til App Store";
var linkToGooglePlay$m = "Link til Google Play";
var loadingRecentActivity$m = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$m = "Loading trusted browsers, please wait...";
var location$m = "Location";
var locationTime$m = "Location/Time";
var loggedOut$m = "Logged Out";
var login$m = "login";
var loginDevice$m = "Login device";
var loginEvent$m = "Login";
var loginFactor$m = "Denne faktor bruges til login.";
var loginFailedEvent$m = "Login Failed";
var loginName$m = "Login Name";
var logOut$m = "Log Out";
var lower$m = "1 Lowercase";
var message$m = "{name} was successfully added.";
var mfaRegistrationFailure$m = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$m = "You successfully registered the device";
var more$m = "More";
var never$m = "Never";
var newPassword$m = "New password";
var newPrimaryFactor$m = "New primary factor";
var noActivities$m = "No activities have been made";
var noDevicesConfigured$m = "No devices have been configured";
var noExpiration$m = "Never expires";
var noMoreSecurityFactors$m = "There are no security factors available for registration.";
var notifyErrorLoadingUser$m = "Loading of user failed. Try again later";
var notifySuccessAddApp$m = "{name} was successfully added.";
var noTrustedBrowsers$m = "No browsers have been saved";
var numbers$m = "1 Number";
var oneloginDesktop$m = "OneLogin Desktop";
var oneloginDesktopFetchFailure$m = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$m = "OneLogin logo";
var onlyDesktopBrowsersSupported$m = "We currently only support browser extensions on desktop browsers.";
var otp1$m = "OTP 1";
var otp2$m = "OTP 2";
var otpDevice$m = "Denne faktor bruges til at logge ind.";
var parsingUserProfilePhotoFailure$m = "Getting image details failed";
var password$m = "password";
var passwordChanged$m = "Password Changed";
var passwordChangedDays$m = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$m = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$m = "Your administrator has configured an external site for resetting your password.";
var passwordReset$m = "Password Reset";
var passwordUpdatedSuccessfully$m = "You have successfully updated your password.";
var passwordUpdateFailure$m = "Password update failed";
var phoneNumber$m = "Phone number";
var prefix$m = "Suspicious login report";
var previousDeviceName$m = "Previously {previousName}";
var primary$m = "Primary";
var proceedAnyway$m = "Proceed anyway";
var profile$m = "Profile";
var profileAvatar$m = "Profile avatar";
var profileMenuToggle$m = "Open profile menu";
var profilePhoto$m = "Profile photo";
var profilePhotoAction$m = "Profile image action";
var pwResetDevice$m = "Denne faktor bruges til nulstilling af adgangskode.";
var pwResetFactor$m = "Denne faktor bruges til adgangskodenulstilling.";
var questionNumber$m = "Question {position}";
var radiusAuthentication$m = "Service Login via Radius";
var recentActivity$m = "Recent Activity";
var redirectToChangePassword$m = "Redirect to change your password?";
var registerSecurityQuestions$m = "Register Security Questions";
var registrationRejected$m = "Registration unsuccessful, please try again.";
var registrationTimedout$m = "Registration context timed out";
var remove$m = "Remove";
var removeCurrentBrowserWarning$m = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$m = "You have successfully removed your profile picture.";
var removeFactorWarning$m = "Are you sure you want to remove {factor}?";
var removeImage$m = "Remove image";
var report$m = "Report";
var reportActivity$m = "Report Activity";
var requestField$m = "Describe the issue you're having";
var requiredQuestions$m = "Required Questions";
var revert$m = "Gå tilbage";
var revertToAdmin$m = "Revert to Admin";
var revertToSuperadmin$m = "Revert to OneLogin Admin";
var revoke$m = "Revoke";
var save$m = "Save Changes";
var searchIcon$m = "søg ikon";
var secureNotes$m = "Secure Notes";
var securityFactorAdded$m = "Security Factor Added";
var securityFactorRemoved$m = "Security Factor Removed";
var securityFactorRenamed$m = "Security Factor Renamed";
var securityFactors$m = "Security Factors";
var securityFactorsDescription$m = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$m = "Security Factors Updated";
var selectNewImage$m = "Select new image";
var selectNewPrimary$m = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$m = "Select Security Factor";
var sending$m = "Sender";
var setPrimaryDevice$m = "Set as primary";
var showDetails$m = "Vis detaljer";
var specials$m = "1 Special character";
var sqDropdownAriaLabel$m = "Question {position} dropdown";
var sqInfoHeader$m = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$m = "Blank answers will not be accepted";
var sqTipDoNotShare$m = "Do not share your questions and answers with anyone.";
var sqTipMinimum$m = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$m = "Answers are not case-sensitive.";
var sqTipNoUsePassword$m = "Do not use a password as an answer.";
var sqTipSameAnswer$m = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$m = "Special characters such as @#&*. will be ignored";
var submit$m = "Submit";
var submitting$m = "Submitting…";
var support$m = "Support";
var supportDefaultDescription$m = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$m = "Supported browsers: {browsers}";
var supportRequestHeader$m = "Support Request";
var time$m = "Time";
var trustDevice$m = "Trust Device";
var trusted$m = "Trusted";
var trustedBrowsers$m = "Trusted Browsers";
var trustedBrowsersDescription$m = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$m = "Trusted Device";
var unavailable$m = "Unavailable";
var unavailableTime$m = "Unavailable";
var unsetFactorSuccess$m = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$m = "Unset as primary";
var unsupportedBrowser$m = "Unsupported Browser";
var unsupportedBrowserHeading$m = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$m = "{newName} was successfully updated";
var updateFactorSuccess$m = "{factorName} is your new default security factor";
var updatePassword$m = "Update Password";
var updateUserProfileFailure$m = "Profile Update Failed";
var updateUserProfilePhotoFailure$m = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$m = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$m = "You have successfully updated your profile.";
var upper$m = "1 Uppercase";
var usedFor$m = "Used For";
var usedForApp$m = "This factor is used for app.";
var usedForLogin$m = "This factor is used for login.";
var usedForPasswordReset$m = "This factor is used for password reset.";
var version$m = "Version: {versionString}";
var yourBrowser$m = "Your browser: {browser}";
var da = {
	"26286820": "Indtast identifikations-id og to fortløbende sikkerhedskoder fra Symantec VIP Access.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Indtast den kode du modtog på SMS.",
	"374233718": "Du kan prøve igen om {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
	"437305782": "Bekræft dine WebAuthn godkendere nu.",
	"505702857": "Magisk link",
	"519412053": "Skift godkendelsesfaktor",
	"655462232": "Hent og installer OneLogin Protect på din enhed",
	"660592555": "OK",
	"662924178": "Det ser ud til at det ikke er vores dag i dag.",
	"694278426": "Indtast din {deviceName} kode",
	"694920552": "Første sikkerhedskode",
	"737192390": "Åbn {appName}",
	"740457555": "Anden kode",
	"744377571": "Minimum antal {length} tegn",
	"751710530": "Indsend",
	"916760408": "Indtast et brugernavn og en sikkerhedskode fra din enhed.",
	"921093870": "Har du ikke modtaget koden?",
	"966052509": "Ingen resultater",
	"987359842": "Klik på linket i din e-mail for at fortsætte",
	"1068496829": "Vælg sikkerhedsspørgsmål {current}/{total}",
	"1079852660": "Indtast to sikkerhedskoder efter hinanden",
	"1080736814": "Indtast {fieldName} fra Symantec VIP Access-appen",
	"1136625613": "Handlingen blev annulleret. Prøv venligst igen eller brug en anden godkendelsesfaktor.",
	"1212847248": "En bekræftelseskode blev sendt til din konfigurerede adresse.",
	"1232460711": "Indtast din email",
	"1242107845": "Vis",
	"1254879564": "Ny adgangskode",
	"1359200231": "Send",
	"1433651550": "Indtast koden fra OneLogin SMS.",
	"1477893598": "Konfigurer",
	"1536965459": "Hent og installer OneLogin Protect på din enhed",
	"1624184662": "For at indstille OneLogin SMS vil vi sende dig en aktiveringskode via SMS. Du skal bruge denne aktiveringskode til at fuldføre enhedsregistreringen.",
	"1654624862": "Sikkerhedskode",
	"1833121415": "Oplys svar {current}/{total}",
	"1919587067": "Gensend kode",
	"1935535842": "Påkrævet",
	"1963245695": "1 stort bogstav",
	"2018264248": "Prøv igen",
	"2091874550": "Første kode",
	"2097632732": "Scan stregkode i stedet",
	"2104438124": "Indtast {fieldName} og to sikkerhedskoder efter hinanden fra Symantec VIP Access.",
	"2124363772": "Indtast dit brugernavn og din sikkerhedskode fra dit SecurID-token.",
	"2229754167": "Indtast dit telefonnummer",
	"2244720377": "En uventet fejl ser ud til at have fundet sted.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Et adgangslink blev sendt til din e-mail",
	"2600324508": "Skjul",
	"2606375562": "Indsæt din YubiKey i USB-porten og tryk på knappen",
	"2663586870": "Brugernavn",
	"2758306961": "Identifikations-id",
	"2792137744": "1 tal",
	"2815222727": "Scan denne stregkode",
	"2828880379": "Bekræft",
	"2859281487": "2-faktor-godkendelse er påkrævet for at sikre din konto.",
	"2942752129": "Anden sikkerhedskode",
	"3060896801": "Har du problemer?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 specialtegn",
	"3294346597": "Prøv igen",
	"3327626662": "Indtast din bekræftelseskode",
	"3374226769": "Klik på Par hvis du bruger manuel indtastning",
	"3469481929": "Kan du ikke scanne koden?",
	"3499598078": "Åben menu",
	"3528672691": "Annuller",
	"3640052215": "Fortsæt",
	"3645029425": "Scan nedenstående QR-kode",
	"3645116517": "Indtast denne kode, når du modtager opkaldet:",
	"3663548834": "Vi undersøger problemet og forventer snart at være tilbage. Vent et par minutter <br /> og opdater din browser, eller besøg vores <a href='https://www.onelogin.com/status'> Statusside </a>.",
	"3669652728": "Et adgangslink blev sendt til",
	"3673120330": "Næste",
	"3737470122": "Kontakt venligst admin for flere detaljer.",
	"3781468762": "Din browser understøtter ikke WebAuthn",
	"3827227259": "En bekræftelseskode er blevet sendt til",
	"3855542277": "Indtast denne kode i appen",
	"3865193889": "Aktiver",
	"3877285238": "1 lille bogstav",
	"4000449233": "Ringer til nedenstående telefonnummer:",
	"4072532148": "Gensend SMS-kode",
	"4151518079": "Vælg sikkerhedsspørgsmål {current} / {total}",
	"4152906165": "Vi undersøger problemet og forventer at være tilbage snart. Vent venligst et par minutter{break}og genopfrisk din browser, eller besøg vores <link>statusside</link>.",
	"4227081527": "Når appen er installeret, skal du komme tilbage til denne skærm og klikke på {action}",
	"4281662478": "Søg",
	addApp: addApp$m,
	addFactor: addFactor$m,
	additionalQuestions: additionalQuestions$m,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$m,
	addNewSecurityQuestion: addNewSecurityQuestion$m,
	administration: administration$m,
	alert: alert$m,
	all: all$m,
	app: app$m,
	appDevice: appDevice$m,
	appDevices: appDevices$m,
	appFactor: appFactor$m,
	application: application$m,
	appName: appName$m,
	appPortal: appPortal$m,
	assumedUserNotification: assumedUserNotification$m,
	broswerExtension: broswerExtension$m,
	browser: browser$m,
	browserDeleteFailure: browserDeleteFailure$m,
	browserDeleteSuccess: browserDeleteSuccess$m,
	browserDevice: browserDevice$m,
	browserFetchFailure: browserFetchFailure$m,
	calling: calling$m,
	callUserAgain: callUserAgain$m,
	cancel: cancel$m,
	changePassword: changePassword$m,
	changeSecurityFactor: changeSecurityFactor$m,
	clearIcon: clearIcon$m,
	close: close$m,
	closeDialog: closeDialog$m,
	codeResent: codeResent$m,
	companyLogo: companyLogo$m,
	companyTab: companyTab$m,
	conditionalRequirement: conditionalRequirement$m,
	configuredOn: configuredOn$m,
	confirm: confirm$m,
	contactAdminEmailOtp: contactAdminEmailOtp$m,
	contactAdminForSMS: contactAdminForSMS$m,
	contactAdminForVoice: contactAdminForVoice$m,
	contactAdminPasswordReset: contactAdminPasswordReset$m,
	credentialId: credentialId$m,
	current: current$m,
	currentPassword: currentPassword$m,
	deleteDeviceSuccess: deleteDeviceSuccess$m,
	deleteQuestion: deleteQuestion$m,
	details: details$m,
	device: device$m,
	deviceDeleteFailure: deviceDeleteFailure$m,
	deviceFetchFailure: deviceFetchFailure$m,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$m,
	deviceRenameFailure: deviceRenameFailure$m,
	downloadOnAppStore: downloadOnAppStore$m,
	editDeviceName: editDeviceName$m,
	editSQinfo: editSQinfo$m,
	enrollNewFactor: enrollNewFactor$m,
	event: event$m,
	eventType: eventType$m,
	eventUserAgent: eventUserAgent$m,
	eventUseragent: eventUseragent$m,
	eventUUID: eventUUID$m,
	eventUuid: eventUuid$m,
	expirationDays: expirationDays$m,
	expireDate: expireDate$m,
	expires: expires$m,
	extensionVersionInstalled: extensionVersionInstalled$m,
	factor: factor$m,
	factorFetchFailure: factorFetchFailure$m,
	factorMfaTokenFailure: factorMfaTokenFailure$m,
	factorPrimaryFailure: factorPrimaryFailure$m,
	factors: factors$m,
	factorsFetchFailure: factorsFetchFailure$m,
	failedToFetchUserInfo: failedToFetchUserInfo$m,
	failedToRegisterAnswers: failedToRegisterAnswers$m,
	failedToRetrieveQuestions: failedToRetrieveQuestions$m,
	forcedLogout: forcedLogout$m,
	getOnGooglePlay: getOnGooglePlay$m,
	goToExternalSite: goToExternalSite$m,
	helpRequestFailed: helpRequestFailed$m,
	helpRequestSuccessful: helpRequestSuccessful$m,
	hostname: hostname$m,
	icon: icon$m,
	identifier: identifier$m,
	imageUpload: imageUpload$m,
	inactive: inactive$m,
	inactiveDevice: inactiveDevice$m,
	install: install$m,
	invalidCode: invalidCode$m,
	invalidPhoneNumber: invalidPhoneNumber$m,
	language: language$m,
	languageConfirmation: languageConfirmation$m,
	lastAuthentication: lastAuthentication$m,
	lastChanged: lastChanged$m,
	lastUsed: lastUsed$m,
	length: length$m,
	letter: letter$m,
	linkToAppStore: linkToAppStore$m,
	linkToGooglePlay: linkToGooglePlay$m,
	loadingRecentActivity: loadingRecentActivity$m,
	loadingTrustedBrowsers: loadingTrustedBrowsers$m,
	location: location$m,
	locationTime: locationTime$m,
	loggedOut: loggedOut$m,
	login: login$m,
	loginDevice: loginDevice$m,
	loginEvent: loginEvent$m,
	loginFactor: loginFactor$m,
	loginFailedEvent: loginFailedEvent$m,
	loginName: loginName$m,
	logOut: logOut$m,
	lower: lower$m,
	message: message$m,
	mfaRegistrationFailure: mfaRegistrationFailure$m,
	mfaRegistrationSuccess: mfaRegistrationSuccess$m,
	more: more$m,
	never: never$m,
	newPassword: newPassword$m,
	newPrimaryFactor: newPrimaryFactor$m,
	noActivities: noActivities$m,
	noDevicesConfigured: noDevicesConfigured$m,
	noExpiration: noExpiration$m,
	noMoreSecurityFactors: noMoreSecurityFactors$m,
	notifyErrorLoadingUser: notifyErrorLoadingUser$m,
	notifySuccessAddApp: notifySuccessAddApp$m,
	noTrustedBrowsers: noTrustedBrowsers$m,
	numbers: numbers$m,
	oneloginDesktop: oneloginDesktop$m,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$m,
	oneloginLogo: oneloginLogo$m,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$m,
	otp1: otp1$m,
	otp2: otp2$m,
	otpDevice: otpDevice$m,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$m,
	password: password$m,
	passwordChanged: passwordChanged$m,
	passwordChangedDays: passwordChangedDays$m,
	passwordHint: passwordHint$m,
	passwordRedirectDescription: passwordRedirectDescription$m,
	passwordReset: passwordReset$m,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$m,
	passwordUpdateFailure: passwordUpdateFailure$m,
	phoneNumber: phoneNumber$m,
	prefix: prefix$m,
	previousDeviceName: previousDeviceName$m,
	primary: primary$m,
	proceedAnyway: proceedAnyway$m,
	profile: profile$m,
	profileAvatar: profileAvatar$m,
	profileMenuToggle: profileMenuToggle$m,
	profilePhoto: profilePhoto$m,
	profilePhotoAction: profilePhotoAction$m,
	pwResetDevice: pwResetDevice$m,
	pwResetFactor: pwResetFactor$m,
	questionNumber: questionNumber$m,
	radiusAuthentication: radiusAuthentication$m,
	recentActivity: recentActivity$m,
	redirectToChangePassword: redirectToChangePassword$m,
	registerSecurityQuestions: registerSecurityQuestions$m,
	registrationRejected: registrationRejected$m,
	registrationTimedout: registrationTimedout$m,
	remove: remove$m,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$m,
	removedProfilePictureSuccess: removedProfilePictureSuccess$m,
	removeFactorWarning: removeFactorWarning$m,
	removeImage: removeImage$m,
	report: report$m,
	reportActivity: reportActivity$m,
	requestField: requestField$m,
	requiredQuestions: requiredQuestions$m,
	revert: revert$m,
	revertToAdmin: revertToAdmin$m,
	revertToSuperadmin: revertToSuperadmin$m,
	revoke: revoke$m,
	save: save$m,
	searchIcon: searchIcon$m,
	secureNotes: secureNotes$m,
	securityFactorAdded: securityFactorAdded$m,
	securityFactorRemoved: securityFactorRemoved$m,
	securityFactorRenamed: securityFactorRenamed$m,
	securityFactors: securityFactors$m,
	securityFactorsDescription: securityFactorsDescription$m,
	securityFactorsUpdated: securityFactorsUpdated$m,
	selectNewImage: selectNewImage$m,
	selectNewPrimary: selectNewPrimary$m,
	selectSecurityFactor: selectSecurityFactor$m,
	sending: sending$m,
	setPrimaryDevice: setPrimaryDevice$m,
	showDetails: showDetails$m,
	specials: specials$m,
	sqDropdownAriaLabel: sqDropdownAriaLabel$m,
	sqInfoHeader: sqInfoHeader$m,
	sqTipBlankAnswers: sqTipBlankAnswers$m,
	sqTipDoNotShare: sqTipDoNotShare$m,
	sqTipMinimum: sqTipMinimum$m,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$m,
	sqTipNoUsePassword: sqTipNoUsePassword$m,
	sqTipSameAnswer: sqTipSameAnswer$m,
	sqTipSpecialChars: sqTipSpecialChars$m,
	submit: submit$m,
	submitting: submitting$m,
	support: support$m,
	supportDefaultDescription: supportDefaultDescription$m,
	supportedBrowsers: supportedBrowsers$m,
	supportRequestHeader: supportRequestHeader$m,
	"switch": "Switch",
	time: time$m,
	trustDevice: trustDevice$m,
	trusted: trusted$m,
	trustedBrowsers: trustedBrowsers$m,
	trustedBrowsersDescription: trustedBrowsersDescription$m,
	trustedDevice: trustedDevice$m,
	unavailable: unavailable$m,
	unavailableTime: unavailableTime$m,
	unsetFactorSuccess: unsetFactorSuccess$m,
	unsetPrimaryDevice: unsetPrimaryDevice$m,
	unsupportedBrowser: unsupportedBrowser$m,
	unsupportedBrowserHeading: unsupportedBrowserHeading$m,
	updateDeviceNameSuccess: updateDeviceNameSuccess$m,
	updateFactorSuccess: updateFactorSuccess$m,
	updatePassword: updatePassword$m,
	updateUserProfileFailure: updateUserProfileFailure$m,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$m,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$m,
	updateUserProfileSuccess: updateUserProfileSuccess$m,
	upper: upper$m,
	usedFor: usedFor$m,
	usedForApp: usedForApp$m,
	usedForLogin: usedForLogin$m,
	usedForPasswordReset: usedForPasswordReset$m,
	version: version$m,
	yourBrowser: yourBrowser$m
};

var addApp$l = "Show {addApp} button when I log in to new websites.";
var addFactor$l = "Add Factor";
var additionalQuestions$l = "Additional Questions";
var addNewPrimaryBeforeRemove$l = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$l = "Add New Security Question";
var administration$l = "Administration";
var alert$l = "Alert";
var all$l = "all";
var app$l = "App";
var appDevice$l = "Dieser Faktor wird für die App verwendet.";
var appDevices$l = "Dieser Faktor wird für die App verwendet";
var appFactor$l = "Dieser Faktor wird für die App verwendet.";
var application$l = "Application";
var appName$l = "App Name";
var appPortal$l = "App Portal";
var assumedUserNotification$l = "You cannot edit personal information while assuming a user.";
var broswerExtension$l = "Browser Extension";
var browser$l = "Browser";
var browserDeleteFailure$l = "Failed to delete trusted browser";
var browserDeleteSuccess$l = "Trusted browser was successfully deleted";
var browserDevice$l = "Browser/Device";
var browserFetchFailure$l = "Failed to fetch browsers";
var calling$l = "Ruft an";
var callUserAgain$l = "Calling you again";
var cancel$l = "abbrechen";
var changePassword$l = "Change Password";
var changeSecurityFactor$l = "Change Security Factor";
var clearIcon$l = "Löschsymbol";
var close$l = "Close";
var closeDialog$l = "Dialog schließen";
var codeResent$l = "Code has been sent to your phone.";
var companyLogo$l = "Firmenlogo";
var companyTab$l = "Default for company tab";
var conditionalRequirement$l = "At least {number} of the following requirements:";
var configuredOn$l = "Configured On";
var confirm$l = "bestätigen";
var contactAdminEmailOtp$l = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$l = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$l = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$l = "Contact your admin to reset password.";
var credentialId$l = "Credential ID";
var current$l = "Current";
var currentPassword$l = "Current password";
var deleteDeviceSuccess$l = "{factorName} was successfully deleted";
var deleteQuestion$l = "Delete question {position}";
var details$l = "Details";
var device$l = "Device";
var deviceDeleteFailure$l = "Failed to remove {factorName}";
var deviceFetchFailure$l = "Failed to fetch devices";
var deviceNameCannotBeBlank$l = "Authentication device name cannot be blank.";
var deviceRenameFailure$l = "Failed to update device name";
var downloadOnAppStore$l = "Im App Store herunterladen";
var editDeviceName$l = "Edit name";
var editSQinfo$l = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$l = "Enroll new primary factor";
var event$l = "Event";
var eventType$l = "Event Type";
var eventUserAgent$l = "Event Useragent";
var eventUseragent$l = "Event Useragent";
var eventUUID$l = "Event UUID";
var eventUuid$l = "Event UUID";
var expirationDays$l = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$l = "Expire Date";
var expires$l = "Expires";
var extensionVersionInstalled$l = "Version {versionString} installed";
var factor$l = "Factor";
var factorFetchFailure$l = "Failed to fetch available factors";
var factorMfaTokenFailure$l = "Failed to fetch mfa token";
var factorPrimaryFailure$l = "Failed to set {factorName} as your primary factor";
var factors$l = "factors";
var factorsFetchFailure$l = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$l = "We couldn’t load your user information.";
var failedToRegisterAnswers$l = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$l = "We couldn't retrieve your security questions at this time.";
var forcedLogout$l = "Forced Logout";
var getOnGooglePlay$l = "Bei Google Play erhalten";
var goToExternalSite$l = "Go to external site";
var helpRequestFailed$l = "We couldn't submit your help request.";
var helpRequestSuccessful$l = "Your support request has been sent to your OneLogin Admin.";
var hostname$l = "Hostname & OS";
var icon$l = "Icon";
var identifier$l = "Credential ID / Identifier";
var imageUpload$l = "Image Upload";
var inactive$l = "Inactive";
var inactiveDevice$l = "Inactive device";
var install$l = "Install";
var invalidCode$l = "Invalid code";
var invalidPhoneNumber$l = "Please use valid phone number.";
var language$l = "Language";
var languageConfirmation$l = "Are you sure you want to switch to {language}?";
var lastAuthentication$l = "Last Authentication";
var lastChanged$l = "Last changed";
var lastUsed$l = "Last Used";
var length$l = "Minimum {length} characters";
var letter$l = "1 Letter";
var linkToAppStore$l = "Link zum App Store";
var linkToGooglePlay$l = "Link zu Google Play";
var loadingRecentActivity$l = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$l = "Loading trusted browsers, please wait...";
var location$l = "Location";
var locationTime$l = "Location/Time";
var loggedOut$l = "Logged Out";
var login$l = "login";
var loginDevice$l = "Login device";
var loginEvent$l = "Login";
var loginFactor$l = "Dieser Faktor wird für die Anmeldung verwendet.";
var loginFailedEvent$l = "Login Failed";
var loginName$l = "Login Name";
var logOut$l = "Log Out";
var lower$l = "1 Lowercase";
var message$l = "{name} was successfully added.";
var mfaRegistrationFailure$l = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$l = "You successfully registered the device";
var more$l = "More";
var never$l = "Never";
var newPassword$l = "New password";
var newPrimaryFactor$l = "New primary factor";
var noActivities$l = "No activities have been made";
var noDevicesConfigured$l = "No devices have been configured";
var noExpiration$l = "Never expires";
var noMoreSecurityFactors$l = "There are no security factors available for registration.";
var notifyErrorLoadingUser$l = "Loading of user failed. Try again later";
var notifySuccessAddApp$l = "{name} was successfully added.";
var noTrustedBrowsers$l = "No browsers have been saved";
var numbers$l = "1 Number";
var oneloginDesktop$l = "OneLogin Desktop";
var oneloginDesktopFetchFailure$l = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$l = "OneLogin logo";
var onlyDesktopBrowsersSupported$l = "We currently only support browser extensions on desktop browsers.";
var otp1$l = "OTP 1";
var otp2$l = "OTP 2";
var otpDevice$l = "Dieser Faktor wird für die Anmeldung verwendet.";
var parsingUserProfilePhotoFailure$l = "Getting image details failed";
var password$l = "password";
var passwordChanged$l = "Password Changed";
var passwordChangedDays$l = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$l = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$l = "Your administrator has configured an external site for resetting your password.";
var passwordReset$l = "Password Reset";
var passwordUpdatedSuccessfully$l = "You have successfully updated your password.";
var passwordUpdateFailure$l = "Password update failed";
var phoneNumber$l = "Phone number";
var prefix$l = "Suspicious login report";
var previousDeviceName$l = "Previously {previousName}";
var primary$l = "Primary";
var proceedAnyway$l = "Proceed anyway";
var profile$l = "Profile";
var profileAvatar$l = "Profile avatar";
var profileMenuToggle$l = "Open profile menu";
var profilePhoto$l = "Profile photo";
var profilePhotoAction$l = "Profile image action";
var pwResetDevice$l = "Dieser Faktor wird zum Zurücksetzen des Passworts verwendet.";
var pwResetFactor$l = "Dieser Faktor wird für das Zurücksetzen des Passworts verwendet.";
var questionNumber$l = "Question {position}";
var radiusAuthentication$l = "Service Login via Radius";
var recentActivity$l = "Recent Activity";
var redirectToChangePassword$l = "Redirect to change your password?";
var registerSecurityQuestions$l = "Register Security Questions";
var registrationRejected$l = "Registration unsuccessful, please try again.";
var registrationTimedout$l = "Registration context timed out";
var remove$l = "Remove";
var removeCurrentBrowserWarning$l = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$l = "You have successfully removed your profile picture.";
var removeFactorWarning$l = "Are you sure you want to remove {factor}?";
var removeImage$l = "Remove image";
var report$l = "Report";
var reportActivity$l = "Report Activity";
var requestField$l = "Describe the issue you're having";
var requiredQuestions$l = "Required Questions";
var revert$l = "rückgängig machen";
var revertToAdmin$l = "Revert to Admin";
var revertToSuperadmin$l = "Revert to OneLogin Admin";
var revoke$l = "Revoke";
var save$l = "Save Changes";
var searchIcon$l = "Suchsymbol";
var secureNotes$l = "Secure Notes";
var securityFactorAdded$l = "Security Factor Added";
var securityFactorRemoved$l = "Security Factor Removed";
var securityFactorRenamed$l = "Security Factor Renamed";
var securityFactors$l = "Security Factors";
var securityFactorsDescription$l = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$l = "Security Factors Updated";
var selectNewImage$l = "Select new image";
var selectNewPrimary$l = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$l = "Select Security Factor";
var sending$l = "Wird gesendet";
var setPrimaryDevice$l = "Set as primary";
var showDetails$l = "Details anzeigen";
var specials$l = "1 Special character";
var sqDropdownAriaLabel$l = "Question {position} dropdown";
var sqInfoHeader$l = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$l = "Blank answers will not be accepted";
var sqTipDoNotShare$l = "Do not share your questions and answers with anyone.";
var sqTipMinimum$l = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$l = "Answers are not case-sensitive.";
var sqTipNoUsePassword$l = "Do not use a password as an answer.";
var sqTipSameAnswer$l = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$l = "Special characters such as @#&*. will be ignored";
var submit$l = "Submit";
var submitting$l = "Submitting…";
var support$l = "Support";
var supportDefaultDescription$l = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$l = "Supported browsers: {browsers}";
var supportRequestHeader$l = "Support Request";
var time$l = "Time";
var trustDevice$l = "Trust Device";
var trusted$l = "Trusted";
var trustedBrowsers$l = "Trusted Browsers";
var trustedBrowsersDescription$l = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$l = "Trusted Device";
var unavailable$l = "Unavailable";
var unavailableTime$l = "Unavailable";
var unsetFactorSuccess$l = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$l = "Unset as primary";
var unsupportedBrowser$l = "Unsupported Browser";
var unsupportedBrowserHeading$l = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$l = "{newName} was successfully updated";
var updateFactorSuccess$l = "{factorName} is your new default security factor";
var updatePassword$l = "Update Password";
var updateUserProfileFailure$l = "Profile Update Failed";
var updateUserProfilePhotoFailure$l = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$l = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$l = "You have successfully updated your profile.";
var upper$l = "1 Uppercase";
var usedFor$l = "Used For";
var usedForApp$l = "This factor is used for app.";
var usedForLogin$l = "This factor is used for login.";
var usedForPasswordReset$l = "This factor is used for password reset.";
var version$l = "Version: {versionString}";
var yourBrowser$l = "Your browser: {browser}";
var de = {
	"26286820": "Geben Sie die Anmeldekennung und zwei aufeinanderfolgende Sicherheitscodes von Symantec VIP Access ein.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Geben Sie den Code ein, den Sie per SMS erhalten haben.",
	"374233718": "Sie können es in {secLeft, number} {secLeft, plural, one {second} other {seconds}} erneut versuchen",
	"437305782": "Ihre WebAuthn-Authentifikatoren werden jetzt überprüft.",
	"505702857": "Magischer Link",
	"519412053": "Authentifizierungsfaktor ändern",
	"655462232": "Laden Sie OneLogin Protect auf Ihr Gerät herunter und installieren Sie es.",
	"660592555": "Okay",
	"662924178": "Heute scheint nicht Ihr Tag zu sein.",
	"694278426": "Geben Sie Ihren {deviceName}-Code ein",
	"694920552": "Erster Sicherheitscode",
	"737192390": "{appName} starten",
	"740457555": "Zweiter Code",
	"744377571": "Mindestens {length} Zeichen",
	"751710530": "Absenden",
	"916760408": "Geben Sie einen Benutzernamen und einen Sicherheitscode von Ihrem Gerät ein.",
	"921093870": "Sie haben den Code nicht erhalten?",
	"966052509": "Keine Ergebnisse",
	"987359842": "Bitte klicken Sie auf den Link in Ihrer E-Mail, um fortzufahren",
	"1068496829": "Sicherheitsfrage {current}/{total} auswählen",
	"1079852660": "Geben Sie zwei aufeinanderfolgende Sicherheitscodes ein",
	"1080736814": "Geben Sie {fieldName} aus der App „Symantec VIP Access” ein",
	"1136625613": "Der Vorgang wurde abgebrochen. Bitte versuchen Sie es erneut oder verwenden Sie einen anderen Authentifizierungsfaktor.",
	"1212847248": "Ein Bestätigungscode wurde an Ihre eingestellte Adresse gesendet.",
	"1232460711": "Geben Sie Ihre E-Mail ein",
	"1242107845": "Zeigen",
	"1254879564": "Neues Passwort",
	"1359200231": "Senden",
	"1433651550": "Geben Sie den Code von OneLogin SMS ein.",
	"1477893598": "Konfigurieren",
	"1536965459": "Laden Sie OneLogin Protect auf Ihr Gerät herunter und installieren Sie es.",
	"1624184662": "Wir schicken Ihnen zum Einrichten von OneLogin SMS eine SMS mit einem Aktivierungscode. Diesen Aktivierungscode brauchen Sie, um die Registrierung des Gerätes abzuschließen.",
	"1654624862": "Sicherheitscode",
	"1833121415": "Antwort {current}/{total} eingeben",
	"1919587067": "Code erneut senden",
	"1935535842": "Erforderlich",
	"1963245695": "1 Großbuchstabe",
	"2018264248": "Erneut versuchen",
	"2091874550": "Erster Code",
	"2097632732": "Stattdessen Barcode scannen",
	"2104438124": "Geben Sie {fieldName} und zwei aufeinanderfolgende Sicherheitscodes aus Symantec VIP Access ein.",
	"2124363772": "Geben Sie Ihren Benutzernamen und Sicherheitscode aus Ihrem SecurID-Token ein.",
	"2229754167": "Geben Sie Ihre Telefonnummer ein",
	"2244720377": "Es scheint ein unerwarteter Fehler aufgetreten zu sein.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Es wurde ein Zugangslink an Ihre E-Mail-Adresse gesendet",
	"2600324508": "Ausblenden",
	"2606375562": "Stecken Sie Ihren YubiKey in den USB-Anschluss und drücken Sie die Taste",
	"2663586870": "Benutzername",
	"2758306961": "Anmeldekennung",
	"2792137744": "1 Zahl",
	"2815222727": "Diesen Barcode scannen",
	"2828880379": "Bestätigen",
	"2859281487": "Zum Sichern Ihres Kontos ist die Zwei-Faktor-Authentifizierung erforderlich.",
	"2942752129": "Zweiter Sicherheitscode",
	"3060896801": "Haben Sie Schwierigkeiten?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 Sonderzeichen",
	"3294346597": "Erneut versuchen",
	"3327626662": "Geben Sie Ihren Bestätigungscode ein",
	"3374226769": "Klicken Sie per manueller Eingabe auf „Koppeln”.",
	"3469481929": "Sie können den Code nicht scannen?",
	"3499598078": "Menü öffnen",
	"3528672691": "Abbrechen",
	"3640052215": "Fortfahren",
	"3645029425": "Scannen Sie den untenstehenden QR-Code",
	"3645116517": "Geben Sie diesen Code ein, wenn Sie den Anruf erhalten:",
	"3663548834": "Wir kümmern uns um das Problem und sind voraussichtlich bald wieder da. Bitte warten Sie ein paar Minuten<br />und aktualisieren Ihren Browser oder besuchen Sie unsere <a href='https://www.onelogin.com/status'>Statusseite</a>.",
	"3669652728": "Ein Zugangslink wurde gesendet an",
	"3673120330": "Weiter",
	"3737470122": "Bitte wenden Sie sich für weitere Informationen an den Administrator.",
	"3781468762": "Ihr Browser unterstützt WebAuthn nicht",
	"3827227259": "Ein Bestätigungscode wurde gesendet an",
	"3855542277": "Geben Sie diesen Code in die App ein",
	"3865193889": "Aktivieren",
	"3877285238": "1 Kleinbuchstabe",
	"4000449233": "Die folgende Telefonnummer wird angerufen:",
	"4072532148": "SMS-Code erneut senden",
	"4151518079": "Sicherheitsfrage {current} / {total} auswählen",
	"4152906165": "Wir untersuchen das Problem und werden uns bald wieder melden. Bitte warten Sie ein paar Minuten{break}und aktualisieren Sie Ihren Browser oder besuchen Sie unsere <link>Statusseite</link>.",
	"4227081527": "Kehren Sie zu diesem Bildschirm zurück, wenn die App installiert ist, und klicken Sie auf {action}.",
	"4281662478": "Suche",
	addApp: addApp$l,
	addFactor: addFactor$l,
	additionalQuestions: additionalQuestions$l,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$l,
	addNewSecurityQuestion: addNewSecurityQuestion$l,
	administration: administration$l,
	alert: alert$l,
	all: all$l,
	app: app$l,
	appDevice: appDevice$l,
	appDevices: appDevices$l,
	appFactor: appFactor$l,
	application: application$l,
	appName: appName$l,
	appPortal: appPortal$l,
	assumedUserNotification: assumedUserNotification$l,
	broswerExtension: broswerExtension$l,
	browser: browser$l,
	browserDeleteFailure: browserDeleteFailure$l,
	browserDeleteSuccess: browserDeleteSuccess$l,
	browserDevice: browserDevice$l,
	browserFetchFailure: browserFetchFailure$l,
	calling: calling$l,
	callUserAgain: callUserAgain$l,
	cancel: cancel$l,
	changePassword: changePassword$l,
	changeSecurityFactor: changeSecurityFactor$l,
	clearIcon: clearIcon$l,
	close: close$l,
	closeDialog: closeDialog$l,
	codeResent: codeResent$l,
	companyLogo: companyLogo$l,
	companyTab: companyTab$l,
	conditionalRequirement: conditionalRequirement$l,
	configuredOn: configuredOn$l,
	confirm: confirm$l,
	contactAdminEmailOtp: contactAdminEmailOtp$l,
	contactAdminForSMS: contactAdminForSMS$l,
	contactAdminForVoice: contactAdminForVoice$l,
	contactAdminPasswordReset: contactAdminPasswordReset$l,
	credentialId: credentialId$l,
	current: current$l,
	currentPassword: currentPassword$l,
	deleteDeviceSuccess: deleteDeviceSuccess$l,
	deleteQuestion: deleteQuestion$l,
	details: details$l,
	device: device$l,
	deviceDeleteFailure: deviceDeleteFailure$l,
	deviceFetchFailure: deviceFetchFailure$l,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$l,
	deviceRenameFailure: deviceRenameFailure$l,
	downloadOnAppStore: downloadOnAppStore$l,
	editDeviceName: editDeviceName$l,
	editSQinfo: editSQinfo$l,
	enrollNewFactor: enrollNewFactor$l,
	event: event$l,
	eventType: eventType$l,
	eventUserAgent: eventUserAgent$l,
	eventUseragent: eventUseragent$l,
	eventUUID: eventUUID$l,
	eventUuid: eventUuid$l,
	expirationDays: expirationDays$l,
	expireDate: expireDate$l,
	expires: expires$l,
	extensionVersionInstalled: extensionVersionInstalled$l,
	factor: factor$l,
	factorFetchFailure: factorFetchFailure$l,
	factorMfaTokenFailure: factorMfaTokenFailure$l,
	factorPrimaryFailure: factorPrimaryFailure$l,
	factors: factors$l,
	factorsFetchFailure: factorsFetchFailure$l,
	failedToFetchUserInfo: failedToFetchUserInfo$l,
	failedToRegisterAnswers: failedToRegisterAnswers$l,
	failedToRetrieveQuestions: failedToRetrieveQuestions$l,
	forcedLogout: forcedLogout$l,
	getOnGooglePlay: getOnGooglePlay$l,
	goToExternalSite: goToExternalSite$l,
	helpRequestFailed: helpRequestFailed$l,
	helpRequestSuccessful: helpRequestSuccessful$l,
	hostname: hostname$l,
	icon: icon$l,
	identifier: identifier$l,
	imageUpload: imageUpload$l,
	inactive: inactive$l,
	inactiveDevice: inactiveDevice$l,
	install: install$l,
	invalidCode: invalidCode$l,
	invalidPhoneNumber: invalidPhoneNumber$l,
	language: language$l,
	languageConfirmation: languageConfirmation$l,
	lastAuthentication: lastAuthentication$l,
	lastChanged: lastChanged$l,
	lastUsed: lastUsed$l,
	length: length$l,
	letter: letter$l,
	linkToAppStore: linkToAppStore$l,
	linkToGooglePlay: linkToGooglePlay$l,
	loadingRecentActivity: loadingRecentActivity$l,
	loadingTrustedBrowsers: loadingTrustedBrowsers$l,
	location: location$l,
	locationTime: locationTime$l,
	loggedOut: loggedOut$l,
	login: login$l,
	loginDevice: loginDevice$l,
	loginEvent: loginEvent$l,
	loginFactor: loginFactor$l,
	loginFailedEvent: loginFailedEvent$l,
	loginName: loginName$l,
	logOut: logOut$l,
	lower: lower$l,
	message: message$l,
	mfaRegistrationFailure: mfaRegistrationFailure$l,
	mfaRegistrationSuccess: mfaRegistrationSuccess$l,
	more: more$l,
	never: never$l,
	newPassword: newPassword$l,
	newPrimaryFactor: newPrimaryFactor$l,
	noActivities: noActivities$l,
	noDevicesConfigured: noDevicesConfigured$l,
	noExpiration: noExpiration$l,
	noMoreSecurityFactors: noMoreSecurityFactors$l,
	notifyErrorLoadingUser: notifyErrorLoadingUser$l,
	notifySuccessAddApp: notifySuccessAddApp$l,
	noTrustedBrowsers: noTrustedBrowsers$l,
	numbers: numbers$l,
	oneloginDesktop: oneloginDesktop$l,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$l,
	oneloginLogo: oneloginLogo$l,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$l,
	otp1: otp1$l,
	otp2: otp2$l,
	otpDevice: otpDevice$l,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$l,
	password: password$l,
	passwordChanged: passwordChanged$l,
	passwordChangedDays: passwordChangedDays$l,
	passwordHint: passwordHint$l,
	passwordRedirectDescription: passwordRedirectDescription$l,
	passwordReset: passwordReset$l,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$l,
	passwordUpdateFailure: passwordUpdateFailure$l,
	phoneNumber: phoneNumber$l,
	prefix: prefix$l,
	previousDeviceName: previousDeviceName$l,
	primary: primary$l,
	proceedAnyway: proceedAnyway$l,
	profile: profile$l,
	profileAvatar: profileAvatar$l,
	profileMenuToggle: profileMenuToggle$l,
	profilePhoto: profilePhoto$l,
	profilePhotoAction: profilePhotoAction$l,
	pwResetDevice: pwResetDevice$l,
	pwResetFactor: pwResetFactor$l,
	questionNumber: questionNumber$l,
	radiusAuthentication: radiusAuthentication$l,
	recentActivity: recentActivity$l,
	redirectToChangePassword: redirectToChangePassword$l,
	registerSecurityQuestions: registerSecurityQuestions$l,
	registrationRejected: registrationRejected$l,
	registrationTimedout: registrationTimedout$l,
	remove: remove$l,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$l,
	removedProfilePictureSuccess: removedProfilePictureSuccess$l,
	removeFactorWarning: removeFactorWarning$l,
	removeImage: removeImage$l,
	report: report$l,
	reportActivity: reportActivity$l,
	requestField: requestField$l,
	requiredQuestions: requiredQuestions$l,
	revert: revert$l,
	revertToAdmin: revertToAdmin$l,
	revertToSuperadmin: revertToSuperadmin$l,
	revoke: revoke$l,
	save: save$l,
	searchIcon: searchIcon$l,
	secureNotes: secureNotes$l,
	securityFactorAdded: securityFactorAdded$l,
	securityFactorRemoved: securityFactorRemoved$l,
	securityFactorRenamed: securityFactorRenamed$l,
	securityFactors: securityFactors$l,
	securityFactorsDescription: securityFactorsDescription$l,
	securityFactorsUpdated: securityFactorsUpdated$l,
	selectNewImage: selectNewImage$l,
	selectNewPrimary: selectNewPrimary$l,
	selectSecurityFactor: selectSecurityFactor$l,
	sending: sending$l,
	setPrimaryDevice: setPrimaryDevice$l,
	showDetails: showDetails$l,
	specials: specials$l,
	sqDropdownAriaLabel: sqDropdownAriaLabel$l,
	sqInfoHeader: sqInfoHeader$l,
	sqTipBlankAnswers: sqTipBlankAnswers$l,
	sqTipDoNotShare: sqTipDoNotShare$l,
	sqTipMinimum: sqTipMinimum$l,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$l,
	sqTipNoUsePassword: sqTipNoUsePassword$l,
	sqTipSameAnswer: sqTipSameAnswer$l,
	sqTipSpecialChars: sqTipSpecialChars$l,
	submit: submit$l,
	submitting: submitting$l,
	support: support$l,
	supportDefaultDescription: supportDefaultDescription$l,
	supportedBrowsers: supportedBrowsers$l,
	supportRequestHeader: supportRequestHeader$l,
	"switch": "Switch",
	time: time$l,
	trustDevice: trustDevice$l,
	trusted: trusted$l,
	trustedBrowsers: trustedBrowsers$l,
	trustedBrowsersDescription: trustedBrowsersDescription$l,
	trustedDevice: trustedDevice$l,
	unavailable: unavailable$l,
	unavailableTime: unavailableTime$l,
	unsetFactorSuccess: unsetFactorSuccess$l,
	unsetPrimaryDevice: unsetPrimaryDevice$l,
	unsupportedBrowser: unsupportedBrowser$l,
	unsupportedBrowserHeading: unsupportedBrowserHeading$l,
	updateDeviceNameSuccess: updateDeviceNameSuccess$l,
	updateFactorSuccess: updateFactorSuccess$l,
	updatePassword: updatePassword$l,
	updateUserProfileFailure: updateUserProfileFailure$l,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$l,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$l,
	updateUserProfileSuccess: updateUserProfileSuccess$l,
	upper: upper$l,
	usedFor: usedFor$l,
	usedForApp: usedForApp$l,
	usedForLogin: usedForLogin$l,
	usedForPasswordReset: usedForPasswordReset$l,
	version: version$l,
	yourBrowser: yourBrowser$l
};

var addApp$k = "Show {addApp} button when I log in to new websites.";
var addFactor$k = "Add Factor";
var additionalQuestions$k = "Additional Questions";
var addNewPrimaryBeforeRemove$k = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$k = "Add New Security Question";
var administration$k = "Administration";
var alert$k = "Alert";
var all$k = "all";
var app$k = "App";
var appDevice$k = "App device";
var appDevices$k = "This factor is used for app";
var appFactor$k = "This factor is used for app.";
var application$k = "Application";
var appName$k = "App Name";
var appPortal$k = "App Portal";
var assumedUserNotification$k = "You cannot edit personal information while assuming a user.";
var broswerExtension$k = "Browser Extension";
var browser$k = "Browser";
var browserDeleteFailure$k = "Failed to delete trusted browser";
var browserDeleteSuccess$k = "Trusted browser was successfully deleted";
var browserDevice$k = "Browser/Device";
var browserFetchFailure$k = "Failed to fetch browsers";
var calling$k = "Calling";
var callUserAgain$k = "Calling you again";
var cancel$k = "Cancel";
var changePassword$k = "Change Password";
var changeSecurityFactor$k = "Change Security Factor";
var clearIcon$k = "clear icon";
var close$k = "Close";
var closeDialog$k = "Close dialog";
var codeResent$k = "Code has been sent to your phone.";
var companyLogo$k = "company logo";
var companyTab$k = "Default for company tab";
var conditionalRequirement$k = "At least {number} of the following requirements:";
var configuredOn$k = "Configured On";
var confirm$k = "confirm";
var contactAdminEmailOtp$k = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$k = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$k = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$k = "Contact your admin to reset password.";
var credentialId$k = "Credential ID";
var current$k = "Current";
var currentPassword$k = "Current password";
var deleteDeviceSuccess$k = "{factorName} was successfully deleted";
var deleteQuestion$k = "Delete question {position}";
var details$k = "Details";
var device$k = "Device";
var deviceDeleteFailure$k = "Failed to remove {factorName}";
var deviceFetchFailure$k = "Failed to fetch devices";
var deviceNameCannotBeBlank$k = "Authentication device name cannot be blank.";
var deviceRenameFailure$k = "Failed to update device name";
var downloadOnAppStore$k = "Download on the app store";
var editDeviceName$k = "Edit name";
var editSQinfo$k = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$k = "Enroll new primary factor";
var event$k = "Event";
var eventType$k = "Event Type";
var eventUserAgent$k = "Event Useragent";
var eventUseragent$k = "Event Useragent";
var eventUUID$k = "Event UUID";
var eventUuid$k = "Event UUID";
var expirationDays$k = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$k = "Expire Date";
var expires$k = "Expires";
var extensionVersionInstalled$k = "Version {versionString} installed";
var factor$k = "Factor";
var factorFetchFailure$k = "Failed to fetch available factors";
var factorMfaTokenFailure$k = "Failed to fetch mfa token";
var factorPrimaryFailure$k = "Failed to set {factorName} as your primary factor";
var factors$k = "factors";
var factorsFetchFailure$k = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$k = "We couldn’t load your user information.";
var failedToRegisterAnswers$k = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$k = "We couldn't retrieve your security questions at this time.";
var forcedLogout$k = "Forced Logout";
var getOnGooglePlay$k = "Get it on Google Play";
var goToExternalSite$k = "Go to external site";
var helpRequestFailed$k = "We couldn't submit your help request.";
var helpRequestSuccessful$k = "Your support request has been sent to your OneLogin Admin.";
var hostname$k = "Hostname & OS";
var icon$k = "Icon";
var identifier$k = "Credential ID / Identifier";
var imageUpload$k = "Image Upload";
var inactive$k = "Inactive";
var inactiveDevice$k = "Inactive device";
var install$k = "Install";
var invalidCode$k = "Invalid code";
var invalidPhoneNumber$k = "Please use valid phone number.";
var language$k = "Language";
var languageConfirmation$k = "Are you sure you want to switch to {language}?";
var lastAuthentication$k = "Last Authentication";
var lastChanged$k = "Last changed";
var lastUsed$k = "Last Used";
var length$k = "Minimum {length} characters";
var letter$k = "1 Letter";
var linkToAppStore$k = "Link to App Store";
var linkToGooglePlay$k = "Link to Google Play";
var loadingRecentActivity$k = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$k = "Loading trusted browsers, please wait...";
var location$k = "Location";
var locationTime$k = "Location/Time";
var loggedOut$k = "Logged Out";
var login$k = "login";
var loginDevice$k = "Login device";
var loginEvent$k = "Login";
var loginFactor$k = "This factor is used for login.";
var loginFailedEvent$k = "Login Failed";
var loginName$k = "Login Name";
var logOut$k = "Log Out";
var lower$k = "1 Lowercase";
var message$k = "{name} was successfully added.";
var mfaRegistrationFailure$k = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$k = "You successfully registered the device";
var more$k = "More";
var never$k = "Never";
var newPassword$k = "New password";
var newPrimaryFactor$k = "New primary factor";
var noActivities$k = "No activities have been made";
var noDevicesConfigured$k = "No devices have been configured";
var noExpiration$k = "Never expires";
var noMoreSecurityFactors$k = "There are no security factors available for registration.";
var notifyErrorLoadingUser$k = "Loading of user failed. Try again later";
var notifySuccessAddApp$k = "{name} was successfully added.";
var noTrustedBrowsers$k = "No browsers have been saved";
var numbers$k = "1 Number";
var oneloginDesktop$k = "OneLogin Desktop";
var oneloginDesktopFetchFailure$k = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$k = "OneLogin logo";
var onlyDesktopBrowsersSupported$k = "We currently only support browser extensions on desktop browsers.";
var otp1$k = "OTP 1";
var otp2$k = "OTP 2";
var otpDevice$k = "This factor is used for login.";
var parsingUserProfilePhotoFailure$k = "Getting image details failed";
var password$k = "password";
var passwordChanged$k = "Password Changed";
var passwordChangedDays$k = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$k = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$k = "Your administrator has configured an external site for resetting your password.";
var passwordReset$k = "Password Reset";
var passwordUpdatedSuccessfully$k = "You have successfully updated your password.";
var passwordUpdateFailure$k = "Password update failed";
var phoneNumber$k = "Phone number";
var prefix$k = "Suspicious login report";
var previousDeviceName$k = "Previously {previousName}";
var primary$k = "Primary";
var proceedAnyway$k = "Proceed anyway";
var profile$k = "Profile";
var profileAvatar$k = "Profile avatar";
var profileMenuToggle$k = "Open profile menu";
var profilePhoto$k = "Profile photo";
var profilePhotoAction$k = "Profile image action";
var pwResetDevice$k = "Password reset device";
var pwResetFactor$k = "This factor is used for password reset.";
var questionNumber$k = "Question {position}";
var radiusAuthentication$k = "Service Login via Radius";
var recentActivity$k = "Recent Activity";
var redirectToChangePassword$k = "Redirect to change your password?";
var registerSecurityQuestions$k = "Register Security Questions";
var registrationRejected$k = "Registration unsuccessful, please try again.";
var registrationTimedout$k = "Registration context timed out";
var remove$k = "Remove";
var removeCurrentBrowserWarning$k = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$k = "You have successfully removed your profile picture.";
var removeFactorWarning$k = "Are you sure you want to remove {factor}?";
var removeImage$k = "Remove image";
var report$k = "Report";
var reportActivity$k = "Report Activity";
var requestField$k = "Describe the issue you're having";
var requiredQuestions$k = "Required Questions";
var revert$k = "revert";
var revertToAdmin$k = "Revert to Admin";
var revertToSuperadmin$k = "Revert to OneLogin Admin";
var revoke$k = "Revoke";
var save$k = "Save Changes";
var searchIcon$k = "search icon";
var secureNotes$k = "Secure Notes";
var securityFactorAdded$k = "Security Factor Added";
var securityFactorRemoved$k = "Security Factor Removed";
var securityFactorRenamed$k = "Security Factor Renamed";
var securityFactors$k = "Security Factors";
var securityFactorsDescription$k = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$k = "Security Factors Updated";
var selectNewImage$k = "Select new image";
var selectNewPrimary$k = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$k = "Select Security Factor";
var sending$k = "Sending";
var setPrimaryDevice$k = "Set as primary";
var showDetails$k = "Show details";
var specials$k = "1 Special character";
var sqDropdownAriaLabel$k = "Question {position} dropdown";
var sqInfoHeader$k = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$k = "Blank answers will not be accepted";
var sqTipDoNotShare$k = "Do not share your questions and answers with anyone.";
var sqTipMinimum$k = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$k = "Answers are not case-sensitive.";
var sqTipNoUsePassword$k = "Do not use a password as an answer.";
var sqTipSameAnswer$k = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$k = "Special characters such as @#&*. will be ignored";
var submit$k = "Submit";
var submitting$k = "Submitting…";
var support$k = "Support";
var supportDefaultDescription$k = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$k = "Supported browsers: {browsers}";
var supportRequestHeader$k = "Support Request";
var time$k = "Time";
var trustDevice$k = "Trust Device";
var trusted$k = "Trusted";
var trustedBrowsers$k = "Trusted Browsers";
var trustedBrowsersDescription$k = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$k = "Trusted Device";
var unavailable$k = "Unavailable";
var unavailableTime$k = "Unavailable";
var unsetFactorSuccess$k = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$k = "Unset as primary";
var unsupportedBrowser$k = "Unsupported Browser";
var unsupportedBrowserHeading$k = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$k = "{newName} was successfully updated";
var updateFactorSuccess$k = "{factorName} is your new default security factor";
var updatePassword$k = "Update Password";
var updateUserProfileFailure$k = "Profile Update Failed";
var updateUserProfilePhotoFailure$k = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$k = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$k = "You have successfully updated your profile.";
var upper$k = "1 Uppercase";
var usedFor$k = "Used For";
var usedForApp$k = "This factor is used for app.";
var usedForLogin$k = "This factor is used for login.";
var usedForPasswordReset$k = "This factor is used for password reset.";
var version$k = "Version: {versionString}";
var yourBrowser$k = "Your browser: {browser}";
var en = {
	"26286820": "Enter Credential ID and two consecutive Security Codes from Symantec VIP Access.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Enter the code you received in SMS.",
	"374233718": "You can try again in {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
	"437305782": "Verifying your WebAuthn authenticators now.",
	"505702857": "Magic Link",
	"519412053": "Change Authentication Factor",
	"655462232": "Download and instal OneLogin Protect on you device",
	"660592555": "OK",
	"662924178": "Looks like today isn’t our day.",
	"694278426": "Enter your {deviceName} code",
	"694920552": "First Security Code",
	"737192390": "Open {appName}",
	"740457555": "Second Code",
	"744377571": "Minimum {length} characters",
	"751710530": "Submit",
	"916760408": "Enter a username and security code from your device.",
	"921093870": "Haven't recieved the code?",
	"966052509": "No Results",
	"987359842": "Please click the link on your email to continue",
	"1068496829": "Select Security Question {current}/{total}",
	"1079852660": "Enter two consecutive Security Codes",
	"1080736814": "Enter {fieldName} from the Symantec VIP Access app",
	"1136625613": "The process was cancelled. Please try again or use another authentication factor.",
	"1212847248": "A confirmation code was sent to your configured address.",
	"1232460711": "Enter your email",
	"1242107845": "Show",
	"1254879564": "New Password",
	"1359200231": "Send",
	"1433651550": "Enter the code from OneLogin SMS.",
	"1477893598": "Configure",
	"1536965459": "Download and install OneLogin Protect on your device",
	"1624184662": "To setup OneLogin SMS we are going to send you an activation code via SMS. You will need this activation code to complete device registration.",
	"1654624862": "Security Code",
	"1833121415": "Provide Answer {current}/{total}",
	"1919587067": "Resend code",
	"1935535842": "Required",
	"1963245695": "1 Uppercase",
	"2018264248": "Try Again",
	"2091874550": "First Code",
	"2097632732": "Scan barcode instead",
	"2104438124": "Enter {fieldName} and two consecutive Security Codes from Symantec VIP Access.",
	"2124363772": "Enter your username and security code from your SecurID token.",
	"2229754167": "Enter your phone number",
	"2244720377": "An unexpected error seems to have occurred.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "An access link was sent to your email",
	"2600324508": "Hide",
	"2606375562": "Insert your YubiKey in the USB port and press the button",
	"2663586870": "Username",
	"2758306961": "Credential ID",
	"2792137744": "1 number",
	"2815222727": "Scan this barcode",
	"2828880379": "Confirm",
	"2859281487": "2-factor authentication is required to secure your account.",
	"2942752129": "Second Security Code",
	"3060896801": "Having trouble?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 special character",
	"3294346597": "Try again",
	"3327626662": "Enter your confirmation code",
	"3374226769": "Click Pair using manual entry",
	"3469481929": "Can't scan the code?",
	"3499598078": "Open menu",
	"3528672691": "Cancel",
	"3640052215": "Continue",
	"3645029425": "Scan below QR Code",
	"3645116517": "Enter this code when receiving the call:",
	"3663548834": "We're invesigating the problem and expect to be back soon. Please wait a few minutes<br />and refresh your browser, or visit our <a href='https://www.onelogin.com/status'>Status Page</a>.",
	"3669652728": "An access link was sent to",
	"3673120330": "Next",
	"3737470122": "Please contact admin for more information.",
	"3781468762": "Your browser doesn't support WebAuthn",
	"3827227259": "A confirmation code was sent to",
	"3855542277": "Enter this code into the app",
	"3865193889": "Activate",
	"3877285238": "1 lowercase",
	"4000449233": "Calling the below phone number:",
	"4072532148": "Resend SMS code",
	"4151518079": "Select Security Question {current} / {total}",
	"4152906165": "We're investigating the problem and expect to be back soon. Please wait a few minutes{break}and refresh your browser, or visit our <link>Status Page</link>.",
	"4227081527": "When the app is installed, come back to this screen and click {action}",
	"4281662478": "Search",
	addApp: addApp$k,
	addFactor: addFactor$k,
	additionalQuestions: additionalQuestions$k,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$k,
	addNewSecurityQuestion: addNewSecurityQuestion$k,
	administration: administration$k,
	alert: alert$k,
	all: all$k,
	app: app$k,
	appDevice: appDevice$k,
	appDevices: appDevices$k,
	appFactor: appFactor$k,
	application: application$k,
	appName: appName$k,
	appPortal: appPortal$k,
	assumedUserNotification: assumedUserNotification$k,
	broswerExtension: broswerExtension$k,
	browser: browser$k,
	browserDeleteFailure: browserDeleteFailure$k,
	browserDeleteSuccess: browserDeleteSuccess$k,
	browserDevice: browserDevice$k,
	browserFetchFailure: browserFetchFailure$k,
	calling: calling$k,
	callUserAgain: callUserAgain$k,
	cancel: cancel$k,
	changePassword: changePassword$k,
	changeSecurityFactor: changeSecurityFactor$k,
	clearIcon: clearIcon$k,
	close: close$k,
	closeDialog: closeDialog$k,
	codeResent: codeResent$k,
	companyLogo: companyLogo$k,
	companyTab: companyTab$k,
	conditionalRequirement: conditionalRequirement$k,
	configuredOn: configuredOn$k,
	confirm: confirm$k,
	contactAdminEmailOtp: contactAdminEmailOtp$k,
	contactAdminForSMS: contactAdminForSMS$k,
	contactAdminForVoice: contactAdminForVoice$k,
	contactAdminPasswordReset: contactAdminPasswordReset$k,
	credentialId: credentialId$k,
	current: current$k,
	currentPassword: currentPassword$k,
	deleteDeviceSuccess: deleteDeviceSuccess$k,
	deleteQuestion: deleteQuestion$k,
	details: details$k,
	device: device$k,
	deviceDeleteFailure: deviceDeleteFailure$k,
	deviceFetchFailure: deviceFetchFailure$k,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$k,
	deviceRenameFailure: deviceRenameFailure$k,
	downloadOnAppStore: downloadOnAppStore$k,
	editDeviceName: editDeviceName$k,
	editSQinfo: editSQinfo$k,
	enrollNewFactor: enrollNewFactor$k,
	event: event$k,
	eventType: eventType$k,
	eventUserAgent: eventUserAgent$k,
	eventUseragent: eventUseragent$k,
	eventUUID: eventUUID$k,
	eventUuid: eventUuid$k,
	expirationDays: expirationDays$k,
	expireDate: expireDate$k,
	expires: expires$k,
	extensionVersionInstalled: extensionVersionInstalled$k,
	factor: factor$k,
	factorFetchFailure: factorFetchFailure$k,
	factorMfaTokenFailure: factorMfaTokenFailure$k,
	factorPrimaryFailure: factorPrimaryFailure$k,
	factors: factors$k,
	factorsFetchFailure: factorsFetchFailure$k,
	failedToFetchUserInfo: failedToFetchUserInfo$k,
	failedToRegisterAnswers: failedToRegisterAnswers$k,
	failedToRetrieveQuestions: failedToRetrieveQuestions$k,
	forcedLogout: forcedLogout$k,
	getOnGooglePlay: getOnGooglePlay$k,
	goToExternalSite: goToExternalSite$k,
	helpRequestFailed: helpRequestFailed$k,
	helpRequestSuccessful: helpRequestSuccessful$k,
	hostname: hostname$k,
	icon: icon$k,
	identifier: identifier$k,
	imageUpload: imageUpload$k,
	inactive: inactive$k,
	inactiveDevice: inactiveDevice$k,
	install: install$k,
	invalidCode: invalidCode$k,
	invalidPhoneNumber: invalidPhoneNumber$k,
	language: language$k,
	languageConfirmation: languageConfirmation$k,
	lastAuthentication: lastAuthentication$k,
	lastChanged: lastChanged$k,
	lastUsed: lastUsed$k,
	length: length$k,
	letter: letter$k,
	linkToAppStore: linkToAppStore$k,
	linkToGooglePlay: linkToGooglePlay$k,
	loadingRecentActivity: loadingRecentActivity$k,
	loadingTrustedBrowsers: loadingTrustedBrowsers$k,
	location: location$k,
	locationTime: locationTime$k,
	loggedOut: loggedOut$k,
	login: login$k,
	loginDevice: loginDevice$k,
	loginEvent: loginEvent$k,
	loginFactor: loginFactor$k,
	loginFailedEvent: loginFailedEvent$k,
	loginName: loginName$k,
	logOut: logOut$k,
	lower: lower$k,
	message: message$k,
	mfaRegistrationFailure: mfaRegistrationFailure$k,
	mfaRegistrationSuccess: mfaRegistrationSuccess$k,
	more: more$k,
	never: never$k,
	newPassword: newPassword$k,
	newPrimaryFactor: newPrimaryFactor$k,
	noActivities: noActivities$k,
	noDevicesConfigured: noDevicesConfigured$k,
	noExpiration: noExpiration$k,
	noMoreSecurityFactors: noMoreSecurityFactors$k,
	notifyErrorLoadingUser: notifyErrorLoadingUser$k,
	notifySuccessAddApp: notifySuccessAddApp$k,
	noTrustedBrowsers: noTrustedBrowsers$k,
	numbers: numbers$k,
	oneloginDesktop: oneloginDesktop$k,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$k,
	oneloginLogo: oneloginLogo$k,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$k,
	otp1: otp1$k,
	otp2: otp2$k,
	otpDevice: otpDevice$k,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$k,
	password: password$k,
	passwordChanged: passwordChanged$k,
	passwordChangedDays: passwordChangedDays$k,
	passwordHint: passwordHint$k,
	passwordRedirectDescription: passwordRedirectDescription$k,
	passwordReset: passwordReset$k,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$k,
	passwordUpdateFailure: passwordUpdateFailure$k,
	phoneNumber: phoneNumber$k,
	prefix: prefix$k,
	previousDeviceName: previousDeviceName$k,
	primary: primary$k,
	proceedAnyway: proceedAnyway$k,
	profile: profile$k,
	profileAvatar: profileAvatar$k,
	profileMenuToggle: profileMenuToggle$k,
	profilePhoto: profilePhoto$k,
	profilePhotoAction: profilePhotoAction$k,
	pwResetDevice: pwResetDevice$k,
	pwResetFactor: pwResetFactor$k,
	questionNumber: questionNumber$k,
	radiusAuthentication: radiusAuthentication$k,
	recentActivity: recentActivity$k,
	redirectToChangePassword: redirectToChangePassword$k,
	registerSecurityQuestions: registerSecurityQuestions$k,
	registrationRejected: registrationRejected$k,
	registrationTimedout: registrationTimedout$k,
	remove: remove$k,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$k,
	removedProfilePictureSuccess: removedProfilePictureSuccess$k,
	removeFactorWarning: removeFactorWarning$k,
	removeImage: removeImage$k,
	report: report$k,
	reportActivity: reportActivity$k,
	requestField: requestField$k,
	requiredQuestions: requiredQuestions$k,
	revert: revert$k,
	revertToAdmin: revertToAdmin$k,
	revertToSuperadmin: revertToSuperadmin$k,
	revoke: revoke$k,
	save: save$k,
	searchIcon: searchIcon$k,
	secureNotes: secureNotes$k,
	securityFactorAdded: securityFactorAdded$k,
	securityFactorRemoved: securityFactorRemoved$k,
	securityFactorRenamed: securityFactorRenamed$k,
	securityFactors: securityFactors$k,
	securityFactorsDescription: securityFactorsDescription$k,
	securityFactorsUpdated: securityFactorsUpdated$k,
	selectNewImage: selectNewImage$k,
	selectNewPrimary: selectNewPrimary$k,
	selectSecurityFactor: selectSecurityFactor$k,
	sending: sending$k,
	setPrimaryDevice: setPrimaryDevice$k,
	showDetails: showDetails$k,
	specials: specials$k,
	sqDropdownAriaLabel: sqDropdownAriaLabel$k,
	sqInfoHeader: sqInfoHeader$k,
	sqTipBlankAnswers: sqTipBlankAnswers$k,
	sqTipDoNotShare: sqTipDoNotShare$k,
	sqTipMinimum: sqTipMinimum$k,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$k,
	sqTipNoUsePassword: sqTipNoUsePassword$k,
	sqTipSameAnswer: sqTipSameAnswer$k,
	sqTipSpecialChars: sqTipSpecialChars$k,
	submit: submit$k,
	submitting: submitting$k,
	support: support$k,
	supportDefaultDescription: supportDefaultDescription$k,
	supportedBrowsers: supportedBrowsers$k,
	supportRequestHeader: supportRequestHeader$k,
	"switch": "Switch",
	time: time$k,
	trustDevice: trustDevice$k,
	trusted: trusted$k,
	trustedBrowsers: trustedBrowsers$k,
	trustedBrowsersDescription: trustedBrowsersDescription$k,
	trustedDevice: trustedDevice$k,
	unavailable: unavailable$k,
	unavailableTime: unavailableTime$k,
	unsetFactorSuccess: unsetFactorSuccess$k,
	unsetPrimaryDevice: unsetPrimaryDevice$k,
	unsupportedBrowser: unsupportedBrowser$k,
	unsupportedBrowserHeading: unsupportedBrowserHeading$k,
	updateDeviceNameSuccess: updateDeviceNameSuccess$k,
	updateFactorSuccess: updateFactorSuccess$k,
	updatePassword: updatePassword$k,
	updateUserProfileFailure: updateUserProfileFailure$k,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$k,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$k,
	updateUserProfileSuccess: updateUserProfileSuccess$k,
	upper: upper$k,
	usedFor: usedFor$k,
	usedForApp: usedForApp$k,
	usedForLogin: usedForLogin$k,
	usedForPasswordReset: usedForPasswordReset$k,
	version: version$k,
	yourBrowser: yourBrowser$k
};

var addApp$j = "Show {addApp} button when I log in to new websites.";
var addFactor$j = "Add Factor";
var additionalQuestions$j = "Additional Questions";
var addNewPrimaryBeforeRemove$j = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$j = "Add New Security Question";
var administration$j = "Administration";
var alert$j = "Alert";
var all$j = "all";
var app$j = "App";
var appDevice$j = "Este factor es utilizado para la aplicación.";
var appDevices$j = "Este factor se utiliza para la aplicación";
var appFactor$j = "Este factor es utilizado para la aplicación.";
var application$j = "Application";
var appName$j = "App Name";
var appPortal$j = "App Portal";
var assumedUserNotification$j = "You cannot edit personal information while assuming a user.";
var broswerExtension$j = "Browser Extension";
var browser$j = "Browser";
var browserDeleteFailure$j = "Failed to delete trusted browser";
var browserDeleteSuccess$j = "Trusted browser was successfully deleted";
var browserDevice$j = "Browser/Device";
var browserFetchFailure$j = "Failed to fetch browsers";
var calling$j = "Llamando";
var callUserAgain$j = "Calling you again";
var cancel$j = "cancelar";
var changePassword$j = "Change Password";
var changeSecurityFactor$j = "Change Security Factor";
var clearIcon$j = "borrar ícono";
var close$j = "Close";
var closeDialog$j = "Cerrar diálogo";
var codeResent$j = "Code has been sent to your phone.";
var companyLogo$j = "logotipo de la compañía";
var companyTab$j = "Default for company tab";
var conditionalRequirement$j = "At least {number} of the following requirements:";
var configuredOn$j = "Configured On";
var confirm$j = "confirmar";
var contactAdminEmailOtp$j = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$j = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$j = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$j = "Contact your admin to reset password.";
var credentialId$j = "Credential ID";
var current$j = "Current";
var currentPassword$j = "Current password";
var deleteDeviceSuccess$j = "{factorName} was successfully deleted";
var deleteQuestion$j = "Delete question {position}";
var details$j = "Details";
var device$j = "Device";
var deviceDeleteFailure$j = "Failed to remove {factorName}";
var deviceFetchFailure$j = "Failed to fetch devices";
var deviceNameCannotBeBlank$j = "Authentication device name cannot be blank.";
var deviceRenameFailure$j = "Failed to update device name";
var downloadOnAppStore$j = "Descargar en la tienda de aplicaciones";
var editDeviceName$j = "Edit name";
var editSQinfo$j = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$j = "Enroll new primary factor";
var event$j = "Event";
var eventType$j = "Event Type";
var eventUserAgent$j = "Event Useragent";
var eventUseragent$j = "Event Useragent";
var eventUUID$j = "Event UUID";
var eventUuid$j = "Event UUID";
var expirationDays$j = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$j = "Expire Date";
var expires$j = "Expires";
var extensionVersionInstalled$j = "Version {versionString} installed";
var factor$j = "Factor";
var factorFetchFailure$j = "Failed to fetch available factors";
var factorMfaTokenFailure$j = "Failed to fetch mfa token";
var factorPrimaryFailure$j = "Failed to set {factorName} as your primary factor";
var factors$j = "factors";
var factorsFetchFailure$j = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$j = "We couldn’t load your user information.";
var failedToRegisterAnswers$j = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$j = "We couldn't retrieve your security questions at this time.";
var forcedLogout$j = "Forced Logout";
var getOnGooglePlay$j = "Consígala en Google Play";
var goToExternalSite$j = "Go to external site";
var helpRequestFailed$j = "We couldn't submit your help request.";
var helpRequestSuccessful$j = "Your support request has been sent to your OneLogin Admin.";
var hostname$j = "Hostname & OS";
var icon$j = "Icon";
var identifier$j = "Credential ID / Identifier";
var imageUpload$j = "Image Upload";
var inactive$j = "Inactive";
var inactiveDevice$j = "Inactive device";
var install$j = "Install";
var invalidCode$j = "Invalid code";
var invalidPhoneNumber$j = "Please use valid phone number.";
var language$j = "Language";
var languageConfirmation$j = "Are you sure you want to switch to {language}?";
var lastAuthentication$j = "Last Authentication";
var lastChanged$j = "Last changed";
var lastUsed$j = "Last Used";
var length$j = "Minimum {length} characters";
var letter$j = "1 Letter";
var linkToAppStore$j = "Enlace a App Store";
var linkToGooglePlay$j = "Enlace a Google Play";
var loadingRecentActivity$j = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$j = "Loading trusted browsers, please wait...";
var location$j = "Location";
var locationTime$j = "Location/Time";
var loggedOut$j = "Logged Out";
var login$j = "login";
var loginDevice$j = "Login device";
var loginEvent$j = "Login";
var loginFactor$j = "Este factor es utilizado para iniciar sesión.";
var loginFailedEvent$j = "Login Failed";
var loginName$j = "Login Name";
var logOut$j = "Log Out";
var lower$j = "1 Lowercase";
var message$j = "{name} was successfully added.";
var mfaRegistrationFailure$j = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$j = "You successfully registered the device";
var more$j = "More";
var never$j = "Never";
var newPassword$j = "New password";
var newPrimaryFactor$j = "New primary factor";
var noActivities$j = "No activities have been made";
var noDevicesConfigured$j = "No devices have been configured";
var noExpiration$j = "Never expires";
var noMoreSecurityFactors$j = "There are no security factors available for registration.";
var notifyErrorLoadingUser$j = "Loading of user failed. Try again later";
var notifySuccessAddApp$j = "{name} was successfully added.";
var noTrustedBrowsers$j = "No browsers have been saved";
var numbers$j = "1 Number";
var oneloginDesktop$j = "OneLogin Desktop";
var oneloginDesktopFetchFailure$j = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$j = "OneLogin logo";
var onlyDesktopBrowsersSupported$j = "We currently only support browser extensions on desktop browsers.";
var otp1$j = "OTP 1";
var otp2$j = "OTP 2";
var otpDevice$j = "Este factor se utiliza para iniciar sesión.";
var parsingUserProfilePhotoFailure$j = "Getting image details failed";
var password$j = "password";
var passwordChanged$j = "Password Changed";
var passwordChangedDays$j = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$j = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$j = "Your administrator has configured an external site for resetting your password.";
var passwordReset$j = "Password Reset";
var passwordUpdatedSuccessfully$j = "You have successfully updated your password.";
var passwordUpdateFailure$j = "Password update failed";
var phoneNumber$j = "Phone number";
var prefix$j = "Suspicious login report";
var previousDeviceName$j = "Previously {previousName}";
var primary$j = "Primary";
var proceedAnyway$j = "Proceed anyway";
var profile$j = "Profile";
var profileAvatar$j = "Profile avatar";
var profileMenuToggle$j = "Open profile menu";
var profilePhoto$j = "Profile photo";
var profilePhotoAction$j = "Profile image action";
var pwResetDevice$j = "Este factor se utiliza para restablecer la contraseña.";
var pwResetFactor$j = "Este factor es utilizado para restablecer la contraseña.";
var questionNumber$j = "Question {position}";
var radiusAuthentication$j = "Service Login via Radius";
var recentActivity$j = "Recent Activity";
var redirectToChangePassword$j = "Redirect to change your password?";
var registerSecurityQuestions$j = "Register Security Questions";
var registrationRejected$j = "Registration unsuccessful, please try again.";
var registrationTimedout$j = "Registration context timed out";
var remove$j = "Remove";
var removeCurrentBrowserWarning$j = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$j = "You have successfully removed your profile picture.";
var removeFactorWarning$j = "Are you sure you want to remove {factor}?";
var removeImage$j = "Remove image";
var report$j = "Report";
var reportActivity$j = "Report Activity";
var requestField$j = "Describe the issue you're having";
var requiredQuestions$j = "Required Questions";
var revert$j = "volver";
var revertToAdmin$j = "Revert to Admin";
var revertToSuperadmin$j = "Revert to OneLogin Admin";
var revoke$j = "Revoke";
var save$j = "Save Changes";
var searchIcon$j = "buscar ícono";
var secureNotes$j = "Secure Notes";
var securityFactorAdded$j = "Security Factor Added";
var securityFactorRemoved$j = "Security Factor Removed";
var securityFactorRenamed$j = "Security Factor Renamed";
var securityFactors$j = "Security Factors";
var securityFactorsDescription$j = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$j = "Security Factors Updated";
var selectNewImage$j = "Select new image";
var selectNewPrimary$j = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$j = "Select Security Factor";
var sending$j = "Enviando";
var setPrimaryDevice$j = "Set as primary";
var showDetails$j = "Mostrar detalles";
var specials$j = "1 Special character";
var sqDropdownAriaLabel$j = "Question {position} dropdown";
var sqInfoHeader$j = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$j = "Blank answers will not be accepted";
var sqTipDoNotShare$j = "Do not share your questions and answers with anyone.";
var sqTipMinimum$j = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$j = "Answers are not case-sensitive.";
var sqTipNoUsePassword$j = "Do not use a password as an answer.";
var sqTipSameAnswer$j = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$j = "Special characters such as @#&*. will be ignored";
var submit$j = "Submit";
var submitting$j = "Submitting…";
var support$j = "Support";
var supportDefaultDescription$j = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$j = "Supported browsers: {browsers}";
var supportRequestHeader$j = "Support Request";
var time$j = "Time";
var trustDevice$j = "Trust Device";
var trusted$j = "Trusted";
var trustedBrowsers$j = "Trusted Browsers";
var trustedBrowsersDescription$j = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$j = "Trusted Device";
var unavailable$j = "Unavailable";
var unavailableTime$j = "Unavailable";
var unsetFactorSuccess$j = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$j = "Unset as primary";
var unsupportedBrowser$j = "Unsupported Browser";
var unsupportedBrowserHeading$j = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$j = "{newName} was successfully updated";
var updateFactorSuccess$j = "{factorName} is your new default security factor";
var updatePassword$j = "Update Password";
var updateUserProfileFailure$j = "Profile Update Failed";
var updateUserProfilePhotoFailure$j = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$j = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$j = "You have successfully updated your profile.";
var upper$j = "1 Uppercase";
var usedFor$j = "Used For";
var usedForApp$j = "This factor is used for app.";
var usedForLogin$j = "This factor is used for login.";
var usedForPasswordReset$j = "This factor is used for password reset.";
var version$j = "Version: {versionString}";
var yourBrowser$j = "Your browser: {browser}";
var es = {
	"26286820": "Ingrese el ID de sus credenciales y dos códigos de seguridad consecutivos del acceso vip de Symantec.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Escribe el código que recibiste por SMS.",
	"374233718": "Puede intentar de nuevo en {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
	"437305782": "Verificando sus autenticadores WebAuthn en este momento.",
	"505702857": "Enlace mágico",
	"519412053": "Cambiar factor de autenticación",
	"655462232": "Descarga e instala OneLogin Protect en tu dispositivo",
	"660592555": "Aceptar",
	"662924178": "Parece que hoy no es nuestro día.",
	"694278426": "Ingrese el código de su {deviceName}",
	"694920552": "Primer código de seguridad",
	"737192390": "Abrir {appName}",
	"740457555": "Segundo código",
	"744377571": "Mínimo {length} caracteres",
	"751710530": "Enviar",
	"916760408": "Ingresa un nombre de usuario y código de seguridad desde tu dispositivo.",
	"921093870": "¿No has recibido el código?",
	"966052509": "No hay resultados",
	"987359842": "Haga clic en el enlace del correo electrónico",
	"1068496829": "Elige una pregunta de seguridad {current}/{total}",
	"1079852660": "Ingresa dos códigos de seguridad consecutivos",
	"1080736814": "Ingresa {fieldName} desde la aplicación de Acceso VIP de Symantec",
	"1136625613": "El proceso fue cancelado. Por favor inténtelo de nuevo o utilice otro factor de autenticación.",
	"1212847248": "Se le envió un código de confirmación a la dirección que ha configurado.",
	"1232460711": "Ingrese su correo electrónico",
	"1242107845": "Mostrar",
	"1254879564": "Nueva contraseña",
	"1359200231": "Enviar",
	"1433651550": "Ingresa el código desde el SMS de OneLogin",
	"1477893598": "Configurar",
	"1536965459": "Descarga e instala OneLogin Protect en tu dispositivo",
	"1624184662": "Para instalar OneLogin SMS te enviaremos un código de activación vía SMS. Necesitarás este código de activación para completar el registro del dispositivo.",
	"1654624862": "Código de seguridad",
	"1833121415": "Responder {current}/{total}",
	"1919587067": "Reenviar código",
	"1935535842": "Requerido",
	"1963245695": "1 mayúscula",
	"2018264248": "Intentar de nuevo",
	"2091874550": "Primer código",
	"2097632732": "Prefiero escanear código de barras",
	"2104438124": "Ingresa {fieldName} y dos códigos de seguridad consecutivos desde el Acceso VIP de Symantec.",
	"2124363772": "Ingresa tu nombre de usuario y código de seguridad desde tu autentificador SecurID.",
	"2229754167": "Ingrese su número de teléfono",
	"2244720377": "Parece que ocurrió un error inesperado.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Se envió un enlace de acceso a su correo electrónico",
	"2600324508": "Ocultar",
	"2606375562": "Inserta tu YubiKey en el puerto USB y oprime el botón",
	"2663586870": "Nombre de usuario",
	"2758306961": "ID de credenciales",
	"2792137744": "1 número",
	"2815222727": "Escanear este código de barras",
	"2828880379": "Confirmar",
	"2859281487": "Se requiere de autenticación de 2 factores para proteger tu cuenta.",
	"2942752129": "Segundo código de seguridad",
	"3060896801": "¿Estás teniendo problemas?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 caracter especial",
	"3294346597": "Intentar de nuevo",
	"3327626662": "Ingrese su código de confirmación",
	"3374226769": "Haz clic en Emparejar usando la entrada manual",
	"3469481929": "¿No puedes escanear el código?",
	"3499598078": "Abrir menú",
	"3528672691": "Cancelar",
	"3640052215": "Continuar",
	"3645029425": "Escanea el código QR de abajo",
	"3645116517": "Ingrese este código al recibir la llamada:",
	"3663548834": "Estamos investigando el problema y esperamos regresar pronto. Espere unos minutos <br />y actualice su navegador o visite nuestra <a href='https://www.onelogin.com/status'>Página de estado</a>.",
	"3669652728": "Se envió un enlace de acceso a",
	"3673120330": "Siguiente",
	"3737470122": "Por favor contacte al administrador para más información.",
	"3781468762": "Su navegador no soporta WebAuthn",
	"3827227259": "Un código de autenticación fue enviado a",
	"3855542277": "Ingresa este código en la aplicación",
	"3865193889": "Activar",
	"3877285238": "1 minúscula",
	"4000449233": "Llamando al siguiente número:",
	"4072532148": "Reenviar código SMS",
	"4151518079": "Elige una pregunta de seguridad {current} / {total}",
	"4152906165": "Estamos investigando el problema y esperamos volver a la brevedad. Espere unos minutos{break}y actualice su navegador o visite nuestra <link>Página de estado</link>.",
	"4227081527": "Cuando la aplicación esté instalada, regresa a esta pantalla y haz clic {action}",
	"4281662478": "Buscar",
	addApp: addApp$j,
	addFactor: addFactor$j,
	additionalQuestions: additionalQuestions$j,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$j,
	addNewSecurityQuestion: addNewSecurityQuestion$j,
	administration: administration$j,
	alert: alert$j,
	all: all$j,
	app: app$j,
	appDevice: appDevice$j,
	appDevices: appDevices$j,
	appFactor: appFactor$j,
	application: application$j,
	appName: appName$j,
	appPortal: appPortal$j,
	assumedUserNotification: assumedUserNotification$j,
	broswerExtension: broswerExtension$j,
	browser: browser$j,
	browserDeleteFailure: browserDeleteFailure$j,
	browserDeleteSuccess: browserDeleteSuccess$j,
	browserDevice: browserDevice$j,
	browserFetchFailure: browserFetchFailure$j,
	calling: calling$j,
	callUserAgain: callUserAgain$j,
	cancel: cancel$j,
	changePassword: changePassword$j,
	changeSecurityFactor: changeSecurityFactor$j,
	clearIcon: clearIcon$j,
	close: close$j,
	closeDialog: closeDialog$j,
	codeResent: codeResent$j,
	companyLogo: companyLogo$j,
	companyTab: companyTab$j,
	conditionalRequirement: conditionalRequirement$j,
	configuredOn: configuredOn$j,
	confirm: confirm$j,
	contactAdminEmailOtp: contactAdminEmailOtp$j,
	contactAdminForSMS: contactAdminForSMS$j,
	contactAdminForVoice: contactAdminForVoice$j,
	contactAdminPasswordReset: contactAdminPasswordReset$j,
	credentialId: credentialId$j,
	current: current$j,
	currentPassword: currentPassword$j,
	deleteDeviceSuccess: deleteDeviceSuccess$j,
	deleteQuestion: deleteQuestion$j,
	details: details$j,
	device: device$j,
	deviceDeleteFailure: deviceDeleteFailure$j,
	deviceFetchFailure: deviceFetchFailure$j,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$j,
	deviceRenameFailure: deviceRenameFailure$j,
	downloadOnAppStore: downloadOnAppStore$j,
	editDeviceName: editDeviceName$j,
	editSQinfo: editSQinfo$j,
	enrollNewFactor: enrollNewFactor$j,
	event: event$j,
	eventType: eventType$j,
	eventUserAgent: eventUserAgent$j,
	eventUseragent: eventUseragent$j,
	eventUUID: eventUUID$j,
	eventUuid: eventUuid$j,
	expirationDays: expirationDays$j,
	expireDate: expireDate$j,
	expires: expires$j,
	extensionVersionInstalled: extensionVersionInstalled$j,
	factor: factor$j,
	factorFetchFailure: factorFetchFailure$j,
	factorMfaTokenFailure: factorMfaTokenFailure$j,
	factorPrimaryFailure: factorPrimaryFailure$j,
	factors: factors$j,
	factorsFetchFailure: factorsFetchFailure$j,
	failedToFetchUserInfo: failedToFetchUserInfo$j,
	failedToRegisterAnswers: failedToRegisterAnswers$j,
	failedToRetrieveQuestions: failedToRetrieveQuestions$j,
	forcedLogout: forcedLogout$j,
	getOnGooglePlay: getOnGooglePlay$j,
	goToExternalSite: goToExternalSite$j,
	helpRequestFailed: helpRequestFailed$j,
	helpRequestSuccessful: helpRequestSuccessful$j,
	hostname: hostname$j,
	icon: icon$j,
	identifier: identifier$j,
	imageUpload: imageUpload$j,
	inactive: inactive$j,
	inactiveDevice: inactiveDevice$j,
	install: install$j,
	invalidCode: invalidCode$j,
	invalidPhoneNumber: invalidPhoneNumber$j,
	language: language$j,
	languageConfirmation: languageConfirmation$j,
	lastAuthentication: lastAuthentication$j,
	lastChanged: lastChanged$j,
	lastUsed: lastUsed$j,
	length: length$j,
	letter: letter$j,
	linkToAppStore: linkToAppStore$j,
	linkToGooglePlay: linkToGooglePlay$j,
	loadingRecentActivity: loadingRecentActivity$j,
	loadingTrustedBrowsers: loadingTrustedBrowsers$j,
	location: location$j,
	locationTime: locationTime$j,
	loggedOut: loggedOut$j,
	login: login$j,
	loginDevice: loginDevice$j,
	loginEvent: loginEvent$j,
	loginFactor: loginFactor$j,
	loginFailedEvent: loginFailedEvent$j,
	loginName: loginName$j,
	logOut: logOut$j,
	lower: lower$j,
	message: message$j,
	mfaRegistrationFailure: mfaRegistrationFailure$j,
	mfaRegistrationSuccess: mfaRegistrationSuccess$j,
	more: more$j,
	never: never$j,
	newPassword: newPassword$j,
	newPrimaryFactor: newPrimaryFactor$j,
	noActivities: noActivities$j,
	noDevicesConfigured: noDevicesConfigured$j,
	noExpiration: noExpiration$j,
	noMoreSecurityFactors: noMoreSecurityFactors$j,
	notifyErrorLoadingUser: notifyErrorLoadingUser$j,
	notifySuccessAddApp: notifySuccessAddApp$j,
	noTrustedBrowsers: noTrustedBrowsers$j,
	numbers: numbers$j,
	oneloginDesktop: oneloginDesktop$j,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$j,
	oneloginLogo: oneloginLogo$j,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$j,
	otp1: otp1$j,
	otp2: otp2$j,
	otpDevice: otpDevice$j,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$j,
	password: password$j,
	passwordChanged: passwordChanged$j,
	passwordChangedDays: passwordChangedDays$j,
	passwordHint: passwordHint$j,
	passwordRedirectDescription: passwordRedirectDescription$j,
	passwordReset: passwordReset$j,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$j,
	passwordUpdateFailure: passwordUpdateFailure$j,
	phoneNumber: phoneNumber$j,
	prefix: prefix$j,
	previousDeviceName: previousDeviceName$j,
	primary: primary$j,
	proceedAnyway: proceedAnyway$j,
	profile: profile$j,
	profileAvatar: profileAvatar$j,
	profileMenuToggle: profileMenuToggle$j,
	profilePhoto: profilePhoto$j,
	profilePhotoAction: profilePhotoAction$j,
	pwResetDevice: pwResetDevice$j,
	pwResetFactor: pwResetFactor$j,
	questionNumber: questionNumber$j,
	radiusAuthentication: radiusAuthentication$j,
	recentActivity: recentActivity$j,
	redirectToChangePassword: redirectToChangePassword$j,
	registerSecurityQuestions: registerSecurityQuestions$j,
	registrationRejected: registrationRejected$j,
	registrationTimedout: registrationTimedout$j,
	remove: remove$j,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$j,
	removedProfilePictureSuccess: removedProfilePictureSuccess$j,
	removeFactorWarning: removeFactorWarning$j,
	removeImage: removeImage$j,
	report: report$j,
	reportActivity: reportActivity$j,
	requestField: requestField$j,
	requiredQuestions: requiredQuestions$j,
	revert: revert$j,
	revertToAdmin: revertToAdmin$j,
	revertToSuperadmin: revertToSuperadmin$j,
	revoke: revoke$j,
	save: save$j,
	searchIcon: searchIcon$j,
	secureNotes: secureNotes$j,
	securityFactorAdded: securityFactorAdded$j,
	securityFactorRemoved: securityFactorRemoved$j,
	securityFactorRenamed: securityFactorRenamed$j,
	securityFactors: securityFactors$j,
	securityFactorsDescription: securityFactorsDescription$j,
	securityFactorsUpdated: securityFactorsUpdated$j,
	selectNewImage: selectNewImage$j,
	selectNewPrimary: selectNewPrimary$j,
	selectSecurityFactor: selectSecurityFactor$j,
	sending: sending$j,
	setPrimaryDevice: setPrimaryDevice$j,
	showDetails: showDetails$j,
	specials: specials$j,
	sqDropdownAriaLabel: sqDropdownAriaLabel$j,
	sqInfoHeader: sqInfoHeader$j,
	sqTipBlankAnswers: sqTipBlankAnswers$j,
	sqTipDoNotShare: sqTipDoNotShare$j,
	sqTipMinimum: sqTipMinimum$j,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$j,
	sqTipNoUsePassword: sqTipNoUsePassword$j,
	sqTipSameAnswer: sqTipSameAnswer$j,
	sqTipSpecialChars: sqTipSpecialChars$j,
	submit: submit$j,
	submitting: submitting$j,
	support: support$j,
	supportDefaultDescription: supportDefaultDescription$j,
	supportedBrowsers: supportedBrowsers$j,
	supportRequestHeader: supportRequestHeader$j,
	"switch": "Switch",
	time: time$j,
	trustDevice: trustDevice$j,
	trusted: trusted$j,
	trustedBrowsers: trustedBrowsers$j,
	trustedBrowsersDescription: trustedBrowsersDescription$j,
	trustedDevice: trustedDevice$j,
	unavailable: unavailable$j,
	unavailableTime: unavailableTime$j,
	unsetFactorSuccess: unsetFactorSuccess$j,
	unsetPrimaryDevice: unsetPrimaryDevice$j,
	unsupportedBrowser: unsupportedBrowser$j,
	unsupportedBrowserHeading: unsupportedBrowserHeading$j,
	updateDeviceNameSuccess: updateDeviceNameSuccess$j,
	updateFactorSuccess: updateFactorSuccess$j,
	updatePassword: updatePassword$j,
	updateUserProfileFailure: updateUserProfileFailure$j,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$j,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$j,
	updateUserProfileSuccess: updateUserProfileSuccess$j,
	upper: upper$j,
	usedFor: usedFor$j,
	usedForApp: usedForApp$j,
	usedForLogin: usedForLogin$j,
	usedForPasswordReset: usedForPasswordReset$j,
	version: version$j,
	yourBrowser: yourBrowser$j
};

var addApp$i = "Show {addApp} button when I log in to new websites.";
var addFactor$i = "Add Factor";
var additionalQuestions$i = "Additional Questions";
var addNewPrimaryBeforeRemove$i = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$i = "Add New Security Question";
var administration$i = "Administration";
var alert$i = "Alert";
var all$i = "all";
var app$i = "App";
var appDevice$i = "Tätä muuttujaa käytetään sovelluksessa.";
var appDevices$i = "Tätä muuttujaa käytetään sovelluksessa";
var appFactor$i = "Tätä muuttujaa käytetään sovelluksessa.";
var application$i = "Application";
var appName$i = "App Name";
var appPortal$i = "App Portal";
var assumedUserNotification$i = "You cannot edit personal information while assuming a user.";
var broswerExtension$i = "Browser Extension";
var browser$i = "Browser";
var browserDeleteFailure$i = "Failed to delete trusted browser";
var browserDeleteSuccess$i = "Trusted browser was successfully deleted";
var browserDevice$i = "Browser/Device";
var browserFetchFailure$i = "Failed to fetch browsers";
var calling$i = "Soitetaan";
var callUserAgain$i = "Calling you again";
var cancel$i = "peruuta";
var changePassword$i = "Change Password";
var changeSecurityFactor$i = "Change Security Factor";
var clearIcon$i = "tyhjennyskuvake";
var close$i = "Close";
var closeDialog$i = "Sulje dialogi";
var codeResent$i = "Code has been sent to your phone.";
var companyLogo$i = "yrityksen logo";
var companyTab$i = "Default for company tab";
var conditionalRequirement$i = "At least {number} of the following requirements:";
var configuredOn$i = "Configured On";
var confirm$i = "vahvista";
var contactAdminEmailOtp$i = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$i = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$i = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$i = "Contact your admin to reset password.";
var credentialId$i = "Credential ID";
var current$i = "Current";
var currentPassword$i = "Current password";
var deleteDeviceSuccess$i = "{factorName} was successfully deleted";
var deleteQuestion$i = "Delete question {position}";
var details$i = "Details";
var device$i = "Device";
var deviceDeleteFailure$i = "Failed to remove {factorName}";
var deviceFetchFailure$i = "Failed to fetch devices";
var deviceNameCannotBeBlank$i = "Authentication device name cannot be blank.";
var deviceRenameFailure$i = "Failed to update device name";
var downloadOnAppStore$i = "Lataa sovelluskaupasta";
var editDeviceName$i = "Edit name";
var editSQinfo$i = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$i = "Enroll new primary factor";
var event$i = "Event";
var eventType$i = "Event Type";
var eventUserAgent$i = "Event Useragent";
var eventUseragent$i = "Event Useragent";
var eventUUID$i = "Event UUID";
var eventUuid$i = "Event UUID";
var expirationDays$i = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$i = "Expire Date";
var expires$i = "Expires";
var extensionVersionInstalled$i = "Version {versionString} installed";
var factor$i = "Factor";
var factorFetchFailure$i = "Failed to fetch available factors";
var factorMfaTokenFailure$i = "Failed to fetch mfa token";
var factorPrimaryFailure$i = "Failed to set {factorName} as your primary factor";
var factors$i = "factors";
var factorsFetchFailure$i = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$i = "We couldn’t load your user information.";
var failedToRegisterAnswers$i = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$i = "We couldn't retrieve your security questions at this time.";
var forcedLogout$i = "Forced Logout";
var getOnGooglePlay$i = "Lataa se Google Playsta";
var goToExternalSite$i = "Go to external site";
var helpRequestFailed$i = "We couldn't submit your help request.";
var helpRequestSuccessful$i = "Your support request has been sent to your OneLogin Admin.";
var hostname$i = "Hostname & OS";
var icon$i = "Icon";
var identifier$i = "Credential ID / Identifier";
var imageUpload$i = "Image Upload";
var inactive$i = "Inactive";
var inactiveDevice$i = "Inactive device";
var install$i = "Install";
var invalidCode$i = "Invalid code";
var invalidPhoneNumber$i = "Please use valid phone number.";
var language$i = "Language";
var languageConfirmation$i = "Are you sure you want to switch to {language}?";
var lastAuthentication$i = "Last Authentication";
var lastChanged$i = "Last changed";
var lastUsed$i = "Last Used";
var length$i = "Minimum {length} characters";
var letter$i = "1 Letter";
var linkToAppStore$i = "Linkki App Storeen";
var linkToGooglePlay$i = "Linkki Google Playhin";
var loadingRecentActivity$i = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$i = "Loading trusted browsers, please wait...";
var location$i = "Location";
var locationTime$i = "Location/Time";
var loggedOut$i = "Logged Out";
var login$i = "login";
var loginDevice$i = "Login device";
var loginEvent$i = "Login";
var loginFactor$i = "Tätä muuttujaa käytetään kirjautumisessa.";
var loginFailedEvent$i = "Login Failed";
var loginName$i = "Login Name";
var logOut$i = "Log Out";
var lower$i = "1 Lowercase";
var message$i = "{name} was successfully added.";
var mfaRegistrationFailure$i = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$i = "You successfully registered the device";
var more$i = "More";
var never$i = "Never";
var newPassword$i = "New password";
var newPrimaryFactor$i = "New primary factor";
var noActivities$i = "No activities have been made";
var noDevicesConfigured$i = "No devices have been configured";
var noExpiration$i = "Never expires";
var noMoreSecurityFactors$i = "There are no security factors available for registration.";
var notifyErrorLoadingUser$i = "Loading of user failed. Try again later";
var notifySuccessAddApp$i = "{name} was successfully added.";
var noTrustedBrowsers$i = "No browsers have been saved";
var numbers$i = "1 Number";
var oneloginDesktop$i = "OneLogin Desktop";
var oneloginDesktopFetchFailure$i = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$i = "OneLogin logo";
var onlyDesktopBrowsersSupported$i = "We currently only support browser extensions on desktop browsers.";
var otp1$i = "OTP 1";
var otp2$i = "OTP 2";
var otpDevice$i = "Tätä muuttujaa käytetään kirjautumisessa.";
var parsingUserProfilePhotoFailure$i = "Getting image details failed";
var password$i = "password";
var passwordChanged$i = "Password Changed";
var passwordChangedDays$i = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$i = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$i = "Your administrator has configured an external site for resetting your password.";
var passwordReset$i = "Password Reset";
var passwordUpdatedSuccessfully$i = "You have successfully updated your password.";
var passwordUpdateFailure$i = "Password update failed";
var phoneNumber$i = "Phone number";
var prefix$i = "Suspicious login report";
var previousDeviceName$i = "Previously {previousName}";
var primary$i = "Primary";
var proceedAnyway$i = "Proceed anyway";
var profile$i = "Profile";
var profileAvatar$i = "Profile avatar";
var profileMenuToggle$i = "Open profile menu";
var profilePhoto$i = "Profile photo";
var profilePhotoAction$i = "Profile image action";
var pwResetDevice$i = "Tätä muuttujaa käytetään salasanan vaihtamisessa.";
var pwResetFactor$i = "Tätä muuttujaa käytetään salasanan vaihtamisessa.";
var questionNumber$i = "Question {position}";
var radiusAuthentication$i = "Service Login via Radius";
var recentActivity$i = "Recent Activity";
var redirectToChangePassword$i = "Redirect to change your password?";
var registerSecurityQuestions$i = "Register Security Questions";
var registrationRejected$i = "Registration unsuccessful, please try again.";
var registrationTimedout$i = "Registration context timed out";
var remove$i = "Remove";
var removeCurrentBrowserWarning$i = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$i = "You have successfully removed your profile picture.";
var removeFactorWarning$i = "Are you sure you want to remove {factor}?";
var removeImage$i = "Remove image";
var report$i = "Report";
var reportActivity$i = "Report Activity";
var requestField$i = "Describe the issue you're having";
var requiredQuestions$i = "Required Questions";
var revert$i = "palauta";
var revertToAdmin$i = "Revert to Admin";
var revertToSuperadmin$i = "Revert to OneLogin Admin";
var revoke$i = "Revoke";
var save$i = "Save Changes";
var searchIcon$i = "hakukuvake";
var secureNotes$i = "Secure Notes";
var securityFactorAdded$i = "Security Factor Added";
var securityFactorRemoved$i = "Security Factor Removed";
var securityFactorRenamed$i = "Security Factor Renamed";
var securityFactors$i = "Security Factors";
var securityFactorsDescription$i = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$i = "Security Factors Updated";
var selectNewImage$i = "Select new image";
var selectNewPrimary$i = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$i = "Select Security Factor";
var sending$i = "Lähetetään";
var setPrimaryDevice$i = "Set as primary";
var showDetails$i = "Näytä tiedot";
var specials$i = "1 Special character";
var sqDropdownAriaLabel$i = "Question {position} dropdown";
var sqInfoHeader$i = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$i = "Blank answers will not be accepted";
var sqTipDoNotShare$i = "Do not share your questions and answers with anyone.";
var sqTipMinimum$i = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$i = "Answers are not case-sensitive.";
var sqTipNoUsePassword$i = "Do not use a password as an answer.";
var sqTipSameAnswer$i = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$i = "Special characters such as @#&*. will be ignored";
var submit$i = "Submit";
var submitting$i = "Submitting…";
var support$i = "Support";
var supportDefaultDescription$i = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$i = "Supported browsers: {browsers}";
var supportRequestHeader$i = "Support Request";
var time$i = "Time";
var trustDevice$i = "Trust Device";
var trusted$i = "Trusted";
var trustedBrowsers$i = "Trusted Browsers";
var trustedBrowsersDescription$i = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$i = "Trusted Device";
var unavailable$i = "Unavailable";
var unavailableTime$i = "Unavailable";
var unsetFactorSuccess$i = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$i = "Unset as primary";
var unsupportedBrowser$i = "Unsupported Browser";
var unsupportedBrowserHeading$i = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$i = "{newName} was successfully updated";
var updateFactorSuccess$i = "{factorName} is your new default security factor";
var updatePassword$i = "Update Password";
var updateUserProfileFailure$i = "Profile Update Failed";
var updateUserProfilePhotoFailure$i = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$i = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$i = "You have successfully updated your profile.";
var upper$i = "1 Uppercase";
var usedFor$i = "Used For";
var usedForApp$i = "This factor is used for app.";
var usedForLogin$i = "This factor is used for login.";
var usedForPasswordReset$i = "This factor is used for password reset.";
var version$i = "Version: {versionString}";
var yourBrowser$i = "Your browser: {browser}";
var fi = {
	"26286820": "Anna käyttötunniste sekä kaksi peräkkäistä Symantecin VIP-käyttöoikeuden turvakoodia",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Syötä koodi, jonka sait tekstiviestitse.",
	"374233718": "Voit yrittää uudestaan, kun on kulunut {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
	"437305782": "Varmennetaan WebAuthn-tunnistautumista.",
	"505702857": "Taikalinkki",
	"519412053": "Muuta vahvistustekijää",
	"655462232": "Lataa ja asenna laitteellesi OneLogin Protect",
	"660592555": "OK",
	"662924178": "Näyttää siltä, että tämä ei ole meidän päivämme.",
	"694278426": "Kirjoita laitteen {deviceName} koodi",
	"694920552": "Ensimmäinen turvakoodi",
	"737192390": "Avaa {appName}",
	"740457555": "Toinen koodi",
	"744377571": "Minimi {length} merkkiä",
	"751710530": "Lähetä",
	"916760408": "Syötä käyttäjänimi ja turvakoodi laitteeltasi.",
	"921093870": "Etkö ole saanut koodia?",
	"966052509": "Ei tuloksia",
	"987359842": "Ole hyvä ja klikkaa linkkiä sähköpostissasi päästäksesi jatkamaan",
	"1068496829": "Valitse turvakysymys {current}/{total}",
	"1079852660": "Syötä kaksi peräkkäistä turvakoodia",
	"1080736814": "Syötä {fieldName} Symantec VIP Access -sovelluksesta",
	"1136625613": "Prosessi peruttiin. Yritä uudelleen tai käytä toista tunnistautumismenetelmää.",
	"1212847248": "Vahvistuskoodi lähetettiin määritettyyn osoitteeseesi.",
	"1232460711": "Syötä sähköpostisi",
	"1242107845": "Näytä",
	"1254879564": "Uusi salasana",
	"1359200231": "Lähetä",
	"1433651550": "Syötä koodi OneLogin SMS:stä",
	"1477893598": "Konfiguroi",
	"1536965459": "Lataa ja asenna OneLogin Protect laitteellesi",
	"1624184662": "Jotta OneLogin SMS voidaan asettaa, lähetämme sinulle aktivointikoodin tekstiviestitse. Tarvitset tämän aktivointikoodin saattaaksesi laitteen rekisteröinnin loppuun.",
	"1654624862": "Turvakoodi",
	"1833121415": "Anna vastaus {current}/{total}",
	"1919587067": "Lähetä koodi uudelleen",
	"1935535842": "Pakollinen",
	"1963245695": "1 isolla",
	"2018264248": "Kokeile uudelleen",
	"2091874550": "Ensimmäinen koodi",
	"2097632732": "Skannaa sen sijaan viivakoodi",
	"2104438124": "Syötä {fieldName} ja kaksi peräkkäistä turvakoodia Symantec VIP Accessista.",
	"2124363772": "Syötä käyttäjänimesi ja turvakoodi SecurID-kupongista.",
	"2229754167": "Kirjoita puhelinnumerosi",
	"2244720377": "Näyttäisi tapahtuneen odottamaton virhe.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Pääsylinkki lähetettiin sähköpostiisi",
	"2600324508": "Piilota",
	"2606375562": "Syötä YubiKey USB-porttiin ja paina nappia",
	"2663586870": "Käyttäjänimi",
	"2758306961": "Käyttötunniste",
	"2792137744": "1 numero",
	"2815222727": "Skannaa tämä viivakoodi",
	"2828880379": "Vahvista",
	"2859281487": "2-vaiheinen vahvistus on pakollinen tilisi turvaamiseksi.",
	"2942752129": "Toinen turvakoodi",
	"3060896801": "Onko ongelmia?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 erikoismerkki",
	"3294346597": "Yritä uudestaan",
	"3327626662": "Kirjoita vahvistuskoodisi",
	"3374226769": "Klikkaa Parita käyttäen manuaalista sisääntuloa",
	"3469481929": "Etkö voi skannata koodia?",
	"3499598078": "Avaa valikko",
	"3528672691": "Peruuta",
	"3640052215": "Jatka",
	"3645029425": "Skannaa alla oleva QR-koodi",
	"3645116517": "Kirjoita tämä koodi, kun vastaat puheluun:",
	"3663548834": "Tutkimme ongelmaa ja odotamme palaavamme pian. Ole hyvä ja odota muutama minuutti<br />ja lataa sitten selain uudestaan tai vieraile <a href='https://www.onelogin.com/status'>tilasivullamme</a>.",
	"3669652728": "Pääsylinkki lähetettiin osoitteeseen",
	"3673120330": "Seuraava",
	"3737470122": "Otathan yhteyttä ylläpitäjään saadaksesi lisätietoja.",
	"3781468762": "Selaimesi ei tue WebAuthn-palvelua",
	"3827227259": "Varmistuskoodi lähetettiin numeroon",
	"3855542277": "Syötä tämä koodi sovellukseen",
	"3865193889": "Aktivoi",
	"3877285238": "1 pieni kirjain",
	"4000449233": "Soitetaan alla olevaan puhelinnumeroon:",
	"4072532148": "Lähetä SMS-koodi uudelleen",
	"4151518079": "Valitse turvakysymys {current} / {total}",
	"4152906165": "Tutkimme parhaillamme ongelmaa ja uskomme palaavamme pian. Pyytäisimme odottamaan muutaman minuutin{break}ja lataamaan selaimen sen jälkeen uudelleen tai käymällä <link>tilasivullamme</link>.",
	"4227081527": "Kun sovellus on asennettu, palaa tälle näytölle ja klikkaa {action}",
	"4281662478": "Hae",
	addApp: addApp$i,
	addFactor: addFactor$i,
	additionalQuestions: additionalQuestions$i,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$i,
	addNewSecurityQuestion: addNewSecurityQuestion$i,
	administration: administration$i,
	alert: alert$i,
	all: all$i,
	app: app$i,
	appDevice: appDevice$i,
	appDevices: appDevices$i,
	appFactor: appFactor$i,
	application: application$i,
	appName: appName$i,
	appPortal: appPortal$i,
	assumedUserNotification: assumedUserNotification$i,
	broswerExtension: broswerExtension$i,
	browser: browser$i,
	browserDeleteFailure: browserDeleteFailure$i,
	browserDeleteSuccess: browserDeleteSuccess$i,
	browserDevice: browserDevice$i,
	browserFetchFailure: browserFetchFailure$i,
	calling: calling$i,
	callUserAgain: callUserAgain$i,
	cancel: cancel$i,
	changePassword: changePassword$i,
	changeSecurityFactor: changeSecurityFactor$i,
	clearIcon: clearIcon$i,
	close: close$i,
	closeDialog: closeDialog$i,
	codeResent: codeResent$i,
	companyLogo: companyLogo$i,
	companyTab: companyTab$i,
	conditionalRequirement: conditionalRequirement$i,
	configuredOn: configuredOn$i,
	confirm: confirm$i,
	contactAdminEmailOtp: contactAdminEmailOtp$i,
	contactAdminForSMS: contactAdminForSMS$i,
	contactAdminForVoice: contactAdminForVoice$i,
	contactAdminPasswordReset: contactAdminPasswordReset$i,
	credentialId: credentialId$i,
	current: current$i,
	currentPassword: currentPassword$i,
	deleteDeviceSuccess: deleteDeviceSuccess$i,
	deleteQuestion: deleteQuestion$i,
	details: details$i,
	device: device$i,
	deviceDeleteFailure: deviceDeleteFailure$i,
	deviceFetchFailure: deviceFetchFailure$i,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$i,
	deviceRenameFailure: deviceRenameFailure$i,
	downloadOnAppStore: downloadOnAppStore$i,
	editDeviceName: editDeviceName$i,
	editSQinfo: editSQinfo$i,
	enrollNewFactor: enrollNewFactor$i,
	event: event$i,
	eventType: eventType$i,
	eventUserAgent: eventUserAgent$i,
	eventUseragent: eventUseragent$i,
	eventUUID: eventUUID$i,
	eventUuid: eventUuid$i,
	expirationDays: expirationDays$i,
	expireDate: expireDate$i,
	expires: expires$i,
	extensionVersionInstalled: extensionVersionInstalled$i,
	factor: factor$i,
	factorFetchFailure: factorFetchFailure$i,
	factorMfaTokenFailure: factorMfaTokenFailure$i,
	factorPrimaryFailure: factorPrimaryFailure$i,
	factors: factors$i,
	factorsFetchFailure: factorsFetchFailure$i,
	failedToFetchUserInfo: failedToFetchUserInfo$i,
	failedToRegisterAnswers: failedToRegisterAnswers$i,
	failedToRetrieveQuestions: failedToRetrieveQuestions$i,
	forcedLogout: forcedLogout$i,
	getOnGooglePlay: getOnGooglePlay$i,
	goToExternalSite: goToExternalSite$i,
	helpRequestFailed: helpRequestFailed$i,
	helpRequestSuccessful: helpRequestSuccessful$i,
	hostname: hostname$i,
	icon: icon$i,
	identifier: identifier$i,
	imageUpload: imageUpload$i,
	inactive: inactive$i,
	inactiveDevice: inactiveDevice$i,
	install: install$i,
	invalidCode: invalidCode$i,
	invalidPhoneNumber: invalidPhoneNumber$i,
	language: language$i,
	languageConfirmation: languageConfirmation$i,
	lastAuthentication: lastAuthentication$i,
	lastChanged: lastChanged$i,
	lastUsed: lastUsed$i,
	length: length$i,
	letter: letter$i,
	linkToAppStore: linkToAppStore$i,
	linkToGooglePlay: linkToGooglePlay$i,
	loadingRecentActivity: loadingRecentActivity$i,
	loadingTrustedBrowsers: loadingTrustedBrowsers$i,
	location: location$i,
	locationTime: locationTime$i,
	loggedOut: loggedOut$i,
	login: login$i,
	loginDevice: loginDevice$i,
	loginEvent: loginEvent$i,
	loginFactor: loginFactor$i,
	loginFailedEvent: loginFailedEvent$i,
	loginName: loginName$i,
	logOut: logOut$i,
	lower: lower$i,
	message: message$i,
	mfaRegistrationFailure: mfaRegistrationFailure$i,
	mfaRegistrationSuccess: mfaRegistrationSuccess$i,
	more: more$i,
	never: never$i,
	newPassword: newPassword$i,
	newPrimaryFactor: newPrimaryFactor$i,
	noActivities: noActivities$i,
	noDevicesConfigured: noDevicesConfigured$i,
	noExpiration: noExpiration$i,
	noMoreSecurityFactors: noMoreSecurityFactors$i,
	notifyErrorLoadingUser: notifyErrorLoadingUser$i,
	notifySuccessAddApp: notifySuccessAddApp$i,
	noTrustedBrowsers: noTrustedBrowsers$i,
	numbers: numbers$i,
	oneloginDesktop: oneloginDesktop$i,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$i,
	oneloginLogo: oneloginLogo$i,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$i,
	otp1: otp1$i,
	otp2: otp2$i,
	otpDevice: otpDevice$i,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$i,
	password: password$i,
	passwordChanged: passwordChanged$i,
	passwordChangedDays: passwordChangedDays$i,
	passwordHint: passwordHint$i,
	passwordRedirectDescription: passwordRedirectDescription$i,
	passwordReset: passwordReset$i,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$i,
	passwordUpdateFailure: passwordUpdateFailure$i,
	phoneNumber: phoneNumber$i,
	prefix: prefix$i,
	previousDeviceName: previousDeviceName$i,
	primary: primary$i,
	proceedAnyway: proceedAnyway$i,
	profile: profile$i,
	profileAvatar: profileAvatar$i,
	profileMenuToggle: profileMenuToggle$i,
	profilePhoto: profilePhoto$i,
	profilePhotoAction: profilePhotoAction$i,
	pwResetDevice: pwResetDevice$i,
	pwResetFactor: pwResetFactor$i,
	questionNumber: questionNumber$i,
	radiusAuthentication: radiusAuthentication$i,
	recentActivity: recentActivity$i,
	redirectToChangePassword: redirectToChangePassword$i,
	registerSecurityQuestions: registerSecurityQuestions$i,
	registrationRejected: registrationRejected$i,
	registrationTimedout: registrationTimedout$i,
	remove: remove$i,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$i,
	removedProfilePictureSuccess: removedProfilePictureSuccess$i,
	removeFactorWarning: removeFactorWarning$i,
	removeImage: removeImage$i,
	report: report$i,
	reportActivity: reportActivity$i,
	requestField: requestField$i,
	requiredQuestions: requiredQuestions$i,
	revert: revert$i,
	revertToAdmin: revertToAdmin$i,
	revertToSuperadmin: revertToSuperadmin$i,
	revoke: revoke$i,
	save: save$i,
	searchIcon: searchIcon$i,
	secureNotes: secureNotes$i,
	securityFactorAdded: securityFactorAdded$i,
	securityFactorRemoved: securityFactorRemoved$i,
	securityFactorRenamed: securityFactorRenamed$i,
	securityFactors: securityFactors$i,
	securityFactorsDescription: securityFactorsDescription$i,
	securityFactorsUpdated: securityFactorsUpdated$i,
	selectNewImage: selectNewImage$i,
	selectNewPrimary: selectNewPrimary$i,
	selectSecurityFactor: selectSecurityFactor$i,
	sending: sending$i,
	setPrimaryDevice: setPrimaryDevice$i,
	showDetails: showDetails$i,
	specials: specials$i,
	sqDropdownAriaLabel: sqDropdownAriaLabel$i,
	sqInfoHeader: sqInfoHeader$i,
	sqTipBlankAnswers: sqTipBlankAnswers$i,
	sqTipDoNotShare: sqTipDoNotShare$i,
	sqTipMinimum: sqTipMinimum$i,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$i,
	sqTipNoUsePassword: sqTipNoUsePassword$i,
	sqTipSameAnswer: sqTipSameAnswer$i,
	sqTipSpecialChars: sqTipSpecialChars$i,
	submit: submit$i,
	submitting: submitting$i,
	support: support$i,
	supportDefaultDescription: supportDefaultDescription$i,
	supportedBrowsers: supportedBrowsers$i,
	supportRequestHeader: supportRequestHeader$i,
	"switch": "Switch",
	time: time$i,
	trustDevice: trustDevice$i,
	trusted: trusted$i,
	trustedBrowsers: trustedBrowsers$i,
	trustedBrowsersDescription: trustedBrowsersDescription$i,
	trustedDevice: trustedDevice$i,
	unavailable: unavailable$i,
	unavailableTime: unavailableTime$i,
	unsetFactorSuccess: unsetFactorSuccess$i,
	unsetPrimaryDevice: unsetPrimaryDevice$i,
	unsupportedBrowser: unsupportedBrowser$i,
	unsupportedBrowserHeading: unsupportedBrowserHeading$i,
	updateDeviceNameSuccess: updateDeviceNameSuccess$i,
	updateFactorSuccess: updateFactorSuccess$i,
	updatePassword: updatePassword$i,
	updateUserProfileFailure: updateUserProfileFailure$i,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$i,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$i,
	updateUserProfileSuccess: updateUserProfileSuccess$i,
	upper: upper$i,
	usedFor: usedFor$i,
	usedForApp: usedForApp$i,
	usedForLogin: usedForLogin$i,
	usedForPasswordReset: usedForPasswordReset$i,
	version: version$i,
	yourBrowser: yourBrowser$i
};

var addApp$h = "Show {addApp} button when I log in to new websites.";
var addFactor$h = "Add Factor";
var additionalQuestions$h = "Additional Questions";
var addNewPrimaryBeforeRemove$h = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$h = "Add New Security Question";
var administration$h = "Administration";
var alert$h = "Alert";
var all$h = "all";
var app$h = "App";
var appDevice$h = "Ce facteur est utilisé pour l'appli.";
var appDevices$h = "Ce facteur est utilisé pour l'application";
var appFactor$h = "Ce facteur est utilisé pour l'appli.";
var application$h = "Application";
var appName$h = "App Name";
var appPortal$h = "App Portal";
var assumedUserNotification$h = "You cannot edit personal information while assuming a user.";
var broswerExtension$h = "Browser Extension";
var browser$h = "Browser";
var browserDeleteFailure$h = "Failed to delete trusted browser";
var browserDeleteSuccess$h = "Trusted browser was successfully deleted";
var browserDevice$h = "Browser/Device";
var browserFetchFailure$h = "Failed to fetch browsers";
var calling$h = "Appel en cours";
var callUserAgain$h = "Calling you again";
var cancel$h = "annuler";
var changePassword$h = "Change Password";
var changeSecurityFactor$h = "Change Security Factor";
var clearIcon$h = "icône claire";
var close$h = "Close";
var closeDialog$h = "Fermer la boîte de dialogue";
var codeResent$h = "Code has been sent to your phone.";
var companyLogo$h = "logo de l'entreprise";
var companyTab$h = "Default for company tab";
var conditionalRequirement$h = "At least {number} of the following requirements:";
var configuredOn$h = "Configured On";
var confirm$h = "confirmer";
var contactAdminEmailOtp$h = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$h = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$h = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$h = "Contact your admin to reset password.";
var credentialId$h = "Credential ID";
var current$h = "Current";
var currentPassword$h = "Current password";
var deleteDeviceSuccess$h = "{factorName} was successfully deleted";
var deleteQuestion$h = "Delete question {position}";
var details$h = "Details";
var device$h = "Device";
var deviceDeleteFailure$h = "Failed to remove {factorName}";
var deviceFetchFailure$h = "Failed to fetch devices";
var deviceNameCannotBeBlank$h = "Authentication device name cannot be blank.";
var deviceRenameFailure$h = "Failed to update device name";
var downloadOnAppStore$h = "Télécharger dans l'App Store";
var editDeviceName$h = "Edit name";
var editSQinfo$h = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$h = "Enroll new primary factor";
var event$h = "Event";
var eventType$h = "Event Type";
var eventUserAgent$h = "Event Useragent";
var eventUseragent$h = "Event Useragent";
var eventUUID$h = "Event UUID";
var eventUuid$h = "Event UUID";
var expirationDays$h = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$h = "Expire Date";
var expires$h = "Expires";
var extensionVersionInstalled$h = "Version {versionString} installed";
var factor$h = "Factor";
var factorFetchFailure$h = "Failed to fetch available factors";
var factorMfaTokenFailure$h = "Failed to fetch mfa token";
var factorPrimaryFailure$h = "Failed to set {factorName} as your primary factor";
var factors$h = "factors";
var factorsFetchFailure$h = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$h = "We couldn’t load your user information.";
var failedToRegisterAnswers$h = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$h = "We couldn't retrieve your security questions at this time.";
var forcedLogout$h = "Forced Logout";
var getOnGooglePlay$h = "Disponible sur Google Play";
var goToExternalSite$h = "Go to external site";
var helpRequestFailed$h = "We couldn't submit your help request.";
var helpRequestSuccessful$h = "Your support request has been sent to your OneLogin Admin.";
var hostname$h = "Hostname & OS";
var icon$h = "Icon";
var identifier$h = "Credential ID / Identifier";
var imageUpload$h = "Image Upload";
var inactive$h = "Inactive";
var inactiveDevice$h = "Inactive device";
var install$h = "Install";
var invalidCode$h = "Invalid code";
var invalidPhoneNumber$h = "Please use valid phone number.";
var language$h = "Language";
var languageConfirmation$h = "Are you sure you want to switch to {language}?";
var lastAuthentication$h = "Last Authentication";
var lastChanged$h = "Last changed";
var lastUsed$h = "Last Used";
var length$h = "Minimum {length} characters";
var letter$h = "1 Letter";
var linkToAppStore$h = "Lien vers l'App Store";
var linkToGooglePlay$h = "Lien vers Google Play";
var loadingRecentActivity$h = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$h = "Loading trusted browsers, please wait...";
var location$h = "Location";
var locationTime$h = "Location/Time";
var loggedOut$h = "Logged Out";
var login$h = "login";
var loginDevice$h = "Login device";
var loginEvent$h = "Login";
var loginFactor$h = "Ce facteur est utilisé pour la connexion.";
var loginFailedEvent$h = "Login Failed";
var loginName$h = "Login Name";
var logOut$h = "Log Out";
var lower$h = "1 Lowercase";
var message$h = "{name} was successfully added.";
var mfaRegistrationFailure$h = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$h = "You successfully registered the device";
var more$h = "More";
var never$h = "Never";
var newPassword$h = "New password";
var newPrimaryFactor$h = "New primary factor";
var noActivities$h = "No activities have been made";
var noDevicesConfigured$h = "No devices have been configured";
var noExpiration$h = "Never expires";
var noMoreSecurityFactors$h = "There are no security factors available for registration.";
var notifyErrorLoadingUser$h = "Loading of user failed. Try again later";
var notifySuccessAddApp$h = "{name} was successfully added.";
var noTrustedBrowsers$h = "No browsers have been saved";
var numbers$h = "1 Number";
var oneloginDesktop$h = "OneLogin Desktop";
var oneloginDesktopFetchFailure$h = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$h = "OneLogin logo";
var onlyDesktopBrowsersSupported$h = "We currently only support browser extensions on desktop browsers.";
var otp1$h = "OTP 1";
var otp2$h = "OTP 2";
var otpDevice$h = "Ce facteur est utilisé pour la connexion.";
var parsingUserProfilePhotoFailure$h = "Getting image details failed";
var password$h = "password";
var passwordChanged$h = "Password Changed";
var passwordChangedDays$h = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$h = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$h = "Your administrator has configured an external site for resetting your password.";
var passwordReset$h = "Password Reset";
var passwordUpdatedSuccessfully$h = "You have successfully updated your password.";
var passwordUpdateFailure$h = "Password update failed";
var phoneNumber$h = "Phone number";
var prefix$h = "Suspicious login report";
var previousDeviceName$h = "Previously {previousName}";
var primary$h = "Primary";
var proceedAnyway$h = "Proceed anyway";
var profile$h = "Profile";
var profileAvatar$h = "Profile avatar";
var profileMenuToggle$h = "Open profile menu";
var profilePhoto$h = "Profile photo";
var profilePhotoAction$h = "Profile image action";
var pwResetDevice$h = "Ce facteur est utilisé pour la réinitialisation du mot de passe.";
var pwResetFactor$h = "Ce facteur est utilisé pour la réinitialisation du mot de passe.";
var questionNumber$h = "Question {position}";
var radiusAuthentication$h = "Service Login via Radius";
var recentActivity$h = "Recent Activity";
var redirectToChangePassword$h = "Redirect to change your password?";
var registerSecurityQuestions$h = "Register Security Questions";
var registrationRejected$h = "Registration unsuccessful, please try again.";
var registrationTimedout$h = "Registration context timed out";
var remove$h = "Remove";
var removeCurrentBrowserWarning$h = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$h = "You have successfully removed your profile picture.";
var removeFactorWarning$h = "Are you sure you want to remove {factor}?";
var removeImage$h = "Remove image";
var report$h = "Report";
var reportActivity$h = "Report Activity";
var requestField$h = "Describe the issue you're having";
var requiredQuestions$h = "Required Questions";
var revert$h = "rétablir";
var revertToAdmin$h = "Revert to Admin";
var revertToSuperadmin$h = "Revert to OneLogin Admin";
var revoke$h = "Revoke";
var save$h = "Save Changes";
var searchIcon$h = "icône de recherche";
var secureNotes$h = "Secure Notes";
var securityFactorAdded$h = "Security Factor Added";
var securityFactorRemoved$h = "Security Factor Removed";
var securityFactorRenamed$h = "Security Factor Renamed";
var securityFactors$h = "Security Factors";
var securityFactorsDescription$h = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$h = "Security Factors Updated";
var selectNewImage$h = "Select new image";
var selectNewPrimary$h = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$h = "Select Security Factor";
var sending$h = "Envoi en cours";
var setPrimaryDevice$h = "Set as primary";
var showDetails$h = "Voir les détails";
var specials$h = "1 Special character";
var sqDropdownAriaLabel$h = "Question {position} dropdown";
var sqInfoHeader$h = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$h = "Blank answers will not be accepted";
var sqTipDoNotShare$h = "Do not share your questions and answers with anyone.";
var sqTipMinimum$h = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$h = "Answers are not case-sensitive.";
var sqTipNoUsePassword$h = "Do not use a password as an answer.";
var sqTipSameAnswer$h = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$h = "Special characters such as @#&*. will be ignored";
var submit$h = "Submit";
var submitting$h = "Submitting…";
var support$h = "Support";
var supportDefaultDescription$h = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$h = "Supported browsers: {browsers}";
var supportRequestHeader$h = "Support Request";
var time$h = "Time";
var trustDevice$h = "Trust Device";
var trusted$h = "Trusted";
var trustedBrowsers$h = "Trusted Browsers";
var trustedBrowsersDescription$h = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$h = "Trusted Device";
var unavailable$h = "Unavailable";
var unavailableTime$h = "Unavailable";
var unsetFactorSuccess$h = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$h = "Unset as primary";
var unsupportedBrowser$h = "Unsupported Browser";
var unsupportedBrowserHeading$h = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$h = "{newName} was successfully updated";
var updateFactorSuccess$h = "{factorName} is your new default security factor";
var updatePassword$h = "Update Password";
var updateUserProfileFailure$h = "Profile Update Failed";
var updateUserProfilePhotoFailure$h = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$h = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$h = "You have successfully updated your profile.";
var upper$h = "1 Uppercase";
var usedFor$h = "Used For";
var usedForApp$h = "This factor is used for app.";
var usedForLogin$h = "This factor is used for login.";
var usedForPasswordReset$h = "This factor is used for password reset.";
var version$h = "Version: {versionString}";
var yourBrowser$h = "Your browser: {browser}";
var fr = {
	"26286820": "Veuillez saisir votre identifiant, puis deux codes de sécurité consécutifs de Symantec VIP Access.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Entrez le code que vous avez reçu par SMS.",
	"374233718": "Vous pourrez réessayer dans {secondes restantes, nombre} {secondes restantes, pluriel, une {seconde} autrement {secondes}}",
	"437305782": "Vérification de vos authentificateurs WebAuthn en cours.",
	"505702857": "Lien magique",
	"519412053": "Modifier le facteur d'authentification",
	"655462232": "Téléchargez et installez OneLogin Protect sur votre appareil.",
	"660592555": "D'accord",
	"662924178": "On dirait qu'aujourd'hui n'est pas notre jour.",
	"694278426": "Veuillez saisir votre code {nom de l'appareil}",
	"694920552": "Premier code de sécurité",
	"737192390": "Ouvrir {appName}",
	"740457555": "Second code",
	"744377571": "{length} minimum de caractères",
	"751710530": "Soumettre",
	"916760408": "Entrez un nom d'utilisateur et un code de sécurité depuis votre appareil.",
	"921093870": "Vous n'avez pas reçu le code ?",
	"966052509": "Aucun résultat",
	"987359842": "Veuillez cliquer sur le lien contenu dans le message pour continuer",
	"1068496829": "Sélectionnez la Question de sécurité {current}/{total}.",
	"1079852660": "Entrez deux codes de sécurité consécutifs",
	"1080736814": "Entrez {fieldName} depuis l'application Symantec VIP Access.",
	"1136625613": "Le processus a été annulé. Veuillez réessayer ou utiliser un autre facteur d'authentification.",
	"1212847248": "Un code de confirmation a été envoyé à l'adresse enregistrée.",
	"1232460711": "Saisissez votre adresse e-mail",
	"1242107845": "Afficher",
	"1254879564": "Nouveau mot de passe",
	"1359200231": "Envoyer",
	"1433651550": "Entrez le code depuis OneLogin SMS.",
	"1477893598": "Configurer",
	"1536965459": "Téléchargez et installez OneLogin Protect sur votre appareil.",
	"1624184662": "Pour configurer OneLogin SMS, nous allons vous envoyer un code d'activation par SMS. Vous aurez besoin de ce code d'activation pour compléter l'enregistrement de l'appareil.",
	"1654624862": "Code de sécurité",
	"1833121415": "Fournir la réponse {current}/{total}.",
	"1919587067": "Renvoyer le code",
	"1935535842": "Requis",
	"1963245695": "1 majuscule",
	"2018264248": "Réessayer",
	"2091874550": "Premier code",
	"2097632732": "Scanner le code-barres à la place",
	"2104438124": "Entrez {fieldName} et deux codes de sécurité consécutifs depuis Symantec VIP Access.",
	"2124363772": "Entrez votre nom d'utilisateur et le code de sécurité de votre jeton SecurID.",
	"2229754167": "Veuillez saisir votre numéro de téléphone",
	"2244720377": "Une erreur inattendue semble s'être produite.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Un lien d'accès vous a été envoyé par mail",
	"2600324508": "Cacher",
	"2606375562": "Insérez votre YubiKey dans le port USB et appuyez sur le bouton.",
	"2663586870": "Nom d'utilisateur",
	"2758306961": "Identifiant",
	"2792137744": "1 numéro",
	"2815222727": "Scanner ce code-barres",
	"2828880379": "Confirmer",
	"2859281487": "Une authentification à 2 facteurs est nécessaire pour sécuriser votre compte.",
	"2942752129": "Second code de sécurité",
	"3060896801": "Vous avez des problèmes ?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 caractère spécial",
	"3294346597": "Essayer à nouveau",
	"3327626662": "Veuillez saisir votre code de confirmation",
	"3374226769": "Cliquez sur Appairer en utilisant la saisie manuelle.",
	"3469481929": "Vous ne pouvez pas scanner le code ?",
	"3499598078": "Ouvrir le menu",
	"3528672691": "Annuler",
	"3640052215": "Continuer",
	"3645029425": "Scanner sous le QR Code",
	"3645116517": "Veuillez saisir le code suivant au moment de recevoir l'appel :",
	"3663548834": "Nous analysons le problème et espérons rétablir bientôt. Veuillez patienter quelques minutes<br />et actualisez votre navigateur, ou consultez notre <a href='https://www.onelogin.com/status'>Page de statut</a>.",
	"3669652728": "Un lien d'accès a été envoyé à",
	"3673120330": "Suivant",
	"3737470122": "Veuillez contacter l'administrateur pour plus d'informations.",
	"3781468762": "Votre navigateur ne supporte pas WebAuthn",
	"3827227259": "Un code de confirmation a été envoyé à",
	"3855542277": "Entrez ce code dans l'application",
	"3865193889": "Activer",
	"3877285238": "1 minuscule",
	"4000449233": "Appel du numéro de téléphone suivant en cours :",
	"4072532148": "Renvoyer le code SMS",
	"4151518079": "Sélectionner la question de sécurité {current} / {total}.",
	"4152906165": "Nous étudions le problème et espérons être bientôt de retour. Veuillez patienter quelques minutes{break}et actualiser votre navigateur, ou visitez notre <link>page d'état</link>.",
	"4227081527": "Lorsque l'application est installée, revenez à cet écran et cliquez sur {action}.",
	"4281662478": "Chercher",
	addApp: addApp$h,
	addFactor: addFactor$h,
	additionalQuestions: additionalQuestions$h,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$h,
	addNewSecurityQuestion: addNewSecurityQuestion$h,
	administration: administration$h,
	alert: alert$h,
	all: all$h,
	app: app$h,
	appDevice: appDevice$h,
	appDevices: appDevices$h,
	appFactor: appFactor$h,
	application: application$h,
	appName: appName$h,
	appPortal: appPortal$h,
	assumedUserNotification: assumedUserNotification$h,
	broswerExtension: broswerExtension$h,
	browser: browser$h,
	browserDeleteFailure: browserDeleteFailure$h,
	browserDeleteSuccess: browserDeleteSuccess$h,
	browserDevice: browserDevice$h,
	browserFetchFailure: browserFetchFailure$h,
	calling: calling$h,
	callUserAgain: callUserAgain$h,
	cancel: cancel$h,
	changePassword: changePassword$h,
	changeSecurityFactor: changeSecurityFactor$h,
	clearIcon: clearIcon$h,
	close: close$h,
	closeDialog: closeDialog$h,
	codeResent: codeResent$h,
	companyLogo: companyLogo$h,
	companyTab: companyTab$h,
	conditionalRequirement: conditionalRequirement$h,
	configuredOn: configuredOn$h,
	confirm: confirm$h,
	contactAdminEmailOtp: contactAdminEmailOtp$h,
	contactAdminForSMS: contactAdminForSMS$h,
	contactAdminForVoice: contactAdminForVoice$h,
	contactAdminPasswordReset: contactAdminPasswordReset$h,
	credentialId: credentialId$h,
	current: current$h,
	currentPassword: currentPassword$h,
	deleteDeviceSuccess: deleteDeviceSuccess$h,
	deleteQuestion: deleteQuestion$h,
	details: details$h,
	device: device$h,
	deviceDeleteFailure: deviceDeleteFailure$h,
	deviceFetchFailure: deviceFetchFailure$h,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$h,
	deviceRenameFailure: deviceRenameFailure$h,
	downloadOnAppStore: downloadOnAppStore$h,
	editDeviceName: editDeviceName$h,
	editSQinfo: editSQinfo$h,
	enrollNewFactor: enrollNewFactor$h,
	event: event$h,
	eventType: eventType$h,
	eventUserAgent: eventUserAgent$h,
	eventUseragent: eventUseragent$h,
	eventUUID: eventUUID$h,
	eventUuid: eventUuid$h,
	expirationDays: expirationDays$h,
	expireDate: expireDate$h,
	expires: expires$h,
	extensionVersionInstalled: extensionVersionInstalled$h,
	factor: factor$h,
	factorFetchFailure: factorFetchFailure$h,
	factorMfaTokenFailure: factorMfaTokenFailure$h,
	factorPrimaryFailure: factorPrimaryFailure$h,
	factors: factors$h,
	factorsFetchFailure: factorsFetchFailure$h,
	failedToFetchUserInfo: failedToFetchUserInfo$h,
	failedToRegisterAnswers: failedToRegisterAnswers$h,
	failedToRetrieveQuestions: failedToRetrieveQuestions$h,
	forcedLogout: forcedLogout$h,
	getOnGooglePlay: getOnGooglePlay$h,
	goToExternalSite: goToExternalSite$h,
	helpRequestFailed: helpRequestFailed$h,
	helpRequestSuccessful: helpRequestSuccessful$h,
	hostname: hostname$h,
	icon: icon$h,
	identifier: identifier$h,
	imageUpload: imageUpload$h,
	inactive: inactive$h,
	inactiveDevice: inactiveDevice$h,
	install: install$h,
	invalidCode: invalidCode$h,
	invalidPhoneNumber: invalidPhoneNumber$h,
	language: language$h,
	languageConfirmation: languageConfirmation$h,
	lastAuthentication: lastAuthentication$h,
	lastChanged: lastChanged$h,
	lastUsed: lastUsed$h,
	length: length$h,
	letter: letter$h,
	linkToAppStore: linkToAppStore$h,
	linkToGooglePlay: linkToGooglePlay$h,
	loadingRecentActivity: loadingRecentActivity$h,
	loadingTrustedBrowsers: loadingTrustedBrowsers$h,
	location: location$h,
	locationTime: locationTime$h,
	loggedOut: loggedOut$h,
	login: login$h,
	loginDevice: loginDevice$h,
	loginEvent: loginEvent$h,
	loginFactor: loginFactor$h,
	loginFailedEvent: loginFailedEvent$h,
	loginName: loginName$h,
	logOut: logOut$h,
	lower: lower$h,
	message: message$h,
	mfaRegistrationFailure: mfaRegistrationFailure$h,
	mfaRegistrationSuccess: mfaRegistrationSuccess$h,
	more: more$h,
	never: never$h,
	newPassword: newPassword$h,
	newPrimaryFactor: newPrimaryFactor$h,
	noActivities: noActivities$h,
	noDevicesConfigured: noDevicesConfigured$h,
	noExpiration: noExpiration$h,
	noMoreSecurityFactors: noMoreSecurityFactors$h,
	notifyErrorLoadingUser: notifyErrorLoadingUser$h,
	notifySuccessAddApp: notifySuccessAddApp$h,
	noTrustedBrowsers: noTrustedBrowsers$h,
	numbers: numbers$h,
	oneloginDesktop: oneloginDesktop$h,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$h,
	oneloginLogo: oneloginLogo$h,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$h,
	otp1: otp1$h,
	otp2: otp2$h,
	otpDevice: otpDevice$h,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$h,
	password: password$h,
	passwordChanged: passwordChanged$h,
	passwordChangedDays: passwordChangedDays$h,
	passwordHint: passwordHint$h,
	passwordRedirectDescription: passwordRedirectDescription$h,
	passwordReset: passwordReset$h,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$h,
	passwordUpdateFailure: passwordUpdateFailure$h,
	phoneNumber: phoneNumber$h,
	prefix: prefix$h,
	previousDeviceName: previousDeviceName$h,
	primary: primary$h,
	proceedAnyway: proceedAnyway$h,
	profile: profile$h,
	profileAvatar: profileAvatar$h,
	profileMenuToggle: profileMenuToggle$h,
	profilePhoto: profilePhoto$h,
	profilePhotoAction: profilePhotoAction$h,
	pwResetDevice: pwResetDevice$h,
	pwResetFactor: pwResetFactor$h,
	questionNumber: questionNumber$h,
	radiusAuthentication: radiusAuthentication$h,
	recentActivity: recentActivity$h,
	redirectToChangePassword: redirectToChangePassword$h,
	registerSecurityQuestions: registerSecurityQuestions$h,
	registrationRejected: registrationRejected$h,
	registrationTimedout: registrationTimedout$h,
	remove: remove$h,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$h,
	removedProfilePictureSuccess: removedProfilePictureSuccess$h,
	removeFactorWarning: removeFactorWarning$h,
	removeImage: removeImage$h,
	report: report$h,
	reportActivity: reportActivity$h,
	requestField: requestField$h,
	requiredQuestions: requiredQuestions$h,
	revert: revert$h,
	revertToAdmin: revertToAdmin$h,
	revertToSuperadmin: revertToSuperadmin$h,
	revoke: revoke$h,
	save: save$h,
	searchIcon: searchIcon$h,
	secureNotes: secureNotes$h,
	securityFactorAdded: securityFactorAdded$h,
	securityFactorRemoved: securityFactorRemoved$h,
	securityFactorRenamed: securityFactorRenamed$h,
	securityFactors: securityFactors$h,
	securityFactorsDescription: securityFactorsDescription$h,
	securityFactorsUpdated: securityFactorsUpdated$h,
	selectNewImage: selectNewImage$h,
	selectNewPrimary: selectNewPrimary$h,
	selectSecurityFactor: selectSecurityFactor$h,
	sending: sending$h,
	setPrimaryDevice: setPrimaryDevice$h,
	showDetails: showDetails$h,
	specials: specials$h,
	sqDropdownAriaLabel: sqDropdownAriaLabel$h,
	sqInfoHeader: sqInfoHeader$h,
	sqTipBlankAnswers: sqTipBlankAnswers$h,
	sqTipDoNotShare: sqTipDoNotShare$h,
	sqTipMinimum: sqTipMinimum$h,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$h,
	sqTipNoUsePassword: sqTipNoUsePassword$h,
	sqTipSameAnswer: sqTipSameAnswer$h,
	sqTipSpecialChars: sqTipSpecialChars$h,
	submit: submit$h,
	submitting: submitting$h,
	support: support$h,
	supportDefaultDescription: supportDefaultDescription$h,
	supportedBrowsers: supportedBrowsers$h,
	supportRequestHeader: supportRequestHeader$h,
	"switch": "Switch",
	time: time$h,
	trustDevice: trustDevice$h,
	trusted: trusted$h,
	trustedBrowsers: trustedBrowsers$h,
	trustedBrowsersDescription: trustedBrowsersDescription$h,
	trustedDevice: trustedDevice$h,
	unavailable: unavailable$h,
	unavailableTime: unavailableTime$h,
	unsetFactorSuccess: unsetFactorSuccess$h,
	unsetPrimaryDevice: unsetPrimaryDevice$h,
	unsupportedBrowser: unsupportedBrowser$h,
	unsupportedBrowserHeading: unsupportedBrowserHeading$h,
	updateDeviceNameSuccess: updateDeviceNameSuccess$h,
	updateFactorSuccess: updateFactorSuccess$h,
	updatePassword: updatePassword$h,
	updateUserProfileFailure: updateUserProfileFailure$h,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$h,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$h,
	updateUserProfileSuccess: updateUserProfileSuccess$h,
	upper: upper$h,
	usedFor: usedFor$h,
	usedForApp: usedForApp$h,
	usedForLogin: usedForLogin$h,
	usedForPasswordReset: usedForPasswordReset$h,
	version: version$h,
	yourBrowser: yourBrowser$h
};

var addApp$g = "Show {addApp} button when I log in to new websites.";
var addFactor$g = "Add Factor";
var additionalQuestions$g = "Additional Questions";
var addNewPrimaryBeforeRemove$g = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$g = "Add New Security Question";
var administration$g = "Administration";
var alert$g = "Alert";
var all$g = "all";
var app$g = "App";
var appDevice$g = "Ezt a tényezőt az alkalmazáshoz használják.";
var appDevices$g = "Ezt a tényezőt az alkalmazáshoz használjuk.";
var appFactor$g = "Ezt a tényezőt az alkalmazáshoz használják.";
var application$g = "Application";
var appName$g = "App Name";
var appPortal$g = "App Portal";
var assumedUserNotification$g = "You cannot edit personal information while assuming a user.";
var broswerExtension$g = "Browser Extension";
var browser$g = "Browser";
var browserDeleteFailure$g = "Failed to delete trusted browser";
var browserDeleteSuccess$g = "Trusted browser was successfully deleted";
var browserDevice$g = "Browser/Device";
var browserFetchFailure$g = "Failed to fetch browsers";
var calling$g = "Hívás";
var callUserAgain$g = "Calling you again";
var cancel$g = "visszavonás";
var changePassword$g = "Change Password";
var changeSecurityFactor$g = "Change Security Factor";
var clearIcon$g = "törlés ikon";
var close$g = "Close";
var closeDialog$g = "Párbeszédablak bezárása";
var codeResent$g = "Code has been sent to your phone.";
var companyLogo$g = "vállalat logója";
var companyTab$g = "Default for company tab";
var conditionalRequirement$g = "At least {number} of the following requirements:";
var configuredOn$g = "Configured On";
var confirm$g = "megerősítés";
var contactAdminEmailOtp$g = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$g = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$g = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$g = "Contact your admin to reset password.";
var credentialId$g = "Credential ID";
var current$g = "Current";
var currentPassword$g = "Current password";
var deleteDeviceSuccess$g = "{factorName} was successfully deleted";
var deleteQuestion$g = "Delete question {position}";
var details$g = "Details";
var device$g = "Device";
var deviceDeleteFailure$g = "Failed to remove {factorName}";
var deviceFetchFailure$g = "Failed to fetch devices";
var deviceNameCannotBeBlank$g = "Authentication device name cannot be blank.";
var deviceRenameFailure$g = "Failed to update device name";
var downloadOnAppStore$g = "Töltse le az App Store-ból";
var editDeviceName$g = "Edit name";
var editSQinfo$g = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$g = "Enroll new primary factor";
var event$g = "Event";
var eventType$g = "Event Type";
var eventUserAgent$g = "Event Useragent";
var eventUseragent$g = "Event Useragent";
var eventUUID$g = "Event UUID";
var eventUuid$g = "Event UUID";
var expirationDays$g = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$g = "Expire Date";
var expires$g = "Expires";
var extensionVersionInstalled$g = "Version {versionString} installed";
var factor$g = "Factor";
var factorFetchFailure$g = "Failed to fetch available factors";
var factorMfaTokenFailure$g = "Failed to fetch mfa token";
var factorPrimaryFailure$g = "Failed to set {factorName} as your primary factor";
var factors$g = "factors";
var factorsFetchFailure$g = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$g = "We couldn’t load your user information.";
var failedToRegisterAnswers$g = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$g = "We couldn't retrieve your security questions at this time.";
var forcedLogout$g = "Forced Logout";
var getOnGooglePlay$g = "Szerezze be Google Play-en";
var goToExternalSite$g = "Go to external site";
var helpRequestFailed$g = "We couldn't submit your help request.";
var helpRequestSuccessful$g = "Your support request has been sent to your OneLogin Admin.";
var hostname$g = "Hostname & OS";
var icon$g = "Icon";
var identifier$g = "Credential ID / Identifier";
var imageUpload$g = "Image Upload";
var inactive$g = "Inactive";
var inactiveDevice$g = "Inactive device";
var install$g = "Install";
var invalidCode$g = "Invalid code";
var invalidPhoneNumber$g = "Please use valid phone number.";
var language$g = "Language";
var languageConfirmation$g = "Are you sure you want to switch to {language}?";
var lastAuthentication$g = "Last Authentication";
var lastChanged$g = "Last changed";
var lastUsed$g = "Last Used";
var length$g = "Minimum {length} characters";
var letter$g = "1 Letter";
var linkToAppStore$g = "Link az App Store-hoz";
var linkToGooglePlay$g = "Link a Google Play-hez";
var loadingRecentActivity$g = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$g = "Loading trusted browsers, please wait...";
var location$g = "Location";
var locationTime$g = "Location/Time";
var loggedOut$g = "Logged Out";
var login$g = "login";
var loginDevice$g = "Login device";
var loginEvent$g = "Login";
var loginFactor$g = "Ezt a tényezőt a bejelentkezéshez használják.";
var loginFailedEvent$g = "Login Failed";
var loginName$g = "Login Name";
var logOut$g = "Log Out";
var lower$g = "1 Lowercase";
var message$g = "{name} was successfully added.";
var mfaRegistrationFailure$g = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$g = "You successfully registered the device";
var more$g = "More";
var never$g = "Never";
var newPassword$g = "New password";
var newPrimaryFactor$g = "New primary factor";
var noActivities$g = "No activities have been made";
var noDevicesConfigured$g = "No devices have been configured";
var noExpiration$g = "Never expires";
var noMoreSecurityFactors$g = "There are no security factors available for registration.";
var notifyErrorLoadingUser$g = "Loading of user failed. Try again later";
var notifySuccessAddApp$g = "{name} was successfully added.";
var noTrustedBrowsers$g = "No browsers have been saved";
var numbers$g = "1 Number";
var oneloginDesktop$g = "OneLogin Desktop";
var oneloginDesktopFetchFailure$g = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$g = "OneLogin logo";
var onlyDesktopBrowsersSupported$g = "We currently only support browser extensions on desktop browsers.";
var otp1$g = "OTP 1";
var otp2$g = "OTP 2";
var otpDevice$g = "Ezt a tényezőt a belépéshez használjuk.";
var parsingUserProfilePhotoFailure$g = "Getting image details failed";
var password$g = "password";
var passwordChanged$g = "Password Changed";
var passwordChangedDays$g = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$g = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$g = "Your administrator has configured an external site for resetting your password.";
var passwordReset$g = "Password Reset";
var passwordUpdatedSuccessfully$g = "You have successfully updated your password.";
var passwordUpdateFailure$g = "Password update failed";
var phoneNumber$g = "Phone number";
var prefix$g = "Suspicious login report";
var previousDeviceName$g = "Previously {previousName}";
var primary$g = "Primary";
var proceedAnyway$g = "Proceed anyway";
var profile$g = "Profile";
var profileAvatar$g = "Profile avatar";
var profileMenuToggle$g = "Open profile menu";
var profilePhoto$g = "Profile photo";
var profilePhotoAction$g = "Profile image action";
var pwResetDevice$g = "Ezt a tényezőt a jelszó újraállításához használjuk.";
var pwResetFactor$g = "Ezt a tényezőt jelszó-újraállításhoz használják.";
var questionNumber$g = "Question {position}";
var radiusAuthentication$g = "Service Login via Radius";
var recentActivity$g = "Recent Activity";
var redirectToChangePassword$g = "Redirect to change your password?";
var registerSecurityQuestions$g = "Register Security Questions";
var registrationRejected$g = "Registration unsuccessful, please try again.";
var registrationTimedout$g = "Registration context timed out";
var remove$g = "Remove";
var removeCurrentBrowserWarning$g = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$g = "You have successfully removed your profile picture.";
var removeFactorWarning$g = "Are you sure you want to remove {factor}?";
var removeImage$g = "Remove image";
var report$g = "Report";
var reportActivity$g = "Report Activity";
var requestField$g = "Describe the issue you're having";
var requiredQuestions$g = "Required Questions";
var revert$g = "visszalépés";
var revertToAdmin$g = "Revert to Admin";
var revertToSuperadmin$g = "Revert to OneLogin Admin";
var revoke$g = "Revoke";
var save$g = "Save Changes";
var searchIcon$g = "keresés ikon";
var secureNotes$g = "Secure Notes";
var securityFactorAdded$g = "Security Factor Added";
var securityFactorRemoved$g = "Security Factor Removed";
var securityFactorRenamed$g = "Security Factor Renamed";
var securityFactors$g = "Security Factors";
var securityFactorsDescription$g = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$g = "Security Factors Updated";
var selectNewImage$g = "Select new image";
var selectNewPrimary$g = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$g = "Select Security Factor";
var sending$g = "Küldés";
var setPrimaryDevice$g = "Set as primary";
var showDetails$g = "Mutasd a részleteket";
var specials$g = "1 Special character";
var sqDropdownAriaLabel$g = "Question {position} dropdown";
var sqInfoHeader$g = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$g = "Blank answers will not be accepted";
var sqTipDoNotShare$g = "Do not share your questions and answers with anyone.";
var sqTipMinimum$g = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$g = "Answers are not case-sensitive.";
var sqTipNoUsePassword$g = "Do not use a password as an answer.";
var sqTipSameAnswer$g = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$g = "Special characters such as @#&*. will be ignored";
var submit$g = "Submit";
var submitting$g = "Submitting…";
var support$g = "Support";
var supportDefaultDescription$g = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$g = "Supported browsers: {browsers}";
var supportRequestHeader$g = "Support Request";
var time$g = "Time";
var trustDevice$g = "Trust Device";
var trusted$g = "Trusted";
var trustedBrowsers$g = "Trusted Browsers";
var trustedBrowsersDescription$g = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$g = "Trusted Device";
var unavailable$g = "Unavailable";
var unavailableTime$g = "Unavailable";
var unsetFactorSuccess$g = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$g = "Unset as primary";
var unsupportedBrowser$g = "Unsupported Browser";
var unsupportedBrowserHeading$g = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$g = "{newName} was successfully updated";
var updateFactorSuccess$g = "{factorName} is your new default security factor";
var updatePassword$g = "Update Password";
var updateUserProfileFailure$g = "Profile Update Failed";
var updateUserProfilePhotoFailure$g = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$g = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$g = "You have successfully updated your profile.";
var upper$g = "1 Uppercase";
var usedFor$g = "Used For";
var usedForApp$g = "This factor is used for app.";
var usedForLogin$g = "This factor is used for login.";
var usedForPasswordReset$g = "This factor is used for password reset.";
var version$g = "Version: {versionString}";
var yourBrowser$g = "Your browser: {browser}";
var huHU = {
	"26286820": "Írja be a hitelesítőadat-azonosítót és két egymást követő biztonsági kódot a Symantec VIP hozzáféréstől.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Írd be az SMS-ben kapott kódot.",
	"374233718": "{secLeft, number} {secLeft, plural, one {second} other {seconds}} múlva újrapróbálhatja",
	"437305782": "Ellenőrizzük a WebAuthn hitelesítőit.",
	"505702857": "Mágikus Hivatkozás",
	"519412053": "Hitelesítési Faktor Változtatása",
	"655462232": "Töltsd le és telepítsd készülékedre a OneLogin Protect-et",
	"660592555": "Rendben",
	"662924178": "Ügy tűnik ez nem a te napod.",
	"694278426": "Írja be a(z) {deviceName} kódot",
	"694920552": "Első Biztonsági Kód",
	"737192390": "{appName} megnyitása",
	"740457555": "Második Kód",
	"744377571": "Legkevesebb {length} karakter",
	"751710530": "Beküldés",
	"916760408": "Írj be egy felhasználónevet és biztonsági kódot készülékedről.",
	"921093870": "Nem kaptad meg a kódot?",
	"966052509": "Nincs eredmény",
	"987359842": "A folytatáshoz kattints a linkre az e-mailben",
	"1068496829": "Válassz Biztonsági Kérdést {current}/{total}",
	"1079852660": "Írj be 2 egymást követő Biztonsági Kódot",
	"1080736814": "Írd be a {fieldName} mezőt a Symantec VIP Access alkalmazásból",
	"1136625613": "A folyamat megszakadt. Kérjük, próbálja újra, vagy használjon másik hitelesítési tényezőt.",
	"1212847248": "Megerősítési kódot elküldtük a beállított címre",
	"1232460711": "Írd be az e-mailed",
	"1242107845": "Mutat",
	"1254879564": "Új Jelszó",
	"1359200231": "Küldés",
	"1433651550": "Írd be a kódot a OneLogin SMS-ből.",
	"1477893598": "Konfigurálás",
	"1536965459": "Töltsd le és telepítsd készülékedre a OneLogin Protect-et",
	"1624184662": "A OneLogin SMS beállításához egy aktiváló kódot küldünk neked SMS-ben. A készülék regisztrációjához szükséged lesz erre a kódra.",
	"1654624862": "Biztonsági Kód",
	"1833121415": "Válaszolj  {current}/{total}",
	"1919587067": "Kód újraküldése",
	"1935535842": "Kötelező",
	"1963245695": "1 Nagybetű",
	"2018264248": "Próbálja újból",
	"2091874550": "Első Kód",
	"2097632732": "Olvasd be a vonalkódot helyette",
	"2104438124": "Írd be a {fieldName} mezőt és két egymást követő Biztonsági Kódot a Symantec VIP Access-ből.",
	"2124363772": "Írd be a felhasználónevedet és biztonsági kódodat a SecureID token-ből.",
	"2229754167": "Írja be telefonszámát",
	"2244720377": "Úgy tűnik, hogy egy váratlan hiba történt.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Egy hozzáférési linket küldtünk az e-mailedre",
	"2600324508": "Elrejt",
	"2606375562": "Helyezd a YubiKey-t az USB portba és nyomd meg a gombot.",
	"2663586870": "Felhasználónév",
	"2758306961": "Hitelesítőadat-azonosító",
	"2792137744": "1 szám",
	"2815222727": "Olvasd be ezt a vonalkódot",
	"2828880379": "Megerősít",
	"2859281487": "Kétfaktoros hitelesítésre van szükség a fiókod megvédéséhez.",
	"2942752129": "Második Biztonsági Kód",
	"3060896801": "Problémád akadt?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 speciális karakter",
	"3294346597": "Próbáld újra",
	"3327626662": "Írja be a megerősítő kódot",
	"3374226769": "Kattints a Párosítás manuális beírással- ra",
	"3469481929": "Nem tudod beolvasni a kódot?",
	"3499598078": "Menü megnyitása",
	"3528672691": "Mégse",
	"3640052215": "Folytatás",
	"3645029425": "Olvasd be alább a QR-kódot",
	"3645116517": "A hívás fogadásakor írja be ezt a kódot:",
	"3663548834": "Kivizsgáljuk a problémát és hamarosan visszatérünk. Várjon néhány percet<br />és frissítse böngészőjét, vagy látogassa meg az <a href='https://www.onelogin.com/status'>Állapotoldalt</a>.",
	"3669652728": "Egy hozzáférési linket küldtünk",
	"3673120330": "Következő",
	"3737470122": "További információért forduljon a rendszergazdához.",
	"3781468762": "A böngészője nem támogatja a WebAuthn szolgáltatást",
	"3827227259": "Megerősítő kódot küldtünk a következő címre:",
	"3855542277": "Add meg ezt a kódot az alkalmazásban",
	"3865193889": "Aktiválás",
	"3877285238": "1 kisbetű",
	"4000449233": "Az alábbi telefonszám hívása:",
	"4072532148": "SMS kód újraküldése",
	"4151518079": "Válassz Biztonsági Kérdést {current}/{total}",
	"4152906165": "Kivizsgáljuk a problémát és várhatóan hamarosan jelentkezünk. Várj néhány percet,{break}és frissítsd a böngésződet vagy keresd fel az <link>Állapotlapunkat</link>.",
	"4227081527": "Amikor telepítetted az alkalmazást, térj vissza erre a képernyőre, és kattints a {action} műveletre.",
	"4281662478": "Keresés",
	addApp: addApp$g,
	addFactor: addFactor$g,
	additionalQuestions: additionalQuestions$g,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$g,
	addNewSecurityQuestion: addNewSecurityQuestion$g,
	administration: administration$g,
	alert: alert$g,
	all: all$g,
	app: app$g,
	appDevice: appDevice$g,
	appDevices: appDevices$g,
	appFactor: appFactor$g,
	application: application$g,
	appName: appName$g,
	appPortal: appPortal$g,
	assumedUserNotification: assumedUserNotification$g,
	broswerExtension: broswerExtension$g,
	browser: browser$g,
	browserDeleteFailure: browserDeleteFailure$g,
	browserDeleteSuccess: browserDeleteSuccess$g,
	browserDevice: browserDevice$g,
	browserFetchFailure: browserFetchFailure$g,
	calling: calling$g,
	callUserAgain: callUserAgain$g,
	cancel: cancel$g,
	changePassword: changePassword$g,
	changeSecurityFactor: changeSecurityFactor$g,
	clearIcon: clearIcon$g,
	close: close$g,
	closeDialog: closeDialog$g,
	codeResent: codeResent$g,
	companyLogo: companyLogo$g,
	companyTab: companyTab$g,
	conditionalRequirement: conditionalRequirement$g,
	configuredOn: configuredOn$g,
	confirm: confirm$g,
	contactAdminEmailOtp: contactAdminEmailOtp$g,
	contactAdminForSMS: contactAdminForSMS$g,
	contactAdminForVoice: contactAdminForVoice$g,
	contactAdminPasswordReset: contactAdminPasswordReset$g,
	credentialId: credentialId$g,
	current: current$g,
	currentPassword: currentPassword$g,
	deleteDeviceSuccess: deleteDeviceSuccess$g,
	deleteQuestion: deleteQuestion$g,
	details: details$g,
	device: device$g,
	deviceDeleteFailure: deviceDeleteFailure$g,
	deviceFetchFailure: deviceFetchFailure$g,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$g,
	deviceRenameFailure: deviceRenameFailure$g,
	downloadOnAppStore: downloadOnAppStore$g,
	editDeviceName: editDeviceName$g,
	editSQinfo: editSQinfo$g,
	enrollNewFactor: enrollNewFactor$g,
	event: event$g,
	eventType: eventType$g,
	eventUserAgent: eventUserAgent$g,
	eventUseragent: eventUseragent$g,
	eventUUID: eventUUID$g,
	eventUuid: eventUuid$g,
	expirationDays: expirationDays$g,
	expireDate: expireDate$g,
	expires: expires$g,
	extensionVersionInstalled: extensionVersionInstalled$g,
	factor: factor$g,
	factorFetchFailure: factorFetchFailure$g,
	factorMfaTokenFailure: factorMfaTokenFailure$g,
	factorPrimaryFailure: factorPrimaryFailure$g,
	factors: factors$g,
	factorsFetchFailure: factorsFetchFailure$g,
	failedToFetchUserInfo: failedToFetchUserInfo$g,
	failedToRegisterAnswers: failedToRegisterAnswers$g,
	failedToRetrieveQuestions: failedToRetrieveQuestions$g,
	forcedLogout: forcedLogout$g,
	getOnGooglePlay: getOnGooglePlay$g,
	goToExternalSite: goToExternalSite$g,
	helpRequestFailed: helpRequestFailed$g,
	helpRequestSuccessful: helpRequestSuccessful$g,
	hostname: hostname$g,
	icon: icon$g,
	identifier: identifier$g,
	imageUpload: imageUpload$g,
	inactive: inactive$g,
	inactiveDevice: inactiveDevice$g,
	install: install$g,
	invalidCode: invalidCode$g,
	invalidPhoneNumber: invalidPhoneNumber$g,
	language: language$g,
	languageConfirmation: languageConfirmation$g,
	lastAuthentication: lastAuthentication$g,
	lastChanged: lastChanged$g,
	lastUsed: lastUsed$g,
	length: length$g,
	letter: letter$g,
	linkToAppStore: linkToAppStore$g,
	linkToGooglePlay: linkToGooglePlay$g,
	loadingRecentActivity: loadingRecentActivity$g,
	loadingTrustedBrowsers: loadingTrustedBrowsers$g,
	location: location$g,
	locationTime: locationTime$g,
	loggedOut: loggedOut$g,
	login: login$g,
	loginDevice: loginDevice$g,
	loginEvent: loginEvent$g,
	loginFactor: loginFactor$g,
	loginFailedEvent: loginFailedEvent$g,
	loginName: loginName$g,
	logOut: logOut$g,
	lower: lower$g,
	message: message$g,
	mfaRegistrationFailure: mfaRegistrationFailure$g,
	mfaRegistrationSuccess: mfaRegistrationSuccess$g,
	more: more$g,
	never: never$g,
	newPassword: newPassword$g,
	newPrimaryFactor: newPrimaryFactor$g,
	noActivities: noActivities$g,
	noDevicesConfigured: noDevicesConfigured$g,
	noExpiration: noExpiration$g,
	noMoreSecurityFactors: noMoreSecurityFactors$g,
	notifyErrorLoadingUser: notifyErrorLoadingUser$g,
	notifySuccessAddApp: notifySuccessAddApp$g,
	noTrustedBrowsers: noTrustedBrowsers$g,
	numbers: numbers$g,
	oneloginDesktop: oneloginDesktop$g,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$g,
	oneloginLogo: oneloginLogo$g,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$g,
	otp1: otp1$g,
	otp2: otp2$g,
	otpDevice: otpDevice$g,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$g,
	password: password$g,
	passwordChanged: passwordChanged$g,
	passwordChangedDays: passwordChangedDays$g,
	passwordHint: passwordHint$g,
	passwordRedirectDescription: passwordRedirectDescription$g,
	passwordReset: passwordReset$g,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$g,
	passwordUpdateFailure: passwordUpdateFailure$g,
	phoneNumber: phoneNumber$g,
	prefix: prefix$g,
	previousDeviceName: previousDeviceName$g,
	primary: primary$g,
	proceedAnyway: proceedAnyway$g,
	profile: profile$g,
	profileAvatar: profileAvatar$g,
	profileMenuToggle: profileMenuToggle$g,
	profilePhoto: profilePhoto$g,
	profilePhotoAction: profilePhotoAction$g,
	pwResetDevice: pwResetDevice$g,
	pwResetFactor: pwResetFactor$g,
	questionNumber: questionNumber$g,
	radiusAuthentication: radiusAuthentication$g,
	recentActivity: recentActivity$g,
	redirectToChangePassword: redirectToChangePassword$g,
	registerSecurityQuestions: registerSecurityQuestions$g,
	registrationRejected: registrationRejected$g,
	registrationTimedout: registrationTimedout$g,
	remove: remove$g,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$g,
	removedProfilePictureSuccess: removedProfilePictureSuccess$g,
	removeFactorWarning: removeFactorWarning$g,
	removeImage: removeImage$g,
	report: report$g,
	reportActivity: reportActivity$g,
	requestField: requestField$g,
	requiredQuestions: requiredQuestions$g,
	revert: revert$g,
	revertToAdmin: revertToAdmin$g,
	revertToSuperadmin: revertToSuperadmin$g,
	revoke: revoke$g,
	save: save$g,
	searchIcon: searchIcon$g,
	secureNotes: secureNotes$g,
	securityFactorAdded: securityFactorAdded$g,
	securityFactorRemoved: securityFactorRemoved$g,
	securityFactorRenamed: securityFactorRenamed$g,
	securityFactors: securityFactors$g,
	securityFactorsDescription: securityFactorsDescription$g,
	securityFactorsUpdated: securityFactorsUpdated$g,
	selectNewImage: selectNewImage$g,
	selectNewPrimary: selectNewPrimary$g,
	selectSecurityFactor: selectSecurityFactor$g,
	sending: sending$g,
	setPrimaryDevice: setPrimaryDevice$g,
	showDetails: showDetails$g,
	specials: specials$g,
	sqDropdownAriaLabel: sqDropdownAriaLabel$g,
	sqInfoHeader: sqInfoHeader$g,
	sqTipBlankAnswers: sqTipBlankAnswers$g,
	sqTipDoNotShare: sqTipDoNotShare$g,
	sqTipMinimum: sqTipMinimum$g,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$g,
	sqTipNoUsePassword: sqTipNoUsePassword$g,
	sqTipSameAnswer: sqTipSameAnswer$g,
	sqTipSpecialChars: sqTipSpecialChars$g,
	submit: submit$g,
	submitting: submitting$g,
	support: support$g,
	supportDefaultDescription: supportDefaultDescription$g,
	supportedBrowsers: supportedBrowsers$g,
	supportRequestHeader: supportRequestHeader$g,
	"switch": "Switch",
	time: time$g,
	trustDevice: trustDevice$g,
	trusted: trusted$g,
	trustedBrowsers: trustedBrowsers$g,
	trustedBrowsersDescription: trustedBrowsersDescription$g,
	trustedDevice: trustedDevice$g,
	unavailable: unavailable$g,
	unavailableTime: unavailableTime$g,
	unsetFactorSuccess: unsetFactorSuccess$g,
	unsetPrimaryDevice: unsetPrimaryDevice$g,
	unsupportedBrowser: unsupportedBrowser$g,
	unsupportedBrowserHeading: unsupportedBrowserHeading$g,
	updateDeviceNameSuccess: updateDeviceNameSuccess$g,
	updateFactorSuccess: updateFactorSuccess$g,
	updatePassword: updatePassword$g,
	updateUserProfileFailure: updateUserProfileFailure$g,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$g,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$g,
	updateUserProfileSuccess: updateUserProfileSuccess$g,
	upper: upper$g,
	usedFor: usedFor$g,
	usedForApp: usedForApp$g,
	usedForLogin: usedForLogin$g,
	usedForPasswordReset: usedForPasswordReset$g,
	version: version$g,
	yourBrowser: yourBrowser$g
};

var addApp$f = "Show {addApp} button when I log in to new websites.";
var addFactor$f = "Add Factor";
var additionalQuestions$f = "Additional Questions";
var addNewPrimaryBeforeRemove$f = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$f = "Add New Security Question";
var administration$f = "Administration";
var alert$f = "Alert";
var all$f = "all";
var app$f = "App";
var appDevice$f = "Questo elemento viene usato per l'app.";
var appDevices$f = "Questo fattore viene utilizzato per l'app.";
var appFactor$f = "Questo elemento viene usato per l'app.";
var application$f = "Application";
var appName$f = "App Name";
var appPortal$f = "App Portal";
var assumedUserNotification$f = "You cannot edit personal information while assuming a user.";
var broswerExtension$f = "Browser Extension";
var browser$f = "Browser";
var browserDeleteFailure$f = "Failed to delete trusted browser";
var browserDeleteSuccess$f = "Trusted browser was successfully deleted";
var browserDevice$f = "Browser/Device";
var browserFetchFailure$f = "Failed to fetch browsers";
var calling$f = "Sta chiamando";
var callUserAgain$f = "Calling you again";
var cancel$f = "annulla";
var changePassword$f = "Change Password";
var changeSecurityFactor$f = "Change Security Factor";
var clearIcon$f = "rimuovi icona";
var close$f = "Close";
var closeDialog$f = "Chiudere dialogo";
var codeResent$f = "Code has been sent to your phone.";
var companyLogo$f = "Logo aziendale";
var companyTab$f = "Default for company tab";
var conditionalRequirement$f = "At least {number} of the following requirements:";
var configuredOn$f = "Configured On";
var confirm$f = "conferma";
var contactAdminEmailOtp$f = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$f = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$f = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$f = "Contact your admin to reset password.";
var credentialId$f = "Credential ID";
var current$f = "Current";
var currentPassword$f = "Current password";
var deleteDeviceSuccess$f = "{factorName} was successfully deleted";
var deleteQuestion$f = "Delete question {position}";
var details$f = "Details";
var device$f = "Device";
var deviceDeleteFailure$f = "Failed to remove {factorName}";
var deviceFetchFailure$f = "Failed to fetch devices";
var deviceNameCannotBeBlank$f = "Authentication device name cannot be blank.";
var deviceRenameFailure$f = "Failed to update device name";
var downloadOnAppStore$f = "Scarica dall'App Store";
var editDeviceName$f = "Edit name";
var editSQinfo$f = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$f = "Enroll new primary factor";
var event$f = "Event";
var eventType$f = "Event Type";
var eventUserAgent$f = "Event Useragent";
var eventUseragent$f = "Event Useragent";
var eventUUID$f = "Event UUID";
var eventUuid$f = "Event UUID";
var expirationDays$f = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$f = "Expire Date";
var expires$f = "Expires";
var extensionVersionInstalled$f = "Version {versionString} installed";
var factor$f = "Factor";
var factorFetchFailure$f = "Failed to fetch available factors";
var factorMfaTokenFailure$f = "Failed to fetch mfa token";
var factorPrimaryFailure$f = "Failed to set {factorName} as your primary factor";
var factors$f = "factors";
var factorsFetchFailure$f = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$f = "We couldn’t load your user information.";
var failedToRegisterAnswers$f = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$f = "We couldn't retrieve your security questions at this time.";
var forcedLogout$f = "Forced Logout";
var getOnGooglePlay$f = "Ottienilo su Google Play";
var goToExternalSite$f = "Go to external site";
var helpRequestFailed$f = "We couldn't submit your help request.";
var helpRequestSuccessful$f = "Your support request has been sent to your OneLogin Admin.";
var hostname$f = "Hostname & OS";
var icon$f = "Icon";
var identifier$f = "Credential ID / Identifier";
var imageUpload$f = "Image Upload";
var inactive$f = "Inactive";
var inactiveDevice$f = "Inactive device";
var install$f = "Install";
var invalidCode$f = "Invalid code";
var invalidPhoneNumber$f = "Please use valid phone number.";
var language$f = "Language";
var languageConfirmation$f = "Are you sure you want to switch to {language}?";
var lastAuthentication$f = "Last Authentication";
var lastChanged$f = "Last changed";
var lastUsed$f = "Last Used";
var length$f = "Minimum {length} characters";
var letter$f = "1 Letter";
var linkToAppStore$f = "Link di App Store";
var linkToGooglePlay$f = "Link di Google Play";
var loadingRecentActivity$f = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$f = "Loading trusted browsers, please wait...";
var location$f = "Location";
var locationTime$f = "Location/Time";
var loggedOut$f = "Logged Out";
var login$f = "login";
var loginDevice$f = "Login device";
var loginEvent$f = "Login";
var loginFactor$f = "Questo elemento viene usato per l'accesso.";
var loginFailedEvent$f = "Login Failed";
var loginName$f = "Login Name";
var logOut$f = "Log Out";
var lower$f = "1 Lowercase";
var message$f = "{name} was successfully added.";
var mfaRegistrationFailure$f = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$f = "You successfully registered the device";
var more$f = "More";
var never$f = "Never";
var newPassword$f = "New password";
var newPrimaryFactor$f = "New primary factor";
var noActivities$f = "No activities have been made";
var noDevicesConfigured$f = "No devices have been configured";
var noExpiration$f = "Never expires";
var noMoreSecurityFactors$f = "There are no security factors available for registration.";
var notifyErrorLoadingUser$f = "Loading of user failed. Try again later";
var notifySuccessAddApp$f = "{name} was successfully added.";
var noTrustedBrowsers$f = "No browsers have been saved";
var numbers$f = "1 Number";
var oneloginDesktop$f = "OneLogin Desktop";
var oneloginDesktopFetchFailure$f = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$f = "OneLogin logo";
var onlyDesktopBrowsersSupported$f = "We currently only support browser extensions on desktop browsers.";
var otp1$f = "OTP 1";
var otp2$f = "OTP 2";
var otpDevice$f = "Questo fattore viene utilizzato per l'accesso.";
var parsingUserProfilePhotoFailure$f = "Getting image details failed";
var password$f = "password";
var passwordChanged$f = "Password Changed";
var passwordChangedDays$f = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$f = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$f = "Your administrator has configured an external site for resetting your password.";
var passwordReset$f = "Password Reset";
var passwordUpdatedSuccessfully$f = "You have successfully updated your password.";
var passwordUpdateFailure$f = "Password update failed";
var phoneNumber$f = "Phone number";
var prefix$f = "Suspicious login report";
var previousDeviceName$f = "Previously {previousName}";
var primary$f = "Primary";
var proceedAnyway$f = "Proceed anyway";
var profile$f = "Profile";
var profileAvatar$f = "Profile avatar";
var profileMenuToggle$f = "Open profile menu";
var profilePhoto$f = "Profile photo";
var profilePhotoAction$f = "Profile image action";
var pwResetDevice$f = "Questo fattore viene utilizzato per il ripristino della password.";
var pwResetFactor$f = "Questo elemento viene usato per il ripristino della password.";
var questionNumber$f = "Question {position}";
var radiusAuthentication$f = "Service Login via Radius";
var recentActivity$f = "Recent Activity";
var redirectToChangePassword$f = "Redirect to change your password?";
var registerSecurityQuestions$f = "Register Security Questions";
var registrationRejected$f = "Registration unsuccessful, please try again.";
var registrationTimedout$f = "Registration context timed out";
var remove$f = "Remove";
var removeCurrentBrowserWarning$f = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$f = "You have successfully removed your profile picture.";
var removeFactorWarning$f = "Are you sure you want to remove {factor}?";
var removeImage$f = "Remove image";
var report$f = "Report";
var reportActivity$f = "Report Activity";
var requestField$f = "Describe the issue you're having";
var requiredQuestions$f = "Required Questions";
var revert$f = "ripristina";
var revertToAdmin$f = "Revert to Admin";
var revertToSuperadmin$f = "Revert to OneLogin Admin";
var revoke$f = "Revoke";
var save$f = "Save Changes";
var searchIcon$f = "cerca icona";
var secureNotes$f = "Secure Notes";
var securityFactorAdded$f = "Security Factor Added";
var securityFactorRemoved$f = "Security Factor Removed";
var securityFactorRenamed$f = "Security Factor Renamed";
var securityFactors$f = "Security Factors";
var securityFactorsDescription$f = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$f = "Security Factors Updated";
var selectNewImage$f = "Select new image";
var selectNewPrimary$f = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$f = "Select Security Factor";
var sending$f = "Invio in corso";
var setPrimaryDevice$f = "Set as primary";
var showDetails$f = "Mostra dettagli";
var specials$f = "1 Special character";
var sqDropdownAriaLabel$f = "Question {position} dropdown";
var sqInfoHeader$f = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$f = "Blank answers will not be accepted";
var sqTipDoNotShare$f = "Do not share your questions and answers with anyone.";
var sqTipMinimum$f = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$f = "Answers are not case-sensitive.";
var sqTipNoUsePassword$f = "Do not use a password as an answer.";
var sqTipSameAnswer$f = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$f = "Special characters such as @#&*. will be ignored";
var submit$f = "Submit";
var submitting$f = "Submitting…";
var support$f = "Support";
var supportDefaultDescription$f = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$f = "Supported browsers: {browsers}";
var supportRequestHeader$f = "Support Request";
var time$f = "Time";
var trustDevice$f = "Trust Device";
var trusted$f = "Trusted";
var trustedBrowsers$f = "Trusted Browsers";
var trustedBrowsersDescription$f = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$f = "Trusted Device";
var unavailable$f = "Unavailable";
var unavailableTime$f = "Unavailable";
var unsetFactorSuccess$f = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$f = "Unset as primary";
var unsupportedBrowser$f = "Unsupported Browser";
var unsupportedBrowserHeading$f = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$f = "{newName} was successfully updated";
var updateFactorSuccess$f = "{factorName} is your new default security factor";
var updatePassword$f = "Update Password";
var updateUserProfileFailure$f = "Profile Update Failed";
var updateUserProfilePhotoFailure$f = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$f = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$f = "You have successfully updated your profile.";
var upper$f = "1 Uppercase";
var usedFor$f = "Used For";
var usedForApp$f = "This factor is used for app.";
var usedForLogin$f = "This factor is used for login.";
var usedForPasswordReset$f = "This factor is used for password reset.";
var version$f = "Version: {versionString}";
var yourBrowser$f = "Your browser: {browser}";
var it = {
	"26286820": "Inserisci il codice di referenza e due codici di sicurezza consecutivi dell'Accesso VIP Symantec.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Inserisci il codice ricevuto tramite SMS.",
	"374233718": "Puoi ritentare fra {secLeft, number} {secLeft, plural, one {second} altri {seconds}}",
	"437305782": "Sta verificando i tuoi autenticatori WebAuthn.",
	"505702857": "Link Magico",
	"519412053": "Cambia Fattore di Autenticazione",
	"655462232": "Scarica e Installa OneLogin Protect sul tuo dispositivo",
	"660592555": "Va bene",
	"662924178": "Sembra che oggi non sia la nostra giornata.",
	"694278426": "Inserisci il codice del {deviceName}",
	"694920552": "Primo Codice di Sicurezza",
	"737192390": "Apri {appName}",
	"740457555": "Secondo Codice",
	"744377571": "Almeno {length} caratteri",
	"751710530": "Invia",
	"916760408": "Inserisci un nome utente e un codice di sicurezza dal tuo dispositivo.",
	"921093870": "Non hai ricevuto il codice?",
	"966052509": "Nessun risultato",
	"987359842": "Per favore, clicca sul link che trovi nella tua mail per continuare",
	"1068496829": "Scegli una Domanda di Sicurezza {current}/{total}",
	"1079852660": "Inserisci due Codici di Sicurezza consecutivi",
	"1080736814": "Inserisci {fieldName} dall'app di Accesso Symantec VIP",
	"1136625613": "L'operazione è stata annullata. Ritenta o utilizza un altro fattore di autenticazione.",
	"1212847248": "Un codice di conferma è stato inviato al tuo indirizzo configurato.",
	"1232460711": "Inserisci la tua email",
	"1242107845": "Mostra",
	"1254879564": "Nuova Password",
	"1359200231": "Invia",
	"1433651550": "Inserisci il codice dell'SMS OneLogin .",
	"1477893598": "Configura",
	"1536965459": "Scarica e Installa OneLogin Protect sul tuo dispositivo",
	"1624184662": "Per impostare OneLogin SMS ti invieremo un codice di attivazione tramite SMS. Questo codice di attivazione ti servirà per completare la registrazione del dispositivo.",
	"1654624862": "Codice di Sicurezza",
	"1833121415": "Fornisci una Risposta {current}/{total}",
	"1919587067": "Invia nuovamente il Codice",
	"1935535842": "Richiesto",
	"1963245695": "1 Maiuscola",
	"2018264248": "Ritenta",
	"2091874550": "Primo Codice",
	"2097632732": "Opta per la scansione del codice a barre",
	"2104438124": "Inserisci {fieldName} e due Codici di Sicurezza consecutivi dall'Accesso Symantec VIP.",
	"2124363772": "Inserisci il tuo nome utente e il tuo codice di sicurezza dal tuo voucher SecurID.",
	"2229754167": "Inserisci il tuo numero di telefono",
	"2244720377": "Sembra essersi verificato un errore imprevisto.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Ti è stata inviata una mail con un link di accesso",
	"2600324508": "Nascondi",
	"2606375562": "Inserisci la tua YubiKey nella porta USB e premi il tasto",
	"2663586870": "Nome Utente",
	"2758306961": "Codice di referenza",
	"2792137744": "1 numero",
	"2815222727": "Scansiona questo codice a barre",
	"2828880379": "Conferma",
	"2859281487": "Si richiede un'autenticazione a 2 fattori per mettere il tuo account in sicurezza.",
	"2942752129": "Secondo Codice di Sicurezza",
	"3060896801": "Stai avendo problemi?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 carattere speciale",
	"3294346597": "Riprova",
	"3327626662": "Inserisci il tuo codice di conferma",
	"3374226769": "Clicca Paio usando l'inserimento manuale",
	"3469481929": "Non riesci a scansionare il codice?",
	"3499598078": "Apri menu",
	"3528672691": "Annulla",
	"3640052215": "Continua",
	"3645029425": "Scansiona il Codice QR in basso",
	"3645116517": "Inserisci questo codice quando ricevi la chiamata:",
	"3663548834": "Stiamo esaminando il problema e contiamo in un tempestivo ritorno. Attendi qualche minuto<br /> e aggiorna il tuo browser, oppure visita la nostra <a href='https://www.onelogin.com/status'>Status Page</a>.",
	"3669652728": "È stato inviato un link di accesso a",
	"3673120330": "Prossimo",
	"3737470122": "Contatta l'amministratore per ulteriori informazioni.",
	"3781468762": "Il tuo browser non supporta WebAuthn",
	"3827227259": "È stato inviato un codice di conferma a",
	"3855542277": "Inserisci questo codice nell'app",
	"3865193889": "Attiva",
	"3877285238": "1 minuscola",
	"4000449233": "Sta chiamando il numero di telefono qui sotto:",
	"4072532148": "Invia nuovamente il codice SMS",
	"4151518079": "Scegli Domanda di Sicurezza {current} / {total}",
	"4152906165": "Stiamo esaminando il problema e prevediamo di risolverlo presto. Attendi qualche minuto{break}e aggiorna il tuo browser oppure visita la nostra <link> Pagina di stato </link>.",
	"4227081527": "Una volta installata l'app, ritorna su questa schermata e clicca {action}",
	"4281662478": "Cerca",
	addApp: addApp$f,
	addFactor: addFactor$f,
	additionalQuestions: additionalQuestions$f,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$f,
	addNewSecurityQuestion: addNewSecurityQuestion$f,
	administration: administration$f,
	alert: alert$f,
	all: all$f,
	app: app$f,
	appDevice: appDevice$f,
	appDevices: appDevices$f,
	appFactor: appFactor$f,
	application: application$f,
	appName: appName$f,
	appPortal: appPortal$f,
	assumedUserNotification: assumedUserNotification$f,
	broswerExtension: broswerExtension$f,
	browser: browser$f,
	browserDeleteFailure: browserDeleteFailure$f,
	browserDeleteSuccess: browserDeleteSuccess$f,
	browserDevice: browserDevice$f,
	browserFetchFailure: browserFetchFailure$f,
	calling: calling$f,
	callUserAgain: callUserAgain$f,
	cancel: cancel$f,
	changePassword: changePassword$f,
	changeSecurityFactor: changeSecurityFactor$f,
	clearIcon: clearIcon$f,
	close: close$f,
	closeDialog: closeDialog$f,
	codeResent: codeResent$f,
	companyLogo: companyLogo$f,
	companyTab: companyTab$f,
	conditionalRequirement: conditionalRequirement$f,
	configuredOn: configuredOn$f,
	confirm: confirm$f,
	contactAdminEmailOtp: contactAdminEmailOtp$f,
	contactAdminForSMS: contactAdminForSMS$f,
	contactAdminForVoice: contactAdminForVoice$f,
	contactAdminPasswordReset: contactAdminPasswordReset$f,
	credentialId: credentialId$f,
	current: current$f,
	currentPassword: currentPassword$f,
	deleteDeviceSuccess: deleteDeviceSuccess$f,
	deleteQuestion: deleteQuestion$f,
	details: details$f,
	device: device$f,
	deviceDeleteFailure: deviceDeleteFailure$f,
	deviceFetchFailure: deviceFetchFailure$f,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$f,
	deviceRenameFailure: deviceRenameFailure$f,
	downloadOnAppStore: downloadOnAppStore$f,
	editDeviceName: editDeviceName$f,
	editSQinfo: editSQinfo$f,
	enrollNewFactor: enrollNewFactor$f,
	event: event$f,
	eventType: eventType$f,
	eventUserAgent: eventUserAgent$f,
	eventUseragent: eventUseragent$f,
	eventUUID: eventUUID$f,
	eventUuid: eventUuid$f,
	expirationDays: expirationDays$f,
	expireDate: expireDate$f,
	expires: expires$f,
	extensionVersionInstalled: extensionVersionInstalled$f,
	factor: factor$f,
	factorFetchFailure: factorFetchFailure$f,
	factorMfaTokenFailure: factorMfaTokenFailure$f,
	factorPrimaryFailure: factorPrimaryFailure$f,
	factors: factors$f,
	factorsFetchFailure: factorsFetchFailure$f,
	failedToFetchUserInfo: failedToFetchUserInfo$f,
	failedToRegisterAnswers: failedToRegisterAnswers$f,
	failedToRetrieveQuestions: failedToRetrieveQuestions$f,
	forcedLogout: forcedLogout$f,
	getOnGooglePlay: getOnGooglePlay$f,
	goToExternalSite: goToExternalSite$f,
	helpRequestFailed: helpRequestFailed$f,
	helpRequestSuccessful: helpRequestSuccessful$f,
	hostname: hostname$f,
	icon: icon$f,
	identifier: identifier$f,
	imageUpload: imageUpload$f,
	inactive: inactive$f,
	inactiveDevice: inactiveDevice$f,
	install: install$f,
	invalidCode: invalidCode$f,
	invalidPhoneNumber: invalidPhoneNumber$f,
	language: language$f,
	languageConfirmation: languageConfirmation$f,
	lastAuthentication: lastAuthentication$f,
	lastChanged: lastChanged$f,
	lastUsed: lastUsed$f,
	length: length$f,
	letter: letter$f,
	linkToAppStore: linkToAppStore$f,
	linkToGooglePlay: linkToGooglePlay$f,
	loadingRecentActivity: loadingRecentActivity$f,
	loadingTrustedBrowsers: loadingTrustedBrowsers$f,
	location: location$f,
	locationTime: locationTime$f,
	loggedOut: loggedOut$f,
	login: login$f,
	loginDevice: loginDevice$f,
	loginEvent: loginEvent$f,
	loginFactor: loginFactor$f,
	loginFailedEvent: loginFailedEvent$f,
	loginName: loginName$f,
	logOut: logOut$f,
	lower: lower$f,
	message: message$f,
	mfaRegistrationFailure: mfaRegistrationFailure$f,
	mfaRegistrationSuccess: mfaRegistrationSuccess$f,
	more: more$f,
	never: never$f,
	newPassword: newPassword$f,
	newPrimaryFactor: newPrimaryFactor$f,
	noActivities: noActivities$f,
	noDevicesConfigured: noDevicesConfigured$f,
	noExpiration: noExpiration$f,
	noMoreSecurityFactors: noMoreSecurityFactors$f,
	notifyErrorLoadingUser: notifyErrorLoadingUser$f,
	notifySuccessAddApp: notifySuccessAddApp$f,
	noTrustedBrowsers: noTrustedBrowsers$f,
	numbers: numbers$f,
	oneloginDesktop: oneloginDesktop$f,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$f,
	oneloginLogo: oneloginLogo$f,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$f,
	otp1: otp1$f,
	otp2: otp2$f,
	otpDevice: otpDevice$f,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$f,
	password: password$f,
	passwordChanged: passwordChanged$f,
	passwordChangedDays: passwordChangedDays$f,
	passwordHint: passwordHint$f,
	passwordRedirectDescription: passwordRedirectDescription$f,
	passwordReset: passwordReset$f,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$f,
	passwordUpdateFailure: passwordUpdateFailure$f,
	phoneNumber: phoneNumber$f,
	prefix: prefix$f,
	previousDeviceName: previousDeviceName$f,
	primary: primary$f,
	proceedAnyway: proceedAnyway$f,
	profile: profile$f,
	profileAvatar: profileAvatar$f,
	profileMenuToggle: profileMenuToggle$f,
	profilePhoto: profilePhoto$f,
	profilePhotoAction: profilePhotoAction$f,
	pwResetDevice: pwResetDevice$f,
	pwResetFactor: pwResetFactor$f,
	questionNumber: questionNumber$f,
	radiusAuthentication: radiusAuthentication$f,
	recentActivity: recentActivity$f,
	redirectToChangePassword: redirectToChangePassword$f,
	registerSecurityQuestions: registerSecurityQuestions$f,
	registrationRejected: registrationRejected$f,
	registrationTimedout: registrationTimedout$f,
	remove: remove$f,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$f,
	removedProfilePictureSuccess: removedProfilePictureSuccess$f,
	removeFactorWarning: removeFactorWarning$f,
	removeImage: removeImage$f,
	report: report$f,
	reportActivity: reportActivity$f,
	requestField: requestField$f,
	requiredQuestions: requiredQuestions$f,
	revert: revert$f,
	revertToAdmin: revertToAdmin$f,
	revertToSuperadmin: revertToSuperadmin$f,
	revoke: revoke$f,
	save: save$f,
	searchIcon: searchIcon$f,
	secureNotes: secureNotes$f,
	securityFactorAdded: securityFactorAdded$f,
	securityFactorRemoved: securityFactorRemoved$f,
	securityFactorRenamed: securityFactorRenamed$f,
	securityFactors: securityFactors$f,
	securityFactorsDescription: securityFactorsDescription$f,
	securityFactorsUpdated: securityFactorsUpdated$f,
	selectNewImage: selectNewImage$f,
	selectNewPrimary: selectNewPrimary$f,
	selectSecurityFactor: selectSecurityFactor$f,
	sending: sending$f,
	setPrimaryDevice: setPrimaryDevice$f,
	showDetails: showDetails$f,
	specials: specials$f,
	sqDropdownAriaLabel: sqDropdownAriaLabel$f,
	sqInfoHeader: sqInfoHeader$f,
	sqTipBlankAnswers: sqTipBlankAnswers$f,
	sqTipDoNotShare: sqTipDoNotShare$f,
	sqTipMinimum: sqTipMinimum$f,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$f,
	sqTipNoUsePassword: sqTipNoUsePassword$f,
	sqTipSameAnswer: sqTipSameAnswer$f,
	sqTipSpecialChars: sqTipSpecialChars$f,
	submit: submit$f,
	submitting: submitting$f,
	support: support$f,
	supportDefaultDescription: supportDefaultDescription$f,
	supportedBrowsers: supportedBrowsers$f,
	supportRequestHeader: supportRequestHeader$f,
	"switch": "Switch",
	time: time$f,
	trustDevice: trustDevice$f,
	trusted: trusted$f,
	trustedBrowsers: trustedBrowsers$f,
	trustedBrowsersDescription: trustedBrowsersDescription$f,
	trustedDevice: trustedDevice$f,
	unavailable: unavailable$f,
	unavailableTime: unavailableTime$f,
	unsetFactorSuccess: unsetFactorSuccess$f,
	unsetPrimaryDevice: unsetPrimaryDevice$f,
	unsupportedBrowser: unsupportedBrowser$f,
	unsupportedBrowserHeading: unsupportedBrowserHeading$f,
	updateDeviceNameSuccess: updateDeviceNameSuccess$f,
	updateFactorSuccess: updateFactorSuccess$f,
	updatePassword: updatePassword$f,
	updateUserProfileFailure: updateUserProfileFailure$f,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$f,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$f,
	updateUserProfileSuccess: updateUserProfileSuccess$f,
	upper: upper$f,
	usedFor: usedFor$f,
	usedForApp: usedForApp$f,
	usedForLogin: usedForLogin$f,
	usedForPasswordReset: usedForPasswordReset$f,
	version: version$f,
	yourBrowser: yourBrowser$f
};

var addApp$e = "Show {addApp} button when I log in to new websites.";
var addFactor$e = "Add Factor";
var additionalQuestions$e = "Additional Questions";
var addNewPrimaryBeforeRemove$e = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$e = "Add New Security Question";
var administration$e = "Administration";
var alert$e = "Alert";
var all$e = "all";
var app$e = "App";
var appDevice$e = "このファクターはアプリに使用されます。";
var appDevices$e = "この要因はアプリに使用されます";
var appFactor$e = "このファクターはアプリに使用されます。";
var application$e = "Application";
var appName$e = "App Name";
var appPortal$e = "App Portal";
var assumedUserNotification$e = "You cannot edit personal information while assuming a user.";
var broswerExtension$e = "Browser Extension";
var browser$e = "Browser";
var browserDeleteFailure$e = "Failed to delete trusted browser";
var browserDeleteSuccess$e = "Trusted browser was successfully deleted";
var browserDevice$e = "Browser/Device";
var browserFetchFailure$e = "Failed to fetch browsers";
var calling$e = "呼び出し中";
var callUserAgain$e = "Calling you again";
var cancel$e = "キャンセル";
var changePassword$e = "Change Password";
var changeSecurityFactor$e = "Change Security Factor";
var clearIcon$e = "消去アイコン";
var close$e = "Close";
var closeDialog$e = "ダイアログを閉じる";
var codeResent$e = "Code has been sent to your phone.";
var companyLogo$e = "会社のロゴ";
var companyTab$e = "Default for company tab";
var conditionalRequirement$e = "At least {number} of the following requirements:";
var configuredOn$e = "Configured On";
var confirm$e = "確認";
var contactAdminEmailOtp$e = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$e = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$e = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$e = "Contact your admin to reset password.";
var credentialId$e = "Credential ID";
var current$e = "Current";
var currentPassword$e = "Current password";
var deleteDeviceSuccess$e = "{factorName} was successfully deleted";
var deleteQuestion$e = "Delete question {position}";
var details$e = "Details";
var device$e = "Device";
var deviceDeleteFailure$e = "Failed to remove {factorName}";
var deviceFetchFailure$e = "Failed to fetch devices";
var deviceNameCannotBeBlank$e = "Authentication device name cannot be blank.";
var deviceRenameFailure$e = "Failed to update device name";
var downloadOnAppStore$e = "app storeでダウンロード";
var editDeviceName$e = "Edit name";
var editSQinfo$e = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$e = "Enroll new primary factor";
var event$e = "Event";
var eventType$e = "Event Type";
var eventUserAgent$e = "Event Useragent";
var eventUseragent$e = "Event Useragent";
var eventUUID$e = "Event UUID";
var eventUuid$e = "Event UUID";
var expirationDays$e = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$e = "Expire Date";
var expires$e = "Expires";
var extensionVersionInstalled$e = "Version {versionString} installed";
var factor$e = "Factor";
var factorFetchFailure$e = "Failed to fetch available factors";
var factorMfaTokenFailure$e = "Failed to fetch mfa token";
var factorPrimaryFailure$e = "Failed to set {factorName} as your primary factor";
var factors$e = "factors";
var factorsFetchFailure$e = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$e = "We couldn’t load your user information.";
var failedToRegisterAnswers$e = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$e = "We couldn't retrieve your security questions at this time.";
var forcedLogout$e = "Forced Logout";
var getOnGooglePlay$e = "Google Playで入手";
var goToExternalSite$e = "Go to external site";
var helpRequestFailed$e = "We couldn't submit your help request.";
var helpRequestSuccessful$e = "Your support request has been sent to your OneLogin Admin.";
var hostname$e = "Hostname & OS";
var icon$e = "Icon";
var identifier$e = "Credential ID / Identifier";
var imageUpload$e = "Image Upload";
var inactive$e = "Inactive";
var inactiveDevice$e = "Inactive device";
var install$e = "Install";
var invalidCode$e = "Invalid code";
var invalidPhoneNumber$e = "Please use valid phone number.";
var language$e = "Language";
var languageConfirmation$e = "Are you sure you want to switch to {language}?";
var lastAuthentication$e = "Last Authentication";
var lastChanged$e = "Last changed";
var lastUsed$e = "Last Used";
var length$e = "Minimum {length} characters";
var letter$e = "1 Letter";
var linkToAppStore$e = "App Storeへのリンク";
var linkToGooglePlay$e = "Google Playへのリンク";
var loadingRecentActivity$e = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$e = "Loading trusted browsers, please wait...";
var location$e = "Location";
var locationTime$e = "Location/Time";
var loggedOut$e = "Logged Out";
var login$e = "login";
var loginDevice$e = "Login device";
var loginEvent$e = "Login";
var loginFactor$e = "このファクターはログインのために使用されます。";
var loginFailedEvent$e = "Login Failed";
var loginName$e = "Login Name";
var logOut$e = "Log Out";
var lower$e = "1 Lowercase";
var message$e = "{name} was successfully added.";
var mfaRegistrationFailure$e = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$e = "You successfully registered the device";
var more$e = "More";
var never$e = "Never";
var newPassword$e = "New password";
var newPrimaryFactor$e = "New primary factor";
var noActivities$e = "No activities have been made";
var noDevicesConfigured$e = "No devices have been configured";
var noExpiration$e = "Never expires";
var noMoreSecurityFactors$e = "There are no security factors available for registration.";
var notifyErrorLoadingUser$e = "Loading of user failed. Try again later";
var notifySuccessAddApp$e = "{name} was successfully added.";
var noTrustedBrowsers$e = "No browsers have been saved";
var numbers$e = "1 Number";
var oneloginDesktop$e = "OneLogin Desktop";
var oneloginDesktopFetchFailure$e = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$e = "OneLogin logo";
var onlyDesktopBrowsersSupported$e = "We currently only support browser extensions on desktop browsers.";
var otp1$e = "OTP 1";
var otp2$e = "OTP 2";
var otpDevice$e = "この要因はログインに使用されます。";
var parsingUserProfilePhotoFailure$e = "Getting image details failed";
var password$e = "password";
var passwordChanged$e = "Password Changed";
var passwordChangedDays$e = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$e = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$e = "Your administrator has configured an external site for resetting your password.";
var passwordReset$e = "Password Reset";
var passwordUpdatedSuccessfully$e = "You have successfully updated your password.";
var passwordUpdateFailure$e = "Password update failed";
var phoneNumber$e = "Phone number";
var prefix$e = "Suspicious login report";
var previousDeviceName$e = "Previously {previousName}";
var primary$e = "Primary";
var proceedAnyway$e = "Proceed anyway";
var profile$e = "Profile";
var profileAvatar$e = "Profile avatar";
var profileMenuToggle$e = "Open profile menu";
var profilePhoto$e = "Profile photo";
var profilePhotoAction$e = "Profile image action";
var pwResetDevice$e = "この要因はパスワードのリセットに使用されます。";
var pwResetFactor$e = "このファクターはパスワードリセットのために使用されます。";
var questionNumber$e = "Question {position}";
var radiusAuthentication$e = "Service Login via Radius";
var recentActivity$e = "Recent Activity";
var redirectToChangePassword$e = "Redirect to change your password?";
var registerSecurityQuestions$e = "Register Security Questions";
var registrationRejected$e = "Registration unsuccessful, please try again.";
var registrationTimedout$e = "Registration context timed out";
var remove$e = "Remove";
var removeCurrentBrowserWarning$e = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$e = "You have successfully removed your profile picture.";
var removeFactorWarning$e = "Are you sure you want to remove {factor}?";
var removeImage$e = "Remove image";
var report$e = "Report";
var reportActivity$e = "Report Activity";
var requestField$e = "Describe the issue you're having";
var requiredQuestions$e = "Required Questions";
var revert$e = "戻る";
var revertToAdmin$e = "Revert to Admin";
var revertToSuperadmin$e = "Revert to OneLogin Admin";
var revoke$e = "Revoke";
var save$e = "Save Changes";
var searchIcon$e = "検索アイコン";
var secureNotes$e = "Secure Notes";
var securityFactorAdded$e = "Security Factor Added";
var securityFactorRemoved$e = "Security Factor Removed";
var securityFactorRenamed$e = "Security Factor Renamed";
var securityFactors$e = "Security Factors";
var securityFactorsDescription$e = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$e = "Security Factors Updated";
var selectNewImage$e = "Select new image";
var selectNewPrimary$e = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$e = "Select Security Factor";
var sending$e = "送信中";
var setPrimaryDevice$e = "Set as primary";
var showDetails$e = "詳細を表示";
var specials$e = "1 Special character";
var sqDropdownAriaLabel$e = "Question {position} dropdown";
var sqInfoHeader$e = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$e = "Blank answers will not be accepted";
var sqTipDoNotShare$e = "Do not share your questions and answers with anyone.";
var sqTipMinimum$e = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$e = "Answers are not case-sensitive.";
var sqTipNoUsePassword$e = "Do not use a password as an answer.";
var sqTipSameAnswer$e = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$e = "Special characters such as @#&*. will be ignored";
var submit$e = "Submit";
var submitting$e = "Submitting…";
var support$e = "Support";
var supportDefaultDescription$e = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$e = "Supported browsers: {browsers}";
var supportRequestHeader$e = "Support Request";
var time$e = "Time";
var trustDevice$e = "Trust Device";
var trusted$e = "Trusted";
var trustedBrowsers$e = "Trusted Browsers";
var trustedBrowsersDescription$e = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$e = "Trusted Device";
var unavailable$e = "Unavailable";
var unavailableTime$e = "Unavailable";
var unsetFactorSuccess$e = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$e = "Unset as primary";
var unsupportedBrowser$e = "Unsupported Browser";
var unsupportedBrowserHeading$e = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$e = "{newName} was successfully updated";
var updateFactorSuccess$e = "{factorName} is your new default security factor";
var updatePassword$e = "Update Password";
var updateUserProfileFailure$e = "Profile Update Failed";
var updateUserProfilePhotoFailure$e = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$e = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$e = "You have successfully updated your profile.";
var upper$e = "1 Uppercase";
var usedFor$e = "Used For";
var usedForApp$e = "This factor is used for app.";
var usedForLogin$e = "This factor is used for login.";
var usedForPasswordReset$e = "This factor is used for password reset.";
var version$e = "Version: {versionString}";
var yourBrowser$e = "Your browser: {browser}";
var ja = {
	"26286820": "認証IDとSymantec VIP Accessの2つの連続するセキュリティコードを入力して下さい。",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "SMSに届いたコードを入力して下さい",
	"374233718": "{secLeft, number} {secLeft, plural, one {second} other {seconds}}で再試行できます",
	"437305782": "WebAuthn認証コードを確認しています。",
	"505702857": "マジックリンク",
	"519412053": "認証要素の変更",
	"655462232": "OneLogin Protectをあなたのデバイスに、ダウンロードしてインストールしましょう",
	"660592555": "OK",
	"662924178": "何か問題が発生しているようです。",
	"694278426": "{deviceName}コードを入力してください",
	"694920552": "最初のセキュリティーコード",
	"737192390": "{appName}を開く",
	"740457555": "セカンドコード",
	"744377571": "最低 {length} 文字",
	"751710530": "提出",
	"916760408": "あなたのデバイスから、ユーザーネームとセキュリティーコードを入力してください",
	"921093870": "コードが届いていませんか？",
	"966052509": "結果がありません",
	"987359842": "メール内のリンクをクリックして続行してください",
	"1068496829": "セキュリティーの質問を選択{current}/{total}",
	"1079852660": "2つの連続するセキュリティーコードを入力してください",
	"1080736814": "Symantec VIP Accessアプリから、 {fieldName}を入力してください",
	"1136625613": "このプロセスはキャンセルされました。再試行するか、別の認証要素を使用してください。",
	"1212847248": "確認コードをご設定のメールアドレスに送信いたしました。",
	"1232460711": "あなたのメールアドレスを入力してください",
	"1242107845": "表示",
	"1254879564": "新しいパスワード",
	"1359200231": "送信",
	"1433651550": "OneLogin SMSからコードを入力してください。",
	"1477893598": "設定",
	"1536965459": "あなたのデバイスに、OneLogin Protectをダウンロードしてインストールしてください",
	"1624184662": "OneLogin SMSを設定するために、SMSでアクティベーションコードを送信します。 デバイスの登録を完了するには、このアクティベーションコードが必要です。",
	"1654624862": "セキュリティーコード",
	"1833121415": "答えを入力 {current}/{total}",
	"1919587067": "コードを再送信",
	"1935535842": "必要な",
	"1963245695": "大文字1つ",
	"2018264248": "再試行する",
	"2091874550": "最初のコード",
	"2097632732": "代わりにバーコードをスキャン",
	"2104438124": "Symantec VIP Accessから、{fieldName}と、2つの連続するセキュリティコードを入力してください。",
	"2124363772": "SecurIDトークンから、ユーザーネームとセキュリティーコードを入力してください",
	"2229754167": "電話番号を入力してください",
	"2244720377": "予期しないエラーが起こったようです。",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "メールでアクセスリンクを送信しました",
	"2600324508": "隠す",
	"2606375562": "USBポートにYubiKeyを挿入し、ボタンを押してください",
	"2663586870": "ユーザーネーム",
	"2758306961": "認証ID",
	"2792137744": "数字1つ",
	"2815222727": "このバーコードをスキャン",
	"2828880379": "確認",
	"2859281487": "アカウントを保護するために、2要素認証が必要です。",
	"2942752129": "2つ目のセキュリティーコード",
	"3060896801": "問題が生じていますか？",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "特殊文字1つ",
	"3294346597": "もう一度試す",
	"3327626662": "確認コードを入力してください",
	"3374226769": "マニュアル入力で「ペアリング」をクリック",
	"3469481929": "コードがスキャンできませんか？",
	"3499598078": "メニューを開く",
	"3528672691": "キャンセル",
	"3640052215": "続行",
	"3645029425": "下のQRコードをスキャン",
	"3645116517": "着信時に次のコードを入力してください：",
	"3663548834": "ただいま問題を調査しておりますが、間もなく復旧する予定です。数分間お待ちになって<br />からブラウザーを再度読み込むか、<a href='https://www.onelogin.com/status'>ステータスページ</a>にアクセスしてください。",
	"3669652728": "アクセスリンクを次のアドレスに送信しました：",
	"3673120330": "次",
	"3737470122": "詳細については、管理者にお問い合わせください。",
	"3781468762": "お使いのブラウザはWebAuthnをサポートしていません",
	"3827227259": "確認コードの送信先",
	"3855542277": "アプリにこのコードを入力してください",
	"3865193889": "アクティブにする",
	"3877285238": "小文字1つ",
	"4000449233": "下記の電話番号に電話しています：",
	"4072532148": "SMSコードを再送信",
	"4151518079": "セキュリティーの質問を選択{current} / {total}",
	"4152906165": "現在、問題を調査しており、まもなく復旧する見込みです。数分間待ってからブラウザを再読み込みするか、<link>ステータスページ</link>をご確認ください。",
	"4227081527": "アプリがインストールされたら、この画面に戻り、{action}をクリックしてください。",
	"4281662478": "検索",
	addApp: addApp$e,
	addFactor: addFactor$e,
	additionalQuestions: additionalQuestions$e,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$e,
	addNewSecurityQuestion: addNewSecurityQuestion$e,
	administration: administration$e,
	alert: alert$e,
	all: all$e,
	app: app$e,
	appDevice: appDevice$e,
	appDevices: appDevices$e,
	appFactor: appFactor$e,
	application: application$e,
	appName: appName$e,
	appPortal: appPortal$e,
	assumedUserNotification: assumedUserNotification$e,
	broswerExtension: broswerExtension$e,
	browser: browser$e,
	browserDeleteFailure: browserDeleteFailure$e,
	browserDeleteSuccess: browserDeleteSuccess$e,
	browserDevice: browserDevice$e,
	browserFetchFailure: browserFetchFailure$e,
	calling: calling$e,
	callUserAgain: callUserAgain$e,
	cancel: cancel$e,
	changePassword: changePassword$e,
	changeSecurityFactor: changeSecurityFactor$e,
	clearIcon: clearIcon$e,
	close: close$e,
	closeDialog: closeDialog$e,
	codeResent: codeResent$e,
	companyLogo: companyLogo$e,
	companyTab: companyTab$e,
	conditionalRequirement: conditionalRequirement$e,
	configuredOn: configuredOn$e,
	confirm: confirm$e,
	contactAdminEmailOtp: contactAdminEmailOtp$e,
	contactAdminForSMS: contactAdminForSMS$e,
	contactAdminForVoice: contactAdminForVoice$e,
	contactAdminPasswordReset: contactAdminPasswordReset$e,
	credentialId: credentialId$e,
	current: current$e,
	currentPassword: currentPassword$e,
	deleteDeviceSuccess: deleteDeviceSuccess$e,
	deleteQuestion: deleteQuestion$e,
	details: details$e,
	device: device$e,
	deviceDeleteFailure: deviceDeleteFailure$e,
	deviceFetchFailure: deviceFetchFailure$e,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$e,
	deviceRenameFailure: deviceRenameFailure$e,
	downloadOnAppStore: downloadOnAppStore$e,
	editDeviceName: editDeviceName$e,
	editSQinfo: editSQinfo$e,
	enrollNewFactor: enrollNewFactor$e,
	event: event$e,
	eventType: eventType$e,
	eventUserAgent: eventUserAgent$e,
	eventUseragent: eventUseragent$e,
	eventUUID: eventUUID$e,
	eventUuid: eventUuid$e,
	expirationDays: expirationDays$e,
	expireDate: expireDate$e,
	expires: expires$e,
	extensionVersionInstalled: extensionVersionInstalled$e,
	factor: factor$e,
	factorFetchFailure: factorFetchFailure$e,
	factorMfaTokenFailure: factorMfaTokenFailure$e,
	factorPrimaryFailure: factorPrimaryFailure$e,
	factors: factors$e,
	factorsFetchFailure: factorsFetchFailure$e,
	failedToFetchUserInfo: failedToFetchUserInfo$e,
	failedToRegisterAnswers: failedToRegisterAnswers$e,
	failedToRetrieveQuestions: failedToRetrieveQuestions$e,
	forcedLogout: forcedLogout$e,
	getOnGooglePlay: getOnGooglePlay$e,
	goToExternalSite: goToExternalSite$e,
	helpRequestFailed: helpRequestFailed$e,
	helpRequestSuccessful: helpRequestSuccessful$e,
	hostname: hostname$e,
	icon: icon$e,
	identifier: identifier$e,
	imageUpload: imageUpload$e,
	inactive: inactive$e,
	inactiveDevice: inactiveDevice$e,
	install: install$e,
	invalidCode: invalidCode$e,
	invalidPhoneNumber: invalidPhoneNumber$e,
	language: language$e,
	languageConfirmation: languageConfirmation$e,
	lastAuthentication: lastAuthentication$e,
	lastChanged: lastChanged$e,
	lastUsed: lastUsed$e,
	length: length$e,
	letter: letter$e,
	linkToAppStore: linkToAppStore$e,
	linkToGooglePlay: linkToGooglePlay$e,
	loadingRecentActivity: loadingRecentActivity$e,
	loadingTrustedBrowsers: loadingTrustedBrowsers$e,
	location: location$e,
	locationTime: locationTime$e,
	loggedOut: loggedOut$e,
	login: login$e,
	loginDevice: loginDevice$e,
	loginEvent: loginEvent$e,
	loginFactor: loginFactor$e,
	loginFailedEvent: loginFailedEvent$e,
	loginName: loginName$e,
	logOut: logOut$e,
	lower: lower$e,
	message: message$e,
	mfaRegistrationFailure: mfaRegistrationFailure$e,
	mfaRegistrationSuccess: mfaRegistrationSuccess$e,
	more: more$e,
	never: never$e,
	newPassword: newPassword$e,
	newPrimaryFactor: newPrimaryFactor$e,
	noActivities: noActivities$e,
	noDevicesConfigured: noDevicesConfigured$e,
	noExpiration: noExpiration$e,
	noMoreSecurityFactors: noMoreSecurityFactors$e,
	notifyErrorLoadingUser: notifyErrorLoadingUser$e,
	notifySuccessAddApp: notifySuccessAddApp$e,
	noTrustedBrowsers: noTrustedBrowsers$e,
	numbers: numbers$e,
	oneloginDesktop: oneloginDesktop$e,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$e,
	oneloginLogo: oneloginLogo$e,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$e,
	otp1: otp1$e,
	otp2: otp2$e,
	otpDevice: otpDevice$e,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$e,
	password: password$e,
	passwordChanged: passwordChanged$e,
	passwordChangedDays: passwordChangedDays$e,
	passwordHint: passwordHint$e,
	passwordRedirectDescription: passwordRedirectDescription$e,
	passwordReset: passwordReset$e,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$e,
	passwordUpdateFailure: passwordUpdateFailure$e,
	phoneNumber: phoneNumber$e,
	prefix: prefix$e,
	previousDeviceName: previousDeviceName$e,
	primary: primary$e,
	proceedAnyway: proceedAnyway$e,
	profile: profile$e,
	profileAvatar: profileAvatar$e,
	profileMenuToggle: profileMenuToggle$e,
	profilePhoto: profilePhoto$e,
	profilePhotoAction: profilePhotoAction$e,
	pwResetDevice: pwResetDevice$e,
	pwResetFactor: pwResetFactor$e,
	questionNumber: questionNumber$e,
	radiusAuthentication: radiusAuthentication$e,
	recentActivity: recentActivity$e,
	redirectToChangePassword: redirectToChangePassword$e,
	registerSecurityQuestions: registerSecurityQuestions$e,
	registrationRejected: registrationRejected$e,
	registrationTimedout: registrationTimedout$e,
	remove: remove$e,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$e,
	removedProfilePictureSuccess: removedProfilePictureSuccess$e,
	removeFactorWarning: removeFactorWarning$e,
	removeImage: removeImage$e,
	report: report$e,
	reportActivity: reportActivity$e,
	requestField: requestField$e,
	requiredQuestions: requiredQuestions$e,
	revert: revert$e,
	revertToAdmin: revertToAdmin$e,
	revertToSuperadmin: revertToSuperadmin$e,
	revoke: revoke$e,
	save: save$e,
	searchIcon: searchIcon$e,
	secureNotes: secureNotes$e,
	securityFactorAdded: securityFactorAdded$e,
	securityFactorRemoved: securityFactorRemoved$e,
	securityFactorRenamed: securityFactorRenamed$e,
	securityFactors: securityFactors$e,
	securityFactorsDescription: securityFactorsDescription$e,
	securityFactorsUpdated: securityFactorsUpdated$e,
	selectNewImage: selectNewImage$e,
	selectNewPrimary: selectNewPrimary$e,
	selectSecurityFactor: selectSecurityFactor$e,
	sending: sending$e,
	setPrimaryDevice: setPrimaryDevice$e,
	showDetails: showDetails$e,
	specials: specials$e,
	sqDropdownAriaLabel: sqDropdownAriaLabel$e,
	sqInfoHeader: sqInfoHeader$e,
	sqTipBlankAnswers: sqTipBlankAnswers$e,
	sqTipDoNotShare: sqTipDoNotShare$e,
	sqTipMinimum: sqTipMinimum$e,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$e,
	sqTipNoUsePassword: sqTipNoUsePassword$e,
	sqTipSameAnswer: sqTipSameAnswer$e,
	sqTipSpecialChars: sqTipSpecialChars$e,
	submit: submit$e,
	submitting: submitting$e,
	support: support$e,
	supportDefaultDescription: supportDefaultDescription$e,
	supportedBrowsers: supportedBrowsers$e,
	supportRequestHeader: supportRequestHeader$e,
	"switch": "Switch",
	time: time$e,
	trustDevice: trustDevice$e,
	trusted: trusted$e,
	trustedBrowsers: trustedBrowsers$e,
	trustedBrowsersDescription: trustedBrowsersDescription$e,
	trustedDevice: trustedDevice$e,
	unavailable: unavailable$e,
	unavailableTime: unavailableTime$e,
	unsetFactorSuccess: unsetFactorSuccess$e,
	unsetPrimaryDevice: unsetPrimaryDevice$e,
	unsupportedBrowser: unsupportedBrowser$e,
	unsupportedBrowserHeading: unsupportedBrowserHeading$e,
	updateDeviceNameSuccess: updateDeviceNameSuccess$e,
	updateFactorSuccess: updateFactorSuccess$e,
	updatePassword: updatePassword$e,
	updateUserProfileFailure: updateUserProfileFailure$e,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$e,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$e,
	updateUserProfileSuccess: updateUserProfileSuccess$e,
	upper: upper$e,
	usedFor: usedFor$e,
	usedForApp: usedForApp$e,
	usedForLogin: usedForLogin$e,
	usedForPasswordReset: usedForPasswordReset$e,
	version: version$e,
	yourBrowser: yourBrowser$e
};

var addApp$d = "Show {addApp} button when I log in to new websites.";
var addFactor$d = "Add Factor";
var additionalQuestions$d = "Additional Questions";
var addNewPrimaryBeforeRemove$d = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$d = "Add New Security Question";
var administration$d = "Administration";
var alert$d = "Alert";
var all$d = "all";
var app$d = "App";
var appDevice$d = "이 인자는 앱에 사용됩니다.";
var appDevices$d = "이 요소는 앱에 사용됩니다";
var appFactor$d = "이 인자는 앱에 사용됩니다.";
var application$d = "Application";
var appName$d = "App Name";
var appPortal$d = "App Portal";
var assumedUserNotification$d = "You cannot edit personal information while assuming a user.";
var broswerExtension$d = "Browser Extension";
var browser$d = "Browser";
var browserDeleteFailure$d = "Failed to delete trusted browser";
var browserDeleteSuccess$d = "Trusted browser was successfully deleted";
var browserDevice$d = "Browser/Device";
var browserFetchFailure$d = "Failed to fetch browsers";
var calling$d = "전화하기";
var callUserAgain$d = "Calling you again";
var cancel$d = "취소";
var changePassword$d = "Change Password";
var changeSecurityFactor$d = "Change Security Factor";
var clearIcon$d = "지우기 아이콘";
var close$d = "Close";
var closeDialog$d = "대화 닫기";
var codeResent$d = "Code has been sent to your phone.";
var companyLogo$d = "회사 로고";
var companyTab$d = "Default for company tab";
var conditionalRequirement$d = "At least {number} of the following requirements:";
var configuredOn$d = "Configured On";
var confirm$d = "확인";
var contactAdminEmailOtp$d = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$d = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$d = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$d = "Contact your admin to reset password.";
var credentialId$d = "Credential ID";
var current$d = "Current";
var currentPassword$d = "Current password";
var deleteDeviceSuccess$d = "{factorName} was successfully deleted";
var deleteQuestion$d = "Delete question {position}";
var details$d = "Details";
var device$d = "Device";
var deviceDeleteFailure$d = "Failed to remove {factorName}";
var deviceFetchFailure$d = "Failed to fetch devices";
var deviceNameCannotBeBlank$d = "Authentication device name cannot be blank.";
var deviceRenameFailure$d = "Failed to update device name";
var downloadOnAppStore$d = "앱 스토어에서 다운로드";
var editDeviceName$d = "Edit name";
var editSQinfo$d = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$d = "Enroll new primary factor";
var event$d = "Event";
var eventType$d = "Event Type";
var eventUserAgent$d = "Event Useragent";
var eventUseragent$d = "Event Useragent";
var eventUUID$d = "Event UUID";
var eventUuid$d = "Event UUID";
var expirationDays$d = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$d = "Expire Date";
var expires$d = "Expires";
var extensionVersionInstalled$d = "Version {versionString} installed";
var factor$d = "Factor";
var factorFetchFailure$d = "Failed to fetch available factors";
var factorMfaTokenFailure$d = "Failed to fetch mfa token";
var factorPrimaryFailure$d = "Failed to set {factorName} as your primary factor";
var factors$d = "factors";
var factorsFetchFailure$d = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$d = "We couldn’t load your user information.";
var failedToRegisterAnswers$d = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$d = "We couldn't retrieve your security questions at this time.";
var forcedLogout$d = "Forced Logout";
var getOnGooglePlay$d = "Google Play에서 받기";
var goToExternalSite$d = "Go to external site";
var helpRequestFailed$d = "We couldn't submit your help request.";
var helpRequestSuccessful$d = "Your support request has been sent to your OneLogin Admin.";
var hostname$d = "Hostname & OS";
var icon$d = "Icon";
var identifier$d = "Credential ID / Identifier";
var imageUpload$d = "Image Upload";
var inactive$d = "Inactive";
var inactiveDevice$d = "Inactive device";
var install$d = "Install";
var invalidCode$d = "Invalid code";
var invalidPhoneNumber$d = "Please use valid phone number.";
var language$d = "Language";
var languageConfirmation$d = "Are you sure you want to switch to {language}?";
var lastAuthentication$d = "Last Authentication";
var lastChanged$d = "Last changed";
var lastUsed$d = "Last Used";
var length$d = "Minimum {length} characters";
var letter$d = "1 Letter";
var linkToAppStore$d = "앱 스토어로 연결";
var linkToGooglePlay$d = "Google Play로 연결";
var loadingRecentActivity$d = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$d = "Loading trusted browsers, please wait...";
var location$d = "Location";
var locationTime$d = "Location/Time";
var loggedOut$d = "Logged Out";
var login$d = "login";
var loginDevice$d = "Login device";
var loginEvent$d = "Login";
var loginFactor$d = "이 인자는 로그인에 사용됩니다.";
var loginFailedEvent$d = "Login Failed";
var loginName$d = "Login Name";
var logOut$d = "Log Out";
var lower$d = "1 Lowercase";
var message$d = "{name} was successfully added.";
var mfaRegistrationFailure$d = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$d = "You successfully registered the device";
var more$d = "More";
var never$d = "Never";
var newPassword$d = "New password";
var newPrimaryFactor$d = "New primary factor";
var noActivities$d = "No activities have been made";
var noDevicesConfigured$d = "No devices have been configured";
var noExpiration$d = "Never expires";
var noMoreSecurityFactors$d = "There are no security factors available for registration.";
var notifyErrorLoadingUser$d = "Loading of user failed. Try again later";
var notifySuccessAddApp$d = "{name} was successfully added.";
var noTrustedBrowsers$d = "No browsers have been saved";
var numbers$d = "1 Number";
var oneloginDesktop$d = "OneLogin Desktop";
var oneloginDesktopFetchFailure$d = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$d = "OneLogin logo";
var onlyDesktopBrowsersSupported$d = "We currently only support browser extensions on desktop browsers.";
var otp1$d = "OTP 1";
var otp2$d = "OTP 2";
var otpDevice$d = "이 요소는 로그인에 사용됩니다.";
var parsingUserProfilePhotoFailure$d = "Getting image details failed";
var password$d = "password";
var passwordChanged$d = "Password Changed";
var passwordChangedDays$d = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$d = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$d = "Your administrator has configured an external site for resetting your password.";
var passwordReset$d = "Password Reset";
var passwordUpdatedSuccessfully$d = "You have successfully updated your password.";
var passwordUpdateFailure$d = "Password update failed";
var phoneNumber$d = "Phone number";
var prefix$d = "Suspicious login report";
var previousDeviceName$d = "Previously {previousName}";
var primary$d = "Primary";
var proceedAnyway$d = "Proceed anyway";
var profile$d = "Profile";
var profileAvatar$d = "Profile avatar";
var profileMenuToggle$d = "Open profile menu";
var profilePhoto$d = "Profile photo";
var profilePhotoAction$d = "Profile image action";
var pwResetDevice$d = "이 요소는 비밀번호 재설정에 사용됩니다";
var pwResetFactor$d = "이 인자는 비밀번호 재설정에 사용됩니다.";
var questionNumber$d = "Question {position}";
var radiusAuthentication$d = "Service Login via Radius";
var recentActivity$d = "Recent Activity";
var redirectToChangePassword$d = "Redirect to change your password?";
var registerSecurityQuestions$d = "Register Security Questions";
var registrationRejected$d = "Registration unsuccessful, please try again.";
var registrationTimedout$d = "Registration context timed out";
var remove$d = "Remove";
var removeCurrentBrowserWarning$d = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$d = "You have successfully removed your profile picture.";
var removeFactorWarning$d = "Are you sure you want to remove {factor}?";
var removeImage$d = "Remove image";
var report$d = "Report";
var reportActivity$d = "Report Activity";
var requestField$d = "Describe the issue you're having";
var requiredQuestions$d = "Required Questions";
var revert$d = "되돌아가기";
var revertToAdmin$d = "Revert to Admin";
var revertToSuperadmin$d = "Revert to OneLogin Admin";
var revoke$d = "Revoke";
var save$d = "Save Changes";
var searchIcon$d = "검색 아이콘";
var secureNotes$d = "Secure Notes";
var securityFactorAdded$d = "Security Factor Added";
var securityFactorRemoved$d = "Security Factor Removed";
var securityFactorRenamed$d = "Security Factor Renamed";
var securityFactors$d = "Security Factors";
var securityFactorsDescription$d = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$d = "Security Factors Updated";
var selectNewImage$d = "Select new image";
var selectNewPrimary$d = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$d = "Select Security Factor";
var sending$d = "전송 중";
var setPrimaryDevice$d = "Set as primary";
var showDetails$d = "세부정보 표시";
var specials$d = "1 Special character";
var sqDropdownAriaLabel$d = "Question {position} dropdown";
var sqInfoHeader$d = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$d = "Blank answers will not be accepted";
var sqTipDoNotShare$d = "Do not share your questions and answers with anyone.";
var sqTipMinimum$d = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$d = "Answers are not case-sensitive.";
var sqTipNoUsePassword$d = "Do not use a password as an answer.";
var sqTipSameAnswer$d = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$d = "Special characters such as @#&*. will be ignored";
var submit$d = "Submit";
var submitting$d = "Submitting…";
var support$d = "Support";
var supportDefaultDescription$d = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$d = "Supported browsers: {browsers}";
var supportRequestHeader$d = "Support Request";
var time$d = "Time";
var trustDevice$d = "Trust Device";
var trusted$d = "Trusted";
var trustedBrowsers$d = "Trusted Browsers";
var trustedBrowsersDescription$d = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$d = "Trusted Device";
var unavailable$d = "Unavailable";
var unavailableTime$d = "Unavailable";
var unsetFactorSuccess$d = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$d = "Unset as primary";
var unsupportedBrowser$d = "Unsupported Browser";
var unsupportedBrowserHeading$d = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$d = "{newName} was successfully updated";
var updateFactorSuccess$d = "{factorName} is your new default security factor";
var updatePassword$d = "Update Password";
var updateUserProfileFailure$d = "Profile Update Failed";
var updateUserProfilePhotoFailure$d = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$d = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$d = "You have successfully updated your profile.";
var upper$d = "1 Uppercase";
var usedFor$d = "Used For";
var usedForApp$d = "This factor is used for app.";
var usedForLogin$d = "This factor is used for login.";
var usedForPasswordReset$d = "This factor is used for password reset.";
var version$d = "Version: {versionString}";
var yourBrowser$d = "Your browser: {browser}";
var ko = {
	"26286820": "Symantec VIP Access에서 인증 정보 ID와 보안 코드 2개를 연속으로 입력하세요.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "SMS에서 받으신 코드를 입력하십시오.",
	"374233718": "{secLeft, number} {secLeft, plural, one {second} other {seconds}}에서 다시 시도할 수 있습니다",
	"437305782": "지금 WebAuthn 인증 부호 확인 중입니다.",
	"505702857": "매직 링크",
	"519412053": "인증 요인 변경",
	"655462232": "OneLogin Protect를 장치에 다운로드후 설치하십시오.",
	"660592555": "확인",
	"662924178": "오늘은 운좋은 날 같진 않군요.",
	"694278426": "{deviceName} 코드를 입력하세요",
	"694920552": "첫번째 보안 코드",
	"737192390": "열기 {appName}",
	"740457555": "두번째 코드",
	"744377571": "최소 {length} 글자",
	"751710530": "제출하기",
	"916760408": "사명자명과 장치에서 받은 보안 코드를 입력하십시오.",
	"921093870": "코드 못 받으셨나요?",
	"966052509": "결과 없음",
	"987359842": "계속하려면 이메일 내 링크를 클릭하세요",
	"1068496829": "보안 질문을 선택하세요 {current}/{total}",
	"1079852660": "두개의 연속된 보안 코드를 입력하세요",
	"1080736814": "Symantec VIP Access 앱에서 {fieldName} 를 입력하세요",
	"1136625613": "해당 과정이 취소되었습니다. 다시 시도하시거나 다른 인증 요소를 사용하세요.",
	"1212847248": "설정된 주소로 확인 코드가 전송되었습니다.",
	"1232460711": "이메일 입력",
	"1242107845": "보이기",
	"1254879564": "새로운 비밀번호",
	"1359200231": "보내기",
	"1433651550": "OneLogin SMS에서 받은 코드를 입력하세요.",
	"1477893598": "환경 설정",
	"1536965459": "OneLogin Protect를 장치에 다운로드하고 설치하기",
	"1624184662": "OneLogin SMS를 설정을 위해 SMS를 통해 활성화코드를 보내드립니다. 장치 등록을 완성하시려면 이 활성화 코드가 필요합니다.",
	"1654624862": "보안 코드",
	"1833121415": "답변 제공하기 {current}/{total}",
	"1919587067": "코드 다시 보내기",
	"1935535842": "필수",
	"1963245695": "1개의 대문자",
	"2018264248": "다시 시도하세요",
	"2091874550": "첫번째 코드",
	"2097632732": "대신 바코드 스캔하기",
	"2104438124": "{fieldName}와 Symantec VIP Access에 있는 두개의 연속 보안카드를 입력하십시오.",
	"2124363772": "사용자명과 SecurID 토큰에서의 보안 코드를 입력하십시오.",
	"2229754167": "전화번호를 입력하세요",
	"2244720377": "예상치 못한 오류가 발생한 것 같습니다.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "이메일로 액세스 링크가 전송되었습니다",
	"2600324508": "숨기기",
	"2606375562": "USB 포트에 YubiKey를 삽입하시고 버튼을 누르십시오",
	"2663586870": "사용자명",
	"2758306961": "인증 정보 ID",
	"2792137744": "1개의 숫자",
	"2815222727": "이 바코드를 스캔하기",
	"2828880379": "확인",
	"2859281487": "계정 보안을 위해 이중(2-factor) 인증이 필요합니다.",
	"2942752129": "두번째 보안 코드",
	"3060896801": "문제가 있으신가요?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1개의 특수문자",
	"3294346597": "다시 시도하세요",
	"3327626662": "확인 코드를 입력하세요",
	"3374226769": "수동 입력을 사용한 페어(Pair) 클릭하기",
	"3469481929": "코드 스캔이 안되세요?",
	"3499598078": "메뉴 열기",
	"3528672691": "취소하기",
	"3640052215": "계속하기",
	"3645029425": "아래의 QR 코드를 스캔하십시오",
	"3645116517": "해당 전화를 받을 때 이 코드를 입력하세요:",
	"3663548834": "문제를 조사 중이며, 곧 다시 복구될 예정입니다. 몇 분 정도 후에<br />브라우저를 새로고침 하거나 <a href='https://www.onelogin.com/status'>상태 페이지</a>를 방문하시기 바랍니다.",
	"3669652728": "다음 대상으로 액세스 링크가 전송되었습니다",
	"3673120330": "다음",
	"3737470122": "더 자세한 내용은 관리자에게 문의해 주세요.",
	"3781468762": "귀하의 브라우저가 WebAuthn을 지원하지 않습니다",
	"3827227259": "확인 코드를 다음으로 전송함:",
	"3855542277": "이 코드를 앱에 입력하기",
	"3865193889": "활성화히기",
	"3877285238": "1개의 소문자",
	"4000449233": "아래 전화번호로 전화하기:",
	"4072532148": "SMS 코드 다시 보내기",
	"4151518079": "보안 질문 {current} / {total} 선택하기",
	"4152906165": "저희가 해당 문제를 조사하고 있으니 곧 다시 연락드리겠습니다. 잠시 기다려 브라우저를 새로 고치거나 저희 <link>Status Page</link>를 방문해 주시기 바랍니다.",
	"4227081527": "앱이 설치되면 이 화면으로 돌아와 {action} 클릭하세요",
	"4281662478": "검색",
	addApp: addApp$d,
	addFactor: addFactor$d,
	additionalQuestions: additionalQuestions$d,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$d,
	addNewSecurityQuestion: addNewSecurityQuestion$d,
	administration: administration$d,
	alert: alert$d,
	all: all$d,
	app: app$d,
	appDevice: appDevice$d,
	appDevices: appDevices$d,
	appFactor: appFactor$d,
	application: application$d,
	appName: appName$d,
	appPortal: appPortal$d,
	assumedUserNotification: assumedUserNotification$d,
	broswerExtension: broswerExtension$d,
	browser: browser$d,
	browserDeleteFailure: browserDeleteFailure$d,
	browserDeleteSuccess: browserDeleteSuccess$d,
	browserDevice: browserDevice$d,
	browserFetchFailure: browserFetchFailure$d,
	calling: calling$d,
	callUserAgain: callUserAgain$d,
	cancel: cancel$d,
	changePassword: changePassword$d,
	changeSecurityFactor: changeSecurityFactor$d,
	clearIcon: clearIcon$d,
	close: close$d,
	closeDialog: closeDialog$d,
	codeResent: codeResent$d,
	companyLogo: companyLogo$d,
	companyTab: companyTab$d,
	conditionalRequirement: conditionalRequirement$d,
	configuredOn: configuredOn$d,
	confirm: confirm$d,
	contactAdminEmailOtp: contactAdminEmailOtp$d,
	contactAdminForSMS: contactAdminForSMS$d,
	contactAdminForVoice: contactAdminForVoice$d,
	contactAdminPasswordReset: contactAdminPasswordReset$d,
	credentialId: credentialId$d,
	current: current$d,
	currentPassword: currentPassword$d,
	deleteDeviceSuccess: deleteDeviceSuccess$d,
	deleteQuestion: deleteQuestion$d,
	details: details$d,
	device: device$d,
	deviceDeleteFailure: deviceDeleteFailure$d,
	deviceFetchFailure: deviceFetchFailure$d,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$d,
	deviceRenameFailure: deviceRenameFailure$d,
	downloadOnAppStore: downloadOnAppStore$d,
	editDeviceName: editDeviceName$d,
	editSQinfo: editSQinfo$d,
	enrollNewFactor: enrollNewFactor$d,
	event: event$d,
	eventType: eventType$d,
	eventUserAgent: eventUserAgent$d,
	eventUseragent: eventUseragent$d,
	eventUUID: eventUUID$d,
	eventUuid: eventUuid$d,
	expirationDays: expirationDays$d,
	expireDate: expireDate$d,
	expires: expires$d,
	extensionVersionInstalled: extensionVersionInstalled$d,
	factor: factor$d,
	factorFetchFailure: factorFetchFailure$d,
	factorMfaTokenFailure: factorMfaTokenFailure$d,
	factorPrimaryFailure: factorPrimaryFailure$d,
	factors: factors$d,
	factorsFetchFailure: factorsFetchFailure$d,
	failedToFetchUserInfo: failedToFetchUserInfo$d,
	failedToRegisterAnswers: failedToRegisterAnswers$d,
	failedToRetrieveQuestions: failedToRetrieveQuestions$d,
	forcedLogout: forcedLogout$d,
	getOnGooglePlay: getOnGooglePlay$d,
	goToExternalSite: goToExternalSite$d,
	helpRequestFailed: helpRequestFailed$d,
	helpRequestSuccessful: helpRequestSuccessful$d,
	hostname: hostname$d,
	icon: icon$d,
	identifier: identifier$d,
	imageUpload: imageUpload$d,
	inactive: inactive$d,
	inactiveDevice: inactiveDevice$d,
	install: install$d,
	invalidCode: invalidCode$d,
	invalidPhoneNumber: invalidPhoneNumber$d,
	language: language$d,
	languageConfirmation: languageConfirmation$d,
	lastAuthentication: lastAuthentication$d,
	lastChanged: lastChanged$d,
	lastUsed: lastUsed$d,
	length: length$d,
	letter: letter$d,
	linkToAppStore: linkToAppStore$d,
	linkToGooglePlay: linkToGooglePlay$d,
	loadingRecentActivity: loadingRecentActivity$d,
	loadingTrustedBrowsers: loadingTrustedBrowsers$d,
	location: location$d,
	locationTime: locationTime$d,
	loggedOut: loggedOut$d,
	login: login$d,
	loginDevice: loginDevice$d,
	loginEvent: loginEvent$d,
	loginFactor: loginFactor$d,
	loginFailedEvent: loginFailedEvent$d,
	loginName: loginName$d,
	logOut: logOut$d,
	lower: lower$d,
	message: message$d,
	mfaRegistrationFailure: mfaRegistrationFailure$d,
	mfaRegistrationSuccess: mfaRegistrationSuccess$d,
	more: more$d,
	never: never$d,
	newPassword: newPassword$d,
	newPrimaryFactor: newPrimaryFactor$d,
	noActivities: noActivities$d,
	noDevicesConfigured: noDevicesConfigured$d,
	noExpiration: noExpiration$d,
	noMoreSecurityFactors: noMoreSecurityFactors$d,
	notifyErrorLoadingUser: notifyErrorLoadingUser$d,
	notifySuccessAddApp: notifySuccessAddApp$d,
	noTrustedBrowsers: noTrustedBrowsers$d,
	numbers: numbers$d,
	oneloginDesktop: oneloginDesktop$d,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$d,
	oneloginLogo: oneloginLogo$d,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$d,
	otp1: otp1$d,
	otp2: otp2$d,
	otpDevice: otpDevice$d,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$d,
	password: password$d,
	passwordChanged: passwordChanged$d,
	passwordChangedDays: passwordChangedDays$d,
	passwordHint: passwordHint$d,
	passwordRedirectDescription: passwordRedirectDescription$d,
	passwordReset: passwordReset$d,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$d,
	passwordUpdateFailure: passwordUpdateFailure$d,
	phoneNumber: phoneNumber$d,
	prefix: prefix$d,
	previousDeviceName: previousDeviceName$d,
	primary: primary$d,
	proceedAnyway: proceedAnyway$d,
	profile: profile$d,
	profileAvatar: profileAvatar$d,
	profileMenuToggle: profileMenuToggle$d,
	profilePhoto: profilePhoto$d,
	profilePhotoAction: profilePhotoAction$d,
	pwResetDevice: pwResetDevice$d,
	pwResetFactor: pwResetFactor$d,
	questionNumber: questionNumber$d,
	radiusAuthentication: radiusAuthentication$d,
	recentActivity: recentActivity$d,
	redirectToChangePassword: redirectToChangePassword$d,
	registerSecurityQuestions: registerSecurityQuestions$d,
	registrationRejected: registrationRejected$d,
	registrationTimedout: registrationTimedout$d,
	remove: remove$d,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$d,
	removedProfilePictureSuccess: removedProfilePictureSuccess$d,
	removeFactorWarning: removeFactorWarning$d,
	removeImage: removeImage$d,
	report: report$d,
	reportActivity: reportActivity$d,
	requestField: requestField$d,
	requiredQuestions: requiredQuestions$d,
	revert: revert$d,
	revertToAdmin: revertToAdmin$d,
	revertToSuperadmin: revertToSuperadmin$d,
	revoke: revoke$d,
	save: save$d,
	searchIcon: searchIcon$d,
	secureNotes: secureNotes$d,
	securityFactorAdded: securityFactorAdded$d,
	securityFactorRemoved: securityFactorRemoved$d,
	securityFactorRenamed: securityFactorRenamed$d,
	securityFactors: securityFactors$d,
	securityFactorsDescription: securityFactorsDescription$d,
	securityFactorsUpdated: securityFactorsUpdated$d,
	selectNewImage: selectNewImage$d,
	selectNewPrimary: selectNewPrimary$d,
	selectSecurityFactor: selectSecurityFactor$d,
	sending: sending$d,
	setPrimaryDevice: setPrimaryDevice$d,
	showDetails: showDetails$d,
	specials: specials$d,
	sqDropdownAriaLabel: sqDropdownAriaLabel$d,
	sqInfoHeader: sqInfoHeader$d,
	sqTipBlankAnswers: sqTipBlankAnswers$d,
	sqTipDoNotShare: sqTipDoNotShare$d,
	sqTipMinimum: sqTipMinimum$d,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$d,
	sqTipNoUsePassword: sqTipNoUsePassword$d,
	sqTipSameAnswer: sqTipSameAnswer$d,
	sqTipSpecialChars: sqTipSpecialChars$d,
	submit: submit$d,
	submitting: submitting$d,
	support: support$d,
	supportDefaultDescription: supportDefaultDescription$d,
	supportedBrowsers: supportedBrowsers$d,
	supportRequestHeader: supportRequestHeader$d,
	"switch": "Switch",
	time: time$d,
	trustDevice: trustDevice$d,
	trusted: trusted$d,
	trustedBrowsers: trustedBrowsers$d,
	trustedBrowsersDescription: trustedBrowsersDescription$d,
	trustedDevice: trustedDevice$d,
	unavailable: unavailable$d,
	unavailableTime: unavailableTime$d,
	unsetFactorSuccess: unsetFactorSuccess$d,
	unsetPrimaryDevice: unsetPrimaryDevice$d,
	unsupportedBrowser: unsupportedBrowser$d,
	unsupportedBrowserHeading: unsupportedBrowserHeading$d,
	updateDeviceNameSuccess: updateDeviceNameSuccess$d,
	updateFactorSuccess: updateFactorSuccess$d,
	updatePassword: updatePassword$d,
	updateUserProfileFailure: updateUserProfileFailure$d,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$d,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$d,
	updateUserProfileSuccess: updateUserProfileSuccess$d,
	upper: upper$d,
	usedFor: usedFor$d,
	usedForApp: usedForApp$d,
	usedForLogin: usedForLogin$d,
	usedForPasswordReset: usedForPasswordReset$d,
	version: version$d,
	yourBrowser: yourBrowser$d
};

var addApp$c = "Show {addApp} button when I log in to new websites.";
var addFactor$c = "Add Factor";
var additionalQuestions$c = "Additional Questions";
var addNewPrimaryBeforeRemove$c = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$c = "Add New Security Question";
var administration$c = "Administration";
var alert$c = "Alert";
var all$c = "all";
var app$c = "App";
var appDevice$c = "Faktor ini digunakan untuk aplikasi.";
var appDevices$c = "Faktor ini digunakan untuk aplikasi";
var appFactor$c = "Faktor ini digunakan untuk aplikasi.";
var application$c = "Application";
var appName$c = "App Name";
var appPortal$c = "App Portal";
var assumedUserNotification$c = "You cannot edit personal information while assuming a user.";
var broswerExtension$c = "Browser Extension";
var browser$c = "Browser";
var browserDeleteFailure$c = "Failed to delete trusted browser";
var browserDeleteSuccess$c = "Trusted browser was successfully deleted";
var browserDevice$c = "Browser/Device";
var browserFetchFailure$c = "Failed to fetch browsers";
var calling$c = "Memanggil";
var callUserAgain$c = "Calling you again";
var cancel$c = "batalkan";
var changePassword$c = "Change Password";
var changeSecurityFactor$c = "Change Security Factor";
var clearIcon$c = "kosongkan ikon";
var close$c = "Close";
var closeDialog$c = "Tutup dialog";
var codeResent$c = "Code has been sent to your phone.";
var companyLogo$c = "logo syarikat";
var companyTab$c = "Default for company tab";
var conditionalRequirement$c = "At least {number} of the following requirements:";
var configuredOn$c = "Configured On";
var confirm$c = "sahkan";
var contactAdminEmailOtp$c = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$c = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$c = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$c = "Contact your admin to reset password.";
var credentialId$c = "Credential ID";
var current$c = "Current";
var currentPassword$c = "Current password";
var deleteDeviceSuccess$c = "{factorName} was successfully deleted";
var deleteQuestion$c = "Delete question {position}";
var details$c = "Details";
var device$c = "Device";
var deviceDeleteFailure$c = "Failed to remove {factorName}";
var deviceFetchFailure$c = "Failed to fetch devices";
var deviceNameCannotBeBlank$c = "Authentication device name cannot be blank.";
var deviceRenameFailure$c = "Failed to update device name";
var downloadOnAppStore$c = "Muat turun di app store";
var editDeviceName$c = "Edit name";
var editSQinfo$c = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$c = "Enroll new primary factor";
var event$c = "Event";
var eventType$c = "Event Type";
var eventUserAgent$c = "Event Useragent";
var eventUseragent$c = "Event Useragent";
var eventUUID$c = "Event UUID";
var eventUuid$c = "Event UUID";
var expirationDays$c = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$c = "Expire Date";
var expires$c = "Expires";
var extensionVersionInstalled$c = "Version {versionString} installed";
var factor$c = "Factor";
var factorFetchFailure$c = "Failed to fetch available factors";
var factorMfaTokenFailure$c = "Failed to fetch mfa token";
var factorPrimaryFailure$c = "Failed to set {factorName} as your primary factor";
var factors$c = "factors";
var factorsFetchFailure$c = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$c = "We couldn’t load your user information.";
var failedToRegisterAnswers$c = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$c = "We couldn't retrieve your security questions at this time.";
var forcedLogout$c = "Forced Logout";
var getOnGooglePlay$c = "Dapatkannya di Google Play";
var goToExternalSite$c = "Go to external site";
var helpRequestFailed$c = "We couldn't submit your help request.";
var helpRequestSuccessful$c = "Your support request has been sent to your OneLogin Admin.";
var hostname$c = "Hostname & OS";
var icon$c = "Icon";
var identifier$c = "Credential ID / Identifier";
var imageUpload$c = "Image Upload";
var inactive$c = "Inactive";
var inactiveDevice$c = "Inactive device";
var install$c = "Install";
var invalidCode$c = "Invalid code";
var invalidPhoneNumber$c = "Please use valid phone number.";
var language$c = "Language";
var languageConfirmation$c = "Are you sure you want to switch to {language}?";
var lastAuthentication$c = "Last Authentication";
var lastChanged$c = "Last changed";
var lastUsed$c = "Last Used";
var length$c = "Minimum {length} characters";
var letter$c = "1 Letter";
var linkToAppStore$c = "Pautan kepada App Store";
var linkToGooglePlay$c = "Pautan kepada Google Play";
var loadingRecentActivity$c = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$c = "Loading trusted browsers, please wait...";
var location$c = "Location";
var locationTime$c = "Location/Time";
var loggedOut$c = "Logged Out";
var login$c = "login";
var loginDevice$c = "Login device";
var loginEvent$c = "Login";
var loginFactor$c = "Faktor ini digunakan untuk log masuk.";
var loginFailedEvent$c = "Login Failed";
var loginName$c = "Login Name";
var logOut$c = "Log Out";
var lower$c = "1 Lowercase";
var message$c = "{name} was successfully added.";
var mfaRegistrationFailure$c = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$c = "You successfully registered the device";
var more$c = "More";
var never$c = "Never";
var newPassword$c = "New password";
var newPrimaryFactor$c = "New primary factor";
var noActivities$c = "No activities have been made";
var noDevicesConfigured$c = "No devices have been configured";
var noExpiration$c = "Never expires";
var noMoreSecurityFactors$c = "There are no security factors available for registration.";
var notifyErrorLoadingUser$c = "Loading of user failed. Try again later";
var notifySuccessAddApp$c = "{name} was successfully added.";
var noTrustedBrowsers$c = "No browsers have been saved";
var numbers$c = "1 Number";
var oneloginDesktop$c = "OneLogin Desktop";
var oneloginDesktopFetchFailure$c = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$c = "OneLogin logo";
var onlyDesktopBrowsersSupported$c = "We currently only support browser extensions on desktop browsers.";
var otp1$c = "OTP 1";
var otp2$c = "OTP 2";
var otpDevice$c = "Faktor ini digunakan untuk log masuk.";
var parsingUserProfilePhotoFailure$c = "Getting image details failed";
var password$c = "password";
var passwordChanged$c = "Password Changed";
var passwordChangedDays$c = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$c = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$c = "Your administrator has configured an external site for resetting your password.";
var passwordReset$c = "Password Reset";
var passwordUpdatedSuccessfully$c = "You have successfully updated your password.";
var passwordUpdateFailure$c = "Password update failed";
var phoneNumber$c = "Phone number";
var prefix$c = "Suspicious login report";
var previousDeviceName$c = "Previously {previousName}";
var primary$c = "Primary";
var proceedAnyway$c = "Proceed anyway";
var profile$c = "Profile";
var profileAvatar$c = "Profile avatar";
var profileMenuToggle$c = "Open profile menu";
var profilePhoto$c = "Profile photo";
var profilePhotoAction$c = "Profile image action";
var pwResetDevice$c = "Faktor ini digunakan untuk pengesetan semula kata laluan.";
var pwResetFactor$c = "Faktor ini digunakan untuk pengesetan semula kata laluan.";
var questionNumber$c = "Question {position}";
var radiusAuthentication$c = "Service Login via Radius";
var recentActivity$c = "Recent Activity";
var redirectToChangePassword$c = "Redirect to change your password?";
var registerSecurityQuestions$c = "Register Security Questions";
var registrationRejected$c = "Registration unsuccessful, please try again.";
var registrationTimedout$c = "Registration context timed out";
var remove$c = "Remove";
var removeCurrentBrowserWarning$c = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$c = "You have successfully removed your profile picture.";
var removeFactorWarning$c = "Are you sure you want to remove {factor}?";
var removeImage$c = "Remove image";
var report$c = "Report";
var reportActivity$c = "Report Activity";
var requestField$c = "Describe the issue you're having";
var requiredQuestions$c = "Required Questions";
var revert$c = "balikkan";
var revertToAdmin$c = "Revert to Admin";
var revertToSuperadmin$c = "Revert to OneLogin Admin";
var revoke$c = "Revoke";
var save$c = "Save Changes";
var searchIcon$c = "cari ikon";
var secureNotes$c = "Secure Notes";
var securityFactorAdded$c = "Security Factor Added";
var securityFactorRemoved$c = "Security Factor Removed";
var securityFactorRenamed$c = "Security Factor Renamed";
var securityFactors$c = "Security Factors";
var securityFactorsDescription$c = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$c = "Security Factors Updated";
var selectNewImage$c = "Select new image";
var selectNewPrimary$c = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$c = "Select Security Factor";
var sending$c = "Menghantar";
var setPrimaryDevice$c = "Set as primary";
var showDetails$c = "Tunjukkan butiran";
var specials$c = "1 Special character";
var sqDropdownAriaLabel$c = "Question {position} dropdown";
var sqInfoHeader$c = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$c = "Blank answers will not be accepted";
var sqTipDoNotShare$c = "Do not share your questions and answers with anyone.";
var sqTipMinimum$c = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$c = "Answers are not case-sensitive.";
var sqTipNoUsePassword$c = "Do not use a password as an answer.";
var sqTipSameAnswer$c = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$c = "Special characters such as @#&*. will be ignored";
var submit$c = "Submit";
var submitting$c = "Submitting…";
var support$c = "Support";
var supportDefaultDescription$c = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$c = "Supported browsers: {browsers}";
var supportRequestHeader$c = "Support Request";
var time$c = "Time";
var trustDevice$c = "Trust Device";
var trusted$c = "Trusted";
var trustedBrowsers$c = "Trusted Browsers";
var trustedBrowsersDescription$c = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$c = "Trusted Device";
var unavailable$c = "Unavailable";
var unavailableTime$c = "Unavailable";
var unsetFactorSuccess$c = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$c = "Unset as primary";
var unsupportedBrowser$c = "Unsupported Browser";
var unsupportedBrowserHeading$c = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$c = "{newName} was successfully updated";
var updateFactorSuccess$c = "{factorName} is your new default security factor";
var updatePassword$c = "Update Password";
var updateUserProfileFailure$c = "Profile Update Failed";
var updateUserProfilePhotoFailure$c = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$c = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$c = "You have successfully updated your profile.";
var upper$c = "1 Uppercase";
var usedFor$c = "Used For";
var usedForApp$c = "This factor is used for app.";
var usedForLogin$c = "This factor is used for login.";
var usedForPasswordReset$c = "This factor is used for password reset.";
var version$c = "Version: {versionString}";
var yourBrowser$c = "Your browser: {browser}";
var msMY = {
	"26286820": "Masukkan ID Kelayakan dan dua Kod Keselamatan berturutan daripada Akses VIP Symantec.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Masukkan kod yang anda terima dalam SMS",
	"374233718": "Anda boleh cuba semula dalam {secLeft, number} {secLeft, plural, one second} lain-lain {seconds}}",
	"437305782": "Mengesahkan pengesah WebAuthn anda sekarang.",
	"505702857": "Pautan Ajaib",
	"519412053": "Tukar Faktor Pengesahan",
	"655462232": "Muat turun dan pasang OneLogin Protect pada peranti anda",
	"660592555": "OK",
	"662924178": "Nampaknya, hari ini bukan hari kita.",
	"694278426": "Masukkan kod {deviceName} anda",
	"694920552": "Kod Keselamatan Pertama",
	"737192390": "Buka {appName}",
	"740457555": "Kod Kedua",
	"744377571": "Minimum {length} aksara",
	"751710530": "Serah",
	"916760408": "Masukkan nama pengguna dan kod keselamatan dari peranti anda.",
	"921093870": "Masih tidak menerima kod?",
	"966052509": "Tiada Hasil",
	"987359842": "Sila klik pautan dalam e-mel anda untuk meneruskan",
	"1068496829": "Pilih Soalan Keselamatan {current}/{total}",
	"1079852660": "Masukkan dua Kod Keselamatan berurutan",
	"1080736814": "Masukkan {fieldName} dari aplikasi Symantec VIP Access",
	"1136625613": "Proses dibatalkan. Sila cuba semula menggunakan faktor pengesahan lain.",
	"1212847248": "Kod pengesahan telah dihantar ke alamat anda yang ditetapkan.",
	"1232460711": "Masukkan e-mel anda",
	"1242107845": "Tunjukkan",
	"1254879564": "Kata Laluan Baharu",
	"1359200231": "Hantar",
	"1433651550": "Masukkan kod dari OneLogin SMS.",
	"1477893598": "Buat konfigurasi",
	"1536965459": "Muat turan dan pasang OneLogin Protect pada peranti anda",
	"1624184662": "Untuk menyediakan OneLogin SMS, kami akan menghantar kod pengaktifan kepada anda melalui SMS. Anda memerlukan kod pengaktifan ini untuk melengkapkan pendaftaran peranti.",
	"1654624862": "Kod Keselamatan",
	"1833121415": "Berikan Jawapan {current}/{total}",
	"1919587067": "Hantar semula kod",
	"1935535842": "Diperlukan",
	"1963245695": "1 Huruf Besar",
	"2018264248": "Cuba Semula",
	"2091874550": "Kod Pertama",
	"2097632732": "Sebaliknya imbas kod bar",
	"2104438124": "Masukkan {fieldName} dan dua Kod Keselamatan berurutan dari Symantec VIP Access.",
	"2124363772": "Masukkan nama pengguna dan kod keselamatan anda dari token SecurID anda.",
	"2229754167": "Masukkan nombor telefon anda",
	"2244720377": "Ralat tidak dijangka nampaknya telah berlaku.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Pautan akses telah dihantar kepada e-mel anda",
	"2600324508": "Sembunyikan",
	"2606375562": "Masukkan YubiKey anda ke dalam port USB dan tekan butang",
	"2663586870": "Nama pengguna",
	"2758306961": "ID Kelayakan",
	"2792137744": "1 nombor",
	"2815222727": "Imbas kod bar ini",
	"2828880379": "Sahkan",
	"2859281487": "Pengesahan 2 faktor diperlukan untuk menjadikan akaun anda selamat.",
	"2942752129": "Kod Keselamatan Kedua",
	"3060896801": "Bermasalah?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 aksara khas",
	"3294346597": "Cuba lagi",
	"3327626662": "Masukkan kod pengesahan anda",
	"3374226769": "Klik Pair dengan menggunakan masukan manual",
	"3469481929": "Tidak boleh mengimbas kod?",
	"3499598078": "Buka menu",
	"3528672691": "Batal",
	"3640052215": "Teruskan",
	"3645029425": "Imbas Kod QR di bawah",
	"3645116517": "MAsukkan kod ini apabila menerima panggilan:",
	"3663548834": "Kami sedang menyiasat masalahnya dan menjangkakan akan kembali sebentar lagi. Sila tunggu beberapa minit<br />dan segar semula pelayar anda, atau kunjungi <a href='https://www.onelogin.com/status'>Halaman Status</a>.",
	"3669652728": "Pautan akses telah dihantar kepada",
	"3673120330": "Berikut",
	"3737470122": "Sila hubungi pentadbir untuk maklumat lanjut",
	"3781468762": "Pelayar anda tidak menyokong WebAuthn",
	"3827227259": "Kod pengesahan telah dihantar kepada",
	"3855542277": "Masukkan kod ini dalam aplikasi",
	"3865193889": "Aktifkan",
	"3877285238": "1 huruf kecil",
	"4000449233": "Memanggil nombor telefon di bawah:",
	"4072532148": "Hantar semula kod SMS",
	"4151518079": "Pilih Soalan Keselamatan {current} / {total}",
	"4152906165": "Kami sedang menyiasat masalah ini dan dijangka akan pulih sebentar lagi. Sila tunggu selama beberapa minit{break}dan segar semula pelayar anda, atau kunjungi <link>Halaman Status</link> kami.",
	"4227081527": "Apabila aplikasi dipasang, kembali ke skrin ini dan klik {action}",
	"4281662478": "Cari",
	addApp: addApp$c,
	addFactor: addFactor$c,
	additionalQuestions: additionalQuestions$c,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$c,
	addNewSecurityQuestion: addNewSecurityQuestion$c,
	administration: administration$c,
	alert: alert$c,
	all: all$c,
	app: app$c,
	appDevice: appDevice$c,
	appDevices: appDevices$c,
	appFactor: appFactor$c,
	application: application$c,
	appName: appName$c,
	appPortal: appPortal$c,
	assumedUserNotification: assumedUserNotification$c,
	broswerExtension: broswerExtension$c,
	browser: browser$c,
	browserDeleteFailure: browserDeleteFailure$c,
	browserDeleteSuccess: browserDeleteSuccess$c,
	browserDevice: browserDevice$c,
	browserFetchFailure: browserFetchFailure$c,
	calling: calling$c,
	callUserAgain: callUserAgain$c,
	cancel: cancel$c,
	changePassword: changePassword$c,
	changeSecurityFactor: changeSecurityFactor$c,
	clearIcon: clearIcon$c,
	close: close$c,
	closeDialog: closeDialog$c,
	codeResent: codeResent$c,
	companyLogo: companyLogo$c,
	companyTab: companyTab$c,
	conditionalRequirement: conditionalRequirement$c,
	configuredOn: configuredOn$c,
	confirm: confirm$c,
	contactAdminEmailOtp: contactAdminEmailOtp$c,
	contactAdminForSMS: contactAdminForSMS$c,
	contactAdminForVoice: contactAdminForVoice$c,
	contactAdminPasswordReset: contactAdminPasswordReset$c,
	credentialId: credentialId$c,
	current: current$c,
	currentPassword: currentPassword$c,
	deleteDeviceSuccess: deleteDeviceSuccess$c,
	deleteQuestion: deleteQuestion$c,
	details: details$c,
	device: device$c,
	deviceDeleteFailure: deviceDeleteFailure$c,
	deviceFetchFailure: deviceFetchFailure$c,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$c,
	deviceRenameFailure: deviceRenameFailure$c,
	downloadOnAppStore: downloadOnAppStore$c,
	editDeviceName: editDeviceName$c,
	editSQinfo: editSQinfo$c,
	enrollNewFactor: enrollNewFactor$c,
	event: event$c,
	eventType: eventType$c,
	eventUserAgent: eventUserAgent$c,
	eventUseragent: eventUseragent$c,
	eventUUID: eventUUID$c,
	eventUuid: eventUuid$c,
	expirationDays: expirationDays$c,
	expireDate: expireDate$c,
	expires: expires$c,
	extensionVersionInstalled: extensionVersionInstalled$c,
	factor: factor$c,
	factorFetchFailure: factorFetchFailure$c,
	factorMfaTokenFailure: factorMfaTokenFailure$c,
	factorPrimaryFailure: factorPrimaryFailure$c,
	factors: factors$c,
	factorsFetchFailure: factorsFetchFailure$c,
	failedToFetchUserInfo: failedToFetchUserInfo$c,
	failedToRegisterAnswers: failedToRegisterAnswers$c,
	failedToRetrieveQuestions: failedToRetrieveQuestions$c,
	forcedLogout: forcedLogout$c,
	getOnGooglePlay: getOnGooglePlay$c,
	goToExternalSite: goToExternalSite$c,
	helpRequestFailed: helpRequestFailed$c,
	helpRequestSuccessful: helpRequestSuccessful$c,
	hostname: hostname$c,
	icon: icon$c,
	identifier: identifier$c,
	imageUpload: imageUpload$c,
	inactive: inactive$c,
	inactiveDevice: inactiveDevice$c,
	install: install$c,
	invalidCode: invalidCode$c,
	invalidPhoneNumber: invalidPhoneNumber$c,
	language: language$c,
	languageConfirmation: languageConfirmation$c,
	lastAuthentication: lastAuthentication$c,
	lastChanged: lastChanged$c,
	lastUsed: lastUsed$c,
	length: length$c,
	letter: letter$c,
	linkToAppStore: linkToAppStore$c,
	linkToGooglePlay: linkToGooglePlay$c,
	loadingRecentActivity: loadingRecentActivity$c,
	loadingTrustedBrowsers: loadingTrustedBrowsers$c,
	location: location$c,
	locationTime: locationTime$c,
	loggedOut: loggedOut$c,
	login: login$c,
	loginDevice: loginDevice$c,
	loginEvent: loginEvent$c,
	loginFactor: loginFactor$c,
	loginFailedEvent: loginFailedEvent$c,
	loginName: loginName$c,
	logOut: logOut$c,
	lower: lower$c,
	message: message$c,
	mfaRegistrationFailure: mfaRegistrationFailure$c,
	mfaRegistrationSuccess: mfaRegistrationSuccess$c,
	more: more$c,
	never: never$c,
	newPassword: newPassword$c,
	newPrimaryFactor: newPrimaryFactor$c,
	noActivities: noActivities$c,
	noDevicesConfigured: noDevicesConfigured$c,
	noExpiration: noExpiration$c,
	noMoreSecurityFactors: noMoreSecurityFactors$c,
	notifyErrorLoadingUser: notifyErrorLoadingUser$c,
	notifySuccessAddApp: notifySuccessAddApp$c,
	noTrustedBrowsers: noTrustedBrowsers$c,
	numbers: numbers$c,
	oneloginDesktop: oneloginDesktop$c,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$c,
	oneloginLogo: oneloginLogo$c,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$c,
	otp1: otp1$c,
	otp2: otp2$c,
	otpDevice: otpDevice$c,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$c,
	password: password$c,
	passwordChanged: passwordChanged$c,
	passwordChangedDays: passwordChangedDays$c,
	passwordHint: passwordHint$c,
	passwordRedirectDescription: passwordRedirectDescription$c,
	passwordReset: passwordReset$c,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$c,
	passwordUpdateFailure: passwordUpdateFailure$c,
	phoneNumber: phoneNumber$c,
	prefix: prefix$c,
	previousDeviceName: previousDeviceName$c,
	primary: primary$c,
	proceedAnyway: proceedAnyway$c,
	profile: profile$c,
	profileAvatar: profileAvatar$c,
	profileMenuToggle: profileMenuToggle$c,
	profilePhoto: profilePhoto$c,
	profilePhotoAction: profilePhotoAction$c,
	pwResetDevice: pwResetDevice$c,
	pwResetFactor: pwResetFactor$c,
	questionNumber: questionNumber$c,
	radiusAuthentication: radiusAuthentication$c,
	recentActivity: recentActivity$c,
	redirectToChangePassword: redirectToChangePassword$c,
	registerSecurityQuestions: registerSecurityQuestions$c,
	registrationRejected: registrationRejected$c,
	registrationTimedout: registrationTimedout$c,
	remove: remove$c,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$c,
	removedProfilePictureSuccess: removedProfilePictureSuccess$c,
	removeFactorWarning: removeFactorWarning$c,
	removeImage: removeImage$c,
	report: report$c,
	reportActivity: reportActivity$c,
	requestField: requestField$c,
	requiredQuestions: requiredQuestions$c,
	revert: revert$c,
	revertToAdmin: revertToAdmin$c,
	revertToSuperadmin: revertToSuperadmin$c,
	revoke: revoke$c,
	save: save$c,
	searchIcon: searchIcon$c,
	secureNotes: secureNotes$c,
	securityFactorAdded: securityFactorAdded$c,
	securityFactorRemoved: securityFactorRemoved$c,
	securityFactorRenamed: securityFactorRenamed$c,
	securityFactors: securityFactors$c,
	securityFactorsDescription: securityFactorsDescription$c,
	securityFactorsUpdated: securityFactorsUpdated$c,
	selectNewImage: selectNewImage$c,
	selectNewPrimary: selectNewPrimary$c,
	selectSecurityFactor: selectSecurityFactor$c,
	sending: sending$c,
	setPrimaryDevice: setPrimaryDevice$c,
	showDetails: showDetails$c,
	specials: specials$c,
	sqDropdownAriaLabel: sqDropdownAriaLabel$c,
	sqInfoHeader: sqInfoHeader$c,
	sqTipBlankAnswers: sqTipBlankAnswers$c,
	sqTipDoNotShare: sqTipDoNotShare$c,
	sqTipMinimum: sqTipMinimum$c,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$c,
	sqTipNoUsePassword: sqTipNoUsePassword$c,
	sqTipSameAnswer: sqTipSameAnswer$c,
	sqTipSpecialChars: sqTipSpecialChars$c,
	submit: submit$c,
	submitting: submitting$c,
	support: support$c,
	supportDefaultDescription: supportDefaultDescription$c,
	supportedBrowsers: supportedBrowsers$c,
	supportRequestHeader: supportRequestHeader$c,
	"switch": "Switch",
	time: time$c,
	trustDevice: trustDevice$c,
	trusted: trusted$c,
	trustedBrowsers: trustedBrowsers$c,
	trustedBrowsersDescription: trustedBrowsersDescription$c,
	trustedDevice: trustedDevice$c,
	unavailable: unavailable$c,
	unavailableTime: unavailableTime$c,
	unsetFactorSuccess: unsetFactorSuccess$c,
	unsetPrimaryDevice: unsetPrimaryDevice$c,
	unsupportedBrowser: unsupportedBrowser$c,
	unsupportedBrowserHeading: unsupportedBrowserHeading$c,
	updateDeviceNameSuccess: updateDeviceNameSuccess$c,
	updateFactorSuccess: updateFactorSuccess$c,
	updatePassword: updatePassword$c,
	updateUserProfileFailure: updateUserProfileFailure$c,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$c,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$c,
	updateUserProfileSuccess: updateUserProfileSuccess$c,
	upper: upper$c,
	usedFor: usedFor$c,
	usedForApp: usedForApp$c,
	usedForLogin: usedForLogin$c,
	usedForPasswordReset: usedForPasswordReset$c,
	version: version$c,
	yourBrowser: yourBrowser$c
};

var addApp$b = "Show {addApp} button when I log in to new websites.";
var addFactor$b = "Add Factor";
var additionalQuestions$b = "Additional Questions";
var addNewPrimaryBeforeRemove$b = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$b = "Add New Security Question";
var administration$b = "Administration";
var alert$b = "Alert";
var all$b = "all";
var app$b = "App";
var appDevice$b = "Deze factor wordt gebruikt voor de app.";
var appDevices$b = "Deze factor wordt gebruikt voor app";
var appFactor$b = "Deze factor wordt gebruikt voor de app.";
var application$b = "Application";
var appName$b = "App Name";
var appPortal$b = "App Portal";
var assumedUserNotification$b = "You cannot edit personal information while assuming a user.";
var broswerExtension$b = "Browser Extension";
var browser$b = "Browser";
var browserDeleteFailure$b = "Failed to delete trusted browser";
var browserDeleteSuccess$b = "Trusted browser was successfully deleted";
var browserDevice$b = "Browser/Device";
var browserFetchFailure$b = "Failed to fetch browsers";
var calling$b = "Aan het bellen";
var callUserAgain$b = "Calling you again";
var cancel$b = "annuleren";
var changePassword$b = "Change Password";
var changeSecurityFactor$b = "Change Security Factor";
var clearIcon$b = "verwijderpictogram";
var close$b = "Close";
var closeDialog$b = "Venster sluiten";
var codeResent$b = "Code has been sent to your phone.";
var companyLogo$b = "bedrijfslogo";
var companyTab$b = "Default for company tab";
var conditionalRequirement$b = "At least {number} of the following requirements:";
var configuredOn$b = "Configured On";
var confirm$b = "bevestigen";
var contactAdminEmailOtp$b = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$b = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$b = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$b = "Contact your admin to reset password.";
var credentialId$b = "Credential ID";
var current$b = "Current";
var currentPassword$b = "Current password";
var deleteDeviceSuccess$b = "{factorName} was successfully deleted";
var deleteQuestion$b = "Delete question {position}";
var details$b = "Details";
var device$b = "Device";
var deviceDeleteFailure$b = "Failed to remove {factorName}";
var deviceFetchFailure$b = "Failed to fetch devices";
var deviceNameCannotBeBlank$b = "Authentication device name cannot be blank.";
var deviceRenameFailure$b = "Failed to update device name";
var downloadOnAppStore$b = "Downloaden via de App Store";
var editDeviceName$b = "Edit name";
var editSQinfo$b = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$b = "Enroll new primary factor";
var event$b = "Event";
var eventType$b = "Event Type";
var eventUserAgent$b = "Event Useragent";
var eventUseragent$b = "Event Useragent";
var eventUUID$b = "Event UUID";
var eventUuid$b = "Event UUID";
var expirationDays$b = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$b = "Expire Date";
var expires$b = "Expires";
var extensionVersionInstalled$b = "Version {versionString} installed";
var factor$b = "Factor";
var factorFetchFailure$b = "Failed to fetch available factors";
var factorMfaTokenFailure$b = "Failed to fetch mfa token";
var factorPrimaryFailure$b = "Failed to set {factorName} as your primary factor";
var factors$b = "factors";
var factorsFetchFailure$b = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$b = "We couldn’t load your user information.";
var failedToRegisterAnswers$b = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$b = "We couldn't retrieve your security questions at this time.";
var forcedLogout$b = "Forced Logout";
var getOnGooglePlay$b = "Downloaden via Google Play";
var goToExternalSite$b = "Go to external site";
var helpRequestFailed$b = "We couldn't submit your help request.";
var helpRequestSuccessful$b = "Your support request has been sent to your OneLogin Admin.";
var hostname$b = "Hostname & OS";
var icon$b = "Icon";
var identifier$b = "Credential ID / Identifier";
var imageUpload$b = "Image Upload";
var inactive$b = "Inactive";
var inactiveDevice$b = "Inactive device";
var install$b = "Install";
var invalidCode$b = "Invalid code";
var invalidPhoneNumber$b = "Please use valid phone number.";
var language$b = "Language";
var languageConfirmation$b = "Are you sure you want to switch to {language}?";
var lastAuthentication$b = "Last Authentication";
var lastChanged$b = "Last changed";
var lastUsed$b = "Last Used";
var length$b = "Minimum {length} characters";
var letter$b = "1 Letter";
var linkToAppStore$b = "Link naar de App Store";
var linkToGooglePlay$b = "Link naar Google Play";
var loadingRecentActivity$b = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$b = "Loading trusted browsers, please wait...";
var location$b = "Location";
var locationTime$b = "Location/Time";
var loggedOut$b = "Logged Out";
var login$b = "login";
var loginDevice$b = "Login device";
var loginEvent$b = "Login";
var loginFactor$b = "Deze factor wordt gebruikt om in te loggen.";
var loginFailedEvent$b = "Login Failed";
var loginName$b = "Login Name";
var logOut$b = "Log Out";
var lower$b = "1 Lowercase";
var message$b = "{name} was successfully added.";
var mfaRegistrationFailure$b = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$b = "You successfully registered the device";
var more$b = "More";
var never$b = "Never";
var newPassword$b = "New password";
var newPrimaryFactor$b = "New primary factor";
var noActivities$b = "No activities have been made";
var noDevicesConfigured$b = "No devices have been configured";
var noExpiration$b = "Never expires";
var noMoreSecurityFactors$b = "There are no security factors available for registration.";
var notifyErrorLoadingUser$b = "Loading of user failed. Try again later";
var notifySuccessAddApp$b = "{name} was successfully added.";
var noTrustedBrowsers$b = "No browsers have been saved";
var numbers$b = "1 Number";
var oneloginDesktop$b = "OneLogin Desktop";
var oneloginDesktopFetchFailure$b = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$b = "OneLogin logo";
var onlyDesktopBrowsersSupported$b = "We currently only support browser extensions on desktop browsers.";
var otp1$b = "OTP 1";
var otp2$b = "OTP 2";
var otpDevice$b = "Deze factor wordt gebruikt om in te loggen.";
var parsingUserProfilePhotoFailure$b = "Getting image details failed";
var password$b = "password";
var passwordChanged$b = "Password Changed";
var passwordChangedDays$b = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$b = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$b = "Your administrator has configured an external site for resetting your password.";
var passwordReset$b = "Password Reset";
var passwordUpdatedSuccessfully$b = "You have successfully updated your password.";
var passwordUpdateFailure$b = "Password update failed";
var phoneNumber$b = "Phone number";
var prefix$b = "Suspicious login report";
var previousDeviceName$b = "Previously {previousName}";
var primary$b = "Primary";
var proceedAnyway$b = "Proceed anyway";
var profile$b = "Profile";
var profileAvatar$b = "Profile avatar";
var profileMenuToggle$b = "Open profile menu";
var profilePhoto$b = "Profile photo";
var profilePhotoAction$b = "Profile image action";
var pwResetDevice$b = "Deze factor wordt gebruikt voor het opnieuw instellen van het wachtwoord.";
var pwResetFactor$b = "Deze factor wordt gebruikt voor het opnieuw instellen van het wachtwoord.";
var questionNumber$b = "Question {position}";
var radiusAuthentication$b = "Service Login via Radius";
var recentActivity$b = "Recent Activity";
var redirectToChangePassword$b = "Redirect to change your password?";
var registerSecurityQuestions$b = "Register Security Questions";
var registrationRejected$b = "Registration unsuccessful, please try again.";
var registrationTimedout$b = "Registration context timed out";
var remove$b = "Remove";
var removeCurrentBrowserWarning$b = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$b = "You have successfully removed your profile picture.";
var removeFactorWarning$b = "Are you sure you want to remove {factor}?";
var removeImage$b = "Remove image";
var report$b = "Report";
var reportActivity$b = "Report Activity";
var requestField$b = "Describe the issue you're having";
var requiredQuestions$b = "Required Questions";
var revert$b = "terug";
var revertToAdmin$b = "Revert to Admin";
var revertToSuperadmin$b = "Revert to OneLogin Admin";
var revoke$b = "Revoke";
var save$b = "Save Changes";
var searchIcon$b = "zoekpictogram";
var secureNotes$b = "Secure Notes";
var securityFactorAdded$b = "Security Factor Added";
var securityFactorRemoved$b = "Security Factor Removed";
var securityFactorRenamed$b = "Security Factor Renamed";
var securityFactors$b = "Security Factors";
var securityFactorsDescription$b = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$b = "Security Factors Updated";
var selectNewImage$b = "Select new image";
var selectNewPrimary$b = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$b = "Select Security Factor";
var sending$b = "Verzenden";
var setPrimaryDevice$b = "Set as primary";
var showDetails$b = "Toon details";
var specials$b = "1 Special character";
var sqDropdownAriaLabel$b = "Question {position} dropdown";
var sqInfoHeader$b = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$b = "Blank answers will not be accepted";
var sqTipDoNotShare$b = "Do not share your questions and answers with anyone.";
var sqTipMinimum$b = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$b = "Answers are not case-sensitive.";
var sqTipNoUsePassword$b = "Do not use a password as an answer.";
var sqTipSameAnswer$b = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$b = "Special characters such as @#&*. will be ignored";
var submit$b = "Submit";
var submitting$b = "Submitting…";
var support$b = "Support";
var supportDefaultDescription$b = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$b = "Supported browsers: {browsers}";
var supportRequestHeader$b = "Support Request";
var time$b = "Time";
var trustDevice$b = "Trust Device";
var trusted$b = "Trusted";
var trustedBrowsers$b = "Trusted Browsers";
var trustedBrowsersDescription$b = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$b = "Trusted Device";
var unavailable$b = "Unavailable";
var unavailableTime$b = "Unavailable";
var unsetFactorSuccess$b = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$b = "Unset as primary";
var unsupportedBrowser$b = "Unsupported Browser";
var unsupportedBrowserHeading$b = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$b = "{newName} was successfully updated";
var updateFactorSuccess$b = "{factorName} is your new default security factor";
var updatePassword$b = "Update Password";
var updateUserProfileFailure$b = "Profile Update Failed";
var updateUserProfilePhotoFailure$b = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$b = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$b = "You have successfully updated your profile.";
var upper$b = "1 Uppercase";
var usedFor$b = "Used For";
var usedForApp$b = "This factor is used for app.";
var usedForLogin$b = "This factor is used for login.";
var usedForPasswordReset$b = "This factor is used for password reset.";
var version$b = "Version: {versionString}";
var yourBrowser$b = "Your browser: {browser}";
var nl = {
	"26286820": "Voer een referentie-ID en twee opeenvolgende beveiligingscodes in van Symantec VIP-toegang.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Voer de code in die u ontving per SMS.",
	"374233718": "U kunt het in {secLeft, number} {secLeft, plural, one {second} other {seconds}} opnieuw proberen",
	"437305782": "Uw WebAuthn-authenticators worden nu geverifieerd.",
	"505702857": "Magische link",
	"519412053": "Wijzig de verificatiefactor",
	"655462232": "Download en installeer OneLogin Protect op uw apparaat",
	"660592555": "OK",
	"662924178": "Het lijkt erop dat het niet onze dag is.",
	"694278426": "Voer uw {deviceName}-code in",
	"694920552": "Eerste veiligheidscode",
	"737192390": "Open  {appName}",
	"740457555": "Tweede code",
	"744377571": "Minimum {length} leestekens",
	"751710530": "Indienen",
	"916760408": "Voer een gebruikersnaam en veiligheidscode van uw apparaat in.",
	"921093870": "De code niet ontvangen?",
	"966052509": "Geen resultaten",
	"987359842": "Klik op de link in het e-mailbericht om door te gaan",
	"1068496829": "Selecteer een veiligheidsvraag {current}/{total}",
	"1079852660": "Voer twee opeenvolgende veiligheidscodes in",
	"1080736814": "Voer {fieldName} van de Symantec VIP Access-app in",
	"1136625613": "Het proces werd beëindigd. Probeer het opnieuw of gebruik een andere authenticatiefactor.",
	"1212847248": "Er is een bevestigingscode verzonden naar uw geconfigureerde adres.",
	"1232460711": "Vul uw e-mailadres in",
	"1242107845": "Tonen",
	"1254879564": "Nieuw wachtwoord",
	"1359200231": "Versturen",
	"1433651550": "Voer de code in van OneLogin SMS.",
	"1477893598": "Configureren",
	"1536965459": "Download en installeer OneLogin Protect op uw apparaat",
	"1624184662": "Om OneLogin SMS in te stellen, sturen we u een activeringscode via SMS. U hebt deze activeringscode nodig om de apparaatregistratie te voltooien.",
	"1654624862": "Veiligheidscode",
	"1833121415": "Geef een antwoord {current}/{total}",
	"1919587067": "Code nogmaals versturen",
	"1935535842": "Vereist",
	"1963245695": "1 hoofdletter",
	"2018264248": "Probeer het opnieuw",
	"2091874550": "Eerste code",
	"2097632732": "Scan in plaats daarvan de barcode",
	"2104438124": "Voer {fieldName} en twee opeenvolgende veiligheidscodes in van Symantec VIP Access.",
	"2124363772": "Voer uw gebruikersnaam en veiligheidscode in met uw SecurID-token.",
	"2229754167": "Voer uw telefoonnummer in",
	"2244720377": "Er is een onverwachte fout opgetreden.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Een toegangslink is naar uw e-mailadres verzonden",
	"2600324508": "Verbergen",
	"2606375562": "Steek uw YubiKey in de USB-poort en druk op de knop",
	"2663586870": "Gebruikersnaam",
	"2758306961": "Referentie-ID",
	"2792137744": "1 nummer",
	"2815222727": "Scan deze barcode",
	"2828880379": "Bevestigen",
	"2859281487": "Authenticatie met 2 factoren is vereist om uw account te beveiligen.",
	"2942752129": "Tweede veiligheidscode",
	"3060896801": "Hebt u problemen?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 speciaal leesteken",
	"3294346597": "Probeer het opnieuw",
	"3327626662": "Voer uw bevestigingscode in",
	"3374226769": "Klik op Paren door de handmatige invoer te gebruiken",
	"3469481929": "U kunt de code niet scannen?",
	"3499598078": "Open menu",
	"3528672691": "Annuleren",
	"3640052215": "Doorgaan",
	"3645029425": "Scan de onderstaande QR-code",
	"3645116517": "Voer deze code in zodra u de oproep ontvangt:",
	"3663548834": "We onderzoeken het probleem en verwachten snel weer terug te zijn. Wacht een paar minuten <br />en laad de de pagina opnieuw in uw browser of bezoek onze <a href='https://www.onelogin.com/status'>Statuspagina</a>.",
	"3669652728": "Er is een toegangslink verzonden naar",
	"3673120330": "Volgende",
	"3737470122": "Neem voor meer informatie contact op met de beheerder",
	"3781468762": "Uw browser ondersteunt geen WebAuthn",
	"3827227259": "Een bevestigingscode is verstuurd naar",
	"3855542277": "Voer deze code in de app in",
	"3865193889": "Activeren",
	"3877285238": "1 kleine letter",
	"4000449233": "Het onderstaande nummer wordt gebeld:",
	"4072532148": "SMS-code opnieuw versturen",
	"4151518079": "Selecteer een veiligheidsvraag {current} / {total}",
	"4152906165": "We onderzoeken het probleem en verwachten snel weer operationeel te zijn. Wacht een paar minuten {break} en vernieuw uw browser of bezoek onze <link> Statuspagina </link>.",
	"4227081527": "Wanneer de app is geïnstalleerd, keer terug naar dit scherm en klik op {action}",
	"4281662478": "Zoeken",
	addApp: addApp$b,
	addFactor: addFactor$b,
	additionalQuestions: additionalQuestions$b,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$b,
	addNewSecurityQuestion: addNewSecurityQuestion$b,
	administration: administration$b,
	alert: alert$b,
	all: all$b,
	app: app$b,
	appDevice: appDevice$b,
	appDevices: appDevices$b,
	appFactor: appFactor$b,
	application: application$b,
	appName: appName$b,
	appPortal: appPortal$b,
	assumedUserNotification: assumedUserNotification$b,
	broswerExtension: broswerExtension$b,
	browser: browser$b,
	browserDeleteFailure: browserDeleteFailure$b,
	browserDeleteSuccess: browserDeleteSuccess$b,
	browserDevice: browserDevice$b,
	browserFetchFailure: browserFetchFailure$b,
	calling: calling$b,
	callUserAgain: callUserAgain$b,
	cancel: cancel$b,
	changePassword: changePassword$b,
	changeSecurityFactor: changeSecurityFactor$b,
	clearIcon: clearIcon$b,
	close: close$b,
	closeDialog: closeDialog$b,
	codeResent: codeResent$b,
	companyLogo: companyLogo$b,
	companyTab: companyTab$b,
	conditionalRequirement: conditionalRequirement$b,
	configuredOn: configuredOn$b,
	confirm: confirm$b,
	contactAdminEmailOtp: contactAdminEmailOtp$b,
	contactAdminForSMS: contactAdminForSMS$b,
	contactAdminForVoice: contactAdminForVoice$b,
	contactAdminPasswordReset: contactAdminPasswordReset$b,
	credentialId: credentialId$b,
	current: current$b,
	currentPassword: currentPassword$b,
	deleteDeviceSuccess: deleteDeviceSuccess$b,
	deleteQuestion: deleteQuestion$b,
	details: details$b,
	device: device$b,
	deviceDeleteFailure: deviceDeleteFailure$b,
	deviceFetchFailure: deviceFetchFailure$b,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$b,
	deviceRenameFailure: deviceRenameFailure$b,
	downloadOnAppStore: downloadOnAppStore$b,
	editDeviceName: editDeviceName$b,
	editSQinfo: editSQinfo$b,
	enrollNewFactor: enrollNewFactor$b,
	event: event$b,
	eventType: eventType$b,
	eventUserAgent: eventUserAgent$b,
	eventUseragent: eventUseragent$b,
	eventUUID: eventUUID$b,
	eventUuid: eventUuid$b,
	expirationDays: expirationDays$b,
	expireDate: expireDate$b,
	expires: expires$b,
	extensionVersionInstalled: extensionVersionInstalled$b,
	factor: factor$b,
	factorFetchFailure: factorFetchFailure$b,
	factorMfaTokenFailure: factorMfaTokenFailure$b,
	factorPrimaryFailure: factorPrimaryFailure$b,
	factors: factors$b,
	factorsFetchFailure: factorsFetchFailure$b,
	failedToFetchUserInfo: failedToFetchUserInfo$b,
	failedToRegisterAnswers: failedToRegisterAnswers$b,
	failedToRetrieveQuestions: failedToRetrieveQuestions$b,
	forcedLogout: forcedLogout$b,
	getOnGooglePlay: getOnGooglePlay$b,
	goToExternalSite: goToExternalSite$b,
	helpRequestFailed: helpRequestFailed$b,
	helpRequestSuccessful: helpRequestSuccessful$b,
	hostname: hostname$b,
	icon: icon$b,
	identifier: identifier$b,
	imageUpload: imageUpload$b,
	inactive: inactive$b,
	inactiveDevice: inactiveDevice$b,
	install: install$b,
	invalidCode: invalidCode$b,
	invalidPhoneNumber: invalidPhoneNumber$b,
	language: language$b,
	languageConfirmation: languageConfirmation$b,
	lastAuthentication: lastAuthentication$b,
	lastChanged: lastChanged$b,
	lastUsed: lastUsed$b,
	length: length$b,
	letter: letter$b,
	linkToAppStore: linkToAppStore$b,
	linkToGooglePlay: linkToGooglePlay$b,
	loadingRecentActivity: loadingRecentActivity$b,
	loadingTrustedBrowsers: loadingTrustedBrowsers$b,
	location: location$b,
	locationTime: locationTime$b,
	loggedOut: loggedOut$b,
	login: login$b,
	loginDevice: loginDevice$b,
	loginEvent: loginEvent$b,
	loginFactor: loginFactor$b,
	loginFailedEvent: loginFailedEvent$b,
	loginName: loginName$b,
	logOut: logOut$b,
	lower: lower$b,
	message: message$b,
	mfaRegistrationFailure: mfaRegistrationFailure$b,
	mfaRegistrationSuccess: mfaRegistrationSuccess$b,
	more: more$b,
	never: never$b,
	newPassword: newPassword$b,
	newPrimaryFactor: newPrimaryFactor$b,
	noActivities: noActivities$b,
	noDevicesConfigured: noDevicesConfigured$b,
	noExpiration: noExpiration$b,
	noMoreSecurityFactors: noMoreSecurityFactors$b,
	notifyErrorLoadingUser: notifyErrorLoadingUser$b,
	notifySuccessAddApp: notifySuccessAddApp$b,
	noTrustedBrowsers: noTrustedBrowsers$b,
	numbers: numbers$b,
	oneloginDesktop: oneloginDesktop$b,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$b,
	oneloginLogo: oneloginLogo$b,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$b,
	otp1: otp1$b,
	otp2: otp2$b,
	otpDevice: otpDevice$b,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$b,
	password: password$b,
	passwordChanged: passwordChanged$b,
	passwordChangedDays: passwordChangedDays$b,
	passwordHint: passwordHint$b,
	passwordRedirectDescription: passwordRedirectDescription$b,
	passwordReset: passwordReset$b,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$b,
	passwordUpdateFailure: passwordUpdateFailure$b,
	phoneNumber: phoneNumber$b,
	prefix: prefix$b,
	previousDeviceName: previousDeviceName$b,
	primary: primary$b,
	proceedAnyway: proceedAnyway$b,
	profile: profile$b,
	profileAvatar: profileAvatar$b,
	profileMenuToggle: profileMenuToggle$b,
	profilePhoto: profilePhoto$b,
	profilePhotoAction: profilePhotoAction$b,
	pwResetDevice: pwResetDevice$b,
	pwResetFactor: pwResetFactor$b,
	questionNumber: questionNumber$b,
	radiusAuthentication: radiusAuthentication$b,
	recentActivity: recentActivity$b,
	redirectToChangePassword: redirectToChangePassword$b,
	registerSecurityQuestions: registerSecurityQuestions$b,
	registrationRejected: registrationRejected$b,
	registrationTimedout: registrationTimedout$b,
	remove: remove$b,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$b,
	removedProfilePictureSuccess: removedProfilePictureSuccess$b,
	removeFactorWarning: removeFactorWarning$b,
	removeImage: removeImage$b,
	report: report$b,
	reportActivity: reportActivity$b,
	requestField: requestField$b,
	requiredQuestions: requiredQuestions$b,
	revert: revert$b,
	revertToAdmin: revertToAdmin$b,
	revertToSuperadmin: revertToSuperadmin$b,
	revoke: revoke$b,
	save: save$b,
	searchIcon: searchIcon$b,
	secureNotes: secureNotes$b,
	securityFactorAdded: securityFactorAdded$b,
	securityFactorRemoved: securityFactorRemoved$b,
	securityFactorRenamed: securityFactorRenamed$b,
	securityFactors: securityFactors$b,
	securityFactorsDescription: securityFactorsDescription$b,
	securityFactorsUpdated: securityFactorsUpdated$b,
	selectNewImage: selectNewImage$b,
	selectNewPrimary: selectNewPrimary$b,
	selectSecurityFactor: selectSecurityFactor$b,
	sending: sending$b,
	setPrimaryDevice: setPrimaryDevice$b,
	showDetails: showDetails$b,
	specials: specials$b,
	sqDropdownAriaLabel: sqDropdownAriaLabel$b,
	sqInfoHeader: sqInfoHeader$b,
	sqTipBlankAnswers: sqTipBlankAnswers$b,
	sqTipDoNotShare: sqTipDoNotShare$b,
	sqTipMinimum: sqTipMinimum$b,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$b,
	sqTipNoUsePassword: sqTipNoUsePassword$b,
	sqTipSameAnswer: sqTipSameAnswer$b,
	sqTipSpecialChars: sqTipSpecialChars$b,
	submit: submit$b,
	submitting: submitting$b,
	support: support$b,
	supportDefaultDescription: supportDefaultDescription$b,
	supportedBrowsers: supportedBrowsers$b,
	supportRequestHeader: supportRequestHeader$b,
	"switch": "Switch",
	time: time$b,
	trustDevice: trustDevice$b,
	trusted: trusted$b,
	trustedBrowsers: trustedBrowsers$b,
	trustedBrowsersDescription: trustedBrowsersDescription$b,
	trustedDevice: trustedDevice$b,
	unavailable: unavailable$b,
	unavailableTime: unavailableTime$b,
	unsetFactorSuccess: unsetFactorSuccess$b,
	unsetPrimaryDevice: unsetPrimaryDevice$b,
	unsupportedBrowser: unsupportedBrowser$b,
	unsupportedBrowserHeading: unsupportedBrowserHeading$b,
	updateDeviceNameSuccess: updateDeviceNameSuccess$b,
	updateFactorSuccess: updateFactorSuccess$b,
	updatePassword: updatePassword$b,
	updateUserProfileFailure: updateUserProfileFailure$b,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$b,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$b,
	updateUserProfileSuccess: updateUserProfileSuccess$b,
	upper: upper$b,
	usedFor: usedFor$b,
	usedForApp: usedForApp$b,
	usedForLogin: usedForLogin$b,
	usedForPasswordReset: usedForPasswordReset$b,
	version: version$b,
	yourBrowser: yourBrowser$b
};

var addApp$a = "Show {addApp} button when I log in to new websites.";
var addFactor$a = "Add Factor";
var additionalQuestions$a = "Additional Questions";
var addNewPrimaryBeforeRemove$a = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$a = "Add New Security Question";
var administration$a = "Administration";
var alert$a = "Alert";
var all$a = "all";
var app$a = "App";
var appDevice$a = "Denne faktoren brukes til appen.";
var appDevices$a = "Denne faktoren brukes til appen";
var appFactor$a = "Denne faktoren brukes til appen.";
var application$a = "Application";
var appName$a = "App Name";
var appPortal$a = "App Portal";
var assumedUserNotification$a = "You cannot edit personal information while assuming a user.";
var broswerExtension$a = "Browser Extension";
var browser$a = "Browser";
var browserDeleteFailure$a = "Failed to delete trusted browser";
var browserDeleteSuccess$a = "Trusted browser was successfully deleted";
var browserDevice$a = "Browser/Device";
var browserFetchFailure$a = "Failed to fetch browsers";
var calling$a = "Ringer";
var callUserAgain$a = "Calling you again";
var cancel$a = "avbryt";
var changePassword$a = "Change Password";
var changeSecurityFactor$a = "Change Security Factor";
var clearIcon$a = "sletteikon";
var close$a = "Close";
var closeDialog$a = "Lukk dialog";
var codeResent$a = "Code has been sent to your phone.";
var companyLogo$a = "selskapets logo";
var companyTab$a = "Default for company tab";
var conditionalRequirement$a = "At least {number} of the following requirements:";
var configuredOn$a = "Configured On";
var confirm$a = "bekreft";
var contactAdminEmailOtp$a = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$a = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$a = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$a = "Contact your admin to reset password.";
var credentialId$a = "Credential ID";
var current$a = "Current";
var currentPassword$a = "Current password";
var deleteDeviceSuccess$a = "{factorName} was successfully deleted";
var deleteQuestion$a = "Delete question {position}";
var details$a = "Details";
var device$a = "Device";
var deviceDeleteFailure$a = "Failed to remove {factorName}";
var deviceFetchFailure$a = "Failed to fetch devices";
var deviceNameCannotBeBlank$a = "Authentication device name cannot be blank.";
var deviceRenameFailure$a = "Failed to update device name";
var downloadOnAppStore$a = "Last ned hos App Store";
var editDeviceName$a = "Edit name";
var editSQinfo$a = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$a = "Enroll new primary factor";
var event$a = "Event";
var eventType$a = "Event Type";
var eventUserAgent$a = "Event Useragent";
var eventUseragent$a = "Event Useragent";
var eventUUID$a = "Event UUID";
var eventUuid$a = "Event UUID";
var expirationDays$a = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$a = "Expire Date";
var expires$a = "Expires";
var extensionVersionInstalled$a = "Version {versionString} installed";
var factor$a = "Factor";
var factorFetchFailure$a = "Failed to fetch available factors";
var factorMfaTokenFailure$a = "Failed to fetch mfa token";
var factorPrimaryFailure$a = "Failed to set {factorName} as your primary factor";
var factors$a = "factors";
var factorsFetchFailure$a = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$a = "We couldn’t load your user information.";
var failedToRegisterAnswers$a = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$a = "We couldn't retrieve your security questions at this time.";
var forcedLogout$a = "Forced Logout";
var getOnGooglePlay$a = "Få det hos Google Play";
var goToExternalSite$a = "Go to external site";
var helpRequestFailed$a = "We couldn't submit your help request.";
var helpRequestSuccessful$a = "Your support request has been sent to your OneLogin Admin.";
var hostname$a = "Hostname & OS";
var icon$a = "Icon";
var identifier$a = "Credential ID / Identifier";
var imageUpload$a = "Image Upload";
var inactive$a = "Inactive";
var inactiveDevice$a = "Inactive device";
var install$a = "Install";
var invalidCode$a = "Invalid code";
var invalidPhoneNumber$a = "Please use valid phone number.";
var language$a = "Language";
var languageConfirmation$a = "Are you sure you want to switch to {language}?";
var lastAuthentication$a = "Last Authentication";
var lastChanged$a = "Last changed";
var lastUsed$a = "Last Used";
var length$a = "Minimum {length} characters";
var letter$a = "1 Letter";
var linkToAppStore$a = "Lenke til App Store";
var linkToGooglePlay$a = "Lenke til Google Play";
var loadingRecentActivity$a = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$a = "Loading trusted browsers, please wait...";
var location$a = "Location";
var locationTime$a = "Location/Time";
var loggedOut$a = "Logged Out";
var login$a = "login";
var loginDevice$a = "Login device";
var loginEvent$a = "Login";
var loginFactor$a = "Denne faktoren brukes til innlogging.";
var loginFailedEvent$a = "Login Failed";
var loginName$a = "Login Name";
var logOut$a = "Log Out";
var lower$a = "1 Lowercase";
var message$a = "{name} was successfully added.";
var mfaRegistrationFailure$a = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$a = "You successfully registered the device";
var more$a = "More";
var never$a = "Never";
var newPassword$a = "New password";
var newPrimaryFactor$a = "New primary factor";
var noActivities$a = "No activities have been made";
var noDevicesConfigured$a = "No devices have been configured";
var noExpiration$a = "Never expires";
var noMoreSecurityFactors$a = "There are no security factors available for registration.";
var notifyErrorLoadingUser$a = "Loading of user failed. Try again later";
var notifySuccessAddApp$a = "{name} was successfully added.";
var noTrustedBrowsers$a = "No browsers have been saved";
var numbers$a = "1 Number";
var oneloginDesktop$a = "OneLogin Desktop";
var oneloginDesktopFetchFailure$a = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$a = "OneLogin logo";
var onlyDesktopBrowsersSupported$a = "We currently only support browser extensions on desktop browsers.";
var otp1$a = "OTP 1";
var otp2$a = "OTP 2";
var otpDevice$a = "Denne faktoren brukes til pålogging.";
var parsingUserProfilePhotoFailure$a = "Getting image details failed";
var password$a = "password";
var passwordChanged$a = "Password Changed";
var passwordChangedDays$a = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$a = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$a = "Your administrator has configured an external site for resetting your password.";
var passwordReset$a = "Password Reset";
var passwordUpdatedSuccessfully$a = "You have successfully updated your password.";
var passwordUpdateFailure$a = "Password update failed";
var phoneNumber$a = "Phone number";
var prefix$a = "Suspicious login report";
var previousDeviceName$a = "Previously {previousName}";
var primary$a = "Primary";
var proceedAnyway$a = "Proceed anyway";
var profile$a = "Profile";
var profileAvatar$a = "Profile avatar";
var profileMenuToggle$a = "Open profile menu";
var profilePhoto$a = "Profile photo";
var profilePhotoAction$a = "Profile image action";
var pwResetDevice$a = "Denne faktoren brukes til tilbakestilling av passord.";
var pwResetFactor$a = "Denne faktoren brukes til å tilbakestille passord.";
var questionNumber$a = "Question {position}";
var radiusAuthentication$a = "Service Login via Radius";
var recentActivity$a = "Recent Activity";
var redirectToChangePassword$a = "Redirect to change your password?";
var registerSecurityQuestions$a = "Register Security Questions";
var registrationRejected$a = "Registration unsuccessful, please try again.";
var registrationTimedout$a = "Registration context timed out";
var remove$a = "Remove";
var removeCurrentBrowserWarning$a = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$a = "You have successfully removed your profile picture.";
var removeFactorWarning$a = "Are you sure you want to remove {factor}?";
var removeImage$a = "Remove image";
var report$a = "Report";
var reportActivity$a = "Report Activity";
var requestField$a = "Describe the issue you're having";
var requiredQuestions$a = "Required Questions";
var revert$a = "gå tilbake til";
var revertToAdmin$a = "Revert to Admin";
var revertToSuperadmin$a = "Revert to OneLogin Admin";
var revoke$a = "Revoke";
var save$a = "Save Changes";
var searchIcon$a = "søkeikon";
var secureNotes$a = "Secure Notes";
var securityFactorAdded$a = "Security Factor Added";
var securityFactorRemoved$a = "Security Factor Removed";
var securityFactorRenamed$a = "Security Factor Renamed";
var securityFactors$a = "Security Factors";
var securityFactorsDescription$a = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$a = "Security Factors Updated";
var selectNewImage$a = "Select new image";
var selectNewPrimary$a = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$a = "Select Security Factor";
var sending$a = "Sender";
var setPrimaryDevice$a = "Set as primary";
var showDetails$a = "Vis detaljer";
var specials$a = "1 Special character";
var sqDropdownAriaLabel$a = "Question {position} dropdown";
var sqInfoHeader$a = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$a = "Blank answers will not be accepted";
var sqTipDoNotShare$a = "Do not share your questions and answers with anyone.";
var sqTipMinimum$a = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$a = "Answers are not case-sensitive.";
var sqTipNoUsePassword$a = "Do not use a password as an answer.";
var sqTipSameAnswer$a = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$a = "Special characters such as @#&*. will be ignored";
var submit$a = "Submit";
var submitting$a = "Submitting…";
var support$a = "Support";
var supportDefaultDescription$a = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$a = "Supported browsers: {browsers}";
var supportRequestHeader$a = "Support Request";
var time$a = "Time";
var trustDevice$a = "Trust Device";
var trusted$a = "Trusted";
var trustedBrowsers$a = "Trusted Browsers";
var trustedBrowsersDescription$a = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$a = "Trusted Device";
var unavailable$a = "Unavailable";
var unavailableTime$a = "Unavailable";
var unsetFactorSuccess$a = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$a = "Unset as primary";
var unsupportedBrowser$a = "Unsupported Browser";
var unsupportedBrowserHeading$a = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$a = "{newName} was successfully updated";
var updateFactorSuccess$a = "{factorName} is your new default security factor";
var updatePassword$a = "Update Password";
var updateUserProfileFailure$a = "Profile Update Failed";
var updateUserProfilePhotoFailure$a = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$a = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$a = "You have successfully updated your profile.";
var upper$a = "1 Uppercase";
var usedFor$a = "Used For";
var usedForApp$a = "This factor is used for app.";
var usedForLogin$a = "This factor is used for login.";
var usedForPasswordReset$a = "This factor is used for password reset.";
var version$a = "Version: {versionString}";
var yourBrowser$a = "Your browser: {browser}";
var no = {
	"26286820": "Oppgi brukeridentifikasjon og to fortløpende sikkerhetskoder fra Symantec VIP-tilgang.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Legg inn koden du mottok på SMS.",
	"374233718": "Du kan prøve igjen om {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
	"437305782": "Bekrefter din WebAuthn-autentikator nå.",
	"505702857": "Magic Link",
	"519412053": "Endre autentiseringsfaktor.",
	"655462232": "Last ned og installer OneLogin Protect på enheten din.",
	"660592555": "OK",
	"662924178": "Ser ut som dette ikke er vår dag.",
	"694278426": "Oppgi koden din for {deviceName}",
	"694920552": "Første sikkerhetskode",
	"737192390": "Åpne {appNavn}",
	"740457555": "Kode nummer to",
	"744377571": "Minimum {lengde} karakterer",
	"751710530": "Send inn",
	"916760408": "Legg inn et brukernavn og sikkerhetskode fra enheten din.",
	"921093870": "Ikke mottatt koden?",
	"966052509": "Ingen resultater",
	"987359842": "Vennligst klikk på lenken i e-posten din for å fortsette",
	"1068496829": "Velg sikkerhetsspørsmål {nåværende}/{total}",
	"1079852660": "Legg inn to påfølgende sikkerhetskoder",
	"1080736814": "Legg inn {feltNavn} fra Symantec VIP Access-appen",
	"1136625613": "Prosessen ble kansellert. Prøv igjen eller bruk en annen autentiseringsfaktor.",
	"1212847248": "En bekreftelseskode ble sendt til adressen din.",
	"1232460711": "Oppgi e-postadressen din",
	"1242107845": "Vis",
	"1254879564": "Nytt passord",
	"1359200231": "Send",
	"1433651550": "Legg inn koden fra OneLogin SMS.",
	"1477893598": "Konfigurer",
	"1536965459": "Last ned og installer OneLogin Protect på enheten din",
	"1624184662": "For å sette opp OneLogin SMS kommer vi til å sende deg en aktiveringskode via SMS. Du vil trenge denne aktiveringskoden for å fullføre enhetsregistreringen.",
	"1654624862": "Sikkerhetskode",
	"1833121415": "Svar {nåværende}/{total}",
	"1919587067": "Send kode på nytt",
	"1935535842": "Påkrevd",
	"1963245695": "1 store bokstaver",
	"2018264248": "Prøv igjen",
	"2091874550": "Første kode",
	"2097632732": "Skann strekkode i stedet",
	"2104438124": "Legg inn {feltNavn} og to påfølgende sikkerhetskoder fra Symantec VIP Access.",
	"2124363772": "Legg inn brukernavnet ditt og sikkerhetskoden fra SecurID-kodebrikken din.",
	"2229754167": "Oppgi telefonnummeret ditt",
	"2244720377": "Det ser ut som at det har oppstått en uventet feil.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "En tilgangslenke er sendt til e-posten din",
	"2600324508": "Skjul",
	"2606375562": "Sett din YubiKey i USB-porten og trykk på knappen",
	"2663586870": "Brukernavn",
	"2758306961": "Brukeridentifikasjon",
	"2792137744": "1 nummer",
	"2815222727": "Skann denne strekkoden",
	"2828880379": "Bekreft",
	"2859281487": "To-faktor-autentisering er påkrevd for å sikre kontoen din.",
	"2942752129": "Sikkerhetskode nummer to",
	"3060896801": "Problemer?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 spesialtegn",
	"3294346597": "Prøv igjen",
	"3327626662": "Oppgi bekreftelseskoden din",
	"3374226769": "Klikk på par ved å benytte manuell innlegging",
	"3469481929": "Kan ikke skanne koden?",
	"3499598078": "Åpne meny",
	"3528672691": "Avbryt",
	"3640052215": "Fortsett",
	"3645029425": "Skann QR-koden nedenfor",
	"3645116517": "Oppgi denne koden når du mottar samtalen:",
	"3663548834": "Vi undersøker problemet og regner med at vi snart er tilbake. Vent et par minutter<br />og oppdater nettleseren din, eller besøk <a href='https://www.onelogin.com/status'>statussiden</a> vår.",
	"3669652728": "En tilgangslenke er sendt til",
	"3673120330": "Neste",
	"3737470122": "Kontakt administrator for ytterligere informasjon.",
	"3781468762": "Nettleseren din støtter ikke WebAunth",
	"3827227259": "En bekreftelseskode ble sendt til",
	"3855542277": "Legg denne koden inn i appen",
	"3865193889": "Aktiver",
	"3877285238": "1 liten bokstav",
	"4000449233": "Ringer telefonnummeret under:",
	"4072532148": "Send SMS-kode på nytt",
	"4151518079": "Velg sikkerhetsspørsmål {nåværende} / {total}",
	"4152906165": "Vi undersøker problemet og forventer å være tilbake snart. Vent noen minutter{break}og oppdater nettleseren, eller besøk <link>statussiden</link> vår.",
	"4227081527": "Når appen er installert, kom tilbake til dette skjermbildet og klikk {aksjon}",
	"4281662478": "Søk",
	addApp: addApp$a,
	addFactor: addFactor$a,
	additionalQuestions: additionalQuestions$a,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$a,
	addNewSecurityQuestion: addNewSecurityQuestion$a,
	administration: administration$a,
	alert: alert$a,
	all: all$a,
	app: app$a,
	appDevice: appDevice$a,
	appDevices: appDevices$a,
	appFactor: appFactor$a,
	application: application$a,
	appName: appName$a,
	appPortal: appPortal$a,
	assumedUserNotification: assumedUserNotification$a,
	broswerExtension: broswerExtension$a,
	browser: browser$a,
	browserDeleteFailure: browserDeleteFailure$a,
	browserDeleteSuccess: browserDeleteSuccess$a,
	browserDevice: browserDevice$a,
	browserFetchFailure: browserFetchFailure$a,
	calling: calling$a,
	callUserAgain: callUserAgain$a,
	cancel: cancel$a,
	changePassword: changePassword$a,
	changeSecurityFactor: changeSecurityFactor$a,
	clearIcon: clearIcon$a,
	close: close$a,
	closeDialog: closeDialog$a,
	codeResent: codeResent$a,
	companyLogo: companyLogo$a,
	companyTab: companyTab$a,
	conditionalRequirement: conditionalRequirement$a,
	configuredOn: configuredOn$a,
	confirm: confirm$a,
	contactAdminEmailOtp: contactAdminEmailOtp$a,
	contactAdminForSMS: contactAdminForSMS$a,
	contactAdminForVoice: contactAdminForVoice$a,
	contactAdminPasswordReset: contactAdminPasswordReset$a,
	credentialId: credentialId$a,
	current: current$a,
	currentPassword: currentPassword$a,
	deleteDeviceSuccess: deleteDeviceSuccess$a,
	deleteQuestion: deleteQuestion$a,
	details: details$a,
	device: device$a,
	deviceDeleteFailure: deviceDeleteFailure$a,
	deviceFetchFailure: deviceFetchFailure$a,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$a,
	deviceRenameFailure: deviceRenameFailure$a,
	downloadOnAppStore: downloadOnAppStore$a,
	editDeviceName: editDeviceName$a,
	editSQinfo: editSQinfo$a,
	enrollNewFactor: enrollNewFactor$a,
	event: event$a,
	eventType: eventType$a,
	eventUserAgent: eventUserAgent$a,
	eventUseragent: eventUseragent$a,
	eventUUID: eventUUID$a,
	eventUuid: eventUuid$a,
	expirationDays: expirationDays$a,
	expireDate: expireDate$a,
	expires: expires$a,
	extensionVersionInstalled: extensionVersionInstalled$a,
	factor: factor$a,
	factorFetchFailure: factorFetchFailure$a,
	factorMfaTokenFailure: factorMfaTokenFailure$a,
	factorPrimaryFailure: factorPrimaryFailure$a,
	factors: factors$a,
	factorsFetchFailure: factorsFetchFailure$a,
	failedToFetchUserInfo: failedToFetchUserInfo$a,
	failedToRegisterAnswers: failedToRegisterAnswers$a,
	failedToRetrieveQuestions: failedToRetrieveQuestions$a,
	forcedLogout: forcedLogout$a,
	getOnGooglePlay: getOnGooglePlay$a,
	goToExternalSite: goToExternalSite$a,
	helpRequestFailed: helpRequestFailed$a,
	helpRequestSuccessful: helpRequestSuccessful$a,
	hostname: hostname$a,
	icon: icon$a,
	identifier: identifier$a,
	imageUpload: imageUpload$a,
	inactive: inactive$a,
	inactiveDevice: inactiveDevice$a,
	install: install$a,
	invalidCode: invalidCode$a,
	invalidPhoneNumber: invalidPhoneNumber$a,
	language: language$a,
	languageConfirmation: languageConfirmation$a,
	lastAuthentication: lastAuthentication$a,
	lastChanged: lastChanged$a,
	lastUsed: lastUsed$a,
	length: length$a,
	letter: letter$a,
	linkToAppStore: linkToAppStore$a,
	linkToGooglePlay: linkToGooglePlay$a,
	loadingRecentActivity: loadingRecentActivity$a,
	loadingTrustedBrowsers: loadingTrustedBrowsers$a,
	location: location$a,
	locationTime: locationTime$a,
	loggedOut: loggedOut$a,
	login: login$a,
	loginDevice: loginDevice$a,
	loginEvent: loginEvent$a,
	loginFactor: loginFactor$a,
	loginFailedEvent: loginFailedEvent$a,
	loginName: loginName$a,
	logOut: logOut$a,
	lower: lower$a,
	message: message$a,
	mfaRegistrationFailure: mfaRegistrationFailure$a,
	mfaRegistrationSuccess: mfaRegistrationSuccess$a,
	more: more$a,
	never: never$a,
	newPassword: newPassword$a,
	newPrimaryFactor: newPrimaryFactor$a,
	noActivities: noActivities$a,
	noDevicesConfigured: noDevicesConfigured$a,
	noExpiration: noExpiration$a,
	noMoreSecurityFactors: noMoreSecurityFactors$a,
	notifyErrorLoadingUser: notifyErrorLoadingUser$a,
	notifySuccessAddApp: notifySuccessAddApp$a,
	noTrustedBrowsers: noTrustedBrowsers$a,
	numbers: numbers$a,
	oneloginDesktop: oneloginDesktop$a,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$a,
	oneloginLogo: oneloginLogo$a,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$a,
	otp1: otp1$a,
	otp2: otp2$a,
	otpDevice: otpDevice$a,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$a,
	password: password$a,
	passwordChanged: passwordChanged$a,
	passwordChangedDays: passwordChangedDays$a,
	passwordHint: passwordHint$a,
	passwordRedirectDescription: passwordRedirectDescription$a,
	passwordReset: passwordReset$a,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$a,
	passwordUpdateFailure: passwordUpdateFailure$a,
	phoneNumber: phoneNumber$a,
	prefix: prefix$a,
	previousDeviceName: previousDeviceName$a,
	primary: primary$a,
	proceedAnyway: proceedAnyway$a,
	profile: profile$a,
	profileAvatar: profileAvatar$a,
	profileMenuToggle: profileMenuToggle$a,
	profilePhoto: profilePhoto$a,
	profilePhotoAction: profilePhotoAction$a,
	pwResetDevice: pwResetDevice$a,
	pwResetFactor: pwResetFactor$a,
	questionNumber: questionNumber$a,
	radiusAuthentication: radiusAuthentication$a,
	recentActivity: recentActivity$a,
	redirectToChangePassword: redirectToChangePassword$a,
	registerSecurityQuestions: registerSecurityQuestions$a,
	registrationRejected: registrationRejected$a,
	registrationTimedout: registrationTimedout$a,
	remove: remove$a,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$a,
	removedProfilePictureSuccess: removedProfilePictureSuccess$a,
	removeFactorWarning: removeFactorWarning$a,
	removeImage: removeImage$a,
	report: report$a,
	reportActivity: reportActivity$a,
	requestField: requestField$a,
	requiredQuestions: requiredQuestions$a,
	revert: revert$a,
	revertToAdmin: revertToAdmin$a,
	revertToSuperadmin: revertToSuperadmin$a,
	revoke: revoke$a,
	save: save$a,
	searchIcon: searchIcon$a,
	secureNotes: secureNotes$a,
	securityFactorAdded: securityFactorAdded$a,
	securityFactorRemoved: securityFactorRemoved$a,
	securityFactorRenamed: securityFactorRenamed$a,
	securityFactors: securityFactors$a,
	securityFactorsDescription: securityFactorsDescription$a,
	securityFactorsUpdated: securityFactorsUpdated$a,
	selectNewImage: selectNewImage$a,
	selectNewPrimary: selectNewPrimary$a,
	selectSecurityFactor: selectSecurityFactor$a,
	sending: sending$a,
	setPrimaryDevice: setPrimaryDevice$a,
	showDetails: showDetails$a,
	specials: specials$a,
	sqDropdownAriaLabel: sqDropdownAriaLabel$a,
	sqInfoHeader: sqInfoHeader$a,
	sqTipBlankAnswers: sqTipBlankAnswers$a,
	sqTipDoNotShare: sqTipDoNotShare$a,
	sqTipMinimum: sqTipMinimum$a,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$a,
	sqTipNoUsePassword: sqTipNoUsePassword$a,
	sqTipSameAnswer: sqTipSameAnswer$a,
	sqTipSpecialChars: sqTipSpecialChars$a,
	submit: submit$a,
	submitting: submitting$a,
	support: support$a,
	supportDefaultDescription: supportDefaultDescription$a,
	supportedBrowsers: supportedBrowsers$a,
	supportRequestHeader: supportRequestHeader$a,
	"switch": "Switch",
	time: time$a,
	trustDevice: trustDevice$a,
	trusted: trusted$a,
	trustedBrowsers: trustedBrowsers$a,
	trustedBrowsersDescription: trustedBrowsersDescription$a,
	trustedDevice: trustedDevice$a,
	unavailable: unavailable$a,
	unavailableTime: unavailableTime$a,
	unsetFactorSuccess: unsetFactorSuccess$a,
	unsetPrimaryDevice: unsetPrimaryDevice$a,
	unsupportedBrowser: unsupportedBrowser$a,
	unsupportedBrowserHeading: unsupportedBrowserHeading$a,
	updateDeviceNameSuccess: updateDeviceNameSuccess$a,
	updateFactorSuccess: updateFactorSuccess$a,
	updatePassword: updatePassword$a,
	updateUserProfileFailure: updateUserProfileFailure$a,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$a,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$a,
	updateUserProfileSuccess: updateUserProfileSuccess$a,
	upper: upper$a,
	usedFor: usedFor$a,
	usedForApp: usedForApp$a,
	usedForLogin: usedForLogin$a,
	usedForPasswordReset: usedForPasswordReset$a,
	version: version$a,
	yourBrowser: yourBrowser$a
};

var addApp$9 = "Show {addApp} button when I log in to new websites.";
var addFactor$9 = "Add Factor";
var additionalQuestions$9 = "Additional Questions";
var addNewPrimaryBeforeRemove$9 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$9 = "Add New Security Question";
var administration$9 = "Administration";
var alert$9 = "Alert";
var all$9 = "all";
var app$9 = "App";
var appDevice$9 = "Ten składnik używany jest do aplikacji.";
var appDevices$9 = "Ten czynnik używany jest do aplikacji.";
var appFactor$9 = "Ten składnik używany jest do aplikacji.";
var application$9 = "Application";
var appName$9 = "App Name";
var appPortal$9 = "App Portal";
var assumedUserNotification$9 = "You cannot edit personal information while assuming a user.";
var broswerExtension$9 = "Browser Extension";
var browser$9 = "Browser";
var browserDeleteFailure$9 = "Failed to delete trusted browser";
var browserDeleteSuccess$9 = "Trusted browser was successfully deleted";
var browserDevice$9 = "Browser/Device";
var browserFetchFailure$9 = "Failed to fetch browsers";
var calling$9 = "Dzwonię";
var callUserAgain$9 = "Calling you again";
var cancel$9 = "anuluj";
var changePassword$9 = "Change Password";
var changeSecurityFactor$9 = "Change Security Factor";
var clearIcon$9 = "wyczyść ikonę";
var close$9 = "Close";
var closeDialog$9 = "Zamknij okno dialogowe";
var codeResent$9 = "Code has been sent to your phone.";
var companyLogo$9 = "logo firmy";
var companyTab$9 = "Default for company tab";
var conditionalRequirement$9 = "At least {number} of the following requirements:";
var configuredOn$9 = "Configured On";
var confirm$9 = "potwierdź";
var contactAdminEmailOtp$9 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$9 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$9 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$9 = "Contact your admin to reset password.";
var credentialId$9 = "Credential ID";
var current$9 = "Current";
var currentPassword$9 = "Current password";
var deleteDeviceSuccess$9 = "{factorName} was successfully deleted";
var deleteQuestion$9 = "Delete question {position}";
var details$9 = "Details";
var device$9 = "Device";
var deviceDeleteFailure$9 = "Failed to remove {factorName}";
var deviceFetchFailure$9 = "Failed to fetch devices";
var deviceNameCannotBeBlank$9 = "Authentication device name cannot be blank.";
var deviceRenameFailure$9 = "Failed to update device name";
var downloadOnAppStore$9 = "Pobierz w sklepie z aplikacjami";
var editDeviceName$9 = "Edit name";
var editSQinfo$9 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$9 = "Enroll new primary factor";
var event$9 = "Event";
var eventType$9 = "Event Type";
var eventUserAgent$9 = "Event Useragent";
var eventUseragent$9 = "Event Useragent";
var eventUUID$9 = "Event UUID";
var eventUuid$9 = "Event UUID";
var expirationDays$9 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$9 = "Expire Date";
var expires$9 = "Expires";
var extensionVersionInstalled$9 = "Version {versionString} installed";
var factor$9 = "Factor";
var factorFetchFailure$9 = "Failed to fetch available factors";
var factorMfaTokenFailure$9 = "Failed to fetch mfa token";
var factorPrimaryFailure$9 = "Failed to set {factorName} as your primary factor";
var factors$9 = "factors";
var factorsFetchFailure$9 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$9 = "We couldn’t load your user information.";
var failedToRegisterAnswers$9 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$9 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$9 = "Forced Logout";
var getOnGooglePlay$9 = "Pobierz z Google Play";
var goToExternalSite$9 = "Go to external site";
var helpRequestFailed$9 = "We couldn't submit your help request.";
var helpRequestSuccessful$9 = "Your support request has been sent to your OneLogin Admin.";
var hostname$9 = "Hostname & OS";
var icon$9 = "Icon";
var identifier$9 = "Credential ID / Identifier";
var imageUpload$9 = "Image Upload";
var inactive$9 = "Inactive";
var inactiveDevice$9 = "Inactive device";
var install$9 = "Install";
var invalidCode$9 = "Invalid code";
var invalidPhoneNumber$9 = "Please use valid phone number.";
var language$9 = "Language";
var languageConfirmation$9 = "Are you sure you want to switch to {language}?";
var lastAuthentication$9 = "Last Authentication";
var lastChanged$9 = "Last changed";
var lastUsed$9 = "Last Used";
var length$9 = "Minimum {length} characters";
var letter$9 = "1 Letter";
var linkToAppStore$9 = "Linkuj do App Store";
var linkToGooglePlay$9 = "Linkuj do Google Play";
var loadingRecentActivity$9 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$9 = "Loading trusted browsers, please wait...";
var location$9 = "Location";
var locationTime$9 = "Location/Time";
var loggedOut$9 = "Logged Out";
var login$9 = "login";
var loginDevice$9 = "Login device";
var loginEvent$9 = "Login";
var loginFactor$9 = "Ten składnik używany jest do logowania.";
var loginFailedEvent$9 = "Login Failed";
var loginName$9 = "Login Name";
var logOut$9 = "Log Out";
var lower$9 = "1 Lowercase";
var message$9 = "{name} was successfully added.";
var mfaRegistrationFailure$9 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$9 = "You successfully registered the device";
var more$9 = "More";
var never$9 = "Never";
var newPassword$9 = "New password";
var newPrimaryFactor$9 = "New primary factor";
var noActivities$9 = "No activities have been made";
var noDevicesConfigured$9 = "No devices have been configured";
var noExpiration$9 = "Never expires";
var noMoreSecurityFactors$9 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$9 = "Loading of user failed. Try again later";
var notifySuccessAddApp$9 = "{name} was successfully added.";
var noTrustedBrowsers$9 = "No browsers have been saved";
var numbers$9 = "1 Number";
var oneloginDesktop$9 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$9 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$9 = "OneLogin logo";
var onlyDesktopBrowsersSupported$9 = "We currently only support browser extensions on desktop browsers.";
var otp1$9 = "OTP 1";
var otp2$9 = "OTP 2";
var otpDevice$9 = "Ten czynnik używany jest do logowania.";
var parsingUserProfilePhotoFailure$9 = "Getting image details failed";
var password$9 = "password";
var passwordChanged$9 = "Password Changed";
var passwordChangedDays$9 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$9 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$9 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$9 = "Password Reset";
var passwordUpdatedSuccessfully$9 = "You have successfully updated your password.";
var passwordUpdateFailure$9 = "Password update failed";
var phoneNumber$9 = "Phone number";
var prefix$9 = "Suspicious login report";
var previousDeviceName$9 = "Previously {previousName}";
var primary$9 = "Primary";
var proceedAnyway$9 = "Proceed anyway";
var profile$9 = "Profile";
var profileAvatar$9 = "Profile avatar";
var profileMenuToggle$9 = "Open profile menu";
var profilePhoto$9 = "Profile photo";
var profilePhotoAction$9 = "Profile image action";
var pwResetDevice$9 = "Ten czynnik używany jest do zresetowania hasła.";
var pwResetFactor$9 = "Ten składnik używany jest do resetowania hasła.";
var questionNumber$9 = "Question {position}";
var radiusAuthentication$9 = "Service Login via Radius";
var recentActivity$9 = "Recent Activity";
var redirectToChangePassword$9 = "Redirect to change your password?";
var registerSecurityQuestions$9 = "Register Security Questions";
var registrationRejected$9 = "Registration unsuccessful, please try again.";
var registrationTimedout$9 = "Registration context timed out";
var remove$9 = "Remove";
var removeCurrentBrowserWarning$9 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$9 = "You have successfully removed your profile picture.";
var removeFactorWarning$9 = "Are you sure you want to remove {factor}?";
var removeImage$9 = "Remove image";
var report$9 = "Report";
var reportActivity$9 = "Report Activity";
var requestField$9 = "Describe the issue you're having";
var requiredQuestions$9 = "Required Questions";
var revert$9 = "cofnij";
var revertToAdmin$9 = "Revert to Admin";
var revertToSuperadmin$9 = "Revert to OneLogin Admin";
var revoke$9 = "Revoke";
var save$9 = "Save Changes";
var searchIcon$9 = "szukaj ikony";
var secureNotes$9 = "Secure Notes";
var securityFactorAdded$9 = "Security Factor Added";
var securityFactorRemoved$9 = "Security Factor Removed";
var securityFactorRenamed$9 = "Security Factor Renamed";
var securityFactors$9 = "Security Factors";
var securityFactorsDescription$9 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$9 = "Security Factors Updated";
var selectNewImage$9 = "Select new image";
var selectNewPrimary$9 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$9 = "Select Security Factor";
var sending$9 = "Wysyłanie";
var setPrimaryDevice$9 = "Set as primary";
var showDetails$9 = "Pokaż szczegóły";
var specials$9 = "1 Special character";
var sqDropdownAriaLabel$9 = "Question {position} dropdown";
var sqInfoHeader$9 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$9 = "Blank answers will not be accepted";
var sqTipDoNotShare$9 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$9 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$9 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$9 = "Do not use a password as an answer.";
var sqTipSameAnswer$9 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$9 = "Special characters such as @#&*. will be ignored";
var submit$9 = "Submit";
var submitting$9 = "Submitting…";
var support$9 = "Support";
var supportDefaultDescription$9 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$9 = "Supported browsers: {browsers}";
var supportRequestHeader$9 = "Support Request";
var time$9 = "Time";
var trustDevice$9 = "Trust Device";
var trusted$9 = "Trusted";
var trustedBrowsers$9 = "Trusted Browsers";
var trustedBrowsersDescription$9 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$9 = "Trusted Device";
var unavailable$9 = "Unavailable";
var unavailableTime$9 = "Unavailable";
var unsetFactorSuccess$9 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$9 = "Unset as primary";
var unsupportedBrowser$9 = "Unsupported Browser";
var unsupportedBrowserHeading$9 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$9 = "{newName} was successfully updated";
var updateFactorSuccess$9 = "{factorName} is your new default security factor";
var updatePassword$9 = "Update Password";
var updateUserProfileFailure$9 = "Profile Update Failed";
var updateUserProfilePhotoFailure$9 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$9 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$9 = "You have successfully updated your profile.";
var upper$9 = "1 Uppercase";
var usedFor$9 = "Used For";
var usedForApp$9 = "This factor is used for app.";
var usedForLogin$9 = "This factor is used for login.";
var usedForPasswordReset$9 = "This factor is used for password reset.";
var version$9 = "Version: {versionString}";
var yourBrowser$9 = "Your browser: {browser}";
var plPL = {
	"26286820": "Wprowadź ID uwierzytelniania i dwa kolejne kody bezpieczeństwa z Symantec VIP Access.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Wpisz kod otrzymany w wiadomości SMS.",
	"374233718": "Możesz spróbować ponownie za {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
	"437305782": "Weryfikuję teraz Twoje wartości uwierzytelniające WebAuthn.",
	"505702857": "Magiczny odnośnik",
	"519412053": "Zmień składnik uwierzytelnienia",
	"655462232": "Pobierz i zainstaluj program OneLogin Protect na swoim urządzeniu.",
	"660592555": "OK",
	"662924178": "Wygląda na to, że dziś nie jest nasz dzień.",
	"694278426": "Wprowadź kod {deviceName}",
	"694920552": "Pierwszy kod bezpieczeństwa",
	"737192390": "Otwórz {appName}",
	"740457555": "Drugi kod",
	"744377571": "Minimalna {length} znaków",
	"751710530": "Prześlij",
	"916760408": "Wpisz nazwę użytkownika i kod bezpieczeństwa ze swojego urządzenia.",
	"921093870": "Nie otrzymałeś(aś) kodu?",
	"966052509": "Brak wyników",
	"987359842": "Kliknij link w e-mailu, aby kontynuować",
	"1068496829": "Wybierz pytanie bezpieczeństwa {current}/{total}",
	"1079852660": "Wpisz dwa kolejne kody bezpieczeństwa",
	"1080736814": "Wpisz {fieldName} z aplikacji Symantec VIP Access",
	"1136625613": "Proces został anulowany. Spróbuj ponownie lub użyj innego składnika uwierzytelniania.",
	"1212847248": "Kod potwierdzenia został wysłany na Twój skonfigurowany adres.",
	"1232460711": "Wpisz adres mailowy",
	"1242107845": "Pokaż",
	"1254879564": "Nowe hasło",
	"1359200231": "Wyślij",
	"1433651550": "Wpisz kod z programu OneLogin SMS.",
	"1477893598": "Skonfiguruj",
	"1536965459": "Pobierz i zainstaluj program OneLogin Protect na swoim urządzeniu.",
	"1624184662": "W celu skonfigurowania aplikacji OneLogin SMS, prześlemy Ci kod aktywacyjny przez SMS. Będziesz go potrzebować do zakończenia rejestracji urządzenia.",
	"1654624862": "Kod bezpieczeństwa",
	"1833121415": "Podaj odpowiedź {current}/{total}",
	"1919587067": "Wyślij kod ponownie",
	"1935535842": "Wymagane",
	"1963245695": "1 wielka litera",
	"2018264248": "Spróbuj ponownie",
	"2091874550": "Pierwszy kod",
	"2097632732": "Zamiast tego zeskanuj kod kreskowy",
	"2104438124": "Wpisz {fieldName} i dwa kolejne kody bezpieczeństwa z programu Symantec VIP Access.",
	"2124363772": "Wpisz swoją nazwę użytkownika i kod bezpieczeństwa ze swojego tokenu SecurID.",
	"2229754167": "Wprowadź swój numer telefonu",
	"2244720377": "Wygląda na to, że wystąpił nieoczekiwany błąd.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Wysłano link dostępu na Twój e-mail",
	"2600324508": "Ukryj",
	"2606375562": "Wsuń swój YubiKey do portu USB i naciśnij przycisk",
	"2663586870": "Nazwa użytkownika",
	"2758306961": "ID uwierzytelniania",
	"2792137744": "1 cyfra",
	"2815222727": "Zeskanuj ten kod kreskowy",
	"2828880379": "Potwierdź",
	"2859281487": "Do zabezpieczenia Twojego konta potrzebne jest uwierzytelnianie dwuskładnikowe.",
	"2942752129": "Drugi kod bezpieczeństwa",
	"3060896801": "Masz kłopot?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 znak specjalny",
	"3294346597": "Spróbuj ponownie",
	"3327626662": "Wprowadź swój kod potwierdzający",
	"3374226769": "Kliknij parę przy użyciu wpisu ręcznego",
	"3469481929": "Nie można zeskanować kodu?",
	"3499598078": "Otwórz menu",
	"3528672691": "Anuluj",
	"3640052215": "Kontynuuj",
	"3645029425": "Zeskanuj poniższy kod QR",
	"3645116517": "Wprowadź ten kod, kiedy odbierasz połączenie:",
	"3663548834": "Badamy problem i prawdopodobnie wkrótce wrócimy. Poczekaj kilka minut<br />i odśwież przeglądarkę lub odwiedź naszą <a href='https://www.onelogin.com/status'>stronę statusu</a>.",
	"3669652728": "Wysłano link dostępu do",
	"3673120330": "Dalej",
	"3737470122": "Skontaktuj się z administratorem, aby dowiedzieć się więcej.",
	"3781468762": "Twoja przeglądarka nie obsługuje WebAuthn",
	"3827227259": "Kod potwierdzający został wysłany do",
	"3855542277": "Wpisz ten kod do aplikacji",
	"3865193889": "Aktywuj",
	"3877285238": "1 mała litera",
	"4000449233": "Dzwonię na poniższy numer telefonu:",
	"4072532148": "Wyślij ponownie kod SMS",
	"4151518079": "Wybierz pytanie bezpieczeństwa {current} / {total}",
	"4152906165": "Badamy ten problem i spodziewamy się niedługo skończyć. Prosimy o poczekanie kilku minut{break}i odświeżenie przeglądarki lub odwiedzenie naszej <link>strony statusu</link>.",
	"4227081527": "Kiedy aplikacja jest zainstalowana, powróć do tego ekranu i kliknij {action}",
	"4281662478": "Szukaj",
	addApp: addApp$9,
	addFactor: addFactor$9,
	additionalQuestions: additionalQuestions$9,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$9,
	addNewSecurityQuestion: addNewSecurityQuestion$9,
	administration: administration$9,
	alert: alert$9,
	all: all$9,
	app: app$9,
	appDevice: appDevice$9,
	appDevices: appDevices$9,
	appFactor: appFactor$9,
	application: application$9,
	appName: appName$9,
	appPortal: appPortal$9,
	assumedUserNotification: assumedUserNotification$9,
	broswerExtension: broswerExtension$9,
	browser: browser$9,
	browserDeleteFailure: browserDeleteFailure$9,
	browserDeleteSuccess: browserDeleteSuccess$9,
	browserDevice: browserDevice$9,
	browserFetchFailure: browserFetchFailure$9,
	calling: calling$9,
	callUserAgain: callUserAgain$9,
	cancel: cancel$9,
	changePassword: changePassword$9,
	changeSecurityFactor: changeSecurityFactor$9,
	clearIcon: clearIcon$9,
	close: close$9,
	closeDialog: closeDialog$9,
	codeResent: codeResent$9,
	companyLogo: companyLogo$9,
	companyTab: companyTab$9,
	conditionalRequirement: conditionalRequirement$9,
	configuredOn: configuredOn$9,
	confirm: confirm$9,
	contactAdminEmailOtp: contactAdminEmailOtp$9,
	contactAdminForSMS: contactAdminForSMS$9,
	contactAdminForVoice: contactAdminForVoice$9,
	contactAdminPasswordReset: contactAdminPasswordReset$9,
	credentialId: credentialId$9,
	current: current$9,
	currentPassword: currentPassword$9,
	deleteDeviceSuccess: deleteDeviceSuccess$9,
	deleteQuestion: deleteQuestion$9,
	details: details$9,
	device: device$9,
	deviceDeleteFailure: deviceDeleteFailure$9,
	deviceFetchFailure: deviceFetchFailure$9,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$9,
	deviceRenameFailure: deviceRenameFailure$9,
	downloadOnAppStore: downloadOnAppStore$9,
	editDeviceName: editDeviceName$9,
	editSQinfo: editSQinfo$9,
	enrollNewFactor: enrollNewFactor$9,
	event: event$9,
	eventType: eventType$9,
	eventUserAgent: eventUserAgent$9,
	eventUseragent: eventUseragent$9,
	eventUUID: eventUUID$9,
	eventUuid: eventUuid$9,
	expirationDays: expirationDays$9,
	expireDate: expireDate$9,
	expires: expires$9,
	extensionVersionInstalled: extensionVersionInstalled$9,
	factor: factor$9,
	factorFetchFailure: factorFetchFailure$9,
	factorMfaTokenFailure: factorMfaTokenFailure$9,
	factorPrimaryFailure: factorPrimaryFailure$9,
	factors: factors$9,
	factorsFetchFailure: factorsFetchFailure$9,
	failedToFetchUserInfo: failedToFetchUserInfo$9,
	failedToRegisterAnswers: failedToRegisterAnswers$9,
	failedToRetrieveQuestions: failedToRetrieveQuestions$9,
	forcedLogout: forcedLogout$9,
	getOnGooglePlay: getOnGooglePlay$9,
	goToExternalSite: goToExternalSite$9,
	helpRequestFailed: helpRequestFailed$9,
	helpRequestSuccessful: helpRequestSuccessful$9,
	hostname: hostname$9,
	icon: icon$9,
	identifier: identifier$9,
	imageUpload: imageUpload$9,
	inactive: inactive$9,
	inactiveDevice: inactiveDevice$9,
	install: install$9,
	invalidCode: invalidCode$9,
	invalidPhoneNumber: invalidPhoneNumber$9,
	language: language$9,
	languageConfirmation: languageConfirmation$9,
	lastAuthentication: lastAuthentication$9,
	lastChanged: lastChanged$9,
	lastUsed: lastUsed$9,
	length: length$9,
	letter: letter$9,
	linkToAppStore: linkToAppStore$9,
	linkToGooglePlay: linkToGooglePlay$9,
	loadingRecentActivity: loadingRecentActivity$9,
	loadingTrustedBrowsers: loadingTrustedBrowsers$9,
	location: location$9,
	locationTime: locationTime$9,
	loggedOut: loggedOut$9,
	login: login$9,
	loginDevice: loginDevice$9,
	loginEvent: loginEvent$9,
	loginFactor: loginFactor$9,
	loginFailedEvent: loginFailedEvent$9,
	loginName: loginName$9,
	logOut: logOut$9,
	lower: lower$9,
	message: message$9,
	mfaRegistrationFailure: mfaRegistrationFailure$9,
	mfaRegistrationSuccess: mfaRegistrationSuccess$9,
	more: more$9,
	never: never$9,
	newPassword: newPassword$9,
	newPrimaryFactor: newPrimaryFactor$9,
	noActivities: noActivities$9,
	noDevicesConfigured: noDevicesConfigured$9,
	noExpiration: noExpiration$9,
	noMoreSecurityFactors: noMoreSecurityFactors$9,
	notifyErrorLoadingUser: notifyErrorLoadingUser$9,
	notifySuccessAddApp: notifySuccessAddApp$9,
	noTrustedBrowsers: noTrustedBrowsers$9,
	numbers: numbers$9,
	oneloginDesktop: oneloginDesktop$9,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$9,
	oneloginLogo: oneloginLogo$9,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$9,
	otp1: otp1$9,
	otp2: otp2$9,
	otpDevice: otpDevice$9,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$9,
	password: password$9,
	passwordChanged: passwordChanged$9,
	passwordChangedDays: passwordChangedDays$9,
	passwordHint: passwordHint$9,
	passwordRedirectDescription: passwordRedirectDescription$9,
	passwordReset: passwordReset$9,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$9,
	passwordUpdateFailure: passwordUpdateFailure$9,
	phoneNumber: phoneNumber$9,
	prefix: prefix$9,
	previousDeviceName: previousDeviceName$9,
	primary: primary$9,
	proceedAnyway: proceedAnyway$9,
	profile: profile$9,
	profileAvatar: profileAvatar$9,
	profileMenuToggle: profileMenuToggle$9,
	profilePhoto: profilePhoto$9,
	profilePhotoAction: profilePhotoAction$9,
	pwResetDevice: pwResetDevice$9,
	pwResetFactor: pwResetFactor$9,
	questionNumber: questionNumber$9,
	radiusAuthentication: radiusAuthentication$9,
	recentActivity: recentActivity$9,
	redirectToChangePassword: redirectToChangePassword$9,
	registerSecurityQuestions: registerSecurityQuestions$9,
	registrationRejected: registrationRejected$9,
	registrationTimedout: registrationTimedout$9,
	remove: remove$9,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$9,
	removedProfilePictureSuccess: removedProfilePictureSuccess$9,
	removeFactorWarning: removeFactorWarning$9,
	removeImage: removeImage$9,
	report: report$9,
	reportActivity: reportActivity$9,
	requestField: requestField$9,
	requiredQuestions: requiredQuestions$9,
	revert: revert$9,
	revertToAdmin: revertToAdmin$9,
	revertToSuperadmin: revertToSuperadmin$9,
	revoke: revoke$9,
	save: save$9,
	searchIcon: searchIcon$9,
	secureNotes: secureNotes$9,
	securityFactorAdded: securityFactorAdded$9,
	securityFactorRemoved: securityFactorRemoved$9,
	securityFactorRenamed: securityFactorRenamed$9,
	securityFactors: securityFactors$9,
	securityFactorsDescription: securityFactorsDescription$9,
	securityFactorsUpdated: securityFactorsUpdated$9,
	selectNewImage: selectNewImage$9,
	selectNewPrimary: selectNewPrimary$9,
	selectSecurityFactor: selectSecurityFactor$9,
	sending: sending$9,
	setPrimaryDevice: setPrimaryDevice$9,
	showDetails: showDetails$9,
	specials: specials$9,
	sqDropdownAriaLabel: sqDropdownAriaLabel$9,
	sqInfoHeader: sqInfoHeader$9,
	sqTipBlankAnswers: sqTipBlankAnswers$9,
	sqTipDoNotShare: sqTipDoNotShare$9,
	sqTipMinimum: sqTipMinimum$9,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$9,
	sqTipNoUsePassword: sqTipNoUsePassword$9,
	sqTipSameAnswer: sqTipSameAnswer$9,
	sqTipSpecialChars: sqTipSpecialChars$9,
	submit: submit$9,
	submitting: submitting$9,
	support: support$9,
	supportDefaultDescription: supportDefaultDescription$9,
	supportedBrowsers: supportedBrowsers$9,
	supportRequestHeader: supportRequestHeader$9,
	"switch": "Switch",
	time: time$9,
	trustDevice: trustDevice$9,
	trusted: trusted$9,
	trustedBrowsers: trustedBrowsers$9,
	trustedBrowsersDescription: trustedBrowsersDescription$9,
	trustedDevice: trustedDevice$9,
	unavailable: unavailable$9,
	unavailableTime: unavailableTime$9,
	unsetFactorSuccess: unsetFactorSuccess$9,
	unsetPrimaryDevice: unsetPrimaryDevice$9,
	unsupportedBrowser: unsupportedBrowser$9,
	unsupportedBrowserHeading: unsupportedBrowserHeading$9,
	updateDeviceNameSuccess: updateDeviceNameSuccess$9,
	updateFactorSuccess: updateFactorSuccess$9,
	updatePassword: updatePassword$9,
	updateUserProfileFailure: updateUserProfileFailure$9,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$9,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$9,
	updateUserProfileSuccess: updateUserProfileSuccess$9,
	upper: upper$9,
	usedFor: usedFor$9,
	usedForApp: usedForApp$9,
	usedForLogin: usedForLogin$9,
	usedForPasswordReset: usedForPasswordReset$9,
	version: version$9,
	yourBrowser: yourBrowser$9
};

var addApp$8 = "Show {addApp} button when I log in to new websites.";
var addFactor$8 = "Add Factor";
var additionalQuestions$8 = "Additional Questions";
var addNewPrimaryBeforeRemove$8 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$8 = "Add New Security Question";
var administration$8 = "Administration";
var alert$8 = "Alert";
var all$8 = "all";
var app$8 = "App";
var appDevice$8 = "Este fator é utilizado para a aplicação.";
var appDevices$8 = "Este fator é usado para a aplicação";
var appFactor$8 = "Este fator é utilizado para a aplicação.";
var application$8 = "Application";
var appName$8 = "App Name";
var appPortal$8 = "App Portal";
var assumedUserNotification$8 = "You cannot edit personal information while assuming a user.";
var broswerExtension$8 = "Browser Extension";
var browser$8 = "Browser";
var browserDeleteFailure$8 = "Failed to delete trusted browser";
var browserDeleteSuccess$8 = "Trusted browser was successfully deleted";
var browserDevice$8 = "Browser/Device";
var browserFetchFailure$8 = "Failed to fetch browsers";
var calling$8 = "A ligar";
var callUserAgain$8 = "Calling you again";
var cancel$8 = "cancelar";
var changePassword$8 = "Change Password";
var changeSecurityFactor$8 = "Change Security Factor";
var clearIcon$8 = "ícone de eliminar";
var close$8 = "Close";
var closeDialog$8 = "Fechar diálogo";
var codeResent$8 = "Code has been sent to your phone.";
var companyLogo$8 = "logotipo da empresa";
var companyTab$8 = "Default for company tab";
var conditionalRequirement$8 = "At least {number} of the following requirements:";
var configuredOn$8 = "Configured On";
var confirm$8 = "confirmar";
var contactAdminEmailOtp$8 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$8 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$8 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$8 = "Contact your admin to reset password.";
var credentialId$8 = "Credential ID";
var current$8 = "Current";
var currentPassword$8 = "Current password";
var deleteDeviceSuccess$8 = "{factorName} was successfully deleted";
var deleteQuestion$8 = "Delete question {position}";
var details$8 = "Details";
var device$8 = "Device";
var deviceDeleteFailure$8 = "Failed to remove {factorName}";
var deviceFetchFailure$8 = "Failed to fetch devices";
var deviceNameCannotBeBlank$8 = "Authentication device name cannot be blank.";
var deviceRenameFailure$8 = "Failed to update device name";
var downloadOnAppStore$8 = "Descarregar na App Store";
var editDeviceName$8 = "Edit name";
var editSQinfo$8 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$8 = "Enroll new primary factor";
var event$8 = "Event";
var eventType$8 = "Event Type";
var eventUserAgent$8 = "Event Useragent";
var eventUseragent$8 = "Event Useragent";
var eventUUID$8 = "Event UUID";
var eventUuid$8 = "Event UUID";
var expirationDays$8 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$8 = "Expire Date";
var expires$8 = "Expires";
var extensionVersionInstalled$8 = "Version {versionString} installed";
var factor$8 = "Factor";
var factorFetchFailure$8 = "Failed to fetch available factors";
var factorMfaTokenFailure$8 = "Failed to fetch mfa token";
var factorPrimaryFailure$8 = "Failed to set {factorName} as your primary factor";
var factors$8 = "factors";
var factorsFetchFailure$8 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$8 = "We couldn’t load your user information.";
var failedToRegisterAnswers$8 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$8 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$8 = "Forced Logout";
var getOnGooglePlay$8 = "Obter no Google Play";
var goToExternalSite$8 = "Go to external site";
var helpRequestFailed$8 = "We couldn't submit your help request.";
var helpRequestSuccessful$8 = "Your support request has been sent to your OneLogin Admin.";
var hostname$8 = "Hostname & OS";
var icon$8 = "Icon";
var identifier$8 = "Credential ID / Identifier";
var imageUpload$8 = "Image Upload";
var inactive$8 = "Inactive";
var inactiveDevice$8 = "Inactive device";
var install$8 = "Install";
var invalidCode$8 = "Invalid code";
var invalidPhoneNumber$8 = "Please use valid phone number.";
var language$8 = "Language";
var languageConfirmation$8 = "Are you sure you want to switch to {language}?";
var lastAuthentication$8 = "Last Authentication";
var lastChanged$8 = "Last changed";
var lastUsed$8 = "Last Used";
var length$8 = "Minimum {length} characters";
var letter$8 = "1 Letter";
var linkToAppStore$8 = "Hiperligação para a App Store";
var linkToGooglePlay$8 = "Hiperligação para o Google Play";
var loadingRecentActivity$8 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$8 = "Loading trusted browsers, please wait...";
var location$8 = "Location";
var locationTime$8 = "Location/Time";
var loggedOut$8 = "Logged Out";
var login$8 = "login";
var loginDevice$8 = "Login device";
var loginEvent$8 = "Login";
var loginFactor$8 = "Este fator é utilizado para iniciar a sessão.";
var loginFailedEvent$8 = "Login Failed";
var loginName$8 = "Login Name";
var logOut$8 = "Log Out";
var lower$8 = "1 Lowercase";
var message$8 = "{name} was successfully added.";
var mfaRegistrationFailure$8 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$8 = "You successfully registered the device";
var more$8 = "More";
var never$8 = "Never";
var newPassword$8 = "New password";
var newPrimaryFactor$8 = "New primary factor";
var noActivities$8 = "No activities have been made";
var noDevicesConfigured$8 = "No devices have been configured";
var noExpiration$8 = "Never expires";
var noMoreSecurityFactors$8 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$8 = "Loading of user failed. Try again later";
var notifySuccessAddApp$8 = "{name} was successfully added.";
var noTrustedBrowsers$8 = "No browsers have been saved";
var numbers$8 = "1 Number";
var oneloginDesktop$8 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$8 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$8 = "OneLogin logo";
var onlyDesktopBrowsersSupported$8 = "We currently only support browser extensions on desktop browsers.";
var otp1$8 = "OTP 1";
var otp2$8 = "OTP 2";
var otpDevice$8 = "Este fator é usado para iniciar a sessão.";
var parsingUserProfilePhotoFailure$8 = "Getting image details failed";
var password$8 = "password";
var passwordChanged$8 = "Password Changed";
var passwordChangedDays$8 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$8 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$8 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$8 = "Password Reset";
var passwordUpdatedSuccessfully$8 = "You have successfully updated your password.";
var passwordUpdateFailure$8 = "Password update failed";
var phoneNumber$8 = "Phone number";
var prefix$8 = "Suspicious login report";
var previousDeviceName$8 = "Previously {previousName}";
var primary$8 = "Primary";
var proceedAnyway$8 = "Proceed anyway";
var profile$8 = "Profile";
var profileAvatar$8 = "Profile avatar";
var profileMenuToggle$8 = "Open profile menu";
var profilePhoto$8 = "Profile photo";
var profilePhotoAction$8 = "Profile image action";
var pwResetDevice$8 = "Este fator é usado para redefinir a palavra-passe.";
var pwResetFactor$8 = "Este fator é utilizado para repor a palavra-passe.";
var questionNumber$8 = "Question {position}";
var radiusAuthentication$8 = "Service Login via Radius";
var recentActivity$8 = "Recent Activity";
var redirectToChangePassword$8 = "Redirect to change your password?";
var registerSecurityQuestions$8 = "Register Security Questions";
var registrationRejected$8 = "Registration unsuccessful, please try again.";
var registrationTimedout$8 = "Registration context timed out";
var remove$8 = "Remove";
var removeCurrentBrowserWarning$8 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$8 = "You have successfully removed your profile picture.";
var removeFactorWarning$8 = "Are you sure you want to remove {factor}?";
var removeImage$8 = "Remove image";
var report$8 = "Report";
var reportActivity$8 = "Report Activity";
var requestField$8 = "Describe the issue you're having";
var requiredQuestions$8 = "Required Questions";
var revert$8 = "reverter";
var revertToAdmin$8 = "Revert to Admin";
var revertToSuperadmin$8 = "Revert to OneLogin Admin";
var revoke$8 = "Revoke";
var save$8 = "Save Changes";
var searchIcon$8 = "ícone de procura";
var secureNotes$8 = "Secure Notes";
var securityFactorAdded$8 = "Security Factor Added";
var securityFactorRemoved$8 = "Security Factor Removed";
var securityFactorRenamed$8 = "Security Factor Renamed";
var securityFactors$8 = "Security Factors";
var securityFactorsDescription$8 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$8 = "Security Factors Updated";
var selectNewImage$8 = "Select new image";
var selectNewPrimary$8 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$8 = "Select Security Factor";
var sending$8 = "A enviar";
var setPrimaryDevice$8 = "Set as primary";
var showDetails$8 = "Mostrar detalhes";
var specials$8 = "1 Special character";
var sqDropdownAriaLabel$8 = "Question {position} dropdown";
var sqInfoHeader$8 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$8 = "Blank answers will not be accepted";
var sqTipDoNotShare$8 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$8 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$8 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$8 = "Do not use a password as an answer.";
var sqTipSameAnswer$8 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$8 = "Special characters such as @#&*. will be ignored";
var submit$8 = "Submit";
var submitting$8 = "Submitting…";
var support$8 = "Support";
var supportDefaultDescription$8 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$8 = "Supported browsers: {browsers}";
var supportRequestHeader$8 = "Support Request";
var time$8 = "Time";
var trustDevice$8 = "Trust Device";
var trusted$8 = "Trusted";
var trustedBrowsers$8 = "Trusted Browsers";
var trustedBrowsersDescription$8 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$8 = "Trusted Device";
var unavailable$8 = "Unavailable";
var unavailableTime$8 = "Unavailable";
var unsetFactorSuccess$8 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$8 = "Unset as primary";
var unsupportedBrowser$8 = "Unsupported Browser";
var unsupportedBrowserHeading$8 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$8 = "{newName} was successfully updated";
var updateFactorSuccess$8 = "{factorName} is your new default security factor";
var updatePassword$8 = "Update Password";
var updateUserProfileFailure$8 = "Profile Update Failed";
var updateUserProfilePhotoFailure$8 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$8 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$8 = "You have successfully updated your profile.";
var upper$8 = "1 Uppercase";
var usedFor$8 = "Used For";
var usedForApp$8 = "This factor is used for app.";
var usedForLogin$8 = "This factor is used for login.";
var usedForPasswordReset$8 = "This factor is used for password reset.";
var version$8 = "Version: {versionString}";
var yourBrowser$8 = "Your browser: {browser}";
var pt = {
	"26286820": "Introduza o ID da credencial e dois Códigos de Segurança consecutivos do Symantec VIP Access.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Insira o código que recebeu por SMS.",
	"374233718": "Pode tentar novamente dentro de {secLeft, number} {secLeft, plural, one {second} {seconds}}",
	"437305782": "A verificar os seus autenticadores WebAuthn.",
	"505702857": "Ligação Mágica",
	"519412053": "Alterar Fator de Autenticação",
	"655462232": "Faça download e instale o OneLogin Protect no seu dispositivo",
	"660592555": "OK",
	"662924178": "Parece que hoje não é o nosso dia.",
	"694278426": "Insira o seu código {deviceName}",
	"694920552": "Primeiro Código de Segurança",
	"737192390": "Abrir {appName}",
	"740457555": "Segundo Código",
	"744377571": "Mínimo de {length} caracteres",
	"751710530": "Enviar",
	"916760408": "Insira um nome de utilizador e código de segurança do seu dispositivo.",
	"921093870": "Não recebeu o código?",
	"966052509": "Sem Resultados",
	"987359842": "Clique na hiperligação do seu email para continuar",
	"1068496829": "Selecionar Pergunta de Segurança {current}/{total}",
	"1079852660": "Insira dois Códigos de Segurança consecutivos",
	"1080736814": "Insira {fieldName} da aplicação Symantec VIP Access",
	"1136625613": "O processo foi cancelado. Tente novamente ou utilize outro fator de autenticação.",
	"1212847248": "Foi enviado um código de confirmação para o seu endereço configurado.",
	"1232460711": "Introduza o seu email",
	"1242107845": "Mostrar",
	"1254879564": "Nova Palavra-passe",
	"1359200231": "Enviar",
	"1433651550": "Insira o código do OneLogin SMS.",
	"1477893598": "Configurar",
	"1536965459": "Faça download e instale o OneLogin Protect no seu dispositivo",
	"1624184662": "Para configurar o OneLogin SMS, iremos enviá-lo um código de ativação por SMS. Precisará deste código de ativação para concluir o registo do dispositivo.",
	"1654624862": "Código de Segurança",
	"1833121415": "Fornecer Resposta {current}/{total}",
	"1919587067": "Reenviar código",
	"1935535842": "Obrigatório",
	"1963245695": "1 letra maiúscula",
	"2018264248": "Tentar Novamente",
	"2091874550": "Primeiro Código",
	"2097632732": "Digitalizar antes código de barra",
	"2104438124": "Insira {fieldName} e dois Códigos de Segurança consecutivos do Symantec VIP Access.",
	"2124363772": "Insira o seu nome de utilizador e o código de segurança do seu token SecurID.",
	"2229754167": "Insira o seu número de telefone",
	"2244720377": "Parece ter ocorrido um erro inesperado.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Uma hiperligação de acesso foi enviada para o seu email",
	"2600324508": "Ocultar",
	"2606375562": "Insira o seu YubiKey na porta USB e pressione o botão",
	"2663586870": "Nome de utilizador",
	"2758306961": "ID da credencial",
	"2792137744": "1 número",
	"2815222727": "Digitalize este código de barras",
	"2828880379": "Confirmar",
	"2859281487": "A autenticação de dois fatores é necessária para proteger a sua conta.",
	"2942752129": "Segundo Código de Segurança",
	"3060896801": "Está com problemas?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 símbolo especial",
	"3294346597": "Tentar novamente",
	"3327626662": "Insira o seu código de confirmação",
	"3374226769": "Clique em Emparelhar usando entrada manual",
	"3469481929": "Não consegue digitalizar o código?",
	"3499598078": "Abrir menu",
	"3528672691": "Cancelar",
	"3640052215": "Continuar",
	"3645029425": "Digitalize o Código QR abaixo",
	"3645116517": "Insira este código quando receber a chamada:",
	"3663548834": "Estamos a investigar o problema e esperamos voltar em breve. Por favor, aguarde alguns minutos<br />e atualize o seu navegador, ou visite a nossa <a href='https://www.onelogin.com/status'>Página de Estado</a>.",
	"3669652728": "Uma hiperligação de acesso foi enviada para",
	"3673120330": "Seguinte",
	"3737470122": "Para mais informações, contacte o administrador.",
	"3781468762": "O WebAuthn não funciona no seu navegador",
	"3827227259": "Foi enviado um código de confirmação para",
	"3855542277": "Insira este código na aplicação",
	"3865193889": "Ativar",
	"3877285238": "1 letra minúscula",
	"4000449233": "A ligar para o número de telefone abaixo:",
	"4072532148": "Reenviar código por SMS",
	"4151518079": "Selecionar Pergunta de Segurança {current} / {total}",
	"4152906165": "Estamos a investigar o problema e esperamos regressar em breve. Por favor, aguarde alguns minutos{break}e atualize o seu navegador ou visite a nossa <link>Página de estado</link>.",
	"4227081527": "Quando a aplicação estiver instalada, volte a este ecrã e clique em {action}",
	"4281662478": "Pesquisar",
	addApp: addApp$8,
	addFactor: addFactor$8,
	additionalQuestions: additionalQuestions$8,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$8,
	addNewSecurityQuestion: addNewSecurityQuestion$8,
	administration: administration$8,
	alert: alert$8,
	all: all$8,
	app: app$8,
	appDevice: appDevice$8,
	appDevices: appDevices$8,
	appFactor: appFactor$8,
	application: application$8,
	appName: appName$8,
	appPortal: appPortal$8,
	assumedUserNotification: assumedUserNotification$8,
	broswerExtension: broswerExtension$8,
	browser: browser$8,
	browserDeleteFailure: browserDeleteFailure$8,
	browserDeleteSuccess: browserDeleteSuccess$8,
	browserDevice: browserDevice$8,
	browserFetchFailure: browserFetchFailure$8,
	calling: calling$8,
	callUserAgain: callUserAgain$8,
	cancel: cancel$8,
	changePassword: changePassword$8,
	changeSecurityFactor: changeSecurityFactor$8,
	clearIcon: clearIcon$8,
	close: close$8,
	closeDialog: closeDialog$8,
	codeResent: codeResent$8,
	companyLogo: companyLogo$8,
	companyTab: companyTab$8,
	conditionalRequirement: conditionalRequirement$8,
	configuredOn: configuredOn$8,
	confirm: confirm$8,
	contactAdminEmailOtp: contactAdminEmailOtp$8,
	contactAdminForSMS: contactAdminForSMS$8,
	contactAdminForVoice: contactAdminForVoice$8,
	contactAdminPasswordReset: contactAdminPasswordReset$8,
	credentialId: credentialId$8,
	current: current$8,
	currentPassword: currentPassword$8,
	deleteDeviceSuccess: deleteDeviceSuccess$8,
	deleteQuestion: deleteQuestion$8,
	details: details$8,
	device: device$8,
	deviceDeleteFailure: deviceDeleteFailure$8,
	deviceFetchFailure: deviceFetchFailure$8,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$8,
	deviceRenameFailure: deviceRenameFailure$8,
	downloadOnAppStore: downloadOnAppStore$8,
	editDeviceName: editDeviceName$8,
	editSQinfo: editSQinfo$8,
	enrollNewFactor: enrollNewFactor$8,
	event: event$8,
	eventType: eventType$8,
	eventUserAgent: eventUserAgent$8,
	eventUseragent: eventUseragent$8,
	eventUUID: eventUUID$8,
	eventUuid: eventUuid$8,
	expirationDays: expirationDays$8,
	expireDate: expireDate$8,
	expires: expires$8,
	extensionVersionInstalled: extensionVersionInstalled$8,
	factor: factor$8,
	factorFetchFailure: factorFetchFailure$8,
	factorMfaTokenFailure: factorMfaTokenFailure$8,
	factorPrimaryFailure: factorPrimaryFailure$8,
	factors: factors$8,
	factorsFetchFailure: factorsFetchFailure$8,
	failedToFetchUserInfo: failedToFetchUserInfo$8,
	failedToRegisterAnswers: failedToRegisterAnswers$8,
	failedToRetrieveQuestions: failedToRetrieveQuestions$8,
	forcedLogout: forcedLogout$8,
	getOnGooglePlay: getOnGooglePlay$8,
	goToExternalSite: goToExternalSite$8,
	helpRequestFailed: helpRequestFailed$8,
	helpRequestSuccessful: helpRequestSuccessful$8,
	hostname: hostname$8,
	icon: icon$8,
	identifier: identifier$8,
	imageUpload: imageUpload$8,
	inactive: inactive$8,
	inactiveDevice: inactiveDevice$8,
	install: install$8,
	invalidCode: invalidCode$8,
	invalidPhoneNumber: invalidPhoneNumber$8,
	language: language$8,
	languageConfirmation: languageConfirmation$8,
	lastAuthentication: lastAuthentication$8,
	lastChanged: lastChanged$8,
	lastUsed: lastUsed$8,
	length: length$8,
	letter: letter$8,
	linkToAppStore: linkToAppStore$8,
	linkToGooglePlay: linkToGooglePlay$8,
	loadingRecentActivity: loadingRecentActivity$8,
	loadingTrustedBrowsers: loadingTrustedBrowsers$8,
	location: location$8,
	locationTime: locationTime$8,
	loggedOut: loggedOut$8,
	login: login$8,
	loginDevice: loginDevice$8,
	loginEvent: loginEvent$8,
	loginFactor: loginFactor$8,
	loginFailedEvent: loginFailedEvent$8,
	loginName: loginName$8,
	logOut: logOut$8,
	lower: lower$8,
	message: message$8,
	mfaRegistrationFailure: mfaRegistrationFailure$8,
	mfaRegistrationSuccess: mfaRegistrationSuccess$8,
	more: more$8,
	never: never$8,
	newPassword: newPassword$8,
	newPrimaryFactor: newPrimaryFactor$8,
	noActivities: noActivities$8,
	noDevicesConfigured: noDevicesConfigured$8,
	noExpiration: noExpiration$8,
	noMoreSecurityFactors: noMoreSecurityFactors$8,
	notifyErrorLoadingUser: notifyErrorLoadingUser$8,
	notifySuccessAddApp: notifySuccessAddApp$8,
	noTrustedBrowsers: noTrustedBrowsers$8,
	numbers: numbers$8,
	oneloginDesktop: oneloginDesktop$8,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$8,
	oneloginLogo: oneloginLogo$8,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$8,
	otp1: otp1$8,
	otp2: otp2$8,
	otpDevice: otpDevice$8,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$8,
	password: password$8,
	passwordChanged: passwordChanged$8,
	passwordChangedDays: passwordChangedDays$8,
	passwordHint: passwordHint$8,
	passwordRedirectDescription: passwordRedirectDescription$8,
	passwordReset: passwordReset$8,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$8,
	passwordUpdateFailure: passwordUpdateFailure$8,
	phoneNumber: phoneNumber$8,
	prefix: prefix$8,
	previousDeviceName: previousDeviceName$8,
	primary: primary$8,
	proceedAnyway: proceedAnyway$8,
	profile: profile$8,
	profileAvatar: profileAvatar$8,
	profileMenuToggle: profileMenuToggle$8,
	profilePhoto: profilePhoto$8,
	profilePhotoAction: profilePhotoAction$8,
	pwResetDevice: pwResetDevice$8,
	pwResetFactor: pwResetFactor$8,
	questionNumber: questionNumber$8,
	radiusAuthentication: radiusAuthentication$8,
	recentActivity: recentActivity$8,
	redirectToChangePassword: redirectToChangePassword$8,
	registerSecurityQuestions: registerSecurityQuestions$8,
	registrationRejected: registrationRejected$8,
	registrationTimedout: registrationTimedout$8,
	remove: remove$8,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$8,
	removedProfilePictureSuccess: removedProfilePictureSuccess$8,
	removeFactorWarning: removeFactorWarning$8,
	removeImage: removeImage$8,
	report: report$8,
	reportActivity: reportActivity$8,
	requestField: requestField$8,
	requiredQuestions: requiredQuestions$8,
	revert: revert$8,
	revertToAdmin: revertToAdmin$8,
	revertToSuperadmin: revertToSuperadmin$8,
	revoke: revoke$8,
	save: save$8,
	searchIcon: searchIcon$8,
	secureNotes: secureNotes$8,
	securityFactorAdded: securityFactorAdded$8,
	securityFactorRemoved: securityFactorRemoved$8,
	securityFactorRenamed: securityFactorRenamed$8,
	securityFactors: securityFactors$8,
	securityFactorsDescription: securityFactorsDescription$8,
	securityFactorsUpdated: securityFactorsUpdated$8,
	selectNewImage: selectNewImage$8,
	selectNewPrimary: selectNewPrimary$8,
	selectSecurityFactor: selectSecurityFactor$8,
	sending: sending$8,
	setPrimaryDevice: setPrimaryDevice$8,
	showDetails: showDetails$8,
	specials: specials$8,
	sqDropdownAriaLabel: sqDropdownAriaLabel$8,
	sqInfoHeader: sqInfoHeader$8,
	sqTipBlankAnswers: sqTipBlankAnswers$8,
	sqTipDoNotShare: sqTipDoNotShare$8,
	sqTipMinimum: sqTipMinimum$8,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$8,
	sqTipNoUsePassword: sqTipNoUsePassword$8,
	sqTipSameAnswer: sqTipSameAnswer$8,
	sqTipSpecialChars: sqTipSpecialChars$8,
	submit: submit$8,
	submitting: submitting$8,
	support: support$8,
	supportDefaultDescription: supportDefaultDescription$8,
	supportedBrowsers: supportedBrowsers$8,
	supportRequestHeader: supportRequestHeader$8,
	"switch": "Switch",
	time: time$8,
	trustDevice: trustDevice$8,
	trusted: trusted$8,
	trustedBrowsers: trustedBrowsers$8,
	trustedBrowsersDescription: trustedBrowsersDescription$8,
	trustedDevice: trustedDevice$8,
	unavailable: unavailable$8,
	unavailableTime: unavailableTime$8,
	unsetFactorSuccess: unsetFactorSuccess$8,
	unsetPrimaryDevice: unsetPrimaryDevice$8,
	unsupportedBrowser: unsupportedBrowser$8,
	unsupportedBrowserHeading: unsupportedBrowserHeading$8,
	updateDeviceNameSuccess: updateDeviceNameSuccess$8,
	updateFactorSuccess: updateFactorSuccess$8,
	updatePassword: updatePassword$8,
	updateUserProfileFailure: updateUserProfileFailure$8,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$8,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$8,
	updateUserProfileSuccess: updateUserProfileSuccess$8,
	upper: upper$8,
	usedFor: usedFor$8,
	usedForApp: usedForApp$8,
	usedForLogin: usedForLogin$8,
	usedForPasswordReset: usedForPasswordReset$8,
	version: version$8,
	yourBrowser: yourBrowser$8
};

var addApp$7 = "Show {addApp} button when I log in to new websites.";
var addFactor$7 = "Add Factor";
var additionalQuestions$7 = "Additional Questions";
var addNewPrimaryBeforeRemove$7 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$7 = "Add New Security Question";
var administration$7 = "Administration";
var alert$7 = "Alert";
var all$7 = "all";
var app$7 = "App";
var appDevice$7 = "Этот фактор используется для приложения.";
var appDevices$7 = "Этот фактор используется для работы приложения";
var appFactor$7 = "Этот фактор используется для приложения.";
var application$7 = "Application";
var appName$7 = "App Name";
var appPortal$7 = "App Portal";
var assumedUserNotification$7 = "You cannot edit personal information while assuming a user.";
var broswerExtension$7 = "Browser Extension";
var browser$7 = "Browser";
var browserDeleteFailure$7 = "Failed to delete trusted browser";
var browserDeleteSuccess$7 = "Trusted browser was successfully deleted";
var browserDevice$7 = "Browser/Device";
var browserFetchFailure$7 = "Failed to fetch browsers";
var calling$7 = "Идет звонок";
var callUserAgain$7 = "Calling you again";
var cancel$7 = "отмена";
var changePassword$7 = "Change Password";
var changeSecurityFactor$7 = "Change Security Factor";
var clearIcon$7 = "значок очистки";
var close$7 = "Close";
var closeDialog$7 = "Закрыть диалог";
var codeResent$7 = "Code has been sent to your phone.";
var companyLogo$7 = "логотип компании";
var companyTab$7 = "Default for company tab";
var conditionalRequirement$7 = "At least {number} of the following requirements:";
var configuredOn$7 = "Configured On";
var confirm$7 = "подтвердить";
var contactAdminEmailOtp$7 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$7 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$7 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$7 = "Contact your admin to reset password.";
var credentialId$7 = "Credential ID";
var current$7 = "Current";
var currentPassword$7 = "Current password";
var deleteDeviceSuccess$7 = "{factorName} was successfully deleted";
var deleteQuestion$7 = "Delete question {position}";
var details$7 = "Details";
var device$7 = "Device";
var deviceDeleteFailure$7 = "Failed to remove {factorName}";
var deviceFetchFailure$7 = "Failed to fetch devices";
var deviceNameCannotBeBlank$7 = "Authentication device name cannot be blank.";
var deviceRenameFailure$7 = "Failed to update device name";
var downloadOnAppStore$7 = "Скачать в App Store";
var editDeviceName$7 = "Edit name";
var editSQinfo$7 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$7 = "Enroll new primary factor";
var event$7 = "Event";
var eventType$7 = "Event Type";
var eventUserAgent$7 = "Event Useragent";
var eventUseragent$7 = "Event Useragent";
var eventUUID$7 = "Event UUID";
var eventUuid$7 = "Event UUID";
var expirationDays$7 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$7 = "Expire Date";
var expires$7 = "Expires";
var extensionVersionInstalled$7 = "Version {versionString} installed";
var factor$7 = "Factor";
var factorFetchFailure$7 = "Failed to fetch available factors";
var factorMfaTokenFailure$7 = "Failed to fetch mfa token";
var factorPrimaryFailure$7 = "Failed to set {factorName} as your primary factor";
var factors$7 = "factors";
var factorsFetchFailure$7 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$7 = "We couldn’t load your user information.";
var failedToRegisterAnswers$7 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$7 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$7 = "Forced Logout";
var getOnGooglePlay$7 = "Скачать в Google Play";
var goToExternalSite$7 = "Go to external site";
var helpRequestFailed$7 = "We couldn't submit your help request.";
var helpRequestSuccessful$7 = "Your support request has been sent to your OneLogin Admin.";
var hostname$7 = "Hostname & OS";
var icon$7 = "Icon";
var identifier$7 = "Credential ID / Identifier";
var imageUpload$7 = "Image Upload";
var inactive$7 = "Inactive";
var inactiveDevice$7 = "Inactive device";
var install$7 = "Install";
var invalidCode$7 = "Invalid code";
var invalidPhoneNumber$7 = "Please use valid phone number.";
var language$7 = "Language";
var languageConfirmation$7 = "Are you sure you want to switch to {language}?";
var lastAuthentication$7 = "Last Authentication";
var lastChanged$7 = "Last changed";
var lastUsed$7 = "Last Used";
var length$7 = "Minimum {length} characters";
var letter$7 = "1 Letter";
var linkToAppStore$7 = "Ссылка на App Store";
var linkToGooglePlay$7 = "Ссылка на Google Play";
var loadingRecentActivity$7 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$7 = "Loading trusted browsers, please wait...";
var location$7 = "Location";
var locationTime$7 = "Location/Time";
var loggedOut$7 = "Logged Out";
var login$7 = "login";
var loginDevice$7 = "Login device";
var loginEvent$7 = "Login";
var loginFactor$7 = "Этот фактор используется для входа в систему.";
var loginFailedEvent$7 = "Login Failed";
var loginName$7 = "Login Name";
var logOut$7 = "Log Out";
var lower$7 = "1 Lowercase";
var message$7 = "{name} was successfully added.";
var mfaRegistrationFailure$7 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$7 = "You successfully registered the device";
var more$7 = "More";
var never$7 = "Never";
var newPassword$7 = "New password";
var newPrimaryFactor$7 = "New primary factor";
var noActivities$7 = "No activities have been made";
var noDevicesConfigured$7 = "No devices have been configured";
var noExpiration$7 = "Never expires";
var noMoreSecurityFactors$7 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$7 = "Loading of user failed. Try again later";
var notifySuccessAddApp$7 = "{name} was successfully added.";
var noTrustedBrowsers$7 = "No browsers have been saved";
var numbers$7 = "1 Number";
var oneloginDesktop$7 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$7 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$7 = "OneLogin logo";
var onlyDesktopBrowsersSupported$7 = "We currently only support browser extensions on desktop browsers.";
var otp1$7 = "OTP 1";
var otp2$7 = "OTP 2";
var otpDevice$7 = "Этот фактор используется для входа в систему.";
var parsingUserProfilePhotoFailure$7 = "Getting image details failed";
var password$7 = "password";
var passwordChanged$7 = "Password Changed";
var passwordChangedDays$7 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$7 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$7 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$7 = "Password Reset";
var passwordUpdatedSuccessfully$7 = "You have successfully updated your password.";
var passwordUpdateFailure$7 = "Password update failed";
var phoneNumber$7 = "Phone number";
var prefix$7 = "Suspicious login report";
var previousDeviceName$7 = "Previously {previousName}";
var primary$7 = "Primary";
var proceedAnyway$7 = "Proceed anyway";
var profile$7 = "Profile";
var profileAvatar$7 = "Profile avatar";
var profileMenuToggle$7 = "Open profile menu";
var profilePhoto$7 = "Profile photo";
var profilePhotoAction$7 = "Profile image action";
var pwResetDevice$7 = "Этот фактор используется для сброса пароля.";
var pwResetFactor$7 = "Этот фактор используется для сброса пароля.";
var questionNumber$7 = "Question {position}";
var radiusAuthentication$7 = "Service Login via Radius";
var recentActivity$7 = "Recent Activity";
var redirectToChangePassword$7 = "Redirect to change your password?";
var registerSecurityQuestions$7 = "Register Security Questions";
var registrationRejected$7 = "Registration unsuccessful, please try again.";
var registrationTimedout$7 = "Registration context timed out";
var remove$7 = "Remove";
var removeCurrentBrowserWarning$7 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$7 = "You have successfully removed your profile picture.";
var removeFactorWarning$7 = "Are you sure you want to remove {factor}?";
var removeImage$7 = "Remove image";
var report$7 = "Report";
var reportActivity$7 = "Report Activity";
var requestField$7 = "Describe the issue you're having";
var requiredQuestions$7 = "Required Questions";
var revert$7 = "вернуть";
var revertToAdmin$7 = "Revert to Admin";
var revertToSuperadmin$7 = "Revert to OneLogin Admin";
var revoke$7 = "Revoke";
var save$7 = "Save Changes";
var searchIcon$7 = "значок поиска";
var secureNotes$7 = "Secure Notes";
var securityFactorAdded$7 = "Security Factor Added";
var securityFactorRemoved$7 = "Security Factor Removed";
var securityFactorRenamed$7 = "Security Factor Renamed";
var securityFactors$7 = "Security Factors";
var securityFactorsDescription$7 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$7 = "Security Factors Updated";
var selectNewImage$7 = "Select new image";
var selectNewPrimary$7 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$7 = "Select Security Factor";
var sending$7 = "Отправка";
var setPrimaryDevice$7 = "Set as primary";
var showDetails$7 = "Показать детали";
var specials$7 = "1 Special character";
var sqDropdownAriaLabel$7 = "Question {position} dropdown";
var sqInfoHeader$7 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$7 = "Blank answers will not be accepted";
var sqTipDoNotShare$7 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$7 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$7 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$7 = "Do not use a password as an answer.";
var sqTipSameAnswer$7 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$7 = "Special characters such as @#&*. will be ignored";
var submit$7 = "Submit";
var submitting$7 = "Submitting…";
var support$7 = "Support";
var supportDefaultDescription$7 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$7 = "Supported browsers: {browsers}";
var supportRequestHeader$7 = "Support Request";
var time$7 = "Time";
var trustDevice$7 = "Trust Device";
var trusted$7 = "Trusted";
var trustedBrowsers$7 = "Trusted Browsers";
var trustedBrowsersDescription$7 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$7 = "Trusted Device";
var unavailable$7 = "Unavailable";
var unavailableTime$7 = "Unavailable";
var unsetFactorSuccess$7 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$7 = "Unset as primary";
var unsupportedBrowser$7 = "Unsupported Browser";
var unsupportedBrowserHeading$7 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$7 = "{newName} was successfully updated";
var updateFactorSuccess$7 = "{factorName} is your new default security factor";
var updatePassword$7 = "Update Password";
var updateUserProfileFailure$7 = "Profile Update Failed";
var updateUserProfilePhotoFailure$7 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$7 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$7 = "You have successfully updated your profile.";
var upper$7 = "1 Uppercase";
var usedFor$7 = "Used For";
var usedForApp$7 = "This factor is used for app.";
var usedForLogin$7 = "This factor is used for login.";
var usedForPasswordReset$7 = "This factor is used for password reset.";
var version$7 = "Version: {versionString}";
var yourBrowser$7 = "Your browser: {browser}";
var ruRU = {
	"26286820": "Введите идентификатор учетных данных и два последовательных кода безопасности из VIP-доступа Symantec.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Введите код, который вы получили в SMS-сообщении.",
	"374233718": "Вы сможете повторить попытку через {secLeft, number} {secLeft, plural, one {сек.} other {сек.}}",
	"437305782": "Идет проверка ваших аутентификаторов WebAuthn.",
	"505702857": "Волшебная ссылка",
	"519412053": "Изменить фактор аутентификации",
	"655462232": "Загрузите и установите на вашем устройстве OneLogin Protect",
	"660592555": "OK",
	"662924178": "Похоже, что сегодня не ваш день.",
	"694278426": "Укажите свой код {deviceName}",
	"694920552": "Первый Код безопасности",
	"737192390": "Откройте {appName}",
	"740457555": "Второй код",
	"744377571": "Минимум {length} символов",
	"751710530": "Отправить",
	"916760408": "Введите имя пользователя и код безопасности с вашего устройства.",
	"921093870": "Не получили код?",
	"966052509": "Нет результатов",
	"987359842": "Перейдите по ссылке в электронном письме, чтобы продолжить",
	"1068496829": "Выберите контрольный вопрос {current}/{total}",
	"1079852660": "Введите два последовательных Кода безопасности",
	"1080736814": "Введите {fieldName} из приложения Symantec VIP Access",
	"1136625613": "Процесс был отменен. Пожалуйста, повторите попытку или используйте другой фактор аутентификации.",
	"1212847248": "На указанный в настройках адрес был отправлен код подтверждения.",
	"1232460711": "Введите ваш адрес электронной почты",
	"1242107845": "Показать",
	"1254879564": "Новый пароль",
	"1359200231": "Отправить",
	"1433651550": "Введите код из OneLogin SMS.",
	"1477893598": "Настроить",
	"1536965459": "Загрузите и установите OneLogin Protect на вашем устройстве",
	"1624184662": "Для настройки OneLogin SMS мы отправим вам SMS-сообщением код активации. Вам понадобится этот код активации для завершения регистрации устройства.",
	"1654624862": "Код безопасности",
	"1833121415": "Укажите ответ {current}/{total}",
	"1919587067": "Отправить код повторно",
	"1935535842": "Необходимо",
	"1963245695": "1 прописная буква",
	"2018264248": "Еще раз",
	"2091874550": "Первый код",
	"2097632732": "Вместо этого сканировать штрих-код",
	"2104438124": "Введите {fieldName} и два последовательных Кода безопасности из Symantec VIP Access.",
	"2124363772": "Введите ваше имя пользователя и код безопасности из вашего токена SecurID.",
	"2229754167": "Укажите свой номер телефона",
	"2244720377": "Кажется, произошла непредвиденная ошибка.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Ссылка для доступа отправлена на Вашу электронную почту",
	"2600324508": "Скрыть",
	"2606375562": "Вставьте ваш YubiKey в USB-порт и нажмите кнопку",
	"2663586870": "Имя пользователя",
	"2758306961": "Идентификатор учетных данных",
	"2792137744": "1 цифра",
	"2815222727": "Сканировать этот штрих-код",
	"2828880379": "Подтвердить",
	"2859281487": "Для обеспечения безопасности вашей учетной записи требуется 2-факторная аутентификация.",
	"2942752129": "Второй Код безопасности",
	"3060896801": "Возникли затруднения?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 специальный символ",
	"3294346597": "Повторите попытку",
	"3327626662": "Укажите свой код подтверждения",
	"3374226769": "Нажмите Pair, используя ручной ввод",
	"3469481929": "Не можете отсканировать код?",
	"3499598078": "Открыть меню",
	"3528672691": "Отменить",
	"3640052215": "Продолжить",
	"3645029425": "Отсканируйте ниже QR-код",
	"3645116517": "Укажите этот код, когда вы примете звонок:",
	"3663548834": "Мы разбираемся с проблемой и надеемся скоро вернуться. Пожалуйста, подождите несколько минут <br />и обновите свой браузер или посетите нашу <a href='https://www.onelogin.com/status'>страницу состояния</a>.",
	"3669652728": "Ссылка для доступа отправлена на",
	"3673120330": "Далее",
	"3737470122": "Пожалуйста, свяжитесь с администратором для получения дополнительной информации.",
	"3781468762": "Ваш браузер не поддерживает WebAuthn",
	"3827227259": "Код подтверждения был отправлен на",
	"3855542277": "Введите этот код в приложении",
	"3865193889": "Активировать",
	"3877285238": "1 строчная буква",
	"4000449233": "Звонок по указанному ниже номеру телефона:",
	"4072532148": "Отправить SMS-код повторно",
	"4151518079": "Выберите контрольный вопрос {current} / {total}",
	"4152906165": "Мы изучаем данную проблему и надеемся, что скоро сможем вернуться к привычному функционированию. Пожалуйста, подождите несколько минут{break}и обновите страницу или перейдите на нашу <link>страницу состояния</link>.",
	"4227081527": "Когда приложение установлено, вернитесь в это меню и нажмите {action}",
	"4281662478": "Искать",
	addApp: addApp$7,
	addFactor: addFactor$7,
	additionalQuestions: additionalQuestions$7,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$7,
	addNewSecurityQuestion: addNewSecurityQuestion$7,
	administration: administration$7,
	alert: alert$7,
	all: all$7,
	app: app$7,
	appDevice: appDevice$7,
	appDevices: appDevices$7,
	appFactor: appFactor$7,
	application: application$7,
	appName: appName$7,
	appPortal: appPortal$7,
	assumedUserNotification: assumedUserNotification$7,
	broswerExtension: broswerExtension$7,
	browser: browser$7,
	browserDeleteFailure: browserDeleteFailure$7,
	browserDeleteSuccess: browserDeleteSuccess$7,
	browserDevice: browserDevice$7,
	browserFetchFailure: browserFetchFailure$7,
	calling: calling$7,
	callUserAgain: callUserAgain$7,
	cancel: cancel$7,
	changePassword: changePassword$7,
	changeSecurityFactor: changeSecurityFactor$7,
	clearIcon: clearIcon$7,
	close: close$7,
	closeDialog: closeDialog$7,
	codeResent: codeResent$7,
	companyLogo: companyLogo$7,
	companyTab: companyTab$7,
	conditionalRequirement: conditionalRequirement$7,
	configuredOn: configuredOn$7,
	confirm: confirm$7,
	contactAdminEmailOtp: contactAdminEmailOtp$7,
	contactAdminForSMS: contactAdminForSMS$7,
	contactAdminForVoice: contactAdminForVoice$7,
	contactAdminPasswordReset: contactAdminPasswordReset$7,
	credentialId: credentialId$7,
	current: current$7,
	currentPassword: currentPassword$7,
	deleteDeviceSuccess: deleteDeviceSuccess$7,
	deleteQuestion: deleteQuestion$7,
	details: details$7,
	device: device$7,
	deviceDeleteFailure: deviceDeleteFailure$7,
	deviceFetchFailure: deviceFetchFailure$7,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$7,
	deviceRenameFailure: deviceRenameFailure$7,
	downloadOnAppStore: downloadOnAppStore$7,
	editDeviceName: editDeviceName$7,
	editSQinfo: editSQinfo$7,
	enrollNewFactor: enrollNewFactor$7,
	event: event$7,
	eventType: eventType$7,
	eventUserAgent: eventUserAgent$7,
	eventUseragent: eventUseragent$7,
	eventUUID: eventUUID$7,
	eventUuid: eventUuid$7,
	expirationDays: expirationDays$7,
	expireDate: expireDate$7,
	expires: expires$7,
	extensionVersionInstalled: extensionVersionInstalled$7,
	factor: factor$7,
	factorFetchFailure: factorFetchFailure$7,
	factorMfaTokenFailure: factorMfaTokenFailure$7,
	factorPrimaryFailure: factorPrimaryFailure$7,
	factors: factors$7,
	factorsFetchFailure: factorsFetchFailure$7,
	failedToFetchUserInfo: failedToFetchUserInfo$7,
	failedToRegisterAnswers: failedToRegisterAnswers$7,
	failedToRetrieveQuestions: failedToRetrieveQuestions$7,
	forcedLogout: forcedLogout$7,
	getOnGooglePlay: getOnGooglePlay$7,
	goToExternalSite: goToExternalSite$7,
	helpRequestFailed: helpRequestFailed$7,
	helpRequestSuccessful: helpRequestSuccessful$7,
	hostname: hostname$7,
	icon: icon$7,
	identifier: identifier$7,
	imageUpload: imageUpload$7,
	inactive: inactive$7,
	inactiveDevice: inactiveDevice$7,
	install: install$7,
	invalidCode: invalidCode$7,
	invalidPhoneNumber: invalidPhoneNumber$7,
	language: language$7,
	languageConfirmation: languageConfirmation$7,
	lastAuthentication: lastAuthentication$7,
	lastChanged: lastChanged$7,
	lastUsed: lastUsed$7,
	length: length$7,
	letter: letter$7,
	linkToAppStore: linkToAppStore$7,
	linkToGooglePlay: linkToGooglePlay$7,
	loadingRecentActivity: loadingRecentActivity$7,
	loadingTrustedBrowsers: loadingTrustedBrowsers$7,
	location: location$7,
	locationTime: locationTime$7,
	loggedOut: loggedOut$7,
	login: login$7,
	loginDevice: loginDevice$7,
	loginEvent: loginEvent$7,
	loginFactor: loginFactor$7,
	loginFailedEvent: loginFailedEvent$7,
	loginName: loginName$7,
	logOut: logOut$7,
	lower: lower$7,
	message: message$7,
	mfaRegistrationFailure: mfaRegistrationFailure$7,
	mfaRegistrationSuccess: mfaRegistrationSuccess$7,
	more: more$7,
	never: never$7,
	newPassword: newPassword$7,
	newPrimaryFactor: newPrimaryFactor$7,
	noActivities: noActivities$7,
	noDevicesConfigured: noDevicesConfigured$7,
	noExpiration: noExpiration$7,
	noMoreSecurityFactors: noMoreSecurityFactors$7,
	notifyErrorLoadingUser: notifyErrorLoadingUser$7,
	notifySuccessAddApp: notifySuccessAddApp$7,
	noTrustedBrowsers: noTrustedBrowsers$7,
	numbers: numbers$7,
	oneloginDesktop: oneloginDesktop$7,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$7,
	oneloginLogo: oneloginLogo$7,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$7,
	otp1: otp1$7,
	otp2: otp2$7,
	otpDevice: otpDevice$7,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$7,
	password: password$7,
	passwordChanged: passwordChanged$7,
	passwordChangedDays: passwordChangedDays$7,
	passwordHint: passwordHint$7,
	passwordRedirectDescription: passwordRedirectDescription$7,
	passwordReset: passwordReset$7,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$7,
	passwordUpdateFailure: passwordUpdateFailure$7,
	phoneNumber: phoneNumber$7,
	prefix: prefix$7,
	previousDeviceName: previousDeviceName$7,
	primary: primary$7,
	proceedAnyway: proceedAnyway$7,
	profile: profile$7,
	profileAvatar: profileAvatar$7,
	profileMenuToggle: profileMenuToggle$7,
	profilePhoto: profilePhoto$7,
	profilePhotoAction: profilePhotoAction$7,
	pwResetDevice: pwResetDevice$7,
	pwResetFactor: pwResetFactor$7,
	questionNumber: questionNumber$7,
	radiusAuthentication: radiusAuthentication$7,
	recentActivity: recentActivity$7,
	redirectToChangePassword: redirectToChangePassword$7,
	registerSecurityQuestions: registerSecurityQuestions$7,
	registrationRejected: registrationRejected$7,
	registrationTimedout: registrationTimedout$7,
	remove: remove$7,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$7,
	removedProfilePictureSuccess: removedProfilePictureSuccess$7,
	removeFactorWarning: removeFactorWarning$7,
	removeImage: removeImage$7,
	report: report$7,
	reportActivity: reportActivity$7,
	requestField: requestField$7,
	requiredQuestions: requiredQuestions$7,
	revert: revert$7,
	revertToAdmin: revertToAdmin$7,
	revertToSuperadmin: revertToSuperadmin$7,
	revoke: revoke$7,
	save: save$7,
	searchIcon: searchIcon$7,
	secureNotes: secureNotes$7,
	securityFactorAdded: securityFactorAdded$7,
	securityFactorRemoved: securityFactorRemoved$7,
	securityFactorRenamed: securityFactorRenamed$7,
	securityFactors: securityFactors$7,
	securityFactorsDescription: securityFactorsDescription$7,
	securityFactorsUpdated: securityFactorsUpdated$7,
	selectNewImage: selectNewImage$7,
	selectNewPrimary: selectNewPrimary$7,
	selectSecurityFactor: selectSecurityFactor$7,
	sending: sending$7,
	setPrimaryDevice: setPrimaryDevice$7,
	showDetails: showDetails$7,
	specials: specials$7,
	sqDropdownAriaLabel: sqDropdownAriaLabel$7,
	sqInfoHeader: sqInfoHeader$7,
	sqTipBlankAnswers: sqTipBlankAnswers$7,
	sqTipDoNotShare: sqTipDoNotShare$7,
	sqTipMinimum: sqTipMinimum$7,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$7,
	sqTipNoUsePassword: sqTipNoUsePassword$7,
	sqTipSameAnswer: sqTipSameAnswer$7,
	sqTipSpecialChars: sqTipSpecialChars$7,
	submit: submit$7,
	submitting: submitting$7,
	support: support$7,
	supportDefaultDescription: supportDefaultDescription$7,
	supportedBrowsers: supportedBrowsers$7,
	supportRequestHeader: supportRequestHeader$7,
	"switch": "Switch",
	time: time$7,
	trustDevice: trustDevice$7,
	trusted: trusted$7,
	trustedBrowsers: trustedBrowsers$7,
	trustedBrowsersDescription: trustedBrowsersDescription$7,
	trustedDevice: trustedDevice$7,
	unavailable: unavailable$7,
	unavailableTime: unavailableTime$7,
	unsetFactorSuccess: unsetFactorSuccess$7,
	unsetPrimaryDevice: unsetPrimaryDevice$7,
	unsupportedBrowser: unsupportedBrowser$7,
	unsupportedBrowserHeading: unsupportedBrowserHeading$7,
	updateDeviceNameSuccess: updateDeviceNameSuccess$7,
	updateFactorSuccess: updateFactorSuccess$7,
	updatePassword: updatePassword$7,
	updateUserProfileFailure: updateUserProfileFailure$7,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$7,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$7,
	updateUserProfileSuccess: updateUserProfileSuccess$7,
	upper: upper$7,
	usedFor: usedFor$7,
	usedForApp: usedForApp$7,
	usedForLogin: usedForLogin$7,
	usedForPasswordReset: usedForPasswordReset$7,
	version: version$7,
	yourBrowser: yourBrowser$7
};

var addApp$6 = "Show {addApp} button when I log in to new websites.";
var addFactor$6 = "Add Factor";
var additionalQuestions$6 = "Additional Questions";
var addNewPrimaryBeforeRemove$6 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$6 = "Add New Security Question";
var administration$6 = "Administration";
var alert$6 = "Alert";
var all$6 = "all";
var app$6 = "App";
var appDevice$6 = "Tento faktor jej použitý pre aplikáciu.";
var appDevices$6 = "Tento faktor sa používa pre aplikáciu";
var appFactor$6 = "Tento faktor jej použitý pre aplikáciu.";
var application$6 = "Application";
var appName$6 = "App Name";
var appPortal$6 = "App Portal";
var assumedUserNotification$6 = "You cannot edit personal information while assuming a user.";
var broswerExtension$6 = "Browser Extension";
var browser$6 = "Browser";
var browserDeleteFailure$6 = "Failed to delete trusted browser";
var browserDeleteSuccess$6 = "Trusted browser was successfully deleted";
var browserDevice$6 = "Browser/Device";
var browserFetchFailure$6 = "Failed to fetch browsers";
var calling$6 = "Volá";
var callUserAgain$6 = "Calling you again";
var cancel$6 = "zrušiť";
var changePassword$6 = "Change Password";
var changeSecurityFactor$6 = "Change Security Factor";
var clearIcon$6 = "vymazať ikonu";
var close$6 = "Close";
var closeDialog$6 = "Zatvoriť dialóg";
var codeResent$6 = "Code has been sent to your phone.";
var companyLogo$6 = "logo spoločnosti";
var companyTab$6 = "Default for company tab";
var conditionalRequirement$6 = "At least {number} of the following requirements:";
var configuredOn$6 = "Configured On";
var confirm$6 = "potvrdiť";
var contactAdminEmailOtp$6 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$6 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$6 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$6 = "Contact your admin to reset password.";
var credentialId$6 = "Credential ID";
var current$6 = "Current";
var currentPassword$6 = "Current password";
var deleteDeviceSuccess$6 = "{factorName} was successfully deleted";
var deleteQuestion$6 = "Delete question {position}";
var details$6 = "Details";
var device$6 = "Device";
var deviceDeleteFailure$6 = "Failed to remove {factorName}";
var deviceFetchFailure$6 = "Failed to fetch devices";
var deviceNameCannotBeBlank$6 = "Authentication device name cannot be blank.";
var deviceRenameFailure$6 = "Failed to update device name";
var downloadOnAppStore$6 = "Stiahnuť z obchodu s aplikáciami";
var editDeviceName$6 = "Edit name";
var editSQinfo$6 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$6 = "Enroll new primary factor";
var event$6 = "Event";
var eventType$6 = "Event Type";
var eventUserAgent$6 = "Event Useragent";
var eventUseragent$6 = "Event Useragent";
var eventUUID$6 = "Event UUID";
var eventUuid$6 = "Event UUID";
var expirationDays$6 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$6 = "Expire Date";
var expires$6 = "Expires";
var extensionVersionInstalled$6 = "Version {versionString} installed";
var factor$6 = "Factor";
var factorFetchFailure$6 = "Failed to fetch available factors";
var factorMfaTokenFailure$6 = "Failed to fetch mfa token";
var factorPrimaryFailure$6 = "Failed to set {factorName} as your primary factor";
var factors$6 = "factors";
var factorsFetchFailure$6 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$6 = "We couldn’t load your user information.";
var failedToRegisterAnswers$6 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$6 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$6 = "Forced Logout";
var getOnGooglePlay$6 = "Získať z Google Play";
var goToExternalSite$6 = "Go to external site";
var helpRequestFailed$6 = "We couldn't submit your help request.";
var helpRequestSuccessful$6 = "Your support request has been sent to your OneLogin Admin.";
var hostname$6 = "Hostname & OS";
var icon$6 = "Icon";
var identifier$6 = "Credential ID / Identifier";
var imageUpload$6 = "Image Upload";
var inactive$6 = "Inactive";
var inactiveDevice$6 = "Inactive device";
var install$6 = "Install";
var invalidCode$6 = "Invalid code";
var invalidPhoneNumber$6 = "Please use valid phone number.";
var language$6 = "Language";
var languageConfirmation$6 = "Are you sure you want to switch to {language}?";
var lastAuthentication$6 = "Last Authentication";
var lastChanged$6 = "Last changed";
var lastUsed$6 = "Last Used";
var length$6 = "Minimum {length} characters";
var letter$6 = "1 Letter";
var linkToAppStore$6 = "Odkaz na obchod s aplikáciami";
var linkToGooglePlay$6 = "Odkaz na Google Play";
var loadingRecentActivity$6 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$6 = "Loading trusted browsers, please wait...";
var location$6 = "Location";
var locationTime$6 = "Location/Time";
var loggedOut$6 = "Logged Out";
var login$6 = "login";
var loginDevice$6 = "Login device";
var loginEvent$6 = "Login";
var loginFactor$6 = "Tento faktor je použitý pre prihlásenie.";
var loginFailedEvent$6 = "Login Failed";
var loginName$6 = "Login Name";
var logOut$6 = "Log Out";
var lower$6 = "1 Lowercase";
var message$6 = "{name} was successfully added.";
var mfaRegistrationFailure$6 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$6 = "You successfully registered the device";
var more$6 = "More";
var never$6 = "Never";
var newPassword$6 = "New password";
var newPrimaryFactor$6 = "New primary factor";
var noActivities$6 = "No activities have been made";
var noDevicesConfigured$6 = "No devices have been configured";
var noExpiration$6 = "Never expires";
var noMoreSecurityFactors$6 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$6 = "Loading of user failed. Try again later";
var notifySuccessAddApp$6 = "{name} was successfully added.";
var noTrustedBrowsers$6 = "No browsers have been saved";
var numbers$6 = "1 Number";
var oneloginDesktop$6 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$6 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$6 = "OneLogin logo";
var onlyDesktopBrowsersSupported$6 = "We currently only support browser extensions on desktop browsers.";
var otp1$6 = "OTP 1";
var otp2$6 = "OTP 2";
var otpDevice$6 = "Tento faktor sa používa na prihlásenie.";
var parsingUserProfilePhotoFailure$6 = "Getting image details failed";
var password$6 = "password";
var passwordChanged$6 = "Password Changed";
var passwordChangedDays$6 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$6 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$6 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$6 = "Password Reset";
var passwordUpdatedSuccessfully$6 = "You have successfully updated your password.";
var passwordUpdateFailure$6 = "Password update failed";
var phoneNumber$6 = "Phone number";
var prefix$6 = "Suspicious login report";
var previousDeviceName$6 = "Previously {previousName}";
var primary$6 = "Primary";
var proceedAnyway$6 = "Proceed anyway";
var profile$6 = "Profile";
var profileAvatar$6 = "Profile avatar";
var profileMenuToggle$6 = "Open profile menu";
var profilePhoto$6 = "Profile photo";
var profilePhotoAction$6 = "Profile image action";
var pwResetDevice$6 = "Tento faktor sa používa na obnovenie hesla.";
var pwResetFactor$6 = "Tento faktor je použitý pre obnovenie hesla.";
var questionNumber$6 = "Question {position}";
var radiusAuthentication$6 = "Service Login via Radius";
var recentActivity$6 = "Recent Activity";
var redirectToChangePassword$6 = "Redirect to change your password?";
var registerSecurityQuestions$6 = "Register Security Questions";
var registrationRejected$6 = "Registration unsuccessful, please try again.";
var registrationTimedout$6 = "Registration context timed out";
var remove$6 = "Remove";
var removeCurrentBrowserWarning$6 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$6 = "You have successfully removed your profile picture.";
var removeFactorWarning$6 = "Are you sure you want to remove {factor}?";
var removeImage$6 = "Remove image";
var report$6 = "Report";
var reportActivity$6 = "Report Activity";
var requestField$6 = "Describe the issue you're having";
var requiredQuestions$6 = "Required Questions";
var revert$6 = "prejsť späť";
var revertToAdmin$6 = "Revert to Admin";
var revertToSuperadmin$6 = "Revert to OneLogin Admin";
var revoke$6 = "Revoke";
var save$6 = "Save Changes";
var searchIcon$6 = "vyhľadať ikonu";
var secureNotes$6 = "Secure Notes";
var securityFactorAdded$6 = "Security Factor Added";
var securityFactorRemoved$6 = "Security Factor Removed";
var securityFactorRenamed$6 = "Security Factor Renamed";
var securityFactors$6 = "Security Factors";
var securityFactorsDescription$6 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$6 = "Security Factors Updated";
var selectNewImage$6 = "Select new image";
var selectNewPrimary$6 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$6 = "Select Security Factor";
var sending$6 = "Odosielanie";
var setPrimaryDevice$6 = "Set as primary";
var showDetails$6 = "Zobraziť podrobnosti";
var specials$6 = "1 Special character";
var sqDropdownAriaLabel$6 = "Question {position} dropdown";
var sqInfoHeader$6 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$6 = "Blank answers will not be accepted";
var sqTipDoNotShare$6 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$6 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$6 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$6 = "Do not use a password as an answer.";
var sqTipSameAnswer$6 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$6 = "Special characters such as @#&*. will be ignored";
var submit$6 = "Submit";
var submitting$6 = "Submitting…";
var support$6 = "Support";
var supportDefaultDescription$6 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$6 = "Supported browsers: {browsers}";
var supportRequestHeader$6 = "Support Request";
var time$6 = "Time";
var trustDevice$6 = "Trust Device";
var trusted$6 = "Trusted";
var trustedBrowsers$6 = "Trusted Browsers";
var trustedBrowsersDescription$6 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$6 = "Trusted Device";
var unavailable$6 = "Unavailable";
var unavailableTime$6 = "Unavailable";
var unsetFactorSuccess$6 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$6 = "Unset as primary";
var unsupportedBrowser$6 = "Unsupported Browser";
var unsupportedBrowserHeading$6 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$6 = "{newName} was successfully updated";
var updateFactorSuccess$6 = "{factorName} is your new default security factor";
var updatePassword$6 = "Update Password";
var updateUserProfileFailure$6 = "Profile Update Failed";
var updateUserProfilePhotoFailure$6 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$6 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$6 = "You have successfully updated your profile.";
var upper$6 = "1 Uppercase";
var usedFor$6 = "Used For";
var usedForApp$6 = "This factor is used for app.";
var usedForLogin$6 = "This factor is used for login.";
var usedForPasswordReset$6 = "This factor is used for password reset.";
var version$6 = "Version: {versionString}";
var yourBrowser$6 = "Your browser: {browser}";
var skSK = {
	"26286820": "Zadajte prihlasovacie ID a dva po sebe nasledujúce bezpečnostné kódy z VIP prístupu Symantec.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Zadajte kód, ktorý ste obdržali v SMS správe.",
	"374233718": "Môžete to skúsiť znova o {secLeft, number} {secLeft, plural, 1 sekundu {second} {seconds}}",
	"437305782": "Teraz overujeme vaše autentifikačné faktory WebAuthn.",
	"505702857": "Magický odkaz",
	"519412053": "Zmeniť zložku overenia pravosti",
	"655462232": "Stiahnite a nainštalujte si do svojho zariadenia OneLogin Protect",
	"660592555": "OK",
	"662924178": "Zdá sa, že dnes nemáme svoj deň.",
	"694278426": "Zadajte váš kód {deviceName}",
	"694920552": "Prvý bezpečnostný kód",
	"737192390": "Otvoriť {appName}",
	"740457555": "Druhý kód",
	"744377571": "Minimálny počet {length} znakov",
	"751710530": "Odovzdať",
	"916760408": "Zadajte užívateľské meno a bezpečnostný kód zo svojho zariadenia.",
	"921093870": "Nedostali ste kód?",
	"966052509": "Žiadne výsledky",
	"987359842": "Pokračujte kliknutím na odkaz vo svojom e-maile",
	"1068496829": "Vyberte si bezpečnostnú otázku {current}/{total}",
	"1079852660": "Zadajte dva po sebe idúce bezpečnostné kódy",
	"1080736814": "Zadajte {fieldName} z aplikácie Symantec VIP Access",
	"1136625613": "Proces bol zrušený. Prosím, skúste to znova alebo použite iný autentifikačný faktor.",
	"1212847248": "Potvrdzovací kód bol zaslaný na nakonfigurovanú adresu.",
	"1232460711": "Zadajte svoj e-mail",
	"1242107845": "Ukázať",
	"1254879564": "Nové heslo",
	"1359200231": "Odoslať",
	"1433651550": "Zadajte kód SMS správy OneLogin.",
	"1477893598": "Konfigurovať",
	"1536965459": "Stiahnite a nainštalujte si do svojho zariadenia OneLogin Protect",
	"1624184662": "Pre nastavenie OneLogin SMS vám v SMS správe pošleme aktivačný kód. Tento aktivačný kód budete potrebovať pre dokončenie registrácie zariadenia.",
	"1654624862": "Bezpečnostný kód",
	"1833121415": "Poskytnúť odpoveď {current}/{total}",
	"1919587067": "Znova odoslať kód",
	"1935535842": "Povinný",
	"1963245695": "1 veľké písmeno",
	"2018264248": "Skúste to znovu",
	"2091874550": "Prvý kód",
	"2097632732": "Namiesto toho naskenujte čiarový kód",
	"2104438124": "Zadajte {fieldName} a dva po sebe idúce bezpečnostné kódy zo Symantec VIP Access.",
	"2124363772": "Zadajte svoje užívateľské meno a bezpečnostný kód zo svojho kupónu SecurID.",
	"2229754167": "Zadajte vaše telefónne číslo",
	"2244720377": "Vyskytla sa neočakávaná chyba.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Na váš e-mail bol zaslaný prístupový odkaz",
	"2600324508": "Skryť",
	"2606375562": "Vložte svoj YubiKey do USB portu a stlačte tlačidlo",
	"2663586870": "Užívateľské meno",
	"2758306961": "Prihlasovacie ID",
	"2792137744": "1 číslo",
	"2815222727": "Naskenujte tento čiarový kód",
	"2828880379": "Potvrdiť",
	"2859281487": "Na zabezpečenie vášho účtu je nutné 2-zložkové overenie pravosti.",
	"2942752129": "Druhý bezpečnostný kód",
	"3060896801": "Máte problém?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 špeciálny znak",
	"3294346597": "Skúsiť znovu",
	"3327626662": "Zadajte potvrdzujúci kód",
	"3374226769": "Pre manuálny vstup kliknite na Pair",
	"3469481929": "Kód sa nedá naskenovať?",
	"3499598078": "Otvoriť ponuku",
	"3528672691": "Zrušiť",
	"3640052215": "Pokračovať",
	"3645029425": "Naskenujte QR kód uvedený nižšie",
	"3645116517": "Pri prijatí hovoru zadajte tento kód:",
	"3663548834": "Problém prešetrujeme a predpokladáme, že čoskoro sme späť. Počkajte niekoľko minút<br /> a obnovte svoj prehliadač alebo navštívte našu <a href='https://www.onelogin.com/status'>stavovú stránku</a>.",
	"3669652728": "Prístupový odkaz bol odoslaný na adresu",
	"3673120330": "Ďalší",
	"3737470122": "Pre viac informácii kontaktujte administrátora",
	"3781468762": "Váš prehliadač nepodporuje WebAuthn",
	"3827227259": "Potvrdzujúci kód bol poslaný na adresu",
	"3855542277": "Zadajte tento kód do aplikácie",
	"3865193889": "Aktivovať",
	"3877285238": "1 malé písmeno",
	"4000449233": "Voláte na nižšie uvedené telefónne číslo:",
	"4072532148": "Znovu odoslať SMS kód",
	"4151518079": "Vyberte si bezpečnostnú otázku {current}/{total}",
	"4152906165": "Problémom sa zaoberáme a predpokladáme, že čoskoro budeme späť. Počkajte niekoľko minút{break}a potom obnovte svoj prehliadač alebo navštívte našu <link>stavovú stránku</link>.",
	"4227081527": "Keď sa aplikácia nainštaluje, vráťte sa na túto obrazovku a kliknite {action}",
	"4281662478": "Hľadať",
	addApp: addApp$6,
	addFactor: addFactor$6,
	additionalQuestions: additionalQuestions$6,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$6,
	addNewSecurityQuestion: addNewSecurityQuestion$6,
	administration: administration$6,
	alert: alert$6,
	all: all$6,
	app: app$6,
	appDevice: appDevice$6,
	appDevices: appDevices$6,
	appFactor: appFactor$6,
	application: application$6,
	appName: appName$6,
	appPortal: appPortal$6,
	assumedUserNotification: assumedUserNotification$6,
	broswerExtension: broswerExtension$6,
	browser: browser$6,
	browserDeleteFailure: browserDeleteFailure$6,
	browserDeleteSuccess: browserDeleteSuccess$6,
	browserDevice: browserDevice$6,
	browserFetchFailure: browserFetchFailure$6,
	calling: calling$6,
	callUserAgain: callUserAgain$6,
	cancel: cancel$6,
	changePassword: changePassword$6,
	changeSecurityFactor: changeSecurityFactor$6,
	clearIcon: clearIcon$6,
	close: close$6,
	closeDialog: closeDialog$6,
	codeResent: codeResent$6,
	companyLogo: companyLogo$6,
	companyTab: companyTab$6,
	conditionalRequirement: conditionalRequirement$6,
	configuredOn: configuredOn$6,
	confirm: confirm$6,
	contactAdminEmailOtp: contactAdminEmailOtp$6,
	contactAdminForSMS: contactAdminForSMS$6,
	contactAdminForVoice: contactAdminForVoice$6,
	contactAdminPasswordReset: contactAdminPasswordReset$6,
	credentialId: credentialId$6,
	current: current$6,
	currentPassword: currentPassword$6,
	deleteDeviceSuccess: deleteDeviceSuccess$6,
	deleteQuestion: deleteQuestion$6,
	details: details$6,
	device: device$6,
	deviceDeleteFailure: deviceDeleteFailure$6,
	deviceFetchFailure: deviceFetchFailure$6,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$6,
	deviceRenameFailure: deviceRenameFailure$6,
	downloadOnAppStore: downloadOnAppStore$6,
	editDeviceName: editDeviceName$6,
	editSQinfo: editSQinfo$6,
	enrollNewFactor: enrollNewFactor$6,
	event: event$6,
	eventType: eventType$6,
	eventUserAgent: eventUserAgent$6,
	eventUseragent: eventUseragent$6,
	eventUUID: eventUUID$6,
	eventUuid: eventUuid$6,
	expirationDays: expirationDays$6,
	expireDate: expireDate$6,
	expires: expires$6,
	extensionVersionInstalled: extensionVersionInstalled$6,
	factor: factor$6,
	factorFetchFailure: factorFetchFailure$6,
	factorMfaTokenFailure: factorMfaTokenFailure$6,
	factorPrimaryFailure: factorPrimaryFailure$6,
	factors: factors$6,
	factorsFetchFailure: factorsFetchFailure$6,
	failedToFetchUserInfo: failedToFetchUserInfo$6,
	failedToRegisterAnswers: failedToRegisterAnswers$6,
	failedToRetrieveQuestions: failedToRetrieveQuestions$6,
	forcedLogout: forcedLogout$6,
	getOnGooglePlay: getOnGooglePlay$6,
	goToExternalSite: goToExternalSite$6,
	helpRequestFailed: helpRequestFailed$6,
	helpRequestSuccessful: helpRequestSuccessful$6,
	hostname: hostname$6,
	icon: icon$6,
	identifier: identifier$6,
	imageUpload: imageUpload$6,
	inactive: inactive$6,
	inactiveDevice: inactiveDevice$6,
	install: install$6,
	invalidCode: invalidCode$6,
	invalidPhoneNumber: invalidPhoneNumber$6,
	language: language$6,
	languageConfirmation: languageConfirmation$6,
	lastAuthentication: lastAuthentication$6,
	lastChanged: lastChanged$6,
	lastUsed: lastUsed$6,
	length: length$6,
	letter: letter$6,
	linkToAppStore: linkToAppStore$6,
	linkToGooglePlay: linkToGooglePlay$6,
	loadingRecentActivity: loadingRecentActivity$6,
	loadingTrustedBrowsers: loadingTrustedBrowsers$6,
	location: location$6,
	locationTime: locationTime$6,
	loggedOut: loggedOut$6,
	login: login$6,
	loginDevice: loginDevice$6,
	loginEvent: loginEvent$6,
	loginFactor: loginFactor$6,
	loginFailedEvent: loginFailedEvent$6,
	loginName: loginName$6,
	logOut: logOut$6,
	lower: lower$6,
	message: message$6,
	mfaRegistrationFailure: mfaRegistrationFailure$6,
	mfaRegistrationSuccess: mfaRegistrationSuccess$6,
	more: more$6,
	never: never$6,
	newPassword: newPassword$6,
	newPrimaryFactor: newPrimaryFactor$6,
	noActivities: noActivities$6,
	noDevicesConfigured: noDevicesConfigured$6,
	noExpiration: noExpiration$6,
	noMoreSecurityFactors: noMoreSecurityFactors$6,
	notifyErrorLoadingUser: notifyErrorLoadingUser$6,
	notifySuccessAddApp: notifySuccessAddApp$6,
	noTrustedBrowsers: noTrustedBrowsers$6,
	numbers: numbers$6,
	oneloginDesktop: oneloginDesktop$6,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$6,
	oneloginLogo: oneloginLogo$6,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$6,
	otp1: otp1$6,
	otp2: otp2$6,
	otpDevice: otpDevice$6,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$6,
	password: password$6,
	passwordChanged: passwordChanged$6,
	passwordChangedDays: passwordChangedDays$6,
	passwordHint: passwordHint$6,
	passwordRedirectDescription: passwordRedirectDescription$6,
	passwordReset: passwordReset$6,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$6,
	passwordUpdateFailure: passwordUpdateFailure$6,
	phoneNumber: phoneNumber$6,
	prefix: prefix$6,
	previousDeviceName: previousDeviceName$6,
	primary: primary$6,
	proceedAnyway: proceedAnyway$6,
	profile: profile$6,
	profileAvatar: profileAvatar$6,
	profileMenuToggle: profileMenuToggle$6,
	profilePhoto: profilePhoto$6,
	profilePhotoAction: profilePhotoAction$6,
	pwResetDevice: pwResetDevice$6,
	pwResetFactor: pwResetFactor$6,
	questionNumber: questionNumber$6,
	radiusAuthentication: radiusAuthentication$6,
	recentActivity: recentActivity$6,
	redirectToChangePassword: redirectToChangePassword$6,
	registerSecurityQuestions: registerSecurityQuestions$6,
	registrationRejected: registrationRejected$6,
	registrationTimedout: registrationTimedout$6,
	remove: remove$6,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$6,
	removedProfilePictureSuccess: removedProfilePictureSuccess$6,
	removeFactorWarning: removeFactorWarning$6,
	removeImage: removeImage$6,
	report: report$6,
	reportActivity: reportActivity$6,
	requestField: requestField$6,
	requiredQuestions: requiredQuestions$6,
	revert: revert$6,
	revertToAdmin: revertToAdmin$6,
	revertToSuperadmin: revertToSuperadmin$6,
	revoke: revoke$6,
	save: save$6,
	searchIcon: searchIcon$6,
	secureNotes: secureNotes$6,
	securityFactorAdded: securityFactorAdded$6,
	securityFactorRemoved: securityFactorRemoved$6,
	securityFactorRenamed: securityFactorRenamed$6,
	securityFactors: securityFactors$6,
	securityFactorsDescription: securityFactorsDescription$6,
	securityFactorsUpdated: securityFactorsUpdated$6,
	selectNewImage: selectNewImage$6,
	selectNewPrimary: selectNewPrimary$6,
	selectSecurityFactor: selectSecurityFactor$6,
	sending: sending$6,
	setPrimaryDevice: setPrimaryDevice$6,
	showDetails: showDetails$6,
	specials: specials$6,
	sqDropdownAriaLabel: sqDropdownAriaLabel$6,
	sqInfoHeader: sqInfoHeader$6,
	sqTipBlankAnswers: sqTipBlankAnswers$6,
	sqTipDoNotShare: sqTipDoNotShare$6,
	sqTipMinimum: sqTipMinimum$6,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$6,
	sqTipNoUsePassword: sqTipNoUsePassword$6,
	sqTipSameAnswer: sqTipSameAnswer$6,
	sqTipSpecialChars: sqTipSpecialChars$6,
	submit: submit$6,
	submitting: submitting$6,
	support: support$6,
	supportDefaultDescription: supportDefaultDescription$6,
	supportedBrowsers: supportedBrowsers$6,
	supportRequestHeader: supportRequestHeader$6,
	"switch": "Switch",
	time: time$6,
	trustDevice: trustDevice$6,
	trusted: trusted$6,
	trustedBrowsers: trustedBrowsers$6,
	trustedBrowsersDescription: trustedBrowsersDescription$6,
	trustedDevice: trustedDevice$6,
	unavailable: unavailable$6,
	unavailableTime: unavailableTime$6,
	unsetFactorSuccess: unsetFactorSuccess$6,
	unsetPrimaryDevice: unsetPrimaryDevice$6,
	unsupportedBrowser: unsupportedBrowser$6,
	unsupportedBrowserHeading: unsupportedBrowserHeading$6,
	updateDeviceNameSuccess: updateDeviceNameSuccess$6,
	updateFactorSuccess: updateFactorSuccess$6,
	updatePassword: updatePassword$6,
	updateUserProfileFailure: updateUserProfileFailure$6,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$6,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$6,
	updateUserProfileSuccess: updateUserProfileSuccess$6,
	upper: upper$6,
	usedFor: usedFor$6,
	usedForApp: usedForApp$6,
	usedForLogin: usedForLogin$6,
	usedForPasswordReset: usedForPasswordReset$6,
	version: version$6,
	yourBrowser: yourBrowser$6
};

var addApp$5 = "Show {addApp} button when I log in to new websites.";
var addFactor$5 = "Add Factor";
var additionalQuestions$5 = "Additional Questions";
var addNewPrimaryBeforeRemove$5 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$5 = "Add New Security Question";
var administration$5 = "Administration";
var alert$5 = "Alert";
var all$5 = "all";
var app$5 = "App";
var appDevice$5 = "Denna faktor används till appen.";
var appDevices$5 = "Denna faktor används för appen";
var appFactor$5 = "Denna faktor används till appen.";
var application$5 = "Application";
var appName$5 = "App Name";
var appPortal$5 = "App Portal";
var assumedUserNotification$5 = "You cannot edit personal information while assuming a user.";
var broswerExtension$5 = "Browser Extension";
var browser$5 = "Browser";
var browserDeleteFailure$5 = "Failed to delete trusted browser";
var browserDeleteSuccess$5 = "Trusted browser was successfully deleted";
var browserDevice$5 = "Browser/Device";
var browserFetchFailure$5 = "Failed to fetch browsers";
var calling$5 = "Ringer";
var callUserAgain$5 = "Calling you again";
var cancel$5 = "avbryt";
var changePassword$5 = "Change Password";
var changeSecurityFactor$5 = "Change Security Factor";
var clearIcon$5 = "rensa ikon";
var close$5 = "Close";
var closeDialog$5 = "Stäng dialogrutan";
var codeResent$5 = "Code has been sent to your phone.";
var companyLogo$5 = "företagslogotyp";
var companyTab$5 = "Default for company tab";
var conditionalRequirement$5 = "At least {number} of the following requirements:";
var configuredOn$5 = "Configured On";
var confirm$5 = "bekräfta";
var contactAdminEmailOtp$5 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$5 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$5 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$5 = "Contact your admin to reset password.";
var credentialId$5 = "Credential ID";
var current$5 = "Current";
var currentPassword$5 = "Current password";
var deleteDeviceSuccess$5 = "{factorName} was successfully deleted";
var deleteQuestion$5 = "Delete question {position}";
var details$5 = "Details";
var device$5 = "Device";
var deviceDeleteFailure$5 = "Failed to remove {factorName}";
var deviceFetchFailure$5 = "Failed to fetch devices";
var deviceNameCannotBeBlank$5 = "Authentication device name cannot be blank.";
var deviceRenameFailure$5 = "Failed to update device name";
var downloadOnAppStore$5 = "Ladda ner från App Store";
var editDeviceName$5 = "Edit name";
var editSQinfo$5 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$5 = "Enroll new primary factor";
var event$5 = "Event";
var eventType$5 = "Event Type";
var eventUserAgent$5 = "Event Useragent";
var eventUseragent$5 = "Event Useragent";
var eventUUID$5 = "Event UUID";
var eventUuid$5 = "Event UUID";
var expirationDays$5 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$5 = "Expire Date";
var expires$5 = "Expires";
var extensionVersionInstalled$5 = "Version {versionString} installed";
var factor$5 = "Factor";
var factorFetchFailure$5 = "Failed to fetch available factors";
var factorMfaTokenFailure$5 = "Failed to fetch mfa token";
var factorPrimaryFailure$5 = "Failed to set {factorName} as your primary factor";
var factors$5 = "factors";
var factorsFetchFailure$5 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$5 = "We couldn’t load your user information.";
var failedToRegisterAnswers$5 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$5 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$5 = "Forced Logout";
var getOnGooglePlay$5 = "Hämta den på Google Play";
var goToExternalSite$5 = "Go to external site";
var helpRequestFailed$5 = "We couldn't submit your help request.";
var helpRequestSuccessful$5 = "Your support request has been sent to your OneLogin Admin.";
var hostname$5 = "Hostname & OS";
var icon$5 = "Icon";
var identifier$5 = "Credential ID / Identifier";
var imageUpload$5 = "Image Upload";
var inactive$5 = "Inactive";
var inactiveDevice$5 = "Inactive device";
var install$5 = "Install";
var invalidCode$5 = "Invalid code";
var invalidPhoneNumber$5 = "Please use valid phone number.";
var language$5 = "Language";
var languageConfirmation$5 = "Are you sure you want to switch to {language}?";
var lastAuthentication$5 = "Last Authentication";
var lastChanged$5 = "Last changed";
var lastUsed$5 = "Last Used";
var length$5 = "Minimum {length} characters";
var letter$5 = "1 Letter";
var linkToAppStore$5 = "Länk till App Store";
var linkToGooglePlay$5 = "Länk till Google Play";
var loadingRecentActivity$5 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$5 = "Loading trusted browsers, please wait...";
var location$5 = "Location";
var locationTime$5 = "Location/Time";
var loggedOut$5 = "Logged Out";
var login$5 = "login";
var loginDevice$5 = "Login device";
var loginEvent$5 = "Login";
var loginFactor$5 = "Denna faktor används till inloggning.";
var loginFailedEvent$5 = "Login Failed";
var loginName$5 = "Login Name";
var logOut$5 = "Log Out";
var lower$5 = "1 Lowercase";
var message$5 = "{name} was successfully added.";
var mfaRegistrationFailure$5 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$5 = "You successfully registered the device";
var more$5 = "More";
var never$5 = "Never";
var newPassword$5 = "New password";
var newPrimaryFactor$5 = "New primary factor";
var noActivities$5 = "No activities have been made";
var noDevicesConfigured$5 = "No devices have been configured";
var noExpiration$5 = "Never expires";
var noMoreSecurityFactors$5 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$5 = "Loading of user failed. Try again later";
var notifySuccessAddApp$5 = "{name} was successfully added.";
var noTrustedBrowsers$5 = "No browsers have been saved";
var numbers$5 = "1 Number";
var oneloginDesktop$5 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$5 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$5 = "OneLogin logo";
var onlyDesktopBrowsersSupported$5 = "We currently only support browser extensions on desktop browsers.";
var otp1$5 = "OTP 1";
var otp2$5 = "OTP 2";
var otpDevice$5 = "Denna faktor används för inloggning.";
var parsingUserProfilePhotoFailure$5 = "Getting image details failed";
var password$5 = "password";
var passwordChanged$5 = "Password Changed";
var passwordChangedDays$5 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$5 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$5 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$5 = "Password Reset";
var passwordUpdatedSuccessfully$5 = "You have successfully updated your password.";
var passwordUpdateFailure$5 = "Password update failed";
var phoneNumber$5 = "Phone number";
var prefix$5 = "Suspicious login report";
var previousDeviceName$5 = "Previously {previousName}";
var primary$5 = "Primary";
var proceedAnyway$5 = "Proceed anyway";
var profile$5 = "Profile";
var profileAvatar$5 = "Profile avatar";
var profileMenuToggle$5 = "Open profile menu";
var profilePhoto$5 = "Profile photo";
var profilePhotoAction$5 = "Profile image action";
var pwResetDevice$5 = "Denna faktor används för att återställa lösenordet.";
var pwResetFactor$5 = "Denna faktor används till lösenordsåterställning.";
var questionNumber$5 = "Question {position}";
var radiusAuthentication$5 = "Service Login via Radius";
var recentActivity$5 = "Recent Activity";
var redirectToChangePassword$5 = "Redirect to change your password?";
var registerSecurityQuestions$5 = "Register Security Questions";
var registrationRejected$5 = "Registration unsuccessful, please try again.";
var registrationTimedout$5 = "Registration context timed out";
var remove$5 = "Remove";
var removeCurrentBrowserWarning$5 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$5 = "You have successfully removed your profile picture.";
var removeFactorWarning$5 = "Are you sure you want to remove {factor}?";
var removeImage$5 = "Remove image";
var report$5 = "Report";
var reportActivity$5 = "Report Activity";
var requestField$5 = "Describe the issue you're having";
var requiredQuestions$5 = "Required Questions";
var revert$5 = "återgå";
var revertToAdmin$5 = "Revert to Admin";
var revertToSuperadmin$5 = "Revert to OneLogin Admin";
var revoke$5 = "Revoke";
var save$5 = "Save Changes";
var searchIcon$5 = "sökikon";
var secureNotes$5 = "Secure Notes";
var securityFactorAdded$5 = "Security Factor Added";
var securityFactorRemoved$5 = "Security Factor Removed";
var securityFactorRenamed$5 = "Security Factor Renamed";
var securityFactors$5 = "Security Factors";
var securityFactorsDescription$5 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$5 = "Security Factors Updated";
var selectNewImage$5 = "Select new image";
var selectNewPrimary$5 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$5 = "Select Security Factor";
var sending$5 = "Skickar";
var setPrimaryDevice$5 = "Set as primary";
var showDetails$5 = "Visa uppgifter";
var specials$5 = "1 Special character";
var sqDropdownAriaLabel$5 = "Question {position} dropdown";
var sqInfoHeader$5 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$5 = "Blank answers will not be accepted";
var sqTipDoNotShare$5 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$5 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$5 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$5 = "Do not use a password as an answer.";
var sqTipSameAnswer$5 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$5 = "Special characters such as @#&*. will be ignored";
var submit$5 = "Submit";
var submitting$5 = "Submitting…";
var support$5 = "Support";
var supportDefaultDescription$5 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$5 = "Supported browsers: {browsers}";
var supportRequestHeader$5 = "Support Request";
var time$5 = "Time";
var trustDevice$5 = "Trust Device";
var trusted$5 = "Trusted";
var trustedBrowsers$5 = "Trusted Browsers";
var trustedBrowsersDescription$5 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$5 = "Trusted Device";
var unavailable$5 = "Unavailable";
var unavailableTime$5 = "Unavailable";
var unsetFactorSuccess$5 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$5 = "Unset as primary";
var unsupportedBrowser$5 = "Unsupported Browser";
var unsupportedBrowserHeading$5 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$5 = "{newName} was successfully updated";
var updateFactorSuccess$5 = "{factorName} is your new default security factor";
var updatePassword$5 = "Update Password";
var updateUserProfileFailure$5 = "Profile Update Failed";
var updateUserProfilePhotoFailure$5 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$5 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$5 = "You have successfully updated your profile.";
var upper$5 = "1 Uppercase";
var usedFor$5 = "Used For";
var usedForApp$5 = "This factor is used for app.";
var usedForLogin$5 = "This factor is used for login.";
var usedForPasswordReset$5 = "This factor is used for password reset.";
var version$5 = "Version: {versionString}";
var yourBrowser$5 = "Your browser: {browser}";
var sv = {
	"26286820": "Ange uppgifts-ID och två på varandra följande säkerhetskoder från Symantecs VIP-åtkomst.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Ange koden du mottagit via SMS.",
	"374233718": "Du kan försöka igen om {secLeft, number} {secLeft, plural, one {sekund} other {sekunder}}",
	"437305782": "Verifierar dina WebAuthn-autentiserare nu.",
	"505702857": "Magisk länk",
	"519412053": "Ändra autentiseringsfaktor",
	"655462232": "Hämta och installera OneLogin Protect på din enhet",
	"660592555": "OK",
	"662924178": "Ser ut som det inte är vår dag idag.",
	"694278426": "Ange din {deviceName}-kod",
	"694920552": "Första säkerhetskoden",
	"737192390": "Öppna {appName}",
	"740457555": "Andra koden",
	"744377571": "Minsta {length} tecken",
	"751710530": "Skicka in",
	"916760408": "Ange ett användarnamn och säkerhetskoden från din enhet.",
	"921093870": "Har du inte fått koden?",
	"966052509": "Inga träffar",
	"987359842": "Klicka på länken i mejlet för att fortsätta.",
	"1068496829": "Välj säkerhetsfråga {current}/{total}",
	"1079852660": "Ange två säkerhetskoder efter varandra",
	"1080736814": "Ange {fieldName} från Symantecs VIP Access-appen",
	"1136625613": "Processen avbröts. Försök igen eller använd en annan autentiseringsfaktor.",
	"1212847248": "En bekräftelsekod skickades till din konfigurerade adress.",
	"1232460711": "Ange din e-postadress",
	"1242107845": "Visa",
	"1254879564": "Nytt lösenord",
	"1359200231": "Skicka",
	"1433651550": "Ange koden från OneLogin SMS.",
	"1477893598": "Konfigurera",
	"1536965459": "Hämta och installera OneLogin Protect på din enhet",
	"1624184662": "För att ställa in OneLogin SMS skickar vi dig en aktiveringskod via SMS. Du behöver denna aktiveringskod för att slutföra enhetsregistreringen.",
	"1654624862": "Säkerhetskod",
	"1833121415": "Ge svar {current}/{total}",
	"1919587067": "Skicka koden igen",
	"1935535842": "Obligatorisk",
	"1963245695": "1 Versaler",
	"2018264248": "Försök igen",
	"2091874550": "Försa koden",
	"2097632732": "Skanna streckkod istället",
	"2104438124": "Ange {fieldName} och två säkerhetskoder i rad från Symantec VIP Access.",
	"2124363772": "Ange ditt användarnamn och säkerhetskoden från din SecurID-token.",
	"2229754167": "Ange ditt telefonnummer",
	"2244720377": "Ett oväntat fel verkar ha inträffat.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "En åtkomstlänk skickades till din e-postadress.",
	"2600324508": "Göm",
	"2606375562": "Sätt i din YubiKey i USB-porten och tryck på knappen",
	"2663586870": "Användarnamn",
	"2758306961": "Uppgifts-ID",
	"2792137744": "1 nummer",
	"2815222727": "Skanna denna streckkod",
	"2828880379": "Bekräfta",
	"2859281487": "2-faktor autentisering krävs för att säkra ditt konto.",
	"2942752129": "Andra säkerhetskoden",
	"3060896801": "Problem?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 specialtecken",
	"3294346597": "Försök igen",
	"3327626662": "Ange din bekräftelseskod",
	"3374226769": "Klicka på para med manuell inmatning",
	"3469481929": "Går inte koden att skanna?",
	"3499598078": "Öppna menyn",
	"3528672691": "Avbryt",
	"3640052215": "Fortsätt",
	"3645029425": "Skanna nedan QR-kod",
	"3645116517": "Ange den här koden när du tar emot samtalet:",
	"3663548834": "Vi undersöker problemet och räknar med att vara tillbaka snart. Vänta ett par minuter <br /> och uppdatera webbläsaren, eller besök vår <a href='https://www.onelogin.com/status'>Statussida</a>.",
	"3669652728": "En åtkomstlänk skickades till",
	"3673120330": "Nästa",
	"3737470122": "Kontakta admin för mer information.",
	"3781468762": "Din webbläsare stöder inte WebAuthn",
	"3827227259": "En bekräftelsekod har skickats till",
	"3855542277": "Ange den här koden i appen",
	"3865193889": "Aktivera",
	"3877285238": "1 liten bokstav",
	"4000449233": "Ringer nedanstående telefonnummer:",
	"4072532148": "Skicka SMS-koden igen",
	"4151518079": "Välj säkerhetsfråga {current} / {total}",
	"4152906165": "Vi undersöker problemet och räknar med att vara tillbaka snart. Vänta ett par minuter{break}och uppdatera din webbläsare, eller besök vår <link>statussida</link>.",
	"4227081527": "När appen är installerad gå tillbaka till den här skärmen och klicka på {action}",
	"4281662478": "Sök",
	addApp: addApp$5,
	addFactor: addFactor$5,
	additionalQuestions: additionalQuestions$5,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$5,
	addNewSecurityQuestion: addNewSecurityQuestion$5,
	administration: administration$5,
	alert: alert$5,
	all: all$5,
	app: app$5,
	appDevice: appDevice$5,
	appDevices: appDevices$5,
	appFactor: appFactor$5,
	application: application$5,
	appName: appName$5,
	appPortal: appPortal$5,
	assumedUserNotification: assumedUserNotification$5,
	broswerExtension: broswerExtension$5,
	browser: browser$5,
	browserDeleteFailure: browserDeleteFailure$5,
	browserDeleteSuccess: browserDeleteSuccess$5,
	browserDevice: browserDevice$5,
	browserFetchFailure: browserFetchFailure$5,
	calling: calling$5,
	callUserAgain: callUserAgain$5,
	cancel: cancel$5,
	changePassword: changePassword$5,
	changeSecurityFactor: changeSecurityFactor$5,
	clearIcon: clearIcon$5,
	close: close$5,
	closeDialog: closeDialog$5,
	codeResent: codeResent$5,
	companyLogo: companyLogo$5,
	companyTab: companyTab$5,
	conditionalRequirement: conditionalRequirement$5,
	configuredOn: configuredOn$5,
	confirm: confirm$5,
	contactAdminEmailOtp: contactAdminEmailOtp$5,
	contactAdminForSMS: contactAdminForSMS$5,
	contactAdminForVoice: contactAdminForVoice$5,
	contactAdminPasswordReset: contactAdminPasswordReset$5,
	credentialId: credentialId$5,
	current: current$5,
	currentPassword: currentPassword$5,
	deleteDeviceSuccess: deleteDeviceSuccess$5,
	deleteQuestion: deleteQuestion$5,
	details: details$5,
	device: device$5,
	deviceDeleteFailure: deviceDeleteFailure$5,
	deviceFetchFailure: deviceFetchFailure$5,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$5,
	deviceRenameFailure: deviceRenameFailure$5,
	downloadOnAppStore: downloadOnAppStore$5,
	editDeviceName: editDeviceName$5,
	editSQinfo: editSQinfo$5,
	enrollNewFactor: enrollNewFactor$5,
	event: event$5,
	eventType: eventType$5,
	eventUserAgent: eventUserAgent$5,
	eventUseragent: eventUseragent$5,
	eventUUID: eventUUID$5,
	eventUuid: eventUuid$5,
	expirationDays: expirationDays$5,
	expireDate: expireDate$5,
	expires: expires$5,
	extensionVersionInstalled: extensionVersionInstalled$5,
	factor: factor$5,
	factorFetchFailure: factorFetchFailure$5,
	factorMfaTokenFailure: factorMfaTokenFailure$5,
	factorPrimaryFailure: factorPrimaryFailure$5,
	factors: factors$5,
	factorsFetchFailure: factorsFetchFailure$5,
	failedToFetchUserInfo: failedToFetchUserInfo$5,
	failedToRegisterAnswers: failedToRegisterAnswers$5,
	failedToRetrieveQuestions: failedToRetrieveQuestions$5,
	forcedLogout: forcedLogout$5,
	getOnGooglePlay: getOnGooglePlay$5,
	goToExternalSite: goToExternalSite$5,
	helpRequestFailed: helpRequestFailed$5,
	helpRequestSuccessful: helpRequestSuccessful$5,
	hostname: hostname$5,
	icon: icon$5,
	identifier: identifier$5,
	imageUpload: imageUpload$5,
	inactive: inactive$5,
	inactiveDevice: inactiveDevice$5,
	install: install$5,
	invalidCode: invalidCode$5,
	invalidPhoneNumber: invalidPhoneNumber$5,
	language: language$5,
	languageConfirmation: languageConfirmation$5,
	lastAuthentication: lastAuthentication$5,
	lastChanged: lastChanged$5,
	lastUsed: lastUsed$5,
	length: length$5,
	letter: letter$5,
	linkToAppStore: linkToAppStore$5,
	linkToGooglePlay: linkToGooglePlay$5,
	loadingRecentActivity: loadingRecentActivity$5,
	loadingTrustedBrowsers: loadingTrustedBrowsers$5,
	location: location$5,
	locationTime: locationTime$5,
	loggedOut: loggedOut$5,
	login: login$5,
	loginDevice: loginDevice$5,
	loginEvent: loginEvent$5,
	loginFactor: loginFactor$5,
	loginFailedEvent: loginFailedEvent$5,
	loginName: loginName$5,
	logOut: logOut$5,
	lower: lower$5,
	message: message$5,
	mfaRegistrationFailure: mfaRegistrationFailure$5,
	mfaRegistrationSuccess: mfaRegistrationSuccess$5,
	more: more$5,
	never: never$5,
	newPassword: newPassword$5,
	newPrimaryFactor: newPrimaryFactor$5,
	noActivities: noActivities$5,
	noDevicesConfigured: noDevicesConfigured$5,
	noExpiration: noExpiration$5,
	noMoreSecurityFactors: noMoreSecurityFactors$5,
	notifyErrorLoadingUser: notifyErrorLoadingUser$5,
	notifySuccessAddApp: notifySuccessAddApp$5,
	noTrustedBrowsers: noTrustedBrowsers$5,
	numbers: numbers$5,
	oneloginDesktop: oneloginDesktop$5,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$5,
	oneloginLogo: oneloginLogo$5,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$5,
	otp1: otp1$5,
	otp2: otp2$5,
	otpDevice: otpDevice$5,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$5,
	password: password$5,
	passwordChanged: passwordChanged$5,
	passwordChangedDays: passwordChangedDays$5,
	passwordHint: passwordHint$5,
	passwordRedirectDescription: passwordRedirectDescription$5,
	passwordReset: passwordReset$5,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$5,
	passwordUpdateFailure: passwordUpdateFailure$5,
	phoneNumber: phoneNumber$5,
	prefix: prefix$5,
	previousDeviceName: previousDeviceName$5,
	primary: primary$5,
	proceedAnyway: proceedAnyway$5,
	profile: profile$5,
	profileAvatar: profileAvatar$5,
	profileMenuToggle: profileMenuToggle$5,
	profilePhoto: profilePhoto$5,
	profilePhotoAction: profilePhotoAction$5,
	pwResetDevice: pwResetDevice$5,
	pwResetFactor: pwResetFactor$5,
	questionNumber: questionNumber$5,
	radiusAuthentication: radiusAuthentication$5,
	recentActivity: recentActivity$5,
	redirectToChangePassword: redirectToChangePassword$5,
	registerSecurityQuestions: registerSecurityQuestions$5,
	registrationRejected: registrationRejected$5,
	registrationTimedout: registrationTimedout$5,
	remove: remove$5,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$5,
	removedProfilePictureSuccess: removedProfilePictureSuccess$5,
	removeFactorWarning: removeFactorWarning$5,
	removeImage: removeImage$5,
	report: report$5,
	reportActivity: reportActivity$5,
	requestField: requestField$5,
	requiredQuestions: requiredQuestions$5,
	revert: revert$5,
	revertToAdmin: revertToAdmin$5,
	revertToSuperadmin: revertToSuperadmin$5,
	revoke: revoke$5,
	save: save$5,
	searchIcon: searchIcon$5,
	secureNotes: secureNotes$5,
	securityFactorAdded: securityFactorAdded$5,
	securityFactorRemoved: securityFactorRemoved$5,
	securityFactorRenamed: securityFactorRenamed$5,
	securityFactors: securityFactors$5,
	securityFactorsDescription: securityFactorsDescription$5,
	securityFactorsUpdated: securityFactorsUpdated$5,
	selectNewImage: selectNewImage$5,
	selectNewPrimary: selectNewPrimary$5,
	selectSecurityFactor: selectSecurityFactor$5,
	sending: sending$5,
	setPrimaryDevice: setPrimaryDevice$5,
	showDetails: showDetails$5,
	specials: specials$5,
	sqDropdownAriaLabel: sqDropdownAriaLabel$5,
	sqInfoHeader: sqInfoHeader$5,
	sqTipBlankAnswers: sqTipBlankAnswers$5,
	sqTipDoNotShare: sqTipDoNotShare$5,
	sqTipMinimum: sqTipMinimum$5,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$5,
	sqTipNoUsePassword: sqTipNoUsePassword$5,
	sqTipSameAnswer: sqTipSameAnswer$5,
	sqTipSpecialChars: sqTipSpecialChars$5,
	submit: submit$5,
	submitting: submitting$5,
	support: support$5,
	supportDefaultDescription: supportDefaultDescription$5,
	supportedBrowsers: supportedBrowsers$5,
	supportRequestHeader: supportRequestHeader$5,
	"switch": "Switch",
	time: time$5,
	trustDevice: trustDevice$5,
	trusted: trusted$5,
	trustedBrowsers: trustedBrowsers$5,
	trustedBrowsersDescription: trustedBrowsersDescription$5,
	trustedDevice: trustedDevice$5,
	unavailable: unavailable$5,
	unavailableTime: unavailableTime$5,
	unsetFactorSuccess: unsetFactorSuccess$5,
	unsetPrimaryDevice: unsetPrimaryDevice$5,
	unsupportedBrowser: unsupportedBrowser$5,
	unsupportedBrowserHeading: unsupportedBrowserHeading$5,
	updateDeviceNameSuccess: updateDeviceNameSuccess$5,
	updateFactorSuccess: updateFactorSuccess$5,
	updatePassword: updatePassword$5,
	updateUserProfileFailure: updateUserProfileFailure$5,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$5,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$5,
	updateUserProfileSuccess: updateUserProfileSuccess$5,
	upper: upper$5,
	usedFor: usedFor$5,
	usedForApp: usedForApp$5,
	usedForLogin: usedForLogin$5,
	usedForPasswordReset: usedForPasswordReset$5,
	version: version$5,
	yourBrowser: yourBrowser$5
};

var addApp$4 = "Show {addApp} button when I log in to new websites.";
var addFactor$4 = "Add Factor";
var additionalQuestions$4 = "Additional Questions";
var addNewPrimaryBeforeRemove$4 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$4 = "Add New Security Question";
var administration$4 = "Administration";
var alert$4 = "Alert";
var all$4 = "all";
var app$4 = "App";
var appDevice$4 = "ค่านี้ใช้สำหรับแอป";
var appDevices$4 = "ปัจจัยนี้ใช้สำหรับแอป";
var appFactor$4 = "ค่านี้ใช้สำหรับแอป";
var application$4 = "Application";
var appName$4 = "App Name";
var appPortal$4 = "App Portal";
var assumedUserNotification$4 = "You cannot edit personal information while assuming a user.";
var broswerExtension$4 = "Browser Extension";
var browser$4 = "Browser";
var browserDeleteFailure$4 = "Failed to delete trusted browser";
var browserDeleteSuccess$4 = "Trusted browser was successfully deleted";
var browserDevice$4 = "Browser/Device";
var browserFetchFailure$4 = "Failed to fetch browsers";
var calling$4 = "กำลังโทร";
var callUserAgain$4 = "Calling you again";
var cancel$4 = "ยกเลิก";
var changePassword$4 = "Change Password";
var changeSecurityFactor$4 = "Change Security Factor";
var clearIcon$4 = "เคลียร์ไอคอน";
var close$4 = "Close";
var closeDialog$4 = "ปิดไดอาล็อก";
var codeResent$4 = "Code has been sent to your phone.";
var companyLogo$4 = "โลโก้บริษัท";
var companyTab$4 = "Default for company tab";
var conditionalRequirement$4 = "At least {number} of the following requirements:";
var configuredOn$4 = "Configured On";
var confirm$4 = "ยืนยัน";
var contactAdminEmailOtp$4 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$4 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$4 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$4 = "Contact your admin to reset password.";
var credentialId$4 = "Credential ID";
var current$4 = "Current";
var currentPassword$4 = "Current password";
var deleteDeviceSuccess$4 = "{factorName} was successfully deleted";
var deleteQuestion$4 = "Delete question {position}";
var details$4 = "Details";
var device$4 = "Device";
var deviceDeleteFailure$4 = "Failed to remove {factorName}";
var deviceFetchFailure$4 = "Failed to fetch devices";
var deviceNameCannotBeBlank$4 = "Authentication device name cannot be blank.";
var deviceRenameFailure$4 = "Failed to update device name";
var downloadOnAppStore$4 = "ดาวน์โหลดใน App Store";
var editDeviceName$4 = "Edit name";
var editSQinfo$4 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$4 = "Enroll new primary factor";
var event$4 = "Event";
var eventType$4 = "Event Type";
var eventUserAgent$4 = "Event Useragent";
var eventUseragent$4 = "Event Useragent";
var eventUUID$4 = "Event UUID";
var eventUuid$4 = "Event UUID";
var expirationDays$4 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$4 = "Expire Date";
var expires$4 = "Expires";
var extensionVersionInstalled$4 = "Version {versionString} installed";
var factor$4 = "Factor";
var factorFetchFailure$4 = "Failed to fetch available factors";
var factorMfaTokenFailure$4 = "Failed to fetch mfa token";
var factorPrimaryFailure$4 = "Failed to set {factorName} as your primary factor";
var factors$4 = "factors";
var factorsFetchFailure$4 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$4 = "We couldn’t load your user information.";
var failedToRegisterAnswers$4 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$4 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$4 = "Forced Logout";
var getOnGooglePlay$4 = "ดาวน์โหลดบน Google Play";
var goToExternalSite$4 = "Go to external site";
var helpRequestFailed$4 = "We couldn't submit your help request.";
var helpRequestSuccessful$4 = "Your support request has been sent to your OneLogin Admin.";
var hostname$4 = "Hostname & OS";
var icon$4 = "Icon";
var identifier$4 = "Credential ID / Identifier";
var imageUpload$4 = "Image Upload";
var inactive$4 = "Inactive";
var inactiveDevice$4 = "Inactive device";
var install$4 = "Install";
var invalidCode$4 = "Invalid code";
var invalidPhoneNumber$4 = "Please use valid phone number.";
var language$4 = "Language";
var languageConfirmation$4 = "Are you sure you want to switch to {language}?";
var lastAuthentication$4 = "Last Authentication";
var lastChanged$4 = "Last changed";
var lastUsed$4 = "Last Used";
var length$4 = "Minimum {length} characters";
var letter$4 = "1 Letter";
var linkToAppStore$4 = "ลิงก์ไปยัง App Store";
var linkToGooglePlay$4 = "ลิงก์ไปยัง Google Play";
var loadingRecentActivity$4 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$4 = "Loading trusted browsers, please wait...";
var location$4 = "Location";
var locationTime$4 = "Location/Time";
var loggedOut$4 = "Logged Out";
var login$4 = "login";
var loginDevice$4 = "Login device";
var loginEvent$4 = "Login";
var loginFactor$4 = "ค่านี้ใช้สำหรับเข้าสู่ระบบ";
var loginFailedEvent$4 = "Login Failed";
var loginName$4 = "Login Name";
var logOut$4 = "Log Out";
var lower$4 = "1 Lowercase";
var message$4 = "{name} was successfully added.";
var mfaRegistrationFailure$4 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$4 = "You successfully registered the device";
var more$4 = "More";
var never$4 = "Never";
var newPassword$4 = "New password";
var newPrimaryFactor$4 = "New primary factor";
var noActivities$4 = "No activities have been made";
var noDevicesConfigured$4 = "No devices have been configured";
var noExpiration$4 = "Never expires";
var noMoreSecurityFactors$4 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$4 = "Loading of user failed. Try again later";
var notifySuccessAddApp$4 = "{name} was successfully added.";
var noTrustedBrowsers$4 = "No browsers have been saved";
var numbers$4 = "1 Number";
var oneloginDesktop$4 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$4 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$4 = "OneLogin logo";
var onlyDesktopBrowsersSupported$4 = "We currently only support browser extensions on desktop browsers.";
var otp1$4 = "OTP 1";
var otp2$4 = "OTP 2";
var otpDevice$4 = "ปัจจัยนี้ใช้เข้าสู่ระบบ";
var parsingUserProfilePhotoFailure$4 = "Getting image details failed";
var password$4 = "password";
var passwordChanged$4 = "Password Changed";
var passwordChangedDays$4 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$4 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$4 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$4 = "Password Reset";
var passwordUpdatedSuccessfully$4 = "You have successfully updated your password.";
var passwordUpdateFailure$4 = "Password update failed";
var phoneNumber$4 = "Phone number";
var prefix$4 = "Suspicious login report";
var previousDeviceName$4 = "Previously {previousName}";
var primary$4 = "Primary";
var proceedAnyway$4 = "Proceed anyway";
var profile$4 = "Profile";
var profileAvatar$4 = "Profile avatar";
var profileMenuToggle$4 = "Open profile menu";
var profilePhoto$4 = "Profile photo";
var profilePhotoAction$4 = "Profile image action";
var pwResetDevice$4 = "ปัจจัยนี้ใช้รีเซ็ตรหัสผ่าน";
var pwResetFactor$4 = "ค่านี้ใช้สำหรับรีเซ็ตรหัสผ่าน";
var questionNumber$4 = "Question {position}";
var radiusAuthentication$4 = "Service Login via Radius";
var recentActivity$4 = "Recent Activity";
var redirectToChangePassword$4 = "Redirect to change your password?";
var registerSecurityQuestions$4 = "Register Security Questions";
var registrationRejected$4 = "Registration unsuccessful, please try again.";
var registrationTimedout$4 = "Registration context timed out";
var remove$4 = "Remove";
var removeCurrentBrowserWarning$4 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$4 = "You have successfully removed your profile picture.";
var removeFactorWarning$4 = "Are you sure you want to remove {factor}?";
var removeImage$4 = "Remove image";
var report$4 = "Report";
var reportActivity$4 = "Report Activity";
var requestField$4 = "Describe the issue you're having";
var requiredQuestions$4 = "Required Questions";
var revert$4 = "ย้อนกลับ";
var revertToAdmin$4 = "Revert to Admin";
var revertToSuperadmin$4 = "Revert to OneLogin Admin";
var revoke$4 = "Revoke";
var save$4 = "Save Changes";
var searchIcon$4 = "ค้นหาไอคอน";
var secureNotes$4 = "Secure Notes";
var securityFactorAdded$4 = "Security Factor Added";
var securityFactorRemoved$4 = "Security Factor Removed";
var securityFactorRenamed$4 = "Security Factor Renamed";
var securityFactors$4 = "Security Factors";
var securityFactorsDescription$4 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$4 = "Security Factors Updated";
var selectNewImage$4 = "Select new image";
var selectNewPrimary$4 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$4 = "Select Security Factor";
var sending$4 = "กำลังส่ง";
var setPrimaryDevice$4 = "Set as primary";
var showDetails$4 = "แสดงรายละเอียด";
var specials$4 = "1 Special character";
var sqDropdownAriaLabel$4 = "Question {position} dropdown";
var sqInfoHeader$4 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$4 = "Blank answers will not be accepted";
var sqTipDoNotShare$4 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$4 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$4 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$4 = "Do not use a password as an answer.";
var sqTipSameAnswer$4 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$4 = "Special characters such as @#&*. will be ignored";
var submit$4 = "Submit";
var submitting$4 = "Submitting…";
var support$4 = "Support";
var supportDefaultDescription$4 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$4 = "Supported browsers: {browsers}";
var supportRequestHeader$4 = "Support Request";
var time$4 = "Time";
var trustDevice$4 = "Trust Device";
var trusted$4 = "Trusted";
var trustedBrowsers$4 = "Trusted Browsers";
var trustedBrowsersDescription$4 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$4 = "Trusted Device";
var unavailable$4 = "Unavailable";
var unavailableTime$4 = "Unavailable";
var unsetFactorSuccess$4 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$4 = "Unset as primary";
var unsupportedBrowser$4 = "Unsupported Browser";
var unsupportedBrowserHeading$4 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$4 = "{newName} was successfully updated";
var updateFactorSuccess$4 = "{factorName} is your new default security factor";
var updatePassword$4 = "Update Password";
var updateUserProfileFailure$4 = "Profile Update Failed";
var updateUserProfilePhotoFailure$4 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$4 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$4 = "You have successfully updated your profile.";
var upper$4 = "1 Uppercase";
var usedFor$4 = "Used For";
var usedForApp$4 = "This factor is used for app.";
var usedForLogin$4 = "This factor is used for login.";
var usedForPasswordReset$4 = "This factor is used for password reset.";
var version$4 = "Version: {versionString}";
var yourBrowser$4 = "Your browser: {browser}";
var thTH = {
	"26286820": "ใส่รหัสข้อมูลประจำตัวและรหัสความปลอดภัยที่เรียงต่อกันสองหลักจากการเข้าถึง Symantec VIP",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "ป้อนรหัสที่คุณได้รับทาง SMS",
	"374233718": "คุณจะลองใหม่ได้ในอีก {secLeft, number} {secLeft, plural, one {second} other {seconds}}",
	"437305782": "กำลังตรวจสอบการยืนยันตัวตนผ่านทาง WebAuthn",
	"505702857": "เมจิกลิงก์",
	"519412053": "เปลี่ยนปัจจัยการตรวจสอบ",
	"655462232": "ดาวน์โหลดและติดตั้ง  OneLogin Protect บนอุปกรณ์ของคุณ",
	"660592555": "โอเค",
	"662924178": "ดูเหมือนนี่จะไม่ใช่วันของเรา",
	"694278426": "ป้อนโค้ดจาก {deviceName} ของคุณ",
	"694920552": "รหัสความปลอดภัยรหัสแรก",
	"737192390": "เปิด {appName}",
	"740457555": "รหัสที่สอง",
	"744377571": "ตัวอักษรขั้นต่ำ {length} ตัวอักษร",
	"751710530": "ส่ง",
	"916760408": "ป้อนชื่อผู้ใช้และรหัสความปลอดภัยจากอุปกรณ์ของคุณ",
	"921093870": "ยังไม่ได้รับรหัสหรือ?",
	"966052509": "ไม่มีผลลัพธ์",
	"987359842": "โปรดคลิกลิงก์ในอีเมลของคุณเพื่อดำเนินการต่อ",
	"1068496829": "เลือกคำถามความปลอดภัย {current}/{total}",
	"1079852660": "ป้อน 2 รหัสความปลอดภัยติดต่อกัน",
	"1080736814": "ป้อน {fieldName} จากแอป Symantec VIP Access",
	"1136625613": "ขั้นตอนถูกยกเลิก โปรดลองใหม่หรือใช้ปัจจัยอื่นในการยืนยันตัวตน",
	"1212847248": "รหัสการยืนยันถูกส่งไปยังที่อยู่ที่คุณกำหนดไว้แล้ว",
	"1232460711": "ป้อนอีเมลของคุณ",
	"1242107845": "แสดง",
	"1254879564": "รหัสผ่านใหม่",
	"1359200231": "ส่ง",
	"1433651550": "ป้อนรหัสจาก SMS ของ OneLogin",
	"1477893598": "กำหนดค่า",
	"1536965459": "ดาวน์โหลดและติดตั้ง OneLogin Protect บนอุปกรณ์ของคุณ",
	"1624184662": "เพื่อที่จะตั้งค่า OneLogin SMS ทางเราจะส่งรหัสการเปิดใช้งานให้คุณทาง SMS คุณต้องใช้รหัสการเปิดใช้งานนี้เพื่อให้การลงทะเบียนอุปกรณ์เสร็จสมบูรณ์",
	"1654624862": "รหัสความปลอดภัย",
	"1833121415": "คำตอบที่มีให้ {current}/{total}",
	"1919587067": "ส่งรหัสอีกครั้ง",
	"1935535842": "จำเป็นต้องมี",
	"1963245695": "1 ตัวพิมพ์ใหญ่",
	"2018264248": "ลองใหม่",
	"2091874550": "รหัสแรก",
	"2097632732": "สแกนบาร์โคดแทน",
	"2104438124": "ป้อน {fieldName} และรหัสความปลอดภัย 2 รหัสติดต่อกัน จาก Symantec VIP Access",
	"2124363772": "ป้อนชื่อผู้ใช้ของคุณและรหัสความปลอดภัยจากโทเค็น SecurID",
	"2229754167": "ป้อนหมายเลขโทรศัพท์ของคุณ",
	"2244720377": "ดูเหมือนจะมีข้อผิดพลาดที่ไม่คาดคิดเกิดขึ้น",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "ลิงก์การเข้าถึงถูกส่งไปยังอีเมลของคุณแล้ว",
	"2600324508": "ซ่อน",
	"2606375562": "ใส่ YubiKey ของคุณในพอร์ท USB แล้วกดปุ่ม",
	"2663586870": "ชื่อผู้ใช้",
	"2758306961": "รหัสข้อมูลประจำตัว",
	"2792137744": "1 หมายเลข",
	"2815222727": "สแกนบาร์โคดนี้",
	"2828880379": "ยืนยัน",
	"2859281487": "จำเป็นต้องมีการตรวจสอบความถูกต้อง 2 ปัจจัยเพื่อความปลอดภัยในบัญชีของคุณ",
	"2942752129": "รหัสความปลอดภัยที่สอง",
	"3060896801": "มีปัญหาหรือ?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 อักขระพิเศษ",
	"3294346597": "ลองอีกครั้ง",
	"3327626662": "ป้อนรหัสยืนยันของคุณ",
	"3374226769": "คลิก Pair โดยป้อนด้วยตนเอง",
	"3469481929": "ไม่สามารถสแกนรหัส?",
	"3499598078": "เปิดเมนู",
	"3528672691": "ยกเลิก",
	"3640052215": "ดำเนินการต่อ",
	"3645029425": "สแกนใต้รหัส QR Code",
	"3645116517": "ป้อนโค้ดนี้เมื่อได้รับสายเรียกเข้า:",
	"3663548834": "เรากำลังตรวจสอบปัญหาและคาดว่าจะกลับมาเร็ว ๆ นี้ กรุณารอสักครู่<br />และรีเฟรชเบราว์เซอร์ของคุณ หรือไปที่<a href='https://www.onelogin.com/status'>หน้าสถานะ</a>ของเรา",
	"3669652728": "ลิงก์การเข้าถึงถูกส่งไปยัง",
	"3673120330": "ต่อไป",
	"3737470122": "โปรดติดต่อผู้ดูแลเพื่อขอข้อมูลเพิ่มเติม",
	"3781468762": "เบราว์เซอร์ของคุณไม่รองรับ WebAuthn",
	"3827227259": "ระบบได้ส่งโค้ดยืนยันไปยัง",
	"3855542277": "ป้อนรหัสนี้ลงในแอป",
	"3865193889": "เปิดใช้งาน",
	"3877285238": "1 ตัวพิมพ์เล็ก",
	"4000449233": "กำลังโทรติดต่อหมายเลขโทรศัพท์ด้านล่างนี้:",
	"4072532148": "ส่งรหัส SMS อีกครั้ง",
	"4151518079": "เลือกคำถามความปลอดภัย {current} / {total}",
	"4152906165": "เรากำลังวินิจฉัยปัญหาและคาดว่าจะกลับมาให้บริการได้เร็ว ๆ นี้ โปรดรอสักครู่แล้วรีเฟรชเบราว์เซอร์ของคุณ หรือไปที่ <link>หน้าสถานะ</link>",
	"4227081527": "เมื่อติดตั้งแอปแล้ว กลับมาที่หน้าจอนี้และคลิก {action}",
	"4281662478": "ค้นหา",
	addApp: addApp$4,
	addFactor: addFactor$4,
	additionalQuestions: additionalQuestions$4,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$4,
	addNewSecurityQuestion: addNewSecurityQuestion$4,
	administration: administration$4,
	alert: alert$4,
	all: all$4,
	app: app$4,
	appDevice: appDevice$4,
	appDevices: appDevices$4,
	appFactor: appFactor$4,
	application: application$4,
	appName: appName$4,
	appPortal: appPortal$4,
	assumedUserNotification: assumedUserNotification$4,
	broswerExtension: broswerExtension$4,
	browser: browser$4,
	browserDeleteFailure: browserDeleteFailure$4,
	browserDeleteSuccess: browserDeleteSuccess$4,
	browserDevice: browserDevice$4,
	browserFetchFailure: browserFetchFailure$4,
	calling: calling$4,
	callUserAgain: callUserAgain$4,
	cancel: cancel$4,
	changePassword: changePassword$4,
	changeSecurityFactor: changeSecurityFactor$4,
	clearIcon: clearIcon$4,
	close: close$4,
	closeDialog: closeDialog$4,
	codeResent: codeResent$4,
	companyLogo: companyLogo$4,
	companyTab: companyTab$4,
	conditionalRequirement: conditionalRequirement$4,
	configuredOn: configuredOn$4,
	confirm: confirm$4,
	contactAdminEmailOtp: contactAdminEmailOtp$4,
	contactAdminForSMS: contactAdminForSMS$4,
	contactAdminForVoice: contactAdminForVoice$4,
	contactAdminPasswordReset: contactAdminPasswordReset$4,
	credentialId: credentialId$4,
	current: current$4,
	currentPassword: currentPassword$4,
	deleteDeviceSuccess: deleteDeviceSuccess$4,
	deleteQuestion: deleteQuestion$4,
	details: details$4,
	device: device$4,
	deviceDeleteFailure: deviceDeleteFailure$4,
	deviceFetchFailure: deviceFetchFailure$4,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$4,
	deviceRenameFailure: deviceRenameFailure$4,
	downloadOnAppStore: downloadOnAppStore$4,
	editDeviceName: editDeviceName$4,
	editSQinfo: editSQinfo$4,
	enrollNewFactor: enrollNewFactor$4,
	event: event$4,
	eventType: eventType$4,
	eventUserAgent: eventUserAgent$4,
	eventUseragent: eventUseragent$4,
	eventUUID: eventUUID$4,
	eventUuid: eventUuid$4,
	expirationDays: expirationDays$4,
	expireDate: expireDate$4,
	expires: expires$4,
	extensionVersionInstalled: extensionVersionInstalled$4,
	factor: factor$4,
	factorFetchFailure: factorFetchFailure$4,
	factorMfaTokenFailure: factorMfaTokenFailure$4,
	factorPrimaryFailure: factorPrimaryFailure$4,
	factors: factors$4,
	factorsFetchFailure: factorsFetchFailure$4,
	failedToFetchUserInfo: failedToFetchUserInfo$4,
	failedToRegisterAnswers: failedToRegisterAnswers$4,
	failedToRetrieveQuestions: failedToRetrieveQuestions$4,
	forcedLogout: forcedLogout$4,
	getOnGooglePlay: getOnGooglePlay$4,
	goToExternalSite: goToExternalSite$4,
	helpRequestFailed: helpRequestFailed$4,
	helpRequestSuccessful: helpRequestSuccessful$4,
	hostname: hostname$4,
	icon: icon$4,
	identifier: identifier$4,
	imageUpload: imageUpload$4,
	inactive: inactive$4,
	inactiveDevice: inactiveDevice$4,
	install: install$4,
	invalidCode: invalidCode$4,
	invalidPhoneNumber: invalidPhoneNumber$4,
	language: language$4,
	languageConfirmation: languageConfirmation$4,
	lastAuthentication: lastAuthentication$4,
	lastChanged: lastChanged$4,
	lastUsed: lastUsed$4,
	length: length$4,
	letter: letter$4,
	linkToAppStore: linkToAppStore$4,
	linkToGooglePlay: linkToGooglePlay$4,
	loadingRecentActivity: loadingRecentActivity$4,
	loadingTrustedBrowsers: loadingTrustedBrowsers$4,
	location: location$4,
	locationTime: locationTime$4,
	loggedOut: loggedOut$4,
	login: login$4,
	loginDevice: loginDevice$4,
	loginEvent: loginEvent$4,
	loginFactor: loginFactor$4,
	loginFailedEvent: loginFailedEvent$4,
	loginName: loginName$4,
	logOut: logOut$4,
	lower: lower$4,
	message: message$4,
	mfaRegistrationFailure: mfaRegistrationFailure$4,
	mfaRegistrationSuccess: mfaRegistrationSuccess$4,
	more: more$4,
	never: never$4,
	newPassword: newPassword$4,
	newPrimaryFactor: newPrimaryFactor$4,
	noActivities: noActivities$4,
	noDevicesConfigured: noDevicesConfigured$4,
	noExpiration: noExpiration$4,
	noMoreSecurityFactors: noMoreSecurityFactors$4,
	notifyErrorLoadingUser: notifyErrorLoadingUser$4,
	notifySuccessAddApp: notifySuccessAddApp$4,
	noTrustedBrowsers: noTrustedBrowsers$4,
	numbers: numbers$4,
	oneloginDesktop: oneloginDesktop$4,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$4,
	oneloginLogo: oneloginLogo$4,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$4,
	otp1: otp1$4,
	otp2: otp2$4,
	otpDevice: otpDevice$4,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$4,
	password: password$4,
	passwordChanged: passwordChanged$4,
	passwordChangedDays: passwordChangedDays$4,
	passwordHint: passwordHint$4,
	passwordRedirectDescription: passwordRedirectDescription$4,
	passwordReset: passwordReset$4,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$4,
	passwordUpdateFailure: passwordUpdateFailure$4,
	phoneNumber: phoneNumber$4,
	prefix: prefix$4,
	previousDeviceName: previousDeviceName$4,
	primary: primary$4,
	proceedAnyway: proceedAnyway$4,
	profile: profile$4,
	profileAvatar: profileAvatar$4,
	profileMenuToggle: profileMenuToggle$4,
	profilePhoto: profilePhoto$4,
	profilePhotoAction: profilePhotoAction$4,
	pwResetDevice: pwResetDevice$4,
	pwResetFactor: pwResetFactor$4,
	questionNumber: questionNumber$4,
	radiusAuthentication: radiusAuthentication$4,
	recentActivity: recentActivity$4,
	redirectToChangePassword: redirectToChangePassword$4,
	registerSecurityQuestions: registerSecurityQuestions$4,
	registrationRejected: registrationRejected$4,
	registrationTimedout: registrationTimedout$4,
	remove: remove$4,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$4,
	removedProfilePictureSuccess: removedProfilePictureSuccess$4,
	removeFactorWarning: removeFactorWarning$4,
	removeImage: removeImage$4,
	report: report$4,
	reportActivity: reportActivity$4,
	requestField: requestField$4,
	requiredQuestions: requiredQuestions$4,
	revert: revert$4,
	revertToAdmin: revertToAdmin$4,
	revertToSuperadmin: revertToSuperadmin$4,
	revoke: revoke$4,
	save: save$4,
	searchIcon: searchIcon$4,
	secureNotes: secureNotes$4,
	securityFactorAdded: securityFactorAdded$4,
	securityFactorRemoved: securityFactorRemoved$4,
	securityFactorRenamed: securityFactorRenamed$4,
	securityFactors: securityFactors$4,
	securityFactorsDescription: securityFactorsDescription$4,
	securityFactorsUpdated: securityFactorsUpdated$4,
	selectNewImage: selectNewImage$4,
	selectNewPrimary: selectNewPrimary$4,
	selectSecurityFactor: selectSecurityFactor$4,
	sending: sending$4,
	setPrimaryDevice: setPrimaryDevice$4,
	showDetails: showDetails$4,
	specials: specials$4,
	sqDropdownAriaLabel: sqDropdownAriaLabel$4,
	sqInfoHeader: sqInfoHeader$4,
	sqTipBlankAnswers: sqTipBlankAnswers$4,
	sqTipDoNotShare: sqTipDoNotShare$4,
	sqTipMinimum: sqTipMinimum$4,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$4,
	sqTipNoUsePassword: sqTipNoUsePassword$4,
	sqTipSameAnswer: sqTipSameAnswer$4,
	sqTipSpecialChars: sqTipSpecialChars$4,
	submit: submit$4,
	submitting: submitting$4,
	support: support$4,
	supportDefaultDescription: supportDefaultDescription$4,
	supportedBrowsers: supportedBrowsers$4,
	supportRequestHeader: supportRequestHeader$4,
	"switch": "Switch",
	time: time$4,
	trustDevice: trustDevice$4,
	trusted: trusted$4,
	trustedBrowsers: trustedBrowsers$4,
	trustedBrowsersDescription: trustedBrowsersDescription$4,
	trustedDevice: trustedDevice$4,
	unavailable: unavailable$4,
	unavailableTime: unavailableTime$4,
	unsetFactorSuccess: unsetFactorSuccess$4,
	unsetPrimaryDevice: unsetPrimaryDevice$4,
	unsupportedBrowser: unsupportedBrowser$4,
	unsupportedBrowserHeading: unsupportedBrowserHeading$4,
	updateDeviceNameSuccess: updateDeviceNameSuccess$4,
	updateFactorSuccess: updateFactorSuccess$4,
	updatePassword: updatePassword$4,
	updateUserProfileFailure: updateUserProfileFailure$4,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$4,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$4,
	updateUserProfileSuccess: updateUserProfileSuccess$4,
	upper: upper$4,
	usedFor: usedFor$4,
	usedForApp: usedForApp$4,
	usedForLogin: usedForLogin$4,
	usedForPasswordReset: usedForPasswordReset$4,
	version: version$4,
	yourBrowser: yourBrowser$4
};

var addApp$3 = "Show {addApp} button when I log in to new websites.";
var addFactor$3 = "Add Factor";
var additionalQuestions$3 = "Additional Questions";
var addNewPrimaryBeforeRemove$3 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$3 = "Add New Security Question";
var administration$3 = "Administration";
var alert$3 = "Alert";
var all$3 = "all";
var app$3 = "App";
var appDevice$3 = "Bu faktör uygulama için kullanılmaktadır.";
var appDevices$3 = "Bu faktör uygulama için kullanılır";
var appFactor$3 = "Bu faktör uygulama için kullanılmaktadır.";
var application$3 = "Application";
var appName$3 = "App Name";
var appPortal$3 = "App Portal";
var assumedUserNotification$3 = "You cannot edit personal information while assuming a user.";
var broswerExtension$3 = "Browser Extension";
var browser$3 = "Browser";
var browserDeleteFailure$3 = "Failed to delete trusted browser";
var browserDeleteSuccess$3 = "Trusted browser was successfully deleted";
var browserDevice$3 = "Browser/Device";
var browserFetchFailure$3 = "Failed to fetch browsers";
var calling$3 = "Aranıyor";
var callUserAgain$3 = "Calling you again";
var cancel$3 = "iptal";
var changePassword$3 = "Change Password";
var changeSecurityFactor$3 = "Change Security Factor";
var clearIcon$3 = "temizleme simgesi";
var close$3 = "Close";
var closeDialog$3 = "Diyaloğu kapat";
var codeResent$3 = "Code has been sent to your phone.";
var companyLogo$3 = "şirket logosu";
var companyTab$3 = "Default for company tab";
var conditionalRequirement$3 = "At least {number} of the following requirements:";
var configuredOn$3 = "Configured On";
var confirm$3 = "onayla";
var contactAdminEmailOtp$3 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$3 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$3 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$3 = "Contact your admin to reset password.";
var credentialId$3 = "Credential ID";
var current$3 = "Current";
var currentPassword$3 = "Current password";
var deleteDeviceSuccess$3 = "{factorName} was successfully deleted";
var deleteQuestion$3 = "Delete question {position}";
var details$3 = "Details";
var device$3 = "Device";
var deviceDeleteFailure$3 = "Failed to remove {factorName}";
var deviceFetchFailure$3 = "Failed to fetch devices";
var deviceNameCannotBeBlank$3 = "Authentication device name cannot be blank.";
var deviceRenameFailure$3 = "Failed to update device name";
var downloadOnAppStore$3 = "App store'dan indir";
var editDeviceName$3 = "Edit name";
var editSQinfo$3 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$3 = "Enroll new primary factor";
var event$3 = "Event";
var eventType$3 = "Event Type";
var eventUserAgent$3 = "Event Useragent";
var eventUseragent$3 = "Event Useragent";
var eventUUID$3 = "Event UUID";
var eventUuid$3 = "Event UUID";
var expirationDays$3 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$3 = "Expire Date";
var expires$3 = "Expires";
var extensionVersionInstalled$3 = "Version {versionString} installed";
var factor$3 = "Factor";
var factorFetchFailure$3 = "Failed to fetch available factors";
var factorMfaTokenFailure$3 = "Failed to fetch mfa token";
var factorPrimaryFailure$3 = "Failed to set {factorName} as your primary factor";
var factors$3 = "factors";
var factorsFetchFailure$3 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$3 = "We couldn’t load your user information.";
var failedToRegisterAnswers$3 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$3 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$3 = "Forced Logout";
var getOnGooglePlay$3 = "Google Play'den Al";
var goToExternalSite$3 = "Go to external site";
var helpRequestFailed$3 = "We couldn't submit your help request.";
var helpRequestSuccessful$3 = "Your support request has been sent to your OneLogin Admin.";
var hostname$3 = "Hostname & OS";
var icon$3 = "Icon";
var identifier$3 = "Credential ID / Identifier";
var imageUpload$3 = "Image Upload";
var inactive$3 = "Inactive";
var inactiveDevice$3 = "Inactive device";
var install$3 = "Install";
var invalidCode$3 = "Invalid code";
var invalidPhoneNumber$3 = "Please use valid phone number.";
var language$3 = "Language";
var languageConfirmation$3 = "Are you sure you want to switch to {language}?";
var lastAuthentication$3 = "Last Authentication";
var lastChanged$3 = "Last changed";
var lastUsed$3 = "Last Used";
var length$3 = "Minimum {length} characters";
var letter$3 = "1 Letter";
var linkToAppStore$3 = "App Store bağlantısı";
var linkToGooglePlay$3 = "Google Play bağlantısı";
var loadingRecentActivity$3 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$3 = "Loading trusted browsers, please wait...";
var location$3 = "Location";
var locationTime$3 = "Location/Time";
var loggedOut$3 = "Logged Out";
var login$3 = "login";
var loginDevice$3 = "Login device";
var loginEvent$3 = "Login";
var loginFactor$3 = "Bu faktör oturum açmak için kullanılır.";
var loginFailedEvent$3 = "Login Failed";
var loginName$3 = "Login Name";
var logOut$3 = "Log Out";
var lower$3 = "1 Lowercase";
var message$3 = "{name} was successfully added.";
var mfaRegistrationFailure$3 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$3 = "You successfully registered the device";
var more$3 = "More";
var never$3 = "Never";
var newPassword$3 = "New password";
var newPrimaryFactor$3 = "New primary factor";
var noActivities$3 = "No activities have been made";
var noDevicesConfigured$3 = "No devices have been configured";
var noExpiration$3 = "Never expires";
var noMoreSecurityFactors$3 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$3 = "Loading of user failed. Try again later";
var notifySuccessAddApp$3 = "{name} was successfully added.";
var noTrustedBrowsers$3 = "No browsers have been saved";
var numbers$3 = "1 Number";
var oneloginDesktop$3 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$3 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$3 = "OneLogin logo";
var onlyDesktopBrowsersSupported$3 = "We currently only support browser extensions on desktop browsers.";
var otp1$3 = "OTP 1";
var otp2$3 = "OTP 2";
var otpDevice$3 = "Bu faktör giriş için kullanılır.";
var parsingUserProfilePhotoFailure$3 = "Getting image details failed";
var password$3 = "password";
var passwordChanged$3 = "Password Changed";
var passwordChangedDays$3 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$3 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$3 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$3 = "Password Reset";
var passwordUpdatedSuccessfully$3 = "You have successfully updated your password.";
var passwordUpdateFailure$3 = "Password update failed";
var phoneNumber$3 = "Phone number";
var prefix$3 = "Suspicious login report";
var previousDeviceName$3 = "Previously {previousName}";
var primary$3 = "Primary";
var proceedAnyway$3 = "Proceed anyway";
var profile$3 = "Profile";
var profileAvatar$3 = "Profile avatar";
var profileMenuToggle$3 = "Open profile menu";
var profilePhoto$3 = "Profile photo";
var profilePhotoAction$3 = "Profile image action";
var pwResetDevice$3 = "Bu faktör parola sıfırlama için kullanılır.";
var pwResetFactor$3 = "Bu faktör parola sıfırlama için kullanılır.";
var questionNumber$3 = "Question {position}";
var radiusAuthentication$3 = "Service Login via Radius";
var recentActivity$3 = "Recent Activity";
var redirectToChangePassword$3 = "Redirect to change your password?";
var registerSecurityQuestions$3 = "Register Security Questions";
var registrationRejected$3 = "Registration unsuccessful, please try again.";
var registrationTimedout$3 = "Registration context timed out";
var remove$3 = "Remove";
var removeCurrentBrowserWarning$3 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$3 = "You have successfully removed your profile picture.";
var removeFactorWarning$3 = "Are you sure you want to remove {factor}?";
var removeImage$3 = "Remove image";
var report$3 = "Report";
var reportActivity$3 = "Report Activity";
var requestField$3 = "Describe the issue you're having";
var requiredQuestions$3 = "Required Questions";
var revert$3 = "geri al";
var revertToAdmin$3 = "Revert to Admin";
var revertToSuperadmin$3 = "Revert to OneLogin Admin";
var revoke$3 = "Revoke";
var save$3 = "Save Changes";
var searchIcon$3 = "arama simgesi";
var secureNotes$3 = "Secure Notes";
var securityFactorAdded$3 = "Security Factor Added";
var securityFactorRemoved$3 = "Security Factor Removed";
var securityFactorRenamed$3 = "Security Factor Renamed";
var securityFactors$3 = "Security Factors";
var securityFactorsDescription$3 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$3 = "Security Factors Updated";
var selectNewImage$3 = "Select new image";
var selectNewPrimary$3 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$3 = "Select Security Factor";
var sending$3 = "Gönderiliyor";
var setPrimaryDevice$3 = "Set as primary";
var showDetails$3 = "Detayları göster";
var specials$3 = "1 Special character";
var sqDropdownAriaLabel$3 = "Question {position} dropdown";
var sqInfoHeader$3 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$3 = "Blank answers will not be accepted";
var sqTipDoNotShare$3 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$3 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$3 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$3 = "Do not use a password as an answer.";
var sqTipSameAnswer$3 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$3 = "Special characters such as @#&*. will be ignored";
var submit$3 = "Submit";
var submitting$3 = "Submitting…";
var support$3 = "Support";
var supportDefaultDescription$3 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$3 = "Supported browsers: {browsers}";
var supportRequestHeader$3 = "Support Request";
var time$3 = "Time";
var trustDevice$3 = "Trust Device";
var trusted$3 = "Trusted";
var trustedBrowsers$3 = "Trusted Browsers";
var trustedBrowsersDescription$3 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$3 = "Trusted Device";
var unavailable$3 = "Unavailable";
var unavailableTime$3 = "Unavailable";
var unsetFactorSuccess$3 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$3 = "Unset as primary";
var unsupportedBrowser$3 = "Unsupported Browser";
var unsupportedBrowserHeading$3 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$3 = "{newName} was successfully updated";
var updateFactorSuccess$3 = "{factorName} is your new default security factor";
var updatePassword$3 = "Update Password";
var updateUserProfileFailure$3 = "Profile Update Failed";
var updateUserProfilePhotoFailure$3 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$3 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$3 = "You have successfully updated your profile.";
var upper$3 = "1 Uppercase";
var usedFor$3 = "Used For";
var usedForApp$3 = "This factor is used for app.";
var usedForLogin$3 = "This factor is used for login.";
var usedForPasswordReset$3 = "This factor is used for password reset.";
var version$3 = "Version: {versionString}";
var yourBrowser$3 = "Your browser: {browser}";
var trTR = {
	"26286820": "Kimlik Bilgisi Kodunu ve Symantec VIP Erişimi'nden iki ardışık Güvenlik Kodunu girin.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "SMS'le aldığınız kodu girin.",
	"374233718": "{secLeft, number} {secLeft, plural, one {second} other {seconds}} içinde tekrar deneyebilirsiniz",
	"437305782": "Şu anda WebAuthn kimlik belirleyiciniz doğrulanıyor.",
	"505702857": "Sihirli Bağlantı",
	"519412053": "Kimlik Doğrulama Etmenini Değiştirin",
	"655462232": "Cihazınıza OneLogin Protect'i indirip kurun",
	"660592555": "Tamam",
	"662924178": "Görünüşe bakılırsa bugün bizim günümüz değil.",
	"694278426": "{deviceName} kodunuzu girin",
	"694920552": "İlk Güvenlik Kodu",
	"737192390": "{appName} Uygulamasını Aç",
	"740457555": "İkinci Kod",
	"744377571": "Asgari {length} karakter",
	"751710530": "Gönder",
	"916760408": "Bir kullanıcı adı ve cihazınızdan bir güvenlik kodu girin.",
	"921093870": "Kodu almadınız mı?",
	"966052509": "Sonuç Yok",
	"987359842": "Devam etmek için lütfen e-postanızdaki bağlantıya tıklayın",
	"1068496829": "Güvenlik Sorusu Seçin {current}/{total}",
	"1079852660": "İki ardışık Güvenlik Kodu girin",
	"1080736814": "Symantec VIP Access uygulamasından {fieldName} alanını girin",
	"1136625613": "Süreç iptal edildi. Lütfen tekrar deneyin veya başka bir kimlik belirleyici faktör kullanın.",
	"1212847248": "Yapılandırılmış adresinize bir onay kodu gönderildi.",
	"1232460711": "Emailinizi girin",
	"1242107845": "Göster",
	"1254879564": "Yeni Şifre",
	"1359200231": "Gönder",
	"1433651550": "OneLogin SMS'ten kodu girin.",
	"1477893598": "Yapılandır",
	"1536965459": "OneLogin Protect'i cihazınıza indirip yükleyin",
	"1624184662": "OneLogin SMS'i kurmak için size SMS yoluyla bir aktivasyon kodu göndereceğiz. Cihaz kaydını tamamlamak için bu aktivasyon koduna ihtiyacınız olacak.",
	"1654624862": "Güvenlik Kodu",
	"1833121415": "Yanıt Verin {current}/{total}",
	"1919587067": "Kodu tekrar gönder",
	"1935535842": "Gerekli",
	"1963245695": "1 büyük harf",
	"2018264248": "Tekrar Deneyin",
	"2091874550": "İlk Kod",
	"2097632732": "Bunun yerine barkodu taratın",
	"2104438124": "{fieldName} alanını ve Symantec VIP Access'ten iki ardışık Güvenlik Kodunu girin.",
	"2124363772": "Kullanıcı adınızı ve SecurID belirtecinizden güvenlik kodunuzu girin.",
	"2229754167": "Telefon numaranızı girin",
	"2244720377": "Beklenmedik bir hata oluşmuş gibi gözüküyor.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "E-postanıza bir erişim bağlantısı gönderildi",
	"2600324508": "Gizle",
	"2606375562": "YubiKey'inizi USB bağlantı noktasına takın ve tuşa basın",
	"2663586870": "Kullanıcı Adı",
	"2758306961": "Kimlik Bilgisi Kodu",
	"2792137744": "1 rakam",
	"2815222727": "Bu barkodu taratın",
	"2828880379": "Onayla",
	"2859281487": "Hesabınızı güvenceye almak için 2 etmenli kimlik doğrulama gerekli.",
	"2942752129": "İkinci Güvenlik Kodu",
	"3060896801": "Sorun mu yaşıyorsunuz?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 özel karakter",
	"3294346597": "Tekrar deneyin",
	"3327626662": "Onay kodunuzu girin",
	"3374226769": "Elle giriş kullanarak Eşleştir'e tıklayın",
	"3469481929": "Kodu taratamıyor musunuz?",
	"3499598078": "Menüyü aç",
	"3528672691": "İptal Et",
	"3640052215": "Devam Et",
	"3645029425": "Aşağıdaki QR Kodunu Taratın",
	"3645116517": "Bu kodu aramayı aldığınızda girin",
	"3663548834": "Sorunu inceliyoruz ve yakında geri gelmeyi bekliyoruz. Lütfen birkaç dakika bekleyin<br />ve tarayıcınızı yenileyin, veya <a href='https://www.onelogin.com/status'>Durum Sayfamızı</a> ziyaret edin.",
	"3669652728": "Bir erişim bağlantısı gönderildi",
	"3673120330": "Sonraki",
	"3737470122": "Daha fazla bilgi için lütfen yönetici ile iletişime geçin.",
	"3781468762": "Tarayıcınız WebAuthn'u desteklemiyor",
	"3827227259": "Şuraya bir onay kodu gönderildi:",
	"3855542277": "Bu kodu uygulamaya girin",
	"3865193889": "Aktive Et",
	"3877285238": "1 küçük harf",
	"4000449233": "Aşağıdaki telefon numarası aranıyor:",
	"4072532148": "SMS kodunu tekrar gönder",
	"4151518079": "Güvenlik Sorusu Seçin {current} / {total}",
	"4152906165": "Sorunu araştırıyoruz ve yakında dönmeyi bekliyoruz. Lütfen birkaç dakika{break} bekleyip tarayıcınızı yenileyin veya <link>Durum Sayfamızı</link> ziyaret edin.",
	"4227081527": "Uygulama yüklenince bu ekrana geri gelip {action} tuşuna tıklayın",
	"4281662478": "Ara",
	addApp: addApp$3,
	addFactor: addFactor$3,
	additionalQuestions: additionalQuestions$3,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$3,
	addNewSecurityQuestion: addNewSecurityQuestion$3,
	administration: administration$3,
	alert: alert$3,
	all: all$3,
	app: app$3,
	appDevice: appDevice$3,
	appDevices: appDevices$3,
	appFactor: appFactor$3,
	application: application$3,
	appName: appName$3,
	appPortal: appPortal$3,
	assumedUserNotification: assumedUserNotification$3,
	broswerExtension: broswerExtension$3,
	browser: browser$3,
	browserDeleteFailure: browserDeleteFailure$3,
	browserDeleteSuccess: browserDeleteSuccess$3,
	browserDevice: browserDevice$3,
	browserFetchFailure: browserFetchFailure$3,
	calling: calling$3,
	callUserAgain: callUserAgain$3,
	cancel: cancel$3,
	changePassword: changePassword$3,
	changeSecurityFactor: changeSecurityFactor$3,
	clearIcon: clearIcon$3,
	close: close$3,
	closeDialog: closeDialog$3,
	codeResent: codeResent$3,
	companyLogo: companyLogo$3,
	companyTab: companyTab$3,
	conditionalRequirement: conditionalRequirement$3,
	configuredOn: configuredOn$3,
	confirm: confirm$3,
	contactAdminEmailOtp: contactAdminEmailOtp$3,
	contactAdminForSMS: contactAdminForSMS$3,
	contactAdminForVoice: contactAdminForVoice$3,
	contactAdminPasswordReset: contactAdminPasswordReset$3,
	credentialId: credentialId$3,
	current: current$3,
	currentPassword: currentPassword$3,
	deleteDeviceSuccess: deleteDeviceSuccess$3,
	deleteQuestion: deleteQuestion$3,
	details: details$3,
	device: device$3,
	deviceDeleteFailure: deviceDeleteFailure$3,
	deviceFetchFailure: deviceFetchFailure$3,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$3,
	deviceRenameFailure: deviceRenameFailure$3,
	downloadOnAppStore: downloadOnAppStore$3,
	editDeviceName: editDeviceName$3,
	editSQinfo: editSQinfo$3,
	enrollNewFactor: enrollNewFactor$3,
	event: event$3,
	eventType: eventType$3,
	eventUserAgent: eventUserAgent$3,
	eventUseragent: eventUseragent$3,
	eventUUID: eventUUID$3,
	eventUuid: eventUuid$3,
	expirationDays: expirationDays$3,
	expireDate: expireDate$3,
	expires: expires$3,
	extensionVersionInstalled: extensionVersionInstalled$3,
	factor: factor$3,
	factorFetchFailure: factorFetchFailure$3,
	factorMfaTokenFailure: factorMfaTokenFailure$3,
	factorPrimaryFailure: factorPrimaryFailure$3,
	factors: factors$3,
	factorsFetchFailure: factorsFetchFailure$3,
	failedToFetchUserInfo: failedToFetchUserInfo$3,
	failedToRegisterAnswers: failedToRegisterAnswers$3,
	failedToRetrieveQuestions: failedToRetrieveQuestions$3,
	forcedLogout: forcedLogout$3,
	getOnGooglePlay: getOnGooglePlay$3,
	goToExternalSite: goToExternalSite$3,
	helpRequestFailed: helpRequestFailed$3,
	helpRequestSuccessful: helpRequestSuccessful$3,
	hostname: hostname$3,
	icon: icon$3,
	identifier: identifier$3,
	imageUpload: imageUpload$3,
	inactive: inactive$3,
	inactiveDevice: inactiveDevice$3,
	install: install$3,
	invalidCode: invalidCode$3,
	invalidPhoneNumber: invalidPhoneNumber$3,
	language: language$3,
	languageConfirmation: languageConfirmation$3,
	lastAuthentication: lastAuthentication$3,
	lastChanged: lastChanged$3,
	lastUsed: lastUsed$3,
	length: length$3,
	letter: letter$3,
	linkToAppStore: linkToAppStore$3,
	linkToGooglePlay: linkToGooglePlay$3,
	loadingRecentActivity: loadingRecentActivity$3,
	loadingTrustedBrowsers: loadingTrustedBrowsers$3,
	location: location$3,
	locationTime: locationTime$3,
	loggedOut: loggedOut$3,
	login: login$3,
	loginDevice: loginDevice$3,
	loginEvent: loginEvent$3,
	loginFactor: loginFactor$3,
	loginFailedEvent: loginFailedEvent$3,
	loginName: loginName$3,
	logOut: logOut$3,
	lower: lower$3,
	message: message$3,
	mfaRegistrationFailure: mfaRegistrationFailure$3,
	mfaRegistrationSuccess: mfaRegistrationSuccess$3,
	more: more$3,
	never: never$3,
	newPassword: newPassword$3,
	newPrimaryFactor: newPrimaryFactor$3,
	noActivities: noActivities$3,
	noDevicesConfigured: noDevicesConfigured$3,
	noExpiration: noExpiration$3,
	noMoreSecurityFactors: noMoreSecurityFactors$3,
	notifyErrorLoadingUser: notifyErrorLoadingUser$3,
	notifySuccessAddApp: notifySuccessAddApp$3,
	noTrustedBrowsers: noTrustedBrowsers$3,
	numbers: numbers$3,
	oneloginDesktop: oneloginDesktop$3,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$3,
	oneloginLogo: oneloginLogo$3,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$3,
	otp1: otp1$3,
	otp2: otp2$3,
	otpDevice: otpDevice$3,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$3,
	password: password$3,
	passwordChanged: passwordChanged$3,
	passwordChangedDays: passwordChangedDays$3,
	passwordHint: passwordHint$3,
	passwordRedirectDescription: passwordRedirectDescription$3,
	passwordReset: passwordReset$3,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$3,
	passwordUpdateFailure: passwordUpdateFailure$3,
	phoneNumber: phoneNumber$3,
	prefix: prefix$3,
	previousDeviceName: previousDeviceName$3,
	primary: primary$3,
	proceedAnyway: proceedAnyway$3,
	profile: profile$3,
	profileAvatar: profileAvatar$3,
	profileMenuToggle: profileMenuToggle$3,
	profilePhoto: profilePhoto$3,
	profilePhotoAction: profilePhotoAction$3,
	pwResetDevice: pwResetDevice$3,
	pwResetFactor: pwResetFactor$3,
	questionNumber: questionNumber$3,
	radiusAuthentication: radiusAuthentication$3,
	recentActivity: recentActivity$3,
	redirectToChangePassword: redirectToChangePassword$3,
	registerSecurityQuestions: registerSecurityQuestions$3,
	registrationRejected: registrationRejected$3,
	registrationTimedout: registrationTimedout$3,
	remove: remove$3,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$3,
	removedProfilePictureSuccess: removedProfilePictureSuccess$3,
	removeFactorWarning: removeFactorWarning$3,
	removeImage: removeImage$3,
	report: report$3,
	reportActivity: reportActivity$3,
	requestField: requestField$3,
	requiredQuestions: requiredQuestions$3,
	revert: revert$3,
	revertToAdmin: revertToAdmin$3,
	revertToSuperadmin: revertToSuperadmin$3,
	revoke: revoke$3,
	save: save$3,
	searchIcon: searchIcon$3,
	secureNotes: secureNotes$3,
	securityFactorAdded: securityFactorAdded$3,
	securityFactorRemoved: securityFactorRemoved$3,
	securityFactorRenamed: securityFactorRenamed$3,
	securityFactors: securityFactors$3,
	securityFactorsDescription: securityFactorsDescription$3,
	securityFactorsUpdated: securityFactorsUpdated$3,
	selectNewImage: selectNewImage$3,
	selectNewPrimary: selectNewPrimary$3,
	selectSecurityFactor: selectSecurityFactor$3,
	sending: sending$3,
	setPrimaryDevice: setPrimaryDevice$3,
	showDetails: showDetails$3,
	specials: specials$3,
	sqDropdownAriaLabel: sqDropdownAriaLabel$3,
	sqInfoHeader: sqInfoHeader$3,
	sqTipBlankAnswers: sqTipBlankAnswers$3,
	sqTipDoNotShare: sqTipDoNotShare$3,
	sqTipMinimum: sqTipMinimum$3,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$3,
	sqTipNoUsePassword: sqTipNoUsePassword$3,
	sqTipSameAnswer: sqTipSameAnswer$3,
	sqTipSpecialChars: sqTipSpecialChars$3,
	submit: submit$3,
	submitting: submitting$3,
	support: support$3,
	supportDefaultDescription: supportDefaultDescription$3,
	supportedBrowsers: supportedBrowsers$3,
	supportRequestHeader: supportRequestHeader$3,
	"switch": "Switch",
	time: time$3,
	trustDevice: trustDevice$3,
	trusted: trusted$3,
	trustedBrowsers: trustedBrowsers$3,
	trustedBrowsersDescription: trustedBrowsersDescription$3,
	trustedDevice: trustedDevice$3,
	unavailable: unavailable$3,
	unavailableTime: unavailableTime$3,
	unsetFactorSuccess: unsetFactorSuccess$3,
	unsetPrimaryDevice: unsetPrimaryDevice$3,
	unsupportedBrowser: unsupportedBrowser$3,
	unsupportedBrowserHeading: unsupportedBrowserHeading$3,
	updateDeviceNameSuccess: updateDeviceNameSuccess$3,
	updateFactorSuccess: updateFactorSuccess$3,
	updatePassword: updatePassword$3,
	updateUserProfileFailure: updateUserProfileFailure$3,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$3,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$3,
	updateUserProfileSuccess: updateUserProfileSuccess$3,
	upper: upper$3,
	usedFor: usedFor$3,
	usedForApp: usedForApp$3,
	usedForLogin: usedForLogin$3,
	usedForPasswordReset: usedForPasswordReset$3,
	version: version$3,
	yourBrowser: yourBrowser$3
};

var addApp$2 = "Show {addApp} button when I log in to new websites.";
var addFactor$2 = "Add Factor";
var additionalQuestions$2 = "Additional Questions";
var addNewPrimaryBeforeRemove$2 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$2 = "Add New Security Question";
var administration$2 = "Administration";
var alert$2 = "Alert";
var all$2 = "all";
var app$2 = "App";
var appDevice$2 = "Yếu tố này được sử dụng cho ứng dụng.";
var appDevices$2 = "Yếu tố này được dùng cho ứng dụng";
var appFactor$2 = "Yếu tố này được sử dụng cho ứng dụng.";
var application$2 = "Application";
var appName$2 = "App Name";
var appPortal$2 = "App Portal";
var assumedUserNotification$2 = "You cannot edit personal information while assuming a user.";
var broswerExtension$2 = "Browser Extension";
var browser$2 = "Browser";
var browserDeleteFailure$2 = "Failed to delete trusted browser";
var browserDeleteSuccess$2 = "Trusted browser was successfully deleted";
var browserDevice$2 = "Browser/Device";
var browserFetchFailure$2 = "Failed to fetch browsers";
var calling$2 = "Đang gọi";
var callUserAgain$2 = "Calling you again";
var cancel$2 = "hủy";
var changePassword$2 = "Change Password";
var changeSecurityFactor$2 = "Change Security Factor";
var clearIcon$2 = "icon xóa";
var close$2 = "Close";
var closeDialog$2 = "Đóng hộp thoại";
var codeResent$2 = "Code has been sent to your phone.";
var companyLogo$2 = "logo công ty";
var companyTab$2 = "Default for company tab";
var conditionalRequirement$2 = "At least {number} of the following requirements:";
var configuredOn$2 = "Configured On";
var confirm$2 = "xác nhận";
var contactAdminEmailOtp$2 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$2 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$2 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$2 = "Contact your admin to reset password.";
var credentialId$2 = "Credential ID";
var current$2 = "Current";
var currentPassword$2 = "Current password";
var deleteDeviceSuccess$2 = "{factorName} was successfully deleted";
var deleteQuestion$2 = "Delete question {position}";
var details$2 = "Details";
var device$2 = "Device";
var deviceDeleteFailure$2 = "Failed to remove {factorName}";
var deviceFetchFailure$2 = "Failed to fetch devices";
var deviceNameCannotBeBlank$2 = "Authentication device name cannot be blank.";
var deviceRenameFailure$2 = "Failed to update device name";
var downloadOnAppStore$2 = "Tải về trên app store";
var editDeviceName$2 = "Edit name";
var editSQinfo$2 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$2 = "Enroll new primary factor";
var event$2 = "Event";
var eventType$2 = "Event Type";
var eventUserAgent$2 = "Event Useragent";
var eventUseragent$2 = "Event Useragent";
var eventUUID$2 = "Event UUID";
var eventUuid$2 = "Event UUID";
var expirationDays$2 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$2 = "Expire Date";
var expires$2 = "Expires";
var extensionVersionInstalled$2 = "Version {versionString} installed";
var factor$2 = "Factor";
var factorFetchFailure$2 = "Failed to fetch available factors";
var factorMfaTokenFailure$2 = "Failed to fetch mfa token";
var factorPrimaryFailure$2 = "Failed to set {factorName} as your primary factor";
var factors$2 = "factors";
var factorsFetchFailure$2 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$2 = "We couldn’t load your user information.";
var failedToRegisterAnswers$2 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$2 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$2 = "Forced Logout";
var getOnGooglePlay$2 = "Tải về trên Google Play";
var goToExternalSite$2 = "Go to external site";
var helpRequestFailed$2 = "We couldn't submit your help request.";
var helpRequestSuccessful$2 = "Your support request has been sent to your OneLogin Admin.";
var hostname$2 = "Hostname & OS";
var icon$2 = "Icon";
var identifier$2 = "Credential ID / Identifier";
var imageUpload$2 = "Image Upload";
var inactive$2 = "Inactive";
var inactiveDevice$2 = "Inactive device";
var install$2 = "Install";
var invalidCode$2 = "Invalid code";
var invalidPhoneNumber$2 = "Please use valid phone number.";
var language$2 = "Language";
var languageConfirmation$2 = "Are you sure you want to switch to {language}?";
var lastAuthentication$2 = "Last Authentication";
var lastChanged$2 = "Last changed";
var lastUsed$2 = "Last Used";
var length$2 = "Minimum {length} characters";
var letter$2 = "1 Letter";
var linkToAppStore$2 = "Liên kết đến App Store";
var linkToGooglePlay$2 = "Liên kết đến Google Play";
var loadingRecentActivity$2 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$2 = "Loading trusted browsers, please wait...";
var location$2 = "Location";
var locationTime$2 = "Location/Time";
var loggedOut$2 = "Logged Out";
var login$2 = "login";
var loginDevice$2 = "Login device";
var loginEvent$2 = "Login";
var loginFactor$2 = "Yếu tố này được sử dụng để đăng nhập.";
var loginFailedEvent$2 = "Login Failed";
var loginName$2 = "Login Name";
var logOut$2 = "Log Out";
var lower$2 = "1 Lowercase";
var message$2 = "{name} was successfully added.";
var mfaRegistrationFailure$2 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$2 = "You successfully registered the device";
var more$2 = "More";
var never$2 = "Never";
var newPassword$2 = "New password";
var newPrimaryFactor$2 = "New primary factor";
var noActivities$2 = "No activities have been made";
var noDevicesConfigured$2 = "No devices have been configured";
var noExpiration$2 = "Never expires";
var noMoreSecurityFactors$2 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$2 = "Loading of user failed. Try again later";
var notifySuccessAddApp$2 = "{name} was successfully added.";
var noTrustedBrowsers$2 = "No browsers have been saved";
var numbers$2 = "1 Number";
var oneloginDesktop$2 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$2 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$2 = "OneLogin logo";
var onlyDesktopBrowsersSupported$2 = "We currently only support browser extensions on desktop browsers.";
var otp1$2 = "OTP 1";
var otp2$2 = "OTP 2";
var otpDevice$2 = "Yếu tố này được dùng để đăng nhập.";
var parsingUserProfilePhotoFailure$2 = "Getting image details failed";
var password$2 = "password";
var passwordChanged$2 = "Password Changed";
var passwordChangedDays$2 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$2 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$2 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$2 = "Password Reset";
var passwordUpdatedSuccessfully$2 = "You have successfully updated your password.";
var passwordUpdateFailure$2 = "Password update failed";
var phoneNumber$2 = "Phone number";
var prefix$2 = "Suspicious login report";
var previousDeviceName$2 = "Previously {previousName}";
var primary$2 = "Primary";
var proceedAnyway$2 = "Proceed anyway";
var profile$2 = "Profile";
var profileAvatar$2 = "Profile avatar";
var profileMenuToggle$2 = "Open profile menu";
var profilePhoto$2 = "Profile photo";
var profilePhotoAction$2 = "Profile image action";
var pwResetDevice$2 = "Yếu tố này được dùng để đặt lại mật khẩu.";
var pwResetFactor$2 = "Yếu tố này được sử dụng để đặt lại mật khẩu.";
var questionNumber$2 = "Question {position}";
var radiusAuthentication$2 = "Service Login via Radius";
var recentActivity$2 = "Recent Activity";
var redirectToChangePassword$2 = "Redirect to change your password?";
var registerSecurityQuestions$2 = "Register Security Questions";
var registrationRejected$2 = "Registration unsuccessful, please try again.";
var registrationTimedout$2 = "Registration context timed out";
var remove$2 = "Remove";
var removeCurrentBrowserWarning$2 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$2 = "You have successfully removed your profile picture.";
var removeFactorWarning$2 = "Are you sure you want to remove {factor}?";
var removeImage$2 = "Remove image";
var report$2 = "Report";
var reportActivity$2 = "Report Activity";
var requestField$2 = "Describe the issue you're having";
var requiredQuestions$2 = "Required Questions";
var revert$2 = "hoàn tác";
var revertToAdmin$2 = "Revert to Admin";
var revertToSuperadmin$2 = "Revert to OneLogin Admin";
var revoke$2 = "Revoke";
var save$2 = "Save Changes";
var searchIcon$2 = "icon tìm kiếm";
var secureNotes$2 = "Secure Notes";
var securityFactorAdded$2 = "Security Factor Added";
var securityFactorRemoved$2 = "Security Factor Removed";
var securityFactorRenamed$2 = "Security Factor Renamed";
var securityFactors$2 = "Security Factors";
var securityFactorsDescription$2 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$2 = "Security Factors Updated";
var selectNewImage$2 = "Select new image";
var selectNewPrimary$2 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$2 = "Select Security Factor";
var sending$2 = "Đang gửi";
var setPrimaryDevice$2 = "Set as primary";
var showDetails$2 = "Hiển thị thông tin chi tiết";
var specials$2 = "1 Special character";
var sqDropdownAriaLabel$2 = "Question {position} dropdown";
var sqInfoHeader$2 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$2 = "Blank answers will not be accepted";
var sqTipDoNotShare$2 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$2 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$2 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$2 = "Do not use a password as an answer.";
var sqTipSameAnswer$2 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$2 = "Special characters such as @#&*. will be ignored";
var submit$2 = "Submit";
var submitting$2 = "Submitting…";
var support$2 = "Support";
var supportDefaultDescription$2 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$2 = "Supported browsers: {browsers}";
var supportRequestHeader$2 = "Support Request";
var time$2 = "Time";
var trustDevice$2 = "Trust Device";
var trusted$2 = "Trusted";
var trustedBrowsers$2 = "Trusted Browsers";
var trustedBrowsersDescription$2 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$2 = "Trusted Device";
var unavailable$2 = "Unavailable";
var unavailableTime$2 = "Unavailable";
var unsetFactorSuccess$2 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$2 = "Unset as primary";
var unsupportedBrowser$2 = "Unsupported Browser";
var unsupportedBrowserHeading$2 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$2 = "{newName} was successfully updated";
var updateFactorSuccess$2 = "{factorName} is your new default security factor";
var updatePassword$2 = "Update Password";
var updateUserProfileFailure$2 = "Profile Update Failed";
var updateUserProfilePhotoFailure$2 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$2 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$2 = "You have successfully updated your profile.";
var upper$2 = "1 Uppercase";
var usedFor$2 = "Used For";
var usedForApp$2 = "This factor is used for app.";
var usedForLogin$2 = "This factor is used for login.";
var usedForPasswordReset$2 = "This factor is used for password reset.";
var version$2 = "Version: {versionString}";
var yourBrowser$2 = "Your browser: {browser}";
var viVN = {
	"26286820": "Nhập ID Xác thực và hai Mã Bảo mật liên tiếp từ quyền Truy cập Symantec VIP.",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "Nhập mã bạn đã nhận được qua SMS.",
	"374233718": "Bạn có thể thử lại trong {secLeft, number} {secLeft, plural, one {giây} other {giây}}",
	"437305782": "Xác minh trình tạo mã xác thực WebAuthn của bạn ngay.",
	"505702857": "Liên kết Kỳ diệu",
	"519412053": "Thay đổi Yếu tố Xác thực",
	"655462232": "Tải xuống và cài đặt OneLogin Protec trên thiết bị của bạn",
	"660592555": "Đồng ý",
	"662924178": "Có vẻ hôm nay không phải ngày của chúng ta.",
	"694278426": "Nhập mã {deviceName} của bạn",
	"694920552": "Mã Bảo mật Đầu tiên",
	"737192390": "Mở {appName}",
	"740457555": "Mã thứ hai",
	"744377571": "Tối thiểu {length} ký tự",
	"751710530": "Gửi",
	"916760408": "Nhập tên người dùng và mã bảo mật từ thiết bị của bạn.",
	"921093870": "Bạn chưa nhận được mã?",
	"966052509": "Không có kết quả",
	"987359842": "Xin vui lòng nhấp vào liên kết trong email của bạn để tiếp tục",
	"1068496829": "Chọn Câu hỏi Bảo mật {current}/{total}",
	"1079852660": "Nhập hai Mã Bảo mật liên tiếp",
	"1080736814": "Nhập {fieldName} từ ứng dụng Symantec VIP Access",
	"1136625613": "Tiến trình bị hủy bỏ. Vui lòng thử lại hoặc sử dụng yếu tố xác thực khác.",
	"1212847248": "Mã xác nhận đã được gửi đến địa chỉ được bạn cấu hình.",
	"1232460711": "Nhập địa chỉ email của bạn",
	"1242107845": "Hiện",
	"1254879564": "Mật khẩu mới",
	"1359200231": "Gửi",
	"1433651550": "Nhập mã từ OneLogin SMS.",
	"1477893598": "Đặt cấu hình",
	"1536965459": "Tải xuống và cài đặt OneLogin Protect trên thiết bị của bạn",
	"1624184662": "Để cài đặt OneLogin SMS, chúng tôi sẽ gửi cho bạn một mã kích hoạt qua SMS. Bạn sẽ cần mã kích hoạt này để hoàn tất đăng ký thiết bị.",
	"1654624862": "Mã Bảo mật",
	"1833121415": "Đưa ra Câu trả lời {current}/{total}",
	"1919587067": "Gửi lại mã",
	"1935535842": "Bắt buộc",
	"1963245695": "1 chữ hoa",
	"2018264248": "Thử lại",
	"2091874550": "Mã đầu tiên",
	"2097632732": "Quét mã vạch để thay thế",
	"2104438124": "Nhập {fieldName} và hai Mã Bảo mật liên tiếp từ Symantec VIP Access.",
	"2124363772": "Nhập tên người dùng và mã bảo mật từ token SecurID của bạn.",
	"2229754167": "Nhập số điện thoại của bạn",
	"2244720377": "Có vẻ như đã xảy ra một lỗi không mong đợi.",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "Liên kết truy cập đã được gửi đến địa chỉ email của bạn",
	"2600324508": "Ẩn",
	"2606375562": "Nhét YubiKey của bạn vào cổng USB và bấm nút",
	"2663586870": "Tên người dùng",
	"2758306961": "ID Xác thực",
	"2792137744": "1 số",
	"2815222727": "Quét mã vạch này",
	"2828880379": "Xác nhận",
	"2859281487": "Yêu cầu xác thực 2 yếu tố để bảo mật cho tài khoản của bạn.",
	"2942752129": "Mã Bảo mật Thứ hai",
	"3060896801": "Bạn gặp rắc rối?",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 ký tự đặc biệt",
	"3294346597": "Thử lại",
	"3327626662": "Nhập mã xác nhận của bạn:",
	"3374226769": "Bấm Ghép đôi bằng cách nhập thủ công",
	"3469481929": "Bạn không thể quét mã?",
	"3499598078": "Mở trình đơn",
	"3528672691": "Hủy",
	"3640052215": "Tiếp tục",
	"3645029425": "Quét mã QR bên dưới",
	"3645116517": "Nhập mã này khi nhận cuộc gọi:",
	"3663548834": "Chúng tôi đang điều tra vấn đề và dự kiến sẽ sớm quay lại. Vui lòng đợi vài phút<br />rồi làm mới trình duyệt của bạn, hoặc truy cập vào <a href='https://www.onelogin.com/status'>Trang Trạng thái</a> của chúng tôi.",
	"3669652728": "Liên kết truy cập đã được gửi đến",
	"3673120330": "Tiếp theo",
	"3737470122": "Vui long liên hệ quản trị viên để biết thêm thông tin.",
	"3781468762": "Trình duyệt của bạn không hỗ trợ WebAuthn",
	"3827227259": "Đã gửi mã xác nhận đến",
	"3855542277": "Nhập mã này vào ứng dụng",
	"3865193889": "Kích hoạt",
	"3877285238": "1 chữ thường",
	"4000449233": "Gọi số điện thoại dưới đây:",
	"4072532148": "Gửi lại mã SMS",
	"4151518079": "Chọn Câu hỏi Bảo mật {current} / {total}",
	"4152906165": "Chúng tôi đang điều tra vấn đề và sẽ sớm hoạt động trở lại. Vui lòng đợi vài phút{break}rồi tải lại trình duyệt của bạn, hoặc truy cập <link>Trang Trạng thái</link> của chúng tôi.",
	"4227081527": "Khi ứng dụng được cài đặt, hãy quay lại màn hình này và bấm {action}",
	"4281662478": "Tìm kiếm",
	addApp: addApp$2,
	addFactor: addFactor$2,
	additionalQuestions: additionalQuestions$2,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$2,
	addNewSecurityQuestion: addNewSecurityQuestion$2,
	administration: administration$2,
	alert: alert$2,
	all: all$2,
	app: app$2,
	appDevice: appDevice$2,
	appDevices: appDevices$2,
	appFactor: appFactor$2,
	application: application$2,
	appName: appName$2,
	appPortal: appPortal$2,
	assumedUserNotification: assumedUserNotification$2,
	broswerExtension: broswerExtension$2,
	browser: browser$2,
	browserDeleteFailure: browserDeleteFailure$2,
	browserDeleteSuccess: browserDeleteSuccess$2,
	browserDevice: browserDevice$2,
	browserFetchFailure: browserFetchFailure$2,
	calling: calling$2,
	callUserAgain: callUserAgain$2,
	cancel: cancel$2,
	changePassword: changePassword$2,
	changeSecurityFactor: changeSecurityFactor$2,
	clearIcon: clearIcon$2,
	close: close$2,
	closeDialog: closeDialog$2,
	codeResent: codeResent$2,
	companyLogo: companyLogo$2,
	companyTab: companyTab$2,
	conditionalRequirement: conditionalRequirement$2,
	configuredOn: configuredOn$2,
	confirm: confirm$2,
	contactAdminEmailOtp: contactAdminEmailOtp$2,
	contactAdminForSMS: contactAdminForSMS$2,
	contactAdminForVoice: contactAdminForVoice$2,
	contactAdminPasswordReset: contactAdminPasswordReset$2,
	credentialId: credentialId$2,
	current: current$2,
	currentPassword: currentPassword$2,
	deleteDeviceSuccess: deleteDeviceSuccess$2,
	deleteQuestion: deleteQuestion$2,
	details: details$2,
	device: device$2,
	deviceDeleteFailure: deviceDeleteFailure$2,
	deviceFetchFailure: deviceFetchFailure$2,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$2,
	deviceRenameFailure: deviceRenameFailure$2,
	downloadOnAppStore: downloadOnAppStore$2,
	editDeviceName: editDeviceName$2,
	editSQinfo: editSQinfo$2,
	enrollNewFactor: enrollNewFactor$2,
	event: event$2,
	eventType: eventType$2,
	eventUserAgent: eventUserAgent$2,
	eventUseragent: eventUseragent$2,
	eventUUID: eventUUID$2,
	eventUuid: eventUuid$2,
	expirationDays: expirationDays$2,
	expireDate: expireDate$2,
	expires: expires$2,
	extensionVersionInstalled: extensionVersionInstalled$2,
	factor: factor$2,
	factorFetchFailure: factorFetchFailure$2,
	factorMfaTokenFailure: factorMfaTokenFailure$2,
	factorPrimaryFailure: factorPrimaryFailure$2,
	factors: factors$2,
	factorsFetchFailure: factorsFetchFailure$2,
	failedToFetchUserInfo: failedToFetchUserInfo$2,
	failedToRegisterAnswers: failedToRegisterAnswers$2,
	failedToRetrieveQuestions: failedToRetrieveQuestions$2,
	forcedLogout: forcedLogout$2,
	getOnGooglePlay: getOnGooglePlay$2,
	goToExternalSite: goToExternalSite$2,
	helpRequestFailed: helpRequestFailed$2,
	helpRequestSuccessful: helpRequestSuccessful$2,
	hostname: hostname$2,
	icon: icon$2,
	identifier: identifier$2,
	imageUpload: imageUpload$2,
	inactive: inactive$2,
	inactiveDevice: inactiveDevice$2,
	install: install$2,
	invalidCode: invalidCode$2,
	invalidPhoneNumber: invalidPhoneNumber$2,
	language: language$2,
	languageConfirmation: languageConfirmation$2,
	lastAuthentication: lastAuthentication$2,
	lastChanged: lastChanged$2,
	lastUsed: lastUsed$2,
	length: length$2,
	letter: letter$2,
	linkToAppStore: linkToAppStore$2,
	linkToGooglePlay: linkToGooglePlay$2,
	loadingRecentActivity: loadingRecentActivity$2,
	loadingTrustedBrowsers: loadingTrustedBrowsers$2,
	location: location$2,
	locationTime: locationTime$2,
	loggedOut: loggedOut$2,
	login: login$2,
	loginDevice: loginDevice$2,
	loginEvent: loginEvent$2,
	loginFactor: loginFactor$2,
	loginFailedEvent: loginFailedEvent$2,
	loginName: loginName$2,
	logOut: logOut$2,
	lower: lower$2,
	message: message$2,
	mfaRegistrationFailure: mfaRegistrationFailure$2,
	mfaRegistrationSuccess: mfaRegistrationSuccess$2,
	more: more$2,
	never: never$2,
	newPassword: newPassword$2,
	newPrimaryFactor: newPrimaryFactor$2,
	noActivities: noActivities$2,
	noDevicesConfigured: noDevicesConfigured$2,
	noExpiration: noExpiration$2,
	noMoreSecurityFactors: noMoreSecurityFactors$2,
	notifyErrorLoadingUser: notifyErrorLoadingUser$2,
	notifySuccessAddApp: notifySuccessAddApp$2,
	noTrustedBrowsers: noTrustedBrowsers$2,
	numbers: numbers$2,
	oneloginDesktop: oneloginDesktop$2,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$2,
	oneloginLogo: oneloginLogo$2,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$2,
	otp1: otp1$2,
	otp2: otp2$2,
	otpDevice: otpDevice$2,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$2,
	password: password$2,
	passwordChanged: passwordChanged$2,
	passwordChangedDays: passwordChangedDays$2,
	passwordHint: passwordHint$2,
	passwordRedirectDescription: passwordRedirectDescription$2,
	passwordReset: passwordReset$2,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$2,
	passwordUpdateFailure: passwordUpdateFailure$2,
	phoneNumber: phoneNumber$2,
	prefix: prefix$2,
	previousDeviceName: previousDeviceName$2,
	primary: primary$2,
	proceedAnyway: proceedAnyway$2,
	profile: profile$2,
	profileAvatar: profileAvatar$2,
	profileMenuToggle: profileMenuToggle$2,
	profilePhoto: profilePhoto$2,
	profilePhotoAction: profilePhotoAction$2,
	pwResetDevice: pwResetDevice$2,
	pwResetFactor: pwResetFactor$2,
	questionNumber: questionNumber$2,
	radiusAuthentication: radiusAuthentication$2,
	recentActivity: recentActivity$2,
	redirectToChangePassword: redirectToChangePassword$2,
	registerSecurityQuestions: registerSecurityQuestions$2,
	registrationRejected: registrationRejected$2,
	registrationTimedout: registrationTimedout$2,
	remove: remove$2,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$2,
	removedProfilePictureSuccess: removedProfilePictureSuccess$2,
	removeFactorWarning: removeFactorWarning$2,
	removeImage: removeImage$2,
	report: report$2,
	reportActivity: reportActivity$2,
	requestField: requestField$2,
	requiredQuestions: requiredQuestions$2,
	revert: revert$2,
	revertToAdmin: revertToAdmin$2,
	revertToSuperadmin: revertToSuperadmin$2,
	revoke: revoke$2,
	save: save$2,
	searchIcon: searchIcon$2,
	secureNotes: secureNotes$2,
	securityFactorAdded: securityFactorAdded$2,
	securityFactorRemoved: securityFactorRemoved$2,
	securityFactorRenamed: securityFactorRenamed$2,
	securityFactors: securityFactors$2,
	securityFactorsDescription: securityFactorsDescription$2,
	securityFactorsUpdated: securityFactorsUpdated$2,
	selectNewImage: selectNewImage$2,
	selectNewPrimary: selectNewPrimary$2,
	selectSecurityFactor: selectSecurityFactor$2,
	sending: sending$2,
	setPrimaryDevice: setPrimaryDevice$2,
	showDetails: showDetails$2,
	specials: specials$2,
	sqDropdownAriaLabel: sqDropdownAriaLabel$2,
	sqInfoHeader: sqInfoHeader$2,
	sqTipBlankAnswers: sqTipBlankAnswers$2,
	sqTipDoNotShare: sqTipDoNotShare$2,
	sqTipMinimum: sqTipMinimum$2,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$2,
	sqTipNoUsePassword: sqTipNoUsePassword$2,
	sqTipSameAnswer: sqTipSameAnswer$2,
	sqTipSpecialChars: sqTipSpecialChars$2,
	submit: submit$2,
	submitting: submitting$2,
	support: support$2,
	supportDefaultDescription: supportDefaultDescription$2,
	supportedBrowsers: supportedBrowsers$2,
	supportRequestHeader: supportRequestHeader$2,
	"switch": "Switch",
	time: time$2,
	trustDevice: trustDevice$2,
	trusted: trusted$2,
	trustedBrowsers: trustedBrowsers$2,
	trustedBrowsersDescription: trustedBrowsersDescription$2,
	trustedDevice: trustedDevice$2,
	unavailable: unavailable$2,
	unavailableTime: unavailableTime$2,
	unsetFactorSuccess: unsetFactorSuccess$2,
	unsetPrimaryDevice: unsetPrimaryDevice$2,
	unsupportedBrowser: unsupportedBrowser$2,
	unsupportedBrowserHeading: unsupportedBrowserHeading$2,
	updateDeviceNameSuccess: updateDeviceNameSuccess$2,
	updateFactorSuccess: updateFactorSuccess$2,
	updatePassword: updatePassword$2,
	updateUserProfileFailure: updateUserProfileFailure$2,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$2,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$2,
	updateUserProfileSuccess: updateUserProfileSuccess$2,
	upper: upper$2,
	usedFor: usedFor$2,
	usedForApp: usedForApp$2,
	usedForLogin: usedForLogin$2,
	usedForPasswordReset: usedForPasswordReset$2,
	version: version$2,
	yourBrowser: yourBrowser$2
};

var addApp$1 = "Show {addApp} button when I log in to new websites.";
var addFactor$1 = "Add Factor";
var additionalQuestions$1 = "Additional Questions";
var addNewPrimaryBeforeRemove$1 = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion$1 = "Add New Security Question";
var administration$1 = "Administration";
var alert$1 = "Alert";
var all$1 = "all";
var app$1 = "App";
var appDevice$1 = "此要素用于应用。";
var appDevices$1 = "此因素用于 app";
var appFactor$1 = "此要素用于应用。";
var application$1 = "Application";
var appName$1 = "App Name";
var appPortal$1 = "App Portal";
var assumedUserNotification$1 = "You cannot edit personal information while assuming a user.";
var broswerExtension$1 = "Browser Extension";
var browser$1 = "Browser";
var browserDeleteFailure$1 = "Failed to delete trusted browser";
var browserDeleteSuccess$1 = "Trusted browser was successfully deleted";
var browserDevice$1 = "Browser/Device";
var browserFetchFailure$1 = "Failed to fetch browsers";
var calling$1 = "正在拨号";
var callUserAgain$1 = "Calling you again";
var cancel$1 = "取消";
var changePassword$1 = "Change Password";
var changeSecurityFactor$1 = "Change Security Factor";
var clearIcon$1 = "清除图标";
var close$1 = "Close";
var closeDialog$1 = "关闭对话";
var codeResent$1 = "Code has been sent to your phone.";
var companyLogo$1 = "公司标志";
var companyTab$1 = "Default for company tab";
var conditionalRequirement$1 = "At least {number} of the following requirements:";
var configuredOn$1 = "Configured On";
var confirm$1 = "确认";
var contactAdminEmailOtp$1 = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS$1 = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice$1 = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset$1 = "Contact your admin to reset password.";
var credentialId$1 = "Credential ID";
var current$1 = "Current";
var currentPassword$1 = "Current password";
var deleteDeviceSuccess$1 = "{factorName} was successfully deleted";
var deleteQuestion$1 = "Delete question {position}";
var details$1 = "Details";
var device$1 = "Device";
var deviceDeleteFailure$1 = "Failed to remove {factorName}";
var deviceFetchFailure$1 = "Failed to fetch devices";
var deviceNameCannotBeBlank$1 = "Authentication device name cannot be blank.";
var deviceRenameFailure$1 = "Failed to update device name";
var downloadOnAppStore$1 = "去应用商店下载";
var editDeviceName$1 = "Edit name";
var editSQinfo$1 = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor$1 = "Enroll new primary factor";
var event$1 = "Event";
var eventType$1 = "Event Type";
var eventUserAgent$1 = "Event Useragent";
var eventUseragent$1 = "Event Useragent";
var eventUUID$1 = "Event UUID";
var eventUuid$1 = "Event UUID";
var expirationDays$1 = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate$1 = "Expire Date";
var expires$1 = "Expires";
var extensionVersionInstalled$1 = "Version {versionString} installed";
var factor$1 = "Factor";
var factorFetchFailure$1 = "Failed to fetch available factors";
var factorMfaTokenFailure$1 = "Failed to fetch mfa token";
var factorPrimaryFailure$1 = "Failed to set {factorName} as your primary factor";
var factors$1 = "factors";
var factorsFetchFailure$1 = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo$1 = "We couldn’t load your user information.";
var failedToRegisterAnswers$1 = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions$1 = "We couldn't retrieve your security questions at this time.";
var forcedLogout$1 = "Forced Logout";
var getOnGooglePlay$1 = "在 Google Play 上获取";
var goToExternalSite$1 = "Go to external site";
var helpRequestFailed$1 = "We couldn't submit your help request.";
var helpRequestSuccessful$1 = "Your support request has been sent to your OneLogin Admin.";
var hostname$1 = "Hostname & OS";
var icon$1 = "Icon";
var identifier$1 = "Credential ID / Identifier";
var imageUpload$1 = "Image Upload";
var inactive$1 = "Inactive";
var inactiveDevice$1 = "Inactive device";
var install$1 = "Install";
var invalidCode$1 = "Invalid code";
var invalidPhoneNumber$1 = "Please use valid phone number.";
var language$1 = "Language";
var languageConfirmation$1 = "Are you sure you want to switch to {language}?";
var lastAuthentication$1 = "Last Authentication";
var lastChanged$1 = "Last changed";
var lastUsed$1 = "Last Used";
var length$1 = "Minimum {length} characters";
var letter$1 = "1 Letter";
var linkToAppStore$1 = "链接到应用商店";
var linkToGooglePlay$1 = "链接至 Google Play";
var loadingRecentActivity$1 = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers$1 = "Loading trusted browsers, please wait...";
var location$1 = "Location";
var locationTime$1 = "Location/Time";
var loggedOut$1 = "Logged Out";
var login$1 = "login";
var loginDevice$1 = "Login device";
var loginEvent$1 = "Login";
var loginFactor$1 = "此要素用于登录。";
var loginFailedEvent$1 = "Login Failed";
var loginName$1 = "Login Name";
var logOut$1 = "Log Out";
var lower$1 = "1 Lowercase";
var message$1 = "{name} was successfully added.";
var mfaRegistrationFailure$1 = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess$1 = "You successfully registered the device";
var more$1 = "More";
var never$1 = "Never";
var newPassword$1 = "New password";
var newPrimaryFactor$1 = "New primary factor";
var noActivities$1 = "No activities have been made";
var noDevicesConfigured$1 = "No devices have been configured";
var noExpiration$1 = "Never expires";
var noMoreSecurityFactors$1 = "There are no security factors available for registration.";
var notifyErrorLoadingUser$1 = "Loading of user failed. Try again later";
var notifySuccessAddApp$1 = "{name} was successfully added.";
var noTrustedBrowsers$1 = "No browsers have been saved";
var numbers$1 = "1 Number";
var oneloginDesktop$1 = "OneLogin Desktop";
var oneloginDesktopFetchFailure$1 = "Failed to fetch OneLogin Desktop data";
var oneloginLogo$1 = "OneLogin logo";
var onlyDesktopBrowsersSupported$1 = "We currently only support browser extensions on desktop browsers.";
var otp1$1 = "OTP 1";
var otp2$1 = "OTP 2";
var otpDevice$1 = "此因素用于登录。";
var parsingUserProfilePhotoFailure$1 = "Getting image details failed";
var password$1 = "password";
var passwordChanged$1 = "Password Changed";
var passwordChangedDays$1 = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint$1 = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription$1 = "Your administrator has configured an external site for resetting your password.";
var passwordReset$1 = "Password Reset";
var passwordUpdatedSuccessfully$1 = "You have successfully updated your password.";
var passwordUpdateFailure$1 = "Password update failed";
var phoneNumber$1 = "Phone number";
var prefix$1 = "Suspicious login report";
var previousDeviceName$1 = "Previously {previousName}";
var primary$1 = "Primary";
var proceedAnyway$1 = "Proceed anyway";
var profile$1 = "Profile";
var profileAvatar$1 = "Profile avatar";
var profileMenuToggle$1 = "Open profile menu";
var profilePhoto$1 = "Profile photo";
var profilePhotoAction$1 = "Profile image action";
var pwResetDevice$1 = "此因素用于重置密码。";
var pwResetFactor$1 = "此要素用于密码重置。";
var questionNumber$1 = "Question {position}";
var radiusAuthentication$1 = "Service Login via Radius";
var recentActivity$1 = "Recent Activity";
var redirectToChangePassword$1 = "Redirect to change your password?";
var registerSecurityQuestions$1 = "Register Security Questions";
var registrationRejected$1 = "Registration unsuccessful, please try again.";
var registrationTimedout$1 = "Registration context timed out";
var remove$1 = "Remove";
var removeCurrentBrowserWarning$1 = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess$1 = "You have successfully removed your profile picture.";
var removeFactorWarning$1 = "Are you sure you want to remove {factor}?";
var removeImage$1 = "Remove image";
var report$1 = "Report";
var reportActivity$1 = "Report Activity";
var requestField$1 = "Describe the issue you're having";
var requiredQuestions$1 = "Required Questions";
var revert$1 = "复原";
var revertToAdmin$1 = "Revert to Admin";
var revertToSuperadmin$1 = "Revert to OneLogin Admin";
var revoke$1 = "Revoke";
var save$1 = "Save Changes";
var searchIcon$1 = "搜索图标";
var secureNotes$1 = "Secure Notes";
var securityFactorAdded$1 = "Security Factor Added";
var securityFactorRemoved$1 = "Security Factor Removed";
var securityFactorRenamed$1 = "Security Factor Renamed";
var securityFactors$1 = "Security Factors";
var securityFactorsDescription$1 = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated$1 = "Security Factors Updated";
var selectNewImage$1 = "Select new image";
var selectNewPrimary$1 = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor$1 = "Select Security Factor";
var sending$1 = "发送中";
var setPrimaryDevice$1 = "Set as primary";
var showDetails$1 = "显示详情";
var specials$1 = "1 Special character";
var sqDropdownAriaLabel$1 = "Question {position} dropdown";
var sqInfoHeader$1 = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers$1 = "Blank answers will not be accepted";
var sqTipDoNotShare$1 = "Do not share your questions and answers with anyone.";
var sqTipMinimum$1 = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive$1 = "Answers are not case-sensitive.";
var sqTipNoUsePassword$1 = "Do not use a password as an answer.";
var sqTipSameAnswer$1 = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars$1 = "Special characters such as @#&*. will be ignored";
var submit$1 = "Submit";
var submitting$1 = "Submitting…";
var support$1 = "Support";
var supportDefaultDescription$1 = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers$1 = "Supported browsers: {browsers}";
var supportRequestHeader$1 = "Support Request";
var time$1 = "Time";
var trustDevice$1 = "Trust Device";
var trusted$1 = "Trusted";
var trustedBrowsers$1 = "Trusted Browsers";
var trustedBrowsersDescription$1 = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice$1 = "Trusted Device";
var unavailable$1 = "Unavailable";
var unavailableTime$1 = "Unavailable";
var unsetFactorSuccess$1 = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice$1 = "Unset as primary";
var unsupportedBrowser$1 = "Unsupported Browser";
var unsupportedBrowserHeading$1 = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess$1 = "{newName} was successfully updated";
var updateFactorSuccess$1 = "{factorName} is your new default security factor";
var updatePassword$1 = "Update Password";
var updateUserProfileFailure$1 = "Profile Update Failed";
var updateUserProfilePhotoFailure$1 = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess$1 = "You have successfully updated your profile picture.";
var updateUserProfileSuccess$1 = "You have successfully updated your profile.";
var upper$1 = "1 Uppercase";
var usedFor$1 = "Used For";
var usedForApp$1 = "This factor is used for app.";
var usedForLogin$1 = "This factor is used for login.";
var usedForPasswordReset$1 = "This factor is used for password reset.";
var version$1 = "Version: {versionString}";
var yourBrowser$1 = "Your browser: {browser}";
var zh = {
	"26286820": "请输入凭证 ID 和 Symantec VIP 访问的两个连续安全代码。",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "输入您在短信中收到的代码。",
	"374233718": "您可以在{secLeft, number} {secLeft, plural, one {second} other {seconds}}后重试",
	"437305782": "正在验证您的WebAuthn身份验证器。",
	"505702857": "Magic Link",
	"519412053": "更改验证因素",
	"655462232": "在您的设备上下载并安装 OneLogin Protect",
	"660592555": "好的",
	"662924178": "看起来今天不是我们的幸运日。",
	"694278426": "输入您的{deviceName}代码",
	"694920552": "第一个安全码",
	"737192390": "打开 {appName}",
	"740457555": "第二个代码",
	"744377571": "最少 {length} 个字符",
	"751710530": "提交",
	"916760408": "输入设备的用户名和安全码。",
	"921093870": "还没有收到代码？",
	"966052509": "无结果",
	"987359842": "请单击您的电子邮件上的链接继续",
	"1068496829": "选择安全问题 {current}/{total}",
	"1079852660": "输入两个连续的安全代码",
	"1080736814": "输入 Symantec VIP Access 应用中的 {fieldName}",
	"1136625613": "该过程已取消。请重试或使用其他身份验证因素。",
	"1212847248": "确认代码已发送到您配置的地址。",
	"1232460711": "输入您的电子邮件",
	"1242107845": "显示",
	"1254879564": "新密码",
	"1359200231": "发送",
	"1433651550": "输入 OneLogin 短信中的代码。",
	"1477893598": "配置",
	"1536965459": "在您的设备上下载并安装 OneLogin Protect",
	"1624184662": "要设置 OneLogin 短信，我们将通过短信向您发送激活码。您需要此激活码才能完成设备注册。",
	"1654624862": "安全码",
	"1833121415": "提供答案 {current}/{total}",
	"1919587067": "重新发送代码",
	"1935535842": "必填的",
	"1963245695": "1 个大写字母",
	"2018264248": "重试",
	"2091874550": "第一个代码",
	"2097632732": "改为扫描条形码",
	"2104438124": "输入 Symantec VIP Access 中的 {fieldName} 和两个连续的安全码。",
	"2124363772": "输入您的用户名和 SecurID 令牌中的安全码。",
	"2229754167": "输入您的电话号码",
	"2244720377": "似乎出现了意外错误。",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "已向您的电子邮件发送访问链接",
	"2600324508": "隐藏",
	"2606375562": "将 YubiKey 插入 USB 端口，然后按下按钮",
	"2663586870": "用户名",
	"2758306961": "凭证 ID",
	"2792137744": "1 个数字",
	"2815222727": "扫描此条形码",
	"2828880379": "确认",
	"2859281487": "保护您的帐户需要双因素身份验证。",
	"2942752129": "第二个安全码",
	"3060896801": "遇到问题？",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 个特殊字符",
	"3294346597": "再试一次",
	"3327626662": "输入您的确认码",
	"3374226769": "点击“使用手动输入来配对”",
	"3469481929": "无法扫描此码？",
	"3499598078": "打开菜单",
	"3528672691": "取消",
	"3640052215": "继续",
	"3645029425": "在下面扫描二维码",
	"3645116517": "接听电话时输入以下代码：",
	"3663548834": "我们正在调查这个问题，预计很快就会恢复。请稍等几分钟<br />并刷新您的浏览器，或者访问我们的<a href='https://www.onelogin.com/status'>状态页面</a>。",
	"3669652728": "访问链接已发送给",
	"3673120330": "下一步",
	"3737470122": "请联系管理员获取更多信息。",
	"3781468762": "您的浏览器不支持WebAuthn",
	"3827227259": "确认码已发送至",
	"3855542277": "在应用中输入此代码",
	"3865193889": "激活",
	"3877285238": "1 个小写字母",
	"4000449233": "正在拨打以下电话号码：",
	"4072532148": "重新发送短信代码",
	"4151518079": "选择安全问题 {current} / {total}",
	"4152906165": "我们正在调查问题，应该很快就回来。请稍等几分钟后{break}刷新您的浏览器，或者访问我们的<link>状态页面</link>。",
	"4227081527": "应用安装完成后，返回此屏幕并点击 {action}",
	"4281662478": "搜索",
	addApp: addApp$1,
	addFactor: addFactor$1,
	additionalQuestions: additionalQuestions$1,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove$1,
	addNewSecurityQuestion: addNewSecurityQuestion$1,
	administration: administration$1,
	alert: alert$1,
	all: all$1,
	app: app$1,
	appDevice: appDevice$1,
	appDevices: appDevices$1,
	appFactor: appFactor$1,
	application: application$1,
	appName: appName$1,
	appPortal: appPortal$1,
	assumedUserNotification: assumedUserNotification$1,
	broswerExtension: broswerExtension$1,
	browser: browser$1,
	browserDeleteFailure: browserDeleteFailure$1,
	browserDeleteSuccess: browserDeleteSuccess$1,
	browserDevice: browserDevice$1,
	browserFetchFailure: browserFetchFailure$1,
	calling: calling$1,
	callUserAgain: callUserAgain$1,
	cancel: cancel$1,
	changePassword: changePassword$1,
	changeSecurityFactor: changeSecurityFactor$1,
	clearIcon: clearIcon$1,
	close: close$1,
	closeDialog: closeDialog$1,
	codeResent: codeResent$1,
	companyLogo: companyLogo$1,
	companyTab: companyTab$1,
	conditionalRequirement: conditionalRequirement$1,
	configuredOn: configuredOn$1,
	confirm: confirm$1,
	contactAdminEmailOtp: contactAdminEmailOtp$1,
	contactAdminForSMS: contactAdminForSMS$1,
	contactAdminForVoice: contactAdminForVoice$1,
	contactAdminPasswordReset: contactAdminPasswordReset$1,
	credentialId: credentialId$1,
	current: current$1,
	currentPassword: currentPassword$1,
	deleteDeviceSuccess: deleteDeviceSuccess$1,
	deleteQuestion: deleteQuestion$1,
	details: details$1,
	device: device$1,
	deviceDeleteFailure: deviceDeleteFailure$1,
	deviceFetchFailure: deviceFetchFailure$1,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank$1,
	deviceRenameFailure: deviceRenameFailure$1,
	downloadOnAppStore: downloadOnAppStore$1,
	editDeviceName: editDeviceName$1,
	editSQinfo: editSQinfo$1,
	enrollNewFactor: enrollNewFactor$1,
	event: event$1,
	eventType: eventType$1,
	eventUserAgent: eventUserAgent$1,
	eventUseragent: eventUseragent$1,
	eventUUID: eventUUID$1,
	eventUuid: eventUuid$1,
	expirationDays: expirationDays$1,
	expireDate: expireDate$1,
	expires: expires$1,
	extensionVersionInstalled: extensionVersionInstalled$1,
	factor: factor$1,
	factorFetchFailure: factorFetchFailure$1,
	factorMfaTokenFailure: factorMfaTokenFailure$1,
	factorPrimaryFailure: factorPrimaryFailure$1,
	factors: factors$1,
	factorsFetchFailure: factorsFetchFailure$1,
	failedToFetchUserInfo: failedToFetchUserInfo$1,
	failedToRegisterAnswers: failedToRegisterAnswers$1,
	failedToRetrieveQuestions: failedToRetrieveQuestions$1,
	forcedLogout: forcedLogout$1,
	getOnGooglePlay: getOnGooglePlay$1,
	goToExternalSite: goToExternalSite$1,
	helpRequestFailed: helpRequestFailed$1,
	helpRequestSuccessful: helpRequestSuccessful$1,
	hostname: hostname$1,
	icon: icon$1,
	identifier: identifier$1,
	imageUpload: imageUpload$1,
	inactive: inactive$1,
	inactiveDevice: inactiveDevice$1,
	install: install$1,
	invalidCode: invalidCode$1,
	invalidPhoneNumber: invalidPhoneNumber$1,
	language: language$1,
	languageConfirmation: languageConfirmation$1,
	lastAuthentication: lastAuthentication$1,
	lastChanged: lastChanged$1,
	lastUsed: lastUsed$1,
	length: length$1,
	letter: letter$1,
	linkToAppStore: linkToAppStore$1,
	linkToGooglePlay: linkToGooglePlay$1,
	loadingRecentActivity: loadingRecentActivity$1,
	loadingTrustedBrowsers: loadingTrustedBrowsers$1,
	location: location$1,
	locationTime: locationTime$1,
	loggedOut: loggedOut$1,
	login: login$1,
	loginDevice: loginDevice$1,
	loginEvent: loginEvent$1,
	loginFactor: loginFactor$1,
	loginFailedEvent: loginFailedEvent$1,
	loginName: loginName$1,
	logOut: logOut$1,
	lower: lower$1,
	message: message$1,
	mfaRegistrationFailure: mfaRegistrationFailure$1,
	mfaRegistrationSuccess: mfaRegistrationSuccess$1,
	more: more$1,
	never: never$1,
	newPassword: newPassword$1,
	newPrimaryFactor: newPrimaryFactor$1,
	noActivities: noActivities$1,
	noDevicesConfigured: noDevicesConfigured$1,
	noExpiration: noExpiration$1,
	noMoreSecurityFactors: noMoreSecurityFactors$1,
	notifyErrorLoadingUser: notifyErrorLoadingUser$1,
	notifySuccessAddApp: notifySuccessAddApp$1,
	noTrustedBrowsers: noTrustedBrowsers$1,
	numbers: numbers$1,
	oneloginDesktop: oneloginDesktop$1,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure$1,
	oneloginLogo: oneloginLogo$1,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported$1,
	otp1: otp1$1,
	otp2: otp2$1,
	otpDevice: otpDevice$1,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure$1,
	password: password$1,
	passwordChanged: passwordChanged$1,
	passwordChangedDays: passwordChangedDays$1,
	passwordHint: passwordHint$1,
	passwordRedirectDescription: passwordRedirectDescription$1,
	passwordReset: passwordReset$1,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully$1,
	passwordUpdateFailure: passwordUpdateFailure$1,
	phoneNumber: phoneNumber$1,
	prefix: prefix$1,
	previousDeviceName: previousDeviceName$1,
	primary: primary$1,
	proceedAnyway: proceedAnyway$1,
	profile: profile$1,
	profileAvatar: profileAvatar$1,
	profileMenuToggle: profileMenuToggle$1,
	profilePhoto: profilePhoto$1,
	profilePhotoAction: profilePhotoAction$1,
	pwResetDevice: pwResetDevice$1,
	pwResetFactor: pwResetFactor$1,
	questionNumber: questionNumber$1,
	radiusAuthentication: radiusAuthentication$1,
	recentActivity: recentActivity$1,
	redirectToChangePassword: redirectToChangePassword$1,
	registerSecurityQuestions: registerSecurityQuestions$1,
	registrationRejected: registrationRejected$1,
	registrationTimedout: registrationTimedout$1,
	remove: remove$1,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning$1,
	removedProfilePictureSuccess: removedProfilePictureSuccess$1,
	removeFactorWarning: removeFactorWarning$1,
	removeImage: removeImage$1,
	report: report$1,
	reportActivity: reportActivity$1,
	requestField: requestField$1,
	requiredQuestions: requiredQuestions$1,
	revert: revert$1,
	revertToAdmin: revertToAdmin$1,
	revertToSuperadmin: revertToSuperadmin$1,
	revoke: revoke$1,
	save: save$1,
	searchIcon: searchIcon$1,
	secureNotes: secureNotes$1,
	securityFactorAdded: securityFactorAdded$1,
	securityFactorRemoved: securityFactorRemoved$1,
	securityFactorRenamed: securityFactorRenamed$1,
	securityFactors: securityFactors$1,
	securityFactorsDescription: securityFactorsDescription$1,
	securityFactorsUpdated: securityFactorsUpdated$1,
	selectNewImage: selectNewImage$1,
	selectNewPrimary: selectNewPrimary$1,
	selectSecurityFactor: selectSecurityFactor$1,
	sending: sending$1,
	setPrimaryDevice: setPrimaryDevice$1,
	showDetails: showDetails$1,
	specials: specials$1,
	sqDropdownAriaLabel: sqDropdownAriaLabel$1,
	sqInfoHeader: sqInfoHeader$1,
	sqTipBlankAnswers: sqTipBlankAnswers$1,
	sqTipDoNotShare: sqTipDoNotShare$1,
	sqTipMinimum: sqTipMinimum$1,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive$1,
	sqTipNoUsePassword: sqTipNoUsePassword$1,
	sqTipSameAnswer: sqTipSameAnswer$1,
	sqTipSpecialChars: sqTipSpecialChars$1,
	submit: submit$1,
	submitting: submitting$1,
	support: support$1,
	supportDefaultDescription: supportDefaultDescription$1,
	supportedBrowsers: supportedBrowsers$1,
	supportRequestHeader: supportRequestHeader$1,
	"switch": "Switch",
	time: time$1,
	trustDevice: trustDevice$1,
	trusted: trusted$1,
	trustedBrowsers: trustedBrowsers$1,
	trustedBrowsersDescription: trustedBrowsersDescription$1,
	trustedDevice: trustedDevice$1,
	unavailable: unavailable$1,
	unavailableTime: unavailableTime$1,
	unsetFactorSuccess: unsetFactorSuccess$1,
	unsetPrimaryDevice: unsetPrimaryDevice$1,
	unsupportedBrowser: unsupportedBrowser$1,
	unsupportedBrowserHeading: unsupportedBrowserHeading$1,
	updateDeviceNameSuccess: updateDeviceNameSuccess$1,
	updateFactorSuccess: updateFactorSuccess$1,
	updatePassword: updatePassword$1,
	updateUserProfileFailure: updateUserProfileFailure$1,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure$1,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess$1,
	updateUserProfileSuccess: updateUserProfileSuccess$1,
	upper: upper$1,
	usedFor: usedFor$1,
	usedForApp: usedForApp$1,
	usedForLogin: usedForLogin$1,
	usedForPasswordReset: usedForPasswordReset$1,
	version: version$1,
	yourBrowser: yourBrowser$1
};

var addApp = "Show {addApp} button when I log in to new websites.";
var addFactor = "Add Factor";
var additionalQuestions = "Additional Questions";
var addNewPrimaryBeforeRemove = "Before you remove {deviceName}, you need to enroll a new primary factor.";
var addNewSecurityQuestion = "Add New Security Question";
var administration = "Administration";
var alert = "Alert";
var all = "all";
var app = "App";
var appDevice = "此要素用於 app。";
var appDevices = "這個因素用於應用程式";
var appFactor = "此要素用於 app。";
var application = "Application";
var appName = "App Name";
var appPortal = "App Portal";
var assumedUserNotification = "You cannot edit personal information while assuming a user.";
var broswerExtension = "Browser Extension";
var browser = "Browser";
var browserDeleteFailure = "Failed to delete trusted browser";
var browserDeleteSuccess = "Trusted browser was successfully deleted";
var browserDevice = "Browser/Device";
var browserFetchFailure = "Failed to fetch browsers";
var calling = "正在撥號";
var callUserAgain = "Calling you again";
var cancel = "取消";
var changePassword = "Change Password";
var changeSecurityFactor = "Change Security Factor";
var clearIcon = "清除圖示";
var close = "Close";
var closeDialog = "關閉對話方塊";
var codeResent = "Code has been sent to your phone.";
var companyLogo = "公司標誌";
var companyTab = "Default for company tab";
var conditionalRequirement = "At least {number} of the following requirements:";
var configuredOn = "Configured On";
var confirm = "確認";
var contactAdminEmailOtp = "Contact your admin to set up an email for your Email OTP.";
var contactAdminForSMS = "Contact your admin to set up a phone number for your SMS OTP.";
var contactAdminForVoice = "Contact your admin to set up a phone number for your Voice OTP.";
var contactAdminPasswordReset = "Contact your admin to reset password.";
var credentialId = "Credential ID";
var current = "Current";
var currentPassword = "Current password";
var deleteDeviceSuccess = "{factorName} was successfully deleted";
var deleteQuestion = "Delete question {position}";
var details = "Details";
var device = "Device";
var deviceDeleteFailure = "Failed to remove {factorName}";
var deviceFetchFailure = "Failed to fetch devices";
var deviceNameCannotBeBlank = "Authentication device name cannot be blank.";
var deviceRenameFailure = "Failed to update device name";
var downloadOnAppStore = "到 App Store 下載";
var editDeviceName = "Edit name";
var editSQinfo = "To edit your security questions, please delete this factor and setup a new one.";
var enrollNewFactor = "Enroll new primary factor";
var event = "Event";
var eventType = "Event Type";
var eventUserAgent = "Event Useragent";
var eventUseragent = "Event Useragent";
var eventUUID = "Event UUID";
var eventUuid = "Event UUID";
var expirationDays = "{numberOfDays, plural,\n                                      =0 {today}\n                                      one {{numberOfDays} day}\n                                      other {{numberOfDays} days}\n                                  }";
var expireDate = "Expire Date";
var expires = "Expires";
var extensionVersionInstalled = "Version {versionString} installed";
var factor = "Factor";
var factorFetchFailure = "Failed to fetch available factors";
var factorMfaTokenFailure = "Failed to fetch mfa token";
var factorPrimaryFailure = "Failed to set {factorName} as your primary factor";
var factors = "factors";
var factorsFetchFailure = "Failed to fetch factors, please try again later";
var failedToFetchUserInfo = "We couldn’t load your user information.";
var failedToRegisterAnswers = "We couldn’t register your security question answers at this time.{break}You can try using the <link>older page</link>.";
var failedToRetrieveQuestions = "We couldn't retrieve your security questions at this time.";
var forcedLogout = "Forced Logout";
var getOnGooglePlay = "到 Google Play 取得";
var goToExternalSite = "Go to external site";
var helpRequestFailed = "We couldn't submit your help request.";
var helpRequestSuccessful = "Your support request has been sent to your OneLogin Admin.";
var hostname = "Hostname & OS";
var icon = "Icon";
var identifier = "Credential ID / Identifier";
var imageUpload = "Image Upload";
var inactive = "Inactive";
var inactiveDevice = "Inactive device";
var install = "Install";
var invalidCode = "Invalid code";
var invalidPhoneNumber = "Please use valid phone number.";
var language = "Language";
var languageConfirmation = "Are you sure you want to switch to {language}?";
var lastAuthentication = "Last Authentication";
var lastChanged = "Last changed";
var lastUsed = "Last Used";
var length = "Minimum {length} characters";
var letter = "1 Letter";
var linkToAppStore = "連結到 App Store";
var linkToGooglePlay = "連結到 Google Play";
var loadingRecentActivity = "Loading recent activity details, please wait...";
var loadingTrustedBrowsers = "Loading trusted browsers, please wait...";
var location = "Location";
var locationTime = "Location/Time";
var loggedOut = "Logged Out";
var login = "login";
var loginDevice = "Login device";
var loginEvent = "Login";
var loginFactor = "此要素用於登入。";
var loginFailedEvent = "Login Failed";
var loginName = "Login Name";
var logOut = "Log Out";
var lower = "1 Lowercase";
var message = "{name} was successfully added.";
var mfaRegistrationFailure = "Verification rejected. Please try again in a moment";
var mfaRegistrationSuccess = "You successfully registered the device";
var more = "More";
var never = "Never";
var newPassword = "New password";
var newPrimaryFactor = "New primary factor";
var noActivities = "No activities have been made";
var noDevicesConfigured = "No devices have been configured";
var noExpiration = "Never expires";
var noMoreSecurityFactors = "There are no security factors available for registration.";
var notifyErrorLoadingUser = "Loading of user failed. Try again later";
var notifySuccessAddApp = "{name} was successfully added.";
var noTrustedBrowsers = "No browsers have been saved";
var numbers = "1 Number";
var oneloginDesktop = "OneLogin Desktop";
var oneloginDesktopFetchFailure = "Failed to fetch OneLogin Desktop data";
var oneloginLogo = "OneLogin logo";
var onlyDesktopBrowsersSupported = "We currently only support browser extensions on desktop browsers.";
var otp1 = "OTP 1";
var otp2 = "OTP 2";
var otpDevice = "這個因素用於登入。";
var parsingUserProfilePhotoFailure = "Getting image details failed";
var password = "password";
var passwordChanged = "Password Changed";
var passwordChangedDays = "{numberOfDays, plural,\n                                  =0 {today}\n                                  one {{numberOfDays} day}\n                                  other {{numberOfDays} days}\n                              }";
var passwordHint = "Strong passwords or passphrases are important for security. Your password must use:";
var passwordRedirectDescription = "Your administrator has configured an external site for resetting your password.";
var passwordReset = "Password Reset";
var passwordUpdatedSuccessfully = "You have successfully updated your password.";
var passwordUpdateFailure = "Password update failed";
var phoneNumber = "Phone number";
var prefix = "Suspicious login report";
var previousDeviceName = "Previously {previousName}";
var primary = "Primary";
var proceedAnyway = "Proceed anyway";
var profile = "Profile";
var profileAvatar = "Profile avatar";
var profileMenuToggle = "Open profile menu";
var profilePhoto = "Profile photo";
var profilePhotoAction = "Profile image action";
var pwResetDevice = "這個因素用於密碼重設。";
var pwResetFactor = "此要素用於密碼重設。";
var questionNumber = "Question {position}";
var radiusAuthentication = "Service Login via Radius";
var recentActivity = "Recent Activity";
var redirectToChangePassword = "Redirect to change your password?";
var registerSecurityQuestions = "Register Security Questions";
var registrationRejected = "Registration unsuccessful, please try again.";
var registrationTimedout = "Registration context timed out";
var remove = "Remove";
var removeCurrentBrowserWarning = "Revoke {browser} browser? You will be automatically logged out.";
var removedProfilePictureSuccess = "You have successfully removed your profile picture.";
var removeFactorWarning = "Are you sure you want to remove {factor}?";
var removeImage = "Remove image";
var report = "Report";
var reportActivity = "Report Activity";
var requestField = "Describe the issue you're having";
var requiredQuestions = "Required Questions";
var revert = "還原";
var revertToAdmin = "Revert to Admin";
var revertToSuperadmin = "Revert to OneLogin Admin";
var revoke = "Revoke";
var save = "Save Changes";
var searchIcon = "搜尋圖示";
var secureNotes = "Secure Notes";
var securityFactorAdded = "Security Factor Added";
var securityFactorRemoved = "Security Factor Removed";
var securityFactorRenamed = "Security Factor Renamed";
var securityFactors = "Security Factors";
var securityFactorsDescription = "Manage security factors to verify your identity when you sign in or reset your password.";
var securityFactorsUpdated = "Security Factors Updated";
var selectNewImage = "Select new image";
var selectNewPrimary = "Before you remove {deviceName}, select your new primary factor.";
var selectSecurityFactor = "Select Security Factor";
var sending = "傳送中";
var setPrimaryDevice = "Set as primary";
var showDetails = "顯示詳細資料";
var specials = "1 Special character";
var sqDropdownAriaLabel = "Question {position} dropdown";
var sqInfoHeader = "If there is a problem with your account, this information will make it easier for you to log back in. <b>Tips for your answers to the security questions:</b>";
var sqTipBlankAnswers = "Blank answers will not be accepted";
var sqTipDoNotShare = "Do not share your questions and answers with anyone.";
var sqTipMinimum = "Answer a minimum of {required} questions.";
var sqTipNotCaseSensitive = "Answers are not case-sensitive.";
var sqTipNoUsePassword = "Do not use a password as an answer.";
var sqTipSameAnswer = "Do not use the same answer for multiple questions.";
var sqTipSpecialChars = "Special characters such as @#&*. will be ignored";
var submit = "Submit";
var submitting = "Submitting…";
var support = "Support";
var supportDefaultDescription = "Please describe the issue you are experiencing and send it to your OneLogin administrator.";
var supportedBrowsers = "Supported browsers: {browsers}";
var supportRequestHeader = "Support Request";
var time = "Time";
var trustDevice = "Trust Device";
var trusted = "Trusted";
var trustedBrowsers = "Trusted Browsers";
var trustedBrowsersDescription = "You will not have to use your security factor when logging in from these browsers.";
var trustedDevice = "Trusted Device";
var unavailable = "Unavailable";
var unavailableTime = "Unavailable";
var unsetFactorSuccess = "{factorName} is no longer your default security factor";
var unsetPrimaryDevice = "Unset as primary";
var unsupportedBrowser = "Unsupported Browser";
var unsupportedBrowserHeading = "OneLogin Profile may not work properly in your browser";
var updateDeviceNameSuccess = "{newName} was successfully updated";
var updateFactorSuccess = "{factorName} is your new default security factor";
var updatePassword = "Update Password";
var updateUserProfileFailure = "Profile Update Failed";
var updateUserProfilePhotoFailure = "Profile Photo Update Failed";
var updateUserProfilePictureSuccess = "You have successfully updated your profile picture.";
var updateUserProfileSuccess = "You have successfully updated your profile.";
var upper = "1 Uppercase";
var usedFor = "Used For";
var usedForApp = "This factor is used for app.";
var usedForLogin = "This factor is used for login.";
var usedForPasswordReset = "This factor is used for password reset.";
var version = "Version: {versionString}";
var yourBrowser = "Your browser: {browser}";
var zhTW = {
	"26286820": "輸入認證識別碼和取自 Symantec VIP Access 的連續兩個安全碼。",
	"39019345": "Press the button on your device and enter the displayed OTP code",
	"198705281": "輸入你在簡訊中收到的代碼。",
	"374233718": "您可以在 {secLeft, number} {secLeft, plural, one {second} other {seconds}} 之後重試",
	"437305782": "正在驗證您的 WebAuthn 驗證器。",
	"505702857": "魔術連結",
	"519412053": "改變認證因素",
	"655462232": "將 OneLogin 保護下載安裝到你的裝置上",
	"660592555": "確定",
	"662924178": "看來今天我們運氣不佳。",
	"694278426": "輸入您的 {deviceName} 代碼",
	"694920552": "第一安全代碼",
	"737192390": "開啟 {appName}",
	"740457555": "第二代碼",
	"744377571": "最少 {length} 字元",
	"751710530": "提交",
	"916760408": "從你的裝置輸入用戶名稱和安全代碼。",
	"921093870": "還沒收到代碼嗎？",
	"966052509": "沒有結果",
	"987359842": "請點擊電郵中的連結以繼續",
	"1068496829": "選擇安全問題 {current}/{total}",
	"1079852660": "輸入兩個連續的安全代碼",
	"1080736814": "從 Symantec VIP Access 應用程式輸入 {fieldName}",
	"1136625613": "流程取消了。請再試一次或使用其它驗證因素。",
	"1212847248": "確認碼已傳送至您設定的地址。",
	"1232460711": "輸入你的電郵",
	"1242107845": "顯示",
	"1254879564": "新密碼",
	"1359200231": "發送",
	"1433651550": "從 OneLogin 簡訊輸入代碼。",
	"1477893598": "配置",
	"1536965459": "將 OneLogin 保護下載安裝到你的裝置上",
	"1624184662": "為設定 OneLogin 簡訊，我們將經由簡訊發送一個啟用代碼給你。你將需要用這個啟用代碼來完成裝置註冊。",
	"1654624862": "安全代碼",
	"1833121415": "提供答案 {current}/{total}",
	"1919587067": "重新發送代碼",
	"1935535842": "需要的",
	"1963245695": "1 大寫體",
	"2018264248": "再試一次",
	"2091874550": "第一代碼",
	"2097632732": "改為掃瞄條碼",
	"2104438124": "從 Symantec VIP Access 應用程式輸入 {fieldName} 和兩個連續安全代碼。",
	"2124363772": "從你的 SecurID 信物輸入你的用戶名稱和安全代碼。",
	"2229754167": "輸入您的電話號碼",
	"2244720377": "似乎發生了意外錯誤。",
	"2372301903": "You are being redirected to complete the MFA verification.",
	"2584272257": "已傳送一個存取連結至你的電郵",
	"2600324508": "隱藏",
	"2606375562": "將你的 YubiKey 插入 USB 埠然後按下按鈕",
	"2663586870": "用戶名稱",
	"2758306961": "認證識別碼",
	"2792137744": "1 數字",
	"2815222727": "掃瞄這個條碼",
	"2828880379": "確認",
	"2859281487": "需要有 2 因素認證來鞏固你的帳號。",
	"2942752129": "第二安全代碼",
	"3060896801": "出問題了嗎？",
	"3061679461": "Enter the serial number printed on the back of your device",
	"3286567409": "1 特殊字元",
	"3294346597": "再試一次",
	"3327626662": "輸入您的確認碼",
	"3374226769": "用手動輸入來點擊配對",
	"3469481929": "無法掃瞄條碼嗎？",
	"3499598078": "開啟選單",
	"3528672691": "取消",
	"3640052215": "繼續",
	"3645029425": "掃瞄下方的 QR 代碼",
	"3645116517": "接聽來電時輸入此代碼：",
	"3663548834": "我們正在調查問題，預計很快恢復正常。請稍候幾分鐘<br />並重新整理瀏覽器，或造訪我們的<a href='https://www.onelogin.com/status'>狀態頁面</a>。",
	"3669652728": "已傳送一個存取連結至",
	"3673120330": "下一步",
	"3737470122": "請連絡系統管理員來取得詳情。",
	"3781468762": "您的瀏覽器不支援 WebAuthn",
	"3827227259": "確認碼已傳送至",
	"3855542277": "將這個代碼輸入到應用程式中",
	"3865193889": "啟用",
	"3877285238": "1 小寫體",
	"4000449233": "正在打給以下電話號碼：",
	"4072532148": "重新發送簡訊代碼",
	"4151518079": "選擇安全問題 {current} / {total}",
	"4152906165": "我們正在調查問題，預計很快就能恢復使用。請稍候幾分鐘{break}並重新整理您的瀏覽器，或到我們的<link>狀態頁面</link>。",
	"4227081527": "當應用程式被安裝時，回到這個螢幕並點擊 {action}",
	"4281662478": "搜尋",
	addApp: addApp,
	addFactor: addFactor,
	additionalQuestions: additionalQuestions,
	addNewPrimaryBeforeRemove: addNewPrimaryBeforeRemove,
	addNewSecurityQuestion: addNewSecurityQuestion,
	administration: administration,
	alert: alert,
	all: all,
	app: app,
	appDevice: appDevice,
	appDevices: appDevices,
	appFactor: appFactor,
	application: application,
	appName: appName,
	appPortal: appPortal,
	assumedUserNotification: assumedUserNotification,
	broswerExtension: broswerExtension,
	browser: browser,
	browserDeleteFailure: browserDeleteFailure,
	browserDeleteSuccess: browserDeleteSuccess,
	browserDevice: browserDevice,
	browserFetchFailure: browserFetchFailure,
	calling: calling,
	callUserAgain: callUserAgain,
	cancel: cancel,
	changePassword: changePassword,
	changeSecurityFactor: changeSecurityFactor,
	clearIcon: clearIcon,
	close: close,
	closeDialog: closeDialog,
	codeResent: codeResent,
	companyLogo: companyLogo,
	companyTab: companyTab,
	conditionalRequirement: conditionalRequirement,
	configuredOn: configuredOn,
	confirm: confirm,
	contactAdminEmailOtp: contactAdminEmailOtp,
	contactAdminForSMS: contactAdminForSMS,
	contactAdminForVoice: contactAdminForVoice,
	contactAdminPasswordReset: contactAdminPasswordReset,
	credentialId: credentialId,
	current: current,
	currentPassword: currentPassword,
	deleteDeviceSuccess: deleteDeviceSuccess,
	deleteQuestion: deleteQuestion,
	details: details,
	device: device,
	deviceDeleteFailure: deviceDeleteFailure,
	deviceFetchFailure: deviceFetchFailure,
	deviceNameCannotBeBlank: deviceNameCannotBeBlank,
	deviceRenameFailure: deviceRenameFailure,
	downloadOnAppStore: downloadOnAppStore,
	editDeviceName: editDeviceName,
	editSQinfo: editSQinfo,
	enrollNewFactor: enrollNewFactor,
	event: event,
	eventType: eventType,
	eventUserAgent: eventUserAgent,
	eventUseragent: eventUseragent,
	eventUUID: eventUUID,
	eventUuid: eventUuid,
	expirationDays: expirationDays,
	expireDate: expireDate,
	expires: expires,
	extensionVersionInstalled: extensionVersionInstalled,
	factor: factor,
	factorFetchFailure: factorFetchFailure,
	factorMfaTokenFailure: factorMfaTokenFailure,
	factorPrimaryFailure: factorPrimaryFailure,
	factors: factors,
	factorsFetchFailure: factorsFetchFailure,
	failedToFetchUserInfo: failedToFetchUserInfo,
	failedToRegisterAnswers: failedToRegisterAnswers,
	failedToRetrieveQuestions: failedToRetrieveQuestions,
	forcedLogout: forcedLogout,
	getOnGooglePlay: getOnGooglePlay,
	goToExternalSite: goToExternalSite,
	helpRequestFailed: helpRequestFailed,
	helpRequestSuccessful: helpRequestSuccessful,
	hostname: hostname,
	icon: icon,
	identifier: identifier,
	imageUpload: imageUpload,
	inactive: inactive,
	inactiveDevice: inactiveDevice,
	install: install,
	invalidCode: invalidCode,
	invalidPhoneNumber: invalidPhoneNumber,
	language: language,
	languageConfirmation: languageConfirmation,
	lastAuthentication: lastAuthentication,
	lastChanged: lastChanged,
	lastUsed: lastUsed,
	length: length,
	letter: letter,
	linkToAppStore: linkToAppStore,
	linkToGooglePlay: linkToGooglePlay,
	loadingRecentActivity: loadingRecentActivity,
	loadingTrustedBrowsers: loadingTrustedBrowsers,
	location: location,
	locationTime: locationTime,
	loggedOut: loggedOut,
	login: login,
	loginDevice: loginDevice,
	loginEvent: loginEvent,
	loginFactor: loginFactor,
	loginFailedEvent: loginFailedEvent,
	loginName: loginName,
	logOut: logOut,
	lower: lower,
	message: message,
	mfaRegistrationFailure: mfaRegistrationFailure,
	mfaRegistrationSuccess: mfaRegistrationSuccess,
	more: more,
	never: never,
	newPassword: newPassword,
	newPrimaryFactor: newPrimaryFactor,
	noActivities: noActivities,
	noDevicesConfigured: noDevicesConfigured,
	noExpiration: noExpiration,
	noMoreSecurityFactors: noMoreSecurityFactors,
	notifyErrorLoadingUser: notifyErrorLoadingUser,
	notifySuccessAddApp: notifySuccessAddApp,
	noTrustedBrowsers: noTrustedBrowsers,
	numbers: numbers,
	oneloginDesktop: oneloginDesktop,
	oneloginDesktopFetchFailure: oneloginDesktopFetchFailure,
	oneloginLogo: oneloginLogo,
	onlyDesktopBrowsersSupported: onlyDesktopBrowsersSupported,
	otp1: otp1,
	otp2: otp2,
	otpDevice: otpDevice,
	parsingUserProfilePhotoFailure: parsingUserProfilePhotoFailure,
	password: password,
	passwordChanged: passwordChanged,
	passwordChangedDays: passwordChangedDays,
	passwordHint: passwordHint,
	passwordRedirectDescription: passwordRedirectDescription,
	passwordReset: passwordReset,
	passwordUpdatedSuccessfully: passwordUpdatedSuccessfully,
	passwordUpdateFailure: passwordUpdateFailure,
	phoneNumber: phoneNumber,
	prefix: prefix,
	previousDeviceName: previousDeviceName,
	primary: primary,
	proceedAnyway: proceedAnyway,
	profile: profile,
	profileAvatar: profileAvatar,
	profileMenuToggle: profileMenuToggle,
	profilePhoto: profilePhoto,
	profilePhotoAction: profilePhotoAction,
	pwResetDevice: pwResetDevice,
	pwResetFactor: pwResetFactor,
	questionNumber: questionNumber,
	radiusAuthentication: radiusAuthentication,
	recentActivity: recentActivity,
	redirectToChangePassword: redirectToChangePassword,
	registerSecurityQuestions: registerSecurityQuestions,
	registrationRejected: registrationRejected,
	registrationTimedout: registrationTimedout,
	remove: remove,
	removeCurrentBrowserWarning: removeCurrentBrowserWarning,
	removedProfilePictureSuccess: removedProfilePictureSuccess,
	removeFactorWarning: removeFactorWarning,
	removeImage: removeImage,
	report: report,
	reportActivity: reportActivity,
	requestField: requestField,
	requiredQuestions: requiredQuestions,
	revert: revert,
	revertToAdmin: revertToAdmin,
	revertToSuperadmin: revertToSuperadmin,
	revoke: revoke,
	save: save,
	searchIcon: searchIcon,
	secureNotes: secureNotes,
	securityFactorAdded: securityFactorAdded,
	securityFactorRemoved: securityFactorRemoved,
	securityFactorRenamed: securityFactorRenamed,
	securityFactors: securityFactors,
	securityFactorsDescription: securityFactorsDescription,
	securityFactorsUpdated: securityFactorsUpdated,
	selectNewImage: selectNewImage,
	selectNewPrimary: selectNewPrimary,
	selectSecurityFactor: selectSecurityFactor,
	sending: sending,
	setPrimaryDevice: setPrimaryDevice,
	showDetails: showDetails,
	specials: specials,
	sqDropdownAriaLabel: sqDropdownAriaLabel,
	sqInfoHeader: sqInfoHeader,
	sqTipBlankAnswers: sqTipBlankAnswers,
	sqTipDoNotShare: sqTipDoNotShare,
	sqTipMinimum: sqTipMinimum,
	sqTipNotCaseSensitive: sqTipNotCaseSensitive,
	sqTipNoUsePassword: sqTipNoUsePassword,
	sqTipSameAnswer: sqTipSameAnswer,
	sqTipSpecialChars: sqTipSpecialChars,
	submit: submit,
	submitting: submitting,
	support: support,
	supportDefaultDescription: supportDefaultDescription,
	supportedBrowsers: supportedBrowsers,
	supportRequestHeader: supportRequestHeader,
	"switch": "Switch",
	time: time,
	trustDevice: trustDevice,
	trusted: trusted,
	trustedBrowsers: trustedBrowsers,
	trustedBrowsersDescription: trustedBrowsersDescription,
	trustedDevice: trustedDevice,
	unavailable: unavailable,
	unavailableTime: unavailableTime,
	unsetFactorSuccess: unsetFactorSuccess,
	unsetPrimaryDevice: unsetPrimaryDevice,
	unsupportedBrowser: unsupportedBrowser,
	unsupportedBrowserHeading: unsupportedBrowserHeading,
	updateDeviceNameSuccess: updateDeviceNameSuccess,
	updateFactorSuccess: updateFactorSuccess,
	updatePassword: updatePassword,
	updateUserProfileFailure: updateUserProfileFailure,
	updateUserProfilePhotoFailure: updateUserProfilePhotoFailure,
	updateUserProfilePictureSuccess: updateUserProfilePictureSuccess,
	updateUserProfileSuccess: updateUserProfileSuccess,
	upper: upper,
	usedFor: usedFor,
	usedForApp: usedForApp,
	usedForLogin: usedForLogin,
	usedForPasswordReset: usedForPasswordReset,
	version: version,
	yourBrowser: yourBrowser
};

var LANGUAGES_MAP = {
  "cs-CZ": csCZ,
  da: da,
  de: de,
  en: en,
  es: es,
  fi: fi,
  fr: fr,
  "hu-HU": huHU,
  it: it,
  ja: ja,
  ko: ko,
  "ms-MY": msMY,
  nl: nl,
  nb: no,
  "pl-PL": plPL,
  pt: pt,
  "ru-RU": ruRU,
  sk: skSK,
  sv: sv,
  th: thTH,
  "tr-TR": trTR,
  "vi-VN": viVN,
  zh: zh,
  "zh-TW": zhTW
};
var removeRegionTag = function removeRegionTag(lang) {
  return lang && lang.split("-")[0];
};
var PRIMARY_LANGUAGES_TAGS = keys(LANGUAGES_MAP).map(removeRegionTag); // Terms: language tag, region tag, primary language tag taken from https://tools.ietf.org/html/rfc5646

/**
 * Resolve best language to use based on user and account settings
 *
 * @param {string} userLanguage language set by user/admin or detected language in browser
 * @param {string} defaultLanguage default language (for account)
 * @param {string[]} enabledLanguages languages enabled by admin (for account). Expecting list of primary language tags (tags without region tag, example: no "zh-TW", just "zh")
 */

var resolveBestLanguage = function resolveBestLanguage(_ref) {
  var _ref$userLanguage = _ref.userLanguage,
      userLanguage = _ref$userLanguage === void 0 ? "" : _ref$userLanguage,
      _ref$defaultLanguage = _ref.defaultLanguage,
      defaultLanguage = _ref$defaultLanguage === void 0 ? "en" : _ref$defaultLanguage,
      _ref$enabledLanguages = _ref.enabledLanguages,
      enabledLanguages = _ref$enabledLanguages === void 0 ? PRIMARY_LANGUAGES_TAGS : _ref$enabledLanguages;
  var primaryTag = removeRegionTag(userLanguage);

  if (enabledLanguages.includes(primaryTag)) {
    if (LANGUAGES_MAP[userLanguage]) {
      return {
        languageTag: userLanguage,
        primaryLanguageTag: primaryTag
      };
    } else if (LANGUAGES_MAP[primaryTag]) {
      return {
        languageTag: primaryTag,
        primaryLanguageTag: primaryTag
      };
    } // else could happen only if LANGUAGES_MAP is not in sync with list of languages in monorail

  }

  return {
    languageTag: defaultLanguage,
    primaryLanguageTag: removeRegionTag(defaultLanguage)
  };
};
var translationsProvider = (function (language) {
  return LANGUAGES_MAP[language];
});

// screens

var NARROW_VIEW_WIDTH_LIMIT = "652px";

export { AnswerSecurityQuestions, Avatar, BREAKPOINTS, Button$1 as Button, COLORS, Checkbox, CommonLayout, Confirm, ContactAdmin, Content$3 as Content, ContentBlock, CopyCodeManually, DialogFooter, Dimmer, Dropdown$2 as Dropdown, DuoFrame, EmailInput, EnterEmail, EnterPhoneNumber, EnterRegistrationCode, EnterYubiKey, FONTS, FactorList, FatalError, Heading$1 as Heading, H1 as HiddenH1, Icon$2 as Icon, IconProvider, InfoText, InlineTextEdit$1 as InlineTextEdit, Input, InstallProtect$1 as InstallProtect, Label$1 as Label, RCLink as Link, LinkButton, LinksList, Load, Loading, LoginLoading, LoginSecurityCode, Menu$2 as Menu, MenuDivider, MenuItem, Modal as ModalDialog, MultiValueForm, NARROW_VIEW_WIDTH_LIMIT, Navbar as Navbar2, NewPassword, Notifications, OneTrust, PairProtectOrAuthenticator, PasswordComplexity, PasswordInput, PhoneNumberInput, ProjectRootProvider, RadioGroup, RegisterOath, RegisterSecureId, RegisterVipAccess, RegisterWithCredentialIdAndTwoOtps, RegistrationRequired, ResponsiveTable, ScanBarCode, ScrollableContent, SearchBox, SearchDropdown, SearchField, SelectMFADevice, SelectSearchDropdown, ShowPinCode$1 as ShowPinCode, SingleValueForm, Tag, TextArea, StyledTextField as TextField, ToDoList, ToggleButton, ToggleTooltip, Tooltip, VerticalList, WaitForEmail$1 as WaitForEmail, WebAuthn, translationsProvider as getTranslations, isValidEmail, resolveBestLanguage, svgList, useKeyDown, useOnClickOutside, useProjectRoot, useWindowSize as useWindowSizeHook };
//# sourceMappingURL=react-components.es.js.map
